(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[326],{

/***/ 25035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Button$1; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(74982);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(48421);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(31545);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Button/Button.css.js
'use client';






// import { colors } from '../Utils/constants'
var rippleAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% {\n        transform: scale(1);\n        opacity: 1;\n    }\n    50% {\n        transform: scale(10);\n        opacity: 0.375;\n    }\n    100% {\n        transform: scale(35);\n        opacity: 0;\n    }\n"], ["\n    0% {\n        transform: scale(1);\n        opacity: 1;\n    }\n    50% {\n        transform: scale(10);\n        opacity: 0.375;\n    }\n    100% {\n        transform: scale(35);\n        opacity: 0;\n    }\n"])));
var ButtonWrapper = styled_components_browser_esm/* default.button */.ZP.button(templateObject_48 || (templateObject_48 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    &.clickable {\n        cursor: pointer;\n    }\n\n    // Disabled button\n    &.btn-disabled,\n    &[disabled] {\n        cursor: not-allowed;\n        pointer-events: none;\n    }\n\n    &.pointer-disabled {\n        pointer-events: none;\n    }\n\n    &.btn-white {\n        color: #333;\n        background-color: #ffffff;\n        border: 1px solid #d6d6d6;\n        &:hover,\n        &:focus {\n            background-color: #ffffff;\n            box-shadow: none;\n        }\n    }\n    /** NEW **/\n    border-radius: 8px;\n    border: none;\n    font-weight: 500;\n    padding: 0 16px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.3s;\n    white-space: nowrap;\n    position: relative;\n    overflow: hidden;\n    outline: none !important;\n    ", "\n    ", "\n\n    ", "\n    ", "\n\n    ", "\n"], ["\n    &.clickable {\n        cursor: pointer;\n    }\n\n    // Disabled button\n    &.btn-disabled,\n    &[disabled] {\n        cursor: not-allowed;\n        pointer-events: none;\n    }\n\n    &.pointer-disabled {\n        pointer-events: none;\n    }\n\n    &.btn-white {\n        color: #333;\n        background-color: #ffffff;\n        border: 1px solid #d6d6d6;\n        &:hover,\n        &:focus {\n            background-color: #ffffff;\n            box-shadow: none;\n        }\n    }\n    /** NEW **/\n    border-radius: 8px;\n    border: none;\n    font-weight: 500;\n    padding: 0 16px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.3s;\n    white-space: nowrap;\n    position: relative;\n    overflow: hidden;\n    outline: none !important;\n    ", "\n    ", "\n\n    ", "\n    ", "\n\n    ", "\n"])), function (_a) {
    var buttonClass = _a.buttonClass, isLightMode = _a.isLightMode, hasValueFilter = _a.hasValueFilter;
    switch (buttonClass) {
        case 'primary':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    color: #fff !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    ", "\n                "], ["\n                    color: #fff !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    ", "\n                "])), Colors/* colors.secondary.40 */.O9.secondary[40], Colors/* colors.secondary.40 */.O9.secondary[40], Colors/* colors.secondary.50 */.O9.secondary[50], Colors/* colors.secondary.50 */.O9.secondary[50], Colors/* colors.secondary.50 */.O9.secondary[50], Colors/* colors.secondary.50 */.O9.secondary[50], Colors/* colors.secondary.100 */.O9.secondary[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.95 */.O9.grey[95], Colors/* colors.grey.95 */.O9.grey[95], function (_a) {
                var outline = _a.outline;
                switch (outline) {
                    default:
                    case 'solid':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
                    case 'none':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "], ["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "])), Colors/* colors.secondary.100 */.O9.secondary[100], Colors/* colors.secondary.40 */.O9.secondary[40], Colors/* colors.secondary.40 */.O9.secondary[40], Colors/* colors.secondary.95 */.O9.secondary[95], Colors/* colors.secondary.95 */.O9.secondary[95], Colors/* colors.secondary.100 */.O9.secondary[100], Colors/* colors.secondary.50 */.O9.secondary[50], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100]);
                    case 'outline':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: transparent !important;\n                                    color: ", " !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px ", " !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        box-shadow: inset 0 0 0 2px ", " !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "], ["\n                                    background-color: transparent !important;\n                                    color: ", " !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px ", " !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        box-shadow: inset 0 0 0 2px ", " !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "])), Colors/* colors.secondary.40 */.O9.secondary[40], Colors/* colors.secondary.50 */.O9.secondary[50], Colors/* colors.secondary.40 */.O9.secondary[40], (0,helpers/* hexToRgb */.oo)(Colors/* colors.secondary.50 */.O9.secondary[50]).toString(), (0,helpers/* hexToRgb */.oo)(Colors/* colors.secondary.50 */.O9.secondary[50]).toString(), Colors/* colors.secondary.50 */.O9.secondary[50], Colors/* colors.secondary.100 */.O9.secondary[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100], Colors/* colors.grey.95 */.O9.grey[95]);
                }
            });
        case 'default':
            if (hasValueFilter) {
                return (0,styled_components_browser_esm/* css */.iv)(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        border: 1px solid #a0c1ff;\n                        display: inline-block;\n                        overflow: hidden;\n                        background: #eff5ff;\n                        color: #003699;\n                        &:before {\n                            content: '';\n                            top: 0px;\n                            left: 0px;\n                            width: 100%;\n                            height: 100%;\n                            position: absolute;\n                            border-radius: 6px;\n                            border: 4px solid #fff !important;\n                        }\n                    "], ["\n                        border: 1px solid #a0c1ff;\n                        display: inline-block;\n                        overflow: hidden;\n                        background: #eff5ff;\n                        color: #003699;\n                        &:before {\n                            content: '';\n                            top: 0px;\n                            left: 0px;\n                            width: 100%;\n                            height: 100%;\n                            position: absolute;\n                            border-radius: 6px;\n                            border: 4px solid #fff !important;\n                        }\n                    "])));
            }
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    color: ", " !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n\n                    ", "\n                "], ["\n                    color: ", " !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n\n                    ", "\n                "])), Colors/* colors.grey.20 */.O9.grey[20], Colors/* colors.neutral.95 */.O9.neutral[95], Colors/* colors.neutral.95 */.O9.neutral[95], Colors/* colors.neutral.90 */.O9.neutral[90], Colors/* colors.neutral.90 */.O9.neutral[90], Colors/* colors.neutral.90 */.O9.neutral[90], Colors/* colors.neutral.80 */.O9.neutral[80], Colors/* colors.neutral.100 */.O9.neutral[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.95 */.O9.grey[95], Colors/* colors.grey.95 */.O9.grey[95], function (_a) {
                var outline = _a.outline;
                switch (outline) {
                    default:
                    case 'solid':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
                    case 'none':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "], ["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "])), Colors/* colors.neutral.100 */.O9.neutral[100], Colors/* colors.grey.20 */.O9.grey[20], Colors/* colors.grey.20 */.O9.grey[20], Colors/* colors.neutral.95 */.O9.neutral[95], Colors/* colors.neutral.95 */.O9.neutral[95], Colors/* colors.neutral.100 */.O9.neutral[100], Colors/* colors.neutral.80 */.O9.neutral[80], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100]);
                    case 'outline':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: transparent !important;\n                                    color: ", " !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px ", " !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        box-shadow: inset 0 0 0 2px ", " !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "], ["\n                                    background-color: transparent !important;\n                                    color: ", " !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px ", " !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        box-shadow: inset 0 0 0 2px ", " !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "])), Colors/* colors.grey.20 */.O9.grey[20], Colors/* colors.neutral.80 */.O9.neutral[80], Colors/* colors.grey.20 */.O9.grey[20], (0,helpers/* hexToRgb */.oo)(Colors/* colors.neutral.50 */.O9.neutral[50]).toString(), (0,helpers/* hexToRgb */.oo)(Colors/* colors.neutral.50 */.O9.neutral[50]).toString(), Colors/* colors.neutral.80 */.O9.neutral[80], Colors/* colors.neutral.100 */.O9.neutral[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100], Colors/* colors.grey.95 */.O9.grey[95]);
                }
            });
        case 'danger':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_14 || (templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    color: ", " !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    ", "\n                "], ["\n                    color: ", " !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    ", "\n                "])), Colors/* colors.error.100 */.O9.error[100], Colors/* colors.error.40 */.O9.error[40], Colors/* colors.error.40 */.O9.error[40], Colors/* colors.error.50 */.O9.error[50], Colors/* colors.error.50 */.O9.error[50], Colors/* colors.error.50 */.O9.error[50], Colors/* colors.error.50 */.O9.error[50], Colors/* colors.error.100 */.O9.error[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.95 */.O9.grey[95], Colors/* colors.grey.95 */.O9.grey[95], function (_a) {
                var outline = _a.outline;
                switch (outline) {
                    default:
                    case 'solid':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
                    case 'none':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        color: ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "], ["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        color: ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "])), Colors/* colors.error.100 */.O9.error[100], Colors/* colors.error.40 */.O9.error[40], Colors/* colors.error.40 */.O9.error[40], Colors/* colors.error.95 */.O9.error[95], Colors/* colors.error.95 */.O9.error[95], Colors/* colors.error.100 */.O9.error[100], Colors/* colors.error.40 */.O9.error[40], Colors/* colors.error.50 */.O9.error[50], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100]);
                    case 'outline':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_13 || (templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: transparent !important;\n                                    color: ", " !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px ", " !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 2px ", " !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "], ["\n                                    background-color: transparent !important;\n                                    color: ", " !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px ", " !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 2px ", " !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "])), Colors/* colors.error.40 */.O9.error[40], Colors/* colors.error.50 */.O9.error[50], Colors/* colors.error.40 */.O9.error[40], (0,helpers/* hexToRgb */.oo)(Colors/* colors.error.50 */.O9.error[50]).toString(), Colors/* colors.error.95 */.O9.error[95], Colors/* colors.error.50 */.O9.error[50], Colors/* colors.error.100 */.O9.error[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100], Colors/* colors.grey.95 */.O9.grey[95]);
                }
            });
        case 'info':
            if (!isLightMode) {
                return (0,styled_components_browser_esm/* css */.iv)(templateObject_18 || (templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        &:hover {\n                            background-color: ", " !important;\n                            border: 2px solid ", " !important;\n                        }\n                        &:focus,\n                        &:active {\n                            background-color: ", " !important;\n                            border: 2px solid ", " !important;\n                            box-shadow: inset 0 0 0 1px ", " !important;\n                        }\n                        &.btn-disabled,\n                        &[disabled] {\n                            color: ", " !important;\n                            background-color: ", " !important;\n                            border: 2px solid ", " !important;\n                        }\n                        ", "\n                    "], ["\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        &:hover {\n                            background-color: ", " !important;\n                            border: 2px solid ", " !important;\n                        }\n                        &:focus,\n                        &:active {\n                            background-color: ", " !important;\n                            border: 2px solid ", " !important;\n                            box-shadow: inset 0 0 0 1px ", " !important;\n                        }\n                        &.btn-disabled,\n                        &[disabled] {\n                            color: ", " !important;\n                            background-color: ", " !important;\n                            border: 2px solid ", " !important;\n                        }\n                        ", "\n                    "])), Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.50 */.O9.primary[50], Colors/* colors.primary.50 */.O9.primary[50], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.95 */.O9.grey[95], Colors/* colors.grey.95 */.O9.grey[95], function (_a) {
                    var outline = _a.outline;
                    switch (outline) {
                        default:
                        case 'solid':
                            return (0,styled_components_browser_esm/* css */.iv)(templateObject_15 || (templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
                        case 'none':
                            return (0,styled_components_browser_esm/* css */.iv)(templateObject_16 || (templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                        background-color: ", " !important;\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        &:hover {\n                                            color: ", " !important;\n                                            border: 2px solid transparent !important;\n                                            background-color: ", " !important;\n                                        }\n                                        &:focus,\n                                        &:active {\n                                            background-color: ", " !important;\n                                            box-shadow: inset 0 0 0 1px ", " !important;\n                                            color: ", " !important;\n                                            border: 2px solid ", " !important;\n                                        }\n                                        &[disabled] {\n                                            color: ", " !important;\n                                            background-color: ", " !important;\n                                            border: 1px solid transparent !important;\n                                        }\n                                    "], ["\n                                        background-color: ", " !important;\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        &:hover {\n                                            color: ", " !important;\n                                            border: 2px solid transparent !important;\n                                            background-color: ", " !important;\n                                        }\n                                        &:focus,\n                                        &:active {\n                                            background-color: ", " !important;\n                                            box-shadow: inset 0 0 0 1px ", " !important;\n                                            color: ", " !important;\n                                            border: 2px solid ", " !important;\n                                        }\n                                        &[disabled] {\n                                            color: ", " !important;\n                                            background-color: ", " !important;\n                                            border: 1px solid transparent !important;\n                                        }\n                                    "])), Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100]);
                        case 'outline':
                            return (0,styled_components_browser_esm/* css */.iv)(templateObject_17 || (templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                        background-color: transparent !important;\n                                        color: ", " !important;\n                                        border: none !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        &:hover {\n                                            color: ", " !important;\n                                            background-color: rgba(\n                                                ", ",\n                                                0.15\n                                            ) !important;\n                                            border: none !important;\n                                        }\n                                        &:focus,\n                                        &:active {\n                                            background-color: ", " !important;\n                                            box-shadow: inset 0 0 0 2px ", " !important;\n                                            border: none !important;\n                                            &::before {\n                                                content: ' ';\n                                                position: absolute;\n                                                left: 2px;\n                                                top: 2px;\n                                                width: calc(100% - 4px);\n                                                height: calc(100% - 4px);\n                                                pointer-events: none;\n                                                user-select: none;\n                                                border: 1px solid ", ";\n                                                border-radius: 6px;\n                                            }\n                                        }\n                                        &[disabled] {\n                                            color: ", " !important;\n                                            background-color: ", " !important;\n                                            border: 1px solid ", " !important;\n                                            box-shadow: none !important;\n                                        }\n                                    "], ["\n                                        background-color: transparent !important;\n                                        color: ", " !important;\n                                        border: none !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        &:hover {\n                                            color: ", " !important;\n                                            background-color: rgba(\n                                                ", ",\n                                                0.15\n                                            ) !important;\n                                            border: none !important;\n                                        }\n                                        &:focus,\n                                        &:active {\n                                            background-color: ", " !important;\n                                            box-shadow: inset 0 0 0 2px ", " !important;\n                                            border: none !important;\n                                            &::before {\n                                                content: ' ';\n                                                position: absolute;\n                                                left: 2px;\n                                                top: 2px;\n                                                width: calc(100% - 4px);\n                                                height: calc(100% - 4px);\n                                                pointer-events: none;\n                                                user-select: none;\n                                                border: 1px solid ", ";\n                                                border-radius: 6px;\n                                            }\n                                        }\n                                        &[disabled] {\n                                            color: ", " !important;\n                                            background-color: ", " !important;\n                                            border: 1px solid ", " !important;\n                                            box-shadow: none !important;\n                                        }\n                                    "])), Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.primary.40 */.O9.primary[40], (0,helpers/* hexToRgb */.oo)(Colors/* colors.primary.50 */.O9.primary[50]).toString(), Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100], Colors/* colors.grey.95 */.O9.grey[95]);
                    }
                });
            }
            // info already have light mode
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_22 || (templateObject_22 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    color: ", " !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    ", "\n                "], ["\n                    color: ", " !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    ", "\n                "])), Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.95 */.O9.grey[95], Colors/* colors.grey.95 */.O9.grey[95], function (_a) {
                var outline = _a.outline;
                switch (outline) {
                    default:
                    case 'solid':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_19 || (templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
                    case 'none':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_20 || (templateObject_20 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        color: ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "], ["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        color: ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "])), Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100]);
                    case 'outline':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_21 || (templateObject_21 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: transparent !important;\n                                    color: ", " !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px ", " !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 2px ", " !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "], ["\n                                    background-color: transparent !important;\n                                    color: ", " !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px ", " !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 2px ", " !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "])), Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.primary.40 */.O9.primary[40], (0,helpers/* hexToRgb */.oo)(Colors/* colors.primary.50 */.O9.primary[50]).toString(), Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100], Colors/* colors.grey.95 */.O9.grey[95]);
                }
            });
        case 'outline':
            // OLD style outline (Used for keep consistent of old component)
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_23 || (templateObject_23 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: transparent;\n                    border: 1px solid ", ";\n                    color: ", ";\n                    &:hover,\n                    &:focus {\n                        background-color: #fff;\n                    }\n                "], ["\n                    background-color: transparent;\n                    border: 1px solid ", ";\n                    color: ", ";\n                    &:hover,\n                    &:focus {\n                        background-color: #fff;\n                    }\n                "])), Colors/* colors.secondary.40 */.O9.secondary[40], Colors/* colors.secondary.40 */.O9.secondary[40]);
        case 'transparent':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_26 || (templateObject_26 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    color: #666;\n                    background-color: transparent;\n                    border: unset;\n                    &:hover {\n                        background-color: #e9e9f2;\n                        border: 1px solid #e9e9f2;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: #d6d6e0 !important;\n                        border: 1px solid #fff !important;\n                        box-shadow: 0 0 0 1px #d6d6e0 !important;\n                    }\n                    ", "\n                "], ["\n                    color: #666;\n                    background-color: transparent;\n                    border: unset;\n                    &:hover {\n                        background-color: #e9e9f2;\n                        border: 1px solid #e9e9f2;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: #d6d6e0 !important;\n                        border: 1px solid #fff !important;\n                        box-shadow: 0 0 0 1px #d6d6e0 !important;\n                    }\n                    ", "\n                "])), function (_a) {
                var outline = _a.outline;
                switch (outline) {
                    case 'outline':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_24 || (templateObject_24 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
                    case 'solid':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_25 || (templateObject_25 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
                    case 'none':
                    default:
                        return '';
                }
            });
        case 'opacity':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_27 || (templateObject_27 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    color: #666;\n                    background-color: transparent;\n                    border: unset;\n                    &:hover {\n                        background-color: rgba(174, 174, 174, 0.5);\n                        border: 1px solid #e9e9f2;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: rgba(174, 174, 174, 0.5) !important;\n                        border: 1px solid #fff !important;\n                        box-shadow: 0 0 0 1px #d6d6e0 !important;\n                    }\n                "], ["\n                    color: #666;\n                    background-color: transparent;\n                    border: unset;\n                    &:hover {\n                        background-color: rgba(174, 174, 174, 0.5);\n                        border: 1px solid #e9e9f2;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: rgba(174, 174, 174, 0.5) !important;\n                        border: 1px solid #fff !important;\n                        box-shadow: 0 0 0 1px #d6d6e0 !important;\n                    }\n                "])));
        case 'highlight':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_31 || (templateObject_31 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    color: ", " !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    ", "\n                "], ["\n                    color: ", " !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    ", "\n                "])), Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.95 */.O9.grey[95], Colors/* colors.grey.95 */.O9.grey[95], function (_a) {
                var outline = _a.outline;
                switch (outline) {
                    default:
                    case 'solid':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_28 || (templateObject_28 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
                    case 'none':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_29 || (templateObject_29 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        color: ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "], ["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        color: ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "])), Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100]);
                    case 'outline':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_30 || (templateObject_30 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px ", " !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 2px ", " !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "], ["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px ", " !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        background-color: rgba(\n                                            ", ",\n                                            0.15\n                                        ) !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 2px ", " !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "])), Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.primary.40 */.O9.primary[40], (0,helpers/* hexToRgb */.oo)(Colors/* colors.primary.50 */.O9.primary[50]).toString(), Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100], Colors/* colors.grey.95 */.O9.grey[95]);
                }
            });
        case 'ai':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_35 || (templateObject_35 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    color: #c006e9 !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid transparent !important;\n                    }\n                    ", "\n                "], ["\n                    color: #c006e9 !important;\n                    background-color: ", " !important;\n                    border: 2px solid ", " !important;\n                    &:hover {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                    }\n                    &:focus,\n                    &:active {\n                        background-color: ", " !important;\n                        border: 2px solid ", " !important;\n                        box-shadow: inset 0 0 0 1px ", " !important;\n                    }\n                    &.btn-disabled,\n                    &[disabled] {\n                        color: ", " !important;\n                        background-color: ", " !important;\n                        border: 2px solid transparent !important;\n                    }\n                    ", "\n                "])), Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.95 */.O9.grey[95], function (_a) {
                var outline = _a.outline;
                switch (outline) {
                    default:
                    case 'solid':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_32 || (templateObject_32 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background: linear-gradient(90deg, #e0369b 0%, #c006e9 100%) !important;\n                                    color: #fff !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        border: 2px solid #c006e9 !important;\n                                        background: linear-gradient(\n                                            90deg,\n                                            rgba(224, 54, 155, 0.8) 0%,\n                                            rgba(192, 6, 233, 0.8) 100%\n                                        );\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        border: 2px solid #c006e9 !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                    }\n                                "], ["\n                                    background: linear-gradient(90deg, #e0369b 0%, #c006e9 100%) !important;\n                                    color: #fff !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        border: 2px solid #c006e9 !important;\n                                        background: linear-gradient(\n                                            90deg,\n                                            rgba(224, 54, 155, 0.8) 0%,\n                                            rgba(192, 6, 233, 0.8) 100%\n                                        );\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        border: 2px solid #c006e9 !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                    }\n                                "])), Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.100 */.O9.primary[100]);
                    case 'none':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_33 || (templateObject_33 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        color: ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "], ["\n                                    background-color: ", " !important;\n                                    color: ", " !important;\n                                    border: 2px solid transparent !important;\n                                    &:hover {\n                                        color: ", " !important;\n                                        border: 2px solid transparent !important;\n                                        background-color: ", " !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: ", " !important;\n                                        box-shadow: inset 0 0 0 1px ", " !important;\n                                        color: ", " !important;\n                                        border: 2px solid ", " !important;\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid transparent !important;\n                                    }\n                                "])), Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.95 */.O9.primary[95], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.40 */.O9.primary[40], Colors/* colors.primary.70 */.O9.primary[70], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100]);
                    case 'outline':
                        return (0,styled_components_browser_esm/* css */.iv)(templateObject_34 || (templateObject_34 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    background-color: ", " !important;\n                                    color: #c006e9 !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px #c006e9 !important;\n                                    &:hover {\n                                        color: #c006e9 !important;\n                                        background-color: #f0dcf5 !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: #f0dcf5 !important;\n                                        box-shadow: inset 0 0 0 2px #c006e9 !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "], ["\n                                    background-color: ", " !important;\n                                    color: #c006e9 !important;\n                                    border: none !important;\n                                    box-shadow: inset 0 0 0 1px #c006e9 !important;\n                                    &:hover {\n                                        color: #c006e9 !important;\n                                        background-color: #f0dcf5 !important;\n                                        border: none !important;\n                                    }\n                                    &:focus,\n                                    &:active {\n                                        background-color: #f0dcf5 !important;\n                                        box-shadow: inset 0 0 0 2px #c006e9 !important;\n                                        border: none !important;\n                                        &::before {\n                                            content: ' ';\n                                            position: absolute;\n                                            left: 2px;\n                                            top: 2px;\n                                            width: calc(100% - 4px);\n                                            height: calc(100% - 4px);\n                                            pointer-events: none;\n                                            user-select: none;\n                                            border: 1px solid ", ";\n                                            border-radius: 6px;\n                                        }\n                                    }\n                                    &[disabled] {\n                                        color: ", " !important;\n                                        background-color: ", " !important;\n                                        border: 1px solid ", " !important;\n                                        box-shadow: none !important;\n                                    }\n                                "])), Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.grey.80 */.O9.grey[80], Colors/* colors.grey.100 */.O9.grey[100], Colors/* colors.grey.95 */.O9.grey[95]);
                }
            });
        default:
            return '';
    }
}, function (_a) {
    var buttonSize = _a.buttonSize;
    switch (buttonSize) {
        case 'xs':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_36 || (templateObject_36 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    font-size: 12px;\n                    height: 28px;\n                    line-height: 20px;\n                "], ["\n                    font-size: 12px;\n                    height: 28px;\n                    line-height: 20px;\n                "])));
        case 'sm':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_37 || (templateObject_37 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    font-size: 12px;\n                    height: 32px;\n                    line-height: 20px;\n                "], ["\n                    font-size: 12px;\n                    height: 32px;\n                    line-height: 20px;\n                "])));
        case 'md-h':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_38 || (templateObject_38 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    font-size: 14px;\n                    height: 40px;\n                    line-height: 20px;\n                "], ["\n                    font-size: 14px;\n                    height: 40px;\n                    line-height: 20px;\n                "])));
        case 'md-up':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_39 || (templateObject_39 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    font-size: 14px;\n                    height: 44px;\n                    line-height: 20px;\n                "], ["\n                    font-size: 14px;\n                    height: 44px;\n                    line-height: 20px;\n                "])));
        case 'lg':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_40 || (templateObject_40 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    font-size: 15px;\n                    height: 48px;\n                    line-height: 20px;\n                "], ["\n                    font-size: 15px;\n                    height: 48px;\n                    line-height: 20px;\n                "])));
        case 'md':
        default:
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_41 || (templateObject_41 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    font-size: 14px;\n                    height: 40px;\n                    line-height: 20px;\n                "], ["\n                    font-size: 14px;\n                    height: 40px;\n                    line-height: 20px;\n                "])));
    }
}, function (_a) {
    var isIcon = _a.isIcon;
    if (!isIcon) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_44 || (templateObject_44 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            padding: 0;\n            svg {\n                pointer-events: none;\n                width: 16px;\n                height: 16px;\n            }\n            ", "\n        "], ["\n            padding: 0;\n            svg {\n                pointer-events: none;\n                width: 16px;\n                height: 16px;\n            }\n            ", "\n        "])), function (_a) {
        var buttonSize = _a.buttonSize;
        switch (buttonSize) {
            case 'xs':
            case 'sm':
                return (0,styled_components_browser_esm/* css */.iv)(templateObject_42 || (templateObject_42 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                            width: 32px;\n                            height: 32px;\n                            min-width: 32px;\n                            min-height: 32px;\n                            font-size: 12px;\n                            height: 32px;\n                            line-height: 20px;\n                        "], ["\n                            width: 32px;\n                            height: 32px;\n                            min-width: 32px;\n                            min-height: 32px;\n                            font-size: 12px;\n                            height: 32px;\n                            line-height: 20px;\n                        "])));
            case 'lg':
            case 'md':
            default:
                return (0,styled_components_browser_esm/* css */.iv)(templateObject_43 || (templateObject_43 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                            font-size: 14px;\n                            height: 40px;\n                            line-height: 20px;\n                            width: 40px;\n                            height: 40px;\n                            min-width: 40px;\n                            min-height: 40px;\n                            svg {\n                                width: 20px;\n                                height: 20px;\n                            }\n                        "], ["\n                            font-size: 14px;\n                            height: 40px;\n                            line-height: 20px;\n                            width: 40px;\n                            height: 40px;\n                            min-width: 40px;\n                            min-height: 40px;\n                            svg {\n                                width: 20px;\n                                height: 20px;\n                            }\n                        "])));
        }
    });
}, function (_a) {
    var isRounded = _a.isRounded;
    if (!isRounded) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_45 || (templateObject_45 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border-radius: 48px;\n            &::before {\n                border-radius: 48px !important;\n            }\n        "], ["\n            border-radius: 48px;\n            &::before {\n                border-radius: 48px !important;\n            }\n        "])));
}, function (_a) {
    var forResponsive = _a.forResponsive, hasValueFilter = _a.hasValueFilter;
    if (forResponsive && !hasValueFilter) {
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_46 || (templateObject_46 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                border: none !important;\n                height: 32px;\n                box-shadow: none !important;\n                background: #f1f2f4 !important;\n                padding: 0 8px;\n                &::before {\n                    border: none !important;\n                }\n            "], ["\n                border: none !important;\n                height: 32px;\n                box-shadow: none !important;\n                background: #f1f2f4 !important;\n                padding: 0 8px;\n                &::before {\n                    border: none !important;\n                }\n            "])));
    }
    if (hasValueFilter && forResponsive) {
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_47 || (templateObject_47 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                background: #eff5ff !important;\n                border: none !important;\n                height: 32px;\n                box-shadow: none !important;\n                padding: 0 8px;\n                &::before {\n                    border: none !important;\n                }\n            "], ["\n                background: #eff5ff !important;\n                border: none !important;\n                height: 32px;\n                box-shadow: none !important;\n                padding: 0 8px;\n                &::before {\n                    border: none !important;\n                }\n            "])));
    }
    return '';
});
var Ripple = styled_components_browser_esm/* default.span */.ZP.span(templateObject_53 || (templateObject_53 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    display: block;\n    content: '';\n    border-radius: 100%;\n    opacity: 1;\n    animation: 1s ease 1 forwards ", ";\n    ", "\n"], ["\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    display: block;\n    content: '';\n    border-radius: 100%;\n    opacity: 1;\n    animation: 1s ease 1 forwards ", ";\n    ", "\n"])), rippleAnimation, function (_a) {
    var buttonClass = _a.buttonClass;
    switch (buttonClass) {
        case 'primary':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_49 || (templateObject_49 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: ", "80;\n                "], ["\n                    background-color: ", "80;\n                "])), Colors/* colors.secondary.40 */.O9.secondary[40]);
        case 'default':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_50 || (templateObject_50 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: #f4f4f7;\n                "], ["\n                    background-color: #f4f4f7;\n                "])));
        case 'danger':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_51 || (templateObject_51 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: #f85a5a;\n                "], ["\n                    background-color: #f85a5a;\n                "])));
        case 'outline':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_52 || (templateObject_52 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: #fff;\n                "], ["\n                    background-color: #fff;\n                "])));
        default:
            return '';
    }
});
var IconWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_56 || (templateObject_56 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    ", "\n"], ["\n    display: flex;\n    align-items: center;\n    ", "\n"])), function (_a) {
    var isLeft = _a.isLeft;
    if (isLeft) {
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_54 || (templateObject_54 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                margin-right: 6px;\n            "], ["\n                margin-right: 6px;\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_55 || (templateObject_55 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            margin-left: 6px;\n        "], ["\n            margin-left: 6px;\n        "])));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56;


//# sourceMappingURL=Button.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Button/index.js
'use client';






var Button = function (_a, refs) {
    var _b = _a.type, type = _b === void 0 ? 'default' : _b, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onMouseDown = _a.onMouseDown, _c = _a.size, size = _c === void 0 ? 'md' : _c; _a.isOutline; var _e = _a.outline, outline = _e === void 0 ? 'solid' : _e, children = _a.children, style = _a.style, _f = _a.className, className = _f === void 0 ? '' : _f, _g = _a.htmlType, htmlType = _g === void 0 ? 'button' : _g, _h = _a.isRounded, isRounded = _h === void 0 ? false : _h, _j = _a.isIcon, isIcon = _j === void 0 ? false : _j, _k = _a.isLightMode, isLightMode = _k === void 0 ? false : _k, _l = _a.iconPosition, iconPosition = _l === void 0 ? 'left' : _l, _m = _a.iconComponent, iconComponent = _m === void 0 ? null : _m, _o = _a.hasValueFilter, hasValueFilter = _o === void 0 ? false : _o, forResponsive = _a.forResponsive, rest = (0,_tslib/* __rest */._T)(_a, ["type", "onClick", "onMouseEnter", "onMouseLeave", "onMouseDown", "size", "isOutline", "outline", "children", "style", "className", "htmlType", "isRounded", "isIcon", "isLightMode", "iconPosition", "iconComponent", "hasValueFilter", "forResponsive"]);
    var _p = (0,react.useState)({ x: -1, y: -1 }), coord = _p[0], setCoord = _p[1];
    var _q = (0,react.useState)(false), isRippling = _q[0], setRipping = _q[1];
    var typeClass = "btn-".concat(type);
    var sizeClass = size === 'lg'
        ? 'btn-lg'
        : size === 'md'
            ? 'btn-md'
            : size === 'md-h'
                ? 'btn-md-h'
                : size === 'sm'
                    ? 'btn-sm'
                    : 'btn-xs';
    var isClickable = type !== 'disabled' && !!onClick;
    var handleOnClick = (0,react.useCallback)(function (e) {
        // TODO: temporary disable Ripple effect due to un-consistent between reactjs project vs vanilla project
        // const rect = e.target.getBoundingClientRect()
        // setCoord({ x: e.clientX - rect.left, y: e.clientY - rect.top })
        onClick && onClick(e);
    }, [onClick]);
    (0,react.useEffect)(function () {
        if (coord.x !== -1 && coord.y !== -1) {
            setRipping(true);
            setTimeout(function () { return setRipping(false); }, 300);
        }
        else {
            setRipping(false);
        }
    }, [coord]);
    (0,react.useEffect)(function () {
        if (!isRippling)
            setCoord({ x: -1, y: -1 });
    }, [isRippling]);
    return ((0,jsx_runtime.jsxs)(ButtonWrapper, (0,_tslib/* __assign */.pi)({ type: htmlType, buttonClass: type, buttonSize: size, isRounded: isRounded, isIcon: isIcon, outline: outline, isLightMode: isLightMode, className: "".concat(typeClass, " ").concat(sizeClass, " ").concat(className, " ").concat(isClickable ? 'clickable' : ''), onClick: handleOnClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseDown: onMouseDown, style: style, ref: refs, hasValueFilter: hasValueFilter, forResponsive: forResponsive }, rest, { children: [iconComponent && iconPosition === 'left' && (0,jsx_runtime.jsx)(IconWrapper, { isLeft: true, children: iconComponent }), children, iconComponent && iconPosition === 'right' && (0,jsx_runtime.jsx)(IconWrapper, { isLeft: false, children: iconComponent }), isRippling ? (0,jsx_runtime.jsx)(Ripple, { buttonClass: type, style: { left: coord.x, top: coord.y } }) : null] })));
};
var Button$1 = (0,react.forwardRef)(Button);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 48421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O9": function() { return /* binding */ colors; },
/* harmony export */   "RA": function() { return /* binding */ getAlertColorRange; }
/* harmony export */ });
/* unused harmony export EColorName */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74982);
/* harmony import */ var _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96782);
'use client';




var EColorName;
(function (EColorName) {
    EColorName["primary"] = "primary";
    EColorName["secondary"] = "secondary";
    EColorName["green"] = "green";
    EColorName["yellow"] = "yellow";
    EColorName["error"] = "error";
    EColorName["neutral"] = "neutral";
    EColorName["grey"] = "grey";
})(EColorName || (EColorName = {}));
var mainColor = {
    0: '#000',
    100: '#fff'
};
var colors = {
    primary: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, mainColor), { 10: '#002466', 20: '#003699', 30: '#0047CC', 40: '#005AFF', 50: '#347BFF', 60: '#4D8CFF', 70: '#80ADFF', 80: '#A0C1FF', 90: '#D4E4FF', 95: '#EFF5FF', 99: '#F9FBFF' }),
    secondary: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, mainColor), { 10: '#3F1F15', 20: '#7F3F2B', 30: '#BE5E40', 40: '#FF7D55', 50: '#FD916F', 60: '#FEA488', 70: '#FEB8A2', 80: '#FFCBBB', 90: '#FFDFD5', 95: '#FFEFEA', 99: '#FCFBFA' }),
    green: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, mainColor), { 10: '#102201', 20: '#214402', 30: '#316503', 40: '#418703', 50: '#609B2D', 60: '#7FAE56', 70: '#9DC27E', 80: '#BCD5A7', 90: '#DCE9D0', 95: '#EFF5EA', 99: '#FAFCF8' }),
    yellow: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, mainColor), { 10: '#402C00', 20: '#805800', 30: '#BF8400', 40: '#FFAF00', 50: '#FFBC2B', 60: '#FFCA56', 70: '#FFD780', 80: '#FFE4AA', 90: '#FFF2D5', 95: '#FFF9EC', 99: '#FFFEFC' }),
    error: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, mainColor), { 10: '#370E0C', 20: '#6E1B17', 30: '#A52923', 40: '#DC362E', 50: '#E35750', 60: '#EA7872', 70: '#F19895', 80: '#F8B9B7', 90: '#FFDAD9', 95: '#FCEDED', 99: '#FFFAFA' }),
    neutral: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, mainColor), { 10: '#1B1E25', 20: '#363C49', 30: '#50596E', 40: '#6B7792', 50: '#838DA3', 60: '#9AA2B4', 70: '#B2B8C5', 80: '#C9CDD6', 90: '#E1E3E8', 95: '#F1F2F4', 99: '#F8F9FA' }),
    grey: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, mainColor), { 10: '#1D1D1D', 20: '#333333', 30: '#494949', 40: '#616161', 50: '#797979', 60: '#939393', 70: '#AEAEAE', 80: '#C9C9C9', 90: '#E2E2E2', 95: '#F1F1F1', 99: '#FCFCFC' })
};
var getAlertColorRange = function (type) {
    var _a;
    return type ? (_a = {},
        _a[_Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .EAlertType.info */ .P.info] = colors.primary,
        _a[_Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .EAlertType.warning */ .P.warning] = colors.yellow,
        _a[_Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .EAlertType.danger */ .P.danger] = colors.error,
        _a[_Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .EAlertType.success */ .P.success] = colors.green,
        _a)[type] : colors.primary;
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 45896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74982);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _LayoutSystem_Col_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38431);
/* harmony import */ var _LayoutSystem_Row_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70676);
'use client';







var Container = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.full, full = _b === void 0 ? false : _b, _c = _a.noOffset, noOffset = _c === void 0 ? false : _c; _a.container; var props = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(_a, ["children", "full", "noOffset", "container"]);
    var size = full ? 'full' : 'vnw';
    var xsOffset = noOffset ? 0 : 8;
    var smOffset = noOffset ? 0 : 16;
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LayoutSystem_Row_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({ ref: ref, container: {
            responsive: {
                xs: {
                    size: size,
                    offset: xsOffset
                },
                sm: {
                    size: size,
                    offset: smOffset
                }
            }
        } }, props, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LayoutSystem_Col_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { children: children }) })));
});


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 60542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ForceLogOut; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(74982);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(48421);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/ForceLogOut/ForceLogOut.css.js
'use client';





var Dialog = {
    Container: styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        border-radius: 12px;\n        background: white;\n        padding: 24px;\n    "], ["\n        border-radius: 12px;\n        background: white;\n        padding: 24px;\n    "]))),
    Body: styled_components_browser_esm/* default.div */.ZP.div(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        text-align: center;\n\n        svg {\n            margin: auto;\n        }\n    "], ["\n        text-align: center;\n\n        svg {\n            margin: auto;\n        }\n    "]))),
    Footer: styled_components_browser_esm/* default.div */.ZP.div(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        padding: 24px;\n        border-top: 1px solid ", ";\n        display: flex;\n        gap: 8px;\n\n        ", "\n    "], ["\n        padding: 24px;\n        border-top: 1px solid ", ";\n        display: flex;\n        gap: 8px;\n\n        ", "\n    "])), Colors/* colors.grey.95 */.O9.grey[95], function (_a) {
        var isMobile = _a.isMobile;
        return isMobile && (0,styled_components_browser_esm/* css */.iv)(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                flex-direction: column;\n            "], ["\n                flex-direction: column;\n            "])));
    })
};
var ListStyle = styled_components_browser_esm/* default.ul */.ZP.ul(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-block;\n    margin: 0;\n"], ["\n    display: inline-block;\n    margin: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;


//# sourceMappingURL=ForceLogOut.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Popup/index.js + 3 modules
var Popup = __webpack_require__(4835);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(25035);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96782);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/ForceLogOut/services.js
'use client';



var checkRefreshToken = function (accessToken, refreshToken, langCode, baseURL) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var searchParams, res;
    var _a, _b, _c;
    return (0,_tslib/* __generator */.Jh)(this, function (_d) {
        switch (_d.label) {
            case 0:
                searchParams = JSON.stringify({
                    accessToken: accessToken,
                    refreshToken: refreshToken
                });
                return [4 /*yield*/, fetch("".concat(baseURL, "/api/v1/checkExpireSessionWS"), {
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'application/json',
                            'Accept-Language': langCode,
                            'Cache-Control': 'no-cache'
                        },
                        body: searchParams
                    })
                        .then(function (res) { return res.json(); })
                        .catch(function (e) { return console.log(e); })];
            case 1:
                res = _d.sent();
                if ((res === null || res === void 0 ? void 0 : res.data) && (res === null || res === void 0 ? void 0 : res.data.length) > 0 && ((_a = res === null || res === void 0 ? void 0 : res.data[0]) === null || _a === void 0 ? void 0 : _a.attributes)) {
                    return [2 /*return*/, (_c = (_b = res === null || res === void 0 ? void 0 : res.data[0]) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.isExpireSessionWS];
                }
                else {
                    return [2 /*return*/, false];
                }
        }
    });
}); };


//# sourceMappingURL=services.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/ForceLogOut/translations.js
'use client';

var translations = {
    'Your session expired for one of two reasons:': 'Phiên làm việc của bạn đã hết hạn vì một trong hai lý do:',
    "You've been active for a long time.": 'Bạn đã hoạt động trong một thời gian dài.',
    "You've signed out on another device.": 'Bạn đã đăng xuất trên một thiết bị khác.',
    'Ready to log back in?': 'Bạn đã sẵn sàng để đăng nhập lại chưa?',
    'Stay logged out': 'Đăng xuất',
    'Login to continue': 'Đăng nhập để tiếp tục'
};


//# sourceMappingURL=translations.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(31545);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/BottomSheet/BottomSheet.css.js
'use client';





var extendFromBottom = (0,styled_components_browser_esm/* keyframes */.F4)(BottomSheet_css_templateObject_1 || (BottomSheet_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"], ["\n  0% {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"])));
var collapseToBottom = (0,styled_components_browser_esm/* keyframes */.F4)(BottomSheet_css_templateObject_2 || (BottomSheet_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n"], ["\n  0% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n"])));
var BottomSheetWrapper = styled_components_browser_esm/* default.div */.ZP.div(BottomSheet_css_templateObject_3 || (BottomSheet_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: ", ";\n"], ["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: ", ";\n"])), function (props) { return props.zIndex || 200; });
var BottomSheetContent = styled_components_browser_esm/* default.div */.ZP.div(BottomSheet_css_templateObject_4 || (BottomSheet_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: #fff;\n    position: fixed;\n    bottom: 0;\n    animation: ", " 0.25s ease-in-out forwards;\n    width: 100vw;\n    border-radius: 10px 10px 0 0;\n"], ["\n    background-color: #fff;\n    position: fixed;\n    bottom: 0;\n    animation: ", " 0.25s ease-in-out forwards;\n    width: 100vw;\n    border-radius: 10px 10px 0 0;\n"])), function (_a) {
    var isClose = _a.isClose;
    return (isClose ? collapseToBottom : extendFromBottom);
});
var Backdrop = styled_components_browser_esm/* default.div */.ZP.div(BottomSheet_css_templateObject_5 || (BottomSheet_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.5);\n"], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.5);\n"])));
var Header = styled_components_browser_esm/* default.div */.ZP.div(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 24px;\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid #F1F1F1;\n    ", "\n"], ["\n    padding: 24px;\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid #F1F1F1;\n    ", "\n"])), function (_a) {
    var isReverseHeader = _a.isReverseHeader;
    return isReverseHeader
        ? (0,styled_components_browser_esm/* css */.iv)(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  flex-direction: row-reverse;\n                  justify-content: flex-end;\n              "], ["\n                  flex-direction: row-reverse;\n                  justify-content: flex-end;\n              "]))) : (0,styled_components_browser_esm/* css */.iv)(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  flex-direction: row;\n                  justify-content: space-between;\n              "], ["\n                  flex-direction: row;\n                  justify-content: space-between;\n              "])));
});
var HeaderLabel = styled_components_browser_esm/* default.div */.ZP.div(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-weight: 600;\n    color: ", ";\n    font-size: 16px;\n    line-height: 20px;\n    width: 100%;\n"], ["\n    font-weight: 600;\n    color: ", ";\n    font-size: 16px;\n    line-height: 20px;\n    width: 100%;\n"])), constants/* colors.textColor */.O9.textColor);
styled_components_browser_esm/* default.div */.ZP.div(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    cursor: pointer;\n"], ["\n    cursor: pointer;\n"])));
var Body = styled_components_browser_esm/* default.div */.ZP.div(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 16px;\n    p {\n        margin: 0;\n    }\n"], ["\n    padding: 16px;\n    p {\n        margin: 0;\n    }\n"])));
var Footer = styled_components_browser_esm/* default.div */.ZP.div(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border-top: 1px solid #f1f1f1;\n    padding: 24px;\n"], ["\n    border-top: 1px solid #f1f1f1;\n    padding: 24px;\n"])));
var BottomSheet_css_templateObject_1, BottomSheet_css_templateObject_2, BottomSheet_css_templateObject_3, BottomSheet_css_templateObject_4, BottomSheet_css_templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;


//# sourceMappingURL=BottomSheet.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Images/CloseIcon/index.js
var CloseIcon = __webpack_require__(18700);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/BottomSheet/constants.js
'use client';

var DEFAULT_OPTION = {
    isCloseOnClickBackdrop: true,
    isHaveCloseIcon: true
};
var DEFAULT_FOOTER_OTPION = {
    text: 'Ok',
    buttonType: 'primary',
    isCloseOnClick: true,
    callbackOnClick: function () { }
};


//# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/BottomSheet/index.js
'use client';










var BottomSheet = function (props) {
    var _a = props.isOpen, isOpen = _a === void 0 ? false : _a, header = props.header, headerOption = props.headerOption, children = props.children, footer = props.footer, options = props.options, footerOptions = props.footerOptions, onClose = props.onClose, trackingOnClose = props.trackingOnClose, _b = props.styleOption, styleOption = _b === void 0 ? {} : _b;
    var mergedOption = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, DEFAULT_OPTION), options);
    var mergedFooterOptions = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, DEFAULT_FOOTER_OTPION), footerOptions);
    var _c = (0,react.useState)(false), isMounted = _c[0], setMounted = _c[1];
    var _d = (0,react.useState)(true), isCloseModal = _d[0], setCloseModal = _d[1];
    var removeOverflowClass = function () {
        document.body.classList.remove('overflow-hidden');
        document.documentElement.classList.remove('overflow-hidden');
    };
    var onAnimationEnd = function () {
        if (!isCloseModal) {
            return;
        }
        removeOverflowClass();
        setMounted(false);
        onClose(false);
    };
    var onClickFooterButton = function () {
        mergedFooterOptions.isCloseOnClick && setCloseModal(true);
        mergedFooterOptions.callbackOnClick && mergedFooterOptions.callbackOnClick();
        trackingOnClose && trackingOnClose('BUTTON');
    };
    (0,react.useEffect)(function () {
        var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
        if (!bodyNode) {
            return;
        }
        if (isMounted) {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
        }
        return function () {
            removeOverflowClass();
        };
    }, []);
    (0,react.useEffect)(function () {
        setCloseModal(!isOpen);
        if (isOpen) {
            setMounted(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);
    return (0,react_dom.createPortal)(isMounted ? ((0,jsx_runtime.jsxs)(BottomSheetWrapper, { "data-cname": 'BottomSheet', zIndex: styleOption.zIndex, children: [(0,jsx_runtime.jsx)(Backdrop, { onClick: function () {
                    mergedOption.isCloseOnClickBackdrop && setCloseModal(true);
                    trackingOnClose && trackingOnClose('BACKDROP');
                } }), (0,jsx_runtime.jsxs)(BottomSheetContent, { isClose: isCloseModal, onAnimationEnd: onAnimationEnd, children: [header && ((0,jsx_runtime.jsxs)(Header, { isReverseHeader: mergedOption.isReverseHeader, style: (0,_tslib/* __assign */.pi)({}, headerOption === null || headerOption === void 0 ? void 0 : headerOption.styles), children: [(0,jsx_runtime.jsx)(HeaderLabel, { children: header }), mergedOption.isHaveCloseIcon && ((0,jsx_runtime.jsx)(Button/* default */.Z, { isRounded: true, isIcon: true, type: 'transparent', onClick: function () {
                                    setCloseModal(true);
                                    trackingOnClose && trackingOnClose('BACKDROP');
                                }, children: (0,jsx_runtime.jsx)(CloseIcon/* default */.Z, {}) }))] })), (0,jsx_runtime.jsx)(Body, { children: children }), footer || ((0,jsx_runtime.jsx)(Footer, { children: (0,jsx_runtime.jsx)(Button/* default */.Z, { type: mergedFooterOptions.buttonType, onClick: onClickFooterButton, style: { width: '100%' }, children: mergedFooterOptions.text }) }))] })] })) : ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})), document === null || document === void 0 ? void 0 : document.body);
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Typography/index.js + 2 modules
var Typography = __webpack_require__(22618);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Typography/components/styled.css.js
'use client';






var AnchorCss = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z)(styled_css_templateObject_1 || (styled_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    cursor: pointer;\n    &:hover,\n    &:focus {\n        color: ", " !important;\n    }\n"], ["\n    cursor: pointer;\n    &:hover,\n    &:focus {\n        color: ", " !important;\n    }\n"])), Colors/* colors.secondary.40 */.O9.secondary[40]);
var styled_css_templateObject_1;


//# sourceMappingURL=styled.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Typography/components/Variant.js
'use client';







var H1 = react.forwardRef(function (_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    return ((0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_tslib/* __assign */.pi)({ ref: ref, variant: 'h1' }, rest, { children: children })));
});
var H2 = react.forwardRef(function (_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    return ((0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_tslib/* __assign */.pi)({ ref: ref, variant: 'h2' }, rest, { children: children })));
});
var H3 = react.forwardRef(function (_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    return ((0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_tslib/* __assign */.pi)({ ref: ref, variant: 'h3' }, rest, { children: children })));
});
var H4 = react.forwardRef(function (_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    return ((0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_tslib/* __assign */.pi)({ ref: ref, variant: 'h4' }, rest, { children: children })));
});
var H5 = react.forwardRef(function (_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    return ((0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_tslib/* __assign */.pi)({ ref: ref, variant: 'h5' }, rest, { children: children })));
});
var H6 = react.forwardRef(function (_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    return ((0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_tslib/* __assign */.pi)({ ref: ref, variant: 'h6' }, rest, { children: children })));
});
var Label = react.forwardRef(function (_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    return ((0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_tslib/* __assign */.pi)({ ref: ref, variant: 'label' }, rest, { children: children })));
});
var Paragraph = react.forwardRef(function (_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    return ((0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_tslib/* __assign */.pi)({ ref: ref, variant: 'p' }, rest, { children: children })));
});
var Span = react.forwardRef(function (_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    return ((0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_tslib/* __assign */.pi)({ ref: ref, variant: 'span' }, rest, { children: children })));
});
var Anchor = react.forwardRef(function (_a, ref) {
    var children = _a.children, rest = (0,_tslib/* __rest */._T)(_a, ["children"]);
    return ((0,jsx_runtime.jsx)(AnchorCss, (0,_tslib/* __assign */.pi)({ ref: ref, variant: 'a' }, rest, { children: children })));
});


//# sourceMappingURL=Variant.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Utils/cookie.js
var cookie = __webpack_require__(75929);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/LoginModal/constants.js
var LoginModal_constants = __webpack_require__(25000);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Utils/responsiveHelper.js
var responsiveHelper = __webpack_require__(53417);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/ForceLogOut/index.js
'use client';

















var ForceLogOut = function (props) {
    var langCode = props.langCode, mode = props.mode, user = props.user, pageName = props.pageName;
    var _a = (0,react.useState)(false), openPopup = _a[0], setOpenPopup = _a[1];
    var baseSecureURL = "https://".concat(mode === 'production' ? "" : "".concat(mode, "-"), "secure.vietnamworks.com");
    var isResponsive = (0,responsiveHelper/* isMobile */.tq)();
    var t = function (text) {
        if (langCode === constants/* ELanguage.EN */.Df.EN) {
            return text;
        }
        else {
            return translations[text] || text;
        }
    };
    var stopBodyScrolling = function () {
        if (typeof window !== undefined) {
            document.body.style.overflow = 'hidden';
        }
    };
    var resumeBodyScrolling = function () {
        if (typeof window !== undefined) {
            document.body.style.overflow = 'initial';
        }
    };
    var checkExpireToken = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var _a, accessToken, _b, refreshToken, TOKEN_LENGTH, encodeAccessToken, encodeRefreshToken, isExpireSessionWS;
        return (0,_tslib/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!user) return [3 /*break*/, 2];
                    _a = user.accessToken, accessToken = _a === void 0 ? '' : _a, _b = user.refreshToken, refreshToken = _b === void 0 ? '' : _b;
                    TOKEN_LENGTH = 86;
                    encodeAccessToken = accessToken.length === TOKEN_LENGTH ? (0,helpers/* encrypt */.HI)(accessToken) : accessToken;
                    encodeRefreshToken = refreshToken.length === TOKEN_LENGTH ? (0,helpers/* encrypt */.HI)(refreshToken) : refreshToken;
                    if (!encodeAccessToken && !encodeRefreshToken) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, checkRefreshToken(encodeAccessToken, encodeRefreshToken, langCode, baseSecureURL)];
                case 1:
                    isExpireSessionWS = _c.sent();
                    if (isExpireSessionWS) {
                        setOpenPopup(true);
                        (0,cookie/* setCookie */.d)(LoginModal_constants/* WS_TOKEN */.dD, '');
                        (0,cookie/* setCookie */.d)(LoginModal_constants/* JS_TOKEN */.h4, '');
                        (0,cookie/* setCookie */.d)(LoginModal_constants/* JS_ALL_TOKEN */.xX, '');
                        (0,cookie/* setCookie */.d)(LoginModal_constants/* USER_COOKIE */.fT, '');
                        (0,cookie/* setCookie */.d)(LoginModal_constants/* WS_COOKIE */.kd, '');
                        stopBodyScrolling();
                    }
                    _c.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleLogin = function () {
        var loginEvent = new CustomEvent('LOGIN_POPUP', {
            detail: {
                langCode: langCode,
                isNeedReload: false,
                onLoggedIn: function () {
                    setOpenPopup(false);
                }
            }
        });
        window.dispatchEvent(loginEvent);
    };
    var handleLogOut = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            fetch('/jobseekers/ajax.php?action=track-logout', { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                var _a;
                if (data.status === 'success') {
                    var logOutUrl = "".concat(baseSecureURL, "/logout/").concat(langCode, "?client_id=3").concat((user === null || user === void 0 ? void 0 : user.userId) ? '&accessToken=' + (0,helpers/* detectEncryptAccessToken */.If)((_a = user === null || user === void 0 ? void 0 : user.accessToken) !== null && _a !== void 0 ? _a : '') : '');
                    location.assign("".concat(logOutUrl, "&as=1"));
                }
                resumeBodyScrolling();
            })
                .catch(function (err) {
                console.log(err);
            });
            return [2 /*return*/];
        });
    }); };
    (0,react.useEffect)(function () {
        if (window) {
            // authtoken will direct login, it's from mobile link, not check expire token
            var queryString = window.location.search;
            var urlParams = new URLSearchParams(queryString);
            if (!urlParams.get('authtoken') && !urlParams.get('authToken') && pageName !== 'wowCv') {
                checkExpireToken();
            }
        }
    }, [user]);
    var renderFooter = function () { return ((0,jsx_runtime.jsxs)(Dialog.Footer, { isMobile: isResponsive, children: [(0,jsx_runtime.jsx)(Button/* default */.Z, { style: { width: '100%' }, onClick: handleLogOut, children: t('Stay logged out') }), (0,jsx_runtime.jsx)(Button/* default */.Z, { style: { width: '100%' }, onClick: handleLogin, type: 'primary', children: t('Login to continue') })] })); };
    var renderBody = function () { return ((0,jsx_runtime.jsx)(Dialog.Container, { children: (0,jsx_runtime.jsxs)(Dialog.Body, { children: [(0,jsx_runtime.jsx)("div", { style: { padding: 16 }, children: (0,jsx_runtime.jsx)("img", { width: 200, height: 110, src: "".concat(props.baseImgUrl, "/images/force-logout.jpg") }) }), (0,jsx_runtime.jsx)(Paragraph, { name: 'title', size: 'large', children: t('Your session expired for one of two reasons:') }), (0,jsx_runtime.jsx)(ListStyle, { style: { marginTop: 8 }, children: (0,jsx_runtime.jsx)("li", { children: (0,jsx_runtime.jsx)(Paragraph, { name: 'paragraph', size: 'medium', children: t("You've been active for a long time.") }) }) }), (0,jsx_runtime.jsx)(ListStyle, { children: (0,jsx_runtime.jsx)("li", { children: (0,jsx_runtime.jsx)(Paragraph, { name: 'paragraph', size: 'medium', children: t("You've signed out on another device.") }) }) }), (0,jsx_runtime.jsx)(Paragraph, { name: 'paragraph', size: 'medium', style: { marginTop: 8 }, children: t('Ready to log back in?') })] }) })); };
    return !isResponsive ? ((0,jsx_runtime.jsx)(Popup/* default */.Z, { isShow: openPopup, onClose: function () { }, lang: langCode, custom: {
            footer: renderFooter(),
            header: (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        }, styleOption: {
            size: 'xs'
        }, children: renderBody() })) : ((0,jsx_runtime.jsx)(BottomSheet, { onClose: function () { }, options: { isCloseOnClickBackdrop: false, isHaveCloseIcon: false }, isOpen: openPopup, header: (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}), footer: renderFooter(), children: renderBody() }));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 31970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xd": function() { return /* binding */ ArrowLeft; },
/* harmony export */   "ol": function() { return /* binding */ ArrowRight; }
/* harmony export */ });
/* unused harmony exports DoubleArrowLeft, DoubleArrowRight, LongArrowRight */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
'use client';



var ArrowLeft = function (_a) {
    var color = _a.color, size = _a.size;
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", { xmlns: 'http://www.w3.org/2000/svg', width: size !== null && size !== void 0 ? size : 16, height: size !== null && size !== void 0 ? size : 16, viewBox: '0 0 16 16', fill: 'none', children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: 'M10.6497 2.00024C10.5082 2.00445 10.3738 2.06361 10.2752 2.16518L4.82657 7.61361C4.72443 7.71579 4.66705 7.85435 4.66705 7.99883C4.66705 8.14331 4.72443 8.28187 4.82657 8.38405L10.2752 13.8325C10.3254 13.8848 10.3855 13.9265 10.452 13.9553C10.5186 13.984 10.5902 13.9992 10.6627 14C10.7352 14.0007 10.8071 13.987 10.8742 13.9596C10.9413 13.9322 11.0023 13.8917 11.0535 13.8404C11.1048 13.7891 11.1453 13.7282 11.1727 13.6611C11.2001 13.5939 11.2139 13.522 11.2131 13.4496C11.2124 13.3771 11.1972 13.3055 11.1684 13.2389C11.1397 13.1724 11.0979 13.1122 11.0456 13.062L5.98227 7.99883L11.0456 2.93562C11.1244 2.85909 11.1781 2.76056 11.1999 2.65294C11.2217 2.54533 11.2104 2.43364 11.1676 2.33253C11.1248 2.23141 11.0525 2.14558 10.9601 2.08629C10.8677 2.02699 10.7595 1.997 10.6497 2.00024Z', fill: color !== null && color !== void 0 ? color : '#888' }) }));
};
var ArrowRight = function (_a) {
    var color = _a.color, size = _a.size;
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", { xmlns: 'http://www.w3.org/2000/svg', width: size !== null && size !== void 0 ? size : 16, height: size !== null && size !== void 0 ? size : 16, viewBox: '0 0 16 16', fill: 'none', children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: 'M5.27436 2C5.16597 2.00003 5.06005 2.03238 4.97015 2.09292C4.88024 2.15346 4.81043 2.23944 4.76964 2.33986C4.72886 2.44029 4.71895 2.55059 4.74118 2.65668C4.76341 2.76276 4.81678 2.85981 4.89445 2.9354L9.9578 7.99871L4.89445 13.062C4.84216 13.1122 4.80041 13.1724 4.77165 13.2389C4.74289 13.3054 4.72769 13.3771 4.72696 13.4495C4.72622 13.522 4.73995 13.5939 4.76735 13.6611C4.79475 13.7282 4.83527 13.7891 4.88653 13.8404C4.93779 13.8917 4.99876 13.9322 5.06588 13.9596C5.13299 13.987 5.2049 14.0007 5.27739 14C5.34988 13.9992 5.42149 13.984 5.48803 13.9553C5.55457 13.9265 5.61471 13.8848 5.66492 13.8325L11.1135 8.38394C11.2156 8.28176 11.273 8.14319 11.273 7.99871C11.273 7.85423 11.2156 7.71567 11.1135 7.61348L5.66492 2.16495C5.61414 2.11275 5.55342 2.07126 5.48634 2.04293C5.41926 2.0146 5.34718 2 5.27436 2Z', fill: color !== null && color !== void 0 ? color : '#888' }) }));
};
var DoubleArrowLeft = function (_a) {
    var color = _a.color, size = _a.size;
    return (jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', width: size !== null && size !== void 0 ? size : 16, viewBox: '0 0 16 16', fill: 'none', children: jsx("path", { d: 'M8.5229 2.12816C8.38434 2.13229 8.25283 2.1902 8.15623 2.28962L2.8229 7.62295C2.72291 7.72298 2.66675 7.85861 2.66675 8.00004C2.66675 8.14146 2.72291 8.2771 2.8229 8.37712L8.15623 13.7105C8.20537 13.7616 8.26424 13.8025 8.32937 13.8307C8.39451 13.8588 8.46461 13.8737 8.53556 13.8744C8.60652 13.8751 8.6769 13.8617 8.7426 13.8349C8.80829 13.808 8.86797 13.7684 8.91815 13.7182C8.96833 13.668 9.00798 13.6083 9.03481 13.5427C9.06163 13.477 9.07507 13.4066 9.07435 13.3356C9.07363 13.2647 9.05875 13.1946 9.0306 13.1294C9.00245 13.0643 8.96158 13.0054 8.9104 12.9563L3.95415 8.00004L8.9104 3.04379C8.98746 2.96887 9.0401 2.87242 9.06141 2.76708C9.08273 2.66174 9.07172 2.55241 9.02983 2.45343C8.98794 2.35445 8.91713 2.27044 8.82667 2.2124C8.73621 2.15435 8.63033 2.12499 8.5229 2.12816ZM12.2562 2.12816C12.1177 2.13229 11.9862 2.1902 11.8896 2.28962L6.55623 7.62295C6.45625 7.72298 6.40008 7.85861 6.40008 8.00004C6.40008 8.14146 6.45625 8.2771 6.55623 8.37712L11.8896 13.7105C11.9387 13.7616 11.9976 13.8025 12.0627 13.8307C12.1278 13.8588 12.1979 13.8737 12.2689 13.8744C12.3398 13.8751 12.4102 13.8617 12.4759 13.8349C12.5416 13.808 12.6013 13.7684 12.6515 13.7182C12.7017 13.668 12.7413 13.6083 12.7681 13.5427C12.795 13.477 12.8084 13.4066 12.8077 13.3356C12.807 13.2647 12.7921 13.1946 12.7639 13.1294C12.7358 13.0643 12.6949 13.0054 12.6437 12.9563L7.68748 8.00004L12.6437 3.04379C12.7208 2.96887 12.7734 2.87242 12.7947 2.76708C12.8161 2.66174 12.805 2.55241 12.7632 2.45343C12.7213 2.35445 12.6505 2.27044 12.56 2.2124C12.4695 2.15435 12.3637 2.12499 12.2562 2.12816Z', fill: color !== null && color !== void 0 ? color : '#888' }) }));
};
var DoubleArrowRight = function (_a) {
    var color = _a.color, size = _a.size;
    return (jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', width: size !== null && size !== void 0 ? size : 16, height: size !== null && size !== void 0 ? size : 16, viewBox: '0 0 16 16', fill: 'none', children: jsx("path", { d: 'M3.72811 2.12793C3.62202 2.12796 3.51834 2.15963 3.43033 2.21889C3.34233 2.27815 3.27399 2.36231 3.23407 2.46061C3.19415 2.55891 3.18445 2.66688 3.20621 2.77072C3.22797 2.87456 3.28021 2.96956 3.35624 3.04355L8.31249 7.9998L3.35624 12.9561C3.30505 13.0052 3.26419 13.0641 3.23603 13.1292C3.20788 13.1943 3.19301 13.2644 3.19229 13.3354C3.19157 13.4063 3.20501 13.4767 3.23183 13.5424C3.25865 13.6081 3.29831 13.6678 3.34849 13.718C3.39866 13.7681 3.45834 13.8078 3.52404 13.8346C3.58973 13.8615 3.66012 13.8749 3.73107 13.8742C3.80203 13.8734 3.87213 13.8586 3.93726 13.8304C4.0024 13.8023 4.06126 13.7614 4.1104 13.7102L9.44374 8.37689C9.54372 8.27687 9.59988 8.14123 9.59988 7.9998C9.59988 7.85838 9.54372 7.72274 9.44374 7.62272L4.1104 2.28939C4.0607 2.2383 4.00127 2.19769 3.9356 2.16996C3.86994 2.14222 3.79939 2.12793 3.72811 2.12793ZM7.46145 2.12793C7.35535 2.12796 7.25167 2.15963 7.16366 2.21889C7.07566 2.27815 7.00733 2.36231 6.9674 2.46061C6.92748 2.55891 6.91778 2.66688 6.93954 2.77072C6.9613 2.87456 7.01354 2.96956 7.08957 3.04355L12.0458 7.9998L7.08957 12.9561C7.03838 13.0052 6.99752 13.0641 6.96937 13.1292C6.94121 13.1943 6.92634 13.2644 6.92562 13.3354C6.9249 13.4063 6.93834 13.4767 6.96516 13.5424C6.99198 13.6081 7.03164 13.6678 7.08182 13.718C7.13199 13.7682 7.19168 13.8078 7.25737 13.8346C7.32306 13.8615 7.39345 13.8749 7.46441 13.8742C7.53536 13.8735 7.60546 13.8586 7.67059 13.8304C7.73573 13.8023 7.79459 13.7614 7.84374 13.7102L13.1771 8.37689C13.2771 8.27687 13.3332 8.14123 13.3332 7.9998C13.3332 7.85838 13.2771 7.72274 13.1771 7.62272L7.84374 2.28939C7.79404 2.2383 7.7346 2.19769 7.66894 2.16996C7.60328 2.14222 7.53272 2.12793 7.46145 2.12793Z', fill: color !== null && color !== void 0 ? color : '#888' }) }));
};
var LongArrowRight = function (_a) {
    var color = _a.color, size = _a.size;
    return (jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', width: size !== null && size !== void 0 ? size : 20, height: size !== null && size !== void 0 ? size : 20, viewBox: '0 0 20 20', fill: 'none', children: jsx("path", { d: 'M15.3272 5.99316C15.1946 5.9932 15.065 6.03278 14.955 6.10686C14.8449 6.18094 14.7595 6.28614 14.7096 6.40901C14.6597 6.53189 14.6476 6.66685 14.6748 6.79665C14.702 6.92646 14.7673 7.0452 14.8623 7.1377L17.0576 9.33301H1.33369C1.24535 9.33176 1.15764 9.34808 1.07566 9.38102C0.993686 9.41396 0.919072 9.46287 0.856159 9.5249C0.793246 9.58693 0.743288 9.66085 0.70919 9.74235C0.675091 9.82386 0.657532 9.91132 0.657532 9.99967C0.657532 10.088 0.675091 10.1755 0.70919 10.257C0.743288 10.3385 0.793246 10.4124 0.856159 10.4744C0.919072 10.5365 0.993686 10.5854 1.07566 10.6183C1.15764 10.6513 1.24535 10.6676 1.33369 10.6663H17.0576L14.8623 12.8617C14.7984 12.9231 14.7473 12.9967 14.7121 13.0781C14.6769 13.1595 14.6583 13.2471 14.6574 13.3358C14.6565 13.4245 14.6733 13.5125 14.7068 13.5946C14.7404 13.6767 14.7899 13.7513 14.8526 13.8141C14.9154 13.8768 14.99 13.9263 15.0721 13.9599C15.1542 13.9934 15.2422 14.0102 15.3309 14.0093C15.4196 14.0084 15.5072 13.9898 15.5886 13.9546C15.67 13.9194 15.7436 13.8683 15.805 13.8044L19.0798 10.5296C19.1612 10.4676 19.2272 10.3876 19.2728 10.2959C19.3183 10.2043 19.3421 10.1033 19.3424 10.001C19.3426 9.8986 19.3193 9.79756 19.2742 9.70566C19.2291 9.61376 19.1635 9.53347 19.0824 9.47103C19.0811 9.47016 19.0798 9.46929 19.0785 9.46842L15.805 6.19499C15.7429 6.13112 15.6686 6.08036 15.5865 6.0457C15.5045 6.01103 15.4163 5.99317 15.3272 5.99316Z', fill: color !== null && color !== void 0 ? color : '#616161' }) }));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 18700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CloseIcon$1; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
'use client';




var CloseIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.fill, fill = _e === void 0 ? '#888' : _e;
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, className: className, viewBox: '0 0 20 20', children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: 'M4.1175 3.3335C3.91681 3.3335 3.7161 3.41014 3.56296 3.56328C3.25668 3.86955 3.25668 4.36607 3.56296 4.67234L8.89084 10.0002L3.56296 15.328C3.25668 15.6343 3.25668 16.1308 3.56296 16.437C3.7163 16.5904 3.91671 16.6668 4.1175 16.6668C4.31829 16.6668 4.51871 16.5904 4.67204 16.437L9.99992 11.1092L15.3278 16.437C15.4811 16.5904 15.6815 16.6668 15.8823 16.6668C16.0831 16.6668 16.2835 16.5904 16.4369 16.437C16.7432 16.1308 16.7432 15.6343 16.4369 15.328L11.109 10.0002L16.4369 4.67234C16.7432 4.36607 16.7432 3.86955 16.4369 3.56328C16.1306 3.257 15.6341 3.257 15.3278 3.56328L9.99992 8.89109L4.67204 3.56328C4.5189 3.41014 4.31819 3.3335 4.1175 3.3335Z', fill: fill }) }));
};
var CloseIcon$1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(CloseIcon);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 68631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Input; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(74982);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Images/EyesCloseIcon/index.js
'use client';




var EyesCloseIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c;
    return ((0,jsx_runtime.jsx)("svg", { width: width, height: height, viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', children: (0,jsx_runtime.jsx)("g", { id: 'icons/icon-forms/icon-eye-closed', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', children: (0,jsx_runtime.jsx)("g", { id: 'icons8-eyelashes-3d', transform: 'translate(2.000000, 5.000000)', fill: '#666666', fillRule: 'nonzero', children: (0,jsx_runtime.jsx)("path", { d: 'M0.700175,9.1 C0.879375,9.1 1.058575,9.0314 1.195075,8.8949 L2.595075,7.4949 C2.618875,7.4711 2.628675,7.441 2.648275,7.4151 C2.914975,7.6734 3.203375,7.9261 3.511375,8.1711 L2.217775,10.1115 C2.002875,10.4335 2.089675,10.8675 2.411675,11.0824 C2.531375,11.1615 2.665775,11.2 2.799475,11.2 C3.025575,11.2 3.248175,11.0908 3.382575,10.8885 L4.657275,8.9761 C5.162675,9.2869 5.705875,9.5634 6.279875,9.7951 L5.621175,12.4306 C5.526675,12.8051 5.754875,13.1852 6.130775,13.279 C6.187475,13.293 6.244875,13.3 6.300875,13.3 C6.614475,13.3 6.899375,13.0879 6.979175,12.7694 L7.614775,10.2284 C8.094275,10.3467 8.589175,10.4328 9.100875,10.4727 L9.100875,13.3 C9.100875,13.6871 9.413775,14 9.800875,14 C10.187975,14 10.500875,13.6871 10.500875,13.3 L10.500875,10.4727 C11.011875,10.4328 11.506775,10.3467 11.986975,10.2284 L12.622575,12.7694 C12.700275,13.0879 12.985875,13.3 13.299475,13.3 C13.355475,13.3 13.412875,13.293 13.469575,13.279 C13.844775,13.1852 14.072975,12.8051 13.979175,12.4306 L13.320475,9.7958 C13.894475,9.5641 14.437675,9.2876 14.943075,8.9768 L16.217775,10.8892 C16.352175,11.0908 16.574075,11.2 16.800875,11.2 C16.933875,11.2 17.068975,11.1615 17.188675,11.0824 C17.510675,10.8675 17.597475,10.4335 17.382575,10.1115 L16.088975,8.1711 C16.396975,7.9261 16.685375,7.6734 16.952075,7.4151 C16.971675,7.441 16.981475,7.4711 17.005275,7.4949 L18.405275,8.8949 C18.541775,9.0314 18.720975,9.1 18.900175,9.1 C19.079375,9.1 19.258575,9.0314 19.395075,8.8949 C19.668775,8.6212 19.668775,8.1788 19.395075,7.9051 L17.995075,6.5051 C17.957275,6.4673 17.911075,6.4477 17.867675,6.4204 C17.972675,6.2895 18.072075,6.16 18.165175,6.0312 C18.391275,5.7183 18.321275,5.2801 18.007675,5.054 C17.694075,4.8265 17.255875,4.8972 17.030475,5.2115 C15.733375,7.0049 13.062175,9.1 9.800175,9.1 C6.538175,9.1 3.866275,7.0049 2.569875,5.2108 C2.343075,4.8972 1.904875,4.8258 1.592675,5.0533 C1.279775,5.2794 1.209075,5.7176 1.435175,6.0305 C1.528275,6.1593 1.627675,6.2888 1.732675,6.4197 C1.689275,6.447 1.643075,6.4666 1.605275,6.5044 L0.205275,7.9044 C-0.068425,8.1781 -0.068425,8.6205 0.205275,8.8942 C0.341775,9.0314 0.520975,9.1 0.700175,9.1 Z M4.300975,3.6722 C4.436075,3.6722 4.573275,3.633 4.693675,3.5511 C4.823175,3.4629 4.968775,3.3579 5.129775,3.2417 C6.142675,2.5081 7.674975,1.4 9.800175,1.4 C12.031075,1.4 13.642475,2.5585 14.604975,3.2515 C14.763175,3.3642 14.904575,3.4664 15.028475,3.5497 C15.351875,3.7667 15.785175,3.6799 16.000075,3.3593 C16.215675,3.038 16.130275,2.6033 15.809675,2.3877 C15.695575,2.3114 15.566075,2.2183 15.422575,2.1147 C14.394275,1.3755 12.481875,0 9.800175,0 C7.220675,0 5.398575,1.3195 4.308675,2.1077 C4.160975,2.2148 4.027275,2.3121 3.907575,2.3933 C3.587675,2.6103 3.504375,3.0457 3.721375,3.3656 C3.857175,3.5651 4.076975,3.6722 4.300975,3.6722 Z', id: 'Shape' }) }) }) }));
};
var EyesCloseIcon$1 = /*#__PURE__*/ react.memo(EyesCloseIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Images/EyesOpenIcon/index.js
'use client';




var EyesOpenIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? '#666666' : _d;
    return ((0,jsx_runtime.jsx)("svg", { width: width, height: height, viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', children: (0,jsx_runtime.jsx)("g", { id: 'icons/icon-forms/icon-eye-open', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', children: (0,jsx_runtime.jsx)("g", { id: 'icons8-eye-(5)', transform: 'translate(2.000000, 5.000000)', fill: color, fillRule: 'nonzero', children: (0,jsx_runtime.jsx)("path", { d: 'M10.5,0 C4.2571921,0 0.224691691,6.447826 0.151757816,6.5652342 C0.0535873741,6.68889382 0,6.8421104 0,7 C0,7.13544939 0.0395429981,7.26795363 0.113476566,7.3814454 C0.114383206,7.3828157 0.115294667,7.38418281 0.116210934,7.3855467 C0.128246496,7.4103827 3.51318191,14 10.5,14 C17.4571754,14 20.8371282,7.4751187 20.8783204,7.3951171 C20.8811066,7.39059116 20.8838413,7.38603363 20.8865237,7.3814454 C20.9604572,7.2679536 21,7.13544937 21,7 C21,6.84274207 20.9469987,6.69007331 20.8496092,6.5666013 C20.8491541,6.56614497 20.8486984,6.56568927 20.8482421,6.5652342 C20.7753084,6.447826 16.7428079,0 10.5,0 Z M10.5,2.1 C13.2062,2.1 15.4,4.2938 15.4,7 C15.4,9.7062 13.2062,11.9 10.5,11.9 C7.7938,11.9 5.6,9.7062 5.6,7 C5.6,4.2938 7.7938,2.1 10.5,2.1 Z M10.5,4.9 C9.34020203,4.9 8.4,5.84020203 8.4,7 C8.4,8.15979797 9.34020203,9.1 10.5,9.1 C11.659798,9.1 12.6,8.15979797 12.6,7 C12.6,5.84020203 11.659798,4.9 10.5,4.9 Z', id: 'Shape' }) }) }) }));
};
var EyesOpenIcon$1 = /*#__PURE__*/ react.memo(EyesOpenIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Images/RemoveFillIcon/index.js
'use client';




var RemoveFillIcon = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.fill, fill = _c === void 0 ? '#666' : _c, _d = _a.onClick, onClick = _d === void 0 ? function () { } : _d, _e = _a.onMouseOver, onMouseOver = _e === void 0 ? function () { } : _e, _f = _a.onMouseLeave, onMouseLeave = _f === void 0 ? function () { } : _f;
    return ((0,jsx_runtime.jsx)("svg", { className: className, onClick: onClick, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave, xmlns: 'http://www.w3.org/2000/svg', width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', children: (0,jsx_runtime.jsx)("path", { d: 'M10 2C5.582 2 2 5.582 2 10C2 14.418 5.582 18 10 18C14.418 18 18 14.418 18 10C18 5.582 14.418 2 10 2ZM10.9427 10C10.9427 10 13.0353 12.0927 13.138 12.1953C13.3987 12.456 13.3987 12.878 13.138 13.138C12.8773 13.3987 12.4553 13.3987 12.1953 13.138C12.0927 13.036 10 10.9427 10 10.9427C10 10.9427 7.90733 13.0353 7.80467 13.138C7.544 13.3987 7.122 13.3987 6.862 13.138C6.60133 12.8773 6.60133 12.4553 6.862 12.1953C6.964 12.0927 9.05733 10 9.05733 10C9.05733 10 6.96467 7.90733 6.862 7.80467C6.60133 7.544 6.60133 7.122 6.862 6.862C7.12267 6.60133 7.54467 6.60133 7.80467 6.862C7.90733 6.964 10 9.05733 10 9.05733C10 9.05733 12.0927 6.96467 12.1953 6.862C12.456 6.60133 12.878 6.60133 13.138 6.862C13.3987 7.12267 13.3987 7.54467 13.138 7.80467C13.036 7.90733 10.9427 10 10.9427 10Z', fill: fill }) }));
};
var RemoveFillIcon$1 = /* #__PURE__ */ react.memo(RemoveFillIcon);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96782);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(48421);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Input/Input.css.js
'use client';






var InputGroupWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    .remove-icon {\n        opacity: ", ";\n        transition: all 0.25s;\n        &.none {\n            opacity: 0;\n            pointer-events: none;\n        }\n        &.is-show {\n            opacity: 0.5;\n        }\n    }\n    &:hover,\n    &:focus {\n        .remove-icon {\n            opacity: 0.5;\n            &:hover {\n                opacity: 1;\n            }\n            &.none {\n                opacity: 0;\n                pointer-events: none;\n            }\n        }\n    }\n    ", "\n    ", "\n    ", "\n"], ["\n    .remove-icon {\n        opacity: ", ";\n        transition: all 0.25s;\n        &.none {\n            opacity: 0;\n            pointer-events: none;\n        }\n        &.is-show {\n            opacity: 0.5;\n        }\n    }\n    &:hover,\n    &:focus {\n        .remove-icon {\n            opacity: 0.5;\n            &:hover {\n                opacity: 1;\n            }\n            &.none {\n                opacity: 0;\n                pointer-events: none;\n            }\n        }\n    }\n    ", "\n    ", "\n    ", "\n"])), function (_a) {
    var isFocus = _a.isFocus;
    return (isFocus ? '0.5' : '0');
}, function (_a) {
    var isHover = _a.isHover, isHaveValue = _a.isHaveValue, isClearValue = _a.isClearValue;
    if (!isHover) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            input {\n                border: 1px solid ", ";\n                box-shadow: none;\n                background-color: #fff;\n                ", "\n                .remove-icon {\n                    opacity: 1 !important;\n                }\n            }\n        "], ["\n            input {\n                border: 1px solid ", ";\n                box-shadow: none;\n                background-color: #fff;\n                ", "\n                .remove-icon {\n                    opacity: 1 !important;\n                }\n            }\n        "])), constants/* colors.borderHover */.O9.borderHover, isHaveValue && isClearValue ? 'padding-right: 36px !important;' : '');
}, function (_a) {
    var isFocus = _a.isFocus, isHaveValue = _a.isHaveValue, isClearValue = _a.isClearValue;
    if (!isFocus) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            input {\n                ", "\n                border-color: ", ";\n            }\n        "], ["\n            input {\n                ", "\n                border-color: ", ";\n            }\n        "])), isHaveValue && isClearValue ? 'padding-right: 36px !important;' : '', constants/* colors.borderFocus */.O9.borderFocus);
}, function (_a) {
    var icon = _a.icon;
    if (icon === 'password') {
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                .remove-icon {\n                    opacity: 0 !important;\n                    pointer-events: none !important;\n                }\n            "], ["\n                .remove-icon {\n                    opacity: 0 !important;\n                    pointer-events: none !important;\n                }\n            "])));
    }
    return '';
});
var InputGroup = styled_components_browser_esm/* default.div */.ZP.div(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    svg {\n        &.remove-icon {\n            position: absolute;\n            z-index: 1;\n            top: 8px;\n            right: 6px;\n            cursor: pointer;\n            opacity: 0;\n            transition: all 0.3s;\n        }\n    }\n    input {\n        background-color: #fff;\n        border: 1px solid ", ";\n        color: ", ";\n        &:hover {\n            border: 1px solid ", ";\n            box-shadow: none;\n            background-color: #fff;\n        }\n        &:focus,\n        &:active {\n            border: 1px solid ", ";\n        }\n        &:disabled {\n            box-shadow: none;\n            border: 1px solid ", ";\n            background-color: ", ";\n            color: #999;\n            cursor: not-allowed;\n            pointer-events: none;\n        }\n        &::placeholder {\n            color: #999;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 18px;\n        }\n    }\n    ", "\n"], ["\n    position: relative;\n    svg {\n        &.remove-icon {\n            position: absolute;\n            z-index: 1;\n            top: 8px;\n            right: 6px;\n            cursor: pointer;\n            opacity: 0;\n            transition: all 0.3s;\n        }\n    }\n    input {\n        background-color: #fff;\n        border: 1px solid ", ";\n        color: ", ";\n        &:hover {\n            border: 1px solid ", ";\n            box-shadow: none;\n            background-color: #fff;\n        }\n        &:focus,\n        &:active {\n            border: 1px solid ", ";\n        }\n        &:disabled {\n            box-shadow: none;\n            border: 1px solid ", ";\n            background-color: ", ";\n            color: #999;\n            cursor: not-allowed;\n            pointer-events: none;\n        }\n        &::placeholder {\n            color: #999;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 18px;\n        }\n    }\n    ", "\n"])), constants/* colors.borderNormal */.O9.borderNormal, constants/* colors.textColor */.O9.textColor, constants/* colors.borderHover */.O9.borderHover, constants/* colors.borderFocus */.O9.borderFocus, constants/* colors.borderDisable */.O9.borderDisable, constants/* colors.bgDisable */.O9.bgDisable, function (_a) {
    var isClearValue = _a.isClearValue;
    if (!isClearValue) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            input {\n                padding-right: 10px;\n            }\n        "], ["\n            input {\n                padding-right: 10px;\n            }\n        "])));
});
var IconWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: grid;\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n    background-color: #fff;\n    border-radius: 4px;\n"], ["\n    display: grid;\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n    background-color: #fff;\n    border-radius: 4px;\n"])));
var InputWrapper = styled_components_browser_esm/* default.input */.ZP.input(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: 40px;\n    border: 1px solid rgba(224, 224, 233, 0.5);\n    border-radius: 6px;\n    padding: 15px 10px 15px 10px;\n    font-size: 13px;\n    outline: none;\n    transition: all 0.3s, font-size 0s, letter-spacing 0s;\n    white-space: nowrap;\n    overflow: hidden !important;\n\n    /* Safari text color input change */\n    -webkit-text-fill-color: ", ";\n    opacity: 1;\n\n    &::placeholder {\n        -webkit-text-fill-color: ", ";\n        color: ", ";\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 18px;\n    }\n    &::-webkit-input-placeholder {\n        color: ", ";\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 18px;\n    }\n\n    ", "\n    ", "\n"], ["\n    width: 100%;\n    height: 40px;\n    border: 1px solid rgba(224, 224, 233, 0.5);\n    border-radius: 6px;\n    padding: 15px 10px 15px 10px;\n    font-size: 13px;\n    outline: none;\n    transition: all 0.3s, font-size 0s, letter-spacing 0s;\n    white-space: nowrap;\n    overflow: hidden !important;\n\n    /* Safari text color input change */\n    -webkit-text-fill-color: ", ";\n    opacity: 1;\n\n    &::placeholder {\n        -webkit-text-fill-color: ", ";\n        color: ", ";\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 18px;\n    }\n    &::-webkit-input-placeholder {\n        color: ", ";\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 18px;\n    }\n\n    ", "\n    ", "\n"])), constants/* colors.textColor */.O9.textColor, constants/* colors.textPlaceholder */.O9.textPlaceholder, constants/* colors.textPlaceholder */.O9.textPlaceholder, constants/* colors.textPlaceholder */.O9.textPlaceholder, function (_a) {
    var isError = _a.isError;
    if (!isError) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border-color: ", " !important;\n            background-color: #fff !important;\n            &:focus,\n            &:active {\n                border-color: ", " !important;\n            }\n        "], ["\n            border-color: ", " !important;\n            background-color: #fff !important;\n            &:focus,\n            &:active {\n                border-color: ", " !important;\n            }\n        "])), constants/* colors.borderError */.O9.borderError, constants/* colors.borderErrorFocus */.O9.borderErrorFocus);
}, function (_a) {
    var isHavePrefix = _a.isHavePrefix;
    if (!isHavePrefix) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            padding-left: 40px;\n        "], ["\n            padding-left: 40px;\n        "])));
});
var InputRecommend = styled_components_browser_esm/* default.div */.ZP.div(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    z-index: 2;\n    width: 100%;\n    max-height: 250px;\n    overflow: auto;\n    margin-top: 8px;\n    background: #fff;\n    box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1);\n    border-radius: 3px;\n"], ["\n    z-index: 2;\n    width: 100%;\n    max-height: 250px;\n    overflow: auto;\n    margin-top: 8px;\n    background: #fff;\n    box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1);\n    border-radius: 3px;\n"])));
var ListRecommend = styled_components_browser_esm/* default.ul */.ZP.ul(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 0;\n    margin: 0;\n    list-style: none;\n"], ["\n    padding: 0;\n    margin: 0;\n    list-style: none;\n"])));
var RecommendItem = styled_components_browser_esm/* default.li */.ZP.li(templateObject_15 || (templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 8px 16px;\n    cursor: pointer;\n    &:hover {\n        background: #f2f2f2;\n    }\n    ", "\n    ", "\n"], ["\n    padding: 8px 16px;\n    cursor: pointer;\n    &:hover {\n        background: #f2f2f2;\n    }\n    ", "\n    ", "\n"])), function (_a) {
    var isActive = _a.isActive;
    if (!isActive) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_13 || (templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            background: #f2f2f2;\n        "], ["\n            background: #f2f2f2;\n        "])));
}, function (_a) {
    var isEmpty = _a.isEmpty;
    if (!isEmpty) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_14 || (templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            color: ", ";\n        "], ["\n            color: ", ";\n        "])), Colors/* colors.grey.60 */.O9.grey[60]);
});
var LabelWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_16 || (templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-bottom: 4px;\n    color: #333;\n    label {\n        margin-bottom: 0;\n    }\n"], ["\n    margin-bottom: 4px;\n    color: #333;\n    label {\n        margin-bottom: 0;\n    }\n"])));
var TextDanger = styled_components_browser_esm/* default.span */.ZP.span(templateObject_17 || (templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), constants/* colors.dangerColor */.O9.dangerColor);
var PrefixIcon = styled_components_browser_esm/* default.div */.ZP.div(templateObject_18 || (templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    pointer-events: none;\n"], ["\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    pointer-events: none;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;


//# sourceMappingURL=Input.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useFloating/index.js + 17 modules
var useFloating = __webpack_require__(88904);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Input/const.js
'use client';

var DELAY_TIMEOUT = 200;


//# sourceMappingURL=const.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Input/index.js
'use client';














var Input = function (props) {
    var onChange = props.onChange, onPressEnter = props.onPressEnter, _a = props.onClickSuggestionItem, onClickSuggestionItem = _a === void 0 ? function (item) { return console.log("".concat(item, " was clicked/selected")); } : _a, value = props.value, _b = props.isRequired, isRequired = _b === void 0 ? false : _b, _c = props.label, label = _c === void 0 ? '' : _c, hasError = props.hasError, listRecommend = props.listRecommend, searchNotFound = props.searchNotFound, _d = props.className, className = _d === void 0 ? '' : _d, _e = props.disabled, disabled = _e === void 0 ? false : _e, _f = props.autoFocus, autoFocus = _f === void 0 ? false : _f, _g = props.clearValue, clearValue = _g === void 0 ? true : _g, icon = props.icon, type = props.type, _h = props.prefixIcon, prefixIcon = _h === void 0 ? null : _h, _j = props.numberFieldRule, numberFieldRule = _j === void 0 ? 'all' : _j, inputRef = props.inputRef, rest = (0,_tslib/* __rest */._T)(props, ["onChange", "onPressEnter", "onClickSuggestionItem", "value", "isRequired", "label", "hasError", "listRecommend", "searchNotFound", "className", "disabled", "autoFocus", "clearValue", "icon", "type", "prefixIcon", "numberFieldRule", "inputRef"]);
    var _k = (0,react.useState)(false), isFocus = _k[0], setIsFocus = _k[1];
    var _l = (0,react.useState)(false), showPassword = _l[0], setShowPassword = _l[1];
    var _m = (0,react.useState)(false), isHover = _m[0], setHover = _m[1];
    var inputGroupRef = (0,react.useRef)(null);
    var _o = (0,useFloating/* default */.Z)({
        placement: 'bottom-start',
        position: 'fixed',
        config: {
            useWindowAsFlippingContainer: true,
            detectHidden: true
        }
    }), context = _o.context, refs = _o.refs, FloatingPortal = _o.FloatingPortal;
    var timer = null;
    var handleClickOnScreen = function (e) {
        timer && clearTimeout(timer);
        timer = setTimeout(function () {
            var _a, _b;
            setIsFocus((_b = (_a = inputGroupRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) !== null && _b !== void 0 ? _b : false);
        }, DELAY_TIMEOUT);
    };
    (0,react.useEffect)(function () {
        // We're using touchend because of some old IOS versions, they're not fired click event, so the handleClickOnScreen func is not worked properly
        window.addEventListener(window.innerWidth < 992 ? 'touchend' : 'click', handleClickOnScreen);
        return function () {
            window.removeEventListener(window.innerWidth < 992 ? 'touchend' : 'click', handleClickOnScreen);
        };
    }, []);
    /**
     * `activeSuggestionIndex`: used to highlight which suggestion is being focused by using up/down key
     */
    var _p = (0,react.useState)(null), activeSuggestionIndex = _p[0], setActiveSuggestionIndex = _p[1];
    var numberOfRecommendedSkills = listRecommend ? listRecommend.length : 0;
    var handleKeyUp = function (event) {
        var _a, _b;
        switch (event.key) {
            case 'ArrowDown': {
                var newIndex = activeSuggestionIndex !== null ? activeSuggestionIndex + 1 : 0;
                if (newIndex >= numberOfRecommendedSkills)
                    newIndex = 0;
                // Set the active item
                setActiveSuggestionIndex(newIndex);
                // Focus on the active item
                var activeItem = refs.popup.current && ((_a = refs.popup.current.querySelectorAll('li')) === null || _a === void 0 ? void 0 : _a[newIndex]);
                activeItem &&
                    activeItem.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                        inline: 'nearest'
                    });
                break;
            }
            case 'ArrowUp': {
                var newIndex = activeSuggestionIndex && activeSuggestionIndex > 0
                    ? activeSuggestionIndex - 1
                    : numberOfRecommendedSkills - 1;
                if (newIndex >= numberOfRecommendedSkills)
                    newIndex = numberOfRecommendedSkills - 1;
                // Set the active item
                setActiveSuggestionIndex(newIndex);
                // Focus on the active item
                var activeItem = refs.popup.current && ((_b = refs.popup.current.querySelectorAll('li')) === null || _b === void 0 ? void 0 : _b[newIndex]);
                activeItem &&
                    activeItem.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                        inline: 'nearest'
                    });
                break;
            }
            case 'Enter': {
                var currentActiveItem = listRecommend === null || listRecommend === void 0 ? void 0 : listRecommend.find(function (_item, index) { return index === activeSuggestionIndex; });
                if (onClickSuggestionItem && currentActiveItem) {
                    onClickSuggestionItem(currentActiveItem);
                    setIsFocus(false);
                    setActiveSuggestionIndex(null);
                }
                break;
            }
        }
    };
    var handleType = (0,react.useCallback)(function () {
        if (type === 'password') {
            if (showPassword)
                return 'text';
            else
                return 'password';
        }
        else if (type) {
            return type;
        }
        else {
            return 'text';
        }
    }, [type, showPassword]);
    var handleOnChange = (0,react.useCallback)(function (e) {
        setActiveSuggestionIndex(null);
        onChange(e.target.value, e);
        setIsFocus(true);
    }, [onChange]);
    var handleOnKeyPress = (0,react.useCallback)(function (e) {
        // If user press `enter` and NOT focusing on the dropdown list
        // We call the input onPressEnter
        if (e.key === 'Enter' && activeSuggestionIndex === null) {
            setIsFocus(false);
            onPressEnter && onPressEnter();
        }
        // If field type is number then
        // numberFieldRule = 'positive-int'
        // positive-int: no negative number, no float and can't be
        if (type === 'number' &&
            numberFieldRule === 'positive-int' &&
            (e.key === 'e' || e.key === 'E' || e.key === '.' || e.key === ',' || e.key === '-' || e.key === '+')) {
            e.preventDefault();
        }
        // numberFieldRule = 'float'
        if (type === 'number' && numberFieldRule === 'float' && (e.key === 'e' || e.key === 'E')) {
            e.preventDefault();
        }
    }, [activeSuggestionIndex, onPressEnter, type]);
    var handleOnClickSuggestItem = (0,react.useCallback)(function (item) {
        if (onClickSuggestionItem) {
            onClickSuggestionItem(item);
            setIsFocus(false);
        }
    }, [onClickSuggestionItem]);
    (0,react.useCallback)(function () {
        if (handleType() === 'password' && !showPassword) {
            return value.replace(/./g, '*');
        }
        return value;
    }, [type, value, showPassword]);
    var handleOnRemoveClick = (0,react.useCallback)(function () {
        var _a, _b;
        onChange('');
        if (inputGroupRef !== undefined && inputGroupRef !== null) {
            (_b = (_a = inputGroupRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('input')) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }, [onChange, inputGroupRef]);
    (0,react.useEffect)(function () {
        if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
            inputRef.current.addEventListener('focus', function () { return setIsFocus(true); });
        }
        return function () {
            var _a;
            if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('focus', function () { return setIsFocus(false); });
            }
        };
    }, [inputRef === null || inputRef === void 0 ? void 0 : inputRef.current]);
    return ((0,jsx_runtime.jsxs)(InputGroupWrapper, { ref: inputGroupRef, isFocus: isFocus, isHover: isHover, isHaveValue: value !== '', isClearValue: clearValue, icon: icon, onMouseEnter: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); }, children: [label ? ((0,jsx_runtime.jsxs)(LabelWrapper, { children: [isRequired ? (0,jsx_runtime.jsx)(TextDanger, { children: "*" }) : null, " ", (0,jsx_runtime.jsx)("label", { children: label })] })) : null, (0,jsx_runtime.jsxs)(InputGroup, { isClearValue: clearValue, ref: refs.setReference, children: [prefixIcon !== null ? (0,jsx_runtime.jsx)(PrefixIcon, { children: prefixIcon }) : null, (0,jsx_runtime.jsx)(InputWrapper, (0,_tslib/* __assign */.pi)({ ref: inputRef, value: value, className: "".concat(className, " class-input-recommend"), onChange: handleOnChange, onKeyPress: handleOnKeyPress, onKeyUp: handleKeyUp, disabled: disabled, autoFocus: autoFocus, type: handleType(), isError: hasError, isHavePrefix: prefixIcon !== null }, rest)), icon === 'password' && ((0,jsx_runtime.jsx)(IconWrapper, { onClick: function () { return setShowPassword(!showPassword); }, onMouseOver: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); }, children: showPassword ? (0,jsx_runtime.jsx)(EyesOpenIcon$1, {}) : (0,jsx_runtime.jsx)(EyesCloseIcon$1, {}) })), value !== '' ? ((0,jsx_runtime.jsx)(RemoveFillIcon$1, { className: "remove-icon ".concat(value && !disabled && clearValue && (isFocus || isHover) ? 'is-show' : 'none'), onClick: function () { return handleOnRemoveClick(); }, onMouseOver: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); } })) : null, value && listRecommend && isFocus ? ((0,jsx_runtime.jsx)(FloatingPortal, { enable: true, children: (0,jsx_runtime.jsx)(InputRecommend, { ref: refs.setPopup, style: {
                                position: context.position,
                                top: context.y,
                                left: context.x,
                                width: refs.reference.current.offsetWidth,
                                zIndex: 1100,
                                display: context.isReferenceHidden ? 'none' : 'block'
                            }, children: (0,jsx_runtime.jsx)(ListRecommend, { children: listRecommend.length !== 0 ? (listRecommend.map(function (item, index) {
                                    return ((0,jsx_runtime.jsx)(RecommendItem, { isActive: activeSuggestionIndex === index, onClick: function () { return handleOnClickSuggestItem(item); }, children: item.name }, index));
                                })) : ((0,jsx_runtime.jsx)(RecommendItem, { isEmpty: true, children: searchNotFound })) }) }) })) : null] })] }));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 38431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Col; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74982);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _LayoutContext_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98712);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8024);
/* harmony import */ var _helper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18732);
'use client';









var Container = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(templateObject_1 || (templateObject_1 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__makeTemplateObject */ .cy)(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var cssString = _a.cssString;
    return cssString;
});
var Col = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_a, ref) {
    var _b = _a.xs, xs = _b === void 0 ? _constants_js__WEBPACK_IMPORTED_MODULE_4__/* .MAXIMUM_COL */ .bD : _b, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, vnw = _a.vnw, children = _a.children, restProps = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__rest */ ._T)(_a, ["xs", "sm", "md", "lg", "xl", "vnw", "children"]);
    var gutter = (0,_LayoutContext_js__WEBPACK_IMPORTED_MODULE_5__/* .useLayoutContext */ .l)().gutter;
    var cssString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () { return (0,_helper_js__WEBPACK_IMPORTED_MODULE_6__/* .renderCssStringOfCol */ .vy)({ xs: xs, sm: sm, md: md, lg: lg, xl: xl, vnw: vnw }, gutter); }, [gutter, lg, md, sm, xl, xs, vnw]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({ cssString: cssString, id: 'vnwLayout__col', ref: ref }, restProps, { children: children })));
});
var templateObject_1;


//# sourceMappingURL=Col.js.map


/***/ }),

/***/ 98712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LayoutContext; },
/* harmony export */   "l": function() { return /* binding */ useLayoutContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var LayoutContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    gutter: 0
});
var useLayoutContext = function () { return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(LayoutContext); };


//# sourceMappingURL=LayoutContext.js.map


/***/ }),

/***/ 70676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Row; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74982);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _helper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18732);
/* harmony import */ var _LayoutContext_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98712);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8024);
'use client';









var RowLayout = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(templateObject_1 || (templateObject_1 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__makeTemplateObject */ .cy)(["\n    box-sizing: border-box;\n    display: flex;\n    flex-flow: row wrap;\n    align-items: ", ";\n    justify-content: ", ";\n    ", ";\n"], ["\n    box-sizing: border-box;\n    display: flex;\n    flex-flow: row wrap;\n    align-items: ", ";\n    justify-content: ", ";\n    ", ";\n"])), function (_a) {
    var align = _a.align;
    return _constants_js__WEBPACK_IMPORTED_MODULE_4__/* .alignValues */ .wr[align];
}, function (_a) {
    var justify = _a.justify;
    return justify;
}, function (_a) {
    var cssString = _a.cssString;
    return cssString;
});
var ContainerLayout = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(templateObject_2 || (templateObject_2 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__makeTemplateObject */ .cy)(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var containerCssString = _a.containerCssString;
    return containerCssString;
});
var Row = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_a, ref) {
    var _b = _a.gutter, gutter = _b === void 0 ? 0 : _b, _c = _a.align, align = _c === void 0 ? 'top' : _c, _d = _a.justify, justify = _d === void 0 ? 'start' : _d, container = _a.container, children = _a.children, restProps = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__rest */ ._T)(_a, ["gutter", "align", "justify", "container", "children"]);
    var rowCssString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () { return (0,_helper_js__WEBPACK_IMPORTED_MODULE_5__/* .renderCssStringOfRow */ .S$)(gutter); }, [gutter]);
    var containerCssString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () { return (0,_helper_js__WEBPACK_IMPORTED_MODULE_5__/* .renderCssStringOfContainer */ .tT)(container); }, [container]);
    var props = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)({
        gutter: gutter
    });
    var renderContainerLayout = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (children) {
        if (container) {
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContainerLayout, { className: 'vnwLayout__container', containerCssString: containerCssString, children: children }));
        }
        return children;
    }, [container, containerCssString]);
    return renderContainerLayout((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RowLayout, (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({ id: 'vnwLayout__row', cssString: rowCssString, align: align, justify: justify, ref: ref }, restProps, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LayoutContext_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Provider */ .Z.Provider, { value: props.current, children: children }) })));
});
var templateObject_1, templateObject_2;


//# sourceMappingURL=Row.js.map


/***/ }),

/***/ 8024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bD": function() { return /* binding */ MAXIMUM_COL; },
/* harmony export */   "j$": function() { return /* binding */ BREAKPOINTS; },
/* harmony export */   "rZ": function() { return /* binding */ CONTAINER; },
/* harmony export */   "wr": function() { return /* binding */ alignValues; }
/* harmony export */ });
'use client';

var BREAKPOINTS = {
    xs: 0,
    sm: 769,
    md: 1025,
    lg: 1301,
    xl: 1441,
    vnw: 1141
};
var CONTAINER = {
    xs: 0,
    sm: 768,
    md: 1024,
    lg: 1300,
    xl: 1440,
    vnw: 1140,
    full: '100%'
};
var MAXIMUM_COL = 24;
var alignValues = {
    top: 'start',
    middle: 'center',
    bottom: 'end'
};


//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 18732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S$": function() { return /* binding */ renderCssStringOfRow; },
/* harmony export */   "tT": function() { return /* binding */ renderCssStringOfContainer; },
/* harmony export */   "vy": function() { return /* binding */ renderCssStringOfCol; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8024);
'use client';



var createRowCssString = function (gutter) {
    if (gutter[0] === 0 && gutter[1] === 0)
        return '';
    var rowGap = gutter[0];
    var colGap = gutter[1];
    return "\n        margin-left: calc(-0.5 * ".concat(colGap, "px);\n        margin-right: calc(-0.5 * ").concat(colGap, "px);\n        margin-top: calc(-1 * ").concat(rowGap, "px);\n      ");
};
var getGapFromGutter = function (gutter) {
    if (!gutter)
        return [0, 0];
    if (typeof gutter === 'number') {
        return [gutter, gutter];
    }
    return gutter;
};
var renderCssStringOfRow = function (gutter) {
    var gap = null;
    var responsive = null;
    if (typeof gutter === 'object' && !Array.isArray(gutter)) {
        responsive = gutter;
    }
    else {
        gap = getGapFromGutter(gutter);
    }
    if (gap) {
        return createRowCssString(gap);
    }
    if (responsive) {
        var cssString_1 = '';
        Object.keys(responsive).map(function (breakpoint) {
            if (breakpoint === 'xs') {
                cssString_1 += createRowCssString(getGapFromGutter(responsive === null || responsive === void 0 ? void 0 : responsive[breakpoint]));
            }
            cssString_1 += "\n                @media screen and (min-width: ".concat(_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .BREAKPOINTS */ .j$[breakpoint], "px) {\n                  ").concat(createRowCssString(getGapFromGutter(responsive === null || responsive === void 0 ? void 0 : responsive[breakpoint])), "\n                }\n            ");
        });
        return cssString_1;
    }
    return '';
};
var renderGap = function (colGap, rowGap) {
    return "\n        ".concat(colGap > 0 ? "padding-left: calc(0.5 * ".concat(colGap, "px);") : '', "\n        ").concat(colGap > 0 ? "padding-right: calc(0.5 * ".concat(colGap, "px);") : '', "\n        ").concat(rowGap > 0 ? "padding-top: ".concat(rowGap, "px;") : '', "\n");
};
var renderAutoLayoutString = function (type) {
    if (type === 'auto') {
        return 'flex: 0 0 auto;max-width:none;';
    }
    return "flex: 1 1 0;max-width:100%;";
};
var createColCssString = function (gutter, col) {
    var colSpan = 0;
    var colOffset = 0;
    var colOrder = 0;
    var rowGap = gutter[0];
    var colGap = gutter[1];
    if (col) {
        if (typeof col === 'number') {
            colSpan = col;
        }
        else if (col instanceof Object) {
            colSpan = col.span;
            colOffset = col.offset || 0;
            colOrder = col.order || 0;
        }
        else {
            /*
             * Return css string immediately if column has auto layout
             * */
            return "\n                ".concat(renderAutoLayoutString(col), "\n                ").concat(renderGap(colGap, rowGap), "\n                ").concat(colOrder ? "order: ".concat(colOrder, ";") : '', "\n            ");
        }
    }
    var containerWidth = (colSpan / _constants_js__WEBPACK_IMPORTED_MODULE_0__/* .MAXIMUM_COL */ .bD) * 100;
    var containerOffset = colOffset > 0 ? (colOffset / _constants_js__WEBPACK_IMPORTED_MODULE_0__/* .MAXIMUM_COL */ .bD) * 100 : null;
    return "\n        ".concat(containerWidth > 0 ? "flex: 0 0 ".concat(containerWidth, "%;") : '', "\n        ").concat(containerWidth > 0 ? "max-width: ".concat(containerWidth, "%;") : '', "\n        ").concat(renderGap(colGap, rowGap), "\n        ").concat(containerOffset !== null ? "margin-left: ".concat(containerOffset, "%;") : '', "\n        ").concat(colOrder ? "order: ".concat(colOrder, ";") : '', "\n    ");
};
var renderCssStringOfCol = function (breakpoints, gutter) {
    var gap = null;
    var responsive = null;
    var cssString = '';
    if (typeof gutter === 'object' && !Array.isArray(gutter)) {
        responsive = gutter;
    }
    else {
        gap = getGapFromGutter(gutter);
    }
    Object.keys(breakpoints).map(function (breakpoint) {
        if (breakpoint === 'xs') {
            if (gap) {
                cssString += createColCssString(gap, breakpoints[breakpoint]);
                return;
            }
            if (responsive) {
                cssString += createColCssString(getGapFromGutter(responsive[breakpoint]), breakpoints[breakpoint]);
                return;
            }
        }
        if (responsive) {
            if (!breakpoints[breakpoint] && !responsive[breakpoint])
                return;
            cssString += "\n                @media screen and (min-width: ".concat(_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .BREAKPOINTS */ .j$[breakpoint], "px) {\n                    ").concat(createColCssString(getGapFromGutter(responsive[breakpoint]), breakpoints[breakpoint]), "\n                }\n            ");
            return;
        }
        if (breakpoints[breakpoint]) {
            cssString += "\n                @media screen and (min-width: ".concat(_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .BREAKPOINTS */ .j$[breakpoint], "px) {\n                    ").concat(createColCssString([0, 0], breakpoints[breakpoint]), "\n                }\n            ");
        }
    });
    return cssString;
};
var renderCssStringOfContainer = function (container) {
    var cssString = '';
    var containerKey;
    var padding = 0;
    if (container) {
        containerKey = Object.keys(container)[0];
        if (containerKey) {
            if (containerKey !== 'responsive') {
                padding = container[containerKey] || 0;
                cssString = "\n                  width: 100%;\n                  max-width: ".concat(containerKey === 'full'
                    ? _constants_js__WEBPACK_IMPORTED_MODULE_0__/* .CONTAINER */ .rZ[containerKey]
                    : "".concat(Number(_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .CONTAINER */ .rZ[containerKey]) + padding * 2, "px"), ";\n                  padding: 0 ").concat(padding, "px;\n                  margin: 0 auto;\n                ");
            }
            else {
                /*
                 * When container has responsive, the responsive is always has at least 1 item (xs is required).
                 * So that, i can make type convention containerResponsive as TContainerResponsive
                 * */
                var containerResponsive_1 = container[containerKey];
                Object.keys(containerResponsive_1).forEach(function (key) {
                    var containerResponsiveItem = containerResponsive_1[key];
                    if (containerResponsiveItem) {
                        var size = containerResponsiveItem.size;
                        padding = containerResponsiveItem.offset || 0;
                        if (key === 'xs') {
                            cssString += "\n                                width: 100%;\n                                max-width: ".concat(size === 'full' ? _constants_js__WEBPACK_IMPORTED_MODULE_0__/* .CONTAINER */ .rZ[size] : "".concat(Number(_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .CONTAINER */ .rZ[size]) + padding * 2, "px"), ";\n                                padding: 0 ").concat(padding, "px;\n                                margin: 0 auto;\n                            ");
                            return;
                        }
                        cssString += "\n                            width: 100%;\n                            @media screen and (min-width: ".concat(_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .BREAKPOINTS */ .j$[key], "px) {\n                                max-width: ").concat(size === 'full' ? _constants_js__WEBPACK_IMPORTED_MODULE_0__/* .CONTAINER */ .rZ[size] : "".concat(Number(_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .CONTAINER */ .rZ[size]) + padding * 2, "px"), ";\n                                ").concat(padding ? "padding: 0 ".concat(padding, "px;") : '', "\n                            }\n                        ");
                    }
                });
            }
        }
    }
    return cssString;
};


//# sourceMappingURL=helper.js.map


/***/ }),

/***/ 25000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$p": function() { return /* binding */ USER_BANNED_EN; },
/* harmony export */   "$v": function() { return /* binding */ USER_NOT_ACTIVE_VI; },
/* harmony export */   "AX": function() { return /* binding */ UPDATE_USER; },
/* harmony export */   "Ic": function() { return /* binding */ USER_EMPLOYER_EN; },
/* harmony export */   "JT": function() { return /* binding */ VNW_NEW_REGISTERED; },
/* harmony export */   "QS": function() { return /* binding */ EPages; },
/* harmony export */   "S3": function() { return /* binding */ USER_NOT_ACTIVE_EN; },
/* harmony export */   "bU": function() { return /* binding */ USER_BANNED_VI; },
/* harmony export */   "dD": function() { return /* binding */ WS_TOKEN; },
/* harmony export */   "eS": function() { return /* binding */ LOGIN_POPUP; },
/* harmony export */   "fQ": function() { return /* binding */ USER_EMPLOYER_VI; },
/* harmony export */   "fT": function() { return /* binding */ USER_COOKIE; },
/* harmony export */   "h4": function() { return /* binding */ JS_TOKEN; },
/* harmony export */   "kd": function() { return /* binding */ WS_COOKIE; },
/* harmony export */   "uK": function() { return /* binding */ VNW_CSRF_JWT_TOKEN; },
/* harmony export */   "vG": function() { return /* binding */ KEY_AUTH_TOKEN; },
/* harmony export */   "xX": function() { return /* binding */ JS_ALL_TOKEN; },
/* harmony export */   "z4": function() { return /* binding */ UTM_SOURCE_MAPPING; }
/* harmony export */ });
'use client';

// Event name using for trigger open/close login popup
var LOGIN_POPUP = 'LOGIN_POPUP';
// UPDATE_USER event used for dispatch userInfo to other microfrontend pages
var UPDATE_USER = 'UPDATE_USER';
// KEY_AUTH_TOKEN is query params that is passed by mobile from WebView
var KEY_AUTH_TOKEN = 'authtoken';
var WS_TOKEN = 'VNWWS128450527232960';
var JS_TOKEN = 'VNW128450527232960';
var JS_ALL_TOKEN = 'VNWJSAll128450527232960';
var USER_COOKIE = 'VNW_USER_COOKIE';
var WS_COOKIE = 'VNW_WS_COOKIE';
var VNW_NEW_REGISTERED = 'VNW_NEW_REGISTERED';
// VNW_CSRF_JWT_TOKEN in cookie
var VNW_CSRF_JWT_TOKEN = 'VNW_CSRF_JWT_TOKEN';
// response message USER_NOT_ACTIVE
var USER_NOT_ACTIVE_EN = 'You have not verified your email. Please check your email inbox for instruction.';
var USER_NOT_ACTIVE_VI = 'Email của bạn chưa được xác thực. Hãy kiểm tra hộp thư để được hướng dẫn.';
// Response message USER_EMPLOYER
var USER_EMPLOYER_EN = 'This email address is registered as Employer, please Sign in from Employer Site.';
var USER_EMPLOYER_VI = 'Email đăng nhập được đăng ký trên trang nhà tuyển dụng, vui lòng đăng nhập trên trang nhà tuyển dụng.';
// BAN case
var USER_BANNED_EN = 'The account is banned from VietnamWorks. For more information, please contact us via (84 28) 5404 1373.';
var USER_BANNED_VI = 'Tài khoản đã bị chặn truy cập vào VietnamWorks. Để biết thêm chi tiết, vui lòng liên hệ chúng tôi qua (84 28) 5404 1373.';
// PageName (type EPages)
var EPages;
(function (EPages) {
    EPages["HOME_PAGE"] = "homepage";
    EPages["SEARCH_RESULT"] = "searchResult";
    EPages["SEO_LANDING_PAGE"] = "SEOLandingPage";
    EPages["TOP_MANAGEMENT_JOBS"] = "topManagementJobs";
    EPages["INTERVIEW"] = "interview";
    EPages["SALARY"] = "salary";
    EPages["COMPANY_LIST"] = "companyList";
    EPages["JOB_DETAIL"] = "jobDetail";
    EPages["MY_CAREER_CENTER"] = "myCareerCenter";
    EPages["DASHBOARD"] = "dashboard";
    EPages["PROFILE_SETTINGS"] = "profileSettings";
    EPages["MY_COMPANIES"] = "myCompanies";
    EPages["PROFILE_VIEWS"] = "profileViews";
    EPages["MY_JOBS"] = "myJobs";
    EPages["JOB_ALERTS"] = "jobAlerts";
    EPages["MY_PROFILE"] = "myProfile";
    EPages["ACCOUNT_SETTINGS"] = "accountSettings";
    EPages["OTHER"] = "other";
    EPages["MY_ACCOUNT"] = "myAccount";
    EPages["WOW_CV"] = "wowCv";
    EPages["REFERRAL_CANDIDATES"] = "referralCandidates";
    EPages["CAREER_TOOLS"] = "careerTools";
    EPages["SALARY_CONVERTER"] = "salaryConverter";
    EPages["CAREER_PATH"] = "careerPath";
    EPages["NUMEROLOGY"] = "numerology";
    EPages["EMPOWER_GROWTH"] = "empowerGrowth";
    EPages["PROFILE_SETTING"] = "profileSettings";
    EPages["VIEWED_JOBS"] = "viewedJobs";
    EPages["ACCOUNT_SETTING"] = "accountSettings";
    EPages["RECOMMENDED_JOBS"] = "recommendedJobs";
    EPages["APPLIED_JOB"] = "appliedJobs";
    EPages["ORDER_MANAGEMENT"] = "orderMangagement";
})(EPages || (EPages = {}));
var UTM_SOURCE_MAPPING = {
    wowCv: 'WowCv'
};


//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 42793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LoginModal; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(74982);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Input/index.js + 5 modules
var Input = __webpack_require__(68631);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/LoginModal/constants.js
var constants = __webpack_require__(25000);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Utils/constants.js
var Utils_constants = __webpack_require__(96782);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/LoginModal/LoginModal.css.js
'use client';





(0,styled_components_browser_esm/* keyframes */.F4)(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n"], ["\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n"])));
(0,styled_components_browser_esm/* keyframes */.F4)(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n"], ["\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n"])));
var LoginModalContainerWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 24px;\n"], ["\n    padding: 24px;\n"])));
var ForgotPasswordLink = styled_components_browser_esm/* default.a */.ZP.a(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", ";\n    cursor: pointer;\n    &:hover {\n        color: ", ";\n    }\n    &:focus-visible {\n        outline: none;\n        color: ", ";\n    }\n"], ["\n    color: ", ";\n    cursor: pointer;\n    &:hover {\n        color: ", ";\n    }\n    &:focus-visible {\n        outline: none;\n        color: ", ";\n    }\n"])), Utils_constants/* colors.primaryColor */.O9.primaryColor, Utils_constants/* colors.buttonColor */.O9.buttonColor, Utils_constants/* colors.buttonColor */.O9.buttonColor);
var SmallLabel = styled_components_browser_esm/* default.p */.ZP.p(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 0 0 16px 0;\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: 600;\n    color: #333;\n    text-align: center;\n"], ["\n    margin: 0 0 16px 0;\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: 600;\n    color: #333;\n    text-align: center;\n"])));
var LabelInput = styled_components_browser_esm/* default.p */.ZP.p(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 0 0 5px 0;\n    font-weight: 500;\n    display: inline-block;\n    color: #333;\n    font-size: 14px;\n    line-height: 18px;\n    > span {\n        color: #ff4a53;\n        font-weight: 700;\n        margin-left: 4px;\n    }\n"], ["\n    margin: 0 0 5px 0;\n    font-weight: 500;\n    display: inline-block;\n    color: #333;\n    font-size: 14px;\n    line-height: 18px;\n    > span {\n        color: #ff4a53;\n        font-weight: 700;\n        margin-left: 4px;\n    }\n"])));
var InputGroup = styled_components_browser_esm/* default.div */.ZP.div(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-bottom: 16px;\n"], ["\n    margin-bottom: 16px;\n"])));
var ForgotGroup = styled_components_browser_esm/* default.div */.ZP.div(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    text-align: right;\n"], ["\n    text-align: right;\n"])));
var SocialLoginGroup = styled_components_browser_esm/* default.div */.ZP.div(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    justify-content: center;\n    margin: 0 -15px 24px -15px;\n    > button {\n        &:first-child {\n            margin-right: 8px;\n        }\n        &:last-child {\n            margin-left: 8px;\n        }\n        > span {\n            margin-left: 8px;\n        }\n    }\n\n    @media (max-width: 768px) {\n        margin: 25px 0 24px;\n        flex-wrap: wrap;\n        gap: 15px;\n        > button {\n            width: 100%;\n            margin-left: 0 !important;\n            margin-right: 0 !important;\n        }\n    }\n"], ["\n    display: flex;\n    justify-content: center;\n    margin: 0 -15px 24px -15px;\n    > button {\n        &:first-child {\n            margin-right: 8px;\n        }\n        &:last-child {\n            margin-left: 8px;\n        }\n        > span {\n            margin-left: 8px;\n        }\n    }\n\n    @media (max-width: 768px) {\n        margin: 25px 0 24px;\n        flex-wrap: wrap;\n        gap: 15px;\n        > button {\n            width: 100%;\n            margin-left: 0 !important;\n            margin-right: 0 !important;\n        }\n    }\n"])));
var ErrorMessage = styled_components_browser_esm/* default.p */.ZP.p(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin: 8px 0 8px 0;\n    color: #ff4a53;\n"], ["\n    margin: 8px 0 8px 0;\n    color: #ff4a53;\n"])));
var RegisterLink = styled_components_browser_esm/* default.a */.ZP.a(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-left: 4px;\n    color: ", ";\n    &:hover {\n        color: ", ";\n    }\n    &:focus-visible {\n        outline: none;\n        color: ", ";\n    }\n"], ["\n    margin-left: 4px;\n    color: ", ";\n    &:hover {\n        color: ", ";\n    }\n    &:focus-visible {\n        outline: none;\n        color: ", ";\n    }\n"])), Utils_constants/* colors.primaryColor */.O9.primaryColor, Utils_constants/* colors.buttonColor */.O9.buttonColor, Utils_constants/* colors.buttonColor */.O9.buttonColor);
var PlatformSelectionSection = styled_components_browser_esm/* default.div */.ZP.div(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    gap: 16px;\n    margin-bottom: 24px;\n    width: 100%;\n    @media (max-width: 768px) {\n        flex-wrap: wrap;\n        flex-direction: column-reverse;\n        margin-bottom: 0px;\n    }\n"], ["\n    display: flex;\n    gap: 16px;\n    margin-bottom: 24px;\n    width: 100%;\n    @media (max-width: 768px) {\n        flex-wrap: wrap;\n        flex-direction: column-reverse;\n        margin-bottom: 0px;\n    }\n"])));
var PlatformButtonColumn = styled_components_browser_esm/* default.div */.ZP.div(templateObject_13 || (templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 50%;\n    background: url('https://www.vietnamworks.com/assets-page-container/images/bg-upzi-login.png') no-repeat left top;\n    border: 1px solid #efefef;\n    border-radius: 24px;\n    padding: 24px;\n    background-size: cover;\n    @media (max-width: 768px) {\n        width: 100%;\n        border: 1px solid #B2B8C5;\n        border-radius: 24px;\n        padding: 24px 24px 0px !important;\n    }\n"], ["\n    width: 50%;\n    background: url('https://www.vietnamworks.com/assets-page-container/images/bg-upzi-login.png') no-repeat left top;\n    border: 1px solid #efefef;\n    border-radius: 24px;\n    padding: 24px;\n    background-size: cover;\n    @media (max-width: 768px) {\n        width: 100%;\n        border: 1px solid #B2B8C5;\n        border-radius: 24px;\n        padding: 24px 24px 0px !important;\n    }\n"])));
var VnwsButtonColumn = styled_components_browser_esm/* default.div */.ZP.div(templateObject_14 || (templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 50%;\n    border-left: 1px solid #9AA2B4;\n    padding-left: 30px;\n    background: url('https://www.vietnamworks.com/assets-page-container/images/bg-vnws-login.png') no-repeat left top;\n    border: 1px solid #efefef;\n    border-radius: 24px;\n    padding: 24px;\n    background-size: cover;\n    @media (max-width: 768px) {\n        width: 100%;\n        border: 1px solid #B2B8C5 !important;\n        border-radius: 24px;\n        padding: 24px 24px 0px !important;\n        padding-left: 0;\n    }\n"], ["\n    width: 50%;\n    border-left: 1px solid #9AA2B4;\n    padding-left: 30px;\n    background: url('https://www.vietnamworks.com/assets-page-container/images/bg-vnws-login.png') no-repeat left top;\n    border: 1px solid #efefef;\n    border-radius: 24px;\n    padding: 24px;\n    background-size: cover;\n    @media (max-width: 768px) {\n        width: 100%;\n        border: 1px solid #B2B8C5 !important;\n        border-radius: 24px;\n        padding: 24px 24px 0px !important;\n        padding-left: 0;\n    }\n"])));
var UpziIntroTextSection = styled_components_browser_esm/* default.div */.ZP.div(templateObject_15 || (templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 50%;\n    text-align:left;\n    background: url('https://www.vietnamworks.com/assets-page-container/images/bg-upzi-login.png') no-repeat left top;\n    background-size:cover;\n    > h3 {\n        text-align:left;\n        margin-top: 30px;\n        line-height: 1.5;\n    }\n"], ["\n    width: 50%;\n    text-align:left;\n    background: url('https://www.vietnamworks.com/assets-page-container/images/bg-upzi-login.png') no-repeat left top;\n    background-size:cover;\n    > h3 {\n        text-align:left;\n        margin-top: 30px;\n        line-height: 1.5;\n    }\n"])));
var UpziIntroQrSection = styled_components_browser_esm/* default.div */.ZP.div(templateObject_16 || (templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 50%;\n    text-align:center;\n"], ["\n    width: 50%;\n    text-align:center;\n"])));
var UpziIntroQrWrap = styled_components_browser_esm/* default.div */.ZP.div(templateObject_17 || (templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-block;\n    border: 4px solid #e0e0e0;\n    border-radius: 45px;\n    background: #fff;\n    padding: 20px;\n"], ["\n    display: inline-block;\n    border: 4px solid #e0e0e0;\n    border-radius: 45px;\n    background: #fff;\n    padding: 20px;\n"])));
var UpziIntroSection = styled_components_browser_esm/* default.div */.ZP.div(templateObject_18 || (templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    padding: 24px 0;\n    \n"], ["\n    display: flex;\n    align-items: center;\n    padding: 24px 0;\n    \n"])));
var UpziTitle = styled_components_browser_esm/* default.h2 */.ZP.h2(templateObject_19 || (templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 28px;\n    font-weight: 700;\n    color: #333;\n    margin: 30px 0 10px 0;\n    text-align: left;\n    @media (max-width: 768px) {\n        font-size: 16px;\n    }\n"], ["\n    font-size: 28px;\n    font-weight: 700;\n    color: #333;\n    margin: 30px 0 10px 0;\n    text-align: left;\n    @media (max-width: 768px) {\n        font-size: 16px;\n    }\n"])));
var UpziSubtitle = styled_components_browser_esm/* default.h3 */.ZP.h3(templateObject_20 || (templateObject_20 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 28px;\n    font-weight: 600;\n    color: #333;\n"], ["\n    font-size: 28px;\n    font-weight: 600;\n    color: #333;\n"])));
var UpziDesc = styled_components_browser_esm/* default.div */.ZP.div(templateObject_21 || (templateObject_21 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 12px;\n    color: #6B7792;\n    margin-top: 20px;\n"], ["\n    font-size: 12px;\n    color: #6B7792;\n    margin-top: 20px;\n"])));
var UpziLearnMore = styled_components_browser_esm/* default.div */.ZP.div(templateObject_22 || (templateObject_22 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    cursor: pointer;\n    position: absolute;\n    right: 24px;\n    top: 14px;\n    > a {\n        font-size: 14px;\n        color: #005AFF;\n     }\n"], ["\n    cursor: pointer;\n    position: absolute;\n    right: 24px;\n    top: 14px;\n    > a {\n        font-size: 14px;\n        color: #005AFF;\n     }\n"])));
var UpziButtonWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_23 || (templateObject_23 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    display: flex;\n    margin-bottom: 24px;\n    \n    > button {\n        background-color: #9345FF !important;\n        color: #fff !important;\n        border-radius: 8px !important;\n        border: none !important;\n        font-weight: 500;\n        width: 250px;\n        &:hover {\n            border: none !important;\n            opacity: .8;\n        }\n        &:disabled {\n            opacity: 0.6;\n            cursor: not-allowed;\n        }\n        @media (max-width: 768px) {\n            display: none;\n        }\n    }\n"], ["\n    width: 100%;\n    display: flex;\n    margin-bottom: 24px;\n    \n    > button {\n        background-color: #9345FF !important;\n        color: #fff !important;\n        border-radius: 8px !important;\n        border: none !important;\n        font-weight: 500;\n        width: 250px;\n        &:hover {\n            border: none !important;\n            opacity: .8;\n        }\n        &:disabled {\n            opacity: 0.6;\n            cursor: not-allowed;\n        }\n        @media (max-width: 768px) {\n            display: none;\n        }\n    }\n"])));
var VnwsButtonWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_24 || (templateObject_24 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    display: flex;\n    margin-bottom: 24px;\n    \n    > button {\n        border: none !important;\n        font-weight: 500;\n        width: 250px;\n        &:hover {\n            border: none !important;\n            opacity: .8;\n        }\n        @media (max-width: 768px) {\n            display: none;\n        }\n    }\n"], ["\n    width: 100%;\n    display: flex;\n    margin-bottom: 24px;\n    \n    > button {\n        border: none !important;\n        font-weight: 500;\n        width: 250px;\n        &:hover {\n            border: none !important;\n            opacity: .8;\n        }\n        @media (max-width: 768px) {\n            display: none;\n        }\n    }\n"])));
var UpziWhySection = styled_components_browser_esm/* default.div */.ZP.div(templateObject_25 || (templateObject_25 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    margin-bottom: 24px;\n    @media (max-width: 768px) {\n        margin-bottom: 0;\n    }\n"], ["\n    width: 100%;\n    margin-bottom: 24px;\n    @media (max-width: 768px) {\n        margin-bottom: 0;\n    }\n"])));
var UpziWhyTitle = styled_components_browser_esm/* default.h4 */.ZP.h4(templateObject_26 || (templateObject_26 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 16px;\n    font-weight: 600;\n    color: #333;\n    margin: 50px 0 15px 0;\n    @media (max-width: 768px) {\n        display: none;\n    }\n"], ["\n    font-size: 16px;\n    font-weight: 600;\n    color: #333;\n    margin: 50px 0 15px 0;\n    @media (max-width: 768px) {\n        display: none;\n    }\n"])));
var UpziWhyList = styled_components_browser_esm/* default.ul */.ZP.ul(templateObject_27 || (templateObject_27 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    width: 100%;\n    \n    li {\n        display: flex;\n        align-items: flex-start;\n        margin-bottom: 12px;\n        font-size: 14px;\n        line-height: 22px;\n        color: #333;\n        font-weigth: 500;\n        position: relative;\n        \n        &:last-child {\n            margin-bottom: 0;\n        }\n\n        svg {\n            margin-right: 10px;\n            @media (max-width: 768px) {\n                display: none;\n            }\n        }\n        @media (max-width: 768px) {\n            &:before {\n                content: \"\";\n                width: 6px;\n                height: 6px;\n                border-radius: 50%;\n                background-color: #333;\n                margin-right: 10px;\n                flex-shrink: 0;\n                margin-top: 8px;\n            }\n            &:last-child {\n                display: none;\n            }\n        }\n    }\n"], ["\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    width: 100%;\n    \n    li {\n        display: flex;\n        align-items: flex-start;\n        margin-bottom: 12px;\n        font-size: 14px;\n        line-height: 22px;\n        color: #333;\n        font-weigth: 500;\n        position: relative;\n        \n        &:last-child {\n            margin-bottom: 0;\n        }\n\n        svg {\n            margin-right: 10px;\n            @media (max-width: 768px) {\n                display: none;\n            }\n        }\n        @media (max-width: 768px) {\n            &:before {\n                content: \"\";\n                width: 6px;\n                height: 6px;\n                border-radius: 50%;\n                background-color: #333;\n                margin-right: 10px;\n                flex-shrink: 0;\n                margin-top: 8px;\n            }\n            &:last-child {\n                display: none;\n            }\n        }\n    }\n"])));
var RegisterLinkButton = styled_components_browser_esm/* default.button */.ZP.button(templateObject_28 || (templateObject_28 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background: none;\n    border: none;\n    padding: 0;\n    margin: 0;\n    margin-left: 4px;\n    color: ", ";\n    cursor: pointer;\n    font-size: inherit;\n    font-weight: inherit;\n    text-decoration: none;\n    \n    &:hover {\n        color: ", ";\n    }\n    \n    &:focus-visible {\n        outline: none;\n        color: ", ";\n    }\n\n    &:focus {\n        outline: none;\n        color: ", ";\n    }\n\n    @media (max-width: 768px) {\n        display:inline-flex !important;\n    }\n"], ["\n    background: none;\n    border: none;\n    padding: 0;\n    margin: 0;\n    margin-left: 4px;\n    color: ", ";\n    cursor: pointer;\n    font-size: inherit;\n    font-weight: inherit;\n    text-decoration: none;\n    \n    &:hover {\n        color: ", ";\n    }\n    \n    &:focus-visible {\n        outline: none;\n        color: ", ";\n    }\n\n    &:focus {\n        outline: none;\n        color: ", ";\n    }\n\n    @media (max-width: 768px) {\n        display:inline-flex !important;\n    }\n"])), Utils_constants/* colors.primaryColor */.O9.primaryColor, Utils_constants/* colors.buttonColor */.O9.buttonColor, Utils_constants/* colors.buttonColor */.O9.buttonColor, Utils_constants/* colors.buttonColor */.O9.buttonColor);
var CloseIconHeader = styled_components_browser_esm/* default.div */.ZP.div(templateObject_29 || (templateObject_29 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    width: 100%;\n    height: 61px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 14px;\n    border-bottom: none;\n    border-radius: 10px 10px 0 0;\n    background: #fff;\n    > button {\n        background: transparent !important;\n        color: #005AFF !important;\n        border: none !important;\n        > svg {\n            margin-right: 10px;\n        }\n        &:hover {\n            background-color: transparent !important;\n            border: none !important;\n            opacity: .6;\n            box-shadow: none !important;\n        }\n        &:focus {\n            border: none !important;\n            background-color: transparent !important;\n            box-shadow: none !important;\n        }\n    }\n"], ["\n    position: relative;\n    width: 100%;\n    height: 61px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 14px;\n    border-bottom: none;\n    border-radius: 10px 10px 0 0;\n    background: #fff;\n    > button {\n        background: transparent !important;\n        color: #005AFF !important;\n        border: none !important;\n        > svg {\n            margin-right: 10px;\n        }\n        &:hover {\n            background-color: transparent !important;\n            border: none !important;\n            opacity: .6;\n            box-shadow: none !important;\n        }\n        &:focus {\n            border: none !important;\n            background-color: transparent !important;\n            box-shadow: none !important;\n        }\n    }\n"])));
var ModalFormWapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_30 || (templateObject_30 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-betwwen;\n"], ["\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-betwwen;\n"])));
var ModalFormTitle = styled_components_browser_esm/* default.div */.ZP.div(templateObject_31 || (templateObject_31 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-size: 20px;\n    font-weight: bold;\n    padding-top: 25px;\n    width: 50%;\n    background: url('https://www.vietnamworks.com/assets-page-container/images/bg-vnws-login.png') no-repeat left 30px;\n    > h3 {\n     margin-top:40px;\n     line-height: 1.5;\n    }\n    @media (max-width: 768px) {\n        display: none;\n    }\n"], ["\n    font-size: 20px;\n    font-weight: bold;\n    padding-top: 25px;\n    width: 50%;\n    background: url('https://www.vietnamworks.com/assets-page-container/images/bg-vnws-login.png') no-repeat left 30px;\n    > h3 {\n     margin-top:40px;\n     line-height: 1.5;\n    }\n    @media (max-width: 768px) {\n        display: none;\n    }\n"])));
var ModalFormTitleSelect = styled_components_browser_esm/* default.div */.ZP.div(templateObject_32 || (templateObject_32 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    > h3 {\n        font-size: 16px;\n        line-height: 20px;\n        font-weight: 600;\n        color: rgb(51, 51, 51);\n        text-align: center;\n    }\n"], ["\n    > h3 {\n        font-size: 16px;\n        line-height: 20px;\n        font-weight: 600;\n        color: rgb(51, 51, 51);\n        text-align: center;\n    }\n"])));
var ModalFormContent = styled_components_browser_esm/* default.div */.ZP.div(templateObject_33 || (templateObject_33 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 50%;\n    @media (max-width: 768px) {\n        width: 100%;\n        display: flex;\n        flex-direction: column-reverse;\n    }\n"], ["\n    width: 50%;\n    @media (max-width: 768px) {\n        width: 100%;\n        display: flex;\n        flex-direction: column-reverse;\n    }\n"])));
var MobileButtonWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_34 || (templateObject_34 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: none;\n    border-top: 1px solid #D9D9D9;\n    text-align: center;\n    font-weight: 500;\n    margin-top: 15px;\n    > button {\n        background-color: transparent !important;\n        border: none !important;\n        color: #1C1C1C !important;\n        display: flex!important;\n        width: 100%;\n        svg {\n            margin-left: 10px;\n        }\n        &:focus {\n            background-color: transparent !important;\n            border: none !important;\n            color: #1C1C1C !important;\n        }\n        &:hover {\n            background-color: transparent !important;\n            border: none !important;\n            color: #1C1C1C !important;\n            box-shadow: none !important;\n        }\n    }\n\n    @media (max-width: 768px) {\n        display: block;\n    }\n"], ["\n    display: none;\n    border-top: 1px solid #D9D9D9;\n    text-align: center;\n    font-weight: 500;\n    margin-top: 15px;\n    > button {\n        background-color: transparent !important;\n        border: none !important;\n        color: #1C1C1C !important;\n        display: flex!important;\n        width: 100%;\n        svg {\n            margin-left: 10px;\n        }\n        &:focus {\n            background-color: transparent !important;\n            border: none !important;\n            color: #1C1C1C !important;\n        }\n        &:hover {\n            background-color: transparent !important;\n            border: none !important;\n            color: #1C1C1C !important;\n            box-shadow: none !important;\n        }\n    }\n\n    @media (max-width: 768px) {\n        display: block;\n    }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34;


//# sourceMappingURL=LoginModal.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/LoginModal/translations.js
'use client';

var translations = {
    'Sign in to continue': 'Đăng nhập để tiếp tục',
    'Register with Email': 'Đăng ký bằng Email',
    'Login with Email': 'Đăng nhập bằng Email',
    'Forgot Password?': 'Quên mật khẩu?',
    Email: 'Email',
    Password: 'Mật khẩu',
    'with Facebook account': 'với tài khoản Facebook',
    'with Google account': 'với tài khoản Google',
    Login: 'Đăng nhập',
    "Don't have an account yet?": 'Chưa có tài khoản?',
    'Register now': 'Đăng Ký',
    'The Email field is required.': 'Vui lòng nhập Email',
    'The Password field is required.': 'Vui lòng nhập Mật Khẩu',
    'The Email must be a valid Email address.': 'Email không hợp lệ.',
    'Wrong email or password. Please check again.': 'Email hoặc mật khẩu không đúng. Hãy kiểm tra lại.',
    'You have not verified your email. Please check your email inbox for instruction.': 'Email của bạn chưa được xác thực. Hãy kiểm tra hộp thư để được hướng dẫn.',
    'This email address is registered as Employer, please Sign in from Employer Site.': 'Email đăng nhập được đăng ký trên trang nhà tuyển dụng, vui lòng đăng nhập trên trang nhà tuyển dụng.',
    'The account is banned from VietnamWorks. For more information, please contact us via (84 28) 5404 1373.': 'Tài khoản đã bị chặn truy cập vào VietnamWorks. Để biết thêm chi tiết, vui lòng liên hệ chúng tôi qua (84 28) 5404 1373.',
    'Choose Login Method': 'Chọn phương thức đăng nhập',
    'Login VietnamWorks': 'Đăng nhập VietnamWorks',
    'Start with Upzi': 'Bắt đầu với Upzi',
    'Continue with VietnamWorks': 'Tiếp tục với Vietnamworks',
    'Welcome to Upzi': 'Chào mừng đến với Upzi',
    'Upzi is a modern platform designed to help you advance your career.': 'Upzi là nền tảng hiện đại được thiết kế để giúp bạn phát triển sự nghiệp.',
    'Discover new opportunities and grow professionally with Upzi.': 'Khám phá cơ hội mới và phát triển chuyên nghiệp cùng Upzi.',
    'Personalized career recommendations': 'Gợi ý nghề nghiệp được cá nhân hóa',
    'Advanced job matching technology': 'Công nghệ kết nối việc làm tiên tiến',
    'Professional development resources': 'Tài nguyên phát triển chuyên nghiệp',
    'Connect with top employers': 'Kết nối với các nhà tuyển dụng hàng đầu',
    'Back': 'Quay lại',
    'Register': 'Đăng ký',
    'First Name': 'Tên',
    'Last Name': 'Họ',
    'Phone Number': 'Số điện thoại',
    'The First Name field is required.': 'Vui lòng nhập Tên',
    'First Name must not exceed 50 characters.': 'Tên không được vượt quá 50 ký tự.',
    'First Name must contain only letters.': 'Tên chỉ được chứa chữ cái.',
    'The Last Name field is required.': 'Vui lòng nhập Họ',
    'Last Name must not exceed 50 characters.': 'Họ không được vượt quá 50 ký tự.',
    'Last Name must contain only letters.': 'Họ chỉ được chứa chữ cái.',
    'The Phone Number field is required.': 'Vui lòng nhập Số điện thoại',
    'Phone is invalid': 'Số điện thoại không hợp lệ',
    'Phone must be at least 7 digits': 'Số điện thoại phải có ít nhất 7 chữ số',
    'Phone must not exceed 15 digits': 'Số điện thoại không được vượt quá 15 chữ số',
    'I agree to the': 'Tôi đồng ý với',
    'and': 'và',
    ' Terms of Use ': ' Thoả thuận sử dụng ',
    ' Privacy Policy ': ' Quy định bảo mật ',
    'of VietnamWorks.': 'của VietnamWorks.',
    'Please tick the checkbox if you want to proceed.': 'Vui lòng đánh dấu vào hộp chọn để tiếp tục đăng ký.',
    'Already have an account?': 'Đã có tài khoản?',
    'Sign in': 'Đăng nhập',
    'Registration failed. Please try again.': 'Đăng ký thất bại. Vui lòng thử lại.',
    'Registration successful! Please check your email to verify your account.': 'Đăng ký thành công! Vui lòng kiểm tra email để xác thực tài khoản.',
    'Password must be between 6 and 50 characters.': 'Mật khẩu phải từ 6 đến 50 ký tự.',
    'Password must contain at least one uppercase letter.': 'Mật khẩu phải có ít nhất một chữ hoa.',
    'Password must contain at least one number.': 'Mật khẩu phải có ít nhất một chữ số.',
    'Registration succeeded but auto login failed. Please login manually.': 'Đăng ký thành công nhưng không thể tự đăng nhập. Vui lòng đăng nhập thủ công.',
    'For Fresher & under 3 years of experience': 'Dành cho Fresher & dưới 3 năm kinh nghiệm',
    'For people with 3 years of experience and above': 'Dành cho người từ 3 năm kinh nghiệm trở lên',
    'Why choose Upzi?': 'Tại sao chọn Upzi?',
    'Career guidance app for young people': 'Ứng dụng hướng nghiệp cho Intern & Fresher',
    'Thousands of job opportunities exclusively for young people': 'Hàng ngàn cơ hội việc làm dành riêng cho giới trẻ',
    'AI-powered job fit assessment for you': 'Đánh giá độ phù hợp của bạn với công việc với AI',
    'Why choose VietnamWorks?': 'Tại sao chọn VietnamWorks',
    'Job platform for experienced professionals': 'Nền tảng tìm việc cho người có kinh nghiệm',
    'Huge number of jobs for all industries': 'Việc làm chất lượng, đa dạng cho mọi ngành nghề',
    'Evaluate your job matching with AI': 'Đánh giá độ phù hợp của bạn với công việc với AI',
    "Register with": "Đăng ký tài khoản",
    "Sign in to": "Đăng nhập với",
    "Scan QR get app to see Thousands of job opportunities exclusively for Freshers": "Scan QR tải app & xem hàng ngàn việc làm cho Freshers",
    "Upzi is a product of Navigos Group – the leading and trusted recruitment organization in Vietnam.": "Upzi là một sản phẩm của Navigos Group – đơn vị tuyển dụng uy tín hàng đầu Việt Nam.",
    'Download Upzi': 'Tải app Upzi',
    "Thousands of job opportunities exclusively for Freshers": "Hàng ngàn cơ hội việc làm dành riêng cho giới trẻ",
    'Learn more': 'Tìm hiểu thêm',
    'What is Upzi?': 'Upzi là gì?',
    'Select to continue': 'Chọn để tiếp tục'
};


//# sourceMappingURL=translations.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Utils/cookie.js
var cookie = __webpack_require__(75929);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(25035);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Images/GoogleLogoIcon/index.js
'use client';




var GoogleLogoIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c;
    return ((0,jsx_runtime.jsxs)("svg", { width: width, height: height, viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: [(0,jsx_runtime.jsx)("path", { d: 'M18.1713 8.36775H17.5001V8.33317H10.0001V11.6665H14.7097C14.0226 13.6069 12.1763 14.9998 10.0001 14.9998C7.23883 14.9998 5.00008 12.7611 5.00008 9.99984C5.00008 7.23859 7.23883 4.99984 10.0001 4.99984C11.2747 4.99984 12.4342 5.48067 13.3172 6.26609L15.6742 3.909C14.1859 2.52192 12.1951 1.6665 10.0001 1.6665C5.398 1.6665 1.66675 5.39775 1.66675 9.99984C1.66675 14.6019 5.398 18.3332 10.0001 18.3332C14.6022 18.3332 18.3334 14.6019 18.3334 9.99984C18.3334 9.44109 18.2759 8.89567 18.1713 8.36775Z', fill: '#FFC107' }), (0,jsx_runtime.jsx)("path", { d: 'M2.62732 6.12109L5.36524 8.129C6.10607 6.29484 7.90024 4.99984 9.99982 4.99984C11.2744 4.99984 12.434 5.48067 13.3169 6.26609L15.674 3.909C14.1857 2.52192 12.1948 1.6665 9.99982 1.6665C6.79899 1.6665 4.02315 3.47359 2.62732 6.12109Z', fill: '#FF3D00' }), (0,jsx_runtime.jsx)("path", { d: 'M10 18.3331C12.1525 18.3331 14.1084 17.5094 15.5871 16.1698L13.008 13.9873C12.1713 14.621 11.1313 14.9998 10 14.9998C7.83255 14.9998 5.99213 13.6177 5.2988 11.689L2.5813 13.7827C3.96047 16.4815 6.7613 18.3331 10 18.3331Z', fill: '#4CAF50' }), (0,jsx_runtime.jsx)("path", { d: 'M18.1712 8.36808H17.5V8.3335H10V11.6668H14.7096C14.3796 12.5989 13.78 13.4027 13.0067 13.9881L13.0079 13.9872L15.5871 16.1697C15.4046 16.3356 18.3333 14.1668 18.3333 10.0002C18.3333 9.44141 18.2758 8.896 18.1712 8.36808Z', fill: '#1976D2' })] }));
};
var GoogleLogoIcon$1 = react.memo(GoogleLogoIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Images/FacebookLogoIcon/index.js
'use client';




var FacebookLogoIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c;
    return ((0,jsx_runtime.jsxs)("svg", { width: width, height: height, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: [(0,jsx_runtime.jsxs)("g", { clipPath: 'url(#clip0_8755_164691)', children: [(0,jsx_runtime.jsx)("path", { d: 'M10.02 23.88C4.32 22.86 0 17.94 0 12C0 5.4 5.4 0 12 0C18.6 0 24 5.4 24 12C24 17.94 19.68 22.86 13.98 23.88L13.32 23.34H10.68L10.02 23.88Z', fill: 'url(#paint0_linear_8755_164691)' }), (0,jsx_runtime.jsx)("path", { d: 'M16.6801 15.3602L17.2201 12.0002H14.0401V9.66018C14.0401 8.70018 14.4001 7.98018 15.8401 7.98018H17.4001V4.92018C16.5601 4.80018 15.6001 4.68018 14.7601 4.68018C12.0001 4.68018 10.0801 6.36018 10.0801 9.36018V12.0002H7.08008V15.3602H10.0801V23.8202C10.7401 23.9402 11.4001 24.0002 12.0601 24.0002C12.7201 24.0002 13.3801 23.9402 14.0401 23.8202V15.3602H16.6801Z', fill: 'white' })] }), (0,jsx_runtime.jsxs)("defs", { children: [(0,jsx_runtime.jsxs)("linearGradient", { id: 'paint0_linear_8755_164691', x1: '12.0006', y1: '23.1654', x2: '12.0006', y2: '-0.00442066', gradientUnits: 'userSpaceOnUse', children: [(0,jsx_runtime.jsx)("stop", { stopColor: '#0062E0' }), (0,jsx_runtime.jsx)("stop", { offset: '1', stopColor: '#19AFFF' })] }), (0,jsx_runtime.jsx)("clipPath", { id: 'clip0_8755_164691', children: (0,jsx_runtime.jsx)("rect", { width: '24', height: '24', fill: 'white' }) })] })] }));
};
var FacebookLogoIcon$1 = react.memo(FacebookLogoIcon);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Images/CloseIcon/index.js
var CloseIcon = __webpack_require__(18700);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/LoginModal/helper.js
'use client';




var isMobile = function () {
    if (typeof window !== 'undefined') {
        var result = window.innerWidth < 768;
        return result;
    }
    return false;
};
var getBaseMsUrl = function () {
    var locationUrl = 'https://ms.vietnamworks.com';
    // Make sure it check window on server side
    if (typeof window !== 'undefined') {
        locationUrl = window.location.origin;
    }
    // staging
    if (locationUrl.indexOf('staging.') >= 0) {
        return locationUrl.replace('staging.', 'staging-ms.');
    }
    // release
    if (locationUrl.indexOf('release.') >= 0) {
        return locationUrl.replace('release.', 'release-ms.');
    }
    // production
    if (locationUrl.indexOf('www.vietnamworks.') >= 0) {
        return locationUrl.replace('www.vietnamworks.', 'ms.vietnamworks.');
    }
    if (locationUrl.indexOf('localhost:') >= 0) {
        return 'https://staging-ms.vietnamworks.com';
    }
    return locationUrl;
};
var secureUrl = function () {
    var locationUrl = 'https://secure.vietnamworks.com';
    // Make sure it check window on server side
    if (typeof window !== 'undefined') {
        locationUrl = window.location.origin;
    }
    // staging
    if (locationUrl.indexOf('staging.') >= 0) {
        return locationUrl.replace('staging.', 'staging-secure.');
    }
    // release
    if (locationUrl.indexOf('release.') >= 0) {
        return locationUrl.replace('release.', 'release-secure.');
    }
    // production
    if (locationUrl.indexOf('www.vietnamworks.') >= 0) {
        return locationUrl.replace('www.vietnamworks.', 'secure.vietnamworks.');
    }
    if (locationUrl.indexOf('localhost:') >= 0) {
        return 'https://staging-secure.vietnamworks.com';
    }
    // Only for wowCV
    if (locationUrl.indexOf('wowcv.') >= 0) {
        return locationUrl.replace('wowcv.', 'secure.');
    }
    return locationUrl;
};
/**
 * Get Vietnamworks url base on current location path (Without using APP_MODE)
 *
 * isHaveLocal true then this function will return base url as localhost
 * (This allow for user login cookie can be saved in localhost)
 *
 * @author Thien Tran
 * @since Jun 09, 2023
 * @param isHaveLocal boolean is isHaveLocal or just want link
 * @returns vietnamworks url
 */
var getBaseUrl = function (isHaveLocal) {
    if (isHaveLocal === void 0) { isHaveLocal = true; }
    var locationUrl = 'www.vietnamworks.com';
    // Make sure it check window on server side
    if (typeof window !== 'undefined') {
        locationUrl = window.location.origin;
    }
    // staging
    if (locationUrl.indexOf('staging.') >= 0 || locationUrl.indexOf('staging-wowcv.') >= 0) {
        return 'staging.vietnamworks.com';
    }
    // release
    if (locationUrl.indexOf('release.') >= 0 || locationUrl.indexOf('release-wowcv.') >= 0) {
        return 'release.vietnamworks.com';
    }
    // production
    if (locationUrl.indexOf('www.vietnamworks.') >= 0 || locationUrl.indexOf('wowcv.') >= 0) {
        return 'www.vietnamworks.com';
    }
    // Make sure cookie was saved in localhost if logged in via localhost
    if (locationUrl.indexOf('localhost:') >= 0) {
        return isHaveLocal ? 'localhost' : 'www.vietnamworks.com';
    }
    return locationUrl;
};
var getRegisterUrl = function (langCode, utmTracking) {
    if (utmTracking === void 0) { utmTracking = ''; }
    var langKey = langCode === Utils_constants/* ELanguage.VI */.Df.VI ? 'vi' : 'en';
    var registerLink = "".concat(secureUrl(), "/register/").concat(langKey, "?client_id=3");
    if (utmTracking !== '') {
        registerLink += "&".concat(utmTracking);
    }
    return registerLink;
};
var getForgotPasswordUrl = function (langCode) {
    var langKey = langCode === Utils_constants/* ELanguage.VI */.Df.VI ? 'vi' : 'en';
    return "".concat(secureUrl(), "/password/").concat(langKey, "/reset?client_id=3");
};
var buildUtm = function (pageName) {
    var utmSource = constants/* UTM_SOURCE_MAPPING */.z4[pageName] || '';
    return "utm_source_navi=".concat(utmSource, "&utm_medium_navi=Header");
};
var getSocialLoginUrl = function (type, langCode, isApply, pageName) {
    // getBaseUrl(false) mean it should return base url without localhost
    var vnwUrl = getBaseUrl(false);
    var loginPath = langCode === Utils_constants/* ELanguage.VI */.Df.VI ? 'dang-nhap' : 'login';
    var loginUrl = "https://".concat(vnwUrl, "/").concat(loginPath, "?type=").concat(type);
    if (typeof window === 'undefined') {
        return loginUrl;
    }
    var locationUrl = window.location.href;
    if (isApply) {
        if (locationUrl.indexOf('?') > 0) {
            locationUrl += '&applyJob=1';
        }
        else {
            locationUrl += '?applyJob=1';
        }
    }
    if (window.location.href.indexOf('.com/logout') >= 1) {
        locationUrl =
            langCode === Utils_constants/* ELanguage.VI */.Df.VI
                ? "https://".concat(vnwUrl, "/quan-ly-nghe-nghiep/tong-quan")
                : "https://".concat(vnwUrl, "/my-career-center/dashboard");
    }
    // Change password page
    if (window.location.href.indexOf('/quan-ly-tai-khoan/thay-mat-khau-thanh-cong') > 0 ||
        window.location.href.indexOf('/account-settings/change-password-success') > 0) {
        locationUrl =
            langCode === Utils_constants/* ELanguage.VI */.Df.VI
                ? "https://".concat(vnwUrl, "/quan-ly-nghe-nghiep/tong-quan")
                : "https://".concat(vnwUrl, "/my-career-center/dashboard");
    }
    // Change email page
    if (window.location.href.indexOf('/quan-ly-tai-khoan/thay-email-thanh-cong') > 0 ||
        window.location.href.indexOf('/account-settings/change-email-success') > 0) {
        locationUrl =
            langCode === Utils_constants/* ELanguage.VI */.Df.VI
                ? "https://".concat(vnwUrl, "/quan-ly-nghe-nghiep/tong-quan")
                : "https://".concat(vnwUrl, "/my-career-center/dashboard");
    }
    // add utm
    if (locationUrl.indexOf('?') > 0) {
        locationUrl += '&' + buildUtm(pageName);
    }
    else {
        locationUrl += '?' + buildUtm(pageName);
    }
    var encodedRedirectUrl = typeof window !== 'undefined' ? encodeURIComponent(locationUrl) : '';
    if (encodedRedirectUrl !== '') {
        loginUrl += "&redirectURL=".concat(encodedRedirectUrl);
    }
    return loginUrl;
};


//# sourceMappingURL=helper.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/QuickApplyJobModal/type.js
'use client';

var ECVOption;
(function (ECVOption) {
    ECVOption["onlineProfile"] = "onlineProfile";
    ECVOption["attachedCV"] = "attachedCV";
})(ECVOption || (ECVOption = {}));
var EEditAction;
(function (EEditAction) {
    EEditAction["editPhone"] = "editPhone";
    EEditAction["editJobTitle"] = "editJobTitle";
    EEditAction["none"] = "none";
})(EEditAction || (EEditAction = {}));
var DEFAULT_ALLOW_FILES_EXT = (/* unused pure expression or super */ null && ([
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
]));
var DEFAULT_ALLOW_EXT = '.doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf';
var DEFAULT_LIMIT_FILE_SIZE = 5120000; // 5MB
var DEFAULT_SUCCESS_CODE = 200;
var EUserInfoType;
(function (EUserInfoType) {
    EUserInfoType["phone"] = "phone";
    EUserInfoType["jobTitle"] = "jobTitle";
})(EUserInfoType || (EUserInfoType = {}));
var EApplyType;
(function (EApplyType) {
    EApplyType["online"] = "online";
    EApplyType["lastAttachment"] = "last_attachment";
    EApplyType["newAttachment"] = "new_attachment";
})(EApplyType || (EApplyType = {}));
var EBlockSuggestion;
(function (EBlockSuggestion) {
    EBlockSuggestion["BasicInfo"] = "BasicInfo";
    EBlockSuggestion["Skills"] = "Skills";
    EBlockSuggestion["Educations"] = "Educations";
    EBlockSuggestion["WorkingHistories"] = "WorkingHistories";
    EBlockSuggestion["Summary"] = "Summary";
})(EBlockSuggestion || (EBlockSuggestion = {}));


//# sourceMappingURL=type.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(31545);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/LoginModal/services.js
'use client';







var apiGetCSRFToken = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var API_GET_CSRF_TOKEN, response, repsonseJson, ex_1;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                API_GET_CSRF_TOKEN = "".concat(secureUrl(), "/api/v1/getCsrfToken");
                return [4 /*yield*/, fetch(API_GET_CSRF_TOKEN)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                repsonseJson = _a.sent();
                return [2 /*return*/, {
                        code: repsonseJson.code,
                        jwtToken: repsonseJson.jwt_token,
                        csrfToken: repsonseJson.csrf_token
                    }];
            case 3:
                ex_1 = _a.sent();
                console.error(ex_1);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
var apiDoLogin = function (params) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var username, password, csrfToken, jwtToken, langCode, headers, formData, LOGIN_API, requestOptions, response, responseJson, ex_2;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                username = params.username, password = params.password, csrfToken = params.csrfToken, jwtToken = params.jwtToken, langCode = params.langCode;
                headers = new Headers();
                headers.append('X-XSRF-TOKEN', csrfToken);
                headers.append('X-JWT-TOKEN', jwtToken);
                headers.append('Accept-Language', langCode);
                formData = new FormData();
                formData.set('username', username);
                formData.set('password', password);
                LOGIN_API = "".concat(secureUrl(), "/api/v1/login");
                requestOptions = {
                    method: 'POST',
                    headers: headers,
                    body: formData
                };
                return [4 /*yield*/, fetch(LOGIN_API, requestOptions)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                responseJson = _a.sent();
                if (!responseJson) {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, {
                        code: (responseJson === null || responseJson === void 0 ? void 0 : responseJson.code) || 400,
                        message: (responseJson === null || responseJson === void 0 ? void 0 : responseJson.message) || '',
                        accessToken: (responseJson === null || responseJson === void 0 ? void 0 : responseJson.access_token) || '',
                        refreshToken: (responseJson === null || responseJson === void 0 ? void 0 : responseJson.refresh_token) || '',
                        expiresIn: (responseJson === null || responseJson === void 0 ? void 0 : responseJson.expires_in) || 0,
                        wsToken: responseJson[constants/* WS_TOKEN */.dD] || '',
                        jsToken: responseJson[constants/* JS_TOKEN */.h4] || '',
                        jsAllToken: responseJson[constants/* JS_ALL_TOKEN */.xX] || '',
                        userCookie: responseJson[constants/* USER_COOKIE */.fT] || '',
                        newRegistered: responseJson[constants/* VNW_NEW_REGISTERED */.JT] || false,
                        scope: (responseJson === null || responseJson === void 0 ? void 0 : responseJson.scope) || ''
                    }];
            case 3:
                ex_2 = _a.sent();
                console.error(ex_2);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
var apiGetUserInfoFromToken = function (jsToken, wsToken) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var GET_INFO_FROM_TOKEN, response, responseData, user, ex_3;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                if (jsToken === '') {
                    console.error('Missing jsToken');
                    return [2 /*return*/, null];
                }
                if (wsToken === '') {
                    console.error('Missing wsToken');
                    return [2 /*return*/, null];
                }
                GET_INFO_FROM_TOKEN = "".concat(secureUrl(), "/api/v1/users/get-info-from-token");
                return [4 /*yield*/, fetch(GET_INFO_FROM_TOKEN, {
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/vnd.api+json',
                            Accept: 'application/vnd.api+json'
                        },
                        body: JSON.stringify({ jsToken: jsToken, wsToken: wsToken })
                    })];
            case 1:
                response = _a.sent();
                if (response.status !== DEFAULT_SUCCESS_CODE) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, response.json()];
            case 2:
                responseData = _a.sent();
                user = responseData.data[0];
                return [2 /*return*/, (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, user.id), user.attributes), { accessToken: (0,helpers/* encrypt */.HI)(user.attributes.accessToken) })];
            case 3:
                ex_3 = _a.sent();
                console.error(ex_3);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
var apiVerifyAuthToken = function (authToken) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var headers, VERIFY_AUTH_TOKEN_API, requestOptions, response, responseJson, ex_4;
    return (0,_tslib/* __generator */.Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                headers = new Headers();
                headers.append('Content-Type', 'application/json');
                VERIFY_AUTH_TOKEN_API = "".concat(secureUrl(), "/api/v1/users/verify-auth-token");
                requestOptions = {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify({
                        auth_token: authToken
                    })
                };
                return [4 /*yield*/, fetch(VERIFY_AUTH_TOKEN_API, requestOptions)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()
                    // Reponse error
                ];
            case 2:
                responseJson = _a.sent();
                // Reponse error
                if (!responseJson) {
                    return [2 /*return*/, null];
                }
                // Response success failed
                if (!responseJson.success) {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, {
                        wsToken: responseJson.data[constants/* WS_TOKEN */.dD] || '',
                        jsToken: responseJson.data[constants/* JS_TOKEN */.h4] || '',
                        jsAllToken: responseJson.data[constants/* JS_ALL_TOKEN */.xX] || '',
                        userCookie: responseJson.data[constants/* USER_COOKIE */.fT] || ''
                    }];
            case 3:
                ex_4 = _a.sent();
                console.error(ex_4);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };


//# sourceMappingURL=services.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Popup/index.js + 3 modules
var Popup = __webpack_require__(4835);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Images/LoadingIcon/index.js
'use client';



var LoadingIcon = function (props) {
    var _a = props.width, width = _a === void 0 ? 24 : _a, _b = props.height, height = _b === void 0 ? 24 : _b, _c = props.bgColor, bgColor = _c === void 0 ? '#FF7D55' : _c, _d = props.durationTime, durationTime = _d === void 0 ? 0.8 : _d;
    return ((0,jsx_runtime.jsxs)("svg", { version: '1.1', xmlns: 'http://www.w3.org/2000/svg', x: '0px', y: '0px', width: width, height: height, viewBox: '0 0 24 30', children: [(0,jsx_runtime.jsxs)("rect", { x: '0', y: '10', width: '4', height: '10', fill: bgColor, opacity: '0.2', children: [(0,jsx_runtime.jsx)("animate", { attributeName: 'opacity', attributeType: 'XML', values: '0.2; 1; .2', begin: '0s', dur: durationTime, repeatCount: 'indefinite' }), (0,jsx_runtime.jsx)("animate", { attributeName: 'height', attributeType: 'XML', values: '10; 20; 10', begin: '0s', dur: durationTime, repeatCount: 'indefinite' }), (0,jsx_runtime.jsx)("animate", { attributeName: 'y', attributeType: 'XML', values: '10; 5; 10', begin: '0s', dur: durationTime, repeatCount: 'indefinite' })] }), (0,jsx_runtime.jsxs)("rect", { x: '8', y: '10', width: '4', height: '10', fill: bgColor, opacity: '0.2', children: [(0,jsx_runtime.jsx)("animate", { attributeName: 'opacity', attributeType: 'XML', values: '0.2; 1; .2', begin: '0.15s', dur: durationTime, repeatCount: 'indefinite' }), (0,jsx_runtime.jsx)("animate", { attributeName: 'height', attributeType: 'XML', values: '10; 20; 10', begin: '0.15s', dur: durationTime, repeatCount: 'indefinite' }), (0,jsx_runtime.jsx)("animate", { attributeName: 'y', attributeType: 'XML', values: '10; 5; 10', begin: '0.15s', dur: durationTime, repeatCount: 'indefinite' })] }), (0,jsx_runtime.jsxs)("rect", { x: '16', y: '10', width: '4', height: '10', fill: bgColor, opacity: '0.2', children: [(0,jsx_runtime.jsx)("animate", { attributeName: 'opacity', attributeType: 'XML', values: '0.2; 1; .2', begin: '0.3s', dur: durationTime, repeatCount: 'indefinite' }), (0,jsx_runtime.jsx)("animate", { attributeName: 'height', attributeType: 'XML', values: '10; 20; 10', begin: '0.3s', dur: durationTime, repeatCount: 'indefinite' }), (0,jsx_runtime.jsx)("animate", { attributeName: 'y', attributeType: 'XML', values: '10; 5; 10', begin: '0.3s', dur: durationTime, repeatCount: 'indefinite' })] })] }));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/PostHog/hooks/useHog/index.js
var useHog = __webpack_require__(20560);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/services/model/index.js
'use client';

var model_ModelError = /** @class */ (function () {
    function ModelError(data) {
        Object.assign(this, data);
    }
    return ModelError;
}());


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/services/resumes/const.js
'use client';

var const_CHANGE_JOB_TITLE = 'api-gateway/v1.0/profile/job-title';
var const_CHANGE_PHONE_NUMBER = 'api-gateway/v1.0/profile/change-phone';
var const_ATTACHED_RESUME_VALIDATE = 'attached-resumes-validation/v1/validate-resume';
var const_ENDPOINT_UPDATE_RESUME_FILE = 'profile/update-resume-file';
var PROFILE_LEVEL = 'api-gateway/v1.0/profile/level';
var const_RESUME_SETTING_INFO = 'api-gateway/v2.0/profile/resume-setting-info';
var const_JOBLEVEL = 'meta/v1.0/job-levels';
var const_BASIC_INFO = 'api-gateway/v1.0/profile/basic-info';
var const_SEARCHABLE = 'api-gateway/v1.0/profile/resume-change-searchable';
var const_PROFILE_COOKIE = 'api-gateway/v1.0/profile/cookie';
var const_SKILL_TAGS = 'skill-tags/api/v1/skills/suggestion';
var const_REFRESH_PROFILE = 'api-gateway/v1.0/profile/refresh-profile';
var const_USER_SKILL = 'api-gateway/v1.0/profile/skill';
var BASIC_INFO_V2 = 'api-gateway/v2.0/profile/info';
var const_DEFAULT_ALLOW_FILES_EXT = (/* unused pure expression or super */ null && ([
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
]));
var const_DEFAULT_ALLOW_EXT = '.doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf';
var const_DEFAULT_LIMIT_FILE_SIZE = 5120000; // 5MB
var const_DEFAULT_SUCCESS_CODE = 200;


//# sourceMappingURL=const.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Utils/time.js
'use client';

var days = (/* unused pure expression or super */ null && (['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']));
var months = (/* unused pure expression or super */ null && ([
    '',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
]));
var nth = function (d) {
    if (d > 3 && d < 21)
        return 'th';
    switch (d % 10) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
};
var convertDateTime = function (time, type) {
    if (type === void 0) { type = 0; }
    var date = new Date(time);
    var day = date.getDate();
    var dayName = days[date.getDay()];
    var month = date.getMonth() + 1;
    var monthName = months[month];
    var year = date.getFullYear();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    var addZero = function (date) { return String(date).padStart(2, '0'); };
    switch (type) {
        case 0: {
            // 30/10/2022 07:30
            var formatDate = addZero(day) + '/' + addZero(month) + '/' + year;
            var formatTime = addZero(hours) + ':' + addZero(minutes);
            return "".concat(formatDate, " ").concat(formatTime);
        }
        case 1: {
            // Friday, 15 Oct 2022
            return "".concat(dayName, ", ").concat(day, " ").concat(monthName, " ").concat(year);
        }
        case 2: {
            // Oct 5th, 2022
            return "".concat(monthName, " ").concat(day).concat(nth(day), ", ").concat(year);
        }
        case 3: {
            // 06:30
            return "".concat(String(hours).padStart(2, '0'), ":").concat(String(minutes).padStart(2, '0'));
        }
        case 4: {
            // 15 Wed, 2022
            return "".concat(day, " ").concat(monthName.slice(0, 3), ", ").concat(year);
        }
        case 5: {
            // Wed 15, 2022
            return "".concat(monthName.slice(0, 3), " ").concat(day, ", ").concat(year);
        }
        case 6: {
            // 2022-10-18 11:04:20
            return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
        }
        case 7: {
            // 30/10/2022
            var formatDate = addZero(day) + '/' + addZero(month) + '/' + year;
            return formatDate;
        }
        default:
            return '';
    }
};
var formatInvalidDate = function (dateTime, format) {
    switch (format) {
        case 'YYYY-MM-DD HH:MM:SS':
            return dateTime.slice(0, 10);
        default:
            return '';
    }
};
var convertDateToISO = function (dateString) {
    // Regular expression to match the exact format YYYY-MM-DD HH:mm:ss
    var regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
    if (regex.test(dateString)) {
        // Replace the space with 'T' to convert to ISO 8601 format
        return dateString.replace(' ', 'T');
    }
    else {
        return dateString;
    }
};
var dateToString = function (dateTime, format) {
    if (format === void 0) { format = 'DD/MM/YYYY'; }
    var date;
    if (!dateTime) {
        date = new Date();
    }
    else {
        if (typeof dateTime === 'string') {
            var a = dateTime.split(/[^0-9]/);
            date = new Date(Number(a[0]), Number(a[1]) - 1, Number(a[2]), Number(a[3]), Number(a[4]), Number(a[5]));
        }
        else {
            date = new Date(dateTime * 1000);
        }
    }
    var rawDay = date.getUTCDate();
    var rawMonth = date.getUTCMonth() + 1;
    var day = rawDay < 10 ? "0".concat(rawDay) : rawDay;
    var month = rawMonth < 10 ? "0".concat(rawMonth) : rawMonth;
    var rawHours = date.getUTCHours();
    var rawMinutes = date.getUTCMinutes();
    var hours = rawHours >= 10 ? rawHours : "0".concat(rawHours);
    var minutes = rawMinutes >= 10 ? rawMinutes : "0".concat(rawMinutes);
    switch (format) {
        case 'DD/MM/YYYY HH:MM':
            return day + '/' + month + '/' + date.getUTCFullYear() + ' ' + hours + ':' + minutes;
        case 'DD/MM/YYYY':
            return day + '/' + month + '/' + date.getUTCFullYear();
        default:
            return (day + '-' + month + '-' + date.getUTCFullYear() + ' ' + hours + ':' + minutes + ':' + date.getSeconds());
    }
};


//# sourceMappingURL=time.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/services/resumes/index.js
'use client';








function changeJobTitle(_a) {
    var baseUrl = _a.baseUrl, accessToken = _a.accessToken, langCode = _a.langCode, value = _a.value;
    return __awaiter(this, void 0, void 0, function () {
        var response, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(CHANGE_JOB_TITLE), {
                            method: 'PUT',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode
                            },
                            body: JSON.stringify({
                                jobTitle: value
                            })
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _b.sent()];
                case 3:
                    err_1 = _b.sent();
                    console.error(err_1);
                    return [2 /*return*/, {}];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function changePhoneNumber(_a) {
    var baseUrl = _a.baseUrl, accessToken = _a.accessToken, langCode = _a.langCode, value = _a.value;
    return __awaiter(this, void 0, void 0, function () {
        var response, err_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(CHANGE_PHONE_NUMBER), {
                            method: 'PUT',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode
                            },
                            body: JSON.stringify({
                                phone: value
                            })
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _b.sent()];
                case 3:
                    err_2 = _b.sent();
                    console.error(err_2);
                    return [2 /*return*/, {}];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var uploadFile = function (_a) {
    var accessToken = _a.accessToken, langCode = _a.langCode, baseUrl = _a.baseUrl, file = _a.file, resumeId = _a.resumeId, apiUploadVersion = _a.apiUploadVersion, action = _a.action;
    return __awaiter(void 0, void 0, void 0, function () {
        var errorSystem, formData, endPointUploadResumeFile, response, responeJson, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    errorSystem = new ModelError({
                        data: file,
                        error: {
                            details: {
                                ERROR_UPLOAD: langCode === ELanguage.EN ? "Can't not upload file" : 'Không thể tải tệp lên'
                            },
                            message: langCode === ELanguage.EN ? "Can't not upload file" : 'Không thể tải tệp lên',
                            status: 500
                        }
                    });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    formData = new FormData();
                    formData.append('resume_file', file);
                    if (resumeId && resumeId > 0) {
                        formData.append('resume_id', resumeId.toString());
                        // When resumeId is provided it always replaced
                        formData.append('is_replaced', 'true');
                    }
                    // Action=1 param is used for by-pass old parsing cv flow
                    if (action) {
                        formData.append('action', action.toString());
                    }
                    endPointUploadResumeFile = "api-gateway/".concat(apiUploadVersion, "/").concat(ENDPOINT_UPDATE_RESUME_FILE);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(endPointUploadResumeFile), {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                Accept: 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept-Language': langCode
                            },
                            body: formData
                        })];
                case 2:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    responeJson = _b.sent();
                    if (!responeJson.data) {
                        if (responeJson.Message || responeJson.Status === 400) {
                            return [2 /*return*/, new ModelError({
                                    data: file,
                                    error: {
                                        details: {
                                            ERROR_UPLOAD: responeJson.Message
                                        },
                                        message: responeJson.Message,
                                        status: responeJson.Status
                                    }
                                })];
                        }
                        return [2 /*return*/, errorSystem];
                    }
                    return [2 /*return*/, responeJson];
                case 4:
                    error_1 = _b.sent();
                    console.error('apiDoUpload ', error_1);
                    return [2 /*return*/, errorSystem];
                case 5: return [2 /*return*/];
            }
        });
    });
};
var validateFile = function (_a) {
    var accessToken = _a.accessToken, langCode = _a.langCode, baseUrl = _a.baseUrl, file = _a.file, userId = _a.userId, jobId = _a.jobId;
    return __awaiter(void 0, void 0, void 0, function () {
        var formData, response, data, error_2, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    formData = new FormData();
                    formData.append('file', file);
                    formData.append('jobId', jobId ? String(jobId) : '0');
                    formData.append('jobseekerId', userId ? String(userId) : '0');
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(ATTACHED_RESUME_VALIDATE), {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                Accept: 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept-Language': langCode
                            },
                            body: formData
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _b.sent();
                    return [2 /*return*/, data];
                case 3:
                    error_2 = _b.sent();
                    console.error('apiDoValidate ', error_2);
                    data = {
                        meta: {
                            statusCode: 413,
                            message: langCode === ELanguage.VI
                                ? 'Hỗ trợ định dạng .doc, .docx, pdf có kích thước dưới 5120KB'
                                : '.doc, .docx and .pdf files that are less than 5120KB in size'
                        }
                    };
                    return [2 /*return*/, data];
                case 4: return [2 /*return*/];
            }
        });
    });
};
function getProfileLevel(accessToken, langCode, baseUrl) {
    return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
        var response, data, err_3;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(PROFILE_LEVEL), {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
                case 3:
                    err_3 = _a.sent();
                    console.error(err_3);
                    return [2 /*return*/];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function getResumeSettingInfo(accessToken, baseUrl, langCode) {
    return __awaiter(this, void 0, void 0, function () {
        var response, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(RESUME_SETTING_INFO, "?date=").concat(Date.now()), {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode !== null && langCode !== void 0 ? langCode : ELanguage.VI
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    err_4 = _a.sent();
                    console.error(err_4);
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var getJobLevelList = function (langCode, baseMsUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var response, dataJs, relationships, err_5;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(JOBLEVEL), {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': langCode
                        }
                    })];
            case 1:
                response = _c.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                dataJs = _c.sent();
                relationships = (_a = dataJs === null || dataJs === void 0 ? void 0 : dataJs.data) === null || _a === void 0 ? void 0 : _a.relationships;
                if ((relationships === null || relationships === void 0 ? void 0 : relationships.data) && ((_b = relationships === null || relationships === void 0 ? void 0 : relationships.data) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    return [2 /*return*/, relationships.data];
                }
                return [2 /*return*/, null];
            case 3:
                err_5 = _c.sent();
                console.error(err_5);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
var updateProfileCookie = function (baseUrl, accessToken, body, langCode) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(PROFILE_COOKIE), {
                        method: 'POST',
                        headers: {
                            Authorization: "Bearer ".concat(accessToken),
                            'Content-Type': 'application/json',
                            'Accept-Language': langCode !== null && langCode !== void 0 ? langCode : ELanguage.VI
                        },
                        body: JSON.stringify(body)
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_3 = _a.sent();
                console.error(error_3);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
function makeSearchable(baseUrl, accessToken, body, langCode) {
    return __awaiter(this, void 0, void 0, function () {
        var response, data, err_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(SEARCHABLE), {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode !== null && langCode !== void 0 ? langCode : ELanguage.VI
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data];
                case 3:
                    err_6 = _a.sent();
                    console.error(err_6);
                    return [2 /*return*/];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var makeRefreshProfile = function (baseMsUrl, accessToken, body, langCode) {
    if (langCode === void 0) { langCode = ELanguage.VI; }
    return __awaiter(void 0, void 0, void 0, function () {
        var response, data, e_1, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(REFRESH_PROFILE), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(accessToken),
                                'Accept-Language': langCode
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data];
                case 3:
                    e_1 = _a.sent();
                    error = {
                        details: {
                            RESFRESH_PROFILE: 'ERROR_RESFRESH_PROFILE'
                        },
                        message: 'bad request',
                        status: 400
                    };
                    return [2 /*return*/, new ModelError({ data: e_1, error: error })];
                case 4: return [2 /*return*/];
            }
        });
    });
};
function getSkills(baseUrl, accessToken, searchKeywork, selectedSkills, limit, lang) {
    return __awaiter(this, void 0, void 0, function () {
        var queryParams, response, jsonData, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    queryParams = __assign(__assign({ query: searchKeywork }, (!selectedSkills ? undefined : { selectedSkill: selectedSkills.join('|') })), (!limit ? undefined : { limit: limit }));
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(SKILL_TAGS, "?").concat(objToQueryStr(queryParams)), {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': lang !== null && lang !== void 0 ? lang : ELanguage.VI
                            }
                        })];
                case 1:
                    response = _a.sent();
                    if (!response) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    jsonData = _a.sent();
                    return [2 /*return*/, jsonData.data];
                case 3: throw response;
                case 4:
                    error_4 = _a.sent();
                    console.log(error_4);
                    return [2 /*return*/];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function updateBasicInfo(baseUrl, accessToken, body, langCode) {
    return __awaiter(this, void 0, void 0, function () {
        var response, data, err_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/").concat(BASIC_INFO), {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode !== null && langCode !== void 0 ? langCode : ELanguage.VI
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data];
                case 3:
                    err_7 = _a.sent();
                    console.error(err_7);
                    return [2 /*return*/];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function updateSkills(baseMsUrl, accessToken, body, langCode, method) {
    if (method === void 0) { method = 'POST'; }
    return __awaiter(this, void 0, void 0, function () {
        var response, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(USER_SKILL), {
                            method: method,
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode !== null && langCode !== void 0 ? langCode : ELanguage.VI
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    error_5 = _a.sent();
                    console.error(error_5);
                    return [2 /*return*/, {
                            errorCode: '',
                            message: '',
                            showMessage: true
                        }];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function getUserProfile(accessToken, baseMsUrl, langCode) {
    var _a, _b;
    return (0,_tslib/* __awaiter */.mG)(this, void 0, void 0, function () {
        var response, responseData, userProfileInfo, error_6;
        return (0,_tslib/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(BASIC_INFO_V2), {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Accept-Language': langCode !== null && langCode !== void 0 ? langCode : Utils_constants/* ELanguage.VI */.Df.VI
                            }
                        })];
                case 1:
                    response = _c.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    responseData = _c.sent();
                    userProfileInfo = (_a = responseData.data) === null || _a === void 0 ? void 0 : _a.attributes;
                    if (userProfileInfo && userProfileInfo.birthday) {
                        userProfileInfo.birthday = formatInvalidDate(userProfileInfo.birthday, 'YYYY-MM-DD HH:MM:SS');
                    }
                    if (!userProfileInfo) {
                        return [2 /*return*/, new model_ModelError({
                                data: null,
                                error: {
                                    details: {
                                        ERROR: (_b = responseData === null || responseData === void 0 ? void 0 : responseData.data) !== null && _b !== void 0 ? _b : ''
                                    },
                                    message: response.statusText,
                                    status: response.status
                                }
                            })];
                    }
                    return [2 /*return*/, userProfileInfo];
                case 3:
                    error_6 = _c.sent();
                    throw new model_ModelError(error_6);
                case 4: return [2 /*return*/];
            }
        });
    });
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/UploadResumeModal/type.js
'use client';

var EMaritalStatus;
(function (EMaritalStatus) {
    EMaritalStatus[EMaritalStatus["NEW"] = 0] = "NEW";
    EMaritalStatus[EMaritalStatus["SINGLE"] = 1] = "SINGLE";
    EMaritalStatus[EMaritalStatus["MARRIED"] = 2] = "MARRIED";
})(EMaritalStatus || (EMaritalStatus = {}));
var EGender;
(function (EGender) {
    EGender[EGender["MALE"] = 1] = "MALE";
    EGender[EGender["FEMALE"] = 2] = "FEMALE";
})(EGender || (EGender = {}));
var ETab;
(function (ETab) {
    ETab[ETab["UPLOAD_CV"] = 1] = "UPLOAD_CV";
    ETab[ETab["CONTACT_INFORMATION"] = 2] = "CONTACT_INFORMATION";
    ETab[ETab["WORKING_PREFERENCE"] = 3] = "WORKING_PREFERENCE";
})(ETab || (ETab = {}));


//# sourceMappingURL=type.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/PostHog/hooks/useIdentify/index.js
'use client';









var DEFAULT_INTERVAL_CHECK_IDENTIFY = 50;
var sendHogIdentify = function (postHog, user, baseMsUrl) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
    var userProfilePromise, userLevelPromise, promiseResponse, response_1, userProfile, userLevel, maritalStatus, ex_1;
    var _a, _b;
    return (0,_tslib/* __generator */.Jh)(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!user || !(user === null || user === void 0 ? void 0 : user.userId) || !(user === null || user === void 0 ? void 0 : user.accessToken)) {
                    return [2 /*return*/];
                }
                if (!postHog) {
                    return [2 /*return*/];
                }
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                userProfilePromise = getUserProfile((0,helpers/* detectEncryptAccessToken */.If)(user === null || user === void 0 ? void 0 : user.accessToken), baseMsUrl);
                userLevelPromise = getProfileLevel((0,helpers/* detectEncryptAccessToken */.If)(user === null || user === void 0 ? void 0 : user.accessToken), Utils_constants/* ELanguage.VI */.Df.VI, baseMsUrl);
                return [4 /*yield*/, Promise.allSettled([userProfilePromise, userLevelPromise])];
            case 2:
                promiseResponse = _c.sent();
                response_1 = [null, null];
                promiseResponse.forEach(function (result) {
                    if (result.status === 'rejected') {
                        response_1.push(null);
                        return;
                    }
                    // fulfilled and no Model
                    if (result.status === 'fulfilled' && ((result === null || result === void 0 ? void 0 : result.value) instanceof model_ModelError || !(result === null || result === void 0 ? void 0 : result.value))) {
                        response_1.push(null);
                        return;
                    }
                    response_1.push(result.value);
                });
                userProfile = response_1[0];
                userLevel = response_1[1];
                maritalStatus = 'Empty';
                if ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.maritalStatusId) === EMaritalStatus.SINGLE) {
                    maritalStatus = 'Single';
                }
                else if ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.maritalStatusId) === EMaritalStatus.MARRIED) {
                    maritalStatus = 'Married';
                }
                postHog === null || postHog === void 0 ? void 0 : postHog.identify(user === null || user === void 0 ? void 0 : user.userId.toString(), {
                    is_jobseeker: true,
                    user_id: user === null || user === void 0 ? void 0 : user.userId,
                    resume_id: user === null || user === void 0 ? void 0 : user.resumeId,
                    job_title: user === null || user === void 0 ? void 0 : user.jobTitle,
                    job_level: user === null || user === void 0 ? void 0 : user.jobLevelId,
                    years_experience: user === null || user === void 0 ? void 0 : user.yearExperience,
                    location_city: user === null || user === void 0 ? void 0 : user.locationList,
                    current_jobfunction_id: userProfile === null || userProfile === void 0 ? void 0 : userProfile.currentJobFunction,
                    current_industry_id: userProfile === null || userProfile === void 0 ? void 0 : userProfile.currentIndustries,
                    highest_degree_id: (_a = userProfile === null || userProfile === void 0 ? void 0 : userProfile.highestDegreeId) !== null && _a !== void 0 ? _a : '',
                    gender: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.genderId) === EGender.MALE ? 'Male' : 'Female',
                    marrigal_status: maritalStatus,
                    expected_job_level_id: userProfile === null || userProfile === void 0 ? void 0 : userProfile.jobLevelId,
                    is_searchable: !!(userProfile === null || userProfile === void 0 ? void 0 : userProfile.isSearchable),
                    wowcv_template_id: userProfile === null || userProfile === void 0 ? void 0 : userProfile.wowcvTemplateId,
                    profile_strength: (_b = userLevel === null || userLevel === void 0 ? void 0 : userLevel.attributes) === null || _b === void 0 ? void 0 : _b.profileStrength,
                    search_setting_id: user === null || user === void 0 ? void 0 : user.searchSettingSortType
                });
                return [3 /*break*/, 4];
            case 3:
                ex_1 = _c.sent();
                console.error('PostHog Error: ', ex_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * This useIdentify function is used to identify a user in PostHog.
 * @param user TAuthUser
 */
var useIdentify = function (user, baseMsUrl, options) {
    var _a;
    // Config
    var intervalTime = (_a = options === null || options === void 0 ? void 0 : options.intervalTime) !== null && _a !== void 0 ? _a : DEFAULT_INTERVAL_CHECK_IDENTIFY;
    var _b = useState(false), isIdentified = _b[0], setIsIdentified = _b[1];
    var _c = useState(true), isEnable = _c[0], setIsEnable = _c[1];
    var _d = useState(false), isSentIdentify = _d[0], setIsSentIdentify = _d[1];
    var intervalIdRef = useRef(null);
    var clearAllInterval = function () {
        intervalIdRef.current && clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
    };
    var checkingIdentified = function () {
        var _a;
        if (!window.posthog || !window.posthog._isIdentified || typeof window.posthog._isIdentified !== 'function') {
            return;
        }
        var isIdentifiedValue = (_a = window === null || window === void 0 ? void 0 : window.posthog) === null || _a === void 0 ? void 0 : _a._isIdentified();
        // Response value is not a boolean
        if (typeof isIdentifiedValue !== 'boolean') {
            return;
        }
        // Already identified
        if (isIdentifiedValue) {
            setIsIdentified(true);
            // Disable interval
            setIsEnable(false);
            clearAllInterval();
            return;
        }
        // Send identify
        if (!isSentIdentify) {
            sendHogIdentify(window === null || window === void 0 ? void 0 : window.posthog, user, baseMsUrl);
            setIsSentIdentify(true);
        }
    };
    useEffect(function () {
        if (!isEnable) {
            clearAllInterval();
            return;
        }
        clearAllInterval();
        intervalIdRef.current = setInterval(checkingIdentified, intervalTime);
        return function () { return clearAllInterval(); };
    }, [isEnable, isSentIdentify, user]);
    return {
        isIdentified: isIdentified
    };
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/PostHog/utils.js
var utils = __webpack_require__(81248);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/LoginModal/index.js
'use client';
























var LoginModal = function (props) {
    var _a;
    var langCode = props.langCode, _b = props.isReloadOnLoggedIn, isReloadOnLoggedIn = _b === void 0 ? false : _b, _c = props.pageName, pageName = _c === void 0 ? constants/* EPages.OTHER */.QS.OTHER : _c, _d = props.utmTracking, utmTracking = _d === void 0 ? '' : _d, jobLevelId = props.jobLevelId, useNewLoginModalProp = props.useNewLoginModal, featureFlag = props.featureFlag;
    var _e = (0,react.useState)(langCode === Utils_constants/* ELanguage.VI */.Df.VI ? 'vi' : 'en'), modalLangCode = _e[0], setLangCode = _e[1];
    var _f = (0,react.useState)(false), isMounted = _f[0], setMounted = _f[1];
    // Forms
    var _g = (0,react.useState)(''), username = _g[0], setUsername = _g[1];
    var _h = (0,react.useState)(''), password = _h[0], setPassword = _h[1];
    var _j = (0,react.useState)(''), csrfToken = _j[0], setCsrfToken = _j[1];
    var _k = (0,react.useState)(''), jwtToken = _k[0], setJwtToken = _k[1];
    // Errors
    var _l = (0,react.useState)(false), isUsernameError = _l[0], setUsernameError = _l[1];
    var _m = (0,react.useState)(false), isPasswordError = _m[0], setPasswordError = _m[1];
    var _o = (0,react.useState)('NONE'), apiError = _o[0], setAPIError = _o[1];
    // Register form state
    var _p = (0,react.useState)(false), isRegisterMode = _p[0], setIsRegisterMode = _p[1];
    var _q = (0,react.useState)(false), hasJustRegistered = _q[0], setHasJustRegistered = _q[1];
    // End Forms
    var _r = (0,react.useState)(false), isLoginDisabled = _r[0], setIsLoginDisabled = _r[1];
    var _s = (0,react.useState)(false), isLoggingIn = _s[0], setIsLoggingIn = _s[1];
    // Other
    var _t = (0,react.useState)(isReloadOnLoggedIn), isNeedReload = _t[0], setIsNeedReload = _t[1];
    var _u = (0,react.useState)(false), isApply = _u[0], setIsApply = _u[1];
    var _v = (0,react.useState)(''), socialUtm = _v[0], setSocialUtm = _v[1];
    var _w = (0,react.useState)(false), isRegisterOnNewTab = _w[0], setIsRegisterOnNewTab = _w[1];
    // Platform selection state
    var _x = (0,react.useState)('none'), selectedPlatform = _x[0], setSelectedPlatform = _x[1];
    var _y = (0,react.useState)(false), isClosing = _y[0], setIsClosing = _y[1];
    // Job level ID from event (overrides prop)
    var _z = (0,react.useState)(undefined), eventJobLevelId = _z[0], setEventJobLevelId = _z[1];
    // Feature flag from event (overrides prop)
    var _0 = (0,react.useState)(undefined), eventFeatureFlag = _0[0], setEventFeatureFlag = _0[1];
    // AB Testing: Feature flag for new login modal version
    var _1 = (0,react.useState)(false), useNewLoginModal = _1[0], setUseNewLoginModal = _1[1];
    // Callback on success
    var onLoggedInRef = (0,react.useRef)(null);
    // Callback on close popup login
    var onCancelPopupRef = (0,react.useRef)(null);
    // Track if signup_start event has been sent for current register mode switch
    var hasSentSignupStartEventRef = (0,react.useRef)(false);
    var tracking = (0,useHog/* default */.Z)().tracking;
    var t = function (text) {
        var _a;
        if (modalLangCode === Utils_constants/* ELanguage.EN */.Df.EN) {
            return text;
        }
        else {
            return (_a = translations[text]) !== null && _a !== void 0 ? _a : text;
        }
    };
    var getPageName = function () {
        if (typeof window === 'undefined') {
            return 'others';
        }
        var url = window.location.href;
        var pathname = window.location.pathname;
        if (pathname === '/' || pathname === '') {
            return 'home_page';
        }
        if (pathname === '/tim-viec-lam/tim-tat-ca-viec-lam') {
            return 'job_list_page';
        }
        if (pathname.includes('-jv') || url.includes('-jv')) {
            return 'job_detail_page';
        }
        if (pathname === '/tai-khoan-ca-nhan') {
            return 'menu';
        }
        // Other pages
        return 'others';
    };
    var showLoginModal = function (e, isNeedReload) {
        var _a, _b, _c, _d, _e, _f;
        if (isNeedReload === void 0) { isNeedReload = false; }
        // window function
        if (typeof e === 'string') {
            setLangCode(e);
            setIsNeedReload(isNeedReload);
            setEventJobLevelId(undefined); // Reset when called via window function
        }
        // window event
        if (typeof e === 'object') {
            var eventDetail = e.detail;
            setLangCode((_a = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.langCode) !== null && _a !== void 0 ? _a : 'vi');
            setIsNeedReload((_b = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.isNeedReload) !== null && _b !== void 0 ? _b : false);
            setIsApply((_c = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.isApply) !== null && _c !== void 0 ? _c : false);
            setSocialUtm((_d = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.utm) !== null && _d !== void 0 ? _d : '');
            setEventJobLevelId(eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.jobLevelId); // Get jobLevelId from event
            setEventFeatureFlag(eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.featureFlag); // Get featureFlag from event
            setIsRegisterOnNewTab((_e = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.isNewTabOnRegister) !== null && _e !== void 0 ? _e : false);
            onLoggedInRef.current = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.onLoggedIn;
            onCancelPopupRef.current = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.onCancelPopup;
        }
        if (typeof e === 'object' && ((_f = e.detail) === null || _f === void 0 ? void 0 : _f.jobLevelId) === undefined) {
            setSelectedPlatform('none');
        }
        else if (typeof e === 'string') {
            setSelectedPlatform('none');
        }
        setIsClosing(false);
        setMounted(true);
    };
    var handleLoginSuccess = function (response, options) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var loginSuccessEvent, letCheckReload, jsTokenDecoded, wsTokenDecoded, userInfo;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loginSuccessEvent = {
                        eventName: 'js_registration:login_success',
                        properties: (0,_tslib/* __assign */.pi)({ isEmail: true, isFacebook: false, isGoogle: false, isAppleid: false, page_name: getPageName() }, options === null || options === void 0 ? void 0 : options.eventProperties)
                    };
                    console.log('[Tracking] js_registration:login_success', loginSuccessEvent);
                    tracking(loginSuccessEvent);
                    (0,cookie/* setCookie */.d)(constants/* WS_TOKEN */.dD, encodeURIComponent(response.wsToken), 730);
                    (0,cookie/* setCookie */.d)(constants/* JS_TOKEN */.h4, encodeURIComponent(response.jsToken), 730);
                    (0,cookie/* setCookie */.d)(constants/* JS_ALL_TOKEN */.xX, encodeURIComponent(response.jsAllToken), 730);
                    (0,cookie/* setCookie */.d)(constants/* USER_COOKIE */.fT, encodeURIComponent(response.userCookie), 730);
                    (0,cookie/* setCookie */.d)(constants/* WS_COOKIE */.kd, encodeURIComponent(response.wsToken), 730);
                    letCheckReload = isNeedReload;
                    if (response.newRegistered) {
                        // Temporary disabled reload request when showing up onboarding
                        letCheckReload = false;
                    }
                    if (!letCheckReload) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0,utils/* delay */.gw)(200)];
                case 1:
                    _a.sent();
                    window.location.reload();
                    return [2 /*return*/];
                case 2:
                    // Change password page
                    if (window.location.href.indexOf('/quan-ly-tai-khoan/thay-mat-khau-thanh-cong') > 0 ||
                        window.location.href.indexOf('/account-settings/change-password-success') > 0) {
                        window.location.href =
                            langCode === Utils_constants/* ELanguage.VI */.Df.VI
                                ? "https://".concat(getBaseUrl(), "/quan-ly-nghe-nghiep/tong-quan")
                                : "https://".concat(getBaseUrl(), "/my-career-center/dashboard");
                    }
                    // Change email page
                    if (window.location.href.indexOf('/quan-ly-tai-khoan/thay-email-thanh-cong') > 0 ||
                        window.location.href.indexOf('/account-settings/change-email-success') > 0) {
                        window.location.href =
                            langCode === Utils_constants/* ELanguage.VI */.Df.VI
                                ? "https://".concat(getBaseUrl(), "/quan-ly-nghe-nghiep/tong-quan")
                                : "https://".concat(getBaseUrl(), "/my-career-center/dashboard");
                    }
                    _a.label = 3;
                case 3:
                    jsTokenDecoded = decodeURIComponent(response.jsToken || '');
                    wsTokenDecoded = decodeURIComponent(response.wsToken || '');
                    return [4 /*yield*/, apiGetUserInfoFromToken(jsTokenDecoded, wsTokenDecoded)
                        // Delay 100ms for cookie all done
                    ];
                case 4:
                    userInfo = _a.sent();
                    // Delay 100ms for cookie all done
                    setTimeout(function () {
                        setIsLoginDisabled(false);
                        setIsLoggingIn(false);
                        if (!userInfo) {
                            setAPIError('WRONG_USER_PASS');
                            return;
                        }
                        onLoggedInRef.current && onLoggedInRef.current(userInfo);
                        // get user and dispatch to AppShell user state
                        var updateUserEvent = new CustomEvent(constants/* UPDATE_USER */.AX, {
                            detail: {
                                user: userInfo,
                                isNewRegistered: response.newRegistered,
                                isApply: isApply
                            }
                        });
                        window.dispatchEvent(updateUserEvent);
                        if (typeof window !== 'undefined') {
                            try {
                                sendHogIdentify(window.posthog, userInfo, getBaseMsUrl());
                            }
                            catch (ex) {
                                console.error('postHog', ex);
                            }
                        }
                        setAPIError('NONE');
                        setIsClosing(true);
                        setMounted(false);
                        // Reset after animation completes (250ms)
                        setTimeout(function () {
                            setSelectedPlatform('none');
                            setIsClosing(false);
                        }, 300);
                    }, 100);
                    return [2 /*return*/];
            }
        });
    }); };
    var doLogin = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var hasError, currentCsrfToken, currentJwtToken, tokenResponse, response;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoginDisabled(true);
                    setIsLoggingIn(true);
                    hasError = false;
                    // username
                    if (username.length === 0) {
                        setUsernameError(true);
                        hasError = true;
                    }
                    // email not valid
                    if (!(0,helpers/* checkIfEmailInString */.n3)(username)) {
                        setUsernameError(true);
                        hasError = true;
                    }
                    // password
                    if (password.length === 0) {
                        setPasswordError(true);
                        hasError = true;
                    }
                    if (hasError) {
                        setIsLoggingIn(false);
                        return [2 /*return*/];
                    }
                    currentCsrfToken = csrfToken;
                    currentJwtToken = jwtToken;
                    if (!(!currentCsrfToken || !currentJwtToken)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getCSRFToken()];
                case 1:
                    tokenResponse = _a.sent();
                    if (!(tokenResponse === null || tokenResponse === void 0 ? void 0 : tokenResponse.csrfToken) || !(tokenResponse === null || tokenResponse === void 0 ? void 0 : tokenResponse.jwtToken)) {
                        setAPIError('WRONG_USER_PASS');
                        setIsLoginDisabled(false);
                        setIsLoggingIn(false);
                        return [2 /*return*/];
                    }
                    currentCsrfToken = tokenResponse.csrfToken;
                    currentJwtToken = tokenResponse.jwtToken;
                    _a.label = 2;
                case 2: return [4 /*yield*/, apiDoLogin({
                        username: username,
                        password: password,
                        csrfToken: currentCsrfToken,
                        jwtToken: currentJwtToken,
                        langCode: modalLangCode
                    })];
                case 3:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.code) !== DEFAULT_SUCCESS_CODE) {
                        // show login error
                        // waiting backend response correct error message for user not active
                        if ((response === null || response === void 0 ? void 0 : response.message) === constants/* USER_NOT_ACTIVE_EN */.S3 || (response === null || response === void 0 ? void 0 : response.message) === constants/* USER_NOT_ACTIVE_VI */.$v) {
                            setAPIError('USER_NOT_ACTIVE');
                        }
                        else if ((response === null || response === void 0 ? void 0 : response.message) === constants/* USER_EMPLOYER_EN */.Ic || (response === null || response === void 0 ? void 0 : response.message) === constants/* USER_EMPLOYER_VI */.fQ) {
                            setAPIError('USER_EMPLOYER');
                        }
                        else if ((response === null || response === void 0 ? void 0 : response.message) === constants/* USER_BANNED_EN */.$p || (response === null || response === void 0 ? void 0 : response.message) === constants/* USER_BANNED_VI */.bU) {
                            setAPIError('USER_BANNED');
                        }
                        else {
                            setAPIError('WRONG_USER_PASS');
                        }
                        setIsLoginDisabled(false);
                        setIsLoggingIn(false);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, handleLoginSuccess(response)];
                case 4:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var inputKeyUp = function (e, type) {
        // turn off error message when keyUp
        if (type === 'email') {
            setUsernameError(false);
            setAPIError('NONE');
            setIsLoginDisabled(false);
        }
        if (type === 'password') {
            setIsLoginDisabled(false);
            setPasswordError(false);
        }
        if (e.key === 'Enter') {
            setUsernameError(false);
            setAPIError('NONE');
            setPasswordError(false);
            doLogin();
        }
    };
    var getCSRFToken = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var csrfTokenResponse, nextCsrfToken, nextJwtToken;
        return (0,_tslib/* __generator */.Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Don't get csrf token again if it already exists
                    if (csrfToken && jwtToken) {
                        return [2 /*return*/, {
                                csrfToken: csrfToken,
                                jwtToken: jwtToken
                            }];
                    }
                    return [4 /*yield*/, apiGetCSRFToken()];
                case 1:
                    csrfTokenResponse = _a.sent();
                    setIsLoginDisabled(false);
                    if (csrfTokenResponse === null) {
                        return [2 /*return*/, null];
                    }
                    nextCsrfToken = (csrfTokenResponse === null || csrfTokenResponse === void 0 ? void 0 : csrfTokenResponse.csrfToken) || '';
                    nextJwtToken = (csrfTokenResponse === null || csrfTokenResponse === void 0 ? void 0 : csrfTokenResponse.jwtToken) || '';
                    setCsrfToken(nextCsrfToken);
                    setJwtToken(nextJwtToken);
                    (0,cookie/* setCookie */.d)(constants/* VNW_CSRF_JWT_TOKEN */.uK, encodeURIComponent(nextJwtToken), 730);
                    return [2 /*return*/, {
                            csrfToken: nextCsrfToken,
                            jwtToken: nextJwtToken
                        }];
            }
        });
    }); };
    var renderErrorMessage = function () {
        if (apiError === 'NONE') {
            return null;
        }
        if (apiError === 'USER_NOT_ACTIVE') {
            return ((0,jsx_runtime.jsx)(ErrorMessage, { children: t('You have not verified your email. Please check your email inbox for instruction.') }));
        }
        else if (apiError === 'USER_EMPLOYER') {
            return ((0,jsx_runtime.jsx)(ErrorMessage, { children: t('This email address is registered as Employer, please Sign in from Employer Site.') }));
        }
        else if (apiError === 'USER_BANNED') {
            return ((0,jsx_runtime.jsx)(ErrorMessage, { children: t('The account is banned from VietnamWorks. For more information, please contact us via (84 28) 5404 1373.') }));
        }
        return (0,jsx_runtime.jsx)(ErrorMessage, { children: t('Wrong email or password. Please check again.') });
    };
    /**
     * Verify Auth Token and login in WebView (Mobile)
     */
    var getAuthTokenFromUrl = function () { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var rawSearchParams, searchParamsPair, searchParams, filteredParams, authToken, response, jsToken, wsToken, userInfo;
        var _a, _b;
        return (0,_tslib/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (typeof window === 'undefined') {
                        return [2 /*return*/];
                    }
                    rawSearchParams = window.location.search.replace('?', '');
                    searchParamsPair = rawSearchParams.split('&');
                    searchParams = [];
                    searchParamsPair.map(function (item) {
                        var _a, _b, _c;
                        var query = item.split('=');
                        // Only check if query have a pair key value
                        if (query.length < 2) {
                            return;
                        }
                        searchParams.push({
                            key: (_b = (_a = query[0]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '',
                            value: (_c = query[1]) !== null && _c !== void 0 ? _c : ''
                        });
                    });
                    filteredParams = searchParams.filter(function (item) { return item.key === constants/* KEY_AUTH_TOKEN */.vG; });
                    if (filteredParams.length === 0) {
                        return [2 /*return*/];
                    }
                    authToken = (_b = (_a = filteredParams[0]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
                    if (authToken === '') {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, apiVerifyAuthToken(authToken)
                        // handle response null error first
                    ];
                case 1:
                    response = _c.sent();
                    // handle response null error first
                    if (response === null) {
                        return [2 /*return*/];
                    }
                    (0,cookie/* setCookie */.d)(constants/* WS_TOKEN */.dD, encodeURIComponent(response.wsToken), 730);
                    (0,cookie/* setCookie */.d)(constants/* JS_TOKEN */.h4, encodeURIComponent(response.jsToken), 730);
                    (0,cookie/* setCookie */.d)(constants/* JS_ALL_TOKEN */.xX, encodeURIComponent(response.jsAllToken), 730);
                    (0,cookie/* setCookie */.d)(constants/* USER_COOKIE */.fT, encodeURIComponent(response.userCookie), 730);
                    (0,cookie/* setCookie */.d)(constants/* WS_COOKIE */.kd, encodeURIComponent(response.wsToken), 730);
                    jsToken = decodeURIComponent(response.jsToken || '');
                    wsToken = decodeURIComponent(response.wsToken || '');
                    return [4 /*yield*/, apiGetUserInfoFromToken(jsToken, wsToken)
                        // Delay 100ms for cookie all done
                    ];
                case 2:
                    userInfo = _c.sent();
                    // Delay 100ms for cookie all done
                    setTimeout(function () {
                        onLoggedInRef.current && onLoggedInRef.current(userInfo);
                        // get user and dispatch to AppShell user state
                        var updateUserEvent = new CustomEvent(constants/* UPDATE_USER */.AX, {
                            detail: {
                                user: userInfo
                            }
                        });
                        window.dispatchEvent(updateUserEvent);
                    }, 100);
                    return [2 /*return*/];
            }
        });
    }); };
    var buildSocialLink = function (socialName) {
        var socialLoginLink = getSocialLoginUrl(socialName, langCode, isApply, pageName);
        if (utmTracking !== '') {
            socialLoginLink += encodeURIComponent("&=".concat(utmTracking));
        }
        if (socialUtm !== '') {
            socialLoginLink += encodeURIComponent("&=".concat(socialUtm));
        }
        return socialLoginLink;
    };
    var handleRegisterClick = function () {
        // Send PostHog event before redirect
        var signupStartEvent = {
            eventName: 'js_registration:signup_start',
            eventDetail: {
                utm: utmTracking
            }
        };
        tracking(signupStartEvent);
        // Redirect to register URL
        var registerUrl = getRegisterUrl(langCode, utmTracking);
        window.location.assign(registerUrl);
    };
    var handleBackToPlatformSelection = function () {
        // Reset everything to initial state
        setIsRegisterMode(false);
        setSelectedPlatform('none');
        setHasJustRegistered(false);
        // Reset login form
        setUsername('');
        setPassword('');
        setUsernameError(false);
        setPasswordError(false);
        setAPIError('NONE');
    };
    var handlePlatformSelection = function (platform) {
        var choosePlatformEvent = {
            eventName: 'js_registration:signup_choose_platform',
            properties: {
                platform: platform
            }
        };
        console.log('[Tracking] js_registration:signup_choose_platform', choosePlatformEvent);
        tracking(choosePlatformEvent);
        // Redirect to Upzi app download page on mobile
        if (isMobile() && platform === 'upzi') {
            window.location.href = 'https://www.upzi.vn/tai-ung-dung?utm_source=vietnamworks_mweb&utm_campaign=signup';
            return;
        }
        setSelectedPlatform(platform);
    };
    (0,react.useEffect)(function () {
        window.addEventListener(constants/* LOGIN_POPUP */.eS, showLoginModal);
        window.showLoginModal = showLoginModal;
        // For mobile WebView
        getAuthTokenFromUrl();
        return function () {
            window.removeEventListener(constants/* LOGIN_POPUP */.eS, showLoginModal);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function () {
        if (isMounted) {
            var currentJobLevelId = eventJobLevelId !== undefined ? eventJobLevelId : jobLevelId;
            if (currentJobLevelId !== undefined) {
                // Job Level 1 or 8 (Intern & Fresher) -> show platform selection
                if (currentJobLevelId === 1 || currentJobLevelId === 8) {
                    setSelectedPlatform('none');
                    setIsRegisterMode(false);
                }
                else if (currentJobLevelId === 3 || currentJobLevelId === 5 || currentJobLevelId === 7) {
                    setSelectedPlatform('vietnamworks');
                    setIsRegisterMode(false);
                }
                // Other job levels -> default to platform selection
                else {
                    setSelectedPlatform('none');
                    setIsRegisterMode(false);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMounted, eventJobLevelId, jobLevelId]);
    // Track when user is forced to VietnamWorks platform (auto-selected based on jobLevelId)
    (0,react.useEffect)(function () {
        if (isMounted && selectedPlatform === 'vietnamworks' && !isRegisterMode) {
            var currentJobLevelId = eventJobLevelId !== undefined ? eventJobLevelId : jobLevelId;
            // Only send event if platform was auto-selected based on jobLevelId (3, 5, or 7)
            if (currentJobLevelId === 3 || currentJobLevelId === 5 || currentJobLevelId === 7) {
                var choosePlatformEvent = {
                    eventName: 'js_registration:signup_choose_platform',
                    properties: {
                        platform: 'vietnamworks'
                    }
                };
                console.log('[Tracking] js_registration:signup_choose_platform (auto-selected)', choosePlatformEvent);
                tracking(choosePlatformEvent);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMounted, selectedPlatform, isRegisterMode]);
    (0,react.useEffect)(function () {
        if (!isMounted) {
            setUsernameError(false);
            setPasswordError(false);
            setAPIError('NONE');
            setIsLoginDisabled(false);
            setSelectedPlatform('none');
            setIsRegisterMode(false);
            setHasJustRegistered(false);
            setEventJobLevelId(undefined); // Reset jobLevelId from event
            // Reset signup_start event tracking ref
            hasSentSignupStartEventRef.current = false;
            return;
        }
        if (selectedPlatform === 'vietnamworks' && !isRegisterMode) {
            getCSRFToken();
            var loginStartEvent = {
                eventName: 'js_registration:login_start',
                properties: {
                    page_name: getPageName()
                }
            };
            console.log('[Tracking] js_registration:login_start', loginStartEvent);
            tracking(loginStartEvent);
        }
    }, [isMounted, selectedPlatform, isRegisterMode]);
    (0,react.useEffect)(function () {
        if (isMounted && selectedPlatform === 'none') {
            var viewPopupEvent = {
                eventName: 'js_registration:view_popup_choose_platform',
                properties: {
                    page_name: getPageName()
                }
            };
            console.log('[Tracking] js_registration:view_popup_choose_platform', viewPopupEvent);
            tracking(viewPopupEvent);
        }
    }, [isMounted, selectedPlatform]);
    (0,react.useEffect)(function () {
        if (isRegisterMode) {
            if (!hasSentSignupStartEventRef.current) {
                var signupStartEvent = {
                    eventName: 'js_registration:signup_start',
                    properties: {
                        page_name: getPageName()
                    }
                };
                console.log('[Tracking] js_registration:signup_start', signupStartEvent);
                tracking(signupStartEvent);
                hasSentSignupStartEventRef.current = true;
            }
        }
        else {
            hasSentSignupStartEventRef.current = false;
        }
    }, [isRegisterMode]);
    (0,react.useEffect)(function () {
        setLangCode(langCode === Utils_constants/* ELanguage.VI */.Df.VI ? 'vi' : 'en');
    }, [langCode]);
    (0,react.useEffect)(function () {
        setUseNewLoginModal(useNewLoginModalProp !== null && useNewLoginModalProp !== void 0 ? useNewLoginModalProp : false);
    }, [useNewLoginModalProp]);
    // Use featureFlag from event if available, otherwise use from props, otherwise use from window object
    var currentFeatureFlag = (_a = eventFeatureFlag !== null && eventFeatureFlag !== void 0 ? eventFeatureFlag : featureFlag) !== null && _a !== void 0 ? _a : (typeof window !== 'undefined' ? window.__LOGIN_MODAL_FEATURE_FLAG__ : undefined);
    console.log('featureFlagText-react-comp', currentFeatureFlag);
    return ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [useNewLoginModal && ((0,jsx_runtime.jsx)(Popup/* default */.Z, { isShow: isMounted, lang: modalLangCode === 'vi' ? Utils_constants/* ELanguage.VI */.Df.VI : Utils_constants/* ELanguage.EN */.Df.EN, text: {
                    primaryBtn: selectedPlatform === 'vietnamworks' ? ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [isLoggingIn ? ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: (0,jsx_runtime.jsx)(LoadingIcon, { bgColor: '#fff' }) })) : null, ' ', isRegisterMode ? t('Register') : t('Login')] })) : undefined
                }, option: {
                    isCloseOnClickBackdrop: true,
                    isShowPrimaryButton: selectedPlatform === 'vietnamworks' && !isRegisterMode,
                    isShowSecondaryButton: false,
                    disabledPrimary: isLoginDisabled
                }, custom: {
                    header: ((0,jsx_runtime.jsxs)(CloseIconHeader, { children: [selectedPlatform !== 'none' && (function () {
                                var currentJobLevelId = eventJobLevelId !== undefined ? eventJobLevelId : jobLevelId;
                                var shouldHideBackButton = currentJobLevelId === 3 || currentJobLevelId === 5 || currentJobLevelId === 7;
                                return !shouldHideBackButton;
                            })() ? ((0,jsx_runtime.jsxs)(Button/* default */.Z, { type: "default", size: "md", onClick: handleBackToPlatformSelection, children: [(0,jsx_runtime.jsx)("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { d: "M4.82868 5.83427C4.65548 5.83943 4.4911 5.91182 4.37035 6.0361L1.09561 9.31084C1.01419 9.37288 0.948158 9.45284 0.902619 9.54452C0.85708 9.6362 0.833262 9.73713 0.83301 9.83949C0.832758 9.94185 0.85608 10.0429 0.901167 10.1348C0.946254 10.2267 1.0119 10.307 1.09301 10.3694C1.09431 10.3703 1.09561 10.3712 1.09691 10.372L4.37035 13.6455C4.43178 13.7095 4.50536 13.7605 4.58678 13.7957C4.6682 13.8309 4.75582 13.8495 4.84451 13.8504C4.93321 13.8513 5.02119 13.8345 5.10331 13.801C5.18543 13.7675 5.26003 13.7179 5.32275 13.6552C5.38547 13.5924 5.43504 13.5178 5.46857 13.4357C5.50209 13.3536 5.5189 13.2656 5.518 13.1769C5.51709 13.0882 5.4985 13.0006 5.46331 12.9192C5.42812 12.8378 5.37704 12.7642 5.31306 12.7028L3.11775 10.5075H18.8417C18.93 10.5087 19.0178 10.4924 19.0997 10.4594C19.1817 10.4265 19.2563 10.3776 19.3192 10.3156C19.3822 10.2535 19.4321 10.1796 19.4662 10.0981C19.5003 10.0166 19.5179 9.92913 19.5179 9.84079C19.5179 9.75243 19.5003 9.66497 19.4662 9.58346C19.4321 9.50196 19.3822 9.42804 19.3192 9.36601C19.2563 9.30398 19.1817 9.25507 19.0997 9.22213C19.0178 9.18919 18.93 9.17287 18.8417 9.17412H3.11775L5.31306 6.97881C5.40939 6.88516 5.47519 6.7646 5.50183 6.63292C5.52847 6.50124 5.51471 6.36459 5.46235 6.24086C5.40999 6.11714 5.32147 6.01212 5.2084 5.93957C5.09533 5.86701 4.96297 5.83031 4.82868 5.83427Z", fill: "#005AFF" }) }), t('Back')] })) : ((0,jsx_runtime.jsx)("div", {})), selectedPlatform === 'none' && isMobile() && ((0,jsx_runtime.jsx)(ModalFormTitleSelect, { style: { margin: 0, textAlign: 'center', flex: 1 }, children: (0,jsx_runtime.jsx)("h3", { style: { fontSize: '18px', fontWeight: 600, margin: 0 }, children: t('Select to continue') }) })), (0,jsx_runtime.jsx)(Button/* default */.Z, { isRounded: true, isIcon: true, type: 'transparent', onClick: function () {
                                    setIsClosing(true);
                                    setMounted(false);
                                    onCancelPopupRef.current && onCancelPopupRef.current();
                                    // Reset after animation completes (250ms)
                                    setTimeout(function () {
                                        setSelectedPlatform('none');
                                        setIsClosing(false);
                                    }, 300);
                                }, children: (0,jsx_runtime.jsx)(CloseIcon/* default */.Z, { fill: '#888' }) })] })),
                    footer: selectedPlatform === 'none' ? null : undefined,
                    leftFooterAlert: selectedPlatform === 'upzi' ? ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: (0,jsx_runtime.jsxs)(UpziLearnMore, { children: [t('Learn more'), " ", (0,jsx_runtime.jsx)("a", { href: "https://www.upzi.vn/", target: '_blank', children: t('What is Upzi?') })] }) })) : selectedPlatform === 'vietnamworks' && !isRegisterMode && !hasJustRegistered ? ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [t("Don't have an account yet?"), ' ', (0,jsx_runtime.jsx)(RegisterLinkButton, { onClick: function (e) {
                                    e.preventDefault();
                                    handleRegisterClick();
                                }, children: t('Register now') })] })) : undefined
                }, onClose: function () {
                    setIsClosing(true);
                    setMounted(false);
                    onCancelPopupRef.current && onCancelPopupRef.current();
                    // Reset after animation completes (250ms)
                    setTimeout(function () {
                        setSelectedPlatform('none');
                        setIsClosing(false);
                    }, 300);
                }, onClickPrimary: selectedPlatform === 'vietnamworks' && !isRegisterMode
                    ? doLogin
                    : undefined, styleOption: { size: 'lg' }, children: (0,jsx_runtime.jsxs)(LoginModalContainerWrapper, { children: [selectedPlatform === 'none' && !isClosing ? ((0,jsx_runtime.jsxs)(PlatformSelectionSection, { children: [(0,jsx_runtime.jsxs)(PlatformButtonColumn, { children: [(0,jsx_runtime.jsx)("div", { children: (0,jsx_runtime.jsxs)("svg", { width: "158", height: "38", viewBox: "0 0 158 38", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [(0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M34.2828 7.00862C38.1713 6.68556 40.5203 7.98649 41.9048 9.41445C46.7472 7.36401 51.0815 7.00211 53.5404 7.0021C57.5775 7.0021 59.8966 7.58371 59.9935 7.60956C60.7557 7.80341 61.3521 8.40002 61.5459 9.16457C61.7397 9.92919 61.5005 10.7369 60.9235 11.2732C60.874 11.3206 56.6 15.3312 52.3217 21.4179C56.4966 21.1767 60.409 21.7432 61.9248 22.0016C62.2844 22.0619 62.5212 22.4087 62.448 22.7662L61.8493 25.7256C61.7804 26.0659 61.4553 26.2898 61.1109 26.2338C59.1966 25.9172 53.1916 25.0946 48.4611 26.3179C47.4987 26.5656 46.4759 26.1262 46.0044 25.213C45.6577 24.5389 45.7138 23.7247 46.1034 23.0764C49.1157 18.0623 52.4918 13.9656 54.8754 11.3336C54.4598 11.3185 54.0141 11.3098 53.5404 11.3098C51.5035 11.3098 47.9572 11.6029 43.9589 13.2247C44.5144 15.5272 44.1806 17.9826 43.4034 19.8091C41.4095 24.4936 37.6437 27.1729 34.2439 26.3221C32.2523 25.8224 30.7515 24.1489 30.42 22.0576C30.1013 20.048 30.6159 16.0203 37.6265 11.6373C36.8298 11.3142 35.833 11.2023 34.6402 11.3014L34.6337 11.3077C31.5224 11.5662 27.0784 14.1767 23.5688 25.1354C22.3157 29.0468 21.5727 33.2662 21.5382 36.5228C21.5361 36.8761 21.2475 37.1604 20.8944 37.1604H17.88C17.5226 37.1603 17.2319 36.8695 17.2341 36.5098C17.2535 33.5009 17.8048 29.8437 18.7629 26.2403C17.583 25.9496 16.5409 25.2474 15.7571 24.1921C15.0854 23.2853 14.6051 22.1351 14.3166 20.7932C11.8965 24.0865 8.97904 26.389 6.02279 26.389C4.32828 26.389 2.8146 25.6093 1.76172 24.1921C-0.406492 21.2758 -0.583028 15.8266 1.28588 9.6149C1.38061 9.30046 1.47959 8.98809 1.58509 8.67365C1.70351 8.32044 2.03078 8.08137 2.40324 8.08134H5.4414C5.8914 8.08135 6.20352 8.52935 6.04634 8.9515C5.82028 9.56317 5.6071 10.1986 5.40902 10.8555C3.78775 16.2464 4.17323 20.2138 5.21747 21.6203C5.53398 22.0424 5.79887 22.079 6.02279 22.079C8.22978 22.079 12.7362 17.3362 15.0595 9.61259C15.1521 9.30892 15.2361 9.00951 15.3158 8.71445C15.4149 8.33758 15.7571 8.07903 16.1447 8.07903H19.4389C19.8889 8.07903 20.2012 8.52707 20.0441 8.94919C19.818 9.56088 19.6048 10.1964 19.4068 10.8534C17.7855 16.2444 18.1708 20.2117 19.215 21.6182C19.5315 22.0403 19.7964 22.0769 20.0203 22.0769C20.0354 22.0769 20.0505 22.0748 20.0634 22.0748C23.4137 12.7056 28.3078 7.50616 34.2828 7.00862ZM39.9068 15.2902C35.7448 17.892 34.4851 20.1988 34.6724 21.3834C34.7478 21.8487 35.0514 22.0812 35.2883 22.1415C36.1883 22.3676 38.1865 21.0646 39.4396 18.1203C39.7819 17.3126 39.9734 16.2853 39.9218 15.2795C39.9175 15.2837 39.9132 15.2859 39.9068 15.2902Z", fill: "#9345FF" }), (0,jsx_runtime.jsx)("path", { d: "M29.2036 32.4844C31.9942 32.0794 48.0222 29.9599 71.2523 30.8925L71.25 30.8949C71.4889 30.9035 71.6764 31.1036 71.6657 31.3427L71.5408 34.3559C71.5322 34.5929 71.3297 34.776 71.0929 34.7674C48.2353 33.8477 32.5238 35.9217 29.8064 36.3138C29.5739 36.3482 29.3565 36.189 29.3198 35.9564L28.8396 32.9797C28.8008 32.7406 28.9646 32.5188 29.2036 32.4844Z", fill: "#9345FF" }), (0,jsx_runtime.jsx)("path", { d: "M70.3845 8.07692C70.6838 8.07693 70.8948 8.37851 70.7872 8.6585C70.5202 9.36062 70.2683 10.0929 70.0401 10.8532C68.4188 16.2442 68.8041 20.2117 69.8483 21.6182C70.1627 22.0403 70.4276 22.0769 70.6516 22.0769C71.3298 22.0769 72.2255 21.6289 73.2095 20.7825C73.4054 20.6145 73.7046 20.6532 73.8489 20.8685L75.649 23.5695L75.6511 23.5674C75.8384 23.8495 75.7759 24.2286 75.5111 24.4375C73.9587 25.6566 72.3482 26.3846 70.6537 26.3846C68.9591 26.3846 67.4455 25.6049 66.3926 24.1877C64.2244 21.2713 64.0478 15.8221 65.9167 9.61049C66.0266 9.24433 66.1449 8.87805 66.2698 8.5119C66.3581 8.25132 66.6059 8.07692 66.8815 8.07692H70.3845Z", fill: "#9345FF" }), (0,jsx_runtime.jsx)("path", { d: "M70.2575 0C71.8926 2.48676e-05 73.2181 1.32594 73.2181 2.96154C73.2181 4.59714 71.8926 5.92305 70.2575 5.92308C68.6224 5.92308 67.2969 4.59715 67.2969 2.96154C67.2969 1.32593 68.6224 0 70.2575 0Z", fill: "#9345FF" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M139.324 19.1922C141.059 19.1922 142.375 20.4457 142.375 22.2808C142.375 24.1158 141.031 25.4059 139.3 25.4059C137.569 25.4059 136.262 24.1395 136.262 22.3066L136.26 22.3043C136.26 20.465 137.588 19.1922 139.324 19.1922ZM139.322 20.0148C138.103 20.0148 137.184 20.9453 137.184 22.2957C137.184 23.6462 138.088 24.5854 139.3 24.5854C140.474 24.5854 141.386 23.6878 141.442 22.4059L141.445 22.2829C141.445 20.9496 140.54 20.0148 139.322 20.0148Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M97.0447 19.1922C98.6897 19.1922 99.8373 20.4952 99.8373 22.1579V22.1623C99.8372 22.3971 99.6478 22.5866 99.4132 22.5866H95.0228C95.1175 23.8272 95.9315 24.6004 97.1717 24.6004C97.8198 24.6004 98.427 24.3872 98.9395 24.0318L99.3722 24.6283V24.6306C98.7973 25.1174 97.9834 25.4038 97.1286 25.4038C95.4621 25.4038 94.097 24.3203 94.097 22.3409C94.097 20.3616 95.3998 19.1922 97.0447 19.1922ZM97.0513 19.9934C95.9488 19.9934 95.1542 20.7925 95.04 21.8759H98.9266C98.8793 20.8873 98.216 19.9934 97.0513 19.9934Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M101.633 19.3106H103.207V19.6917C103.207 19.92 103.022 20.1052 102.794 20.1053H101.633V23.0022C101.633 24.2256 102.135 24.4518 102.996 24.6435L102.882 25.4017C101.794 25.3651 100.722 24.7942 100.722 23.4244V18.0139C100.722 17.7059 100.94 17.4388 101.241 17.3764L101.633 17.2966V19.3106Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M155.141 19.1878C155.843 19.1878 156.504 19.3923 157.029 19.7563L156.807 20.1204L156.812 20.1225C156.726 20.2646 156.547 20.3185 156.398 20.2474C156.034 20.0773 155.608 19.9696 155.199 19.9696C154.587 19.9696 153.924 20.2002 153.924 20.8528C153.924 22.2958 157.208 21.5054 157.208 23.6442C157.208 24.8416 156.189 25.4017 154.956 25.4017C154.066 25.4017 153.414 25.1088 152.781 24.65L153.046 24.288C153.145 24.1524 153.33 24.118 153.474 24.202C153.905 24.4518 154.355 24.6048 154.893 24.6048C155.515 24.6048 156.295 24.4 156.295 23.6957C156.295 22.2571 153.024 23.069 153.024 20.9087C153.024 19.7285 153.997 19.1878 155.141 19.1878Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M113.288 19.1899C114.836 19.1899 115.713 19.8685 115.713 21.2125V23.7495C115.713 24.2923 115.796 24.5746 116.094 24.7211L115.984 25.3952C115.206 25.3091 114.862 25.1 114.862 24.3677L114.855 24.3635C114.494 24.9558 113.628 25.3994 112.648 25.3994C111.494 25.3994 110.554 24.8072 110.554 23.6376C110.554 22.4681 111.421 21.7185 113.178 21.7185C113.742 21.7185 114.309 21.8027 114.81 21.9017V21.4062C114.81 20.3444 114.136 19.9782 113.17 19.9782C112.631 19.9782 112.106 20.0946 111.639 20.2885C111.479 20.3552 111.294 20.2776 111.223 20.1204L111.062 19.7643C111.678 19.3554 112.522 19.1899 113.288 19.1899ZM113.273 22.4572C112.007 22.4572 111.449 22.8967 111.449 23.5966C111.449 24.3612 112.112 24.6327 112.741 24.6327C113.703 24.6327 114.81 23.9995 114.81 23.1099V22.6297C114.429 22.5522 113.85 22.4572 113.273 22.4572Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M86.1175 19.3127C86.3888 19.3127 86.6322 19.4807 86.7269 19.737L88.4105 24.2687V24.2666L90.1761 19.7262C90.273 19.4764 90.5143 19.3127 90.7813 19.3127H91.2744L88.8584 25.2831H87.9067L85.5771 19.3127H86.1175Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M107.285 19.1922C108.764 19.1922 109.591 20.17 109.591 21.6691V25.2831H108.676V21.7896C108.676 20.717 108.142 20.0235 107.091 20.0234C105.963 20.0234 105.19 20.8182 105.19 21.9167V25.2831H104.275V19.961C104.275 19.6013 104.566 19.3106 104.925 19.3106H105.052V20.1204C105.052 20.157 105.1 20.172 105.121 20.1419C105.539 19.541 106.327 19.19 107.167 19.1922H107.285Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M93.1087 25.281H92.1957V19.6358C92.1958 19.457 92.3423 19.3106 92.521 19.3106H93.1087V25.281Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M124.011 19.1899C125.438 19.1899 126.095 20.2302 126.095 21.6668V25.281H125.18V21.7875C125.18 20.7666 124.803 20.0256 123.8 20.0213C122.717 20.0149 122.107 20.8678 122.107 21.936V25.281H121.194V21.7875C121.194 20.7666 120.807 20.0214 119.814 20.0213C118.742 20.0213 118.126 20.885 118.126 21.936V25.281H117.215V19.961C117.215 19.6013 117.506 19.3106 117.866 19.3106H118.087V20.1118C118.087 20.1484 118.135 20.1634 118.156 20.1332C118.58 19.5259 119.229 19.1899 119.986 19.1899C120.843 19.1899 121.569 19.6186 121.883 20.4134C122.329 19.6294 123.087 19.1899 124.011 19.1899Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M129.331 24.1633L130.769 19.7586C130.858 19.4915 131.105 19.3106 131.387 19.3106H131.865L133.428 24.1675L135.116 19.3106H136.047L133.878 25.281H132.944L131.372 20.4176L129.772 25.281H128.836L126.724 19.3106H127.72L129.331 24.1633Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M145.699 19.1943C146.21 19.1684 146.632 19.2913 146.632 19.2913L146.548 19.7994C146.518 19.9739 146.354 20.0924 146.177 20.0666C146.08 20.0515 145.981 20.0451 145.88 20.0451C144.659 20.0451 144.177 21.1177 144.177 22.326V25.281H143.266V21.7572C143.266 20.4176 144.36 19.2417 145.699 19.1922V19.1943Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M148.371 21.6281H148.638L150.735 19.5022C150.858 19.3795 151.024 19.3085 151.198 19.3085H152.098L149.429 22.0157L152.314 25.2789H151.442C151.256 25.2789 151.078 25.1991 150.955 25.0591V25.0614L148.638 22.4423H148.371V25.281H147.46V17.0726C147.46 16.7647 147.678 16.4976 147.979 16.4351L148.371 16.3556V21.6281Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M111.062 19.7643L111.062 19.7649V19.7628L111.062 19.7643Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M92.6522 17.2966C93.0096 17.2966 93.2981 17.5853 93.2982 17.9428C93.2982 18.3003 93.0097 18.5889 92.6522 18.5889C92.2948 18.5889 92.0063 18.3003 92.0063 17.9428C92.0063 17.5853 92.2949 17.2967 92.6522 17.2966Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M131.605 10.7728L132.348 12.9094C132.429 13.1485 132.498 13.3854 132.554 13.6202C132.574 13.7085 132.599 13.7969 132.621 13.8852C132.645 13.7969 132.671 13.7085 132.692 13.6202C132.75 13.3832 132.821 13.1463 132.905 12.9115L133.662 10.777H134.456L132.821 15.0612C132.746 15.2615 132.653 15.4316 132.541 15.5651C132.429 15.6986 132.298 15.8 132.145 15.8689C131.992 15.9378 131.816 15.9721 131.613 15.9721C131.497 15.9721 131.394 15.9635 131.301 15.9463C131.211 15.929 131.142 15.9097 131.097 15.8903L131.278 15.2873L131.361 15.3066C131.488 15.3389 131.605 15.3476 131.706 15.3325C131.807 15.3174 131.895 15.27 131.971 15.1903C132.046 15.1106 132.106 14.99 132.152 14.8285L132.233 14.5528L130.804 10.7728H131.605Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M98.2569 10.7297C98.5562 10.7297 98.8254 10.805 99.0623 10.9579H99.0665C99.3033 11.1109 99.4886 11.3327 99.6264 11.6213C99.7621 11.9099 99.8308 12.2633 99.8308 12.6682C99.8308 13.0731 99.762 13.4198 99.6285 13.7106C99.4929 14.0014 99.3077 14.2255 99.0709 14.3805C98.834 14.5378 98.5648 14.6153 98.259 14.6153C98.0308 14.6153 97.8457 14.5765 97.7014 14.4989C97.5572 14.4214 97.443 14.331 97.3612 14.2276C97.2794 14.1242 97.217 14.0337 97.1717 13.9519H97.1307V15.9484H96.3902V10.7791H97.1093V11.391H97.1696C97.2148 11.3113 97.2773 11.2208 97.357 11.1174C97.4366 11.014 97.5486 10.9236 97.6907 10.846C97.8328 10.7685 98.0222 10.7297 98.2569 10.7297ZM98.091 11.3565C97.8801 11.3565 97.7035 11.4125 97.5572 11.5202C97.4107 11.63 97.3009 11.7809 97.2277 11.9747C97.1523 12.1685 97.1158 12.399 97.1158 12.6596C97.1158 12.9202 97.1523 13.1507 97.2277 13.3488C97.303 13.547 97.4129 13.7021 97.5593 13.8141C97.7056 13.9261 97.8758 13.9819 98.091 13.9819C98.3063 13.9819 98.4873 13.9239 98.6337 13.8076C98.778 13.6913 98.8877 13.534 98.9609 13.3337V13.3316C99.0341 13.1334 99.0709 12.9072 99.0709 12.6596C99.0709 12.4119 99.0341 12.19 98.9609 11.9941C98.8877 11.7981 98.778 11.6429 98.6337 11.5288C98.4895 11.4146 98.302 11.3565 98.091 11.3565Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M102.232 10.7297C102.585 10.7297 102.895 10.8094 103.157 10.971C103.42 11.1325 103.625 11.3587 103.771 11.6516C103.918 11.9445 103.991 12.2913 103.991 12.6768C103.991 13.0623 103.918 13.4026 103.771 13.6934C103.625 13.9863 103.42 14.2125 103.157 14.374C102.895 14.5334 102.585 14.6153 102.232 14.6153C101.879 14.6153 101.571 14.5355 101.308 14.374C101.045 14.2125 100.841 13.9841 100.694 13.6934C100.548 13.4026 100.475 13.0666 100.475 12.6768C100.475 12.287 100.548 11.9445 100.694 11.6516C100.839 11.3587 101.045 11.1325 101.308 10.971C101.571 10.8116 101.879 10.7297 102.232 10.7297ZM102.23 11.3521C102.003 11.3521 101.816 11.4124 101.667 11.533C101.519 11.6536 101.409 11.8131 101.336 12.0134C101.263 12.2137 101.226 12.4377 101.226 12.6768C101.226 12.9159 101.263 13.1334 101.336 13.3316C101.409 13.5297 101.519 13.6891 101.667 13.8097C101.816 13.9303 102.001 13.9906 102.23 13.9906C102.458 13.9906 102.647 13.9303 102.796 13.8097C102.944 13.6891 103.056 13.5297 103.129 13.3316V13.3295C103.203 13.1313 103.239 12.9137 103.239 12.6747C103.239 12.4356 103.203 12.2137 103.129 12.0134C103.056 11.8131 102.944 11.6536 102.796 11.533C102.647 11.4124 102.456 11.3521 102.23 11.3521Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M127.757 11.391H127.798C127.843 11.3113 127.906 11.2208 127.985 11.1174C128.065 11.014 128.177 10.9236 128.319 10.846C128.461 10.7685 128.651 10.7297 128.885 10.7297C129.185 10.7297 129.454 10.805 129.691 10.9579C129.928 11.1108 130.113 11.3327 130.25 11.6213C130.386 11.9099 130.455 12.2633 130.455 12.6682C130.455 13.0731 130.386 13.4198 130.253 13.7106C130.117 14.0014 129.932 14.2255 129.695 14.3805C129.458 14.5377 129.189 14.6153 128.883 14.6153C128.655 14.6153 128.47 14.5765 128.326 14.4989C128.181 14.4214 128.067 14.331 127.985 14.2276C127.904 14.1242 127.841 14.0337 127.796 13.9519H127.736V14.5398H127.017V9.52575H127.757V11.391ZM128.719 11.3565C128.509 11.3565 128.332 11.4125 128.186 11.5202C128.039 11.63 127.929 11.7809 127.856 11.9747C127.781 12.1685 127.744 12.399 127.744 12.6596C127.744 12.9202 127.781 13.1507 127.856 13.3488C127.931 13.547 128.041 13.7021 128.188 13.8141C128.334 13.9261 128.504 13.9819 128.719 13.9819C128.935 13.9819 129.116 13.9239 129.262 13.8076C129.406 13.6913 129.516 13.534 129.589 13.3337V13.3316C129.663 13.1334 129.699 12.9072 129.699 12.6596C129.699 12.4119 129.663 12.19 129.589 11.9941C129.516 11.7981 129.406 11.6429 129.262 11.5288C129.118 11.4146 128.93 11.3565 128.719 11.3565Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M111.852 10.7276C112.067 10.7276 112.274 10.7619 112.474 10.833C112.674 10.9041 112.853 11.0139 113.012 11.1647V11.1605C113.172 11.3112 113.299 11.5051 113.391 11.7442C113.484 11.9832 113.531 12.274 113.531 12.6143V12.877H110.866C110.872 13.1032 110.915 13.2971 110.995 13.4586C111.083 13.6374 111.208 13.7731 111.367 13.8635C111.527 13.954 111.712 13.9992 111.923 13.9992C112.061 13.9992 112.188 13.9799 112.3 13.9411C112.412 13.9024 112.509 13.842 112.59 13.7623C112.672 13.6827 112.735 13.5835 112.778 13.4672L113.473 13.633C113.413 13.8268 113.312 13.9972 113.17 14.1458C113.027 14.2944 112.849 14.4085 112.638 14.4903C112.427 14.5722 112.185 14.6132 111.916 14.6132C111.546 14.6131 111.227 14.5334 110.958 14.374C110.689 14.2168 110.483 13.9906 110.338 13.702C110.194 13.4134 110.121 13.0688 110.121 12.6833C110.121 12.2978 110.192 11.9595 110.334 11.6645C110.476 11.3694 110.676 11.141 110.937 10.9752C111.197 10.8093 111.503 10.7276 111.852 10.7276ZM111.852 11.3414C111.645 11.3414 111.466 11.391 111.318 11.4922C111.169 11.5934 111.057 11.7247 110.98 11.8906H110.982C110.917 12.0262 110.881 12.1727 110.87 12.33H112.797C112.782 12.1727 112.75 12.0305 112.698 11.9013C112.625 11.7269 112.519 11.5891 112.379 11.4901C112.237 11.391 112.058 11.3414 111.852 11.3414Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M118.432 10.7276C118.647 10.7276 118.854 10.7619 119.054 10.833C119.254 10.9041 119.433 11.0139 119.592 11.1647V11.1605C119.752 11.3113 119.879 11.5051 119.971 11.7442C120.064 11.9832 120.111 12.274 120.111 12.6143V12.877H117.446C117.452 13.1032 117.495 13.2971 117.575 13.4586C117.663 13.6374 117.788 13.7731 117.947 13.8635C118.107 13.954 118.292 13.9992 118.503 13.9992C118.641 13.9992 118.768 13.9799 118.88 13.9411C118.992 13.9024 119.089 13.842 119.17 13.7623C119.252 13.6827 119.315 13.5836 119.358 13.4672L120.053 13.633C119.993 13.8268 119.892 13.9972 119.75 14.1458C119.608 14.2944 119.429 14.4085 119.218 14.4903C119.007 14.5722 118.766 14.6132 118.496 14.6132C118.126 14.6132 117.807 14.5334 117.538 14.374C117.269 14.2168 117.062 13.9906 116.918 13.702C116.774 13.4134 116.701 13.0688 116.701 12.6833C116.701 12.2978 116.772 11.9595 116.914 11.6645C117.056 11.3694 117.256 11.141 117.517 10.9752C117.777 10.8094 118.083 10.7276 118.432 10.7276ZM118.432 11.3414C118.225 11.3414 118.046 11.391 117.898 11.4922C117.749 11.5934 117.637 11.7248 117.56 11.8906H117.562C117.497 12.0262 117.461 12.1727 117.45 12.33H119.377C119.362 12.1727 119.33 12.0305 119.278 11.9013C119.205 11.7269 119.099 11.5891 118.959 11.4901C118.817 11.391 118.639 11.3414 118.432 11.3414Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M124.187 14.5376H123.468V13.9498H123.408C123.365 14.0294 123.3 14.122 123.218 14.2253C123.134 14.3287 123.022 14.4193 122.878 14.4968C122.734 14.5744 122.549 14.6132 122.322 14.6132C122.017 14.6131 121.746 14.5333 121.509 14.3782C121.272 14.2231 121.085 13.9992 120.951 13.7085C120.815 13.4178 120.749 13.0753 120.749 12.6661C120.749 12.2568 120.815 11.9078 120.953 11.6192C121.091 11.3285 121.276 11.1087 121.515 10.9558C121.752 10.8029 122.021 10.7276 122.322 10.7276C122.555 10.7276 122.745 10.7664 122.887 10.8439C123.029 10.9215 123.139 11.0119 123.22 11.1153C123.302 11.2186 123.363 11.3112 123.406 11.3887H123.447V9.52344H124.187V14.5376ZM122.482 11.3586C122.264 11.3586 122.086 11.4168 121.939 11.5309C121.793 11.645 121.685 11.8002 121.612 11.9962C121.539 12.1943 121.502 12.414 121.502 12.6617C121.502 12.9093 121.541 13.1334 121.614 13.3337C121.687 13.5318 121.797 13.6913 121.944 13.8076C122.09 13.9239 122.271 13.9819 122.482 13.9819C122.693 13.9819 122.872 13.9261 123.016 13.8141C123.16 13.7021 123.27 13.5469 123.345 13.3488V13.3509C123.418 13.1506 123.457 12.9244 123.457 12.6617C123.457 12.3989 123.418 12.1706 123.345 11.9768C123.272 11.783 123.162 11.6321 123.018 11.5223C122.874 11.4124 122.699 11.3586 122.482 11.3586Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M94.2046 10.7125C94.4264 10.7125 94.6266 10.7599 94.8075 10.8568L94.8054 10.8612C94.9862 10.9581 95.1284 11.1024 95.2339 11.2919C95.3372 11.4815 95.391 11.7205 95.391 12.0048V14.5421H94.6504V12.078C94.6504 11.8281 94.5793 11.645 94.4393 11.533C94.2994 11.421 94.1336 11.3651 93.9441 11.3651C93.7891 11.3651 93.6557 11.3975 93.5438 11.4621C93.4318 11.5267 93.3456 11.6171 93.2854 11.7334C93.2251 11.8497 93.1949 11.9811 93.1949 12.1318V14.5421H92.4649V12.0306C92.4649 11.8282 92.4004 11.6666 92.2712 11.546C92.1421 11.4254 91.9784 11.3652 91.7782 11.3651C91.6425 11.3651 91.5132 11.3996 91.3969 11.4621C91.2807 11.5246 91.186 11.6193 91.115 11.7442C91.0439 11.8691 91.0094 12.022 91.0094 12.2029V14.5421H90.2689V10.7791H90.9728L90.9901 11.4791C91.0417 11.3435 91.1064 11.225 91.186 11.126C91.298 10.9882 91.4294 10.887 91.5801 10.8181C91.7308 10.7492 91.8879 10.7146 92.0515 10.7146C92.325 10.7146 92.5467 10.7987 92.7147 10.9689C92.8503 11.1067 92.9472 11.2876 93.0118 11.5094C93.0613 11.3737 93.1303 11.2552 93.2164 11.1519C93.337 11.0076 93.4855 10.8998 93.6556 10.8244C93.8257 10.749 94.0087 10.7125 94.2046 10.7125Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M108.588 14.5376H107.845L107.38 12.9181C107.332 12.7544 107.287 12.5842 107.242 12.4055C107.197 12.2267 107.154 12.0457 107.111 11.8584C107.091 11.7809 107.074 11.7033 107.055 11.6258C107.038 11.7033 107.018 11.7809 107.001 11.8584C106.956 12.0457 106.913 12.2288 106.867 12.4097C106.822 12.5906 106.777 12.7608 106.729 12.9202L106.264 14.5398H105.522L104.391 10.777H105.171L105.584 12.3344C105.647 12.5691 105.711 12.8277 105.78 13.1141C105.829 13.323 105.879 13.5534 105.929 13.8032C105.976 13.5663 106.025 13.3381 106.075 13.1313C106.144 12.8449 106.211 12.5799 106.273 12.3344L106.687 10.777H107.427L107.834 12.3344C107.896 12.5734 107.961 12.8363 108.03 13.1227C108.079 13.3294 108.129 13.562 108.177 13.8032C108.226 13.5641 108.273 13.3358 108.323 13.129C108.392 12.8404 108.456 12.5756 108.519 12.3344L108.521 12.3321L108.934 10.7749H109.722L108.588 14.5376Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M89.3279 10.1826H86.9399V11.6775H89.1578V12.3344H86.9399V13.8787H89.3494V14.5376H86.1735V9.52344H89.3279V10.1826Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M116.05 10.7211C116.098 10.7211 116.152 10.721 116.212 10.7253C116.272 10.7296 116.322 10.734 116.363 10.7404V11.447C116.335 11.4384 116.283 11.4297 116.208 11.4211C116.13 11.4125 116.053 11.4083 115.975 11.4083C115.805 11.4083 115.65 11.4449 115.514 11.516C115.379 11.587 115.271 11.6861 115.196 11.8132C115.12 11.9402 115.082 12.0867 115.082 12.2526V14.5376H114.341V10.7749H115.058V11.3801H115.099C115.168 11.1733 115.29 11.0118 115.463 10.8955C115.635 10.7792 115.831 10.7211 116.05 10.7211Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M133.662 10.777H133.661L133.663 10.7749L133.662 10.777Z", fill: "black" })] }) }), (0,jsx_runtime.jsx)(UpziTitle, { children: t('For Fresher & under 3 years of experience') }), (0,jsx_runtime.jsx)(UpziButtonWrapper, { children: (0,jsx_runtime.jsx)(Button/* default */.Z, { type: "primary", size: "lg", onClick: function () { return handlePlatformSelection('upzi'); }, children: t('Start with Upzi') }) }), (0,jsx_runtime.jsxs)(UpziWhySection, { children: [(0,jsx_runtime.jsx)(UpziWhyTitle, { children: t('Why choose Upzi?') }), (0,jsx_runtime.jsxs)(UpziWhyList, { children: [(0,jsx_runtime.jsxs)("li", { children: [(0,jsx_runtime.jsx)("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { d: "M9.6 0C4.2984 0 0 4.2984 0 9.6C0 14.9016 4.2984 19.2 9.6 19.2C14.9016 19.2 19.2 14.9016 19.2 9.6C19.2 4.2984 14.9016 0 9.6 0ZM14.9656 7.7656L8.9176 13.8136C8.7672 13.964 8.564 14.048 8.352 14.048C8.14 14.048 7.936 13.964 7.7864 13.8136L5.024 11.0512C4.7112 10.7384 4.7112 10.2328 5.024 9.92C5.3368 9.6072 5.8424 9.6072 6.1552 9.92L8.352 12.1168L13.8344 6.6344C14.1472 6.3216 14.6528 6.3216 14.9656 6.6344C15.2784 6.9472 15.2784 7.4528 14.9656 7.7656Z", fill: "#609B2D" }) }), t('Career guidance app for young people')] }), (0,jsx_runtime.jsxs)("li", { children: [(0,jsx_runtime.jsx)("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { d: "M9.6 0C4.2984 0 0 4.2984 0 9.6C0 14.9016 4.2984 19.2 9.6 19.2C14.9016 19.2 19.2 14.9016 19.2 9.6C19.2 4.2984 14.9016 0 9.6 0ZM14.9656 7.7656L8.9176 13.8136C8.7672 13.964 8.564 14.048 8.352 14.048C8.14 14.048 7.936 13.964 7.7864 13.8136L5.024 11.0512C4.7112 10.7384 4.7112 10.2328 5.024 9.92C5.3368 9.6072 5.8424 9.6072 6.1552 9.92L8.352 12.1168L13.8344 6.6344C14.1472 6.3216 14.6528 6.3216 14.9656 6.6344C15.2784 6.9472 15.2784 7.4528 14.9656 7.7656Z", fill: "#609B2D" }) }), t('Thousands of job opportunities exclusively for Freshers')] }), (0,jsx_runtime.jsxs)("li", { children: [(0,jsx_runtime.jsx)("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { d: "M9.6 0C4.2984 0 0 4.2984 0 9.6C0 14.9016 4.2984 19.2 9.6 19.2C14.9016 19.2 19.2 14.9016 19.2 9.6C19.2 4.2984 14.9016 0 9.6 0ZM14.9656 7.7656L8.9176 13.8136C8.7672 13.964 8.564 14.048 8.352 14.048C8.14 14.048 7.936 13.964 7.7864 13.8136L5.024 11.0512C4.7112 10.7384 4.7112 10.2328 5.024 9.92C5.3368 9.6072 5.8424 9.6072 6.1552 9.92L8.352 12.1168L13.8344 6.6344C14.1472 6.3216 14.6528 6.3216 14.9656 6.6344C15.2784 6.9472 15.2784 7.4528 14.9656 7.7656Z", fill: "#609B2D" }) }), t('Evaluate your job matching with AI')] })] }), (0,jsx_runtime.jsx)(MobileButtonWrapper, { children: (0,jsx_runtime.jsxs)(Button/* default */.Z, { type: "primary", size: "lg", onClick: function () { return handlePlatformSelection('upzi'); }, children: [t('Download Upzi'), (0,jsx_runtime.jsx)("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { d: "M2 19V15C2 14.4477 2.44772 14 3 14C3.55228 14 4 14.4477 4 15V19C4 19.2652 4.10543 19.5195 4.29297 19.707C4.48051 19.8946 4.73478 20 5 20H19C19.2652 20 19.5195 19.8946 19.707 19.707C19.8946 19.5195 20 19.2652 20 19V15C20 14.4477 20.4477 14 21 14C21.5523 14 22 14.4477 22 15V19C22 19.7957 21.6837 20.5585 21.1211 21.1211C20.5585 21.6837 19.7957 22 19 22H5C4.20435 22 3.44152 21.6837 2.87891 21.1211C2.3163 20.5585 2 19.7957 2 19ZM11 3C11 2.44772 11.4477 2 12 2C12.5523 2 13 2.44772 13 3V12.5859L16.293 9.29297C16.6835 8.90244 17.3165 8.90244 17.707 9.29297C18.0976 9.68349 18.0976 10.3165 17.707 10.707L12.707 15.707C12.3165 16.0976 11.6835 16.0976 11.293 15.707L6.29297 10.707C5.90244 10.3165 5.90244 9.68349 6.29297 9.29297C6.68349 8.90244 7.31651 8.90244 7.70703 9.29297L11 12.5859V3Z", fill: "#1C1C1C" }) })] }) })] })] }), (0,jsx_runtime.jsxs)(VnwsButtonColumn, { children: [(0,jsx_runtime.jsx)("div", { children: (0,jsx_runtime.jsxs)("svg", { width: "176", height: "42", viewBox: "0 0 176 42", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [(0,jsx_runtime.jsx)("path", { d: "M168.215 9.38725C165.955 9.02523 163.327 9.93413 163.327 9.93413C160.374 10.8704 157.661 10.5893 157.661 10.5893C155.522 10.4908 153.316 9.75475 153.316 9.75475C151.924 9.33257 150.198 9.2571 150.198 9.2571C150.198 9.2571 153.892 5.58868 159.401 4.55509C159.401 4.55509 166.09 3.02604 168.974 8.87866C169.119 9.17288 168.866 9.50647 168.542 9.44632L168.213 9.38616L168.215 9.38725Z", fill: "url(#paint0_linear_33609_24741)" }), (0,jsx_runtime.jsx)("path", { d: "M169.164 10.0753C169.164 10.0753 175.799 9.82916 175.998 16.933C175.998 16.933 176.277 22.5986 170.438 27.9175C170.438 27.9175 165.511 32.6479 160.014 32.5101C159.709 32.5025 159.61 32.0989 159.877 31.9512C161.333 31.1375 164.231 29.0594 167.299 24.271C167.299 24.271 172.166 17.4088 169.164 10.0763V10.0753Z", fill: "url(#paint1_linear_33609_24741)" }), (0,jsx_runtime.jsx)("path", { d: "M159.152 32.8601C159.152 32.8601 150.731 38.5082 144.703 33.1368C144.703 33.1368 140.482 29.4432 142.742 22.4389C142.852 22.0988 143.324 22.0659 143.481 22.3875C144.425 24.3169 147.02 28.9051 151.204 30.9909C151.204 30.9909 154.224 32.9192 159.152 32.8601Z", fill: "url(#paint2_linear_33609_24741)" }), (0,jsx_runtime.jsx)("path", { d: "M151.815 10.7199C150.145 11.783 146.035 15.1047 144.512 22.762C144.512 22.762 141.048 17.2791 144.258 12.7225C144.258 12.7225 146.405 9.47632 151.69 10.1719C151.969 10.208 152.05 10.569 151.813 10.7199H151.815Z", fill: "url(#paint3_linear_33609_24741)" }), (0,jsx_runtime.jsx)("path", { d: "M60.2422 28.1719H64.6565V28.885H61.0507V31.4269H64.1912V32.14H61.0507V34.742H64.7511V35.4551H60.2422V28.1719V28.1719Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { d: "M65.6279 35.4553V30.3344H66.2978L66.3803 31.1295C66.7433 30.5509 67.3285 30.2305 68.0204 30.2305C68.7596 30.2305 69.3855 30.598 69.6572 31.2794C70.0422 30.6067 70.6967 30.2305 71.4931 30.2305C72.7251 30.2305 73.2916 31.123 73.2916 32.3545V35.4553H72.5018V32.4573C72.5018 31.5812 72.1762 30.9458 71.3105 30.9425C70.3755 30.9359 69.8508 31.6687 69.8508 32.5853V35.4542H69.0643V32.4562C69.0643 31.5801 68.7299 30.9414 67.873 30.9414C66.9468 30.9414 66.4166 31.683 66.4166 32.5842V35.4531H65.6301L65.6279 35.4553Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M76.9147 30.2305C76.1469 30.2305 75.4957 30.5673 75.0535 31.1798V31.1787L74.9677 30.3333H74.2979V37.7106L75.0876 37.5509V34.6765H75.0942C75.4957 35.2573 76.1634 35.5592 76.8894 35.5592C78.2292 35.5592 79.3545 34.6065 79.3545 32.8664C79.3545 31.1262 78.1632 30.2305 76.9147 30.2305ZM75.0601 32.9178C75.0601 31.7803 75.7388 30.9348 76.8102 30.9348L76.8091 30.9359C77.8299 30.9359 78.557 31.7147 78.557 32.8839C78.557 34.0531 77.8079 34.8537 76.8036 34.8537C75.7993 34.8537 75.0601 34.0553 75.0601 32.9178Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M82.6225 30.2305C81.1243 30.2305 79.9771 31.3242 79.9771 32.9014H79.9782C79.9782 34.472 81.1056 35.5592 82.6005 35.5592C84.0954 35.5592 85.2548 34.4545 85.2548 32.8795C85.2548 31.3045 84.1207 30.2305 82.6225 30.2305ZM82.6192 30.9381C83.6708 30.9381 84.4518 31.7387 84.4518 32.8828H84.4507C84.4507 34.0389 83.6444 34.8592 82.5994 34.8592C81.5544 34.8592 80.7735 34.0553 80.7735 32.8959C80.7735 31.7366 81.5676 30.9381 82.6192 30.9381Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { d: "M86.2042 30.334L87.5946 34.4968L88.963 30.334H89.7814L91.1311 34.5001L92.5874 30.334H93.3904L91.5194 35.4549H90.7142L89.359 31.2823L87.9785 35.4549H87.17L85.3462 30.334H86.2053H86.2042Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M93.5586 32.932C93.5586 34.6284 94.7378 35.5581 96.1755 35.5581L96.1744 35.5592C96.9136 35.5592 97.6154 35.3142 98.1115 34.8964L97.7386 34.3845C97.2964 34.6897 96.7717 34.8712 96.2129 34.8712C95.1415 34.8712 94.4408 34.2084 94.3583 33.1431H98.491C98.4998 33.0709 98.513 32.9233 98.513 32.7756C98.513 31.3494 97.5197 30.2305 96.1018 30.2305C94.6839 30.2305 93.5586 31.2356 93.5586 32.932ZM96.1084 30.9173C97.1138 30.9173 97.6858 31.6841 97.7265 32.5328H94.3737C94.4716 31.602 95.1569 30.9173 96.1084 30.9173Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { d: "M99.3766 30.3344H100.046L100.134 31.1667H100.141C100.475 30.5444 100.95 30.2305 101.667 30.2305C101.876 30.2305 102.087 30.2556 102.279 30.3092L102.16 31.0355C101.989 30.9852 101.815 30.9567 101.632 30.9567C100.579 30.9567 100.162 31.8776 100.162 32.9134V35.4553H99.3755V30.3344H99.3766Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M107.168 37.7114C108.672 37.7114 109.743 36.8375 109.743 35.2636L109.742 35.2658V30.3363H109.06L108.978 31.1654C108.564 30.5562 107.901 30.2324 107.148 30.2324C105.938 30.2324 104.7 31.1304 104.7 32.8115C104.7 34.4926 105.869 35.3971 107.124 35.3971C107.857 35.3971 108.555 35.0854 108.95 34.5013H108.957V35.0886C108.957 36.4646 108.176 37.0049 107.117 37.0049C106.526 37.0049 106.017 36.8321 105.54 36.4996L105.152 37.0268C105.717 37.4697 106.378 37.7114 107.168 37.7114ZM107.227 30.9368C108.258 30.9368 108.972 31.6915 108.972 32.8191V32.818C108.972 33.9304 108.304 34.6938 107.246 34.6938C106.188 34.6938 105.493 33.8812 105.493 32.8093C105.493 31.7374 106.197 30.9368 107.227 30.9368Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { d: "M110.861 30.3344H111.531L111.619 31.1667H111.626C111.96 30.5444 112.434 30.2305 113.152 30.2305C113.361 30.2305 113.572 30.2556 113.764 30.3092L113.644 31.0355C113.474 30.9852 113.3 30.9567 113.116 30.9567C112.065 30.9567 111.647 31.8776 111.647 32.9134V35.4553H110.86V30.3344H110.861Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M116.471 30.2305C114.972 30.2305 113.825 31.3242 113.825 32.9014H113.826C113.826 34.472 114.954 35.5592 116.449 35.5592C117.944 35.5592 119.103 34.4545 119.103 32.8795C119.103 31.3045 117.969 30.2305 116.471 30.2305ZM116.467 30.9381C117.519 30.9381 118.3 31.7387 118.3 32.8828H118.299C118.299 34.0389 117.493 34.8592 116.448 34.8592C115.403 34.8592 114.622 34.0553 114.622 32.8959C114.622 31.7366 115.416 30.9381 116.467 30.9381Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { d: "M119.997 30.334L121.388 34.4968L122.756 30.334H123.574L124.924 34.5001L126.38 30.334H127.183L125.312 35.4549H124.507L123.152 31.2823L121.771 35.4549H120.963L119.139 30.334H119.998H119.997Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { d: "M127.639 30.3328H128.599V28.6987L129.385 28.5391V30.3328H130.744V31.0153H129.385V33.5003C129.385 34.5503 129.819 34.745 130.561 34.9079L130.463 35.5587C129.525 35.527 128.599 35.037 128.599 33.8623V31.0164H127.639V30.3339V30.3328Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { d: "M135.276 35.456V32.5368C135.276 31.5853 134.834 30.9433 133.886 30.9433C132.937 30.9433 132.202 31.5842 132.202 32.5084V35.455H131.415V27.9967L132.202 27.8359V31.0942H132.208C132.625 30.5156 133.286 30.2301 134.041 30.2301C135.323 30.2301 136.063 31.0625 136.063 32.3542V35.455H135.276V35.456Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { d: "M114.476 12.6288C111.928 12.7229 109.845 14.9465 109.845 17.4828V24.1525H111.581V18.558C111.581 16.2699 112.502 14.2399 114.823 14.2399C115.015 14.2399 115.204 14.2541 115.389 14.2815C115.725 14.3307 116.038 14.1076 116.093 13.7751L116.253 12.8126C116.253 12.8126 115.449 12.5807 114.477 12.6299L114.476 12.6288Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { d: "M67.82 24.1531V17.5403C67.82 15.6065 67.0808 14.1989 65.1922 14.1989C63.1495 14.1989 61.978 15.8351 61.978 17.8247V24.1531H60.2422V14.0841C60.2422 13.4048 60.7955 12.8536 61.4797 12.8536H61.9021V14.3695C61.9021 14.4406 61.9934 14.4669 62.0341 14.4089C62.8415 13.2594 64.0746 12.625 65.52 12.625C67.1512 12.625 68.5317 13.4366 69.1312 14.9405C69.9815 13.4573 71.4247 12.625 73.1814 12.625C75.9006 12.625 77.148 14.5937 77.148 17.3106V24.152H75.4056V17.5392C75.4056 15.6055 74.6873 14.2055 72.7777 14.1978C70.7141 14.1836 69.5569 15.799 69.5569 17.8236V24.152H67.8211L67.82 24.1531Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { d: "M5.39657 22.2324L8.75705 13.6377C8.94185 13.1652 9.39945 12.8535 9.90984 12.8535H10.8481L6.24686 24.153H4.43407L0 12.8535H1.02959C1.54659 12.8535 2.00859 13.1729 2.18899 13.6552L5.39657 22.2324Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.4728 11.4844C14.1515 11.4844 14.7015 10.9376 14.7015 10.2627C14.7015 9.58789 14.1515 9.04102 13.4728 9.04102C12.7941 9.04102 12.2441 9.58789 12.2441 10.2627C12.2441 10.9376 12.7941 11.4844 13.4728 11.4844ZM12.6049 13.4685V24.1522V24.1533H14.3407V12.8538H13.2231C12.8821 12.8538 12.6049 13.1283 12.6049 13.4685Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M26.2674 22.9197C26.2676 22.9196 26.2678 22.9195 26.2679 22.9193V22.9204L26.2674 22.9197ZM21.9944 24.3816C23.6255 24.3816 25.173 23.8415 26.2674 22.9197L25.4451 21.7906C24.4694 22.4621 23.3122 22.8646 22.078 22.8646C19.7153 22.8646 18.1676 21.4012 17.9861 19.0518H26.3471C26.7915 19.0518 27.1534 18.6931 27.1534 18.2501V18.2403C27.1534 15.0925 24.9644 12.625 21.8338 12.625C18.7033 12.625 16.2217 14.8442 16.2217 18.587C16.2217 22.3298 18.8221 24.3816 21.9944 24.3816ZM21.8481 14.1431C24.0646 14.1431 25.3263 15.8351 25.4176 17.7065H18.0213C18.2369 15.6547 19.7494 14.1431 21.8481 14.1431Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { d: "M32.7852 14.3577H30.5731V19.8406C30.5731 22.1561 31.5279 22.5859 33.1669 22.9458L32.9513 24.3808C30.8811 24.3119 28.8384 23.2302 28.8384 20.638V10.3984C28.8384 9.81429 29.252 9.31117 29.8273 9.19305L30.5742 9.04102V12.8538H33.5717V13.5768C33.5717 14.0077 33.2197 14.3577 32.7863 14.3577H32.7852Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { d: "M37.0809 12.8525V14.3859C37.0809 14.4548 37.1711 14.4855 37.2107 14.4286C38.0071 13.2911 39.5053 12.6261 41.1069 12.6294C41.1817 12.6294 41.2576 12.625 41.3324 12.625C44.1495 12.625 45.7247 14.4756 45.7247 17.3106V24.152H43.9812V17.5392C43.9812 15.5081 42.9637 14.1978 40.9628 14.1978C38.8156 14.1978 37.3449 15.7017 37.3449 17.782V24.152H35.6025V14.0808C35.6025 13.4016 36.1558 12.8503 36.84 12.8503H37.0809V12.8525Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M52.7632 12.625C51.3068 12.625 49.6964 12.9367 48.5249 13.7133L48.8329 14.3903C48.9693 14.6889 49.3191 14.8344 49.6238 14.7086C50.5126 14.3411 51.5169 14.1223 52.5399 14.1223C54.3801 14.1223 55.6627 14.8158 55.6627 16.8261V17.7623C54.7068 17.5753 53.6267 17.4156 52.5531 17.4156C49.2069 17.4156 47.5547 18.8375 47.5547 21.0479C47.5547 23.2584 49.3466 24.3816 51.5422 24.3816C53.4111 24.3816 55.0566 23.5427 55.7463 22.4195L55.7606 22.426C55.7606 23.8107 56.4151 24.2056 57.8957 24.3696L58.1025 23.0921C57.5382 22.8154 57.3776 22.2817 57.3776 21.2557V16.452C57.3776 13.908 55.7122 12.625 52.7632 12.625ZM49.2641 20.9637C49.2641 19.6403 50.3234 18.8079 52.7357 18.8079V18.809C53.8368 18.809 54.9389 18.9895 55.6638 19.135V20.0428C55.6638 21.7271 53.5585 22.9259 51.7248 22.9259C50.5258 22.9259 49.2641 22.4129 49.2641 20.9637Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { d: "M80.2444 12.8535L83.3123 22.0388L86.0524 13.7023C86.2185 13.197 86.6926 12.8546 87.2283 12.8546H88.1369L91.1134 22.0464L94.3276 12.8546H96.0986L91.9714 24.1541H90.1939L87.203 14.948L84.156 24.1541H82.3718L78.3491 12.8546H80.2455L80.2444 12.8535Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { d: "M124.485 23.7381L120.072 18.7802H119.563V24.1526H117.827V8.6171C117.827 8.03304 118.241 7.52992 118.816 7.4118L119.563 7.25977V17.2413H120.072L124.066 13.2196C124.298 12.9855 124.615 12.8543 124.946 12.8543H126.66L121.578 17.9774L127.071 24.1537H125.412C125.057 24.1537 124.72 24.0028 124.485 23.7392V23.7381Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { d: "M135.637 14.3883C135.473 14.6552 135.134 14.7591 134.849 14.6257C134.159 14.3019 133.343 14.1007 132.566 14.1007C131.402 14.1007 130.139 14.5371 130.139 15.7708C130.139 18.5019 136.393 17.0046 136.393 21.0525C136.393 23.3199 134.454 24.3797 132.105 24.3797C130.411 24.3797 129.17 23.8252 127.963 22.9589L128.467 22.2753C128.656 22.0194 129.008 21.9527 129.284 22.1124C130.104 22.5849 130.96 22.8758 131.985 22.8758C133.17 22.8758 134.655 22.4875 134.655 21.1564C134.655 18.4319 128.429 19.9708 128.429 15.8813C128.429 13.649 130.283 12.623 132.458 12.623C133.797 12.623 135.052 13.0113 136.055 13.6982L135.634 14.3873L135.637 14.3883Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M102.341 12.625C99.0369 12.625 96.5059 15.0367 96.5059 18.517C96.5059 21.9831 98.994 24.3816 102.292 24.3816C105.59 24.3816 108.148 21.9415 108.148 18.4689C108.148 14.9962 105.646 12.625 102.341 12.625ZM102.334 14.1847C104.656 14.1847 106.377 15.9522 106.377 18.4754V18.4743C106.377 21.026 104.6 22.8351 102.292 22.8351C99.984 22.8351 98.2626 21.0599 98.2626 18.5028C98.2626 15.9456 100.012 14.1847 102.334 14.1847Z", fill: "#001744" }), (0,jsx_runtime.jsxs)("defs", { children: [(0,jsx_runtime.jsxs)("linearGradient", { id: "paint0_linear_33609_24741", x1: "150.199", y1: "10.6298", x2: "169.018", y2: "10.6298", gradientUnits: "userSpaceOnUse", children: [(0,jsx_runtime.jsx)("stop", { "stop-color": "#3CAAFF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.24", "stop-color": "#47B2FF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.68", "stop-color": "#67C9FF" }), (0,jsx_runtime.jsx)("stop", { offset: "1", "stop-color": "#82DCFF" })] }), (0,jsx_runtime.jsxs)("linearGradient", { id: "paint1_linear_33609_24741", x1: "170.378", y1: "1.12331", x2: "148.733", y2: "10.0474", gradientUnits: "userSpaceOnUse", children: [(0,jsx_runtime.jsx)("stop", { offset: "0.1", "stop-color": "#005AFF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.13", "stop-color": "#035EFF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.5", "stop-color": "#2287FF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.79", "stop-color": "#35A0FF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.96", "stop-color": "#3CAAFF" })] }), (0,jsx_runtime.jsxs)("linearGradient", { id: "paint2_linear_33609_24741", x1: "141.02", y1: "35.4548", x2: "158.094", y2: "35.4548", gradientUnits: "userSpaceOnUse", children: [(0,jsx_runtime.jsx)("stop", { "stop-color": "#82DCFF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.25", "stop-color": "#65C7FF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.57", "stop-color": "#47B2FF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.75", "stop-color": "#3CAAFF" })] }), (0,jsx_runtime.jsxs)("linearGradient", { id: "paint3_linear_33609_24741", x1: "143.396", y1: "26.6586", x2: "155.152", y2: "23.6608", gradientUnits: "userSpaceOnUse", children: [(0,jsx_runtime.jsx)("stop", { "stop-color": "#005AFF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.26", "stop-color": "#1272FF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.75", "stop-color": "#309AFF" }), (0,jsx_runtime.jsx)("stop", { offset: "1", "stop-color": "#3CAAFF" })] })] })] }) }), (0,jsx_runtime.jsx)(UpziTitle, { children: t('For people with 3 years of experience and above') }), (0,jsx_runtime.jsx)(VnwsButtonWrapper, { children: (0,jsx_runtime.jsx)(Button/* default */.Z, { type: "primary", size: "lg", onClick: function () { return handlePlatformSelection('vietnamworks'); }, children: t('Continue with VietnamWorks') }) }), (0,jsx_runtime.jsxs)(UpziWhySection, { children: [(0,jsx_runtime.jsx)(UpziWhyTitle, { children: t('Why choose VietnamWorks?') }), (0,jsx_runtime.jsxs)(UpziWhyList, { children: [(0,jsx_runtime.jsxs)("li", { children: [(0,jsx_runtime.jsx)("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { d: "M9.6 0C4.2984 0 0 4.2984 0 9.6C0 14.9016 4.2984 19.2 9.6 19.2C14.9016 19.2 19.2 14.9016 19.2 9.6C19.2 4.2984 14.9016 0 9.6 0ZM14.9656 7.7656L8.9176 13.8136C8.7672 13.964 8.564 14.048 8.352 14.048C8.14 14.048 7.936 13.964 7.7864 13.8136L5.024 11.0512C4.7112 10.7384 4.7112 10.2328 5.024 9.92C5.3368 9.6072 5.8424 9.6072 6.1552 9.92L8.352 12.1168L13.8344 6.6344C14.1472 6.3216 14.6528 6.3216 14.9656 6.6344C15.2784 6.9472 15.2784 7.4528 14.9656 7.7656Z", fill: "#609B2D" }) }), t('Job platform for experienced professionals')] }), (0,jsx_runtime.jsxs)("li", { children: [(0,jsx_runtime.jsx)("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { d: "M9.6 0C4.2984 0 0 4.2984 0 9.6C0 14.9016 4.2984 19.2 9.6 19.2C14.9016 19.2 19.2 14.9016 19.2 9.6C19.2 4.2984 14.9016 0 9.6 0ZM14.9656 7.7656L8.9176 13.8136C8.7672 13.964 8.564 14.048 8.352 14.048C8.14 14.048 7.936 13.964 7.7864 13.8136L5.024 11.0512C4.7112 10.7384 4.7112 10.2328 5.024 9.92C5.3368 9.6072 5.8424 9.6072 6.1552 9.92L8.352 12.1168L13.8344 6.6344C14.1472 6.3216 14.6528 6.3216 14.9656 6.6344C15.2784 6.9472 15.2784 7.4528 14.9656 7.7656Z", fill: "#609B2D" }) }), t('Huge number of jobs for all industries')] }), (0,jsx_runtime.jsxs)("li", { children: [(0,jsx_runtime.jsx)("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { d: "M9.6 0C4.2984 0 0 4.2984 0 9.6C0 14.9016 4.2984 19.2 9.6 19.2C14.9016 19.2 19.2 14.9016 19.2 9.6C19.2 4.2984 14.9016 0 9.6 0ZM14.9656 7.7656L8.9176 13.8136C8.7672 13.964 8.564 14.048 8.352 14.048C8.14 14.048 7.936 13.964 7.7864 13.8136L5.024 11.0512C4.7112 10.7384 4.7112 10.2328 5.024 9.92C5.3368 9.6072 5.8424 9.6072 6.1552 9.92L8.352 12.1168L13.8344 6.6344C14.1472 6.3216 14.6528 6.3216 14.9656 6.6344C15.2784 6.9472 15.2784 7.4528 14.9656 7.7656Z", fill: "#609B2D" }) }), t('Evaluate your job matching with AI')] })] }), (0,jsx_runtime.jsx)(MobileButtonWrapper, { children: (0,jsx_runtime.jsxs)(Button/* default */.Z, { type: "primary", size: "lg", onClick: function () { return handlePlatformSelection('vietnamworks'); }, children: [t('Continue with VietnamWorks'), (0,jsx_runtime.jsx)("svg", { width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { d: "M10.293 3.29289C10.6835 2.90237 11.3165 2.90237 11.707 3.29289L18.707 10.2929C19.0976 10.6834 19.0976 11.3164 18.707 11.707L11.707 18.707C11.3165 19.0975 10.6835 19.0975 10.293 18.707C9.90244 18.3164 9.90244 17.6834 10.293 17.2929L15.5859 11.9999H4C3.44772 11.9999 3 11.5522 3 10.9999C3 10.4476 3.44772 9.99992 4 9.99992H15.5859L10.293 4.70696C9.90244 4.31643 9.90244 3.68342 10.293 3.29289Z", fill: "#1C1C1C" }) })] }) })] })] })] })) : null, selectedPlatform === 'upzi' ? ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: (0,jsx_runtime.jsxs)(UpziIntroSection, { children: [(0,jsx_runtime.jsxs)(UpziIntroTextSection, { children: [(0,jsx_runtime.jsx)("div", { children: (0,jsx_runtime.jsxs)("svg", { width: "158", height: "38", viewBox: "0 0 158 38", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [(0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M34.2828 7.00862C38.1713 6.68556 40.5203 7.98649 41.9048 9.41445C46.7472 7.36401 51.0815 7.00211 53.5404 7.0021C57.5775 7.0021 59.8966 7.58371 59.9935 7.60956C60.7557 7.80341 61.3521 8.40002 61.5459 9.16457C61.7397 9.92919 61.5005 10.7369 60.9235 11.2732C60.874 11.3206 56.6 15.3312 52.3217 21.4179C56.4966 21.1767 60.409 21.7432 61.9248 22.0016C62.2844 22.0619 62.5212 22.4087 62.448 22.7662L61.8493 25.7256C61.7804 26.0659 61.4553 26.2898 61.1109 26.2338C59.1966 25.9172 53.1916 25.0946 48.4611 26.3179C47.4987 26.5656 46.4759 26.1262 46.0044 25.213C45.6577 24.5389 45.7138 23.7247 46.1034 23.0764C49.1157 18.0623 52.4918 13.9656 54.8754 11.3336C54.4598 11.3185 54.0141 11.3098 53.5404 11.3098C51.5035 11.3098 47.9572 11.6029 43.9589 13.2247C44.5144 15.5272 44.1806 17.9826 43.4034 19.8091C41.4095 24.4936 37.6437 27.1729 34.2439 26.3221C32.2523 25.8224 30.7515 24.1489 30.42 22.0576C30.1013 20.048 30.6159 16.0203 37.6265 11.6373C36.8298 11.3142 35.833 11.2023 34.6402 11.3014L34.6337 11.3077C31.5224 11.5662 27.0784 14.1767 23.5688 25.1354C22.3157 29.0468 21.5727 33.2662 21.5382 36.5228C21.5361 36.8761 21.2475 37.1604 20.8944 37.1604H17.88C17.5226 37.1603 17.2319 36.8695 17.2341 36.5098C17.2535 33.5009 17.8048 29.8437 18.7629 26.2403C17.583 25.9496 16.5409 25.2474 15.7571 24.1921C15.0854 23.2853 14.6051 22.1351 14.3166 20.7932C11.8965 24.0865 8.97904 26.389 6.02279 26.389C4.32828 26.389 2.8146 25.6093 1.76172 24.1921C-0.406492 21.2758 -0.583028 15.8266 1.28588 9.6149C1.38061 9.30046 1.47959 8.98809 1.58509 8.67365C1.70351 8.32044 2.03078 8.08137 2.40324 8.08134H5.4414C5.8914 8.08135 6.20352 8.52935 6.04634 8.9515C5.82028 9.56317 5.6071 10.1986 5.40902 10.8555C3.78775 16.2464 4.17323 20.2138 5.21747 21.6203C5.53398 22.0424 5.79887 22.079 6.02279 22.079C8.22978 22.079 12.7362 17.3362 15.0595 9.61259C15.1521 9.30892 15.2361 9.00951 15.3158 8.71445C15.4149 8.33758 15.7571 8.07903 16.1447 8.07903H19.4389C19.8889 8.07903 20.2012 8.52707 20.0441 8.94919C19.818 9.56088 19.6048 10.1964 19.4068 10.8534C17.7855 16.2444 18.1708 20.2117 19.215 21.6182C19.5315 22.0403 19.7964 22.0769 20.0203 22.0769C20.0354 22.0769 20.0505 22.0748 20.0634 22.0748C23.4137 12.7056 28.3078 7.50616 34.2828 7.00862ZM39.9068 15.2902C35.7448 17.892 34.4851 20.1988 34.6724 21.3834C34.7478 21.8487 35.0514 22.0812 35.2883 22.1415C36.1883 22.3676 38.1865 21.0646 39.4396 18.1203C39.7819 17.3126 39.9734 16.2853 39.9218 15.2795C39.9175 15.2837 39.9132 15.2859 39.9068 15.2902Z", fill: "#9345FF" }), (0,jsx_runtime.jsx)("path", { d: "M29.2036 32.4844C31.9942 32.0794 48.0222 29.9599 71.2523 30.8925L71.25 30.8949C71.4889 30.9035 71.6764 31.1036 71.6657 31.3427L71.5408 34.3559C71.5322 34.5929 71.3297 34.776 71.0929 34.7674C48.2353 33.8477 32.5238 35.9217 29.8064 36.3138C29.5739 36.3482 29.3565 36.189 29.3198 35.9564L28.8396 32.9797C28.8008 32.7406 28.9646 32.5188 29.2036 32.4844Z", fill: "#9345FF" }), (0,jsx_runtime.jsx)("path", { d: "M70.3845 8.07692C70.6838 8.07693 70.8948 8.37851 70.7872 8.6585C70.5202 9.36062 70.2683 10.0929 70.0401 10.8532C68.4188 16.2442 68.8041 20.2117 69.8483 21.6182C70.1627 22.0403 70.4276 22.0769 70.6516 22.0769C71.3298 22.0769 72.2255 21.6289 73.2095 20.7825C73.4054 20.6145 73.7046 20.6532 73.8489 20.8685L75.649 23.5695L75.6511 23.5674C75.8384 23.8495 75.7759 24.2286 75.5111 24.4375C73.9587 25.6566 72.3482 26.3846 70.6537 26.3846C68.9591 26.3846 67.4455 25.6049 66.3926 24.1877C64.2244 21.2713 64.0478 15.8221 65.9167 9.61049C66.0266 9.24433 66.1449 8.87805 66.2698 8.5119C66.3581 8.25132 66.6059 8.07692 66.8815 8.07692H70.3845Z", fill: "#9345FF" }), (0,jsx_runtime.jsx)("path", { d: "M70.2575 0C71.8926 2.48676e-05 73.2181 1.32594 73.2181 2.96154C73.2181 4.59714 71.8926 5.92305 70.2575 5.92308C68.6224 5.92308 67.2969 4.59715 67.2969 2.96154C67.2969 1.32593 68.6224 0 70.2575 0Z", fill: "#9345FF" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M139.324 19.1922C141.059 19.1922 142.375 20.4457 142.375 22.2808C142.375 24.1158 141.031 25.4059 139.3 25.4059C137.569 25.4059 136.262 24.1395 136.262 22.3066L136.26 22.3043C136.26 20.465 137.588 19.1922 139.324 19.1922ZM139.322 20.0148C138.103 20.0148 137.184 20.9453 137.184 22.2957C137.184 23.6462 138.088 24.5854 139.3 24.5854C140.474 24.5854 141.386 23.6878 141.442 22.4059L141.445 22.2829C141.445 20.9496 140.54 20.0148 139.322 20.0148Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M97.0447 19.1922C98.6897 19.1922 99.8373 20.4952 99.8373 22.1579V22.1623C99.8372 22.3971 99.6478 22.5866 99.4132 22.5866H95.0228C95.1175 23.8272 95.9315 24.6004 97.1717 24.6004C97.8198 24.6004 98.427 24.3872 98.9395 24.0318L99.3722 24.6283V24.6306C98.7973 25.1174 97.9834 25.4038 97.1286 25.4038C95.4621 25.4038 94.097 24.3203 94.097 22.3409C94.097 20.3616 95.3998 19.1922 97.0447 19.1922ZM97.0513 19.9934C95.9488 19.9934 95.1542 20.7925 95.04 21.8759H98.9266C98.8793 20.8873 98.216 19.9934 97.0513 19.9934Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M101.633 19.3106H103.207V19.6917C103.207 19.92 103.022 20.1052 102.794 20.1053H101.633V23.0022C101.633 24.2256 102.135 24.4518 102.996 24.6435L102.882 25.4017C101.794 25.3651 100.722 24.7942 100.722 23.4244V18.0139C100.722 17.7059 100.94 17.4388 101.241 17.3764L101.633 17.2966V19.3106Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M155.141 19.1878C155.843 19.1878 156.504 19.3923 157.029 19.7563L156.807 20.1204L156.812 20.1225C156.726 20.2646 156.547 20.3185 156.398 20.2474C156.034 20.0773 155.608 19.9696 155.199 19.9696C154.587 19.9696 153.924 20.2002 153.924 20.8528C153.924 22.2958 157.208 21.5054 157.208 23.6442C157.208 24.8416 156.189 25.4017 154.956 25.4017C154.066 25.4017 153.414 25.1088 152.781 24.65L153.046 24.288C153.145 24.1524 153.33 24.118 153.474 24.202C153.905 24.4518 154.355 24.6048 154.893 24.6048C155.515 24.6048 156.295 24.4 156.295 23.6957C156.295 22.2571 153.024 23.069 153.024 20.9087C153.024 19.7285 153.997 19.1878 155.141 19.1878Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M113.288 19.1899C114.836 19.1899 115.713 19.8685 115.713 21.2125V23.7495C115.713 24.2923 115.796 24.5746 116.094 24.7211L115.984 25.3952C115.206 25.3091 114.862 25.1 114.862 24.3677L114.855 24.3635C114.494 24.9558 113.628 25.3994 112.648 25.3994C111.494 25.3994 110.554 24.8072 110.554 23.6376C110.554 22.4681 111.421 21.7185 113.178 21.7185C113.742 21.7185 114.309 21.8027 114.81 21.9017V21.4062C114.81 20.3444 114.136 19.9782 113.17 19.9782C112.631 19.9782 112.106 20.0946 111.639 20.2885C111.479 20.3552 111.294 20.2776 111.223 20.1204L111.062 19.7643C111.678 19.3554 112.522 19.1899 113.288 19.1899ZM113.273 22.4572C112.007 22.4572 111.449 22.8967 111.449 23.5966C111.449 24.3612 112.112 24.6327 112.741 24.6327C113.703 24.6327 114.81 23.9995 114.81 23.1099V22.6297C114.429 22.5522 113.85 22.4572 113.273 22.4572Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M86.1175 19.3127C86.3888 19.3127 86.6322 19.4807 86.7269 19.737L88.4105 24.2687V24.2666L90.1761 19.7262C90.273 19.4764 90.5143 19.3127 90.7813 19.3127H91.2744L88.8584 25.2831H87.9067L85.5771 19.3127H86.1175Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M107.285 19.1922C108.764 19.1922 109.591 20.17 109.591 21.6691V25.2831H108.676V21.7896C108.676 20.717 108.142 20.0235 107.091 20.0234C105.963 20.0234 105.19 20.8182 105.19 21.9167V25.2831H104.275V19.961C104.275 19.6013 104.566 19.3106 104.925 19.3106H105.052V20.1204C105.052 20.157 105.1 20.172 105.121 20.1419C105.539 19.541 106.327 19.19 107.167 19.1922H107.285Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M93.1087 25.281H92.1957V19.6358C92.1958 19.457 92.3423 19.3106 92.521 19.3106H93.1087V25.281Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M124.011 19.1899C125.438 19.1899 126.095 20.2302 126.095 21.6668V25.281H125.18V21.7875C125.18 20.7666 124.803 20.0256 123.8 20.0213C122.717 20.0149 122.107 20.8678 122.107 21.936V25.281H121.194V21.7875C121.194 20.7666 120.807 20.0214 119.814 20.0213C118.742 20.0213 118.126 20.885 118.126 21.936V25.281H117.215V19.961C117.215 19.6013 117.506 19.3106 117.866 19.3106H118.087V20.1118C118.087 20.1484 118.135 20.1634 118.156 20.1332C118.58 19.5259 119.229 19.1899 119.986 19.1899C120.843 19.1899 121.569 19.6186 121.883 20.4134C122.329 19.6294 123.087 19.1899 124.011 19.1899Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M129.331 24.1633L130.769 19.7586C130.858 19.4915 131.105 19.3106 131.387 19.3106H131.865L133.428 24.1675L135.116 19.3106H136.047L133.878 25.281H132.944L131.372 20.4176L129.772 25.281H128.836L126.724 19.3106H127.72L129.331 24.1633Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M145.699 19.1943C146.21 19.1684 146.632 19.2913 146.632 19.2913L146.548 19.7994C146.518 19.9739 146.354 20.0924 146.177 20.0666C146.08 20.0515 145.981 20.0451 145.88 20.0451C144.659 20.0451 144.177 21.1177 144.177 22.326V25.281H143.266V21.7572C143.266 20.4176 144.36 19.2417 145.699 19.1922V19.1943Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M148.371 21.6281H148.638L150.735 19.5022C150.858 19.3795 151.024 19.3085 151.198 19.3085H152.098L149.429 22.0157L152.314 25.2789H151.442C151.256 25.2789 151.078 25.1991 150.955 25.0591V25.0614L148.638 22.4423H148.371V25.281H147.46V17.0726C147.46 16.7647 147.678 16.4976 147.979 16.4351L148.371 16.3556V21.6281Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M111.062 19.7643L111.062 19.7649V19.7628L111.062 19.7643Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M92.6522 17.2966C93.0096 17.2966 93.2981 17.5853 93.2982 17.9428C93.2982 18.3003 93.0097 18.5889 92.6522 18.5889C92.2948 18.5889 92.0063 18.3003 92.0063 17.9428C92.0063 17.5853 92.2949 17.2967 92.6522 17.2966Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M131.605 10.7728L132.348 12.9094C132.429 13.1485 132.498 13.3854 132.554 13.6202C132.574 13.7085 132.599 13.7969 132.621 13.8852C132.645 13.7969 132.671 13.7085 132.692 13.6202C132.75 13.3832 132.821 13.1463 132.905 12.9115L133.662 10.777H134.456L132.821 15.0612C132.746 15.2615 132.653 15.4316 132.541 15.5651C132.429 15.6986 132.298 15.8 132.145 15.8689C131.992 15.9378 131.816 15.9721 131.613 15.9721C131.497 15.9721 131.394 15.9635 131.301 15.9463C131.211 15.929 131.142 15.9097 131.097 15.8903L131.278 15.2873L131.361 15.3066C131.488 15.3389 131.605 15.3476 131.706 15.3325C131.807 15.3174 131.895 15.27 131.971 15.1903C132.046 15.1106 132.106 14.99 132.152 14.8285L132.233 14.5528L130.804 10.7728H131.605Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M98.2569 10.7297C98.5562 10.7297 98.8254 10.805 99.0623 10.9579H99.0665C99.3033 11.1109 99.4886 11.3327 99.6264 11.6213C99.7621 11.9099 99.8308 12.2633 99.8308 12.6682C99.8308 13.0731 99.762 13.4198 99.6285 13.7106C99.4929 14.0014 99.3077 14.2255 99.0709 14.3805C98.834 14.5378 98.5648 14.6153 98.259 14.6153C98.0308 14.6153 97.8457 14.5765 97.7014 14.4989C97.5572 14.4214 97.443 14.331 97.3612 14.2276C97.2794 14.1242 97.217 14.0337 97.1717 13.9519H97.1307V15.9484H96.3902V10.7791H97.1093V11.391H97.1696C97.2148 11.3113 97.2773 11.2208 97.357 11.1174C97.4366 11.014 97.5486 10.9236 97.6907 10.846C97.8328 10.7685 98.0222 10.7297 98.2569 10.7297ZM98.091 11.3565C97.8801 11.3565 97.7035 11.4125 97.5572 11.5202C97.4107 11.63 97.3009 11.7809 97.2277 11.9747C97.1523 12.1685 97.1158 12.399 97.1158 12.6596C97.1158 12.9202 97.1523 13.1507 97.2277 13.3488C97.303 13.547 97.4129 13.7021 97.5593 13.8141C97.7056 13.9261 97.8758 13.9819 98.091 13.9819C98.3063 13.9819 98.4873 13.9239 98.6337 13.8076C98.778 13.6913 98.8877 13.534 98.9609 13.3337V13.3316C99.0341 13.1334 99.0709 12.9072 99.0709 12.6596C99.0709 12.4119 99.0341 12.19 98.9609 11.9941C98.8877 11.7981 98.778 11.6429 98.6337 11.5288C98.4895 11.4146 98.302 11.3565 98.091 11.3565Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M102.232 10.7297C102.585 10.7297 102.895 10.8094 103.157 10.971C103.42 11.1325 103.625 11.3587 103.771 11.6516C103.918 11.9445 103.991 12.2913 103.991 12.6768C103.991 13.0623 103.918 13.4026 103.771 13.6934C103.625 13.9863 103.42 14.2125 103.157 14.374C102.895 14.5334 102.585 14.6153 102.232 14.6153C101.879 14.6153 101.571 14.5355 101.308 14.374C101.045 14.2125 100.841 13.9841 100.694 13.6934C100.548 13.4026 100.475 13.0666 100.475 12.6768C100.475 12.287 100.548 11.9445 100.694 11.6516C100.839 11.3587 101.045 11.1325 101.308 10.971C101.571 10.8116 101.879 10.7297 102.232 10.7297ZM102.23 11.3521C102.003 11.3521 101.816 11.4124 101.667 11.533C101.519 11.6536 101.409 11.8131 101.336 12.0134C101.263 12.2137 101.226 12.4377 101.226 12.6768C101.226 12.9159 101.263 13.1334 101.336 13.3316C101.409 13.5297 101.519 13.6891 101.667 13.8097C101.816 13.9303 102.001 13.9906 102.23 13.9906C102.458 13.9906 102.647 13.9303 102.796 13.8097C102.944 13.6891 103.056 13.5297 103.129 13.3316V13.3295C103.203 13.1313 103.239 12.9137 103.239 12.6747C103.239 12.4356 103.203 12.2137 103.129 12.0134C103.056 11.8131 102.944 11.6536 102.796 11.533C102.647 11.4124 102.456 11.3521 102.23 11.3521Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M127.757 11.391H127.798C127.843 11.3113 127.906 11.2208 127.985 11.1174C128.065 11.014 128.177 10.9236 128.319 10.846C128.461 10.7685 128.651 10.7297 128.885 10.7297C129.185 10.7297 129.454 10.805 129.691 10.9579C129.928 11.1108 130.113 11.3327 130.25 11.6213C130.386 11.9099 130.455 12.2633 130.455 12.6682C130.455 13.0731 130.386 13.4198 130.253 13.7106C130.117 14.0014 129.932 14.2255 129.695 14.3805C129.458 14.5377 129.189 14.6153 128.883 14.6153C128.655 14.6153 128.47 14.5765 128.326 14.4989C128.181 14.4214 128.067 14.331 127.985 14.2276C127.904 14.1242 127.841 14.0337 127.796 13.9519H127.736V14.5398H127.017V9.52575H127.757V11.391ZM128.719 11.3565C128.509 11.3565 128.332 11.4125 128.186 11.5202C128.039 11.63 127.929 11.7809 127.856 11.9747C127.781 12.1685 127.744 12.399 127.744 12.6596C127.744 12.9202 127.781 13.1507 127.856 13.3488C127.931 13.547 128.041 13.7021 128.188 13.8141C128.334 13.9261 128.504 13.9819 128.719 13.9819C128.935 13.9819 129.116 13.9239 129.262 13.8076C129.406 13.6913 129.516 13.534 129.589 13.3337V13.3316C129.663 13.1334 129.699 12.9072 129.699 12.6596C129.699 12.4119 129.663 12.19 129.589 11.9941C129.516 11.7981 129.406 11.6429 129.262 11.5288C129.118 11.4146 128.93 11.3565 128.719 11.3565Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M111.852 10.7276C112.067 10.7276 112.274 10.7619 112.474 10.833C112.674 10.9041 112.853 11.0139 113.012 11.1647V11.1605C113.172 11.3112 113.299 11.5051 113.391 11.7442C113.484 11.9832 113.531 12.274 113.531 12.6143V12.877H110.866C110.872 13.1032 110.915 13.2971 110.995 13.4586C111.083 13.6374 111.208 13.7731 111.367 13.8635C111.527 13.954 111.712 13.9992 111.923 13.9992C112.061 13.9992 112.188 13.9799 112.3 13.9411C112.412 13.9024 112.509 13.842 112.59 13.7623C112.672 13.6827 112.735 13.5835 112.778 13.4672L113.473 13.633C113.413 13.8268 113.312 13.9972 113.17 14.1458C113.027 14.2944 112.849 14.4085 112.638 14.4903C112.427 14.5722 112.185 14.6132 111.916 14.6132C111.546 14.6131 111.227 14.5334 110.958 14.374C110.689 14.2168 110.483 13.9906 110.338 13.702C110.194 13.4134 110.121 13.0688 110.121 12.6833C110.121 12.2978 110.192 11.9595 110.334 11.6645C110.476 11.3694 110.676 11.141 110.937 10.9752C111.197 10.8093 111.503 10.7276 111.852 10.7276ZM111.852 11.3414C111.645 11.3414 111.466 11.391 111.318 11.4922C111.169 11.5934 111.057 11.7247 110.98 11.8906H110.982C110.917 12.0262 110.881 12.1727 110.87 12.33H112.797C112.782 12.1727 112.75 12.0305 112.698 11.9013C112.625 11.7269 112.519 11.5891 112.379 11.4901C112.237 11.391 112.058 11.3414 111.852 11.3414Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M118.432 10.7276C118.647 10.7276 118.854 10.7619 119.054 10.833C119.254 10.9041 119.433 11.0139 119.592 11.1647V11.1605C119.752 11.3113 119.879 11.5051 119.971 11.7442C120.064 11.9832 120.111 12.274 120.111 12.6143V12.877H117.446C117.452 13.1032 117.495 13.2971 117.575 13.4586C117.663 13.6374 117.788 13.7731 117.947 13.8635C118.107 13.954 118.292 13.9992 118.503 13.9992C118.641 13.9992 118.768 13.9799 118.88 13.9411C118.992 13.9024 119.089 13.842 119.17 13.7623C119.252 13.6827 119.315 13.5836 119.358 13.4672L120.053 13.633C119.993 13.8268 119.892 13.9972 119.75 14.1458C119.608 14.2944 119.429 14.4085 119.218 14.4903C119.007 14.5722 118.766 14.6132 118.496 14.6132C118.126 14.6132 117.807 14.5334 117.538 14.374C117.269 14.2168 117.062 13.9906 116.918 13.702C116.774 13.4134 116.701 13.0688 116.701 12.6833C116.701 12.2978 116.772 11.9595 116.914 11.6645C117.056 11.3694 117.256 11.141 117.517 10.9752C117.777 10.8094 118.083 10.7276 118.432 10.7276ZM118.432 11.3414C118.225 11.3414 118.046 11.391 117.898 11.4922C117.749 11.5934 117.637 11.7248 117.56 11.8906H117.562C117.497 12.0262 117.461 12.1727 117.45 12.33H119.377C119.362 12.1727 119.33 12.0305 119.278 11.9013C119.205 11.7269 119.099 11.5891 118.959 11.4901C118.817 11.391 118.639 11.3414 118.432 11.3414Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M124.187 14.5376H123.468V13.9498H123.408C123.365 14.0294 123.3 14.122 123.218 14.2253C123.134 14.3287 123.022 14.4193 122.878 14.4968C122.734 14.5744 122.549 14.6132 122.322 14.6132C122.017 14.6131 121.746 14.5333 121.509 14.3782C121.272 14.2231 121.085 13.9992 120.951 13.7085C120.815 13.4178 120.749 13.0753 120.749 12.6661C120.749 12.2568 120.815 11.9078 120.953 11.6192C121.091 11.3285 121.276 11.1087 121.515 10.9558C121.752 10.8029 122.021 10.7276 122.322 10.7276C122.555 10.7276 122.745 10.7664 122.887 10.8439C123.029 10.9215 123.139 11.0119 123.22 11.1153C123.302 11.2186 123.363 11.3112 123.406 11.3887H123.447V9.52344H124.187V14.5376ZM122.482 11.3586C122.264 11.3586 122.086 11.4168 121.939 11.5309C121.793 11.645 121.685 11.8002 121.612 11.9962C121.539 12.1943 121.502 12.414 121.502 12.6617C121.502 12.9093 121.541 13.1334 121.614 13.3337C121.687 13.5318 121.797 13.6913 121.944 13.8076C122.09 13.9239 122.271 13.9819 122.482 13.9819C122.693 13.9819 122.872 13.9261 123.016 13.8141C123.16 13.7021 123.27 13.5469 123.345 13.3488V13.3509C123.418 13.1506 123.457 12.9244 123.457 12.6617C123.457 12.3989 123.418 12.1706 123.345 11.9768C123.272 11.783 123.162 11.6321 123.018 11.5223C122.874 11.4124 122.699 11.3586 122.482 11.3586Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M94.2046 10.7125C94.4264 10.7125 94.6266 10.7599 94.8075 10.8568L94.8054 10.8612C94.9862 10.9581 95.1284 11.1024 95.2339 11.2919C95.3372 11.4815 95.391 11.7205 95.391 12.0048V14.5421H94.6504V12.078C94.6504 11.8281 94.5793 11.645 94.4393 11.533C94.2994 11.421 94.1336 11.3651 93.9441 11.3651C93.7891 11.3651 93.6557 11.3975 93.5438 11.4621C93.4318 11.5267 93.3456 11.6171 93.2854 11.7334C93.2251 11.8497 93.1949 11.9811 93.1949 12.1318V14.5421H92.4649V12.0306C92.4649 11.8282 92.4004 11.6666 92.2712 11.546C92.1421 11.4254 91.9784 11.3652 91.7782 11.3651C91.6425 11.3651 91.5132 11.3996 91.3969 11.4621C91.2807 11.5246 91.186 11.6193 91.115 11.7442C91.0439 11.8691 91.0094 12.022 91.0094 12.2029V14.5421H90.2689V10.7791H90.9728L90.9901 11.4791C91.0417 11.3435 91.1064 11.225 91.186 11.126C91.298 10.9882 91.4294 10.887 91.5801 10.8181C91.7308 10.7492 91.8879 10.7146 92.0515 10.7146C92.325 10.7146 92.5467 10.7987 92.7147 10.9689C92.8503 11.1067 92.9472 11.2876 93.0118 11.5094C93.0613 11.3737 93.1303 11.2552 93.2164 11.1519C93.337 11.0076 93.4855 10.8998 93.6556 10.8244C93.8257 10.749 94.0087 10.7125 94.2046 10.7125Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M108.588 14.5376H107.845L107.38 12.9181C107.332 12.7544 107.287 12.5842 107.242 12.4055C107.197 12.2267 107.154 12.0457 107.111 11.8584C107.091 11.7809 107.074 11.7033 107.055 11.6258C107.038 11.7033 107.018 11.7809 107.001 11.8584C106.956 12.0457 106.913 12.2288 106.867 12.4097C106.822 12.5906 106.777 12.7608 106.729 12.9202L106.264 14.5398H105.522L104.391 10.777H105.171L105.584 12.3344C105.647 12.5691 105.711 12.8277 105.78 13.1141C105.829 13.323 105.879 13.5534 105.929 13.8032C105.976 13.5663 106.025 13.3381 106.075 13.1313C106.144 12.8449 106.211 12.5799 106.273 12.3344L106.687 10.777H107.427L107.834 12.3344C107.896 12.5734 107.961 12.8363 108.03 13.1227C108.079 13.3294 108.129 13.562 108.177 13.8032C108.226 13.5641 108.273 13.3358 108.323 13.129C108.392 12.8404 108.456 12.5756 108.519 12.3344L108.521 12.3321L108.934 10.7749H109.722L108.588 14.5376Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M89.3279 10.1826H86.9399V11.6775H89.1578V12.3344H86.9399V13.8787H89.3494V14.5376H86.1735V9.52344H89.3279V10.1826Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M116.05 10.7211C116.098 10.7211 116.152 10.721 116.212 10.7253C116.272 10.7296 116.322 10.734 116.363 10.7404V11.447C116.335 11.4384 116.283 11.4297 116.208 11.4211C116.13 11.4125 116.053 11.4083 115.975 11.4083C115.805 11.4083 115.65 11.4449 115.514 11.516C115.379 11.587 115.271 11.6861 115.196 11.8132C115.12 11.9402 115.082 12.0867 115.082 12.2526V14.5376H114.341V10.7749H115.058V11.3801H115.099C115.168 11.1733 115.29 11.0118 115.463 10.8955C115.635 10.7792 115.831 10.7211 116.05 10.7211Z", fill: "black" }), (0,jsx_runtime.jsx)("path", { d: "M133.662 10.777H133.661L133.663 10.7749L133.662 10.777Z", fill: "black" })] }) }), (0,jsx_runtime.jsx)(UpziDesc, { children: t('Upzi is a product of Navigos Group – the leading and trusted recruitment organization in Vietnam.') }), (0,jsx_runtime.jsx)(UpziSubtitle, { children: t('Scan QR get app to see Thousands of job opportunities exclusively for Freshers') })] }), (0,jsx_runtime.jsx)(UpziIntroQrSection, { children: (0,jsx_runtime.jsx)(UpziIntroQrWrap, { children: (0,jsx_runtime.jsx)("img", { width: "272", src: 'https://www.vietnamworks.com/assets-page-container/images/upzi_qr_scan.png?v=1', alt: '' }) }) })] }) })) : null, selectedPlatform === 'vietnamworks' && !isRegisterMode ? ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: (0,jsx_runtime.jsxs)(ModalFormWapper, { children: [(0,jsx_runtime.jsxs)(ModalFormTitle, { children: [(0,jsx_runtime.jsx)("div", { children: (0,jsx_runtime.jsxs)("svg", { width: "176", height: "42", viewBox: "0 0 176 42", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [(0,jsx_runtime.jsx)("path", { d: "M168.214 9.38725C165.955 9.02523 163.327 9.93413 163.327 9.93413C160.373 10.8704 157.661 10.5893 157.661 10.5893C155.521 10.4908 153.316 9.75475 153.316 9.75475C151.923 9.33257 150.197 9.2571 150.197 9.2571C150.197 9.2571 153.891 5.58868 159.401 4.55509C159.401 4.55509 166.09 3.02604 168.973 8.87866C169.118 9.17288 168.865 9.50647 168.542 9.44632L168.213 9.38616L168.214 9.38725Z", fill: "url(#paint0_linear_33609_31043)" }), (0,jsx_runtime.jsx)("path", { d: "M169.163 10.0753C169.163 10.0753 175.798 9.82916 175.998 16.933C175.998 16.933 176.277 22.5986 170.437 27.9175C170.437 27.9175 165.51 32.6479 160.014 32.5101C159.709 32.5025 159.61 32.0989 159.876 31.9512C161.332 31.1375 164.231 29.0594 167.299 24.271C167.299 24.271 172.165 17.4088 169.163 10.0763V10.0753Z", fill: "url(#paint1_linear_33609_31043)" }), (0,jsx_runtime.jsx)("path", { d: "M159.151 32.8601C159.151 32.8601 150.731 38.5082 144.703 33.1368C144.703 33.1368 140.482 29.4432 142.741 22.4389C142.851 22.0988 143.323 22.0659 143.481 22.3875C144.424 24.3169 147.019 28.9051 151.204 30.9909C151.204 30.9909 154.223 32.9192 159.151 32.8601Z", fill: "url(#paint2_linear_33609_31043)" }), (0,jsx_runtime.jsx)("path", { d: "M151.814 10.7199C150.144 11.783 146.035 15.1047 144.511 22.762C144.511 22.762 141.047 17.2791 144.257 12.7225C144.257 12.7225 146.404 9.47632 151.69 10.1719C151.968 10.208 152.049 10.569 151.813 10.7199H151.814Z", fill: "url(#paint3_linear_33609_31043)" }), (0,jsx_runtime.jsx)("path", { d: "M60.2422 28.1719H64.6565V28.885H61.0507V31.4269H64.1912V32.14H61.0507V34.742H64.7511V35.4551H60.2422V28.1719V28.1719Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { d: "M65.6279 35.4553V30.3344H66.2978L66.3803 31.1295C66.7433 30.5509 67.3285 30.2305 68.0204 30.2305C68.7596 30.2305 69.3855 30.598 69.6572 31.2794C70.0422 30.6067 70.6967 30.2305 71.4931 30.2305C72.7251 30.2305 73.2916 31.123 73.2916 32.3545V35.4553H72.5018V32.4573C72.5018 31.5812 72.1762 30.9458 71.3105 30.9425C70.3755 30.9359 69.8508 31.6687 69.8508 32.5853V35.4542H69.0643V32.4562C69.0643 31.5801 68.7299 30.9414 67.873 30.9414C66.9468 30.9414 66.4166 31.683 66.4166 32.5842V35.4531H65.6301L65.6279 35.4553Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M76.9147 30.2295C76.1469 30.2295 75.4957 30.5664 75.0535 31.1789V31.1778L74.9677 30.3323H74.2979V37.7096L75.0876 37.5499V34.6756H75.0942C75.4957 35.2563 76.1634 35.5582 76.8894 35.5582C78.2292 35.5582 79.3545 34.6056 79.3545 32.8654C79.3545 31.1253 78.1632 30.2295 76.9147 30.2295ZM75.0601 32.9168C75.0601 31.7793 75.7388 30.9339 76.8102 30.9339L76.8091 30.935C77.8299 30.935 78.557 31.7137 78.557 32.8829C78.557 34.0521 77.8079 34.8527 76.8036 34.8527C75.7993 34.8527 75.0601 34.0543 75.0601 32.9168Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M82.623 30.2295C81.1248 30.2295 79.9775 31.3232 79.9775 32.9004H79.9786C79.9786 34.471 81.1061 35.5582 82.601 35.5582C84.0959 35.5582 85.2553 34.4535 85.2553 32.8785C85.2553 31.3035 84.1212 30.2295 82.623 30.2295ZM82.6197 30.9371C83.6713 30.9371 84.4523 31.7378 84.4523 32.8818H84.4512C84.4512 34.0379 83.6449 34.8582 82.5999 34.8582C81.5549 34.8582 80.7739 34.0543 80.7739 32.8949C80.7739 31.7356 81.5681 30.9371 82.6197 30.9371Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { d: "M86.2047 30.333L87.5951 34.4958L88.9635 30.333H89.7819L91.1315 34.4991L92.5879 30.333H93.3909L91.5198 35.4539H90.7146L89.3595 31.2813L87.979 35.4539H87.1705L85.3467 30.333H86.2058H86.2047Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M93.5586 32.932C93.5586 34.6284 94.7378 35.5581 96.1755 35.5581L96.1744 35.5592C96.9136 35.5592 97.6154 35.3142 98.1115 34.8964L97.7386 34.3845C97.2964 34.6897 96.7717 34.8712 96.2129 34.8712C95.1415 34.8712 94.4408 34.2084 94.3583 33.1431H98.491C98.4998 33.0709 98.513 32.9233 98.513 32.7756C98.513 31.3494 97.5197 30.2305 96.1018 30.2305C94.6839 30.2305 93.5586 31.2356 93.5586 32.932ZM96.1084 30.9173C97.1138 30.9173 97.6858 31.6841 97.7265 32.5328H94.3737C94.4716 31.602 95.1569 30.9173 96.1084 30.9173Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { d: "M99.3771 30.3334H100.047L100.135 31.1657H100.142C100.476 30.5434 100.95 30.2295 101.667 30.2295C101.876 30.2295 102.087 30.2546 102.28 30.3082L102.16 31.0345C101.99 30.9842 101.816 30.9557 101.632 30.9557C100.579 30.9557 100.162 31.8767 100.162 32.9124V35.4543H99.376V30.3334H99.3771Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M107.168 37.7114C108.671 37.7114 109.743 36.8375 109.743 35.2636L109.742 35.2658V30.3363H109.06L108.977 31.1654C108.563 30.5562 107.9 30.2324 107.148 30.2324C105.938 30.2324 104.699 31.1304 104.699 32.8115C104.699 34.4926 105.869 35.3971 107.124 35.3971C107.856 35.3971 108.555 35.0854 108.95 34.5013H108.956V35.0886C108.956 36.4646 108.175 37.0049 107.117 37.0049C106.525 37.0049 106.017 36.8321 105.54 36.4996L105.151 37.0268C105.717 37.4697 106.378 37.7114 107.168 37.7114ZM107.227 30.9368C108.258 30.9368 108.972 31.6915 108.972 32.8191V32.818C108.972 33.9304 108.304 34.6938 107.246 34.6938C106.188 34.6938 105.492 33.8812 105.492 32.8093C105.492 31.7374 106.196 30.9368 107.227 30.9368Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { d: "M110.861 30.3334H111.531L111.619 31.1657H111.626C111.96 30.5434 112.434 30.2295 113.152 30.2295C113.361 30.2295 113.572 30.2546 113.764 30.3082L113.644 31.0345C113.474 30.9842 113.3 30.9557 113.116 30.9557C112.065 30.9557 111.647 31.8767 111.647 32.9124V35.4543H110.86V30.3334H110.861Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M116.471 30.2295C114.972 30.2295 113.825 31.3232 113.825 32.9004H113.826C113.826 34.471 114.954 35.5582 116.449 35.5582C117.944 35.5582 119.103 34.4535 119.103 32.8785C119.103 31.3035 117.969 30.2295 116.471 30.2295ZM116.467 30.9371C117.519 30.9371 118.3 31.7378 118.3 32.8818H118.299C118.299 34.0379 117.493 34.8582 116.448 34.8582C115.403 34.8582 114.622 34.0543 114.622 32.8949C114.622 31.7356 115.416 30.9371 116.467 30.9371Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { d: "M119.997 30.333L121.387 34.4958L122.755 30.333H123.574L124.924 34.4991L126.38 30.333H127.183L125.312 35.4539H124.507L123.151 31.2813L121.771 35.4539H120.962L119.139 30.333H119.998H119.997Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { d: "M127.639 30.3328H128.599V28.6987L129.385 28.5391V30.3328H130.744V31.0153H129.385V33.5003C129.385 34.5503 129.819 34.745 130.561 34.9079L130.463 35.5587C129.525 35.527 128.599 35.037 128.599 33.8623V31.0164H127.639V30.3339V30.3328Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { d: "M135.276 35.4551V32.5359C135.276 31.5843 134.834 30.9423 133.886 30.9423C132.937 30.9423 132.202 31.5832 132.202 32.5074V35.454H131.415V27.9957L132.202 27.835V31.0932H132.208C132.625 30.5146 133.286 30.2292 134.041 30.2292C135.323 30.2292 136.063 31.0615 136.063 32.3532V35.454H135.276V35.4551Z", fill: "#005AFF" }), (0,jsx_runtime.jsx)("path", { d: "M114.477 12.6288C111.928 12.7229 109.846 14.9465 109.846 17.4828V24.1525H111.581V18.558C111.581 16.2699 112.502 14.2399 114.823 14.2399C115.016 14.2399 115.205 14.2541 115.39 14.2815C115.725 14.3307 116.039 14.1076 116.094 13.7751L116.253 12.8126C116.253 12.8126 115.449 12.5807 114.478 12.6299L114.477 12.6288Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { d: "M67.82 24.1531V17.5403C67.82 15.6065 67.0808 14.1989 65.1922 14.1989C63.1495 14.1989 61.978 15.8351 61.978 17.8247V24.1531H60.2422V14.0841C60.2422 13.4048 60.7955 12.8536 61.4797 12.8536H61.9021V14.3695C61.9021 14.4406 61.9934 14.4669 62.0341 14.4089C62.8415 13.2594 64.0746 12.625 65.52 12.625C67.1512 12.625 68.5317 13.4366 69.1312 14.9405C69.9815 13.4573 71.4247 12.625 73.1814 12.625C75.9006 12.625 77.148 14.5937 77.148 17.3106V24.152H75.4056V17.5392C75.4056 15.6055 74.6873 14.2055 72.7777 14.1978C70.7141 14.1836 69.5569 15.799 69.5569 17.8236V24.152H67.8211L67.82 24.1531Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { d: "M5.39657 22.2324L8.75705 13.6377C8.94185 13.1652 9.39945 12.8535 9.90984 12.8535H10.8481L6.24686 24.153H4.43407L0 12.8535H1.02959C1.54659 12.8535 2.00859 13.1729 2.18899 13.6552L5.39657 22.2324Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.4728 11.4844C14.1515 11.4844 14.7015 10.9376 14.7015 10.2627C14.7015 9.58789 14.1515 9.04102 13.4728 9.04102C12.7941 9.04102 12.2441 9.58789 12.2441 10.2627C12.2441 10.9376 12.7941 11.4844 13.4728 11.4844ZM12.6049 13.4685V24.1522V24.1533H14.3407V12.8538H13.2231C12.8821 12.8538 12.6049 13.1283 12.6049 13.4685Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M26.2674 22.9197C26.2676 22.9196 26.2678 22.9195 26.2679 22.9193V22.9204L26.2674 22.9197ZM21.9944 24.3816C23.6255 24.3816 25.173 23.8415 26.2674 22.9197L25.4451 21.7906C24.4694 22.4621 23.3122 22.8646 22.078 22.8646C19.7153 22.8646 18.1676 21.4012 17.9861 19.0518H26.3471C26.7915 19.0518 27.1534 18.6931 27.1534 18.2501V18.2403C27.1534 15.0925 24.9644 12.625 21.8338 12.625C18.7033 12.625 16.2217 14.8442 16.2217 18.587C16.2217 22.3298 18.8221 24.3816 21.9944 24.3816ZM21.8481 14.1431C24.0646 14.1431 25.3263 15.8351 25.4176 17.7065H18.0213C18.2369 15.6547 19.7494 14.1431 21.8481 14.1431Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { d: "M32.7856 14.3577H30.5736V19.8406C30.5736 22.1561 31.5284 22.5859 33.1673 22.9458L32.9517 24.3808C30.8816 24.3119 28.8389 23.2302 28.8389 20.638V10.3984C28.8389 9.81429 29.2525 9.31117 29.8278 9.19305L30.5747 9.04102V12.8538H33.5721V13.5768C33.5721 14.0077 33.2201 14.3577 32.7867 14.3577H32.7856Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { d: "M37.0809 12.8525V14.3859C37.0809 14.4548 37.1711 14.4855 37.2107 14.4286C38.0071 13.2911 39.5053 12.6261 41.1069 12.6294C41.1817 12.6294 41.2576 12.625 41.3324 12.625C44.1495 12.625 45.7247 14.4756 45.7247 17.3106V24.152H43.9812V17.5392C43.9812 15.5081 42.9637 14.1978 40.9628 14.1978C38.8156 14.1978 37.3449 15.7017 37.3449 17.782V24.152H35.6025V14.0808C35.6025 13.4016 36.1558 12.8503 36.84 12.8503H37.0809V12.8525Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M52.7632 12.625C51.3068 12.625 49.6964 12.9367 48.5249 13.7133L48.8329 14.3903C48.9693 14.6889 49.3191 14.8344 49.6238 14.7086C50.5126 14.3411 51.5169 14.1223 52.5399 14.1223C54.3801 14.1223 55.6627 14.8158 55.6627 16.8261V17.7623C54.7068 17.5753 53.6267 17.4156 52.5531 17.4156C49.2069 17.4156 47.5547 18.8375 47.5547 21.0479C47.5547 23.2584 49.3466 24.3816 51.5422 24.3816C53.4111 24.3816 55.0566 23.5427 55.7463 22.4195L55.7606 22.426C55.7606 23.8107 56.4151 24.2056 57.8957 24.3696L58.1025 23.0921C57.5382 22.8154 57.3776 22.2817 57.3776 21.2557V16.452C57.3776 13.908 55.7122 12.625 52.7632 12.625ZM49.2641 20.9637C49.2641 19.6403 50.3234 18.8079 52.7357 18.8079V18.809C53.8368 18.809 54.9389 18.9895 55.6638 19.135V20.0428C55.6638 21.7271 53.5585 22.9259 51.7248 22.9259C50.5258 22.9259 49.2641 22.4129 49.2641 20.9637Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { d: "M80.2449 12.8535L83.3128 22.0388L86.0529 13.7023C86.219 13.197 86.6931 12.8546 87.2288 12.8546H88.1374L91.1139 22.0464L94.3281 12.8546H96.0991L91.9719 24.1541H90.1943L87.2035 14.948L84.1565 24.1541H82.3723L78.3496 12.8546H80.246L80.2449 12.8535Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { d: "M124.485 23.7381L120.072 18.7802H119.563V24.1526H117.827V8.6171C117.827 8.03304 118.241 7.52992 118.816 7.4118L119.563 7.25977V17.2413H120.072L124.066 13.2196C124.298 12.9855 124.615 12.8543 124.946 12.8543H126.66L121.578 17.9774L127.071 24.1537H125.412C125.057 24.1537 124.72 24.0028 124.485 23.7392V23.7381Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { d: "M135.636 14.3883C135.473 14.6552 135.134 14.7591 134.849 14.6257C134.158 14.3019 133.343 14.1007 132.565 14.1007C131.401 14.1007 130.139 14.5371 130.139 15.7708C130.139 18.5019 136.392 17.0046 136.392 21.0525C136.392 23.3199 134.454 24.3797 132.104 24.3797C130.41 24.3797 129.17 23.8252 127.963 22.9589L128.467 22.2753C128.656 22.0194 129.008 21.9527 129.284 22.1124C130.103 22.5849 130.959 22.8758 131.984 22.8758C133.169 22.8758 134.654 22.4875 134.654 21.1564C134.654 18.4319 128.428 19.9708 128.428 15.8813C128.428 13.649 130.283 12.623 132.457 12.623C133.796 12.623 135.051 13.0113 136.054 13.6982L135.633 14.3873L135.636 14.3883Z", fill: "#001744" }), (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M102.341 12.625C99.0369 12.625 96.5059 15.0367 96.5059 18.517C96.5059 21.9831 98.994 24.3816 102.292 24.3816C105.59 24.3816 108.148 21.9415 108.148 18.4689C108.148 14.9962 105.646 12.625 102.341 12.625ZM102.334 14.1847C104.656 14.1847 106.377 15.9522 106.377 18.4754V18.4743C106.377 21.026 104.6 22.8351 102.292 22.8351C99.984 22.8351 98.2626 21.0599 98.2626 18.5028C98.2626 15.9456 100.012 14.1847 102.334 14.1847Z", fill: "#001744" }), (0,jsx_runtime.jsxs)("defs", { children: [(0,jsx_runtime.jsxs)("linearGradient", { id: "paint0_linear_33609_31043", x1: "150.198", y1: "10.6298", x2: "169.017", y2: "10.6298", gradientUnits: "userSpaceOnUse", children: [(0,jsx_runtime.jsx)("stop", { "stop-color": "#3CAAFF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.24", "stop-color": "#47B2FF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.68", "stop-color": "#67C9FF" }), (0,jsx_runtime.jsx)("stop", { offset: "1", "stop-color": "#82DCFF" })] }), (0,jsx_runtime.jsxs)("linearGradient", { id: "paint1_linear_33609_31043", x1: "170.378", y1: "1.12331", x2: "148.732", y2: "10.0474", gradientUnits: "userSpaceOnUse", children: [(0,jsx_runtime.jsx)("stop", { offset: "0.1", "stop-color": "#005AFF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.13", "stop-color": "#035EFF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.5", "stop-color": "#2287FF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.79", "stop-color": "#35A0FF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.96", "stop-color": "#3CAAFF" })] }), (0,jsx_runtime.jsxs)("linearGradient", { id: "paint2_linear_33609_31043", x1: "141.02", y1: "35.4548", x2: "158.094", y2: "35.4548", gradientUnits: "userSpaceOnUse", children: [(0,jsx_runtime.jsx)("stop", { "stop-color": "#82DCFF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.25", "stop-color": "#65C7FF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.57", "stop-color": "#47B2FF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.75", "stop-color": "#3CAAFF" })] }), (0,jsx_runtime.jsxs)("linearGradient", { id: "paint3_linear_33609_31043", x1: "143.396", y1: "26.6586", x2: "155.151", y2: "23.6608", gradientUnits: "userSpaceOnUse", children: [(0,jsx_runtime.jsx)("stop", { "stop-color": "#005AFF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.26", "stop-color": "#1272FF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.75", "stop-color": "#309AFF" }), (0,jsx_runtime.jsx)("stop", { offset: "1", "stop-color": "#3CAAFF" })] })] })] }) }), (0,jsx_runtime.jsxs)("h3", { children: [t('Sign in to'), (0,jsx_runtime.jsx)("br", {}), "VietnamWorks"] })] }), (0,jsx_runtime.jsxs)(ModalFormContent, { children: [(0,jsx_runtime.jsxs)(SocialLoginGroup, { children: [(0,jsx_runtime.jsxs)(Button/* default */.Z, { onClick: function () { return window.location.assign(buildSocialLink('google')); }, children: [(0,jsx_runtime.jsx)(GoogleLogoIcon$1, {}), " ", (0,jsx_runtime.jsx)("span", { children: t('with Google account') })] }), (0,jsx_runtime.jsxs)(Button/* default */.Z, { onClick: function () { return window.location.assign(buildSocialLink('facebook')); }, children: [(0,jsx_runtime.jsx)(FacebookLogoIcon$1, {}), " ", (0,jsx_runtime.jsx)("span", { children: t('with Facebook account') })] })] }), (0,jsx_runtime.jsxs)("div", { children: [(0,jsx_runtime.jsx)(SmallLabel, { children: t('Login with Email') }), (0,jsx_runtime.jsxs)(InputGroup, { children: [(0,jsx_runtime.jsxs)(LabelInput, { children: [t('Email'), (0,jsx_runtime.jsx)("span", { children: "*" })] }), (0,jsx_runtime.jsx)(Input/* default */.Z, { hasError: isUsernameError || apiError !== 'NONE', value: username, name: 'username', onChange: function (e) { return setUsername(e); }, onKeyUp: function (e) { return inputKeyUp(e, 'email'); }, autoFocus: true, disabled: isLoggingIn }), isUsernameError ? ((0,jsx_runtime.jsx)(ErrorMessage, { children: username.length === 0
                                                                    ? t('The Email field is required.')
                                                                    : t('The Email must be a valid Email address.') })) : null, renderErrorMessage()] }), (0,jsx_runtime.jsxs)(InputGroup, { children: [(0,jsx_runtime.jsxs)(LabelInput, { children: [t('Password'), (0,jsx_runtime.jsx)("span", { children: "*" })] }), (0,jsx_runtime.jsx)(Input/* default */.Z, { hasError: isPasswordError, value: password, type: 'password', icon: 'password', onChange: function (e) { return setPassword(e); }, onKeyUp: function (e) { return inputKeyUp(e, 'password'); }, disabled: isLoggingIn }), isPasswordError ? (0,jsx_runtime.jsx)(ErrorMessage, { children: t('The Password field is required.') }) : null] }), (0,jsx_runtime.jsx)(ForgotGroup, { children: (0,jsx_runtime.jsx)(ForgotPasswordLink, { href: getForgotPasswordUrl(modalLangCode === 'vi' ? Utils_constants/* ELanguage.VI */.Df.VI : Utils_constants/* ELanguage.EN */.Df.EN), children: t('Forgot Password?') }) })] })] })] }) })) : null] }) })), !useNewLoginModal && ((0,jsx_runtime.jsx)(Popup/* default */.Z, { isShow: isMounted, lang: modalLangCode === 'vi' ? Utils_constants/* ELanguage.VI */.Df.VI : Utils_constants/* ELanguage.EN */.Df.EN, text: {
                    header: t('Sign in to continue'),
                    primaryBtn: ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [isLoggingIn ? ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: (0,jsx_runtime.jsx)(LoadingIcon, { bgColor: '#fff' }) })) : null, ' ', t('Login')] }))
                }, option: {
                    isCloseOnClickBackdrop: true,
                    disabledPrimary: isLoginDisabled
                }, custom: {
                    leftFooterAlert: ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [t("Don't have an account yet?"), ' ', (0,jsx_runtime.jsx)(RegisterLink, (0,_tslib/* __assign */.pi)({ href: getRegisterUrl(modalLangCode === 'vi' ? Utils_constants/* ELanguage.VI */.Df.VI : Utils_constants/* ELanguage.EN */.Df.EN, utmTracking) }, (isRegisterOnNewTab
                                ? {
                                    target: '_blank'
                                }
                                : null), { children: t('Register now') }))] }))
                }, onClose: function () {
                    setIsClosing(true);
                    setMounted(false);
                    onCancelPopupRef.current && onCancelPopupRef.current();
                    // Reset after animation completes (250ms)
                    setTimeout(function () {
                        setSelectedPlatform('none');
                        setIsClosing(false);
                    }, 300);
                }, onClickPrimary: doLogin, children: (0,jsx_runtime.jsxs)(LoginModalContainerWrapper, { children: [(0,jsx_runtime.jsxs)(SocialLoginGroup, { children: [(0,jsx_runtime.jsxs)(Button/* default */.Z, { onClick: function () { return window.location.assign(buildSocialLink('google')); }, children: [(0,jsx_runtime.jsx)(GoogleLogoIcon$1, {}), " ", !isMobile() ? (0,jsx_runtime.jsx)("span", { children: t('with Google account') }) : null] }), (0,jsx_runtime.jsxs)(Button/* default */.Z, { onClick: function () { return window.location.assign(buildSocialLink('facebook')); }, children: [(0,jsx_runtime.jsx)(FacebookLogoIcon$1, {}), " ", !isMobile() ? (0,jsx_runtime.jsx)("span", { children: t('with Facebook account') }) : null] })] }), (0,jsx_runtime.jsx)(SmallLabel, { children: t('or with your email') }), (0,jsx_runtime.jsxs)(InputGroup, { children: [(0,jsx_runtime.jsxs)(LabelInput, { children: [t('Email'), (0,jsx_runtime.jsx)("span", { children: "*" })] }), (0,jsx_runtime.jsx)(Input/* default */.Z, { hasError: isUsernameError || apiError !== 'NONE', value: username, name: 'username', onChange: function (e) { return setUsername(e); }, onKeyUp: function (e) { return inputKeyUp(e, 'email'); }, autoFocus: true, disabled: isLoggingIn }), isUsernameError ? ((0,jsx_runtime.jsx)(ErrorMessage, { children: username.length === 0
                                        ? t('The Email field is required.')
                                        : t('The Email must be a valid Email address.') })) : null, renderErrorMessage()] }), (0,jsx_runtime.jsxs)(InputGroup, { children: [(0,jsx_runtime.jsxs)(LabelInput, { children: [t('Password'), (0,jsx_runtime.jsx)("span", { children: "*" })] }), (0,jsx_runtime.jsx)(Input/* default */.Z, { hasError: isPasswordError, value: password, type: 'password', icon: 'password', onChange: function (e) { return setPassword(e); }, onKeyUp: function (e) { return inputKeyUp(e, 'password'); }, disabled: isLoggingIn }), isPasswordError ? (0,jsx_runtime.jsx)(ErrorMessage, { children: t('The Password field is required.') }) : null] }), (0,jsx_runtime.jsx)(ForgotGroup, { children: (0,jsx_runtime.jsx)(ForgotPasswordLink, { href: getForgotPasswordUrl(modalLangCode === 'vi' ? Utils_constants/* ELanguage.VI */.Df.VI : Utils_constants/* ELanguage.EN */.Df.EN), children: t('Forgot Password?') }) })] }) }))] }));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 54129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": function() { return /* binding */ Footer; },
/* harmony export */   "Jk": function() { return /* binding */ PopupContentWrapper; },
/* harmony export */   "Ow": function() { return /* binding */ BackdropWrapper; },
/* harmony export */   "QF": function() { return /* binding */ CustomBody; },
/* harmony export */   "SM": function() { return /* binding */ PopupWrapper; },
/* harmony export */   "Wf": function() { return /* binding */ TopWrapper; },
/* harmony export */   "h4": function() { return /* binding */ Header; },
/* harmony export */   "pP": function() { return /* binding */ PopupContent; },
/* harmony export */   "sL": function() { return /* binding */ MoreFooterButton; },
/* harmony export */   "sg": function() { return /* binding */ Column; },
/* harmony export */   "uT": function() { return /* binding */ Body; },
/* harmony export */   "z": function() { return /* binding */ HeaderText; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74982);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
'use client';




var openPopup = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_1 || (templateObject_1 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n"], ["\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n"])));
var closePopup = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_2 || (templateObject_2 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n"], ["\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n"])));
var openResponsivePopup = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_3 || (templateObject_3 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    0% {\n        top: calc(100% + 15px);\n    }\n    100% {\n        top: 15px;\n    }\n"], ["\n    0% {\n        top: calc(100% + 15px);\n    }\n    100% {\n        top: 15px;\n    }\n"])));
var closeResponsivePopup = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_4 || (templateObject_4 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    0% {\n        top: 15px;\n    }\n    100% {\n        top: calc(100% + 15px);\n    }\n"], ["\n    0% {\n        top: 15px;\n    }\n    100% {\n        top: calc(100% + 15px);\n    }\n"])));
var animFooterOpenPopup = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_5 || (templateObject_5 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    0% {\n        bottom: -100%;\n    }\n    100% {\n        bottom: 0;\n    }\n"], ["\n    0% {\n        bottom: -100%;\n    }\n    100% {\n        bottom: 0;\n    }\n"])));
var animFooterClosePopup = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_6 || (templateObject_6 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    0% {\n        bottom: 0;\n    }\n    100% {\n        bottom: -100%;\n    }\n"], ["\n    0% {\n        bottom: 0;\n    }\n    100% {\n        bottom: -100%;\n    }\n"])));
var PopupWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_8 || (templateObject_8 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: 1099;\n    animation: ", " 0.25s ease-in-out forwards;\n    @media screen and (max-width: 768px) {\n        animation: ", " 0.4s ease forwards;\n    }\n    ", "\n    .w-100 {\n        width: 100%;\n    }\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n"], ["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: 1099;\n    animation: ", " 0.25s ease-in-out forwards;\n    @media screen and (max-width: 768px) {\n        animation: ", " 0.4s ease forwards;\n    }\n    ", "\n    .w-100 {\n        width: 100%;\n    }\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n"])), function (_a) {
    var isShow = _a.isShow;
    return (isShow ? openPopup : closePopup);
}, function (_a) {
    var isShow = _a.isShow;
    return (isShow ? openResponsivePopup : closeResponsivePopup);
}, function (_a) {
    var isDisplayNone = _a.isDisplayNone;
    if (!isDisplayNone) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_7 || (templateObject_7 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            display: none;\n        "], ["\n            display: none;\n        "])));
});
var BackdropWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_9 || (templateObject_9 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 1001;\n    ", "\n    display: ", ";\n"], ["\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 1001;\n    ", "\n    display: ", ";\n"])), function (_a) {
    var clickableBackdrop = _a.clickableBackdrop;
    return (clickableBackdrop ? 'cursor: pointer;' : '');
}, function (_a) {
    var isShowBackdrop = _a.isShowBackdrop;
    return (isShowBackdrop ? 'block' : 'none');
});
var PopupContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_10 || (templateObject_10 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    user-select: none;\n"], ["\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    user-select: none;\n"])));
var PopupContent = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_19 || (templateObject_19 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    height: auto;\n    background: #fff;\n    z-index: 1002;\n    transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n    overflow: visible;\n    border-radius: 12px;\n    max-height: 100%;\n    animation: ", " 0.25s ease-in-out forwards;\n    ", "\n    ", "\n    ", "\n"], ["\n    height: auto;\n    background: #fff;\n    z-index: 1002;\n    transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n    overflow: visible;\n    border-radius: 12px;\n    max-height: 100%;\n    animation: ", " 0.25s ease-in-out forwards;\n    ", "\n    ", "\n    ", "\n"])), function (_a) {
    var isShow = _a.isShow;
    return (isShow ? openPopup : closePopup);
}, function (_a) {
    var size = _a.size;
    switch (size) {
        case 'xxs':
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_11 || (templateObject_11 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                    width: 375px;\n                "], ["\n                    width: 375px;\n                "])));
        case 'xs':
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_12 || (templateObject_12 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                    width: 450px;\n                "], ["\n                    width: 450px;\n                "])));
        case 'sm':
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_13 || (templateObject_13 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                    width: 500px;\n                "], ["\n                    width: 500px;\n                "])));
        case 'lg':
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_14 || (templateObject_14 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                    width: 960px;\n                "], ["\n                    width: 960px;\n                "])));
        case 'md':
        default:
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_15 || (templateObject_15 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                    width: 700px;\n                "], ["\n                    width: 700px;\n                "])));
    }
}, function (_a) {
    var isFullScreenOnMobile = _a.isFullScreenOnMobile, isPopupCenter = _a.isPopupCenter;
    if (!isFullScreenOnMobile || isPopupCenter) {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_16 || (templateObject_16 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                margin: 16px;\n            "], ["\n                margin: 16px;\n            "])));
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_17 || (templateObject_17 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            @media screen and (max-width: 768px) {\n                width: 100%;\n                height: calc(100% - 32px);\n                display: flex;\n                flex-direction: column;\n                top: calc(50% + 15px);\n                animation: ", " 0.4s ease forwards;\n            }\n        "], ["\n            @media screen and (max-width: 768px) {\n                width: 100%;\n                height: calc(100% - 32px);\n                display: flex;\n                flex-direction: column;\n                top: calc(50% + 15px);\n                animation: ", " 0.4s ease forwards;\n            }\n        "])), function (_a) {
        var isShow = _a.isShow;
        return (isShow ? openResponsivePopup : closeResponsivePopup);
    });
}, function (_a) {
    var isHaveBorder = _a.isHaveBorder;
    if (!isHaveBorder) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_18 || (templateObject_18 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            border: 1px solid #ddd;\n        "], ["\n            border: 1px solid #ddd;\n        "])));
});
var Header = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_23 || (templateObject_23 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    border-bottom: ", ";\n    padding: 10px 14px 10px 24px;\n    display: flex;\n    justify-content: ", ";\n    align-items: center;\n    background: ", ";\n    border-radius: 10px 10px 0 0;\n\n    @media screen and (max-width: 768px) {\n        .popup-header-text {\n            padding-right: ", ";\n        }\n        justify-content: center;\n        height: 61px;\n        margin-bottom: -1px;\n        .close-btn {\n            position: absolute;\n            ", "\n        }\n    }\n    ", "\n"], ["\n    border-bottom: ", ";\n    padding: 10px 14px 10px 24px;\n    display: flex;\n    justify-content: ", ";\n    align-items: center;\n    background: ", ";\n    border-radius: 10px 10px 0 0;\n\n    @media screen and (max-width: 768px) {\n        .popup-header-text {\n            padding-right: ", ";\n        }\n        justify-content: center;\n        height: 61px;\n        margin-bottom: -1px;\n        .close-btn {\n            position: absolute;\n            ", "\n        }\n    }\n    ", "\n"])), function (_a) {
    var noBorderHeader = _a.noBorderHeader;
    return (noBorderHeader ? 'none' : '1px solid #efefef');
}, function (_a) {
    var isCenterTitle = _a.isCenterTitle;
    return (isCenterTitle ? 'center' : 'space-between');
}, function (_a) {
    var bgColor = _a.bgColor;
    return bgColor !== null && bgColor !== void 0 ? bgColor : '#fff';
}, function (_a) {
    var closeButtonPosition = _a.closeButtonPosition;
    return (closeButtonPosition === 'right' ? '30px' : '30px');
}, function (_a) {
    var closeButtonPosition = _a.closeButtonPosition;
    return closeButtonPosition === 'left'
        ? (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_20 || (templateObject_20 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                          left: 8px;\n                      "], ["\n                          left: 8px;\n                      "]))) : (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_21 || (templateObject_21 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                          right: 8px;\n                      "], ["\n                          right: 8px;\n                      "])));
}, function (_a) {
    var bgColor = _a.bgColor;
    if (bgColor === '#fff') {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_22 || (templateObject_22 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            .close-btn:hover {\n                svg {\n                    path {\n                        fill: ", ";\n                    }\n                }\n                background-color: rgba(174, 174, 174, 0.5); //colors.grey[70]\n            }\n        "], ["\n            .close-btn:hover {\n                svg {\n                    path {\n                        fill: ", ";\n                    }\n                }\n                background-color: rgba(174, 174, 174, 0.5); //colors.grey[70]\n            }\n        "])), function (_a) {
        var bgColor = _a.bgColor;
        return bgColor !== null && bgColor !== void 0 ? bgColor : '#888';
    });
});
var Body = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_24 || (templateObject_24 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    overflow-y: ", ";\n    padding: 16px;\n    height: auto;\n\n    //32px is padding top bottom\n    max-height: ", ";\n    z-index: 0; // prevent children elements from overflow footer if their z-index is set higher than 1\n    @media screen and (max-width: 768px) {\n        // position of footer is fixed by default on mobile, so we using a number = 90px replace for footer height\n        max-height: ", ";\n    }\n"], ["\n    overflow-y: ", ";\n    padding: 16px;\n    height: auto;\n\n    //32px is padding top bottom\n    max-height: ", ";\n    z-index: 0; // prevent children elements from overflow footer if their z-index is set higher than 1\n    @media screen and (max-width: 768px) {\n        // position of footer is fixed by default on mobile, so we using a number = 90px replace for footer height\n        max-height: ", ";\n    }\n"])), function (_a) {
    var overflow = _a.overflow;
    return overflow || 'auto';
}, function (_a) {
    var headerHeight = _a.headerHeight, footerHeight = _a.footerHeight;
    return "calc(100vh - ".concat(headerHeight !== null && headerHeight !== void 0 ? headerHeight : 0, "px - ").concat(footerHeight !== null && footerHeight !== void 0 ? footerHeight : 0, "px - 32px)");
}, function (_a) {
    var headerHeight = _a.headerHeight, additionalFooterHeight = _a.additionalFooterHeight;
    return "calc(100vh - ".concat(headerHeight !== null && headerHeight !== void 0 ? headerHeight : 0, "px - 72px - 32px - ").concat(additionalFooterHeight !== null && additionalFooterHeight !== void 0 ? additionalFooterHeight : 0, "px)");
});
var Column = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_25 || (templateObject_25 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    display: inline-flex;\n    width: 50%;\n    align-items: center;\n    &:first-child {\n        justify-content: left;\n    }\n    &:last-child {\n        justify-content: right;\n    }\n    &:only-child {\n        width: 100%;\n    }\n    > button {\n        margin: 0 4px;\n        &:first-child {\n            margin-right: 4px;\n            margin-left: 0;\n        }\n        &:last-child {\n            margin-left: 4px;\n            margin-right: 0;\n        }\n    }\n    @media screen and (max-width: 768px) {\n        &:first-child {\n            justify-content: center;\n        }\n        &:last-child {\n            justify-content: center;\n        }\n    }\n"], ["\n    display: inline-flex;\n    width: 50%;\n    align-items: center;\n    &:first-child {\n        justify-content: left;\n    }\n    &:last-child {\n        justify-content: right;\n    }\n    &:only-child {\n        width: 100%;\n    }\n    > button {\n        margin: 0 4px;\n        &:first-child {\n            margin-right: 4px;\n            margin-left: 0;\n        }\n        &:last-child {\n            margin-left: 4px;\n            margin-right: 0;\n        }\n    }\n    @media screen and (max-width: 768px) {\n        &:first-child {\n            justify-content: center;\n        }\n        &:last-child {\n            justify-content: center;\n        }\n    }\n"])));
var Footer = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_29 || (templateObject_29 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    padding: 24px;\n    display: flex;\n    background-color: #fff;\n    border-top: 1px solid #efefef;\n    border-radius: 0px 0 12px 12px;\n    position: relative;\n    > button {\n        &:nth-child(2) {\n            margin-left: 8px;\n        }\n    }\n    ", "\n\n    ", "\n\n    ", "\n"], ["\n    padding: 24px;\n    display: flex;\n    background-color: #fff;\n    border-top: 1px solid #efefef;\n    border-radius: 0px 0 12px 12px;\n    position: relative;\n    > button {\n        &:nth-child(2) {\n            margin-left: 8px;\n        }\n    }\n    ", "\n\n    ", "\n\n    ", "\n"])), function (_a) {
    var isFullScreenOnMobile = _a.isFullScreenOnMobile;
    if (!isFullScreenOnMobile) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_26 || (templateObject_26 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            @media screen and (max-width: 768px) {\n                width: 100%;\n                position: fixed;\n                bottom: 0;\n                left: 0;\n                height: ", "px;\n                display: flex;\n                flex-direction: column;\n                animation: ", " 0.25s ease-in-out\n                    forwards;\n                ", " {\n                    flex: 1;\n                    width: 100%;\n                    &:last-child {\n                        margin-top: 16px;\n                    }\n                    &:only-child {\n                        margin-top: 0;\n                    }\n                }\n                button {\n                    flex: 1;\n                }\n            }\n        "], ["\n            @media screen and (max-width: 768px) {\n                width: 100%;\n                position: fixed;\n                bottom: 0;\n                left: 0;\n                height: ", "px;\n                display: flex;\n                flex-direction: column;\n                animation: ", " 0.25s ease-in-out\n                    forwards;\n                ", " {\n                    flex: 1;\n                    width: 100%;\n                    &:last-child {\n                        margin-top: 16px;\n                    }\n                    &:only-child {\n                        margin-top: 0;\n                    }\n                }\n                button {\n                    flex: 1;\n                }\n            }\n        "])), function (_a) {
        var isHaveLeftFooter = _a.isHaveLeftFooter;
        return (isHaveLeftFooter ? 123 : 90);
    }, function (_a) {
        var isShow = _a.isShow;
        return (isShow ? animFooterOpenPopup : animFooterClosePopup);
    }, Column);
}, function (_a) {
    var isCenter = _a.isCenter;
    if (!isCenter) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_27 || (templateObject_27 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            text-align: center;\n        "], ["\n            text-align: center;\n        "])));
}, function (_a) {
    var isFooterButtonFullWidth = _a.isFooterButtonFullWidth;
    if (!isFooterButtonFullWidth) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_28 || (templateObject_28 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            ", " {\n                justify-content: center;\n                > button {\n                    width: 50%;\n                    &:only-child {\n                        width: 100%;\n                    }\n                }\n            }\n        "], ["\n            ", " {\n                justify-content: center;\n                > button {\n                    width: 50%;\n                    &:only-child {\n                        width: 100%;\n                    }\n                }\n            }\n        "])), Column);
});
var CustomBody = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_31 || (templateObject_31 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    overflow-y: ", ";\n    height: auto;\n\n    max-height: ", ";\n    @media screen and (max-width: 768px) {\n        height: ", ";\n        overflow-y: auto;\n        overflow-x: hidden;\n        ", "\n    }\n"], ["\n    overflow-y: ", ";\n    height: auto;\n\n    max-height: ", ";\n    @media screen and (max-width: 768px) {\n        height: ", ";\n        overflow-y: auto;\n        overflow-x: hidden;\n        ", "\n    }\n"])), function (_a) {
    var overflow = _a.overflow;
    return overflow || 'auto';
}, function (_a) {
    var headerHeight = _a.headerHeight, footerHeight = _a.footerHeight;
    return "calc(100dvh - ".concat(headerHeight !== null && headerHeight !== void 0 ? headerHeight : 0, "px - ").concat(footerHeight ? footerHeight + 30 : 0, "px )");
}, function (_a) {
    var responsiveHeight = _a.responsiveHeight;
    return responsiveHeight;
}, function (_a) {
    var isHaveLeftFooter = _a.isHaveLeftFooter;
    if (!isHaveLeftFooter) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_30 || (templateObject_30 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                height: calc(100vh - 200px);\n            "], ["\n                height: calc(100vh - 200px);\n            "])));
});
var HeaderText = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_32 || (templateObject_32 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    font-size: 18px;\n    font-weight: 600;\n    color: ", ";\n    line-height: 22px;\n"], ["\n    font-size: 18px;\n    font-weight: 600;\n    color: ", ";\n    line-height: 22px;\n"])), function (_a) {
    var textColor = _a.textColor;
    return textColor !== null && textColor !== void 0 ? textColor : '#333';
});
styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_36 || (templateObject_36 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    cursor: pointer;\n    display: ", ";\n    ", "\n"], ["\n    cursor: pointer;\n    display: ", ";\n    ", "\n"])), function (_a) {
    var isShowClose = _a.isShowClose;
    return (isShowClose ? 'block' : 'none');
}, function (_a) {
    var isHeaderCenter = _a.isHeaderCenter;
    if (!isHeaderCenter) {
        return '';
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_35 || (templateObject_35 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n            position: absolute;\n            padding: 15px;\n            top: 0;\n            ", "\n        "], ["\n            position: absolute;\n            padding: 15px;\n            top: 0;\n            ", "\n        "])), function (_a) {
        var btnPosition = _a.btnPosition;
        if (btnPosition === 'left') {
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_33 || (templateObject_33 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                        left: 0;\n                    "], ["\n                        left: 0;\n                    "])));
        }
        else {
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_34 || (templateObject_34 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n                        right: 0;\n                    "], ["\n                        right: 0;\n                    "])));
        }
    });
});
var MoreFooterButton = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_37 || (templateObject_37 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)([""], [""])));
var openWrapperResponsive = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_38 || (templateObject_38 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    0% {\n        translate: 0 0;\n        scale: 1;\n    }\n    100% {\n        translate: 0 -42px;\n        scale: 0.9;\n    }\n"], ["\n    0% {\n        translate: 0 0;\n        scale: 1;\n    }\n    100% {\n        translate: 0 -42px;\n        scale: 0.9;\n    }\n"])));
var closeWrapperResponsive = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(templateObject_39 || (templateObject_39 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    0% {\n        translate: 0 -42px;\n        scale: 0.9;\n    }\n    100% {\n        translate: 0 0;\n        scale: 1;\n    }\n"], ["\n    0% {\n        translate: 0 -42px;\n        scale: 0.9;\n    }\n    100% {\n        translate: 0 0;\n        scale: 1;\n    }\n"])));
var TopWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(templateObject_40 || (templateObject_40 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__makeTemplateObject */ .cy)(["\n    @media screen and (max-width: 768px) {\n        width: 100vw;\n        position: fixed;\n        z-index: 10;\n        top: ", ";\n        left: 0;\n        height: 100vh;\n        border-top: 16px solid #000;\n        transition: 0.4s ease;\n        &::before {\n            content: ' ';\n            height: calc(100vh + 50px);\n            width: 100vw;\n            display: block;\n            position: absolute;\n            top: 0;\n            left: 0;\n            box-shadow: 0 0 0 150px #000;\n            border-radius: 12px;\n            transition: 0.4s ease;\n            animation: ", " 0.4s ease forwards;\n        }\n    }\n"], ["\n    @media screen and (max-width: 768px) {\n        width: 100vw;\n        position: fixed;\n        z-index: 10;\n        top: ", ";\n        left: 0;\n        height: 100vh;\n        border-top: 16px solid #000;\n        transition: 0.4s ease;\n        &::before {\n            content: ' ';\n            height: calc(100vh + 50px);\n            width: 100vw;\n            display: block;\n            position: absolute;\n            top: 0;\n            left: 0;\n            box-shadow: 0 0 0 150px #000;\n            border-radius: 12px;\n            transition: 0.4s ease;\n            animation: ", " 0.4s ease forwards;\n        }\n    }\n"])), function (_a) {
    var isShow = _a.isShow;
    return (isShow ? 0 : '-16px');
}, function (_a) {
    var isShow = _a.isShow;
    return (isShow ? openWrapperResponsive : closeWrapperResponsive);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40;


//# sourceMappingURL=Popup.css.js.map


/***/ }),

/***/ 4835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Popup; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(74982);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(25035);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Images/CloseIcon/index.js
var CloseIcon = __webpack_require__(18700);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Popup/Popup.css.js
var Popup_css = __webpack_require__(54129);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Popup/translation.js
'use client';

var translations = {
    Yes: 'Đồng ý',
    No: 'Không',
    Cancel: 'Huỷ',
    Alert: 'Thông báo'
};


//# sourceMappingURL=translation.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Popup/constants.js
'use client';

var DEFAULT_STYLE_OPTION = {
    primaryBtnStyle: 'primary',
    secondaryBtnStyle: 'default',
    primaryBtnOutline: 'solid',
    secondaryBtnOutline: 'solid',
    size: 'md',
    isCenterTitle: false,
    closeButtonPosition: 'right',
    className: '',
    bodyDivQuerySelector: '',
    isPushViewBehind: false,
    isFooterButtonFullWidth: false,
    headerBg: '#fff',
    closeIconColor: '#888',
    headerTextColor: '#333',
    isHaveBorder: true,
    primaryBtnWidth: '',
    isDisplayNone: false
};
var DEFAULT_OPTION = {
    isShowBackdrop: true,
    isCloseOnClickBackdrop: true,
    isShowClose: true,
    isFullScreenOnMobile: true,
    isShowSecondaryButton: true,
    isShowPrimaryButton: true,
    isCenterFooter: false,
    isReverseAction: false
};
var DEFAULT_HEIGHT_FIX = 135;


//# sourceMappingURL=constants.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Utils/responsiveHelper.js
var responsiveHelper = __webpack_require__(53417);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useIsomorphicLayoutEffect.js
var useIsomorphicLayoutEffect = __webpack_require__(57767);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useScrollLock.js
'use client';




var IS_SERVER = typeof window === 'undefined';
var lockCount = 0;
var savedStyle = null;
var applyLockStyles = function (element, widthReflow) {
    savedStyle = {
        overflow: element.style.overflow,
        paddingRight: element.style.paddingRight
    };
    if (widthReflow) {
        var offsetWidth = element === document.body ? window.innerWidth : element.offsetWidth;
        var currentPaddingRight = parseInt(window.getComputedStyle(element).paddingRight, 10) || 0;
        var scrollbarWidth = offsetWidth - element.scrollWidth;
        element.style.paddingRight = "".concat(scrollbarWidth + currentPaddingRight, "px");
    }
    element.style.overflow = 'hidden';
};
var applyUnlockStyles = function (element, mode, widthReflow) {
    if (mode === 'soft' && savedStyle) {
        element.style.overflow = savedStyle.overflow;
        element.style.paddingRight = savedStyle.paddingRight;
    }
    else {
        element.style.overflow = '';
        if (widthReflow) {
            element.style.paddingRight = '';
        }
    }
    savedStyle = null;
};
function useScrollLock(options) {
    if (options === void 0) { options = {}; }
    var _a = options.autoLock, autoLock = _a === void 0 ? true : _a, lockTarget = options.lockTarget, _b = options.widthReflow, widthReflow = _b === void 0 ? true : _b;
    var _c = (0,react.useState)(false), isLocked = _c[0], setIsLocked = _c[1];
    var target = (0,react.useRef)(null);
    var isLockOwner = (0,react.useRef)(false);
    var lock = (0,react.useCallback)(function () {
        if (!target.current || isLockOwner.current) {
            return;
        }
        if (lockCount === 0) {
            applyLockStyles(target.current, widthReflow);
        }
        lockCount++;
        isLockOwner.current = true;
        setIsLocked(true);
    }, [widthReflow]);
    var unlock = (0,react.useCallback)(function (mode) {
        if (mode === void 0) { mode = 'hard'; }
        if (!target.current || !isLockOwner.current) {
            return;
        }
        lockCount = Math.max(0, lockCount - 1);
        isLockOwner.current = false;
        setIsLocked(false);
        if (lockCount === 0) {
            applyUnlockStyles(target.current, mode, widthReflow);
        }
    }, [widthReflow]);
    (0,useIsomorphicLayoutEffect/* default */.Z)(function () {
        if (IS_SERVER)
            return;
        if (lockTarget) {
            target.current = typeof lockTarget === 'string' ? document.querySelector(lockTarget) : lockTarget;
        }
        if (!target.current) {
            target.current = document.body;
        }
        if (autoLock) {
            lock();
        }
        return function () {
            if (isLockOwner.current) {
                unlock('hard');
            }
        };
    }, [autoLock, lockTarget, lock, unlock]);
    return { isLocked: isLocked, lock: lock, unlock: unlock };
}


//# sourceMappingURL=useScrollLock.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Popup/index.js
'use client';
















var Popup = function (props) {
    var _a;
    var isShow = props.isShow, _b = props.custom, custom = _b === void 0 ? null : _b, children = props.children, _c = props.text, text = _c === void 0 ? null : _c, lang = props.lang, styleOption = props.styleOption, option = props.option, onClickPrimary = props.onClickPrimary, onClickOutside = props.onClickOutside, onClose = props.onClose, _d = props.className, className = _d === void 0 ? '' : _d, customActionPopup = props.customActionPopup;
    var mergedStyleOption = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, DEFAULT_STYLE_OPTION), styleOption);
    var mergedOption = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, DEFAULT_OPTION), option);
    var bodyOverflow = (custom === null || custom === void 0 ? void 0 : custom.bodyOverflow) || 'auto';
    var bodyNode = typeof document !== 'undefined' ? document === null || document === void 0 ? void 0 : document.querySelector('body') : null;
    var _e = (0,react.useState)(), headerHeight = _e[0], setHeaderHeight = _e[1];
    var _f = (0,react.useState)(), footerHeight = _f[0], setFooterHeight = _f[1];
    var customRef = (0,react.useCallback)(function (node, ref) {
        if (node === null)
            return;
        switch (ref) {
            case 'header':
                setHeaderHeight(node.clientHeight);
                break;
            case 'footer':
                setFooterHeight(node.clientHeight);
                break;
        }
    }, []);
    /*
     * when toggle popup, it add and remove overflow: hidden on body tag.
     * On ios device, this action make header on mobile flickering when scroll up and doww.
     * So we must delay the close popup state to fix this bug
     * */
    var _g = customActionPopup || {}, _h = _g.enable, enableCustomPopup = _h === void 0 ? false : _h, actionCustomPopupAfterShow = _g.actionCustomPopupAfterShow, _j = _g.delayTime, delayTime = _j === void 0 ? 100 : _j;
    var _k = (0,react.useState)(isShow), customActionPopupState = _k[0], setCustomActionPopupState = _k[1];
    var _l = (0,react.useState)(false), isMounted = _l[0], setMounted = _l[1];
    var _m = useScrollLock({
        autoLock: (custom === null || custom === void 0 ? void 0 : custom.autoLockScroll) || false,
        lockTarget: custom === null || custom === void 0 ? void 0 : custom.lockTarget
    }), lock = _m.lock, unlock = _m.unlock;
    var isInMobile = (0,responsiveHelper/* isMobile */.tq)();
    var getPopupState = (0,react.useMemo)(function () {
        if (enableCustomPopup) {
            return customActionPopupState;
        }
        return isShow;
    }, [enableCustomPopup, isShow, customActionPopupState]);
    var updatePushView = function () {
        // Is in mobile and option isPushViewBehind true
        if (!isInMobile) {
            return;
        }
        if (!mergedStyleOption.isPushViewBehind) {
            return;
        }
        // Make sure it will not action when bodyDiv element was not exist
        if (!mergedStyleOption.bodyDivQuerySelector || mergedStyleOption.bodyDivQuerySelector === '') {
            return;
        }
        var rootElement = document.querySelector(mergedStyleOption.bodyDivQuerySelector);
        if (bodyNode === null || rootElement === null) {
            return;
        }
        bodyNode.style.backgroundColor = '#000';
        rootElement.style.transition = '0.4s ease';
        rootElement.style.transform = "translate(0, ".concat(window.scrollY < DEFAULT_HEIGHT_FIX ? "-".concat(DEFAULT_HEIGHT_FIX - window.scrollY, "px") : 0, ") scale(0.9)");
        rootElement.style.borderRadius = '12px';
        rootElement.style.backgroundColor = '#fff';
    };
    (0,react.useEffect)(function () {
        setCustomActionPopupState(isShow);
        if (!isShow) {
            return;
        }
        setMounted(isShow);
        lock();
        return function () {
            var _a;
            unlock((_a = props.custom) === null || _a === void 0 ? void 0 : _a.scrollLockMode);
        };
    }, [isShow, lock, unlock, (_a = props.custom) === null || _a === void 0 ? void 0 : _a.scrollLockMode]);
    (0,react.useEffect)(function () {
        if (!enableCustomPopup) {
            return;
        }
        if (!isShow) {
            setTimeout(function () {
                setCustomActionPopupState(false);
                actionCustomPopupAfterShow && actionCustomPopupAfterShow();
            }, delayTime);
            return;
        }
        setCustomActionPopupState(isShow);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enableCustomPopup, delayTime, isShow]);
    (0,react.useEffect)(function () {
        if (!bodyNode) {
            return;
        }
        var resetBodyPopupPush = function () {
            if (!isInMobile) {
                return;
            }
            if (!mergedStyleOption.isPushViewBehind) {
                return;
            }
            // Make sure it will not action when bodyDiv element was not exist
            if (!mergedStyleOption.bodyDivQuerySelector || mergedStyleOption.bodyDivQuerySelector === '') {
                return;
            }
            var rootElement = document.querySelector(mergedStyleOption.bodyDivQuerySelector);
            if (rootElement === null) {
                return;
            }
            rootElement.style.transform = 'initial';
        };
        // lock scrolling on body
        if (isShow) {
            updatePushView();
        }
        else {
            resetBodyPopupPush();
        }
        // Component will unmount
        return function () {
            resetBodyPopupPush();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bodyNode, isInMobile, isShow]);
    if (!bodyNode) {
        return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    if (!isMounted) {
        return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var t = function (text) {
        if (lang === 'en') {
            return text;
        }
        else {
            return translations[text];
        }
    };
    var doClosePopup = function () {
        if (enableCustomPopup) {
            setCustomActionPopupState(false);
        }
        onClose && onClose();
    };
    var handleOnClickSecondary = function () {
        if (mergedOption.isReverseAction) {
            onClickPrimary && onClickPrimary();
            return;
        }
        doClosePopup();
    };
    var handleOnClickPrimary = function () {
        if (mergedOption.isReverseAction) {
            doClosePopup();
            return;
        }
        onClickPrimary && onClickPrimary();
    };
    var handleOnClickBackdrop = function () {
        onClickOutside && onClickOutside();
        if (mergedOption.isCloseOnClickBackdrop) {
            doClosePopup();
        }
    };
    var onAnimationEndClosePushView = function () {
        if (!isInMobile) {
            return;
        }
        if (!mergedStyleOption.isPushViewBehind) {
            return;
        }
        // Make sure it will not action when bodyDiv element was not exist
        if (!mergedStyleOption.bodyDivQuerySelector || mergedStyleOption.bodyDivQuerySelector === '') {
            return;
        }
        var rootElement = document.querySelector(mergedStyleOption.bodyDivQuerySelector);
        if (bodyNode === null || rootElement === null) {
            return;
        }
        rootElement.style.overflow = 'initial';
        rootElement.style.height = 'initial';
        rootElement.style.borderRadius = 'initial';
        bodyNode.style.backgroundColor = 'initial';
    };
    var onAnimationEnd = function () {
        if (getPopupState) {
            return;
        }
        onAnimationEndClosePushView();
        setMounted(false);
    };
    var calculateBodyHeight = function () {
        var _a;
        if (typeof window === 'undefined') {
            return "100vh";
        }
        if (custom === null || custom === void 0 ? void 0 : custom.isPopupCenter) {
            return '';
        }
        var height = window.innerHeight;
        var headerHeight = 61;
        var footerHeight = 90;
        var additionalFooterHeight = (_a = custom === null || custom === void 0 ? void 0 : custom.additionalFooterHeight) !== null && _a !== void 0 ? _a : 0;
        var isHaveCustomFooter = (custom === null || custom === void 0 ? void 0 : custom.footer) !== undefined;
        if (isHaveCustomFooter) {
            footerHeight = 0;
        }
        if (!isHaveCustomFooter && (custom === null || custom === void 0 ? void 0 : custom.leftFooterAlert)) {
            footerHeight = 123;
        }
        // Calculate body height by removed all other element height
        // 34px is margin-top pixel of main popup
        return "".concat(height - headerHeight - footerHeight - 34 - additionalFooterHeight, "px");
    };
    /**
     * Render
     */
    var renderHeader = function () {
        return ((0,jsx_runtime.jsx)("div", { ref: function (node) { return customRef(node, 'header'); }, children: (custom === null || custom === void 0 ? void 0 : custom.header) !== undefined ? (custom.header) : ((0,jsx_runtime.jsxs)(Popup_css/* Header */.h4, { isCenterTitle: mergedStyleOption.isCenterTitle, bgColor: mergedStyleOption.headerBg, noBorderHeader: mergedStyleOption.noBorderHeader, closeButtonPosition: mergedStyleOption.closeButtonPosition, children: [(0,jsx_runtime.jsx)(Popup_css/* HeaderText */.z, { className: "popup-header-text".concat((text === null || text === void 0 ? void 0 : text.class) ? " ".concat(text.class) : ''), textColor: mergedStyleOption.headerTextColor, children: text === null || text.header === undefined ? t('Alert') : text.header }), mergedOption.isShowClose ? ((0,jsx_runtime.jsx)(Button/* default */.Z, { className: 'close-btn', isRounded: true, isIcon: true, type: 'transparent', onClick: function () { return doClosePopup(); }, children: (0,jsx_runtime.jsx)(CloseIcon/* default */.Z, { fill: mergedStyleOption.closeIconColor }) })) : null] })) }));
    };
    var renderFooter = function () {
        var primaryBtnStyle = {};
        if (mergedOption.isShowPrimaryButton && mergedStyleOption.primaryBtnWidth !== '') {
            primaryBtnStyle = {
                width: mergedStyleOption.primaryBtnWidth
            };
        }
        return ((0,jsx_runtime.jsx)("div", { ref: function (node) { return customRef(node, 'footer'); }, children: (custom === null || custom === void 0 ? void 0 : custom.footer) !== undefined ? (custom.footer) : ((0,jsx_runtime.jsxs)(Popup_css/* Footer */.$_, { isShow: getPopupState, isFullScreenOnMobile: mergedOption.isFullScreenOnMobile, isCenter: mergedOption.isCenterFooter, isHaveLeftFooter: !!(custom === null || custom === void 0 ? void 0 : custom.leftFooterAlert), isFooterButtonFullWidth: mergedStyleOption.isFooterButtonFullWidth, children: [(custom === null || custom === void 0 ? void 0 : custom.leftFooterAlert) ? (0,jsx_runtime.jsx)(Popup_css/* Column */.sg, { children: custom === null || custom === void 0 ? void 0 : custom.leftFooterAlert }) : null, (0,jsx_runtime.jsxs)(Popup_css/* Column */.sg, { children: [(custom === null || custom === void 0 ? void 0 : custom.footerButtons) !== undefined
                                ? custom === null || custom === void 0 ? void 0 : custom.footerButtons.map(function (item, index) {
                                    return (0,jsx_runtime.jsx)(Popup_css/* MoreFooterButton */.sL, { children: item }, "footer-button-".concat(index));
                                })
                                : null, mergedOption.isShowSecondaryButton && ((0,jsx_runtime.jsx)(Button/* default */.Z, { type: mergedStyleOption.secondaryBtnStyle, outline: mergedStyleOption.secondaryBtnOutline, onClick: handleOnClickSecondary, children: text === null || text.secondaryBtn === undefined ? t('Cancel') : text.secondaryBtn })), mergedOption.isShowPrimaryButton && ((0,jsx_runtime.jsx)(Button/* default */.Z, { disabled: (option === null || option === void 0 ? void 0 : option.disabledPrimary) || false, type: mergedStyleOption.primaryBtnStyle, outline: mergedStyleOption.primaryBtnOutline, onClick: handleOnClickPrimary, style: primaryBtnStyle, children: text === null || text.primaryBtn === undefined ? t('Yes') : text.primaryBtn }))] })] })) }));
    };
    var renderCustom = function () {
        var _a;
        var bodyHeight = calculateBodyHeight();
        return ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [renderHeader(), (custom === null || custom === void 0 ? void 0 : custom.withDefaultBody) ? ((0,jsx_runtime.jsx)(Popup_css/* Body */.uT, { className: custom === null || custom === void 0 ? void 0 : custom.bodyClass, overflow: bodyOverflow, responsiveHeight: bodyHeight, headerHeight: headerHeight || null, footerHeight: footerHeight || null, additionalFooterHeight: (_a = custom === null || custom === void 0 ? void 0 : custom.additionalFooterHeight) !== null && _a !== void 0 ? _a : 0, children: children })) : ((0,jsx_runtime.jsx)(Popup_css/* CustomBody */.QF, { className: custom === null || custom === void 0 ? void 0 : custom.bodyClass, overflow: bodyOverflow, isHaveLeftFooter: !!(custom === null || custom === void 0 ? void 0 : custom.leftFooterAlert), responsiveHeight: bodyHeight, headerHeight: headerHeight || null, footerHeight: footerHeight || null, children: children })), renderFooter()] }));
    };
    var renderPopupDefault = function () {
        var bodyHeight = calculateBodyHeight();
        return ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [renderHeader(), (0,jsx_runtime.jsx)(Popup_css/* Body */.uT, { className: custom === null || custom === void 0 ? void 0 : custom.bodyClass, overflow: bodyOverflow, responsiveHeight: bodyHeight, headerHeight: headerHeight || null, footerHeight: footerHeight || null, children: children }), renderFooter()] }));
    };
    return (0,react_dom.createPortal)((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [(0,jsx_runtime.jsxs)(Popup_css/* PopupWrapper */.SM, { className: className, isShow: getPopupState, isDisplayNone: mergedStyleOption.isDisplayNone, children: [(0,jsx_runtime.jsx)(Popup_css/* BackdropWrapper */.Ow, { isShowBackdrop: mergedOption.isShowBackdrop, onClick: handleOnClickBackdrop, clickableBackdrop: mergedOption.isCloseOnClickBackdrop }), (0,jsx_runtime.jsx)(Popup_css/* PopupContentWrapper */.Jk, { children: (0,jsx_runtime.jsx)(Popup_css/* PopupContent */.pP, { isShow: getPopupState, className: "vnw-popup-content ".concat(mergedStyleOption.className), size: mergedStyleOption.size, isFullScreenOnMobile: mergedOption.isFullScreenOnMobile, onAnimationEnd: onAnimationEnd, isHaveBorder: mergedStyleOption.isHaveBorder, isPopupCenter: custom === null || custom === void 0 ? void 0 : custom.isPopupCenter, children: custom !== null ? renderCustom() : renderPopupDefault() }) })] }), mergedStyleOption.isPushViewBehind && (0,react_dom.createPortal)((0,jsx_runtime.jsx)(Popup_css/* TopWrapper */.Wf, { isShow: getPopupState }), bodyNode)] }), bodyNode);
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 77091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PopupNewUser; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(74982);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/PopupNewUser/PopupNewUser.css.js
'use client';




var generalStyled = "\n    position:fixed;\n    bottom: 0;\n    left:0;\n    right:0;\n    width: 100%;\n    transition:all .3s;\n    z-index:201;\n";
var ratingStart = "\n    .app-rating{\n        display: flex;\n        align-items: center;\n        svg{\n            &:not(:first-child){\n                margin-left:5px;\n            }\n        }\n        .app-score{\n            color:#757575;\n            font-size:13px;\n            margin-left:5px;\n        }\n    }\n";
var downloadBtn = "\n        display: flex;\n        color: white;\n        border-radius: 5px;\n        text-align: center;\n        width: 100%;\n        border: 1px solid #ff7d55;\n        transition:all .3s;\n        cursor:pointer;\n        &:focus{\n            outline:none;\n        }\n";
var vnwLogo = "\n    background:#005AFF;\n    border-radius:10px;\n    padding:5px;\n";
var returnNMinimum = "\n    display:flex;\n    align-items: center;\n    transition:all .3s;\n    .content-popup{\n        margin-left:12px;\n        margin-bottom:0;\n        .app-title{\n            font-weight:600;\n        }\n        .app-brief{\n            color:#8a8a8a;\n            font-size:12px;\n        }\n    }\n        .download-btn{\n            margin-left:auto;\n            ".concat(downloadBtn, "\n            width:93px;\n            height:37px;\n            border-radius:5px;\n            font-weight:600;\n            font-size:14px;\n            padding:0;\n        }\n");
var NewPopup = styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    transition: 0.3s;\n    color: black;\n    padding: 25px 15px 15px;\n    z-index: 201;\n    background: #fff;\n    position: absolute;\n    top: 50%;\n    width: 90%;\n    left: 0;\n    transform: translateX(-50%) translateY(-50%);\n    left: 50%;\n    border-radius: 15px;\n    .title {\n        margin-bottom: 15px;\n        font-size: 17px;\n        padding: 0 15px 0 5px;\n        font-weight: 600;\n        position: relative;\n        line-height: 1.5;\n    }\n    .popup-close-btn {\n        position: absolute;\n        top: 8px;\n        right: 8px;\n        width: 32px;\n        height: 32px;\n        border: none;\n        background: transparent;\n        border-radius: 16px;\n        padding: 0;\n        cursor: pointer;\n        z-index: 2;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        &:focus {\n            outline: none;\n        }\n    }\n\n    .download-btn {\n        padding: 15px 0;\n        font-size: 17px;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        border-top: 1px solid rgba(225, 226, 226, 1);\n    }\n\n    .download-btn-content {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n    }\n\n    .download-btn-text {\n        font-size: 14px;\n        margin-left: 15px;\n    }\n\n    .popup-item-text {\n        font-size: 14px;\n        font-weight: 600;\n        margin-bottom: 15px;\n    }\n    \n    .popup-item-download {\n        padding: 15px;\n        background: rgba(244, 244, 247, 1);\n        border-radius: 16px;\n        margin-top: 15px;\n    }\n\n    .popup-title {\n        font-size: 18px;\n        font-weight: 600;\n        text-align: center;\n        padding: 0 24px;\n    }\n"], ["\n    transition: 0.3s;\n    color: black;\n    padding: 25px 15px 15px;\n    z-index: 201;\n    background: #fff;\n    position: absolute;\n    top: 50%;\n    width: 90%;\n    left: 0;\n    transform: translateX(-50%) translateY(-50%);\n    left: 50%;\n    border-radius: 15px;\n    .title {\n        margin-bottom: 15px;\n        font-size: 17px;\n        padding: 0 15px 0 5px;\n        font-weight: 600;\n        position: relative;\n        line-height: 1.5;\n    }\n    .popup-close-btn {\n        position: absolute;\n        top: 8px;\n        right: 8px;\n        width: 32px;\n        height: 32px;\n        border: none;\n        background: transparent;\n        border-radius: 16px;\n        padding: 0;\n        cursor: pointer;\n        z-index: 2;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        &:focus {\n            outline: none;\n        }\n    }\n\n    .download-btn {\n        padding: 15px 0;\n        font-size: 17px;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        border-top: 1px solid rgba(225, 226, 226, 1);\n    }\n\n    .download-btn-content {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n    }\n\n    .download-btn-text {\n        font-size: 14px;\n        margin-left: 15px;\n    }\n\n    .popup-item-text {\n        font-size: 14px;\n        font-weight: 600;\n        margin-bottom: 15px;\n    }\n    \n    .popup-item-download {\n        padding: 15px;\n        background: rgba(244, 244, 247, 1);\n        border-radius: 16px;\n        margin-top: 15px;\n    }\n\n    .popup-title {\n        font-size: 18px;\n        font-weight: 600;\n        text-align: center;\n        padding: 0 24px;\n    }\n"])));
var MinimumPopup = styled_components_browser_esm/* default.div */.ZP.div(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", ";\n    background: #f8f8f8;\n    .filter-close {\n        width: 25px;\n        height: 25px;\n        position: absolute;\n        top: 3px;\n        right: 7px;\n        z-index: 1;\n        cursor: pointer;\n    }\n\n    .wrap-content-minimum {\n        ", ";\n        padding: 25px 12px 15px 15px;\n        height: 93px;\n        align-items: center;\n        .logo {\n            ", ";\n        }\n        ", ";\n        .download-btn {\n            margin-top: 5px;\n            cursor: pointer;\n            font-size: 14px;\n            padding: 0;\n        }\n    }\n"], ["\n    ", ";\n    background: #f8f8f8;\n    .filter-close {\n        width: 25px;\n        height: 25px;\n        position: absolute;\n        top: 3px;\n        right: 7px;\n        z-index: 1;\n        cursor: pointer;\n    }\n\n    .wrap-content-minimum {\n        ", ";\n        padding: 25px 12px 15px 15px;\n        height: 93px;\n        align-items: center;\n        .logo {\n            ", ";\n        }\n        ", ";\n        .download-btn {\n            margin-top: 5px;\n            cursor: pointer;\n            font-size: 14px;\n            padding: 0;\n        }\n    }\n"])), generalStyled, returnNMinimum, vnwLogo, ratingStart);
var PopupOverlay = styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: fixed;\n    width: ", ";\n    height: 100%;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.3);\n    z-index: 200;\n    cursor: pointer;\n    opacity: ", ";\n    transition: opacity 0.3s;\n"], ["\n    position: fixed;\n    width: ", ";\n    height: 100%;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.3);\n    z-index: 200;\n    cursor: pointer;\n    opacity: ", ";\n    transition: opacity 0.3s;\n"])), function (props) { return (props.active ? '100%' : '0'); }, function (props) { return (props.active ? '1' : '0'); });
var templateObject_1, templateObject_2, templateObject_3;


//# sourceMappingURL=PopupNewUser.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/PopupNewUser/vi.js
'use client';

var vi = {
    'Job Search and Recruitment': 'Việc Làm và Tuyển Dụng',
    "Experience VietnamWorks - Vietnam's largest job search application": 'Trải nghiệm VietnamWorks - Ứng dụng tìm việc làm lớn nhất Việt Nam',
    'Install Application': 'Cài Đặt Ứng Dụng',
    Install: 'Cài Đặt',
    'Open App': 'Mở App'
};


//# sourceMappingURL=vi.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/PostHog/hooks/useHog/index.js
var useHog = __webpack_require__(20560);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/PopupNewUser/index.js
'use client';











var hasLocalStorage = !!(typeof window !== 'undefined' && window.localStorage);
if (typeof window !== 'undefined') {
    window.opera = window.opera || {};
    window._gaq = window._gaq || [];
}
var ETypePopup;
(function (ETypePopup) {
    ETypePopup["New"] = "new";
    ETypePopup["Return"] = "return";
    ETypePopup["Minimum"] = "minimum";
})(ETypePopup || (ETypePopup = {}));
var PopupNewUserClass = /** @class */ (function (_super) {
    (0,_tslib/* __extends */.ZT)(PopupNewUserClass, _super);
    function PopupNewUserClass(props) {
        var _this = _super.call(this, props) || this;
        _this.isSafariBrowser = function () {
            if (typeof navigator !== 'undefined' && typeof window !== 'undefined') {
                return !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
            }
            return false;
        };
        _this.getLinkDownload = function () {
            if (typeof window !== 'undefined') {
                var trackingQueue = _this.props.trackingQueue;
                if (trackingQueue) {
                    trackingQueue({
                        eventName: 'js_platform_discovery:popup_choose_platform',
                        properties: {
                            platform: 'vietnamworks',
                            download_url: "https://vietnamworks.onelink.me/UtAm?pid=mobile&url=".concat(encodeURIComponent(window.location.pathname))
                        }
                    });
                }
                window.location.href = "https://vietnamworks.onelink.me/UtAm?pid=mobile&url=".concat(encodeURIComponent(window.location.pathname));
            }
        };
        _this.getLinkDownloadUpzi = function () {
            if (typeof window !== 'undefined') {
                var trackingQueue = _this.props.trackingQueue;
                if (trackingQueue) {
                    trackingQueue({
                        eventName: 'js_platform_discovery:popup_choose_platform',
                        properties: {
                            platform: 'upzi',
                            download_url: "https://www.upzi.vn/tai-ung-dung?utm_source=vietnamworks_mweb&utm_campaign=popup_download"
                        }
                    });
                }
                window.location.href = "https://www.upzi.vn/tai-ung-dung?utm_source=vietnamworks_mweb&utm_campaign=popup_download";
            }
        };
        _this.pushGA = function (bannerType) {
            if (typeof window !== 'undefined') {
                if (window._gaq && window._gaq.push) {
                    window._gaq.push(['_trackEvent', 'NoThanksBanner', 'Click', bannerType]);
                }
            }
        };
        _this.initPopup = function () {
            // Chỉ hiển thị popup trên mobile (window.innerWidth < 900)
            if (typeof window !== 'undefined' && window.innerWidth >= 900) {
                return;
            }
            if (hasLocalStorage) {
                var popupClosed = localStorage.getItem('popupNewUser');
                // Chỉ hiển thị popup nếu chưa có localStorage (user chưa từng đóng popup)
                if (!popupClosed) {
                    // Gửi tracking event khi popup hiển thị
                    var trackingQueue = _this.props.trackingQueue;
                    if (trackingQueue) {
                        trackingQueue({
                            eventName: 'js_platform_discovery:popup_download_app',
                            properties: {
                                fromPage: 'mweb',
                            }
                        });
                    }
                    _this.setState({ isShowNewPopup: true });
                }
            }
        };
        _this.handleClickoverlay = function () {
            // Tạo localStorage khi user click overlay để đóng popup
            if (hasLocalStorage) {
                localStorage.setItem('popupNewUser', 'true');
            }
            _this.setState({
                isShowNewPopup: false,
                isShowReturnPopup: false
            });
        };
        _this.renderPopupOverlay = function () {
            var bodyNode = typeof document !== 'undefined' && document.querySelector('body');
            if (bodyNode) {
                return react_dom.createPortal((0,jsx_runtime.jsx)(PopupOverlay, { onClick: _this.handleClickoverlay, active: _this.state.isShowNewPopup }), bodyNode);
            }
            return null;
        };
        _this.handleClosePopup = function (position) {
            var onClosePopup = _this.props.onClosePopup;
            // Tạo localStorage khi user đóng popup
            if (hasLocalStorage) {
                localStorage.setItem('popupNewUser', 'true');
            }
            switch (position) {
                case ETypePopup.New:
                    _this.setState({ isShowNewPopup: false });
                    _this.pushGA('NEW_USER_BANNER');
                    break;
                case ETypePopup.Minimum:
                    _this.setState({ isShowMinimumPopup: false });
                    _this.pushGA('MINIMUM_USER_BANNER');
                    break;
                case ETypePopup.Return:
                    _this.setState({ isShowReturnPopup: false });
                    _this.pushGA('RETURN_USER_BANNER');
                    break;
            }
            onClosePopup && onClosePopup();
        };
        _this.renderStarIcon = function () {
            var ratingStartList = [];
            for (var i = 0; i < 5; i++) {
                ratingStartList.push((0,jsx_runtime.jsx)("svg", { className: 'rating', width: '14px', height: '13px', viewBox: '0 0 14 13', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', children: (0,jsx_runtime.jsx)("g", { id: 'Popup-Install-App', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', children: (0,jsx_runtime.jsx)("g", { id: 'New-User', transform: 'translate(-115.000000, -557.000000)', fill: '#ff7d55', fillRule: 'nonzero', children: (0,jsx_runtime.jsx)("g", { id: 'Group-4', transform: 'translate(0.000000, 387.000000)', children: (0,jsx_runtime.jsx)("g", { id: 'Group-3', transform: 'translate(16.000000, 103.000000)', children: (0,jsx_runtime.jsx)("path", { d: 'M102.349306,79.533297 L105.577822,77.1675744 L108.801699,79.533297 C109.135683,79.774508 109.404726,79.8255334 109.627382,79.6631798 C109.840761,79.5008263 109.891787,79.2317834 109.757265,78.8421349 L108.490908,75.0477013 L111.742617,72.7098107 C112.076601,72.4732384 112.201845,72.2273888 112.118349,71.9676232 C112.034853,71.7171349 111.789003,71.5826134 111.376162,71.5872521 L107.382265,71.6104455 L106.166933,67.8020959 C106.03705,67.4078087 105.846865,67.2129845 105.577822,67.2129845 C105.30414,67.2129845 105.113955,67.4078087 104.988711,67.8020959 L103.76874,71.6104455 L99.7748433,71.5872521 C99.3620015,71.5826134 99.1207906,71.7171349 99.0372945,71.9676232 C98.9491597,72.2273888 99.0790425,72.4732384 99.4083882,72.7098107 L102.660097,75.0477013 L101.39374,78.8421349 C101.263857,79.2317834 101.314882,79.5008263 101.528261,79.6631798 C101.746279,79.8255334 102.019961,79.774508 102.349306,79.533297 Z', id: 'icon-star-l' }) }) }) }) }) }, i));
            }
            return ratingStartList;
        };
        _this.renderCloseBtn = function (position) {
            return ((0,jsx_runtime.jsx)("svg", { className: 'filter-close', viewBox: '0 0 50 50', onClick: function () { return _this.handleClosePopup(position); }, children: (0,jsx_runtime.jsx)("path", { d: 'M 14.40625 13 L 13 14.40625 L 23.625 25 L 13 35.59375 L 14.40625 37 L 25.0625 26.40625 L 35.6875 37 L 37.09375 35.59375 L 26.46875 25 L 37.09375 14.40625 L 35.6875 13 L 25.0625 23.59375 Z' }) }));
        };
        _this.renderVietnamworksLogo = function () {
            return ((0,jsx_runtime.jsxs)("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '68', height: '68', children: [(0,jsx_runtime.jsxs)("defs", { children: [(0,jsx_runtime.jsx)("clipPath", { id: 'a', children: (0,jsx_runtime.jsx)("path", { d: 'M62 0a6 6 0 0 1 6 6v56a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6h56Z' }) }), (0,jsx_runtime.jsx)("clipPath", { id: 'b', children: (0,jsx_runtime.jsx)("path", { d: 'M29.401 6.242c.227.407-.168.87-.675.787l-.515-.084c-3.37-.478-7.263.643-7.626.75l-.027.009c-4.626 1.297-8.872.908-8.872.908-3.35-.137-6.803-1.157-6.803-1.157C2.703 6.87 0 6.765 0 6.765S5.784 1.682 14.411.25c0 0 10.476-2.12 14.99 5.992Z' }) }), (0,jsx_runtime.jsx)("clipPath", { id: 'd', children: (0,jsx_runtime.jsx)("path", { d: 'm25.997 10.596.003.114v.198c-.025 1.627-.593 9.355-8.885 16.66 0 0-7.869 7.308-16.649 7.094-.487-.012-.644-.634-.22-.864 2.326-1.257 6.957-4.468 11.855-11.866 0 0 7.772-10.601 2.98-21.93h.015l.02-.001h.211c1.595.025 10.379.618 10.67 10.595Z' }) }), (0,jsx_runtime.jsx)("clipPath", { id: 'f', children: (0,jsx_runtime.jsx)("path", { d: 'm25.965 16.763-.06.04c-1.179.777-13.186 8.356-21.906.37 0 0-.026-.023-.073-.07l-.067-.066C2.938 16.107-2.123 10.42 1.013.43A.604.604 0 0 1 2.14.35c1.436 3.02 5.387 10.2 11.758 13.464 0 0 4.435 2.91 11.703 2.927l.398-.003a.577.577 0 0 1-.034.024Z' }) }), (0,jsx_runtime.jsx)("clipPath", { id: 'h', children: (0,jsx_runtime.jsx)("path", { d: 'M13.465.147c.426.055.551.597.19.823-2.557 1.596-8.847 6.589-11.179 18.097 0 0-5.303-8.239-.388-15.087 0 0 3.286-4.878 11.377-3.833Z' }) }), (0,jsx_runtime.jsxs)("linearGradient", { id: 'c', x1: '-.001', y1: '4.333', x2: '29.466', y2: '4.333', gradientUnits: 'userSpaceOnUse', children: [(0,jsx_runtime.jsx)("stop", { stopColor: '#3baaff', offset: '0%' }), (0,jsx_runtime.jsx)("stop", { stopColor: '#47b2ff', offset: '24%' }), (0,jsx_runtime.jsx)("stop", { stopColor: '#67c9ff', offset: '68%' }), (0,jsx_runtime.jsx)("stop", { stopColor: '#82dcff', offset: '100%' })] }), (0,jsx_runtime.jsxs)("linearGradient", { id: 'e', x1: '22.651', y1: '8.871', x2: '-3.642', y2: '28.797', gradientUnits: 'userSpaceOnUse', children: [(0,jsx_runtime.jsx)("stop", { stopColor: '#0059ff', offset: '10%' }), (0,jsx_runtime.jsx)("stop", { stopColor: '#035eff', offset: '13%' }), (0,jsx_runtime.jsx)("stop", { stopColor: '#2187ff', offset: '50%' }), (0,jsx_runtime.jsx)("stop", { stopColor: '#34a0ff', offset: '79%' }), (0,jsx_runtime.jsx)("stop", { stopColor: '#3baaff', offset: '96%' })] }), (0,jsx_runtime.jsxs)("linearGradient", { id: 'g', x1: '-1.609', y1: '10.4', x2: '17.891', y2: '10.4', gradientUnits: 'userSpaceOnUse', children: [(0,jsx_runtime.jsx)("stop", { stopColor: '#82dcff', offset: '0%' }), (0,jsx_runtime.jsx)("stop", { stopColor: '#65c7ff', offset: '25%' }), (0,jsx_runtime.jsx)("stop", { stopColor: '#47b2ff', offset: '57%' }), (0,jsx_runtime.jsx)("stop", { stopColor: '#3baaff', offset: '75%' })] }), (0,jsx_runtime.jsxs)("linearGradient", { id: 'i', x1: '-2.266', y1: '13.235', x2: '14.73', y2: '4.889', gradientUnits: 'userSpaceOnUse', children: [(0,jsx_runtime.jsx)("stop", { stopColor: '#0059ff', offset: '0%' }), (0,jsx_runtime.jsx)("stop", { stopColor: '#1271ff', offset: '26%' }), (0,jsx_runtime.jsx)("stop", { stopColor: '#309aff', offset: '75%' }), (0,jsx_runtime.jsx)("stop", { stopColor: '#3baaff', offset: '100%' })] })] }), (0,jsx_runtime.jsx)("g", { clipPath: 'url(#a)', children: (0,jsx_runtime.jsx)("path", { fill: '#001644', d: 'M0 0h68v68H0V0z' }) }), (0,jsx_runtime.jsx)("g", { clipPath: 'url(#b)', transform: 'translate(20.133 10)', children: (0,jsx_runtime.jsx)("path", { fill: 'url(#c)', d: 'M0 0h29.467v8.667H0V0z' }) }), (0,jsx_runtime.jsx)("g", { clipPath: 'url(#d)', transform: 'translate(34 16.933)', children: (0,jsx_runtime.jsx)("path", { fill: 'url(#e)', d: 'M0 0h26v34.667H0V0z' }) }), (0,jsx_runtime.jsx)("g", { clipPath: 'url(#f)', transform: 'translate(8 37.733)', children: (0,jsx_runtime.jsx)("path", { fill: 'url(#g)', d: 'M0 0h26v20.8H0V0z' }) }), (0,jsx_runtime.jsx)("g", { clipPath: 'url(#h)', transform: 'translate(8 18.667)', children: (0,jsx_runtime.jsx)("path", { fill: 'url(#i)', d: 'M0 0h13.867v19.067H0V0z' }) })] }));
        };
        _this.renderNewPopup = function () {
            var langCode = _this.props.langCode;
            // Disable moreIconBtn khi popup hiển thị
            _this.setMoreIconBtnState(true);
            var bodyNode = typeof document !== 'undefined' && document.querySelector('body');
            if (bodyNode) {
                return react_dom.createPortal((0,jsx_runtime.jsxs)(NewPopup, { children: [(0,jsx_runtime.jsx)("button", { type: 'button', className: 'popup-close-btn', "aria-label": langCode === 'en' ? 'Close' : 'Đóng', onClick: function () { return _this.handleClosePopup(ETypePopup.New); }, children: (0,jsx_runtime.jsx)("svg", { width: '16', height: '16', viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: (0,jsx_runtime.jsx)("path", { d: 'M12 4L4 12M4 4L12 12', stroke: '#424242', strokeWidth: '1.8', strokeLinecap: 'round' }) }) }), (0,jsx_runtime.jsx)("div", { className: 'popup-title', children: langCode === 'en' ? 'Get the full app experience' : "T\u1EA3i app \u0111\u1EC3 c\u00F3 tr\u1EA3i nghi\u1EC7m t\u1ED1t" }), (0,jsx_runtime.jsxs)("div", { className: "popup-item-download", children: [(0,jsx_runtime.jsx)("div", { className: 'popup-item-text', children: langCode === 'en' ? 'For professionals with 3+ years of experience' : "D\u00E0nh cho ng\u01B0\u1EDDi t\u1EEB 3 n\u0103m kinh nghi\u1EC7m" }), (0,jsx_runtime.jsxs)("a", { onClick: _this.getLinkDownload, className: 'download-btn', children: [(0,jsx_runtime.jsxs)("div", { className: 'download-btn-content', children: [(0,jsx_runtime.jsxs)("svg", { width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [(0,jsx_runtime.jsx)("path", { d: "M0 7.74194C0 3.46618 3.46618 0 7.74194 0H32.2581C36.5338 0 40 3.46618 40 7.74194V32.2581C40 36.5338 36.5338 40 32.2581 40H7.74194C3.46618 40 0 36.5338 0 32.2581V7.74194Z", fill: "#002466" }), (0,jsx_runtime.jsx)("path", { d: "M27.7237 10.9065C25.8186 10.6362 23.6029 11.3149 23.6029 11.3149C21.1121 12.0134 18.8256 11.8039 18.8256 11.8039C17.0217 11.7303 15.1624 11.1812 15.1624 11.1812C13.9886 10.8659 12.5333 10.8099 12.5333 10.8099C12.5333 10.8099 15.648 8.07198 20.2933 7.30106C20.2933 7.30106 25.9341 6.16009 28.3648 10.5276C28.4867 10.7469 28.274 10.9961 28.0012 10.9515L27.7237 10.9062V10.9065Z", fill: "url(#paint0_linear_32214_2465)" }), (0,jsx_runtime.jsx)("path", { d: "M28.1201 10.9009C28.1201 10.9009 33.826 10.6964 33.9982 16.6058C33.9982 16.6058 34.2385 21.3191 29.216 25.744C29.216 25.744 24.9786 29.6793 20.2511 29.5642C19.9886 29.5579 19.9039 29.2226 20.133 29.0987C21.385 28.4221 23.8783 26.6932 26.5162 22.7095C26.5162 22.7095 30.701 17.0011 28.1201 10.9009Z", fill: "url(#paint1_linear_32214_2465)" }), (0,jsx_runtime.jsx)("path", { d: "M19.9997 31.1136C19.9997 31.1136 13.0959 35.8734 8.15335 31.3471C8.15335 31.3471 4.69261 28.234 6.54571 22.3314C6.63576 22.045 7.02307 22.0173 7.1517 22.2881C7.92563 23.9141 10.053 27.7813 13.4835 29.5388C13.4835 29.5388 15.959 31.1637 20 31.1136H19.9997Z", fill: "url(#paint2_linear_32214_2465)" }), (0,jsx_runtime.jsx)("path", { d: "M13.3524 12.3555C11.976 13.2152 8.58912 15.9033 7.33328 22.1C7.33328 22.1 4.47801 17.6638 7.12427 13.9764C7.12427 13.9764 8.89391 11.3497 13.2504 11.9123C13.4797 11.942 13.5471 12.234 13.3524 12.3555Z", fill: "url(#paint3_linear_32214_2465)" }), (0,jsx_runtime.jsxs)("defs", { children: [(0,jsx_runtime.jsxs)("linearGradient", { id: "paint0_linear_32214_2465", x1: "12.533", y1: "11.8333", x2: "28.3998", y2: "11.8333", gradientUnits: "userSpaceOnUse", children: [(0,jsx_runtime.jsx)("stop", { "stop-color": "#3CAAFF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.24", "stop-color": "#47B2FF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.68", "stop-color": "#67C9FF" }), (0,jsx_runtime.jsx)("stop", { offset: "1", "stop-color": "#82DCFF" })] }), (0,jsx_runtime.jsxs)("linearGradient", { id: "paint1_linear_32214_2465", x1: "29.1648", y1: "3.454", x2: "10.733", y2: "11.3109", gradientUnits: "userSpaceOnUse", children: [(0,jsx_runtime.jsx)("stop", { offset: "0.1", "stop-color": "#005AFF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.13", "stop-color": "#035EFF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.5", "stop-color": "#2287FF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.79", "stop-color": "#35A0FF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.96", "stop-color": "#3CAAFF" })] }), (0,jsx_runtime.jsxs)("linearGradient", { id: "paint2_linear_32214_2465", x1: "5.13346", y1: "33.2999", x2: "19.1336", y2: "33.2999", gradientUnits: "userSpaceOnUse", children: [(0,jsx_runtime.jsx)("stop", { "stop-color": "#82DCFF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.25", "stop-color": "#65C7FF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.57", "stop-color": "#47B2FF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.75", "stop-color": "#3CAAFF" })] }), (0,jsx_runtime.jsxs)("linearGradient", { id: "paint3_linear_32214_2465", x1: "6.41392", y1: "25.2518", x2: "16.081", y2: "22.7409", gradientUnits: "userSpaceOnUse", children: [(0,jsx_runtime.jsx)("stop", { "stop-color": "#005AFF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.26", "stop-color": "#1272FF" }), (0,jsx_runtime.jsx)("stop", { offset: "0.75", "stop-color": "#309AFF" }), (0,jsx_runtime.jsx)("stop", { offset: "1", "stop-color": "#3CAAFF" })] })] })] }), (0,jsx_runtime.jsxs)("div", { className: 'download-btn-text', children: [langCode === 'en' ? 'Get app' : "T\u1EA3i app", (0,jsx_runtime.jsx)("br", {}), (0,jsx_runtime.jsx)("strong", { children: "VietnamWorks" })] })] }), (0,jsx_runtime.jsx)("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { d: "M7.4266 2.5C7.29111 2.50004 7.15871 2.54048 7.04633 2.61615C6.93395 2.69183 6.84669 2.7993 6.7957 2.92483C6.74472 3.05036 6.73233 3.18824 6.76012 3.32085C6.78791 3.45345 6.85462 3.57476 6.95171 3.66925L13.2809 9.99839L6.95171 16.3275C6.88635 16.3903 6.83416 16.4655 6.79821 16.5486C6.76226 16.6318 6.74327 16.7213 6.74234 16.8119C6.74142 16.9025 6.75859 16.9924 6.79284 17.0763C6.82709 17.1602 6.87774 17.2364 6.94181 17.3005C7.00589 17.3646 7.0821 17.4152 7.16599 17.4495C7.24989 17.4837 7.33977 17.5009 7.43038 17.5C7.52099 17.499 7.61051 17.4801 7.69369 17.4441C7.77687 17.4081 7.85204 17.356 7.91479 17.2906L14.7255 10.4799C14.8532 10.3522 14.9249 10.179 14.9249 9.99839C14.9249 9.81779 14.8532 9.64459 14.7255 9.51686L7.91479 2.70618C7.85132 2.64094 7.77542 2.58908 7.69157 2.55367C7.60772 2.51825 7.51762 2.50001 7.4266 2.5Z", fill: "#616161" }) })] })] }), (0,jsx_runtime.jsxs)("div", { className: "popup-item-download", children: [(0,jsx_runtime.jsx)("div", { className: 'popup-item-text', children: langCode === 'en' ? 'For Interns/Freshers and under 3 years of experience' : "D\u00E0nh cho Intern/ Fresher v\u00E0 d\u01B0\u1EDBi 3 n\u0103m kinh nghi\u1EC7m" }), (0,jsx_runtime.jsxs)("a", { onClick: _this.getLinkDownloadUpzi, className: 'download-btn', children: [(0,jsx_runtime.jsxs)("div", { className: 'download-btn-content', children: [(0,jsx_runtime.jsxs)("svg", { width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [(0,jsx_runtime.jsxs)("g", { "clip-path": "url(#clip0_32214_2481)", children: [(0,jsx_runtime.jsx)("path", { d: "M40 0H0V40H40V0Z", fill: "#9345FF" }), (0,jsx_runtime.jsx)("path", { d: "M32.7002 14.3269C31.89 13.5242 30.8135 13.0207 29.69 12.829C29.0786 12.7255 28.4548 12.7117 27.8379 12.7628C24.0079 13.0814 20.8708 16.4111 18.7232 22.4111C18.715 22.4111 18.7053 22.4124 18.6956 22.4124C18.5521 22.4124 18.3823 22.389 18.1795 22.1186C17.5101 21.2179 17.263 18.6773 18.3023 15.2248C18.4293 14.8042 18.5659 14.3973 18.7108 14.0055C18.8116 13.7352 18.6114 13.4483 18.323 13.4483H16.2113C15.9629 13.4483 15.7435 13.6138 15.68 13.8552C15.6289 14.0442 15.5751 14.2359 15.5157 14.4304C14.0265 19.3766 11.1378 22.4138 9.72317 22.4138C9.57963 22.4138 9.40987 22.3904 9.20699 22.12C8.53761 21.2193 8.29056 18.6786 9.32982 15.2262C9.4568 14.8055 9.59344 14.3986 9.73835 14.0069C9.8391 13.7366 9.63898 13.4497 9.35053 13.4497H7.40311C7.16434 13.4497 6.95456 13.6028 6.87865 13.829C6.81102 14.0304 6.74753 14.2304 6.6868 14.4317C5.48882 18.4097 5.60199 21.8993 6.99182 23.7669C7.66672 24.6745 8.63698 25.1738 9.72317 25.1738C11.6181 25.1738 13.4883 23.6993 15.0396 21.5904C15.2245 22.4497 15.5323 23.1862 15.9629 23.7669C16.4653 24.4428 17.1333 24.8924 17.8896 25.0786C17.2754 27.3862 16.9221 29.7283 16.9097 31.6552C16.9083 31.8855 17.0946 32.0717 17.3238 32.0717H19.256C19.4823 32.0717 19.6673 31.8897 19.6687 31.6635C19.6907 29.5779 20.1669 26.8759 20.9702 24.3711C23.2198 17.3531 26.0685 15.6814 28.0628 15.5159C28.8274 15.4524 29.4665 15.5242 29.9771 15.7311C25.4833 18.5379 25.1534 21.1173 25.3577 22.4042C25.5702 23.7435 26.5322 24.8152 27.8089 25.1352C30.042 25.6924 32.035 23.9035 33.0922 22.1269C34.4075 19.9173 34.7525 16.7848 33.0259 14.6911C32.9224 14.5655 32.812 14.4455 32.6974 14.3311L32.7002 14.3269ZM31.4525 18.0607C31.4856 18.7048 31.3628 19.3628 31.1434 19.88C30.3401 21.7655 29.0593 22.6 28.4824 22.4552C28.3306 22.4166 28.136 22.2676 28.0877 21.9697C27.9676 21.2111 28.775 19.7338 31.4429 18.0676C31.447 18.0648 31.4498 18.0635 31.4525 18.0607Z", fill: "white" })] }), (0,jsx_runtime.jsx)("defs", { children: (0,jsx_runtime.jsx)("clipPath", { id: "clip0_32214_2481", children: (0,jsx_runtime.jsx)("path", { d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z", fill: "white" }) }) })] }), (0,jsx_runtime.jsxs)("div", { className: 'download-btn-text', children: [langCode === 'en' ? 'Get app' : "T\u1EA3i app", (0,jsx_runtime.jsx)("br", {}), (0,jsx_runtime.jsx)("strong", { children: "Upzi" })] })] }), (0,jsx_runtime.jsx)("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { d: "M7.4266 2.5C7.29111 2.50004 7.15871 2.54048 7.04633 2.61615C6.93395 2.69183 6.84669 2.7993 6.7957 2.92483C6.74472 3.05036 6.73233 3.18824 6.76012 3.32085C6.78791 3.45345 6.85462 3.57476 6.95171 3.66925L13.2809 9.99839L6.95171 16.3275C6.88635 16.3903 6.83416 16.4655 6.79821 16.5486C6.76226 16.6318 6.74327 16.7213 6.74234 16.8119C6.74142 16.9025 6.75859 16.9924 6.79284 17.0763C6.82709 17.1602 6.87774 17.2364 6.94181 17.3005C7.00589 17.3646 7.0821 17.4152 7.16599 17.4495C7.24989 17.4837 7.33977 17.5009 7.43038 17.5C7.52099 17.499 7.61051 17.4801 7.69369 17.4441C7.77687 17.4081 7.85204 17.356 7.91479 17.2906L14.7255 10.4799C14.8532 10.3522 14.9249 10.179 14.9249 9.99839C14.9249 9.81779 14.8532 9.64459 14.7255 9.51686L7.91479 2.70618C7.85132 2.64094 7.77542 2.58908 7.69157 2.55367C7.60772 2.51825 7.51762 2.50001 7.4266 2.5Z", fill: "#616161" }) })] })] })] }), bodyNode);
            }
            return null;
        };
        _this.renderMinimumPopup = function () {
            var langCode = _this.props.langCode;
            var closeBtn = _this.renderCloseBtn(ETypePopup.Minimum);
            var logo = _this.renderVietnamworksLogo();
            var ratingStart = _this.renderStarIcon();
            return ((0,jsx_runtime.jsxs)(MinimumPopup, { children: [closeBtn, (0,jsx_runtime.jsxs)("div", { className: 'wrap-content-minimum', children: [logo, (0,jsx_runtime.jsxs)("div", { className: 'content-popup', children: [(0,jsx_runtime.jsx)("div", { className: 'app-title', children: "VietnamWorks" }), (0,jsx_runtime.jsx)("div", { className: 'app-brief', children: langCode === 'en' ? 'Job Search and Recruitment' : vi["Job Search and Recruitment"] }), (0,jsx_runtime.jsxs)("div", { className: 'app-rating', children: [ratingStart, (0,jsx_runtime.jsx)("span", { className: 'app-score', children: "(4,7)" }), ' '] })] }), (0,jsx_runtime.jsx)("button", { onClick: _this.getLinkDownload, className: 'download-btn', children: langCode === 'en' ? 'Open App' : vi["Open App"] })] })] }));
        };
        _this.checkIsMobile = function () {
            if (typeof window !== 'undefined') {
                var isMobile = window.innerWidth < 900;
                _this.setState({ isMobile: isMobile });
            }
        };
        _this.toggleBodyScroll = function (disable) {
            if (typeof document !== 'undefined') {
                if (disable) {
                    // Ngăn body scroll khi popup hiển thị
                    document.body.style.overflow = 'hidden';
                }
                else {
                    // Cho phép body scroll lại khi popup đóng
                    document.body.style.overflow = '';
                }
            }
        };
        _this.setMoreIconBtnState = function (disabled) {
            var applyState = function () {
                if (typeof document === 'undefined')
                    return;
                var element = document.getElementById('moreIconBtn');
                if (element) {
                    var el = element;
                    if (disabled) {
                        el.style.setProperty('pointer-events', 'none', 'important');
                        el.style.setProperty('opacity', '0.5', 'important');
                        el.setAttribute('aria-disabled', 'true');
                        el.setAttribute('tabindex', '-1');
                        if ('disabled' in element) {
                            element.disabled = true;
                        }
                    }
                    else {
                        el.style.removeProperty('pointer-events');
                        el.style.removeProperty('opacity');
                        el.removeAttribute('aria-disabled');
                        el.removeAttribute('tabindex');
                        if ('disabled' in element) {
                            element.disabled = false;
                        }
                    }
                }
            };
            applyState();
            // Retry sau 1 tick - element có thể chưa render khi popup vừa hiện
            setTimeout(applyState, 0);
        };
        _this.state = {
            isMobile: false,
            isShowNewPopup: false,
            isShowMinimumPopup: false,
            isShowReturnPopup: false
        };
        return _this;
    }
    PopupNewUserClass.prototype.componentDidMount = function () {
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.checkIsMobile);
        }
        this.checkIsMobile();
        this.initPopup();
    };
    PopupNewUserClass.prototype.componentDidUpdate = function (_prevProps, prevState) {
        // Popup chỉ hiển thị khi isMobile VÀ isShowNewPopup
        var isPopupVisible = this.state.isMobile && this.state.isShowNewPopup;
        var wasPopupVisible = prevState.isMobile && prevState.isShowNewPopup;
        if (isPopupVisible !== wasPopupVisible) {
            this.toggleBodyScroll(isPopupVisible);
            this.setMoreIconBtnState(isPopupVisible);
        }
    };
    PopupNewUserClass.prototype.componentWillUnmount = function () {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.checkIsMobile);
        }
        // Đảm bảo restore body scroll khi component unmount
        this.toggleBodyScroll(false);
        // Enable moreIconBtn khi component unmount
        this.setMoreIconBtnState(false);
    };
    PopupNewUserClass.prototype.render = function () {
        var _a = this.state, isMobile = _a.isMobile, isShowNewPopup = _a.isShowNewPopup, isShowReturnPopup = _a.isShowReturnPopup, isShowMinimumPopup = _a.isShowMinimumPopup;
        // Chỉ render trên mobile; ẩn hoàn toàn khi đang hiển thị return popup
        if (!isMobile || isShowReturnPopup) {
            return null;
        }
        var newPopup = this.renderNewPopup();
        var minimumPopup = this.renderMinimumPopup();
        var overlay = this.renderPopupOverlay();
        return ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [isShowNewPopup ? newPopup : null, isShowNewPopup ? overlay : null, isShowMinimumPopup ? minimumPopup : null] }));
    };
    return PopupNewUserClass;
}(react.PureComponent));
// Wrapper component to use PostHog hook
function PopupNewUser(props) {
    var _a = (0,useHog/* default */.Z)(), tracking = _a.tracking, trackingQueue = _a.trackingQueue;
    return (0,jsx_runtime.jsx)(PopupNewUserClass, (0,_tslib/* __assign */.pi)({}, props, { tracking: tracking, trackingQueue: trackingQueue }));
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 20560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useHog; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74982);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81248);
'use client';





var INTERVAL_TIME = 500;
var DEBUG_VNW_KEY = 'debug_vnw';
var isDebugVnwEnabled = function () {
    var _a;
    try {
        return typeof window !== 'undefined' && ((_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem(DEBUG_VNW_KEY)) === 'true';
    }
    catch (_b) {
        return false;
    }
};
// This useHog function is used to centralize PostHog.
// In the future, any further requirements or changes can
// easily be updated here.
/**
 * A Hog Hook that return a tracking function and a tracking queue function.
 *
 * @returns  tracking, trackingQueue
 */
var useHog = function () {
    // Queue
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isEnableQueue = _a[0], setIsEnableQueue = _a[1];
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), trackingQueues = _b[0], setTrackingQueues = _b[1];
    var intervalIdRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var tracking = function (params, options) {
        try {
            if (!window.posthog) {
                console.error('PostHog is not ready!');
                return;
            }
            var _a = params.eventName, eventName = _a === void 0 ? '' : _a, _b = params.properties, properties = _b === void 0 ? {} : _b;
            // Do not tracking when there is no eventName provided
            if (eventName === '') {
                console.error('eventName is empty!');
                return;
            }
            // Parse page-name from window.location.pathname
            properties.pageName = (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .getPageName */ .j0)();
            var parsedProperties = (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .convertKeysToSnakeCase */ .K9)(properties);
            if (isDebugVnwEnabled()) {
                console.log('[PostHog]', {
                    eventName: eventName,
                    properties: parsedProperties,
                    options: options
                });
            }
            window.posthog.capture(eventName, parsedProperties, options);
        }
        catch (ex) {
            console.error('PostHog Error', ex);
        }
    };
    var trackingQueue = function (params, options) {
        try {
            // Run tracking when postHog is ready! No need to queue
            if (window.posthog) {
                tracking(params, options);
                return;
            }
            // PostHog is not ready then we should add it to queue
            var newTrackingQueues = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__spreadArray */ .ev)([], trackingQueues, true);
            newTrackingQueues.push({
                id: "".concat(params.eventName, "_").concat(trackingQueues.length + 1),
                trackingParams: params,
                options: options
            });
            setTrackingQueues(newTrackingQueues);
            setIsEnableQueue(true);
        }
        catch (ex) {
            console.error('Tracking Queue Error', ex);
        }
    };
    var checkingPostHog = function () {
        if (!window.posthog) {
            return;
        }
        // Disable interval to prevent javascript running endless
        if (trackingQueues.length === 0) {
            setIsEnableQueue(false);
            return;
        }
        // Loop through queues
        trackingQueues.forEach(function (trackingItem) {
            // Send tracking event
            tracking(trackingItem.trackingParams, trackingItem === null || trackingItem === void 0 ? void 0 : trackingItem.options);
        });
        // All tracking is sent then we should empty it
        setTrackingQueues([]);
        setIsEnableQueue(false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (!isEnableQueue) {
            return;
        }
        if (trackingQueues.length === 0) {
            return;
        }
        intervalIdRef.current = setInterval(checkingPostHog, INTERVAL_TIME);
        return function () {
            intervalIdRef.current && clearInterval(intervalIdRef.current);
            intervalIdRef.current = null;
        };
    }, [isEnableQueue, trackingQueues]);
    return {
        tracking: tracking,
        trackingQueue: trackingQueue
    };
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 81248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K9": function() { return /* binding */ convertKeysToSnakeCase; },
/* harmony export */   "gw": function() { return /* binding */ delay; },
/* harmony export */   "j0": function() { return /* binding */ getPageName; }
/* harmony export */ });
/* unused harmony exports camelToSnake, generateUuidV4 */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74982);
'use client';



// Pre-compiled regex patterns for better performance (only safe optimizations)
var CAMEL_TO_SNAKE_REGEX = /[A-Z]/g;
var JOB_DETAIL_REGEX = /\d{6}(-jd|-jv)/;
var MULTIPLE_JOB_APPLY_REGEX_VN = /^\/ung-tuyen-nhieu-viec-lam/;
var MULTIPLE_JOB_APPLY_REGEX_EN = /^\/apply-multiple-jobs/;
var SALARY_REGEX_VN = /^\/muc-luong/;
var SALARY_REGEX_EN = /^\/salary/;
var INTERVIEW_REGEX_VN = /^\/cau-hoi-phong-van/;
var INTERVIEW_REGEX_EN = /^\/interview/;
var CAREER_PATH_REGEX_VN = /^\/lo-trinh-su-nghiep/;
var CAREER_PATH_REGEX_EN = /^\/career-path/;
var RULING_NUMBER_REGEX_VN = /\/so-chu-dao/;
var RULING_NUMBER_REGEX_EN = /\/ruling-number/;
var COMPANIES_REGEX_VN = /\/nha-tuyen-dung/;
var COMPANIES_REGEX_EN = /\/companies/;
var MANAGEMENT_JOBS_REGEX_VN = /\/viec-lam-quan-ly/;
var MANAGEMENT_JOBS_REGEX_EN = /\/management-jobs/;
// Note: Removed 'g' flag from original - global flag with .test() can cause bugs
var SEARCH_RESULTS_REGEX = /-kv|-kw|-i\d{2}|-v\d{2}|jobs|all-jobs|viec-lam|tat-ca-viec-lam|e\d{7}-vn|e\d{7}-en/i;
var ONBOARDING_REGEX = /\/onboarding|\/chao-don-ung-vien-moi/;
var LOGIN_REGEX = /\/login\/vi|\/login\/en/;
var CAREER_CENTER_REGEX = /\/my-career-center|\/quan-ly-nghe-nghiep/;
// Simple cache for page name (only caches when pathname unchanged - safe)
var cachedPageName = null;
var cachedPathname = null;
function camelToSnake(key) {
    // Exact same logic as original - just using pre-compiled regex
    return key.replace(CAMEL_TO_SNAKE_REGEX, function (letter) { return "_".concat(letter.toLowerCase()); });
}
function convertKeysToSnakeCase(obj) {
    // Exact same logic as original - no changes to behavior
    if (Array.isArray(obj)) {
        return obj.map(function (item) { return convertKeysToSnakeCase(item); });
    }
    else if (obj !== null && typeof obj === 'object') {
        return Object.keys(obj).reduce(function (acc, key) {
            var snakeKey = camelToSnake(key);
            acc[snakeKey] = convertKeysToSnakeCase(obj[key]);
            return acc;
        }, {});
    }
    return obj;
}
function getPageName() {
    if (typeof window === 'undefined') {
        return '';
    }
    var pathname = window.location.pathname;
    // Safe cache: only use if pathname hasn't changed
    if (cachedPathname === pathname && cachedPageName !== null) {
        return cachedPageName;
    }
    var pageName;
    // Exact same logic as original - just using pre-compiled regex patterns
    // Homepage
    if (pathname === '/') {
        pageName = 'homepage';
    }
    // page-container
    // Search result: All jobs
    else if (pathname === '/tim-viec-lam/tim-tat-ca-viec-lam' || pathname === '/job-search/all-jobs') {
        pageName = 'search_results';
    }
    // multiple-job-apply
    else if (MULTIPLE_JOB_APPLY_REGEX_VN.test(pathname) || MULTIPLE_JOB_APPLY_REGEX_EN.test(pathname)) {
        pageName = 'multiple_job_apply';
    }
    // career-center-container
    else if (pathname === '/quan-ly-nghe-nghiep/thong-bao-viec-lam' || pathname === '/my-career-center/my-job-alert') {
        pageName = 'my_job_alert';
    }
    // career-center-container
    else if (pathname === '/quan-ly-nghe-nghiep/viec-lam-cua-toi' || pathname === '/my-career-center/my-jobs') {
        pageName = 'my_jobs';
    }
    // career-center-container
    else if (pathname === '/quan-ly-nghe-nghiep/cong-ty-cua-toi' || pathname === '/my-career-center/my-companies') {
        pageName = 'my_companies';
    }
    // page-container
    // Search result: filtered jobs
    else if (pathname.indexOf('-en') >= 1 && pathname.indexOf('-vn') >= 1) {
        pageName = 'search_results';
    }
    // wealth-container
    else if (SALARY_REGEX_VN.test(pathname) || SALARY_REGEX_EN.test(pathname)) {
        pageName = 'landing_career_salary';
    }
    // wealth-container
    // Interview Page
    else if (INTERVIEW_REGEX_VN.test(pathname) || INTERVIEW_REGEX_EN.test(pathname)) {
        pageName = 'interview_page';
    }
    // wow-cv-container
    else if (pathname === '/wowcv/en' || pathname === '/wowcv') {
        pageName = 'wow_cv';
    }
    // new-wowcv-container
    else if (pathname === '/preview-cv' || pathname === '/xem-truoc') {
        pageName = 'new_wow_cv';
    }
    // marketing-landing-container
    // intech
    else if (pathname === '/intech') {
        pageName = 'intech_page';
    }
    // landing-page-container
    // career-newbies
    else if (pathname === '/career-newbies') {
        pageName = 'career_newbies';
    }
    // landing-page-container
    else if (pathname === '/job-search' || pathname === '/tim-viec-lam') {
        pageName = 'landing_job_search';
    }
    // landing-page-container
    else if (CAREER_PATH_REGEX_VN.test(pathname) || CAREER_PATH_REGEX_EN.test(pathname)) {
        pageName = 'landing_career_path';
    }
    // landing-page-container
    else if (pathname === '/nhan-so-hoc' || pathname === '/numberology') {
        pageName = 'numerology';
    }
    // landing-page-container
    else if (RULING_NUMBER_REGEX_VN.test(pathname) || RULING_NUMBER_REGEX_EN.test(pathname)) {
        pageName = 'numerology_ruling_number';
    }
    // companyprofile
    else if (pathname.indexOf('/company/') >= 0) {
        pageName = 'company_culture_profile';
    }
    // company-container
    else if (COMPANIES_REGEX_VN.test(pathname) || COMPANIES_REGEX_EN.test(pathname)) {
        pageName = 'company_profile';
    }
    // company-container
    else if (pathname === '/danh-sach-cong-ty' || pathname === '/company-list') {
        pageName = 'company_profile';
    }
    // job-details
    else if (JOB_DETAIL_REGEX.test(pathname)) {
        pageName = 'job_detail';
    }
    // page-container
    else if (MANAGEMENT_JOBS_REGEX_VN.test(pathname) || MANAGEMENT_JOBS_REGEX_EN.test(pathname)) {
        pageName = 'search_results';
    }
    // page-container
    else if (SEARCH_RESULTS_REGEX.test(pathname)) {
        pageName = 'search_results';
    }
    // landing-page-container Onboarding
    else if (ONBOARDING_REGEX.test(pathname)) {
        pageName = 'onboarding_page';
    }
    // sso
    else if (LOGIN_REGEX.test(pathname)) {
        pageName = 'sso';
    }
    // career-center-container
    else if (CAREER_CENTER_REGEX.test(pathname)) {
        pageName = 'my_career_center';
    }
    // career-center-container
    else if (pathname === '/quan-ly-tai-khoan' || pathname === '/account-settings') {
        pageName = 'account_settings';
    }
    // career-center-container
    else if (pathname === '/ho-so' || pathname === '/my-profile') {
        pageName = 'my_profile';
    }
    // vietnamworks
    else if (pathname === '/logout' || pathname === '/thoat') {
        pageName = 'logout';
    }
    // Welcome/onboarding paths
    else if (pathname === '/welcome/start' ||
        pathname === '/chao-mung/bat-dau' ||
        pathname === '/welcome/create-profile' ||
        pathname === '/chao-mung/tao-ho-so' ||
        pathname === '/welcome/work-info' ||
        pathname === '/chao-mung/nghe-nghiep' ||
        pathname === '/welcome/skills' ||
        pathname === '/chao-mung/ky-nang' ||
        pathname === '/welcome/experience' ||
        pathname === '/chao-mung/kinh-nghiem' ||
        pathname === '/welcome/contact' ||
        pathname === '/chao-mung/lien-he' ||
        pathname === '/welcome/basic' ||
        pathname === '/chao-mung/co-ban' ||
        pathname === '/welcome/preference' ||
        pathname === '/chao-mung/mong-muon') {
        pageName = 'new-onboarding';
    }
    else {
        pageName = pathname;
    }
    // Cache the result (safe - automatically updates when pathname changes)
    cachedPathname = pathname;
    cachedPageName = pageName;
    return pageName;
}
function delay(ms) {
    if (ms === void 0) { ms = 0; }
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(this, void 0, void 0, function () {
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) { return setTimeout(resolve, ms); })];
        });
    });
}
function generateUuidV4() {
    // Use crypto.randomUUID if available (faster and more secure, but same format)
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    // Exact same fallback logic as original
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
        var random = (Math.random() * 16) | 0;
        // Ensures the 4 and y positions follow the UUIDv4 spec
        var value = char === 'x' ? random : (random & 0x3) | 0x8;
        return value.toString(16);
    });
}


//# sourceMappingURL=utils.js.map


/***/ }),

/***/ 49988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$E": function() { return /* binding */ getSuggestionKeyword; },
/* harmony export */   "SX": function() { return /* binding */ getJobYouWillLove; },
/* harmony export */   "s4": function() { return /* binding */ getSearchBarHighLight; },
/* harmony export */   "tC": function() { return /* binding */ getSearchJob; },
/* harmony export */   "x_": function() { return /* binding */ getHotKeywords; },
/* harmony export */   "zK": function() { return /* binding */ trackSuggestionKeywords; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74982);
/* harmony import */ var _Utils_helpers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31545);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83528);
'use client';





var getHotKeywords = function (msBaseUrl, rawUserId, language) {
    if (language === void 0) { language = 'vi'; }
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
        var userId, apiUrl, response, err_1;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userId = rawUserId !== undefined && rawUserId !== null && rawUserId !== -1 ? rawUserId : 0;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    apiUrl = "".concat(msBaseUrl, "/hot-keywords/api/v1/hot-keywords?userId=").concat(userId, "&lang=").concat(language);
                    return [4 /*yield*/, fetch(apiUrl, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/vnd.api+json',
                                Accept: 'application/vnd.api+json',
                                'Accept-Language': language
                            }
                        })];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3: return [2 /*return*/, _a.sent()];
                case 4:
                    err_1 = _a.sent();
                    // TODO: Log Error To Sentry
                    console.debug('error getHotKeywords', err_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/, { data: [] }];
            }
        });
    });
};
var getSearchBarHighLight = function (msBaseUrl, jobFunctionIds, lang) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
    var URL, response;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = (0,_Utils_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .attachQueryParamToUrl */ ._2)("".concat(msBaseUrl, "/banners/v1.0/searchbar-highlight"), {
                    jobFunctionIds: jobFunctionIds
                });
                return [4 /*yield*/, fetch(URL, {
                        method: 'GET',
                        headers: {
                            'Accept-Language': lang,
                            'Content-Type': 'application/json'
                        }
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var getSuggestionKeyword = function (msBaseUrl, keyword, language, limit) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
    var encodedKeyword, apiUrl, suggestions, response, err_2;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                encodedKeyword = encodeURIComponent(keyword);
                apiUrl = "".concat(msBaseUrl, "/hot-keywords/api/v2/keywords/suggestion?query=").concat(encodedKeyword, "&limit=").concat(limit, "&lang=").concat(language);
                suggestions = {
                    data: []
                };
                if (keyword === '') {
                    return [2 /*return*/, suggestions];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch(apiUrl, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/vnd.api+json',
                            Accept: 'application/vnd.api+json',
                            'Accept-Language': language
                        }
                    })];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 3: return [2 /*return*/, _a.sent()];
            case 4:
                err_2 = _a.sent();
                // TODO: Log Error To Sentry
                console.debug('error getHotKeywords', err_2);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/, suggestions];
        }
    });
}); };
var EMPTY_RESPONSE = {
    data: [],
    facets: {},
    meta: {
        code: 400,
        message: '',
        nbHits: 0,
        page: 0,
        nbPages: 0,
        hitsPerPage: 0
    }
};
var getSearchJob = function (msBaseUrl, postData) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
    var URL_1, onlyAddText, response, responseData, ex_1;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                URL_1 = "".concat(msBaseUrl, "/job-search/v1.0/search");
                onlyAddText = localStorage.getItem('onlyAddText');
                if (!!onlyAddText) return [3 /*break*/, 3];
                return [4 /*yield*/, fetch(URL_1, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Source': 'Page-Container'
                        },
                        body: JSON.stringify(postData)
                    })];
            case 1:
                response = _a.sent();
                if (!(response.status === _constants_js__WEBPACK_IMPORTED_MODULE_2__/* .SUCCESS_CODE */ .Gh)) return [3 /*break*/, 3];
                return [4 /*yield*/, response.json()];
            case 2:
                responseData = _a.sent();
                return [2 /*return*/, responseData !== null && responseData !== void 0 ? responseData : EMPTY_RESPONSE];
            case 3: return [2 /*return*/, EMPTY_RESPONSE];
            case 4:
                ex_1 = _a.sent();
                console.error(ex_1);
                return [2 /*return*/, EMPTY_RESPONSE];
            case 5: return [2 /*return*/];
        }
    });
}); };
var trackSuggestionKeywords = function (_a) {
    var msBaseUrl = _a.msBaseUrl, language = _a.language, body = _a.body;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
        var URL_2, err_3;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    URL_2 = "".concat(msBaseUrl, "/hot-keywords/api/v2/keywords/suggestion");
                    return [4 /*yield*/, fetch(URL_2, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': language
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_3 = _b.sent();
                    // TODO: Log Error To Sentry
                    console.error('error track suggestion keyword', err_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
};
var getJobYouWillLove = function (params) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
    var msBaseUrl, _a, jobId, _b, limit, userId, langCode, URL_3, response, err_4;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                msBaseUrl = params.msBaseUrl, _a = params.jobId, jobId = _a === void 0 ? 0 : _a, _b = params.limit, limit = _b === void 0 ? 5 : _b, userId = params.userId, langCode = params.langCode;
                URL_3 = "".concat(msBaseUrl, "/smartnavi/v2/jobs?jobId=").concat(jobId, "&limit=").concat(limit, "&user=").concat(userId, "&l=").concat(langCode);
                return [4 /*yield*/, fetch(URL_3, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': langCode
                        }
                    })];
            case 1:
                response = _c.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _c.sent()];
            case 3:
                err_4 = _c.sent();
                console.error('getJobYouWillLove', err_4);
                return [2 /*return*/, {
                        jobs: [],
                        total: 0,
                        source: ''
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };


//# sourceMappingURL=apiServices.js.map


/***/ }),

/***/ 83528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ UTM_JOB_YOU_WILL_LOVE; },
/* harmony export */   "DG": function() { return /* binding */ UTM_SEARCH_JOB_YOU_LOVE; },
/* harmony export */   "FB": function() { return /* binding */ defaultSearchFilterParams; },
/* harmony export */   "Gf": function() { return /* binding */ DEBOUNCE_SEARCH_TIME; },
/* harmony export */   "Gh": function() { return /* binding */ SUCCESS_CODE; },
/* harmony export */   "JI": function() { return /* binding */ DEBOUNCE_SEARCH_TOP_JOB_TIME; },
/* harmony export */   "Kr": function() { return /* binding */ VNW_SEARCH_JOB_CITY_COOKIE_NAME; },
/* harmony export */   "Mt": function() { return /* binding */ RECENT_SEARCH; },
/* harmony export */   "Nk": function() { return /* binding */ DEFAULT_COMPANY_LOGO; },
/* harmony export */   "Ps": function() { return /* binding */ KEYCODE; },
/* harmony export */   "R_": function() { return /* binding */ SUGGEST_COMPANY_MAX; },
/* harmony export */   "TT": function() { return /* binding */ COMPANY_LOGO_NAME; },
/* harmony export */   "Uj": function() { return /* binding */ DEFAULT_SEARCH_BAR_OPTIONS; },
/* harmony export */   "YA": function() { return /* binding */ RETRIEVE_FIELDS_SEARCH; },
/* harmony export */   "_o": function() { return /* binding */ SEARCH_INPUT_QUERY_STRING; },
/* harmony export */   "m5": function() { return /* binding */ DEFAULT_MAX_LENGTH_INPUT; },
/* harmony export */   "mF": function() { return /* binding */ DEFAULT_LIMIT_SUGGESTION; }
/* harmony export */ });
/* unused harmony export keyCode */
'use client';

var keyCode = {
    Escape: 'Escape',
    ArrowDown: 'ArrowDown',
    ArrowUp: 'ArrowUp',
    Enter: 'Enter',
    Tab: 'Tab',
    Space: ' '
};
var VNW_SEARCH_JOB_CITY_COOKIE_NAME = 'VNWSearchJob[city]';
var RECENT_SEARCH = '_recent_searches_v1';
var DEFAULT_LIMIT_SUGGESTION = 5;
var DEBOUNCE_SEARCH_TIME = 400;
var DEBOUNCE_SEARCH_TOP_JOB_TIME = 1000; // 1s
var RETRIEVE_FIELDS_SEARCH = [
    'address',
    'benefits',
    'jobTitle',
    'salaryMax',
    'isSalaryVisible',
    'jobLevelVI',
    'isShowLogo',
    'salaryMin',
    'companyLogo',
    'userId',
    'jobUrl',
    'jobLevel',
    'jobLevelId',
    'jobId',
    'companyId',
    'approvedOn',
    'isAnonymous',
    'alias',
    'expiredOn',
    'industries',
    'workingLocations',
    'services',
    'service_names',
    'companyName',
    'salary',
    'onlineOn',
    'simpleServices',
    'visibilityDisplay',
    'isShowLogoInSearch',
    'priorityOrder',
    'skills',
    'profilePublishedSiteMask',
    'jobDescription',
    'jobRequirement',
    'prettySalary',
    'requiredCoverLetter',
    'languageSelectedVI',
    'languageSelected',
    'languageSelectedId',
    'numberOfRecruits',
    'performance_outcome_at_event',
    'performance_as_of'
];
var DEFAULT_MAX_LENGTH_INPUT = 100;
// Input className using for querySelector
var SEARCH_INPUT_QUERY_STRING = 'input.class-input-recommend';
var defaultSearchFilterParams = {
    salary: [-1, -1],
    benefitIds: [],
    categoryId: [],
    locationId: [],
    districtId: [],
    jobLevelId: -1,
    typeWorkingId: -1,
    isUrgentJob: false,
    companySizeId: -1,
    salaryCurrency: 1
};
/**
 * VNW - 16434 [SearchBar] Company Search
 *
 * SUGGEST_COMPANY_MAX means each suggestion keyword count equal company slice
 * This only happen when have topJobItem
 * example:
 * 0 keyword equal 4 companies      (Display: 4 companies, 0 keyword, 1 top job item)
 * 1 keyword equal 3 companies      (Display: 3 companies, 1 keyword, 1 top job item)
 * 2 keywords equal 2 companies     (Display: 2 companies, 2 keywords, 1 top job item)
 * 3 keywords equal 2 companies     (Display: 2 companies, 3 keywords, 1 top job item)
 * 4 keywords equals 2 companies    (Display: 2 companies, 2 keywords, 1 top job item)
 */
var SUGGEST_COMPANY_MAX = [4, 3, 2, 2, 2];
var DEFAULT_COMPANY_LOGO = 'https://images.vietnamworks.com/img/company-default-logo.svg';
// Link of company logo response from server
var COMPANY_LOGO_NAME = 'company-default-logo.png';
var DEFAULT_SEARCH_BAR_OPTIONS = {
    isNeedNavigate: true,
    isHomepage: false,
    maxInputLength: DEFAULT_MAX_LENGTH_INPUT
};
// KeyCode
var KEYCODE = {
    ENTER: 'Enter',
    ESCAPE: 'Escape',
    ARROW_DOWN: 'ArrowDown',
    ARROW_UP: 'ArrowUp',
    TAB: 'Tab',
    SPACE: 'Space'
};
var UTM_SEARCH_JOB_YOU_LOVE = 'utm_source_navi=searchbox&utm_campaign_navi=jobyouwilllove&utm_content_navi=searchjob';
var UTM_JOB_YOU_WILL_LOVE = 'utm_source_navi=searchbox&utm_campaign_navi=jobyouwilllove&utm_content_navi=SmartNaviIOP';
var SUCCESS_CODE = 200;


//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 49625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ ACTIONS; }
/* harmony export */ });
'use client';

var ACTIONS;
(function (ACTIONS) {
    ACTIONS["SHOW"] = "SHOW";
    ACTIONS["FORCE_CONTROL"] = "FORCE_CONTROL";
    ACTIONS["SET_KEYWORD"] = "SET_KEYWORD";
    ACTIONS["SET_TOP_JOB_ITEM"] = "SET_TOP_JOB_ITEM";
    ACTIONS["SET_HOT_KEYWORDS"] = "SET_HOT_KEYWORDS";
    ACTIONS["SET_SUGGESTIONS"] = "SET_SUGGESTIONS";
    ACTIONS["BLUR_BACKGROUND"] = "BLUR_BACKGROUND";
    ACTIONS["SET_HIGHLIGHT_JOB"] = "SET_HIGHLIGHT_JOB";
    ACTIONS["SET_FIRST_TIME_LOAD"] = "SET_FIRST_TIME_LOAD";
    ACTIONS["OPEN_DROP_DOWN"] = "OPEN_DROP_DOWN";
    ACTIONS["CLOSE_DROP_DOWN"] = "CLOSE_DROP_DOWN";
    ACTIONS["UPDATE_SELECTED_SUGGESTION_INDEX"] = "UPDATE_SELECTED_SUGGESTION_INDEX";
    ACTIONS["TOGGLE_LOCK_DEBOUNCE"] = "TOGGLE_LOCK_DEBOUNCE";
    ACTIONS["SET_JOB_YOU_WILL_LOVE"] = "SET_JOB_YOU_WILL_LOVE";
    ACTIONS["SET_SEARCH_JOB_YOU_LOVE"] = "SET_SEARCH_JOB_YOU_LOVE";
    ACTIONS["SET_RECENT_KEYWORDS"] = "SET_RECENT_KEYWORDS";
    ACTIONS["SET_LOCATIONS"] = "SET_LOCATIONS";
})(ACTIONS || (ACTIONS = {}));


//# sourceMappingURL=actions.js.map


/***/ }),

/***/ 17224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ initialSearchBar; }
/* harmony export */ });
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84051);
'use client';



var initialSearchBar = {
    keyword: '',
    isShow: false,
    forceControllDropdown: _types_js__WEBPACK_IMPORTED_MODULE_0__/* .EForceControDropdown.JUST_SHOW_DROPDOWN_CONTENT */ .q.JUST_SHOW_DROPDOWN_CONTENT,
    isLoaded: false,
    isBlurBackground: false,
    isInMobile: true,
    topJobItem: null,
    highlightJob: null,
    hotKeywords: [],
    suggestions: [],
    selectedSuggestionIndex: -1,
    isLockedDebounce: false,
    jobYouWillLove: [],
    searchJobYouLove: [],
    recentSearch: [],
    locations: []
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 23174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ SearchBarContext; },
/* harmony export */   "V": function() { return /* binding */ searchBarReducer; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74982);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17224);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84051);
/* harmony import */ var _actions_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49625);
/* harmony import */ var _Utils_constants_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96782);
/* harmony import */ var _TreeSelect_helpers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71078);
'use client';









var searchBarReducer = function (state, action) {
    var _a, _b, _c, _d, _e;
    var type = action.type;
    var clonedState = (0,_TreeSelect_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .deepCloneObject */ .kh)(state);
    switch (type) {
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SHOW */ .a.SHOW: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { isShow: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.FORCE_CONTROL */ .a.FORCE_CONTROL: {
            switch (action.payload) {
                case _types_js__WEBPACK_IMPORTED_MODULE_4__/* .EForceControDropdown.CLOSE_ALL */ .q.CLOSE_ALL:
                    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { forceControllDropdown: _types_js__WEBPACK_IMPORTED_MODULE_4__/* .EForceControDropdown.CLOSE_ALL */ .q.CLOSE_ALL, isBlurBackground: false, isShow: false, selectedSuggestionIndex: -1 });
                case _types_js__WEBPACK_IMPORTED_MODULE_4__/* .EForceControDropdown.JUST_SHOW_DROPDOWN_CONTENT */ .q.JUST_SHOW_DROPDOWN_CONTENT:
                    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { forceControllDropdown: _types_js__WEBPACK_IMPORTED_MODULE_4__/* .EForceControDropdown.JUST_SHOW_DROPDOWN_CONTENT */ .q.JUST_SHOW_DROPDOWN_CONTENT, isBlurBackground: true, isShow: true });
                case _types_js__WEBPACK_IMPORTED_MODULE_4__/* .EForceControDropdown.JUST_SHOW_DROPDOWN_TREE_SELECT */ .q.JUST_SHOW_DROPDOWN_TREE_SELECT:
                    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { isBlurBackground: true, isShow: true, forceControllDropdown: _types_js__WEBPACK_IMPORTED_MODULE_4__/* .EForceControDropdown.JUST_SHOW_DROPDOWN_TREE_SELECT */ .q.JUST_SHOW_DROPDOWN_TREE_SELECT });
                default:
                    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state);
            }
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.BLUR_BACKGROUND */ .a.BLUR_BACKGROUND: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { isBlurBackground: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SET_KEYWORD */ .a.SET_KEYWORD: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { keyword: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SET_TOP_JOB_ITEM */ .a.SET_TOP_JOB_ITEM: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, clonedState), { topJobItem: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SET_HIGHLIGHT_JOB */ .a.SET_HIGHLIGHT_JOB: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, clonedState), { highlightJob: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SET_FIRST_TIME_LOAD */ .a.SET_FIRST_TIME_LOAD: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { isLoaded: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.OPEN_DROP_DOWN */ .a.OPEN_DROP_DOWN: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { isBlurBackground: true, isShow: true });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.CLOSE_DROP_DOWN */ .a.CLOSE_DROP_DOWN: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { isBlurBackground: false, isShow: false, selectedSuggestionIndex: -1 });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SET_HOT_KEYWORDS */ .a.SET_HOT_KEYWORDS: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { hotKeywords: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SET_SUGGESTIONS */ .a.SET_SUGGESTIONS: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { suggestions: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.UPDATE_SELECTED_SUGGESTION_INDEX */ .a.UPDATE_SELECTED_SUGGESTION_INDEX: {
            var nextIndex = action.payload;
            var _f = clonedState.suggestions, suggestions = _f === void 0 ? [] : _f, keyword = clonedState.keyword;
            var isSuggest = ((_a = suggestions[nextIndex]) === null || _a === void 0 ? void 0 : _a.type) === 'suggest';
            var nextKeyword = isSuggest
                ? (_c = (_b = suggestions[nextIndex]) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.suggest
                : (_e = (_d = suggestions[nextIndex]) === null || _d === void 0 ? void 0 : _d.attributes) === null || _e === void 0 ? void 0 : _e.companyName;
            var updateKeyword = keyword;
            if (nextKeyword) {
                updateKeyword = nextKeyword;
            }
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, clonedState), { selectedSuggestionIndex: action.payload, keyword: updateKeyword, isLockedDebounce: true });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.TOGGLE_LOCK_DEBOUNCE */ .a.TOGGLE_LOCK_DEBOUNCE: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { isLockedDebounce: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SET_JOB_YOU_WILL_LOVE */ .a.SET_JOB_YOU_WILL_LOVE: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { jobYouWillLove: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SET_SEARCH_JOB_YOU_LOVE */ .a.SET_SEARCH_JOB_YOU_LOVE: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { searchJobYouLove: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SET_RECENT_KEYWORDS */ .a.SET_RECENT_KEYWORDS: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { recentSearch: action.payload });
        }
        case _actions_js__WEBPACK_IMPORTED_MODULE_2__/* .ACTIONS.SET_LOCATIONS */ .a.SET_LOCATIONS: {
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state), { locations: action.payload });
        }
        default:
            console.error('Unknown type of Search Bar Reducer');
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, state);
    }
};
var SearchBarContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    state: _index_js__WEBPACK_IMPORTED_MODULE_5__/* .initialSearchBar */ .n,
    props: {
        langCode: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_6__/* .ELanguage.VI */ .Df.VI,
        isMobile: true,
        pageName: '',
        msBaseUrl: '',
        dataProvider: null,
        userId: 0,
        userIP: '::1',
        VNWAppId: '',
        responsiveStyle: 'fill',
        optionList: [],
        mode: 'staging',
        userJobFunction: []
    },
    t: function (text) {
        return text;
    },
    dispatch: function () { },
    search: function () { }
});


//# sourceMappingURL=reducer.js.map


/***/ }),

/***/ 84051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ EForceControDropdown; }
/* harmony export */ });
'use client';

var EForceControDropdown;
(function (EForceControDropdown) {
    EForceControDropdown["JUST_SHOW_DROPDOWN_CONTENT"] = "JUST_SHOW_DROPDOWN_CONTENT";
    EForceControDropdown["JUST_SHOW_DROPDOWN_TREE_SELECT"] = "JUST_SHOW_DROPDOWN_TREE_SELECT";
    EForceControDropdown["CLOSE_ALL"] = "CLOSE_ALL";
})(EForceControDropdown || (EForceControDropdown = {}));


//# sourceMappingURL=types.js.map


/***/ }),

/***/ 30871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ index; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(74982);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/SearchBarUnstable/context/reducer.js
var reducer = __webpack_require__(23174);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/SearchBarUnstable/context/index.js
var context = __webpack_require__(17224);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(48421);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/SearchBarUnstable/SearchBar.css.js
'use client';





var fadeIn = (0,styled_components_browser_esm/* keyframes */.F4)(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"], ["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"])));
var fadeOut = (0,styled_components_browser_esm/* keyframes */.F4)(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n"], ["\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n"])));
var SearchBarWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n    z-index: 100;\n    width: 100%;\n    top: 0;\n    transition: all 0.25s ease-in-out;\n    ", "\n"], ["\n    ", "\n    z-index: 100;\n    width: 100%;\n    top: 0;\n    transition: all 0.25s ease-in-out;\n    ", "\n"])), function (_a) {
    var isShow = _a.isShow;
    if (isShow) {
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                position: absolute;\n            "], ["\n                position: absolute;\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            position: ", ";\n        "], ["\n            position: ", ";\n        "])), function (_a) {
        var isMountedDropdown = _a.isMountedDropdown;
        return (isMountedDropdown ? 'absolute' : 'relative');
    });
}, function (_a) {
    var isMobile = _a.isMobile;
    if (!isMobile) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            right: 0;\n            ", "\n        "], ["\n            right: 0;\n            ", "\n        "])), function (_a) {
        var isShow = _a.isShow;
        if (isShow) {
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        position: fixed;\n                    "], ["\n                        position: fixed;\n                    "])));
        }
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    position: ", ";\n                "], ["\n                    position: ", ";\n                "])), function (_a) {
            var isMountedDropdown = _a.isMountedDropdown;
            return (isMountedDropdown ? 'fixed' : 'relative');
        });
    });
});
var SearchBarContentWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    transition: all 0.25s ease-in-out;\n    ", "\n"], ["\n    transition: all 0.25s ease-in-out;\n    ", "\n"])), function (_a) {
    var isHomepage = _a.isHomepage;
    if (isHomepage) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            @media (min-width: 767px) {\n                margin-right: 16px;\n            }\n        "], ["\n            @media (min-width: 767px) {\n                margin-right: 16px;\n            }\n        "])));
});
var SearchBlockHolder = styled_components_browser_esm/* default.div */.ZP.div(templateObject_13 || (templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n    height: 40px;\n"], ["\n    ", "\n    height: 40px;\n"])), function (_a) {
    var isMountedDropdown = _a.isMountedDropdown;
    if (isMountedDropdown) {
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                display: block;\n            "], ["\n                display: block;\n            "])));
    }
    else {
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                display: ", ";\n            "], ["\n                display: ", ";\n            "])), function (_a) {
            var isShow = _a.isShow;
            return (isShow ? 'block' : 'none');
        });
    }
});
var SearchBarBackground = styled_components_browser_esm/* default.div */.ZP.div(templateObject_14 || (templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    opacity: 1;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    @supports (height: 100dvh) {\n        height: 100dvh;\n    }\n    z-index: 100;\n    background-color: rgba(0, 0, 0, 0.6);\n    animation: ", " 0.25s ease-in-out forwards;\n"], ["\n    opacity: 1;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    @supports (height: 100dvh) {\n        height: 100dvh;\n    }\n    z-index: 100;\n    background-color: rgba(0, 0, 0, 0.6);\n    animation: ", " 0.25s ease-in-out forwards;\n"])), function (_a) {
    var isShow = _a.isShow;
    return (isShow ? fadeIn : fadeOut);
});
var SearchBarContent = styled_components_browser_esm/* default.div */.ZP.div(templateObject_18 || (templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    border-radius: 95px;\n    display: block;\n    height: 100%;\n    position: relative;\n    z-index: 10;\n    max-width: 100%;\n    ", "\n    ", "\n"], ["\n    border-radius: 95px;\n    display: block;\n    height: 100%;\n    position: relative;\n    z-index: 10;\n    max-width: 100%;\n    ", "\n    ", "\n"])), function (_a) {
    var isShow = _a.isShow;
    if (isShow) {
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_15 || (templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                width: 100%;\n            "], ["\n                width: 100%;\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_16 || (templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            width: ", ";\n        "], ["\n            width: ", ";\n        "])), function (_a) {
        var initialWidth = _a.initialWidth;
        if (initialWidth > -1) {
            return "".concat(initialWidth, "px");
        }
        else if (initialWidth === -2) {
            return "calc(100% - 32px)";
        }
        else {
            return '100%';
        }
    });
}, function (_a) {
    var isMounted = _a.isMounted;
    if (!isMounted) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_17 || (templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            transition: all 0.5s cubic-bezier(0.8, -0.1, 0.1, 1.2);\n        "], ["\n            transition: all 0.5s cubic-bezier(0.8, -0.1, 0.1, 1.2);\n        "])));
});
styled_components_browser_esm/* default.div */.ZP.div(templateObject_19 || (templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
var DropDownContentOverflow = styled_components_browser_esm/* default.div */.ZP.div(templateObject_21 || (templateObject_21 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: ", ";\n    overflow: hidden;\n    border-radius: 24px;\n    margin-top: 8px;\n    ", "\n"], ["\n    display: ", ";\n    overflow: hidden;\n    border-radius: 24px;\n    margin-top: 8px;\n    ", "\n"])), function (_a) {
    var isHidden = _a.isHidden;
    return (!isHidden ? 'block' : 'none');
}, function (_a) {
    var isMobile = _a.isMobile;
    if (!isMobile) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_20 || (templateObject_20 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            position: fixed;\n            z-index: 11;\n            left: 0;\n            top: 16px;\n            margin-top: 58px;\n            margin-left: 8px;\n            margin-right: 8px;\n            border-radius: 12px;\n        "], ["\n            position: fixed;\n            z-index: 11;\n            left: 0;\n            top: 16px;\n            margin-top: 58px;\n            margin-left: 8px;\n            margin-right: 8px;\n            border-radius: 12px;\n        "])));
});
styled_components_browser_esm/* default.div */.ZP.div(templateObject_22 || (templateObject_22 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 50px;\n    height: 50px;\n    border-radius: 48px;\n    background-color: ", ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n"], ["\n    width: 50px;\n    height: 50px;\n    border-radius: 48px;\n    background-color: ", ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n"])), Colors/* colors.primary.40 */.O9.primary[40]);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22;


//# sourceMappingURL=SearchBar.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/SearchBarUnstable/translation.js
'use client';

var translations = {
    Search: 'Tìm kiếm',
    'Find your dream jobs': 'Tìm kiếm công việc mơ ước',
    'All Locations': 'Tất cả địa điểm',
    'All locations': 'Tất cả địa điểm',
    'All Province/City': 'Tất cả tỉnh/thành phố',
    'Select Province/City': 'Chọn tỉnh/thành phố',
    'You have selected up to three Province/City': 'Bạn đã chọn tối đa ba tỉnh/thành phố',
    'You have selected up to three locations': 'Bạn đã chọn tối đa ba địa điểm',
    All: 'Tất cả',
    Location: 'Địa điểm',
    Locations: 'Địa điểm',
    Apply: 'Áp dụng',
    Cancel: 'Huỷ',
    'Selected Locations': 'Địa điểm đã chọn',
    'No Result': 'Không có kết quả',
    'Search for jobs, companies, skills': 'Tìm kiếm việc làm, công ty, kỹ năng',
    'Try Searching For': 'Có Phải Bạn Đang Tìm',
    'Hot Keywords': 'Từ Khoá Phổ Biến',
    'No suggestions for': 'Không có gợi ý cho',
    'Jobs you will love': 'Việc làm bạn sẽ thích',
    Profile: 'Hồ sơ',
    Salary: 'Mức lương',
    Interview: 'Phỏng vấn',
    jobs: 'việc làm',
    job: 'việc làm',
    Job: 'Việc làm',
    Discovery: 'Khám phá',
    Company: 'Công ty',
    'Clear all': 'Xoá hết',
    'Wow CV': 'Wow CV',
    'Recent searchs': 'Tìm kiếm gần đây',
    'Prepare your interview': 'Chuẩn bị cho buổi phỏng vấn',
    'Update your resume': '	Cập nhật hồ sơ của bạn',
    'Impress recruiter': 'Gây ấn tượng với nhà tuyển dụng',
    'Know your worth': 'Tìm hiểu mức lương phù hợp',
    '/job-search/all-jobs': '/tim-viec-lam/tim-tat-ca-viec-lam',
    'You have no keyword search': 'Bạn không có tìm kiếm từ khoá nào',
    'No recent searches': 'Không có tìm kiếm gần đây',
    'Your search will be listed here in the future': 'Lịch sử từ khoá tìm kiếm của bạn sẽ được hiển thị ở đây',
    'Double check your keywords or try another search term.': 'Kiểm tra lại từ khóa hoặc thử một cụm từ tìm kiếm khác.',
    'Enter a job title to view a set of interview questions': 'Nhập chức danh để xem bộ câu hỏi phỏng vấn',
    'Enter a job title to view salary': 'Nhập chức danh để xem mức lương',
    'https://www.vietnamworks.com/my-career-center/dashboard': 'https://www.vietnamworks.com/quan-ly-nghe-nghiep/quan-ly-ho-so',
    '/my-career-center/dashboard': '/quan-ly-nghe-nghiep/quan-ly-ho-so',
    '/my-profile': '/ho-so',
    'All Districts': 'Tất cả Quận/Huyện',
    "There are no suitable job recommendations for you on VietnamWorks at the moment. We'll notify you as soon as new opportunities come up!": 'Hiện tại, chưa có gợi ý công việc phù hợp với bạn trên VietnamWorks. Chúng tôi sẽ thông báo ngay khi có cơ hội mới!'
};


//# sourceMappingURL=translation.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/SearchBarUnstable/context/actions.js
var actions = __webpack_require__(49625);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/SearchBarUnstable/context/types.js
var types = __webpack_require__(84051);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/SearchBarUnstable/components/SearchBarBackground/index.js
'use client';








var SearchBackground = function () {
    var _a = (0,react.useContext)(reducer/* SearchBarContext */.O), state = _a.state, dispatch = _a.dispatch;
    var isBlurBackground = state.isBlurBackground, isShow = state.isShow;
    var _b = (0,react.useState)(false), isMounted = _b[0], setMounted = _b[1];
    var onAnimationEnd = function () {
        if (isBlurBackground) {
            return;
        }
        setMounted(false);
    };
    (0,react.useEffect)(function () {
        if (!isBlurBackground) {
            return;
        }
        setMounted(true);
    }, [isBlurBackground]);
    return isMounted ? ((0,jsx_runtime.jsx)(SearchBarBackground, { "data-cname": 'SearchBackground', isShow: isBlurBackground, onClick: function () {
            if (isShow) {
                dispatch({
                    type: actions/* ACTIONS.FORCE_CONTROL */.a.FORCE_CONTROL,
                    payload: types/* EForceControDropdown.CLOSE_ALL */.q.CLOSE_ALL
                });
            }
        }, onAnimationEnd: onAnimationEnd })) : ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}));
};
var SearchBackground$1 = react.memo(SearchBackground);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/SearchBarUnstable/components/SearchSection/SearchSection.css.js
'use client';





var effectFadeUp = (0,styled_components_browser_esm/* keyframes */.F4)(SearchSection_css_templateObject_1 || (SearchSection_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"], ["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"])));
var effectFadeDown = (0,styled_components_browser_esm/* keyframes */.F4)(SearchSection_css_templateObject_2 || (SearchSection_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n"], ["\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n"])));
var extendFromRight = (0,styled_components_browser_esm/* keyframes */.F4)(SearchSection_css_templateObject_3 || (SearchSection_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    translate: calc(100% - 40px) 0;\n    animation-timing-function: cubic-bezier(0.8, -0.1, 0.1, 1.2);\n    width: 40px;\n    opacity: 0;\n  }\n  100% {\n    translate: 0% 0;\n    width: 100%;\n    opacity: 1;\n  }\n"], ["\n  0% {\n    translate: calc(100% - 40px) 0;\n    animation-timing-function: cubic-bezier(0.8, -0.1, 0.1, 1.2);\n    width: 40px;\n    opacity: 0;\n  }\n  100% {\n    translate: 0% 0;\n    width: 100%;\n    opacity: 1;\n  }\n"])));
var collapseToRight = (0,styled_components_browser_esm/* keyframes */.F4)(SearchSection_css_templateObject_4 || (SearchSection_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    translate: 0% 0;\n    animation-timing-function: cubic-bezier(0.8, -0.1, 0.1, 1.2);\n    width: 100%;\n    opacity: 1;\n  }\n  100% {\n    translate: calc(100% - 40px) 0;\n    width: 40px;\n    opacity: 0;\n  }\n"], ["\n  0% {\n    translate: 0% 0;\n    animation-timing-function: cubic-bezier(0.8, -0.1, 0.1, 1.2);\n    width: 100%;\n    opacity: 1;\n  }\n  100% {\n    translate: calc(100% - 40px) 0;\n    width: 40px;\n    opacity: 0;\n  }\n"])));
var CustomTreeSelect = styled_components_browser_esm/* default.div */.ZP.div(SearchSection_css_templateObject_6 || (SearchSection_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    div[data-id='tree-select'] {\n        div.tree-select-input {\n            height: 32px;\n        }\n        ", ";\n    }\n    @media screen and (max-width: 767px) {\n        div[data-id='tree-select'] {\n            div.tree-select-input {\n                height: 40px;\n            }\n        }\n        display: none;\n    }\n"], ["\n    div[data-id='tree-select'] {\n        div.tree-select-input {\n            height: 32px;\n        }\n        ", ";\n    }\n    @media screen and (max-width: 767px) {\n        div[data-id='tree-select'] {\n            div.tree-select-input {\n                height: 40px;\n            }\n        }\n        display: none;\n    }\n"])), function (_a) {
    var isShow = _a.isShow, isHomePage = _a.isHomePage;
    if (isHomePage) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_5 || (SearchSection_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                @media screen and (max-width: 1023px) {\n                    display: ", ";\n                }\n            "], ["\n                @media screen and (max-width: 1023px) {\n                    display: ", ";\n                }\n            "])), isShow ? 'block' : 'none');
});
var ActionGroup = styled_components_browser_esm/* default.div */.ZP.div(SearchSection_css_templateObject_7 || (SearchSection_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: ", ";\n    width: auto;\n    align-items: center;\n    > button {\n        width: 100%;\n        height: 32px;\n        border-radius: 48px;\n        padding-left: 12px;\n        padding-right: 12px;\n    }\n    animation: ", " 0.25s ease-in-out forwards;\n    @media screen and (max-width: 768px) {\n        .search {\n            &__button {\n                display: ", ";\n            }\n        }\n    }\n    @media screen and (max-width: 767px) {\n        > button {\n            height: 40px;\n        }\n        .search {\n            &__button {\n                display: none;\n            }\n        }\n    }\n"], ["\n    display: ", ";\n    width: auto;\n    align-items: center;\n    > button {\n        width: 100%;\n        height: 32px;\n        border-radius: 48px;\n        padding-left: 12px;\n        padding-right: 12px;\n    }\n    animation: ", " 0.25s ease-in-out forwards;\n    @media screen and (max-width: 768px) {\n        .search {\n            &__button {\n                display: ", ";\n            }\n        }\n    }\n    @media screen and (max-width: 767px) {\n        > button {\n            height: 40px;\n        }\n        .search {\n            &__button {\n                display: none;\n            }\n        }\n    }\n"])), function (_a) {
    var isShow = _a.isShow, isMobile = _a.isMobile;
    if (isMobile)
        return 'none';
    return isShow ? 'flex' : 'none';
}, effectFadeUp, function (_a) {
    var isShow = _a.isShow;
    return (isShow ? 'block' : 'none');
});
var InputGroup = styled_components_browser_esm/* default.div */.ZP.div(SearchSection_css_templateObject_10 || (SearchSection_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    width: 100%;\n    input.class-input-recommend {\n        border: none;\n        border-radius: 32px;\n        background-color: transparent !important;\n        color: #fff;\n        -webkit-text-fill-color: #fff;\n    }\n    svg.remove-icon {\n        top: 7px !important;\n    }\n    ", "\n"], ["\n    display: flex;\n    width: 100%;\n    input.class-input-recommend {\n        border: none;\n        border-radius: 32px;\n        background-color: transparent !important;\n        color: #fff;\n        -webkit-text-fill-color: #fff;\n    }\n    svg.remove-icon {\n        top: 7px !important;\n    }\n    ", "\n"])), function (_a) {
    var isMobile = _a.isMobile;
    if (!isMobile) {
        return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_8 || (SearchSection_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                input.class-input-recommend {\n                    height: 32px;\n                    border-radius: 32px;\n                    background-color: transparent !important;\n                    color: #fff;\n                    -webkit-text-fill-color: #fff;\n                }\n            "], ["\n                input.class-input-recommend {\n                    height: 32px;\n                    border-radius: 32px;\n                    background-color: transparent !important;\n                    color: #fff;\n                    -webkit-text-fill-color: #fff;\n                }\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_9 || (SearchSection_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border-radius: 32px;\n            svg.remove-icon {\n                top: 8px !important;\n            }\n            input.class-input-recommend {\n                height: 40px;\n                color: #333;\n                -webkit-text-fill-color: #333;\n                /* >= 16px prevents mobile browsers from auto-zooming on input focus */\n                font-size: 16px !important;\n            }\n        "], ["\n            border-radius: 32px;\n            svg.remove-icon {\n                top: 8px !important;\n            }\n            input.class-input-recommend {\n                height: 40px;\n                color: #333;\n                -webkit-text-fill-color: #333;\n                /* >= 16px prevents mobile browsers from auto-zooming on input focus */\n                font-size: 16px !important;\n            }\n        "])));
});
var SearchSectionWrapper = styled_components_browser_esm/* default.div */.ZP.div(templateObject_24 || (templateObject_24 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    border-radius: 32px;\n    padding: ", ";\n    background-color: ", ";\n    input.class-input-recommend {\n        color: ", " !important;\n        -webkit-text-fill-color: ", " !important;\n    }\n    .sb-searchIcon {\n        svg {\n            path {\n                fill: ", ";\n            }\n        }\n    }\n    ", "\n    @media screen and (max-width: 767px) {\n        flex-wrap: wrap;\n        ", " {\n            order: 2;\n            flex-basis: 80%;\n        }\n        ", " {\n            flex-basis: ", ";\n        }\n        ", " {\n            flex: 1;\n        }\n    }\n    @media screen and (max-width: 425px) {\n        ", " {\n            flex-basis: 70%;\n        }\n        ", " {\n            flex-basis: ", ";\n        }\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    border-radius: 32px;\n    padding: ", ";\n    background-color: ", ";\n    input.class-input-recommend {\n        color: ", " !important;\n        -webkit-text-fill-color: ", " !important;\n    }\n    .sb-searchIcon {\n        svg {\n            path {\n                fill: ", ";\n            }\n        }\n    }\n    ", "\n    @media screen and (max-width: 767px) {\n        flex-wrap: wrap;\n        ", " {\n            order: 2;\n            flex-basis: 80%;\n        }\n        ", " {\n            flex-basis: ", ";\n        }\n        ", " {\n            flex: 1;\n        }\n    }\n    @media screen and (max-width: 425px) {\n        ", " {\n            flex-basis: 70%;\n        }\n        ", " {\n            flex-basis: ", ";\n        }\n    }\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? 0 : '4px');
}, Colors/* colors.primary.100 */.O9.primary[100], Colors/* colors.grey.30 */.O9.grey[30], Colors/* colors.grey.30 */.O9.grey[30], Colors/* colors.grey.20 */.O9.grey[20], function (_a) {
    var isMobile = _a.isMobile, isShow = _a.isShow;
    if (!isMobile) {
        return isShow
            ? (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_11 || (SearchSection_css_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                      input.class-input-recommend {\n                          color: ", " !important;\n                          -webkit-text-fill-color: ", " !important;\n                      }\n                      &:hover {\n                          .sb-searchIcon {\n                              svg {\n                                  path {\n                                      fill: ", " !important;\n                                  }\n                              }\n                          }\n                          input.class-input-recommend {\n                              &::placeholder {\n                                  color: ", " !important;\n                                  -webkit-text-fill-color: ", " !important;\n                              }\n                          }\n                      }\n                  "], ["\n                      input.class-input-recommend {\n                          color: ", " !important;\n                          -webkit-text-fill-color: ", " !important;\n                      }\n                      &:hover {\n                          .sb-searchIcon {\n                              svg {\n                                  path {\n                                      fill: ", " !important;\n                                  }\n                              }\n                          }\n                          input.class-input-recommend {\n                              &::placeholder {\n                                  color: ", " !important;\n                                  -webkit-text-fill-color: ", " !important;\n                              }\n                          }\n                      }\n                  "])), Colors/* colors.grey.30 */.O9.grey[30], Colors/* colors.grey.30 */.O9.grey[30], Colors/* colors.grey.20 */.O9.grey[20], Colors/* colors.neutral.50 */.O9.neutral[50], Colors/* colors.neutral.50 */.O9.neutral[50]) : '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_23 || (templateObject_23 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            position: fixed;\n            right: 0;\n            width: 100%;\n            max-width: calc(100% - 16px);\n            margin-left: 8px;\n            margin-right: 8px;\n            ", "\n            animation-timing-function: cubic-bezier(0.8, -0.1, 0.1, 1.2);\n            min-width: 40px;\n            border: none;\n            ", ";\n            ", "\n            /*  for page-container */\n            ", "\n        "], ["\n            position: fixed;\n            right: 0;\n            width: 100%;\n            max-width: calc(100% - 16px);\n            margin-left: 8px;\n            margin-right: 8px;\n            ", "\n            animation-timing-function: cubic-bezier(0.8, -0.1, 0.1, 1.2);\n            min-width: 40px;\n            border: none;\n            ", ";\n            ", "\n            /*  for page-container */\n            ", "\n        "])), function (_a) {
        var pageName = _a.pageName, isSupportAnim = _a.isSupportAnim;
        if (!isSupportAnim) {
            return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_12 || (SearchSection_css_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        animation: none !important;\n                        opacity: ", ";\n                    "], ["\n                        animation: none !important;\n                        opacity: ", ";\n                    "])), function (_a) {
                var isShow = _a.isShow;
                return (isShow ? 1 : 0);
            });
        }
        if (pageName === 'searchResult') {
            return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_13 || (SearchSection_css_templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        animation: ", " 0.5s forwards;\n                    "], ["\n                        animation: ", " 0.5s forwards;\n                    "])), function (_a) {
                var isShow = _a.isShow;
                return (isShow ? effectFadeUp : effectFadeDown);
            });
        }
        return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_14 || (SearchSection_css_templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    animation: ", " 0.5s forwards;\n                "], ["\n                    animation: ", " 0.5s forwards;\n                "])), function (_a) {
            var isShow = _a.isShow;
            return (isShow ? extendFromRight : collapseToRight);
        });
    }, function (_a) {
        var isMountedDropdown = _a.isMountedDropdown;
        if (!isMountedDropdown) {
            return '';
        }
        return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_15 || (SearchSection_css_templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    top: 16px;\n                "], ["\n                    top: 16px;\n                "])));
    }, function (_a) {
        var isShow = _a.isShow, isMountedDropdown = _a.isMountedDropdown;
        if (!isShow && !isMountedDropdown) {
            return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_16 || (SearchSection_css_templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        position: relative;\n                        height: 40px;\n                        width: 40px;\n                        max-width: 40px;\n                        margin: 0;\n                        opacity: 1 !important;\n                        translate: 0% 0 !important;\n                    "], ["\n                        position: relative;\n                        height: 40px;\n                        width: 40px;\n                        max-width: 40px;\n                        margin: 0;\n                        opacity: 1 !important;\n                        translate: 0% 0 !important;\n                    "])));
        }
        if (isMountedDropdown) {
            return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_17 || (SearchSection_css_templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        background-color: transparent;\n                        > div:first-child {\n                            background-color: ", ";\n                        }\n                    "], ["\n                        background-color: transparent;\n                        > div:first-child {\n                            background-color: ", ";\n                        }\n                    "])), Colors/* colors.neutral.95 */.O9.neutral[95]);
        }
        return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_18 || (SearchSection_css_templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
    }, function (_a) {
        var pageName = _a.pageName;
        if (pageName !== 'searchResult') {
            return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_19 || (SearchSection_css_templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                        background-color: ", ";\n                        > div > div > svg {\n                            path {\n                                fill: ", " !important;\n                            }\n                        }\n                    "], ["\n                        background-color: ", ";\n                        > div > div > svg {\n                            path {\n                                fill: ", " !important;\n                            }\n                        }\n                    "])), function (_a) {
                var isMountedDropdown = _a.isMountedDropdown;
                return isMountedDropdown ? 'transparent' : Colors/* colors.primary.40 */.O9.primary[40];
            }, function (_a) {
                var isMountedDropdown = _a.isMountedDropdown;
                return isMountedDropdown ? Colors/* colors.primary.20 */.O9.primary[20] : '#fff';
            });
        }
        return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_22 || (SearchSection_css_templateObject_22 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    left: 0;\n                    width: auto;\n                    max-width: 100%;\n                    ", "\n                    input.class-input-recommend {\n                        opacity: 1 !important;\n                        height: 42px !important;\n                        color: #333 !important;\n                        -webkit-text-fill-color: #333 !important;\n                    }\n                "], ["\n                    left: 0;\n                    width: auto;\n                    max-width: 100%;\n                    ", "\n                    input.class-input-recommend {\n                        opacity: 1 !important;\n                        height: 42px !important;\n                        color: #333 !important;\n                        -webkit-text-fill-color: #333 !important;\n                    }\n                "])), function (_a) {
            var isMountedDropdown = _a.isMountedDropdown;
            if (!isMountedDropdown) {
                return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_20 || (SearchSection_css_templateObject_20 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                background-color: #fff;\n                            "], ["\n                                background-color: #fff;\n                            "])));
            }
            return (0,styled_components_browser_esm/* css */.iv)(SearchSection_css_templateObject_21 || (SearchSection_css_templateObject_21 = (0,_tslib/* __makeTemplateObject */.cy)([""], [""])));
        });
    });
}, CustomTreeSelect, InputGroup, function (_a) {
    var isShow = _a.isShow;
    return (!isShow ? '100%' : '80%');
}, ActionGroup, CustomTreeSelect, InputGroup, function (_a) {
    var isShow = _a.isShow;
    return (!isShow ? '100%' : '70%');
});
var Icon = styled_components_browser_esm/* default.div */.ZP.div(templateObject_31 || (templateObject_31 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding-left: ", "px;\n\n    justify-content: center;\n    align-items: center;\n    ", "\n    ", "\n    @media screen and (max-width: 1023px) {\n        display: inline-flex !important;\n    }\n"], ["\n    padding-left: ", "px;\n\n    justify-content: center;\n    align-items: center;\n    ", "\n    ", "\n    @media screen and (max-width: 1023px) {\n        display: inline-flex !important;\n    }\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? 8 : 12);
}, function (_a) {
    var isHomePage = _a.isHomePage;
    if (isHomePage) {
        return (0,styled_components_browser_esm/* css */.iv)(templateObject_25 || (templateObject_25 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                display: inline-flex;\n            "], ["\n                display: inline-flex;\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_26 || (templateObject_26 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            display: none;\n        "], ["\n            display: none;\n        "])));
}, function (_a) {
    var isHaveKeyword = _a.isHaveKeyword;
    if (!isHaveKeyword) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_30 || (templateObject_30 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            svg {\n                path {\n                    ", "\n                }\n            }\n        "], ["\n            svg {\n                path {\n                    ", "\n                }\n            }\n        "])), function (_a) {
        var pageName = _a.pageName, isMobile = _a.isMobile;
        if (pageName === 'searchResult') {
            if (isMobile) {
                return (0,styled_components_browser_esm/* css */.iv)(templateObject_27 || (templateObject_27 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    fill: ", ";\n                                "], ["\n                                    fill: ", ";\n                                "])), Colors/* colors.grey.20 */.O9.grey[20]);
            }
            else {
                return (0,styled_components_browser_esm/* css */.iv)(templateObject_28 || (templateObject_28 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                    fill: ", ";\n                                "], ["\n                                    fill: ", ";\n                                "])), function (_a) {
                    var isShow = _a.isShow;
                    return (isShow ? Colors/* colors.grey.20 */.O9.grey[20] : Colors/* colors.grey.100 */.O9.grey[100]);
                });
            }
        }
        else {
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_29 || (templateObject_29 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                                fill: ", ";\n                            "], ["\n                                fill: ", ";\n                            "])), function (_a) {
                var isShow = _a.isShow;
                return (isShow ? Colors/* colors.grey.20 */.O9.grey[20] : Colors/* colors.grey.100 */.O9.grey[100]);
            });
        }
    });
});
var InputContent = styled_components_browser_esm/* default.div */.ZP.div(templateObject_32 || (templateObject_32 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    width: 100%;\n    > div {\n        width: 100%;\n    }\n    input {\n        border: none !important;\n        /* >= 16px prevents mobile browsers from auto-zooming on input focus */\n        font-size: 16px !important;\n        @media screen and (min-width: 1024px) {\n            font-size: 15px;\n        }\n        &:focus {\n            border: none !important;\n        }\n    }\n"], ["\n    display: flex;\n    width: 100%;\n    > div {\n        width: 100%;\n    }\n    input {\n        border: none !important;\n        /* >= 16px prevents mobile browsers from auto-zooming on input focus */\n        font-size: 16px !important;\n        @media screen and (min-width: 1024px) {\n            font-size: 15px;\n        }\n        &:focus {\n            border: none !important;\n        }\n    }\n"])));
var SearchIconWrap = styled_components_browser_esm/* default.span */.ZP.span(templateObject_33 || (templateObject_33 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    height: 100%;\n    align-items: center;\n    display: ", ";\n    @media screen and (max-width: 1023px) {\n        display: none !important;\n    }\n"], ["\n    width: 100%;\n    height: 100%;\n    align-items: center;\n    display: ", ";\n    @media screen and (max-width: 1023px) {\n        display: none !important;\n    }\n"])), function (_a) {
    var isHomepage = _a.isHomepage, isShow = _a.isShow;
    if (isHomepage || isShow) {
        return 'none';
    }
    return 'flex';
});
var TextButton = styled_components_browser_esm/* default.span */.ZP.span(templateObject_34 || (templateObject_34 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: ", ";\n"], ["\n    display: ", ";\n"])), function (_a) {
    var isHomepage = _a.isHomepage, isShow = _a.isShow;
    if (isHomepage || isShow) {
        return 'block';
    }
    return 'none';
});
var SearchSection_css_templateObject_1, SearchSection_css_templateObject_2, SearchSection_css_templateObject_3, SearchSection_css_templateObject_4, SearchSection_css_templateObject_5, SearchSection_css_templateObject_6, SearchSection_css_templateObject_7, SearchSection_css_templateObject_8, SearchSection_css_templateObject_9, SearchSection_css_templateObject_10, SearchSection_css_templateObject_11, SearchSection_css_templateObject_12, SearchSection_css_templateObject_13, SearchSection_css_templateObject_14, SearchSection_css_templateObject_15, SearchSection_css_templateObject_16, SearchSection_css_templateObject_17, SearchSection_css_templateObject_18, SearchSection_css_templateObject_19, SearchSection_css_templateObject_20, SearchSection_css_templateObject_21, SearchSection_css_templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34;


//# sourceMappingURL=SearchSection.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(25035);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/icons/index.js
'use client';




var IconArrowLeft = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 50 : _b, _c = _a.height, height = _c === void 0 ? 50 : _c, _d = _a.fill, fill = _d === void 0 ? 'unset' : _d, _e = _a.stroke, stroke = _e === void 0 ? 'unset' : _e, _f = _a.className, className = _f === void 0 ? '' : _f;
    return (jsx("svg", { width: width, height: height, fill: fill, className: className, stroke: stroke, xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', children: jsx("path", { d: 'M 19.8125 13.09375 C 19.59375 13.132813 19.398438 13.242188 19.25 13.40625 L 8.34375 24.28125 L 7.65625 25 L 8.34375 25.71875 L 19.25 36.59375 C 19.492188 36.890625 19.878906 37.027344 20.253906 36.941406 C 20.625 36.855469 20.917969 36.5625 21.003906 36.191406 C 21.089844 35.816406 20.953125 35.429688 20.65625 35.1875 L 11.46875 26 L 41 26 C 41.359375 26.003906 41.695313 25.816406 41.878906 25.503906 C 42.058594 25.191406 42.058594 24.808594 41.878906 24.496094 C 41.695313 24.183594 41.359375 23.996094 41 24 L 11.46875 24 L 20.65625 14.8125 C 20.980469 14.511719 21.066406 14.035156 20.871094 13.640625 C 20.679688 13.242188 20.246094 13.023438 19.8125 13.09375 Z' }) }));
};
var IconSearch = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.fill, fill = _d === void 0 ? '#333333' : _d;
    return ((0,jsx_runtime.jsx)("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 21 20', fill: 'none', children: (0,jsx_runtime.jsx)("path", { d: 'M8.87958 1.6665C5.05481 1.6665 1.93933 4.78198 1.93933 8.60676C1.93933 12.4315 5.05481 15.547 8.87958 15.547C10.5428 15.547 12.0703 14.9564 13.2674 13.976L17.4112 18.1198C17.4752 18.1864 17.5518 18.2396 17.6365 18.2762C17.7213 18.3128 17.8125 18.3322 17.9048 18.3331C17.9972 18.3341 18.0888 18.3166 18.1743 18.2817C18.2597 18.2468 18.3374 18.1952 18.4027 18.1299C18.468 18.0646 18.5196 17.9869 18.5545 17.9014C18.5894 17.8159 18.6069 17.7243 18.606 17.632C18.605 17.5397 18.5857 17.4485 18.549 17.3637C18.5124 17.2789 18.4592 17.2023 18.3926 17.1384L14.2488 12.9946C15.2292 11.7975 15.8198 10.27 15.8198 8.60676C15.8198 4.78198 12.7044 1.6665 8.87958 1.6665ZM8.87958 3.05455C11.9542 3.05455 14.4318 5.53214 14.4318 8.60676C14.4318 11.6814 11.9542 14.159 8.87958 14.159C5.80497 14.159 3.32738 11.6814 3.32738 8.60676C3.32738 5.53214 5.80497 3.05455 8.87958 3.05455Z', fill: fill }) }));
};
var IconCheck = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.stroke, stroke = _e === void 0 ? '#ffffff' : _e;
    return (jsxs("svg", { width: width, height: height, className: className, viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', children: [jsx("defs", { children: jsx("filter", { id: 'filter-selected-tag', children: jsx("feColorMatrix", { in: 'SourceGraphic', type: 'matrix' }) }) }), jsx("g", { id: 'icons/icon-forms/icon-check', stroke: stroke, strokeWidth: '1', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round', strokeLinejoin: 'round', children: jsx("g", { filter: 'url(#filter-selected-tag)', id: 'icons8-checkmark-(5)', children: jsx("g", { transform: 'translate(5.000000, 6.000000)', children: jsx("polyline", { id: 'Path', stroke: stroke, strokeWidth: '1.6', points: '0 7.7248 5.5684 12.5392 13.6 0.2608' }) }) }) })] }));
};
var IconClose = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, className: className, viewBox: '0 0 50 50', children: jsx("path", { d: 'M9.156 6.313L6.312 9.155 22.157 25 6.22 40.969 9.03 43.78 25 27.844 40.938 43.78l2.843-2.843L27.844 25 43.687 9.156l-2.843-2.844L25 22.157z' }) }));
};
var IconError = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, className: className, viewBox: '0 0 50 50', children: jsx("path", { d: 'M49.777 45.348L25.867 3.93c-.36-.618-1.375-.618-1.734 0l-24 41.57a1.014 1.014 0 000 1c.18.309.512.5.867.5h48.02c.554 0 1-.445 1-1 0-.25-.09-.477-.243-.652zM23.492 19.266c0-.215.145-.36.36-.36h2.296c.215 0 .356.145.356.36v14.46c0 .215-.14.36-.356.36h-2.296c-.215 0-.36-.145-.36-.36zm3.086 20.672c0 .214-.144.355-.355.355H23.78c-.215 0-.355-.145-.355-.355v-2.622c0-.214.144-.355.355-.355h2.442c.215 0 .355.14.355.355z' }) }));
};
var IconDeleteWhite = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.stroke, stroke = _e === void 0 ? '#ffffff' : _e, _f = _a.onClick, onClick = _f === void 0 ? function (e) { } : _f;
    return (jsx("svg", { width: width, height: height, className: className, viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', onClick: onClick, children: jsxs("g", { id: 'icons/icon-forms/icon-remove-w', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', children: [jsx("circle", { id: 'Oval', stroke: stroke, cx: '12', cy: '12', r: '7.5' }), jsxs("g", { id: 'Group-5', transform: 'translate(9.000000, 9.000000)', stroke: stroke, strokeLinecap: 'round', strokeLinejoin: 'round', children: [jsx("g", { id: 'Group-4', transform: 'translate(3.000000, 0.000000)', children: jsx("polyline", { id: 'Stroke-718', transform: 'translate(1.500000, 3.000000) scale(-1, 1) translate(-1.500000, -3.000000) ', points: '0 0 3 3 0 6' }) }), jsx("g", { id: 'Group-4', transform: 'translate(1.500000, 3.000000) scale(-1, 1) translate(-1.500000, -3.000000) ', children: jsx("polyline", { id: 'Stroke-718', transform: 'translate(1.500000, 3.000000) scale(-1, 1) translate(-1.500000, -3.000000) ', points: '0 0 3 3 0 6' }) })] })] }) }));
};
var IconDeleteGrey = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (jsxs("svg", { width: width, height: height, className: className, viewBox: '0 0 32 32', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', children: [jsx("defs", { children: jsx("filter", { id: 'filter-delete-formModal', children: jsx("feColorMatrix", { in: 'SourceGraphic', type: 'matrix', values: '0 0 0 0 0.466667 0 0 0 0 0.466667 0 0 0 0 0.466667 0 0 0 1.000000 0' }) }) }), jsx("g", { id: 'icons/action/icon-delete/size-m', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round', children: jsx("g", { filter: 'url(#filter-delete-formModal)', id: 'icons8-trash-can-(3)', children: jsxs("g", { transform: 'translate(8.000000, 5.000000)', children: [jsx("path", { d: 'M5.28,2.4 L5.28,0.96 C5.28,0.432 5.712,0 6.24,0 L10.08,0 C10.608,0 11.04,0.432 11.04,0.96 L11.04,2.4 M0,2.4 L16.32,2.4 M8.16,5.76 L8.16,17.76 M11.04,5.76 L11.04,17.76 M5.28,5.76 L5.28,17.76', id: 'Shape', stroke: '#000000', strokeWidth: '0.96' }), jsx("path", { d: 'M15.36,2.4 L15.36,20.16 C15.36,20.688 14.928,21.12 14.4,21.12 L1.92,21.12 C1.392,21.12 0.96,20.688 0.96,20.16 L0.96,2.4', id: 'Path', stroke: '#000000', strokeWidth: '0.96' })] }) }) })] }));
};
var IconChevronDown = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.onClick, onClick = _e === void 0 ? function () { } : _e, rest = __rest(_a, ["width", "height", "className", "onClick"]);
    return (jsx("svg", __assign({ xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, className: className, viewBox: '0 0 30 30', onClick: onClick }, rest, { children: jsx("path", { d: 'M3 12v-2a1.002 1.002 0 011.634-.774L15 17.708l10.367-8.482A1.001 1.001 0 0127 10v2a1 1 0 01-.367.774l-11 9a1.002 1.002 0 01-1.267 0l-11-9A1.003 1.003 0 013 12z' }) })));
};
var IconAdd = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.fill, fill = _e === void 0 ? 'currentColor' : _e;
    return (jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 50 50', className: className, style: { fill: fill }, children: jsx("path", { d: 'M25 2C12.264 2 2 12.264 2 25s10.264 23 23 23 23-10.264 23-23S37.736 2 25 2zm0 2c11.664 0 21 9.336 21 21s-9.336 21-21 21S4 36.664 4 25 13.336 4 25 4zm-1 9v11H13v2h11v11h2V26h11v-2H26V13h-2z' }) }));
};
var IconSpeedometer = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 32 : _b, _c = _a.height, height = _c === void 0 ? 32 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.fill, fill = _e === void 0 ? '#555555' : _e; _a.strokeWidth;
    return ((0,jsx_runtime.jsxs)("svg", { width: width, height: height, viewBox: '0 0 32.0 32.0', className: className, children: [(0,jsx_runtime.jsx)("defs", { children: (0,jsx_runtime.jsx)("clipPath", { id: 'icon-speedometer-i0', children: (0,jsx_runtime.jsx)("path", { d: 'M11.197422,0 C17.385422,0 22.3948437,5.07733333 22.3948437,11.3333333 L22.3722654,11.9 L22.3722654,11.9907553 C22.3495988,12.1720886 22.3493336,12.330578 22.3266669,12.4892447 L22.3266669,12.511823 C22.0546669,15.0731563 20.944177,17.476177 19.1081773,19.3348437 C19.1081773,19.3575104 19.0852449,19.3573333 19.0625783,19.38 C17.0452449,21.42 14.257422,22.6666667 11.197422,22.6666667 C8.13742197,22.6666667 5.34959899,21.42 3.33226566,19.38 L3.28666667,19.3348437 C1.45066667,17.476177 0.340177259,15.095823 0.0681772586,12.511823 L0.0681772586,12.4892447 C0.045510592,12.3079114 0.022578272,12.149422 0.022578272,11.9907553 L0.022578272,11.9 C0,11.7186667 0,11.5373333 0,11.3333333 C0,5.07733333 5.00942197,0 11.197422,0 Z M11.197422,4.03484369 C7.20808863,4.03484369 3.98924494,7.29866667 3.98924494,11.3333333 C3.98924494,13.2826667 4.73742197,15.1188437 6.09742197,16.5015104 C6.36942197,16.7735104 6.36942197,17.1813333 6.09742197,17.4533333 L4.73742197,18.8359114 C6.4827553,20.3772449 8.7267553,21.3066667 11.197422,21.3066667 C13.6680886,21.3066667 15.9120886,20.3772449 17.657422,18.8359114 L16.297422,17.4533333 C16.025422,17.1813333 16.025422,16.7735104 16.297422,16.5015104 C17.657422,15.1188437 18.405599,13.2826667 18.405599,11.3333333 C18.405599,7.29866667 15.1867553,4.03484369 11.197422,4.03484369 Z M13.26,18.088177 C13.6453333,18.088177 13.9625783,18.3828437 13.9625783,18.768177 C13.9625783,19.1535104 13.6679116,19.448177 13.2825783,19.448177 L9.13484393,19.448177 C8.74951059,19.448177 8.45484393,19.1535104 8.45484393,18.768177 C8.45484393,18.3828437 8.74951059,18.088177 9.13484393,18.088177 Z M11.197422,1.36 C5.78008863,1.36 1.36000001,5.82533333 1.36000001,11.3333333 C1.36000001,11.5146667 1.38257827,11.6731563 1.38257827,11.831823 L1.38257827,11.968177 C1.38257827,12.0815104 1.38293233,12.217422 1.40559899,12.3307553 C1.42826566,12.353422 1.42817726,12.3987553 1.42817726,12.4440886 C1.45084393,12.557422 1.4507553,12.6933333 1.4507553,12.8066667 C1.47342197,12.8293333 1.47333334,12.8747553 1.47333334,12.897422 C1.49600001,13.0560886 1.51884393,13.192177 1.54151059,13.328177 L1.54151059,13.3507553 C1.90417726,15.0507553 2.67457827,16.592177 3.76257827,17.8615104 L4.66924494,16.9548437 C3.35457827,15.3908437 2.62924494,13.4186667 2.62924494,11.3333333 C2.62924494,6.55066667 6.46008863,2.67484369 11.197422,2.67484369 C15.9347553,2.67484369 19.7655988,6.55066667 19.7655988,11.3333333 L21.0348437,11.3333333 C21.0348437,5.82533333 16.6147553,1.36 11.197422,1.36 Z M15.4500783,6.3325 C15.6229116,6.32966667 15.7988439,6.39217703 15.9348439,6.52817703 C16.2068439,6.80017703 16.2068439,7.23066667 15.9348439,7.48 L13.305599,10.1548437 C13.4869323,10.5175104 13.6,10.9026667 13.6,11.3333333 C13.6,12.6706667 12.5347553,13.7584896 11.197422,13.7584896 C9.86008863,13.7584896 8.79484393,12.6706667 8.79484393,11.3333333 C8.79484393,9.996 9.86008863,8.90817703 11.197422,8.90817703 C11.6280886,8.90817703 12.0133333,9.02124471 12.3533333,9.20257804 L14.9825783,6.52817703 C15.1072449,6.40351036 15.2772449,6.33533333 15.4500783,6.3325 Z M11.197422,10.268177 C10.6307553,10.268177 10.1548439,10.744 10.1548439,11.3333333 C10.1548439,11.9226667 10.6080886,12.3984896 11.197422,12.3984896 C11.7867553,12.3984896 12.24,11.9226667 12.24,11.3333333 C12.24,10.744 11.7640886,10.268177 11.197422,10.268177 Z' }) }) }), (0,jsx_runtime.jsx)("g", { transform: 'translate(4.666666666666668 4.666666666666668)', children: (0,jsx_runtime.jsx)("g", { transform: 'translate(0.13591136803800552 0.0)', children: (0,jsx_runtime.jsx)("g", { clipPath: 'url(#icon-speedometer-i0)', children: (0,jsx_runtime.jsx)("polygon", { points: '0,0 22.3948437,0 22.3948437,22.6666667 0,22.6666667 0,0', stroke: 'none', fill: fill }) }) }) })] }));
};
var IconPerson = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 32 : _b, _c = _a.height, height = _c === void 0 ? 32 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.fill, fill = _e === void 0 ? '#555555' : _e; _a.strokeWidth;
    return ((0,jsx_runtime.jsxs)("svg", { width: width, height: height, className: className, viewBox: '0 0 32.0 32.0', children: [(0,jsx_runtime.jsx)("defs", { children: (0,jsx_runtime.jsx)("clipPath", { id: 'icon-person-i0', children: (0,jsx_runtime.jsx)("path", { d: 'M10.4267652,14.0487805 C14.6934319,14.0487805 18.6477002,16.3641259 20.7550175,20.0584351 C20.9631476,20.4226628 20.8331678,20.9168702 20.4689401,21.1250003 C20.1047125,21.3331304 19.610505,21.2031506 19.4023749,20.8389229 C17.5552205,17.6129064 14.1210741,15.6097561 10.4267652,15.6097561 C6.73245624,15.6097561 3.29820818,17.6129064 1.47706997,20.8389229 C1.34698867,21.0990855 1.06091153,21.2291668 0.800748928,21.2291668 C0.670667627,21.2291668 0.540586326,21.2030491 0.410505025,21.1250003 C0.0202611227,20.9168702 -0.109616991,20.4226628 0.0985130901,20.0584351 C2.20583016,16.3641259 6.16009852,14.0487805 10.4267652,14.0487805 Z M10.4267652,0 C13.7308302,0 16.410505,2.6796748 16.410505,5.98373984 C16.410505,9.28780488 13.7308302,11.9674797 10.4267652,11.9674797 C7.12270015,11.9674797 4.44302535,9.28780488 4.44302535,5.98373984 C4.44302535,2.6796748 7.12270015,0 10.4267652,0 Z M10.4267652,1.56097561 C7.98123673,1.56097561 6.00400096,3.53821138 6.00400096,5.98373984 C6.00400096,8.42926829 7.98123673,10.4065041 10.4267652,10.4065041 C12.8722936,10.4065041 14.8495294,8.42926829 14.8495294,5.98373984 C14.8495294,3.53821138 12.8722936,1.56097561 10.4267652,1.56097561 Z' }) }) }), (0,jsx_runtime.jsx)("g", { transform: 'translate(5.333333333333334 5.333333333333334)', children: (0,jsx_runtime.jsx)("g", { transform: 'translate(0.23990147896259373 0.0)', children: (0,jsx_runtime.jsx)("g", { clipPath: 'url(#icon-person-i0)', children: (0,jsx_runtime.jsx)("polygon", { points: '-1.38777878e-17,0 20.8543723,0 20.8543723,21.2291668 -1.38777878e-17,21.2291668 -1.38777878e-17,0', stroke: 'none', fill: fill }) }) }) })] }));
};
var IconPersonSetting = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 32 : _b, _c = _a.height, height = _c === void 0 ? 32 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.fill, fill = _e === void 0 ? '#555555' : _e; _a.strokeWidth;
    return ((0,jsx_runtime.jsxs)("svg", { width: width, height: height, className: className, viewBox: '0 0 32.0 32.0', children: [(0,jsx_runtime.jsxs)("defs", { children: [(0,jsx_runtime.jsx)("clipPath", { id: 'icon-person-setting-i0', children: (0,jsx_runtime.jsx)("path", { d: 'M7.60977029,0 C7.89866969,0 8.16120308,0.155555556 8.29252098,0.388888889 L10.5777599,4.27777778 C10.7353413,4.51111111 10.7353413,4.82222222 10.5777599,5.05555556 L8.29252098,8.94444444 C8.16120308,9.17777778 7.89866969,9.33333333 7.60977029,9.33333333 L3.06647825,9.33333333 C2.77757886,9.33333333 2.5145328,9.17777778 2.3832149,8.94444444 L0.0984884304,5.05555556 C-0.0328294768,4.82222222 -0.0328294768,4.51111111 0.0984884304,4.27777778 L2.3832149,0.388888889 C2.5145328,0.155555556 2.77757886,0 3.06647825,0 Z M5.35120472,1.79487179 C3.73498432,1.79487179 2.44200801,3.07122507 2.44200801,4.66666667 C2.44200801,6.26210826 3.73498432,7.53846154 5.35120472,7.53846154 C6.96742511,7.53846154 8.26040143,6.26210826 8.26040143,4.66666667 C8.26040143,3.07122507 6.96742511,1.79487179 5.35120472,1.79487179 Z' }) }), (0,jsx_runtime.jsx)("clipPath", { id: 'icon-person-setting-i1', children: (0,jsx_runtime.jsx)("path", { d: 'M5.34459758,-6.66133815e-14 C8.29574493,-6.66133815e-14 10.6891952,2.39345022 10.6891952,5.34459758 C10.6891952,8.29574493 8.29574493,10.6891952 5.34459758,10.6891952 C2.39345022,10.6891952 2.11208828e-12,8.29574493 2.11208828e-12,5.34459758 C2.11208828e-12,2.39345022 2.39345022,-6.66133815e-14 5.34459758,-6.66133815e-14 Z M5.34459758,1.39424285 C3.16028378,1.39424285 1.39424285,3.16028378 1.39424285,5.34459758 C1.39424285,7.52891137 3.16028378,9.29495231 5.34459758,9.29495231 C7.52891137,9.29495231 9.29495231,7.52891137 9.29495231,5.34459758 C9.29495231,3.16028378 7.52891137,1.39424285 5.34459758,1.39424285 Z' }) }), (0,jsx_runtime.jsx)("clipPath", { id: 'icon-person-setting-i2', children: (0,jsx_runtime.jsx)("path", { d: 'M9.31380103,0 C10.591857,0 11.823529,0.232555292 13.0086354,0.650828145 C13.3804335,0.79025243 13.5428228,1.18492494 13.4266359,1.55672303 C13.310449,1.8355716 13.0319634,2.02147064 12.7531149,2.02147064 C12.6834027,2.02147064 12.5904532,1.99841475 12.5207411,1.97517736 C11.4982963,1.60337927 10.4291953,1.39424285 9.31380103,1.39424285 C6.01409296,1.39424285 2.9467587,3.18343031 1.29690467,6.06486575 C1.18071777,6.27400218 0.948434816,6.41342647 0.692823627,6.41342647 C0.576636723,6.41342647 0.46044982,6.39009846 0.344262916,6.32038632 C0.018939585,6.13448727 -0.097156693,5.71630504 0.0887423531,5.36774433 C1.97097019,2.06803603 5.50287059,0 9.31380103,0 Z' }) })] }), (0,jsx_runtime.jsxs)("g", { transform: 'translate(3.9999999999999982 4.666666666666666)', children: [(0,jsx_runtime.jsx)("g", { transform: 'translate(13.815912984942466 13.929395790902763)', children: (0,jsx_runtime.jsx)("g", { clipPath: 'url(#icon-person-setting-i0)', children: (0,jsx_runtime.jsx)("polygon", { points: '-1.38777878e-17,0 10.695946,0 10.695946,9.33333333 -1.38777878e-17,9.33333333 -1.38777878e-17,0', stroke: 'none', fill: fill }) }) }), (0,jsx_runtime.jsx)("g", { transform: 'translate(3.969203456768203 0.0)', children: (0,jsx_runtime.jsx)("g", { clipPath: 'url(#icon-person-setting-i1)', children: (0,jsx_runtime.jsx)("polygon", { points: '2.11208828e-12,-6.66133815e-14 10.6891952,-6.66133815e-14 10.6891952,10.6891952 2.11208828e-12,10.6891952 2.11208828e-12,-6.66133815e-14', stroke: 'none', fill: fill }) }) }), (0,jsx_runtime.jsx)("g", { transform: 'translate(0.0 12.548185612648314)', children: (0,jsx_runtime.jsx)("g", { clipPath: 'url(#icon-person-setting-i2)', children: (0,jsx_runtime.jsx)("polygon", { points: '1.38777878e-17,0 13.4636328,0 13.4636328,6.41342647 1.38777878e-17,6.41342647 1.38777878e-17,0', stroke: 'none', fill: fill }) }) })] })] }));
};
var IconPersonSearch = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 32 : _b, _c = _a.height, height = _c === void 0 ? 32 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.fill, fill = _e === void 0 ? '#555555' : _e; _a.strokeWidth;
    return ((0,jsx_runtime.jsxs)("svg", { width: width, height: height, className: className, viewBox: '0 0 32.0 32.0', children: [(0,jsx_runtime.jsxs)("defs", { children: [(0,jsx_runtime.jsx)("clipPath", { id: 'icon-person-search-i0', children: (0,jsx_runtime.jsx)("path", { d: 'M6,0 C9.27807674,0 11.4896334,3.07568764 11.8590524,3.62591191 L11.9049635,3.69565436 L11.9132812,3.70872605 C11.9697136,3.77924814 12,3.86549131 12,3.95432692 C12,4.03084279 11.9774041,4.10569494 11.9351564,4.1698069 C11.9069304,4.2227233 9.9755288,7.90865385 6,7.90865385 C2.00753252,7.90865385 0.073283712,4.18615369 0.066406248,4.17212374 C0.0225959989,4.10569496 0,4.03084281 0,3.95432692 C0,3.86513448 0.0306213566,3.77858185 0.086718752,3.70872605 C0.0878451439,3.7069335 0.0906242819,3.70252877 0.0950364322,3.69565436 L0.140947612,3.62591191 C0.510366601,3.07568764 2.72192326,0 6,0 Z M6,1.18629808 C4.4536,1.18629808 3.2,2.42558413 3.2,3.95432692 C3.2,5.48306971 4.4536,6.72235577 6,6.72235577 C7.5464,6.72235577 8.8,5.48306971 8.8,3.95432692 C8.8,2.42558413 7.5464,1.18629808 6,1.18629808 Z M6,2.76802885 C6.6627417,2.76802885 7.2,3.29915259 7.2,3.95432692 C7.2,4.60950126 6.6627417,5.140625 6,5.140625 C5.3372583,5.140625 4.8,4.60950126 4.8,3.95432692 C4.8,3.29915259 5.3372583,2.76802885 6,2.76802885 Z' }) }), (0,jsx_runtime.jsx)("clipPath", { id: 'icon-person-search-i1', children: (0,jsx_runtime.jsx)("path", { d: 'M5.34459758,-6.66133815e-14 C8.29574493,-6.66133815e-14 10.6891952,2.39345022 10.6891952,5.34459758 C10.6891952,8.29574493 8.29574493,10.6891952 5.34459758,10.6891952 C2.39345022,10.6891952 2.11208828e-12,8.29574493 2.11208828e-12,5.34459758 C2.11208828e-12,2.39345022 2.39345022,-6.66133815e-14 5.34459758,-6.66133815e-14 Z M5.34459758,1.39424285 C3.16028378,1.39424285 1.39424285,3.16028378 1.39424285,5.34459758 C1.39424285,7.52891137 3.16028378,9.29495231 5.34459758,9.29495231 C7.52891137,9.29495231 9.29495231,7.52891137 9.29495231,5.34459758 C9.29495231,3.16028378 7.52891137,1.39424285 5.34459758,1.39424285 Z' }) }), (0,jsx_runtime.jsx)("clipPath", { id: 'icon-person-search-i2', children: (0,jsx_runtime.jsx)("path", { d: 'M9.31380103,0 C10.591857,0 11.823529,0.232555292 13.0086354,0.650828145 C13.3804335,0.79025243 13.5428228,1.18492494 13.4266359,1.55672303 C13.310449,1.8355716 13.0319634,2.02147064 12.7531149,2.02147064 C12.6834027,2.02147064 12.5904532,1.99841475 12.5207411,1.97517736 C11.4982963,1.60337927 10.4291953,1.39424285 9.31380103,1.39424285 C6.01409296,1.39424285 2.9467587,3.18343031 1.29690467,6.06486575 C1.18071777,6.27400218 0.948434816,6.41342647 0.692823627,6.41342647 C0.576636723,6.41342647 0.46044982,6.39009846 0.344262916,6.32038632 C0.018939585,6.13448727 -0.097156693,5.71630504 0.0887423531,5.36774433 C1.97097019,2.06803603 5.50287059,0 9.31380103,0 Z' }) })] }), (0,jsx_runtime.jsxs)("g", { transform: 'translate(4.0 4.666666666666668)', children: [(0,jsx_runtime.jsx)("g", { transform: 'translate(12.018945570341808 14.67299297779452)', children: (0,jsx_runtime.jsx)("g", { clipPath: 'url(#icon-person-search-i0)', children: (0,jsx_runtime.jsx)("polygon", { points: '0,0 12,0 12,7.90865385 0,7.90865385 0,0', stroke: 'none', fill: fill }) }) }), (0,jsx_runtime.jsx)("g", { transform: 'translate(3.969203456768202 0.0)', children: (0,jsx_runtime.jsx)("g", { clipPath: 'url(#icon-person-search-i1)', children: (0,jsx_runtime.jsx)("polygon", { points: '2.11208828e-12,-6.66133815e-14 10.6891952,-6.66133815e-14 10.6891952,10.6891952 2.11208828e-12,10.6891952 2.11208828e-12,-6.66133815e-14', stroke: 'none', fill: fill }) }) }), (0,jsx_runtime.jsx)("g", { transform: 'translate(0.0 12.548185612648314)', children: (0,jsx_runtime.jsx)("g", { clipPath: 'url(#icon-person-search-i2)', children: (0,jsx_runtime.jsx)("polygon", { points: '-1.38777878e-17,0 13.4636328,0 13.4636328,6.41342647 -1.38777878e-17,6.41342647 -1.38777878e-17,0', stroke: 'none', fill: fill }) }) })] })] }));
};
var IconBriefcase = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 47 : _b, _c = _a.height, height = _c === void 0 ? 53 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.fill, fill = _e === void 0 ? '#555555' : _e; _a.strokeWidth;
    return ((0,jsx_runtime.jsxs)("svg", { version: '1.1', width: width, height: height, className: className, viewBox: '0 0 32.0 32.0', children: [(0,jsx_runtime.jsx)("defs", { children: (0,jsx_runtime.jsx)("clipPath", { id: 'icon-briefcase-i0', children: (0,jsx_runtime.jsx)("path", { d: 'M22.0251572,13.2578616 C22.3886792,13.2578616 22.6666667,13.5358491 22.6666667,13.8993711 L22.6666667,19.8867925 C22.6666667,21.4264151 21.4264151,22.6666667 19.8867925,22.6666667 L2.77987421,22.6666667 C1.24025157,22.6666667 0,21.4264151 0,19.8867925 L0,13.8993711 C0,13.5358491 0.277987421,13.2578616 0.641509434,13.2578616 C1.00503145,13.2578616 1.28301887,13.5358491 1.28301887,13.8993711 L1.28301887,19.8867925 C1.28301887,20.7207547 1.94591195,21.3836478 2.77987421,21.3836478 L19.8867925,21.3836478 C20.7207547,21.3836478 21.3836478,20.7207547 21.3836478,19.8867925 L21.3836478,13.8993711 C21.3836478,13.5358491 21.6616352,13.2578616 22.0251572,13.2578616 Z M19.8867925,4.27672956 C21.4264151,4.27672956 22.6666667,5.51698113 22.6666667,7.05660377 L22.6666667,10.6918239 C22.6666667,10.927044 22.5383648,11.1194132 22.3459119,11.2477151 C18.9459119,13.2791617 15.1396226,14.305744 11.3333333,14.305744 C7.52704403,14.305744 3.72075472,13.2791617 0.320754717,11.2477151 C0.128301887,11.1194132 0,10.927044 0,10.6918239 L0,7.05660377 C0,5.51698113 1.24025157,4.27672956 2.77987421,4.27672956 Z M19.8867925,5.55974843 L2.77987421,5.55974843 C1.94591195,5.55974843 1.28301887,6.22264151 1.28301887,7.05660377 L1.28301887,10.3284689 C7.50566038,13.9209217 15.1610063,13.9209217 21.3836478,10.3284689 L21.3836478,7.05660377 C21.3836478,6.22264151 20.7207547,5.55974843 19.8867925,5.55974843 Z M13.0440252,0 C14.5836478,0 15.8238994,1.24025157 15.8238994,2.77987421 C15.8238994,3.14339623 15.5459119,3.42138365 15.1823899,3.42138365 C14.8188679,3.42138365 14.5408805,3.14339623 14.5408805,2.77987421 C14.5408805,1.94591195 13.8779874,1.28301887 13.0440252,1.28301887 L9.62264151,1.28301887 C8.78867925,1.28301887 8.12578616,1.94591195 8.12578616,2.77987421 C8.12578616,3.14339623 7.84779874,3.42138365 7.48427673,3.42138365 C7.12075472,3.42138365 6.8427673,3.14339623 6.8427673,2.77987421 C6.8427673,1.24025157 8.08301887,0 9.62264151,0 Z' }) }) }), (0,jsx_runtime.jsx)("g", { transform: 'translate(4.666666666666668 4.666666666666668)', children: (0,jsx_runtime.jsx)("g", { clipPath: 'url(#icon-briefcase-i0)', children: (0,jsx_runtime.jsx)("polygon", { points: '0,0 22.6666667,0 22.6666667,22.6666667 0,22.6666667 0,0', stroke: 'none', fill: fill }) }) })] }));
};
var IconBell = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 47 : _b, _c = _a.height, height = _c === void 0 ? 53 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.fill, fill = _e === void 0 ? '#555555' : _e; _a.strokeWidth;
    return ((0,jsx_runtime.jsxs)("svg", { width: width, height: height, className: className, viewBox: '0 0 32.0 32.0', children: [(0,jsx_runtime.jsx)("defs", { children: (0,jsx_runtime.jsx)("clipPath", { id: 'icon-bell-i0', children: (0,jsx_runtime.jsx)("path", { d: 'M8.77473001,0.000231813462 C9.59335403,-0.0140999131 10.2685233,0.637903475 10.2827699,1.45652898 L10.2934067,2.06773459 C14.0182869,2.70154063 16.8981339,5.91668492 16.9662047,9.8281184 L17.0544849,14.9008281 C17.0721746,15.9172824 17.3204742,16.916495 17.7824252,17.8217302 L18.0675387,18.3786578 C18.533203,19.2924754 17.8420335,20.4442062 16.8160383,20.4621683 L12.4254066,20.5390359 C12.8407052,21.7390334 12.5888646,23.1276782 11.6514871,24.098361 C10.3249929,25.471986 8.11171323,25.5107341 6.73823119,24.1843779 C5.7678885,23.2473288 5.46734451,21.8686479 5.84020943,20.6550619 L1.45105418,20.7319034 C0.424625929,20.7498732 -0.306760373,19.6228291 0.127793618,18.6919922 L0.330682327,18.2579553 C0.801654463,17.2502044 1.03605946,16.1485804 1.01669922,15.036139 L0.930211326,10.1088621 C0.89176499,7.89968813 1.75736866,5.87970185 3.18416119,4.40221493 C4.28356357,3.26375044 5.71851736,2.45218991 7.32891811,2.11963409 L7.31828135,1.50842856 C7.30403478,0.68980305 7.95647736,0.0141789799 8.77473001,0.000231813462 Z M11.4822968,20.5749025 L7.0297131,20.5749025 C6.91400097,20.8565852 6.85019346,21.1650738 6.85019346,21.4884655 C6.85019346,22.8171585 7.92731196,23.894277 9.25600496,23.894277 C10.584698,23.894277 11.6618165,22.8171585 11.6618165,21.4884655 C11.6618165,21.1650738 11.5980089,20.8565852 11.4822968,20.5749025 Z M1.91947107,17.1571744 C1.76545999,17.7438532 1.55811546,18.3165282 1.29198736,18.8650468 L1.19820143,19.0594803 L16.9065763,19.133899 L16.7422173,18.7981661 C16.4932705,18.2922852 16.305085,17.7633867 16.1572616,17.223917 L1.91947107,17.1571744 Z M8.97217689,3.2956275 C7.10646658,3.28586434 5.42563457,4.02789941 4.21382026,5.23971372 C3.00200595,6.45152802 2.25997088,8.13236003 2.26973404,9.99807035 L2.29604734,15.1746492 C2.2973268,15.4191508 2.2857886,15.6630526 2.26807768,15.9057964 L15.7977662,15.9765965 C15.783979,15.7844985 15.7748141,15.5918406 15.7738039,15.398726 L15.7451358,10.0685864 C15.7256095,6.33716574 12.7035975,3.31515381 8.97217689,3.2956275 Z' }) }) }), (0,jsx_runtime.jsx)("g", { transform: 'translate(6.666666666666666 3.333333333333334)', children: (0,jsx_runtime.jsx)("g", { clipPath: 'url(#icon-bell-i0)', children: (0,jsx_runtime.jsx)("polygon", { points: '-1.20192745e-12,1.53866991e-14 18.2156673,1.53866991e-14 18.2156673,25.1544028 -1.20192745e-12,25.1544028 -1.20192745e-12,1.53866991e-14', stroke: 'none', fill: fill }) }) })] }));
};
var IconPersonPassword = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 32 : _b, _c = _a.height, height = _c === void 0 ? 32 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.fill, fill = _e === void 0 ? '#555555' : _e; _a.strokeWidth;
    return ((0,jsx_runtime.jsxs)("svg", { width: width, height: height, className: className, viewBox: '0 0 32.0 32.0', children: [(0,jsx_runtime.jsxs)("defs", { children: [(0,jsx_runtime.jsx)("pattern", { id: 'icon-person-password-i0', patternUnits: 'userSpaceOnUse', x: '0px', y: '0px', width: '8.83809524px', height: '10.6666667px', children: (0,jsx_runtime.jsx)("image", { width: '8.83809524px', height: '10.6666667px', preserveAspectRatio: 'none', xlinkHref: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABgCAYAAACKa/UAAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAUKADAAQAAAABAAAAYAAAAACQwfTJAAAE/UlEQVR4Ae2dy2vUUBTGW6U+sAi684VYxQpW8QGKbqyCCurOgntRUHQr+jdIi+7duRBfIOgouBDxWbUPEBR8bHwsXFgLVkUFX9+XmunNmZlO5p7MJGnPgc/Jvcm599zfnCQ3mSY2N2XD2hFGJ7QGWg4thuZCrRDtKzQMvYVeQk+h29AraNLaaoy8B3oP/fXUO/h1Q2xrUlgzRrkbegD5Qqvkdx9t7oLYx4S09RjVY6gSgKTqe9HHuolEcAYGcxr6BVWCNIJ116Hj0B6Ix8Q5UMt/cZl1XMdtbkBfoErtsa9T0HQo17YM0Q9C5Qb6B/UFaC/kM1B+MV0QwbOtcn0MoH4plEvbhKg/QXJgHOx5qANKylahoYuQ7IvlIWgjlCvbgWg59ZADeoG6Tqhetg0Nc5oj+2Us2+vVadLtbkCD5eCdRX1r0p2VaW8m6s5AEuI31G0us32mqnjMk7std9ljKUR5An3KY+NH1LWlEEusLnlQlycMDuBALO/6bHQQzUqIfajzOWnVJ0KnVU5V5G6TRuY5IQWLnPbIuLrlRmmXOUmW87xzaQfl9M/jrwuRsa511qe6yEsneYXBs+2sVKOKds6TF288uBB56ZcJ47WtGxiXOZ3Imm1BQPJ4uDMLQcobA5wkZ9UuITD3y76bdqAdIiB+w6zLqq1EYL8hFyKvYlKzHvTsBlNILZL4HfNGhBvzyfiuyW8pb4Z2Jd9F4i3uQ4suwDeJ9xCzwXYRCG9JZXKCKsbDSz15qckrKC+b4uU16rRV+N5D+aeoy2LxO4KSUxjvWYMGoPwdIvUzWg3f1h2xrRyLWF25qAG4QjT7TJSzXHwuguPhyMs0AJeIHl+LcpaL8ufQNt9gNQBni06HRDnLRRmrHEtDYucJw50OTGtIr8l0wtmCG/sP32Z5I8DXGIBrmrbcdhq1nEj8ml24UQPNdD8GUPn1GEADqCSgdLcMNIBKAkp3y0ADqCSgdLcMNIBKAkp3y8AEAfJmwFHoESRvebsX3uGy7Dqsz8tnrfGTSS90BCq5cTIflYNQXgafdpwDYDUPCow0DV7tydMPbi1T8c9haD9kVhsB7rUf6MJjnrtLXEWZK82iBBageA1yWT3kJvJxAW5oVp7AQlS7AEd4F5kVruXtzrIbeyOWI7xsHqhEbgANoJKA0t0y0AAqCSjdLQMNoJKA0t0y0AAqCSjdLQMNoJKA0t0y0AAqCSjdLQMNoJKA0t0y0AAqCSjdLQMNoJKA0t03Axeh38sQHzCkrkC1PO2Td38Md8zcX5kiP5iMbRJZ4uDlu2HoNwxxXTXLu38Jr5KKKgSYedInLPP9VdUs7/7hWMPPEhjVAHCXDZ3l5+dqzlifd//ImH2PgZU4sXGN5c7fB+CtcQjdHGdduCrv/uE4ip+RlCzWVl7g2ZYnDOk3hDr+6UM1y7u/HHcJiGoAuJ5nUp4weMyjLkBx4GGzwPLsHwFofxsTfqXxPwmwaD7HwKKzLTQ1GUBlFhhAA6gkoHS3DDSASgJKd8tAA6gkoHS3DDSASgJKd8tAA6gkoHS3DDSASgJKd8tAA6gkoHS3DEwAIB93dc0ed3VpRJflzxYBO/nANR8qNohRcCwRXgFyfxMJHrjmWyjcSluOz+MQ2AWv8OBbKAxcbQyegBn/48DA+AqPfsggxmPQB1bF154EBPEPafINHvz/QeR7FAzsKBOy4W5bzLx/cIr0XT4zV84AAAAASUVORK5CYII=' }) }), (0,jsx_runtime.jsx)("clipPath", { id: 'icon-person-password-i1', children: (0,jsx_runtime.jsx)("path", { d: 'M5.34459758,-6.66133815e-14 C8.29574493,-6.66133815e-14 10.6891952,2.39345022 10.6891952,5.34459758 C10.6891952,8.29574493 8.29574493,10.6891952 5.34459758,10.6891952 C2.39345022,10.6891952 2.11208828e-12,8.29574493 2.11208828e-12,5.34459758 C2.11208828e-12,2.39345022 2.39345022,-6.66133815e-14 5.34459758,-6.66133815e-14 Z M5.34459758,1.39424285 C3.16028378,1.39424285 1.39424285,3.16028378 1.39424285,5.34459758 C1.39424285,7.52891137 3.16028378,9.29495231 5.34459758,9.29495231 C7.52891137,9.29495231 9.29495231,7.52891137 9.29495231,5.34459758 C9.29495231,3.16028378 7.52891137,1.39424285 5.34459758,1.39424285 Z' }) }), (0,jsx_runtime.jsx)("clipPath", { id: 'icon-person-password-i2', children: (0,jsx_runtime.jsx)("path", { d: 'M9.31380103,0 C10.591857,0 11.823529,0.232555292 13.0086354,0.650828145 C13.3804335,0.79025243 13.5428228,1.18492494 13.4266359,1.55672303 C13.310449,1.8355716 13.0319634,2.02147064 12.7531149,2.02147064 C12.6834027,2.02147064 12.5904532,1.99841475 12.5207411,1.97517736 C11.4982963,1.60337927 10.4291953,1.39424285 9.31380103,1.39424285 C6.01409296,1.39424285 2.9467587,3.18343031 1.29690467,6.06486575 C1.18071777,6.27400218 0.948434816,6.41342647 0.692823627,6.41342647 C0.576636723,6.41342647 0.46044982,6.39009846 0.344262916,6.32038632 C0.018939585,6.13448727 -0.097156693,5.71630504 0.0887423531,5.36774433 C1.97097019,2.06803603 5.50287059,0 9.31380103,0 Z' }) })] }), (0,jsx_runtime.jsxs)("g", { transform: 'translate(4.666666666666666 4.666666666666666)', children: [(0,jsx_runtime.jsx)("g", { transform: 'translate(14.443906380247428 11.402298850574574)', children: (0,jsx_runtime.jsx)("polygon", { points: '0,0 8.83809524,0 8.83809524,10.6666667 0,10.6666667 0,0', stroke: 'none', fill: 'url(#icon-person-password-i0)', opacity: '69.9999988%' }) }), (0,jsx_runtime.jsx)("g", { transform: 'translate(3.969203456768202 0.0)', children: (0,jsx_runtime.jsx)("g", { clipPath: 'url(#icon-person-password-i1)', children: (0,jsx_runtime.jsx)("polygon", { points: '2.11208828e-12,-6.66133815e-14 10.6891952,-6.66133815e-14 10.6891952,10.6891952 2.11208828e-12,10.6891952 2.11208828e-12,-6.66133815e-14', stroke: 'none', fill: fill }) }) }), (0,jsx_runtime.jsx)("g", { transform: 'translate(0.0 12.548185612648314)', children: (0,jsx_runtime.jsx)("g", { clipPath: 'url(#icon-person-password-i2)', children: (0,jsx_runtime.jsx)("polygon", { points: '-1.38777878e-17,0 13.4636328,0 13.4636328,6.41342647 -1.38777878e-17,6.41342647 -1.38777878e-17,0', stroke: 'none', fill: fill }) }) })] })] }));
};
var NavIcons = {
    IconSpeedometer: IconSpeedometer,
    IconPerson: IconPerson,
    IconPersonSetting: IconPersonSetting,
    IconPersonSearch: IconPersonSearch,
    IconBriefcase: IconBriefcase,
    IconBell: IconBell,
    IconPersonPassword: IconPersonPassword
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Input/index.js + 5 modules
var Input = __webpack_require__(68631);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/SearchBarUnstable/apiServices.js
var apiServices = __webpack_require__(49988);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/SearchBarUnstable/constants.js
var constants = __webpack_require__(83528);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/SearchBarUnstable/searchbarHelpers.js + 1 modules
var searchbarHelpers = __webpack_require__(62761);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/SearchBarUnstable/components/SearchInput/index.js
'use client';












var SearchInput = function () {
    var _a;
    var _b = (0,react.useContext)(reducer/* SearchBarContext */.O), state = _b.state, dispatch = _b.dispatch, t = _b.t, props = _b.props, search = _b.search;
    var keyword = state.keyword, isShow = state.isShow, selectedSuggestionIndex = state.selectedSuggestionIndex, suggestions = state.suggestions;
    var pageName = props.pageName, msBaseUrl = props.msBaseUrl, searchBarOptions = props.searchBarOptions, isMobile = props.isMobile;
    var _c = (0,react.useState)(t('Search for jobs, companies, skills')), placeholderText = _c[0], setPlaceholderText = _c[1];
    var timer = (0,react.useRef)();
    var inputRef = (0,react.useRef)(null);
    var doGetSearchTopJob = function (locationList) { return (0,_tslib/* __awaiter */.mG)(void 0, void 0, void 0, function () {
        var filter, postData, searchTopJob, topJobItem;
        var _a, _b;
        return (0,_tslib/* __generator */.Jh)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (keyword.length === 0) {
                        return [2 /*return*/, false];
                    }
                    filter = [];
                    if (locationList.length > 0) {
                        filter.push({
                            field: 'workingLocations.cityId',
                            value: (_a = locationList === null || locationList === void 0 ? void 0 : locationList.map(function (item) { return item.parentId; })) === null || _a === void 0 ? void 0 : _a.join(',')
                        });
                    }
                    postData = {
                        query: keyword,
                        filter: filter,
                        ranges: [],
                        order: [],
                        hitsPerPage: 1,
                        page: 0,
                        retrieveFields: constants/* RETRIEVE_FIELDS_SEARCH */.YA
                    };
                    return [4 /*yield*/, (0,apiServices/* getSearchJob */.tC)(msBaseUrl, postData)];
                case 1:
                    searchTopJob = _c.sent();
                    topJobItem = null;
                    if (((_b = searchTopJob === null || searchTopJob === void 0 ? void 0 : searchTopJob.data) === null || _b === void 0 ? void 0 : _b.length) > 0 && searchTopJob.data[0].priorityOrder !== '1970-01-01T07:00:00') {
                        topJobItem = searchTopJob.data[0];
                    }
                    if (topJobItem !== null) {
                        dispatch({
                            type: actions/* ACTIONS.SET_TOP_JOB_ITEM */.a.SET_TOP_JOB_ITEM,
                            payload: topJobItem
                        });
                    }
                    return [2 /*return*/, true];
            }
        });
    }); };
    var onInputChange = function (keyword) {
        var _a;
        dispatch({
            type: actions/* ACTIONS.SET_KEYWORD */.a.SET_KEYWORD,
            payload: keyword
        });
        dispatch({
            type: actions/* ACTIONS.SET_TOP_JOB_ITEM */.a.SET_TOP_JOB_ITEM,
            payload: null
        });
        if (keyword.length <= 0) {
            return;
        }
        var lastCharacterOfKeyword = keyword.substring(keyword.length - 1);
        if (lastCharacterOfKeyword !== ' ') {
            return;
        }
        var localParams = (0,searchbarHelpers/* getLocalStorage */.$o)('params', '');
        doGetSearchTopJob((_a = localParams === null || localParams === void 0 ? void 0 : localParams.locations) !== null && _a !== void 0 ? _a : []);
    };
    var onInputKeydown = function (e) {
        var _a, _b;
        switch (e.key) {
            case constants/* KEYCODE.ENTER */.Ps.ENTER:
                search();
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                dispatch({
                    type: actions/* ACTIONS.CLOSE_DROP_DOWN */.a.CLOSE_DROP_DOWN
                });
                break;
            case constants/* KEYCODE.ESCAPE */.Ps.ESCAPE:
                (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.blur();
                dispatch({
                    type: actions/* ACTIONS.CLOSE_DROP_DOWN */.a.CLOSE_DROP_DOWN
                });
                break;
            case constants/* KEYCODE.ARROW_UP */.Ps.ARROW_UP:
                {
                    if (suggestions.length === 0) {
                        return;
                    }
                    e.preventDefault();
                    var maxIndex = suggestions.length - 1;
                    var nextIndex = selectedSuggestionIndex - 1;
                    if (nextIndex < 0) {
                        nextIndex = maxIndex;
                    }
                    dispatch({
                        type: actions/* ACTIONS.UPDATE_SELECTED_SUGGESTION_INDEX */.a.UPDATE_SELECTED_SUGGESTION_INDEX,
                        payload: nextIndex
                    });
                }
                break;
            case constants/* KEYCODE.ARROW_DOWN */.Ps.ARROW_DOWN:
                {
                    if (suggestions.length === 0) {
                        return;
                    }
                    e.preventDefault();
                    var maxIndex = suggestions.length - 1;
                    var nextIndex = selectedSuggestionIndex + 1;
                    if (nextIndex > maxIndex) {
                        nextIndex = 0;
                    }
                    dispatch({
                        type: actions/* ACTIONS.UPDATE_SELECTED_SUGGESTION_INDEX */.a.UPDATE_SELECTED_SUGGESTION_INDEX,
                        payload: nextIndex
                    });
                }
                break;
            default:
                {
                    // Release locked debounce
                    dispatch({
                        type: actions/* ACTIONS.TOGGLE_LOCK_DEBOUNCE */.a.TOGGLE_LOCK_DEBOUNCE,
                        payload: false
                    });
                }
                break;
        }
    };
    var onInputFocus = function () {
        if (isShow) {
            return;
        }
        if (timer.current) {
            clearTimeout(timer.current);
        }
        timer.current = setTimeout(function () {
            dispatch({
                type: actions/* ACTIONS.FORCE_CONTROL */.a.FORCE_CONTROL,
                payload: types/* EForceControDropdown.JUST_SHOW_DROPDOWN_CONTENT */.q.JUST_SHOW_DROPDOWN_CONTENT
            });
        }, 250);
    };
    var onTouchMove = function (e) {
        var _a;
        if (!isMobile) {
            return;
        }
        // Blur input when user scrolling out
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
    };
    (0,react.useEffect)(function () {
        var _a;
        if (isShow) {
            return;
        }
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
    }, [isShow]);
    (0,react.useEffect)(function () {
        var newPlaceholderText = placeholderText;
        if (pageName === 'interview') {
            newPlaceholderText = t('Enter a job title to view a set of interview questions');
        }
        else if (pageName === 'salary') {
            newPlaceholderText = t('Enter a job title to view salary');
        }
        // Special breakpoint for place holder
        var isInMobile = typeof window !== 'undefined' ? window.innerWidth <= 1024 : false;
        if (isInMobile) {
            newPlaceholderText = t('Search');
        }
        setPlaceholderText(newPlaceholderText);
    }, [pageName]);
    (0,react.useEffect)(function () {
        window.addEventListener('touchmove', onTouchMove, { passive: false });
        return function () {
            window.removeEventListener('touchmove', onTouchMove);
        };
    }, []);
    return ((0,jsx_runtime.jsx)(Input/* default */.Z, { value: keyword, onChange: onInputChange, onKeyDown: onInputKeydown, placeholder: placeholderText, autoComplete: 'off', maxLength: (_a = searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.maxInputLength) !== null && _a !== void 0 ? _a : constants/* DEFAULT_MAX_LENGTH_INPUT */.m5, onFocus: onInputFocus, inputRef: inputRef, enterKeyHint: 'search' }));
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(31545);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useFloating/index.js + 17 modules
var useFloating = __webpack_require__(88904);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useClickAway.js
var useClickAway = __webpack_require__(11908);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Utils/constants.js
var Utils_constants = __webpack_require__(96782);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Images/ArrowDownIcon/index.js
'use client';





var ArrowDownIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c; _a.color; var _d = _a.thickness, thickness = _d === void 0 ? 1 : _d, props = (0,_tslib/* __rest */._T)(_a, ["width", "height", "color", "thickness"]);
    return ((0,jsx_runtime.jsx)("svg", (0,_tslib/* __assign */.pi)({ width: width, height: height, viewBox: '0 0 20 20', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' }, props, { children: (0,jsx_runtime.jsx)("path", { d: "M16.8028 5.8332C16.6231 5.83744 16.4524 5.91251 16.3279 6.04205L9.99853 12.3714L3.66918 6.04205C3.60571 5.9768 3.52981 5.92494 3.44596 5.88953C3.3621 5.85411 3.272 5.83586 3.18098 5.83586C3.04549 5.83589 2.91309 5.87634 2.8007 5.95201C2.68831 6.02769 2.60105 6.13517 2.55006 6.2607C2.49908 6.38623 2.48669 6.52412 2.51448 6.65673C2.54227 6.78934 2.60898 6.91065 2.70608 7.00515L9.51698 13.816C9.64471 13.9437 9.81792 14.0154 9.99853 14.0154C10.1791 14.0154 10.3523 13.9437 10.4801 13.816L17.291 7.00515C17.3899 6.91003 17.4578 6.78726 17.4857 6.65291C17.5137 6.51856 17.5004 6.37891 17.4476 6.25223C17.3949 6.12556 17.3051 6.01778 17.19 5.943C17.0749 5.86823 16.94 5.82996 16.8028 5.8332Z", fill: "#616161", strokeWidth: thickness }) })));
};
var ArrowDownIcon$1 = /*#__PURE__*/ react.memo(ArrowDownIcon);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Images/CheckTagIcon/index.js
'use client';




var CheckTagIcon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#003699' : _b;
    return ((0,jsx_runtime.jsx)("svg", { width: '12', height: '12', viewBox: '0 0 12 12', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: (0,jsx_runtime.jsx)("path", { d: 'M1.2939 0.666992C1.13335 0.666992 0.972782 0.728306 0.850271 0.850816C0.605248 1.09584 0.605248 1.49305 0.850271 1.73807L5.11257 6.00033L0.850271 10.2626C0.605249 10.5076 0.605248 10.9048 0.850271 11.1498C0.972939 11.2725 1.13327 11.3337 1.2939 11.3337C1.45453 11.3337 1.61487 11.2725 1.73754 11.1498L5.99984 6.88758L10.2621 11.1498C10.3848 11.2725 10.5451 11.3337 10.7058 11.3337C10.8664 11.3337 11.0267 11.2725 11.1494 11.1498C11.3944 10.9048 11.3944 10.5076 11.1494 10.2626L6.8871 6.00033L11.1494 1.73807C11.3944 1.49305 11.3944 1.09584 11.1494 0.850816C10.9044 0.605796 10.5072 0.605796 10.2621 0.850816L5.99984 5.11307L1.73754 0.850816C1.61502 0.728306 1.45445 0.666992 1.2939 0.666992Z', fill: color }) }));
};
var CheckTagIcon$1 = react.memo(CheckTagIcon);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/TreeSelect/constants.js
var TreeSelect_constants = __webpack_require__(98965);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/TreeSelect/types.js
var TreeSelect_types = __webpack_require__(69710);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/TreeSelect/components/InputContainer/InputContainer.css.js
'use client';






var dimAnim = (0,styled_components_browser_esm/* keyframes */.F4)(InputContainer_css_templateObject_1 || (InputContainer_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"], ["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"])));
var SInputContainer = styled_components_browser_esm/* default.div */.ZP.div(InputContainer_css_templateObject_9 || (InputContainer_css_templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    max-width: 100%;\n    width: 100%;\n    cursor: pointer;\n    height: ", ";\n    gap: ", ";\n    ", ";\n\n    ", "\n    ", "\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n"], ["\n    display: flex;\n    align-items: center;\n    max-width: 100%;\n    width: 100%;\n    cursor: pointer;\n    height: ", ";\n    gap: ", ";\n    ", ";\n\n    ", "\n    ", "\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n"])), function (_a) {
    var forResponsive = _a.forResponsive;
    return (forResponsive ? '32px' : '40px');
}, function (_a) {
    var variant = _a.variant;
    return (variant === TreeSelect_types/* EVariant.SECONDARY */.e.SECONDARY ? '4px' : 0);
}, function (_a) {
    var variant = _a.variant, isDisabled = _a.isDisabled;
    switch (variant) {
        case TreeSelect_types/* EVariant.PRIMARY */.e.PRIMARY:
            return (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_2 || (InputContainer_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: ", ";\n                    border: 1px solid ", ";\n                    border-radius: 6px;\n                    padding: 3px;\n                    justify-content: space-between;\n\n                    &:hover {\n                        border: 1px solid ", ";\n                    }\n                "], ["\n                    background-color: ", ";\n                    border: 1px solid ", ";\n                    border-radius: 6px;\n                    padding: 3px;\n                    justify-content: space-between;\n\n                    &:hover {\n                        border: 1px solid ", ";\n                    }\n                "])), isDisabled ? '#F6F8FB' : '#fff', isDisabled ? '#F6F8FB' : Colors/* colors.neutral.80 */.O9.neutral[80], Colors/* colors.primary.70 */.O9.primary[70]);
        case TreeSelect_types/* EVariant.SECONDARY */.e.SECONDARY:
            return (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_3 || (InputContainer_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: ", ";\n                    border: none;\n                    border-radius: 48px;\n                    padding: 5px 8px;\n                    justify-content: flex-start;\n                "], ["\n                    background-color: ", ";\n                    border: none;\n                    border-radius: 48px;\n                    padding: 5px 8px;\n                    justify-content: flex-start;\n                "])), isDisabled ? '#F6F8FB' : Colors/* colors.neutral.95 */.O9.neutral[95]);
        default:
            return '';
    }
}, function (_a) {
    var isError = _a.isError;
    return isError && (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_4 || (InputContainer_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border: 1px solid #ff4a53;\n            :hover {\n                border: 1px solid #ff4a53;\n            }\n        "], ["\n            border: 1px solid #ff4a53;\n            :hover {\n                border: 1px solid #ff4a53;\n            }\n        "])));
}, function (_a) {
    var isPlaceholder = _a.isPlaceholder;
    return isPlaceholder && "color:#999;";
}, function (_a) {
    var isTransparentBackground = _a.isTransparentBackground;
    if (!isTransparentBackground) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_5 || (InputContainer_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            background-color: transparent;\n            border: 1px solid transparent;\n            :hover {\n                border: 1px solid transparent;\n            }\n        "], ["\n            background-color: transparent;\n            border: 1px solid transparent;\n            :hover {\n                border: 1px solid transparent;\n            }\n        "])));
}, function (_a) {
    var markHasValue = _a.markHasValue;
    return markHasValue && (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_6 || (InputContainer_css_templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border: 1px solid rgb(0, 102, 255);\n        "], ["\n            border: 1px solid rgb(0, 102, 255);\n        "])));
}, function (_a) {
    var forResponsive = _a.forResponsive;
    return forResponsive && (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_7 || (InputContainer_css_templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            border: none;\n            color: #333 !important;\n            background: #f1f2f4 !important;\n        "], ["\n            border: none;\n            color: #333 !important;\n            background: #f1f2f4 !important;\n        "])));
}, function (_a) {
    var forResponsive = _a.forResponsive, markHasValue = _a.markHasValue;
    return forResponsive && markHasValue
        ? (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_8 || (InputContainer_css_templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                  background: #eff5ff !important;\n                  border: none;\n              "], ["\n                  background: #eff5ff !important;\n                  border: none;\n              "]))) : "";
});
var SelectedItem = styled_components_browser_esm/* default.div */.ZP.div(InputContainer_css_templateObject_10 || (InputContainer_css_templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    overflow: hidden;\n    white-space: nowrap;\n    width: 100%;\n"], ["\n    display: flex;\n    overflow: hidden;\n    white-space: nowrap;\n    width: 100%;\n"])));
var NumberDistricts = styled_components_browser_esm/* default.span */.ZP.span(InputContainer_css_templateObject_11 || (InputContainer_css_templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    font-weight: 500;\n    line-height: 18px;\n    margin-left: 4px;\n"], ["\n    font-weight: 500;\n    line-height: 18px;\n    margin-left: 4px;\n"])));
var RemoveSpan = styled_components_browser_esm/* default.span */.ZP.span(InputContainer_css_templateObject_12 || (InputContainer_css_templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    pointer-events: none;\n    margin-left: 6px;\n    right: 10px;\n    opacity: 0;\n    transition: all 0.25s;\n    position: absolute;\n    display: inline-flex;\n"], ["\n    pointer-events: none;\n    margin-left: 6px;\n    right: 10px;\n    opacity: 0;\n    transition: all 0.25s;\n    position: absolute;\n    display: inline-flex;\n"])));
var ItemTag = styled_components_browser_esm/* default.div */.ZP.div(InputContainer_css_templateObject_17 || (InputContainer_css_templateObject_17 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n    font-size: 14px;\n    margin-left: 4px;\n    display: flex;\n    align-items: center;\n    position: relative;\n    transition: all 0.25s;\n    animation: ", " 0.25s ease-in-out forwards;\n    will-change: transform;\n    &:first-child {\n        margin-left: 0;\n    }\n    ", "\n"], ["\n    ", "\n    font-size: 14px;\n    margin-left: 4px;\n    display: flex;\n    align-items: center;\n    position: relative;\n    transition: all 0.25s;\n    animation: ", " 0.25s ease-in-out forwards;\n    will-change: transform;\n    &:first-child {\n        margin-left: 0;\n    }\n    ", "\n"])), function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? TreeSelect_types/* EVariant.PRIMARY */.e.PRIMARY : _b, forResponsive = _a.forResponsive;
    if (variant === TreeSelect_types/* EVariant.SECONDARY */.e.SECONDARY) {
        return (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_13 || (InputContainer_css_templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                background: ", ";\n                color: ", ";\n                font-weight: 500;\n                line-height: 18px;\n                border-radius: 12px;\n                padding: 2px 6px;\n                @media screen and (max-width: 767px) {\n                    padding: 6px 8px;\n                    border-radius: 16px;\n                }\n            "], ["\n                background: ", ";\n                color: ", ";\n                font-weight: 500;\n                line-height: 18px;\n                border-radius: 12px;\n                padding: 2px 6px;\n                @media screen and (max-width: 767px) {\n                    padding: 6px 8px;\n                    border-radius: 16px;\n                }\n            "])), Colors/* colors.primary.90 */.O9.primary[90], Colors/* colors.primary.20 */.O9.primary[20]);
    }
    if (forResponsive) {
        return (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_14 || (InputContainer_css_templateObject_14 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                background-color: transparent;\n                color: #003699;\n            "], ["\n                background-color: transparent;\n                color: #003699;\n            "])));
    }
    return (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_15 || (InputContainer_css_templateObject_15 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            background-color: #e6efff;\n            border: 1px solid tranparent;\n            color: #003699;\n            line-height: 20px;\n            font-weight: 400;\n            border-radius: 4px;\n            padding: 4px 8px;\n        "], ["\n            background-color: #e6efff;\n            border: 1px solid tranparent;\n            color: #003699;\n            line-height: 20px;\n            font-weight: 400;\n            border-radius: 4px;\n            padding: 4px 8px;\n        "])));
}, dimAnim, function (_a) {
    var isHover = _a.isHover, isDisabledClearValue = _a.isDisabledClearValue;
    if (!isHover || isDisabledClearValue) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_16 || (InputContainer_css_templateObject_16 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            padding-right: 26px;\n            ", " {\n                pointer-events: initial;\n                right: 6px;\n                opacity: 1;\n            }\n        "], ["\n            padding-right: 26px;\n            ", " {\n                pointer-events: initial;\n                right: 6px;\n                opacity: 1;\n            }\n        "])), RemoveSpan);
});
var SingleItem = styled_components_browser_esm/* default.span */.ZP.span(InputContainer_css_templateObject_18 || (InputContainer_css_templateObject_18 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding-left: 4px;\n    padding-right: 3px;\n    font-size: 14px;\n    line-height: 24px;\n    color: ", ";\n"], ["\n    padding-left: 4px;\n    padding-right: 3px;\n    font-size: 14px;\n    line-height: 24px;\n    color: ", ";\n"])), function (_a) {
    var isPlaceholder = _a.isPlaceholder, placeholderColor = _a.placeholderColor;
    return (isPlaceholder ? (placeholderColor !== null && placeholderColor !== void 0 ? placeholderColor : '#999') : '#333');
});
var PlaceHolder = styled_components_browser_esm/* default.div */.ZP.div(InputContainer_css_templateObject_22 || (InputContainer_css_templateObject_22 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    margin-left: 4px;\n    ", "\n    ", "\n    ", "\n"], ["\n    margin-left: 4px;\n    ", "\n    ", "\n    ", "\n"])), function (_a) {
    var clearSpaceLeft = _a.clearSpaceLeft;
    if (clearSpaceLeft) {
        return (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_19 || (InputContainer_css_templateObject_19 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                margin-left: 0 !important;\n                padding-left: 0 !important;\n            "], ["\n                margin-left: 0 !important;\n                padding-left: 0 !important;\n            "])));
    }
    return '';
}, function (_a) {
    var isInFilter = _a.isInFilter, _b = _a.variant, variant = _b === void 0 ? TreeSelect_types/* EVariant.PRIMARY */.e.PRIMARY : _b;
    if (!isInFilter) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_20 || (InputContainer_css_templateObject_20 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            font-size: 14px;\n            line-height: ", ";\n            font-weight: ", ";\n            color: ", ";\n            padding-left: ", ";\n        "], ["\n            font-size: 14px;\n            line-height: ", ";\n            font-weight: ", ";\n            color: ", ";\n            padding-left: ", ";\n        "])), variant === TreeSelect_types/* EVariant.SECONDARY */.e.SECONDARY ? '18px' : '24px', variant === TreeSelect_types/* EVariant.SECONDARY */.e.SECONDARY ? 500 : 400, variant === TreeSelect_types/* EVariant.SECONDARY */.e.SECONDARY ? Colors/* colors.grey.20 */.O9.grey[20] : '#333', variant === TreeSelect_types/* EVariant.SECONDARY */.e.SECONDARY ? 0 : '5px');
}, function (_a) {
    var placeholderColor = _a.placeholderColor;
    return placeholderColor && (0,styled_components_browser_esm/* css */.iv)(InputContainer_css_templateObject_21 || (InputContainer_css_templateObject_21 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            color: ", ";\n        "], ["\n            color: ", ";\n        "])), placeholderColor);
});
var InputContainer_css_templateObject_1, InputContainer_css_templateObject_2, InputContainer_css_templateObject_3, InputContainer_css_templateObject_4, InputContainer_css_templateObject_5, InputContainer_css_templateObject_6, InputContainer_css_templateObject_7, InputContainer_css_templateObject_8, InputContainer_css_templateObject_9, InputContainer_css_templateObject_10, InputContainer_css_templateObject_11, InputContainer_css_templateObject_12, InputContainer_css_templateObject_13, InputContainer_css_templateObject_14, InputContainer_css_templateObject_15, InputContainer_css_templateObject_16, InputContainer_css_templateObject_17, InputContainer_css_templateObject_18, InputContainer_css_templateObject_19, InputContainer_css_templateObject_20, InputContainer_css_templateObject_21, InputContainer_css_templateObject_22;


//# sourceMappingURL=InputContainer.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/TreeSelect/components/InputContainer/index.js
'use client';












var InputContainer = (0,react.forwardRef)(function (props, ref) {
    var placeholder = props.placeholder, isError = props.isError, styleOptions = props.styleOptions, value = props.value, options = props.options, childrenList = props.childrenList, _a = props.isDisabled, isDisabled = _a === void 0 ? false : _a, _b = props.langCode, langCode = _b === void 0 ? Utils_constants/* ELanguage.VI */.Df.VI : _b, onClick = props.onClick, onRemoveItem = props.onRemoveItem, selectOptions = props.selectOptions, isDisabledClearValue = props.isDisabledClearValue, markHasValue = props.markHasValue, forResponsive = props.forResponsive;
    var mergedStyleOption = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, TreeSelect_constants/* DEFAULT_INPUT_STYLE */.v1), styleOptions);
    var mergedSelectOptions = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, TreeSelect_constants/* DEFAULT_SELECT_OPTIONS */.mt), selectOptions);
    var _c = (0,react.useState)(mergedStyleOption.limitDisplay), showLimit = _c[0], setShowLimit = _c[1];
    var _d = (0,react.useState)(false), isStripFirstLabel = _d[0], setIsRequireStripFirstLabel = _d[1];
    var itemTagWrapperRef = (0,react.useRef)(null);
    var _e = (0,react.useState)(0), parentTagsWrapperWidth = _e[0], setParentTagsWrapperWidth = _e[1];
    var getSelectedItemInText = (0,react.useCallback)(function (limit) {
        var _a, _b;
        var selectedItem = (_a = (value &&
            value.map(function (item) {
                var filteredOptions = options.filter(function (optionItem) { return optionItem.id === item.parentId; });
                if (filteredOptions.length === 0) {
                    return {
                        id: -1,
                        name: ''
                    };
                }
                return filteredOptions[0];
            }))) !== null && _a !== void 0 ? _a : [];
        // Filter empty item out of array
        var filteredNotEmpty = selectedItem.filter(function (item) { return item.id !== -1; });
        filteredNotEmpty = filteredNotEmpty.slice(0, limit);
        // Count total text length
        var joinedText = filteredNotEmpty.map(function (item) { return item.name; }).join('');
        return {
            selectedItem: filteredNotEmpty,
            totalLength: (_b = joinedText === null || joinedText === void 0 ? void 0 : joinedText.length) !== null && _b !== void 0 ? _b : 0
        };
    }, [options, value]);
    var calculateDisplayItem = (0,react.useCallback)(function (limit) {
        var _a;
        var _b = getSelectedItemInText(limit), selectedItem = _b.selectedItem, _c = _b.totalLength, totalLength = _c === void 0 ? 0 : _c;
        if (!selectedItem || (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.length) === 0) {
            return [0, 0];
        }
        var itemWrapper = (_a = itemTagWrapperRef === null || itemTagWrapperRef === void 0 ? void 0 : itemTagWrapperRef.current) !== null && _a !== void 0 ? _a : null;
        if (itemWrapper === null || !(itemWrapper === null || itemWrapper === void 0 ? void 0 : itemWrapper.parentElement)) {
            return [0, 0];
        }
        // Calculate width being use
        var totalTextWidth = totalLength * TreeSelect_constants/* DEFAULT_CHARACTER_WIDTH */.r$;
        var totalPaddingWidth = limit * TreeSelect_constants/* DEFAULT_PADDING_WIDTH */.Rm;
        var totalMarginWidth = limit > 1 ? (limit - 1) * TreeSelect_constants/* DEFAULT_MARGIN_WIDTH */.P7 : 0;
        var totalBorderWidth = limit * TreeSelect_constants/* DEFAULT_BORDER_WIDTH */.Z0;
        // calculate total
        var totalWidth = totalTextWidth + totalPaddingWidth + totalBorderWidth + totalMarginWidth + TreeSelect_constants/* DEFAULT_REMOVE_ICON_WIDTH */.mG;
        return [totalWidth, parentTagsWrapperWidth];
    }, [getSelectedItemInText, itemTagWrapperRef, parentTagsWrapperWidth]);
    var updateDisplayItem = (0,react.useCallback)(function () {
        if ((value === null || value === void 0 ? void 0 : value.length) === 0) {
            return;
        }
        var isFit = false;
        var isStripFirstItem = false;
        var calcTotalWidth = 0;
        var calcItemWrapperWidth = 0;
        var limitCount = mergedStyleOption.limitDisplay;
        while (!isFit) {
            var _a = calculateDisplayItem(limitCount), totalWidth = _a[0], itemWrapperWidth = _a[1];
            if (totalWidth === 0 && itemWrapperWidth === 0) {
                isFit = true;
            }
            if (totalWidth < itemWrapperWidth) {
                isFit = true;
                calcTotalWidth = totalWidth;
                calcItemWrapperWidth = itemWrapperWidth;
            }
            else {
                limitCount--;
            }
            if (limitCount <= 0) {
                limitCount = 1;
                isFit = true;
                isStripFirstItem = totalWidth > itemWrapperWidth;
            }
        }
        var displayItemCount = limitCount;
        if (calcTotalWidth >= calcItemWrapperWidth) {
            // minus 1 item
            displayItemCount = (limitCount !== null && limitCount !== void 0 ? limitCount : 2) - 1;
        }
        // Allow to display all
        if (displayItemCount === 0) {
            displayItemCount = 1;
        }
        setShowLimit(displayItemCount);
        setIsRequireStripFirstLabel(isStripFirstItem);
    }, [calculateDisplayItem, value]);
    (0,react.useEffect)(function () {
        setTimeout(function () {
            var _a, _b, _c, _d;
            // delay 600ms wait for transitions 500ms in searchbar
            if ((_b = (_a = itemTagWrapperRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.clientWidth) {
                setParentTagsWrapperWidth((_d = (_c = itemTagWrapperRef.current) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.clientWidth);
            }
        }, 600);
        if (styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.forceLimitDisplay) {
            setShowLimit(styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.forceLimitDisplay);
            return;
        }
        updateDisplayItem();
        if (typeof window === 'undefined') {
            return;
        }
        window.addEventListener('resize', updateDisplayItem);
        return function () {
            if (typeof window === 'undefined') {
                return;
            }
            window.removeEventListener('resize', updateDisplayItem);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options, value, styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.forceLimitDisplay, itemTagWrapperRef.current]);
    var renderSelectedItem = function () {
        var _a;
        var selectedItem = getSelectedItemInText(showLimit).selectedItem;
        var itemTagList = [];
        if (value && (value === null || value === void 0 ? void 0 : value.length) > 0 && (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.length) === 0) {
            itemTagList.push((0,jsx_runtime.jsxs)(ItemTag, { variant: mergedStyleOption.variant, isHover: false, forResponsive: forResponsive, children: ["+", value.length - showLimit] }, 'item-tag-plus'));
        }
        if ((value && (value === null || value === void 0 ? void 0 : value.length) === 0) || !selectedItem) {
            return ((0,jsx_runtime.jsx)(PlaceHolder, { variant: mergedStyleOption.variant, isInFilter: mergedSelectOptions.isFilter, clearSpaceLeft: mergedStyleOption.clearSpaceLeft, placeholderColor: mergedStyleOption.placeholderColor, children: placeholder }));
        }
        var itemWrapper = (_a = itemTagWrapperRef === null || itemTagWrapperRef === void 0 ? void 0 : itemTagWrapperRef.current) !== null && _a !== void 0 ? _a : null;
        if (itemWrapper === null || !(itemWrapper === null || itemWrapper === void 0 ? void 0 : itemWrapper.parentElement)) {
            return ((0,jsx_runtime.jsx)(PlaceHolder, { variant: mergedStyleOption.variant, isInFilter: mergedSelectOptions.isFilter, clearSpaceLeft: mergedStyleOption.clearSpaceLeft, placeholderColor: mergedStyleOption.placeholderColor, children: placeholder }));
        }
        itemTagList = selectedItem.map(function (item, index) {
            var _a;
            var filteredValue = value === null || value === void 0 ? void 0 : value.filter(function (valueItem) {
                return valueItem.parentId === item.id;
            });
            var countChild = 0;
            if (filteredValue && (filteredValue === null || filteredValue === void 0 ? void 0 : filteredValue.length) > 0) {
                countChild = filteredValue === null || filteredValue === void 0 ? void 0 : filteredValue.length;
            }
            // get number districts
            var numberDistricts;
            var province = value === null || value === void 0 ? void 0 : value.find(function (_a) {
                var parentId = _a.parentId;
                return parentId === item.id;
            });
            if (province && province.childrenIds[0] !== -1) {
                numberDistricts = province.childrenIds.length;
            }
            var itemLabel = item.name;
            if ((selectOptions === null || selectOptions === void 0 ? void 0 : selectOptions.isStripFirstItem) && isStripFirstLabel) {
                var totalTextWidth = item.name.length * TreeSelect_constants/* DEFAULT_CHARACTER_WIDTH */.r$;
                var inputWidth = (((_a = itemWrapper === null || itemWrapper === void 0 ? void 0 : itemWrapper.parentElement) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0) -
                    (TreeSelect_constants/* DEFAULT_REMOVE_ICON_WIDTH */.mG + TreeSelect_constants/* DEFAULT_MARGIN_WIDTH */.P7 + TreeSelect_constants/* DEFAULT_BORDER_WIDTH */.Z0);
                if (value && value.length > 1) {
                    inputWidth -= TreeSelect_constants/* FIXED_WIDTH_OF_INPUT */.mg;
                }
                var isSplit = itemLabel.length > mergedSelectOptions.limitFirstItemLength;
                if (isSplit && totalTextWidth > inputWidth) {
                    itemLabel = itemLabel.slice(0, mergedSelectOptions.limitFirstItemLength) + '...';
                }
            }
            return ((0,jsx_runtime.jsxs)(ItemTag, { "data-selected-child-count": countChild, variant: mergedStyleOption.variant, isDisabledClearValue: isDisabledClearValue, isHover: true, forResponsive: forResponsive, children: [(0,jsx_runtime.jsx)("span", { children: itemLabel }), !!numberDistricts && ((0,jsx_runtime.jsx)(NumberDistricts, { children: (styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.variant) === TreeSelect_types/* EVariant.SECONDARY */.e.SECONDARY ? "(".concat(numberDistricts, ")") : numberDistricts })), !isDisabledClearValue ? ((0,jsx_runtime.jsx)(RemoveSpan, { onClick: function (e) {
                            e.stopPropagation();
                            onRemoveItem(item.id);
                        }, children: (0,jsx_runtime.jsx)(CheckTagIcon$1, {}) })) : null] }, "item-tag-".concat(index)));
        });
        if (value && (value === null || value === void 0 ? void 0 : value.length) > showLimit) {
            itemTagList.push((0,jsx_runtime.jsxs)(ItemTag, { variant: mergedStyleOption.variant, isHover: false, forResponsive: forResponsive, children: ["+", value.length - showLimit] }, 'item-tag-plus'));
        }
        return itemTagList;
    };
    var renderSingleSelectItem = function () {
        var placeHolderComponent = ((0,jsx_runtime.jsx)(SingleItem, { isPlaceholder: true, placeholderColor: mergedStyleOption.placeholderColor, children: placeholder }));
        if (!value || (value && (value === null || value === void 0 ? void 0 : value.length) === 0)) {
            return placeHolderComponent;
        }
        if (value[0].childrenIds.length === 0) {
            return placeHolderComponent;
        }
        var selectedParentId = value[0].parentId;
        var selectedChildId = value[0].childrenIds[0];
        // Find child item by selected id
        var keys = Object.keys(childrenList);
        var values = Object.values(childrenList);
        var index = keys.indexOf(selectedParentId.toString());
        var childItems = values[index];
        if (!childItems) {
            return placeHolderComponent;
        }
        var childItemInfo = childItems.filter(function (item) { return item.id === selectedChildId; });
        if (childItemInfo.length === 0) {
            return placeHolderComponent;
        }
        return (0,jsx_runtime.jsx)(SingleItem, { children: langCode === Utils_constants/* ELanguage.VI */.Df.VI ? childItemInfo[0].name : childItemInfo[0].nameEn });
    };
    var leftIcon = function () {
        if (styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.leftIcon) {
            var Icon = styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.leftIcon;
            return ((0,jsx_runtime.jsx)(Icon, { color: value && value.length > 0 ? Colors/* colors.primary.30 */.O9.primary[30] : undefined, width: mergedStyleOption.arrowDownSize.width, height: mergedStyleOption.arrowDownSize.height }));
        }
        return null;
    };
    return ((0,jsx_runtime.jsxs)(SInputContainer, { isError: isError, isDisabled: isDisabled, isPlaceholder: true, onClick: function () { return onClick && onClick(); }, isTransparentBackground: mergedStyleOption.isTransparentBackground, variant: mergedStyleOption.variant, ref: ref, className: 'tree-select-input', markHasValue: markHasValue, forResponsive: forResponsive, children: [mergedStyleOption.variant === TreeSelect_types/* EVariant.SECONDARY */.e.SECONDARY ? leftIcon() : null, (0,jsx_runtime.jsx)(SelectedItem, { ref: itemTagWrapperRef, children: mergedSelectOptions.isSingleSelect ? renderSingleSelectItem() : renderSelectedItem() }), mergedStyleOption.variant === TreeSelect_types/* EVariant.PRIMARY */.e.PRIMARY && ((0,jsx_runtime.jsx)(ArrowDownIcon$1, { width: mergedStyleOption.arrowDownSize.width, height: mergedStyleOption.arrowDownSize.height }))] }));
});


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/TreeSelect/components/MobileDialog/MobileDialog.css.js
'use client';




var MobileDialogWrapper = styled_components_browser_esm/* default.div */.ZP.div(MobileDialog_css_templateObject_1 || (MobileDialog_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: 999;\n    display: ", ";\n"], ["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: 999;\n    display: ", ";\n"])), function (_a) {
    var isShow = _a.isShow;
    return (isShow ? 'block' : 'none');
});
var MobileContent = styled_components_browser_esm/* default.div */.ZP.div(MobileDialog_css_templateObject_2 || (MobileDialog_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    background-color: #fff;\n    width: 100%;\n    height: 100%;\n    padding: 16px;\n"], ["\n    background-color: #fff;\n    width: 100%;\n    height: 100%;\n    padding: 16px;\n"])));
var MobileBody = styled_components_browser_esm/* default.div */.ZP.div(MobileDialog_css_templateObject_3 || (MobileDialog_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    height: 100%;\n"], ["\n    height: 100%;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(MobileDialog_css_templateObject_4 || (MobileDialog_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    height: 60px;\n    display: flex;\n    justify-content: space-between;\n    padding-top: 20px;\n    border-top: 1px solid #eaeaf0;\n    > button {\n        width: 50%;\n        &:nth-child(1) {\n            margin-right: 5px;\n        }\n        &:nth-child(2) {\n            margin-left: 5px;\n        }\n    }\n"], ["\n    height: 60px;\n    display: flex;\n    justify-content: space-between;\n    padding-top: 20px;\n    border-top: 1px solid #eaeaf0;\n    > button {\n        width: 50%;\n        &:nth-child(1) {\n            margin-right: 5px;\n        }\n        &:nth-child(2) {\n            margin-left: 5px;\n        }\n    }\n"])));
var MobileDialog_css_templateObject_1, MobileDialog_css_templateObject_2, MobileDialog_css_templateObject_3, MobileDialog_css_templateObject_4;


//# sourceMappingURL=MobileDialog.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/TreeSelect/components/MobileDialog/index.js
'use client';






var MobileDialog = function (props) {
    var children = props.children, _a = props.isShow, isShow = _a === void 0 ? false : _a, onUnmount = props.onUnmount;
    var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
    (0,react.useEffect)(function () {
        if (!bodyNode) {
            return;
        }
        // Lock body scroll
        var removeOverflowClass = function () {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        };
        // lock scrolling on body
        if (isShow) {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
        }
        else {
            removeOverflowClass();
        }
        // Component will unmount
        return function () {
            removeOverflowClass();
        };
    }, [bodyNode, isShow]);
    (0,react.useEffect)(function () {
        // Trigger onUnmount when component is un-mounted
        return function () {
            onUnmount && onUnmount();
        };
    }, [onUnmount]);
    if (!bodyNode || !isShow) {
        return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return (0,react_dom.createPortal)((0,jsx_runtime.jsx)(MobileDialogWrapper, { "data-cname": 'portal-mobile-dialog', isShow: isShow, children: (0,jsx_runtime.jsx)(MobileContent, { children: (0,jsx_runtime.jsx)(MobileBody, { children: children }) }) }), bodyNode);
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/TreeSelect/translations.js
'use client';

var translations_translations = {
    All: 'Tất cả',
    Back: 'Trở về',
    Apply: 'Áp dụng',
    Cancel: 'Hủy',
    Select: 'Chọn',
    Search: 'Tìm kiếm',
    'Remove all': 'Xóa tất cả',
    'No result': 'Không có kết quả',
    'You have selected up to three options': 'Bạn đã chọn tối đa ba tuỳ chọn',
    districts: 'quận/huyện'
};


//# sourceMappingURL=translations.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Popup/index.js + 3 modules
var Popup = __webpack_require__(4835);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Popup/Popup.css.js
var Popup_css = __webpack_require__(54129);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/TreeSelect/TreeSelect.css.js
'use client';






var TreeSelectWrapper = styled_components_browser_esm/* default.div */.ZP.div(TreeSelect_css_templateObject_3 || (TreeSelect_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    width: 100%;\n    ", "\n    ", "\n"], ["\n    position: relative;\n    width: 100%;\n    ", "\n    ", "\n"])), function (_a) {
    var isDisabled = _a.isDisabled;
    if (!isDisabled) {
        return '';
    }
    return (0,styled_components_browser_esm/* css */.iv)(TreeSelect_css_templateObject_1 || (TreeSelect_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            pointer-events: none;\n        "], ["\n            pointer-events: none;\n        "])));
}, function (_a) {
    var cssString = _a.cssString;
    if (!cssString)
        return;
    return (0,styled_components_browser_esm/* css */.iv)(TreeSelect_css_templateObject_2 || (TreeSelect_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            ", "\n        "], ["\n            ", "\n        "])), cssString);
});
(0,styled_components_browser_esm/* default */.ZP)(Popup/* default */.Z)(TreeSelect_css_templateObject_4 || (TreeSelect_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", " {\n        background-color: #fff;\n    }\n"], ["\n    ", " {\n        background-color: #fff;\n    }\n"])), Popup_css/* PopupContent */.pP);
var TreeSelect_css_templateObject_1, TreeSelect_css_templateObject_2, TreeSelect_css_templateObject_3, TreeSelect_css_templateObject_4;


//# sourceMappingURL=TreeSelect.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/TreeSelect/context/reducer.js
var context_reducer = __webpack_require__(49287);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/TreeSelect/context/index.js
var TreeSelect_context = __webpack_require__(68371);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/TreeSelect/context/types.js
var context_types = __webpack_require__(69013);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/TreeSelect/helpers.js
var TreeSelect_helpers = __webpack_require__(71078);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/TreeSelect/index.js
'use client';




















var Dropdown = react.lazy(function () { return __webpack_require__.e(/* import() */ 696).then(__webpack_require__.bind(__webpack_require__, 28696)); });
var TreeSelect = function (props) {
    var langCode = props.langCode, textOptions = props.textOptions, selectOptions = props.selectOptions, _a = props.hasError, hasError = _a === void 0 ? false : _a, _b = props.isMobile, isMobile = _b === void 0 ? false : _b, _c = props.isEnableFooter, isEnableFooter = _c === void 0 ? false : _c, _d = props.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = props.options, options = _e === void 0 ? [] : _e, _f = props.childrenList, childrenList = _f === void 0 ? {} : _f, _g = props.value, value = _g === void 0 ? [] : _g, dropdownStyleOptions = props.dropdownStyleOptions, styleOptions = props.styleOptions, onValueChange = props.onValueChange, onRemoveEachValue = props.onRemoveEachValue, onCloseDropdown = props.onCloseDropdown, onShowDropdown = props.onShowDropdown, floatingConfig = props.floatingConfig, onBlur = props.onBlur, onApplyChangeProps = props.onClickApply, onClickCancel = props.onClickCancel, isDisabledClearValue = props.isDisabledClearValue, forResponsive = props.forResponsive;
    var _h = floatingConfig || {}, _j = _h.placement, placement = _j === void 0 ? 'bottom-start' : _j, _k = _h.position, position = _k === void 0 ? 'absolute' : _k, _l = _h.useWindowAsFlippingContainer, useWindowAsFlippingContainer = _l === void 0 ? false : _l, _m = _h.enablePortal, enablePortal = _m === void 0 ? false : _m, _o = _h.isFlip, isFlip = _o === void 0 ? true : _o;
    var mergedSelectOptions = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, TreeSelect_constants/* DEFAULT_SELECT_OPTIONS */.mt), selectOptions);
    var mergedDropdownStyleOptions = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, TreeSelect_constants/* DEFAULT_DROPDOWN_STYLE_OPTIONS */.tX), dropdownStyleOptions);
    var _p = (0,react.useReducer)(context_reducer/* treeSelectReducer */.s, TreeSelect_context/* initialTreeSelect */.b), treeSelectState = _p[0], dispatch = _p[1];
    // Dropdown state
    var _q = (0,react.useState)(false), isVisible = _q[0], setElementVisible = _q[1];
    var _r = (0,useFloating/* default */.Z)({
        placement: placement,
        position: position,
        config: {
            useWindowAsFlippingContainer: useWindowAsFlippingContainer,
            isFlip: isFlip,
            detectHidden: !mergedDropdownStyleOptions.isForceClose
        }
    }), refs = _r.refs, context = _r.context, FloatingPortal = _r.FloatingPortal;
    // Value
    var _s = (0,react.useState)(value), selectedValue = _s[0], setSelectedValue = _s[1];
    // Mobile temporary Value
    var _t = (0,react.useState)(value), tempSelectedValue = _t[0], setTempSelectedValue = _t[1];
    // Dropdown state
    var _u = (0,react.useState)(true), isFirstLevelMounted = _u[0], setFirstLevelMounted = _u[1];
    var _v = (0,react.useState)(false), isSecondLevelMounted = _v[0], setSecondLevelMounted = _v[1];
    var resetSelectView = function () {
        if (!mergedSelectOptions.isSingleSelect) {
            return;
        }
        dispatch({
            type: context_types/* TreeSelectAction.UPDATE_SELECT_LEVEL */.N.UPDATE_SELECT_LEVEL,
            payload: 0
        });
        dispatch({
            type: context_types/* TreeSelectAction.UPDATE_SELECTED_PARENT_ID */.N.UPDATE_SELECTED_PARENT_ID,
            payload: -1
        });
        setFirstLevelMounted(true);
        setSecondLevelMounted(false);
    };
    (0,useClickAway/* default */.Z)(function () {
        resetSelectView();
        setElementVisible(false);
        onBlur && onBlur();
    }, {
        nodeRefs: [refs.popup, refs.reference]
    });
    // End dropdown state
    var sortedOptions = (0,TreeSelect_helpers/* sortOptionsAlphabet */.t_)((0,_tslib/* __spreadArray */.ev)([], options, true), mergedSelectOptions.isSortAlphabet);
    var sortedChildOptions = (0,TreeSelect_helpers/* sortChildOptionAlphabet */.j5)((0,_tslib/* __assign */.pi)({}, childrenList), langCode, mergedSelectOptions.isSortAlphabet);
    // isApply Click
    var isApplyClick = (0,react.useRef)(false);
    var isAlreadyOpened = (0,react.useRef)(false);
    var bodyNode = typeof document !== 'undefined' ? document === null || document === void 0 ? void 0 : document.querySelector('body') : null;
    var t = function (text) {
        var _a;
        if (langCode === Utils_constants/* ELanguage.EN */.Df.EN) {
            return text;
        }
        else {
            return (_a = translations_translations[text]) !== null && _a !== void 0 ? _a : text;
        }
    };
    // this cb handle for case just apply value changed when
    var dispatchValueChanged = function (clonedSelectedValue) {
        // Only callback onValueChange when value is different with value from prop
        if (value.length === 0 && clonedSelectedValue.length === 0) {
            return;
        }
        var isChange = (0,helpers/* isLocationChanged */.G)(value, clonedSelectedValue);
        if (!isChange) {
            return;
        }
        onValueChange && onValueChange(clonedSelectedValue);
    };
    var onRemoveItem = function (id) {
        var clonedSelectedValue = (0,_tslib/* __spreadArray */.ev)([], selectedValue, true).filter(function (item) { return item.parentId !== id; });
        setSelectedValue(clonedSelectedValue);
        dispatchValueChanged(clonedSelectedValue);
        if (onRemoveEachValue) {
            var itemRemove = selectedValue.find(function (item) { return item.parentId === id; });
            onRemoveEachValue(clonedSelectedValue, itemRemove);
        }
        setTempSelectedValue(clonedSelectedValue);
    };
    var onSetSelectedValue = function (value) {
        var clonedValue = (0,_tslib/* __spreadArray */.ev)([], value, true);
        // Do update temporary selectedValue when isMobile or isEnableFooter
        if (!(selectOptions === null || selectOptions === void 0 ? void 0 : selectOptions.isSingleSelect) && (isMobile || isEnableFooter)) {
            setTempSelectedValue(clonedValue);
            return;
        }
        if (selectOptions === null || selectOptions === void 0 ? void 0 : selectOptions.isSingleSelect) {
            setTempSelectedValue(clonedValue);
        }
        setSelectedValue(clonedValue);
        dispatchValueChanged(clonedValue);
        if ((selectOptions === null || selectOptions === void 0 ? void 0 : selectOptions.isSingleSelect) && clonedValue.length > 0) {
            setElementVisible(false);
        }
    };
    var onClickApply = function () {
        isApplyClick.current = true;
        // When apply button clicked, set selectedValue from tempSelectedValue
        setSelectedValue(tempSelectedValue);
        dispatchValueChanged(tempSelectedValue);
        onApplyChangeProps && onApplyChangeProps(tempSelectedValue);
    };
    var resetTemporarySelectedValue = function () {
        if (isApplyClick.current) {
            isApplyClick.current = false;
            return;
        }
        if (isVisible) {
            return;
        }
        // Reset tempSelectedValue when apply is not triggered
        setTempSelectedValue(selectedValue);
    };
    var getInputContainerValue = function () {
        if (isApplyClick.current && isMobile) {
            return tempSelectedValue;
        }
        if (isEnableFooter) {
            return tempSelectedValue;
        }
        return (0,TreeSelect_helpers/* deepCloneArray */.NU)(selectedValue);
    };
    var updateMountedLevel = function (level) {
        if (level === TreeSelect_constants/* SELECT_CATE_LEVEL_PARENT */.av) {
            return;
        }
        setFirstLevelMounted(false);
        setSecondLevelMounted(true);
    };
    var checkAndUpdateHistory = function () {
        // This function is not ready for mutiple select yet
        // TODO: make this into option that allow to show current view from history
        if (!mergedSelectOptions.isSingleSelect) {
            return;
        }
        var history = treeSelectState.history, selectLevel = treeSelectState.selectLevel, selectedParentId = treeSelectState.selectedParentId;
        var isHistoryChange = false;
        if (selectLevel !== history.selectLevel) {
            // Update select level
            dispatch({
                type: context_types/* TreeSelectAction.UPDATE_SELECT_LEVEL */.N.UPDATE_SELECT_LEVEL,
                payload: history.selectLevel
            });
            updateMountedLevel(history.selectLevel);
            isHistoryChange = true;
        }
        if (selectedParentId !== history.selectedParentId) {
            // Update select parent
            dispatch({
                type: context_types/* TreeSelectAction.UPDATE_SELECTED_PARENT_ID */.N.UPDATE_SELECTED_PARENT_ID,
                payload: history.selectedParentId
            });
            isHistoryChange = true;
        }
        // Check history change
        if (isHistoryChange) {
            return;
        }
        // Check value and set level
        if (value.length === 0) {
            return;
        }
        var levelFromValue = value[0].parentId === -1 ? TreeSelect_constants/* SELECT_CATE_LEVEL_PARENT */.av : TreeSelect_constants/* SELECT_CATE_LEVEL_SUB */.Rh;
        dispatch({
            type: context_types/* TreeSelectAction.UPDATE_SELECT_LEVEL */.N.UPDATE_SELECT_LEVEL,
            payload: levelFromValue
        });
        dispatch({
            type: context_types/* TreeSelectAction.UPDATE_SELECTED_PARENT_ID */.N.UPDATE_SELECTED_PARENT_ID,
            payload: value[0].parentId
        });
        dispatch({
            type: context_types/* TreeSelectAction.UPDATE_HISTORY */.N.UPDATE_HISTORY,
            payload: {
                selectedParentId: value[0].parentId,
                selectLevel: levelFromValue
            }
        });
        updateMountedLevel(levelFromValue);
    };
    var onClickInputContainer = function () {
        var delayTime = mergedDropdownStyleOptions.delayTime;
        if (delayTime && delayTime > 0) {
            if (isVisible) {
                setElementVisible(false);
            }
            else {
                setTimeout(function () {
                    setElementVisible(true);
                }, delayTime);
            }
        }
        else {
            setElementVisible(!isVisible);
        }
        onShowDropdown && onShowDropdown(!isVisible);
        if (!isVisible) {
            return;
        }
        resetSelectView();
    };
    // We have a issue when parent component change
    // make treeselect component infinity loop
    // this hook useMemo help by pass this error
    var memoValueProps = (0,react.useMemo)(function () {
        if (!value || value.length < 1) {
            return null;
        }
        return value;
    }, [value]);
    (0,react.useEffect)(function () {
        var _a;
        if (!memoValueProps) {
            if (isMobile || isEnableFooter) {
                setTempSelectedValue([]);
            }
            setSelectedValue([]);
            return;
        }
        var mappedValues = [];
        // Re-mapped list with empty child
        for (var i = 0; i < memoValueProps.length; i++) {
            var valueItem = memoValueProps[i];
            if (!(valueItem === null || valueItem === void 0 ? void 0 : valueItem.parentId)) {
                continue;
            }
            mappedValues.push({
                parentId: valueItem === null || valueItem === void 0 ? void 0 : valueItem.parentId,
                childrenIds: (_a = valueItem === null || valueItem === void 0 ? void 0 : valueItem.childrenIds) !== null && _a !== void 0 ? _a : [-1]
            });
        }
        // Make sure filter out undefined and null value
        var filteredValues = mappedValues.filter(function (item) { return item !== undefined && item !== null; });
        // only setMobileSelectedValue for mobile or Desktop with option Enable Footer
        if (isMobile || isEnableFooter) {
            setTempSelectedValue(filteredValues);
        }
        setSelectedValue(filteredValues);
    }, [isMobile, memoValueProps, isEnableFooter]);
    (0,react.useEffect)(function () {
        if (isVisible) {
            checkAndUpdateHistory();
            isAlreadyOpened.current = true;
            return;
        }
        if (isEnableFooter) {
            resetTemporarySelectedValue();
        }
        if (!isAlreadyOpened.current) {
            return;
        }
        onCloseDropdown && onCloseDropdown(selectedValue, isVisible);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isVisible, isAlreadyOpened]);
    (0,react.useEffect)(function () {
        if (!(mergedDropdownStyleOptions === null || mergedDropdownStyleOptions === void 0 ? void 0 : mergedDropdownStyleOptions.isForceClose)) {
            return;
        }
        var onForceClose = function () {
            setElementVisible(false);
            return function () {
                window.removeEventListener('scroll', onForceClose);
            };
        };
        window.addEventListener('scroll', onForceClose);
    }, [mergedDropdownStyleOptions === null || mergedDropdownStyleOptions === void 0 ? void 0 : mergedDropdownStyleOptions.isForceClose]);
    var renderDropdown = function () {
        var _a;
        var parsedSelectedValue = isMobile || isEnableFooter ? tempSelectedValue : selectedValue;
        var isEnableFooterChecked = isMobile ? true : isEnableFooter;
        if (bodyNode === null) {
            return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        }
        var width;
        if (dropdownStyleOptions === null || dropdownStyleOptions === void 0 ? void 0 : dropdownStyleOptions.width) {
            width = dropdownStyleOptions === null || dropdownStyleOptions === void 0 ? void 0 : dropdownStyleOptions.width;
        }
        if (!(dropdownStyleOptions === null || dropdownStyleOptions === void 0 ? void 0 : dropdownStyleOptions.width) && context.position === 'fixed') {
            width = "".concat((_a = refs.reference.current) === null || _a === void 0 ? void 0 : _a.offsetWidth, "px");
        }
        var dropdownStyle = isMobile
            ? {}
            : {
                position: context.position,
                top: context.y,
                left: context.x,
                display: context.isReferenceHidden ? 'none' : 'block',
                width: width,
                marginTop: mergedDropdownStyleOptions.marginTop
            };
        return ((0,jsx_runtime.jsx)(FloatingPortal, { enable: isMobile ? false : enablePortal, children: (0,jsx_runtime.jsx)(react.Suspense, { fallback: (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}), children: (0,jsx_runtime.jsx)(Dropdown, { ref: refs.setPopup, isShow: isVisible, isMobile: isMobile, options: sortedOptions, childrenList: sortedChildOptions, selectOptions: selectOptions, selectedValue: parsedSelectedValue, setSelectedValue: onSetSelectedValue, firstLevelMount: [isFirstLevelMounted, setFirstLevelMounted], secondLevelMount: [isSecondLevelMounted, setSecondLevelMounted], t: t, textOptions: {
                        headerLabel: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.headerLabel) || t('Select'),
                        searchPlaceholder: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.searchPlaceholder) || t('Search'),
                        allText: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.allOptionText) || t('All'),
                        subOptionText: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.subOptionText) || t('districts'),
                        selectAllText: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.selectAllText) || t('All'),
                        maxLimitText: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.maxLimitText) || t('You have selected up to three options'),
                        removeAllText: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.removeAllText) || t('Remove all'),
                        backText: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.backText) || t('Back'),
                        noResultText: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.noResultText) || t('No result'),
                        selectedCountText: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.selectedCountText) || '',
                        primaryButtonText: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.primaryButtonText) || ''
                    }, footerOptions: {
                        isEnableFooter: isEnableFooterChecked,
                        setElementVisible: setElementVisible,
                        onClickApply: onClickApply,
                        onClickCancel: onClickCancel,
                        resetSelectedValue: function () { return setTempSelectedValue(selectedValue); }
                    }, langCode: langCode, styleOptions: dropdownStyleOptions, style: dropdownStyle, placement: context.placement }) }) }));
    };
    return ((0,jsx_runtime.jsx)(context_reducer/* TreeSelectContext.Provider */.E.Provider, { value: {
            state: treeSelectState,
            dispatch: dispatch
        }, children: (0,jsx_runtime.jsxs)(TreeSelectWrapper, { "data-id": 'tree-select', cssString: styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.cssString, isDisabled: isDisabled, children: [(0,jsx_runtime.jsx)(InputContainer, { placeholder: (textOptions === null || textOptions === void 0 ? void 0 : textOptions.inputPlaceholder) || t('All'), isError: hasError, isDisabledClearValue: isDisabledClearValue, value: getInputContainerValue(), options: sortedOptions, isDisabled: isDisabled, onClick: onClickInputContainer, childrenList: sortedChildOptions, onRemoveItem: function (id) { return onRemoveItem(id); }, styleOptions: styleOptions, selectOptions: selectOptions, dropdownStyleOptions: mergedDropdownStyleOptions, langCode: langCode, ref: refs.setReference, markHasValue: tempSelectedValue.length > 0, forResponsive: forResponsive }), isMobile ? ((0,jsx_runtime.jsx)(MobileDialog, { isShow: isVisible, onUnmount: resetTemporarySelectedValue, children: renderDropdown() })) : (renderDropdown())] }) }));
};
var TreeSelect$1 = (0,react.memo)(TreeSelect);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/CompanySize.js
'use client';





var CompanySizeIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return ((0,jsx_runtime.jsx)("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none', children: (0,jsx_runtime.jsx)("path", { d: 'M12 4C9.4544 4 8.4 5.6328 8.4 7.6C8.4 8.2624 8.71719 8.92812 8.71719 8.92812C8.58999 9.00172 8.37845 9.23564 8.43125 9.64844C8.52965 10.418 8.86376 10.6121 9.07656 10.6281C9.15736 11.3465 9.9304 12.2664 10.2 12.4V13.4734C9.6 15.2734 4.8 15 4.8 19.2H19.2C19.2 15 14.4 15.2734 13.8 13.4734V12.4C14.0704 12.2664 14.8426 11.3465 14.9234 10.6281C15.1362 10.6121 15.4704 10.418 15.5688 9.64844C15.6215 9.23484 15.41 9.00172 15.2828 8.92812C15.2828 8.92812 15.6 8.3272 15.6 7.6C15.6 6.1432 15.028 4.9 13.8 4.9C13.8 4.9 13.3736 4 12 4ZM18 5.59844C17.5904 5.59844 17.2419 5.67253 16.9219 5.77813C17.0971 6.32133 17.2 6.9272 17.2 7.6C17.2 8.0256 17.1332 8.41579 17.0484 8.74219C17.1644 9.08539 17.2043 9.4628 17.1547 9.85C17.0419 10.7308 16.6999 11.3294 16.2703 11.7062C16.1455 12.0086 15.9746 12.2951 15.7906 12.5688C16.0178 13.0351 16.3504 13.4504 16.5 13.5344V13.5437C18.1296 14.3077 20.8 15.592 20.8 19.2H24C24 15.2336 20 15.8031 19.5 14.1031V13.5328C19.7248 13.4064 20.3687 12.5378 20.4359 11.8594C20.6127 11.8442 20.8918 11.6616 20.9734 10.9344C21.0174 10.544 20.8415 10.3243 20.7359 10.2547C20.7359 10.2547 21 9.6856 21 9C21 7.624 20.5232 6.45 19.5 6.45C19.5 6.45 19.1448 5.59844 18 5.59844ZM6 5.6C4.8552 5.6 4.5 6.45 4.5 6.45C3.4768 6.45 3 7.62556 3 9.00156C3 9.68796 3.26406 10.2547 3.26406 10.2547C3.15766 10.3235 2.98256 10.544 3.02656 10.9344C3.10816 11.6616 3.38726 11.8457 3.56406 11.8609C3.63126 12.5393 4.2752 13.408 4.5 13.5344V14.1031C4 15.8023 0 15.2336 0 19.2H3.2C3.2 15.592 5.8704 14.3085 7.5 13.5437V13.5328C7.6496 13.4488 7.98218 13.036 8.20938 12.5688C8.02538 12.2952 7.85449 12.0071 7.72969 11.7047C7.30009 11.3287 6.95731 10.73 6.84531 9.85C6.79491 9.458 6.83629 9.07452 6.95469 8.72813C6.86829 8.39932 6.8 8.0088 6.8 7.6C6.8 6.9384 6.89366 6.3302 7.06406 5.775C6.74806 5.6718 6.404 5.6 6 5.6Z', fill: color }) }));
};
var CompanySizeIcon$1 = react.memo(CompanySizeIcon);


//# sourceMappingURL=CompanySize.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/Location.js
'use client';





var LocationIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return ((0,jsx_runtime.jsx)("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none', children: (0,jsx_runtime.jsx)("path", { d: 'M12.0003 0.47998C7.76656 0.47998 4.32031 3.92623 4.32031 8.15998C4.32031 14.9344 11.3422 23.0137 11.6403 23.355C11.7322 23.46 11.8616 23.52 12.0003 23.52C12.1484 23.5106 12.2684 23.46 12.3603 23.355C12.6584 23.0081 19.6803 14.79 19.6803 8.15998C19.6803 3.92623 16.2341 0.47998 12.0003 0.47998ZM12.0003 5.75998C13.5903 5.75998 14.8803 7.04998 14.8803 8.63998C14.8803 10.23 13.5903 11.52 12.0003 11.52C10.4103 11.52 9.12031 10.23 9.12031 8.63998C9.12031 7.04998 10.4103 5.75998 12.0003 5.75998Z', fill: color }) }));
};
var LocationIcon$1 = react.memo(LocationIcon);


//# sourceMappingURL=Location.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/Education.js
'use client';





var EducationIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return ((0,jsx_runtime.jsxs)("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none', children: [(0,jsx_runtime.jsx)("g", { clipPath: 'url(#clip0_720_5761)', children: (0,jsx_runtime.jsx)("path", { d: 'M12 2.3999C11.868 2.4 11.7381 2.43274 11.6219 2.49521L0.429688 8.09053V8.09209C0.300312 8.15965 0.191884 8.26132 0.116145 8.38608C0.0404055 8.51084 0.00024084 8.65395 0 8.7999C0.00024084 8.94586 0.0404055 9.08896 0.116145 9.21373C0.191884 9.33849 0.300312 9.44015 0.429688 9.50771V9.50928L11.6172 15.1015C11.7345 15.1658 11.8662 15.1996 12 15.1999C12.132 15.1998 12.2619 15.1671 12.3781 15.1046L23.5625 9.5124C23.5651 9.51137 23.5677 9.51033 23.5703 9.50928V9.50771C23.6997 9.44015 23.8081 9.33849 23.8839 9.21373C23.9596 9.08896 23.9998 8.94586 24 8.7999C23.9998 8.65395 23.9596 8.51084 23.8839 8.38608C23.8081 8.26132 23.6997 8.15965 23.5703 8.09209V8.09053L12.3828 2.49834C12.2655 2.43402 12.1338 2.40018 12 2.3999ZM23.2 11.4827L21.6 12.2827V19.4218C21.1235 19.6988 20.8 20.2087 20.8 20.7999C20.8 21.6839 22.4 23.9999 22.4 23.9999C22.4 23.9999 24 21.6839 24 20.7999C24 20.2087 23.6765 19.6988 23.2 19.4218V11.4827ZM4.8 13.4812V16.7999C4.8 19.0087 8.0232 20.7999 12 20.7999C15.9768 20.7999 19.2 19.0087 19.2 16.7999V13.4812L13.0922 16.5358C13.025 16.5694 12.9579 16.597 12.8891 16.6202C12.5995 16.7394 12.3016 16.7999 12 16.7999C11.6992 16.7999 11.4021 16.7394 11.1141 16.6202C11.0445 16.597 10.9758 16.5687 10.9078 16.5343L4.8 13.4812Z', fill: color }) }), (0,jsx_runtime.jsx)("defs", { children: (0,jsx_runtime.jsx)("clipPath", { id: 'clip0_720_5761', children: (0,jsx_runtime.jsx)("rect", { width: '24', height: '24', fill: 'white' }) }) })] }));
};
var EducationIcon$1 = react.memo(EducationIcon);


//# sourceMappingURL=Education.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/PhoneNumber.js
'use client';





var PhoneNumberIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return ((0,jsx_runtime.jsx)("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none', children: (0,jsx_runtime.jsx)("path", { d: 'M16.9792 14.3111C16.6544 14.1207 16.2552 14.1247 15.932 14.3167L14.2952 15.2919C13.9288 15.5103 13.4712 15.4847 13.1352 15.2223C12.5544 14.7687 11.6192 14.0055 10.8056 13.1919C9.99202 12.3783 9.22882 11.4431 8.77522 10.8623C8.51282 10.5263 8.48723 10.0687 8.70563 9.70233L9.68082 8.06553C9.87362 7.74233 9.87522 7.33993 9.68482 7.01513L7.28322 2.91273C7.05042 2.51593 6.58802 2.32073 6.14082 2.43033C5.70642 2.53593 5.14242 2.79353 4.55122 3.38553C2.70003 5.23673 1.71683 8.35913 8.67842 15.3207C15.64 22.2823 18.7616 21.2999 20.6136 19.4479C21.2064 18.8551 21.4632 18.2903 21.5696 17.8551C21.6776 17.4087 21.4856 16.9495 21.0896 16.7175C20.1008 16.1391 17.968 14.8903 16.9792 14.3111Z', fill: color }) }));
};
var PhoneNumberIcon$1 = react.memo(PhoneNumberIcon);


//# sourceMappingURL=PhoneNumber.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/CalendarIOS16Glyph.js
'use client';





var CalendarIOS16GlyphIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return ((0,jsx_runtime.jsx)("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none', children: (0,jsx_runtime.jsx)("path", { d: 'M19.2002 3.2002H4.8002C3.9162 3.2002 3.2002 3.9162 3.2002 4.8002V19.2002C3.2002 20.0842 3.9162 20.8002 4.8002 20.8002H19.2002C20.0842 20.8002 20.8002 20.0842 20.8002 19.2002V4.8002C20.8002 3.9162 20.0842 3.2002 19.2002 3.2002ZM5.6002 18.4002C5.1586 18.4002 4.8002 18.0418 4.8002 17.6002C4.8002 17.1586 5.1586 16.8002 5.6002 16.8002C6.0418 16.8002 6.4002 17.1586 6.4002 17.6002C6.4002 18.0418 6.0418 18.4002 5.6002 18.4002ZM5.6002 15.2002C5.1586 15.2002 4.8002 14.8418 4.8002 14.4002C4.8002 13.9586 5.1586 13.6002 5.6002 13.6002C6.0418 13.6002 6.4002 13.9586 6.4002 14.4002C6.4002 14.8418 6.0418 15.2002 5.6002 15.2002ZM8.8002 18.4002C8.3586 18.4002 8.0002 18.0418 8.0002 17.6002C8.0002 17.1586 8.3586 16.8002 8.8002 16.8002C9.2418 16.8002 9.6002 17.1586 9.6002 17.6002C9.6002 18.0418 9.2418 18.4002 8.8002 18.4002ZM8.8002 15.2002C8.3586 15.2002 8.0002 14.8418 8.0002 14.4002C8.0002 13.9586 8.3586 13.6002 8.8002 13.6002C9.2418 13.6002 9.6002 13.9586 9.6002 14.4002C9.6002 14.8418 9.2418 15.2002 8.8002 15.2002ZM8.8002 12.0002C8.3586 12.0002 8.0002 11.6418 8.0002 11.2002C8.0002 10.7586 8.3586 10.4002 8.8002 10.4002C9.2418 10.4002 9.6002 10.7586 9.6002 11.2002C9.6002 11.6418 9.2418 12.0002 8.8002 12.0002ZM12.0002 18.4002C11.5586 18.4002 11.2002 18.0418 11.2002 17.6002C11.2002 17.1586 11.5586 16.8002 12.0002 16.8002C12.4418 16.8002 12.8002 17.1586 12.8002 17.6002C12.8002 18.0418 12.4418 18.4002 12.0002 18.4002ZM12.0002 15.2002C11.5586 15.2002 11.2002 14.8418 11.2002 14.4002C11.2002 13.9586 11.5586 13.6002 12.0002 13.6002C12.4418 13.6002 12.8002 13.9586 12.8002 14.4002C12.8002 14.8418 12.4418 15.2002 12.0002 15.2002ZM12.0002 12.0002C11.5586 12.0002 11.2002 11.6418 11.2002 11.2002C11.2002 10.7586 11.5586 10.4002 12.0002 10.4002C12.4418 10.4002 12.8002 10.7586 12.8002 11.2002C12.8002 11.6418 12.4418 12.0002 12.0002 12.0002ZM15.2002 18.4002C14.7586 18.4002 14.4002 18.0418 14.4002 17.6002C14.4002 17.1586 14.7586 16.8002 15.2002 16.8002C15.6418 16.8002 16.0002 17.1586 16.0002 17.6002C16.0002 18.0418 15.6418 18.4002 15.2002 18.4002ZM15.2002 15.2002C14.7586 15.2002 14.4002 14.8418 14.4002 14.4002C14.4002 13.9586 14.7586 13.6002 15.2002 13.6002C15.6418 13.6002 16.0002 13.9586 16.0002 14.4002C16.0002 14.8418 15.6418 15.2002 15.2002 15.2002ZM14.4002 11.2002C14.4002 10.7586 14.7586 10.4002 15.2002 10.4002C15.6418 10.4002 16.0002 10.7586 16.0002 11.2002C16.0002 11.6418 15.6418 12.0002 15.2002 12.0002C14.7586 12.0002 14.4002 11.6418 14.4002 11.2002ZM18.4002 15.2002C17.9586 15.2002 17.6002 14.8418 17.6002 14.4002C17.6002 13.9586 17.9586 13.6002 18.4002 13.6002C18.8418 13.6002 19.2002 13.9586 19.2002 14.4002C19.2002 14.8418 18.8418 15.2002 18.4002 15.2002ZM18.4002 12.0002C17.9586 12.0002 17.6002 11.6418 17.6002 11.2002C17.6002 10.7586 17.9586 10.4002 18.4002 10.4002C18.8418 10.4002 19.2002 10.7586 19.2002 11.2002C19.2002 11.6418 18.8418 12.0002 18.4002 12.0002ZM19.2002 8.0002H4.8002V4.8002H19.2002V8.0002Z', fill: color }) }));
};
var CalendarIOS16GlyphICon = react.memo(CalendarIOS16GlyphIcon);


//# sourceMappingURL=CalendarIOS16Glyph.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/Admin.js
'use client';





var AdminIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return ((0,jsx_runtime.jsx)("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none', children: (0,jsx_runtime.jsx)("path", { d: 'M12.199 3C11.7747 3 11.3677 3.16857 11.0677 3.46863C10.7676 3.76869 10.599 4.17565 10.599 4.6C10.5992 4.88983 10.678 5.17418 10.8272 5.42269C10.9763 5.67119 11.1902 5.87451 11.4459 6.01094L8.28184 11.9438L3.97715 9.41094C4.12207 9.16524 4.19868 8.88526 4.19902 8.6C4.19902 8.17565 4.03045 7.76869 3.73039 7.46863C3.43034 7.16857 3.02337 7 2.59902 7C2.17468 7 1.76771 7.16857 1.46765 7.46863C1.16759 7.76869 0.999023 8.17565 0.999023 8.6C0.999023 9.02435 1.16759 9.43131 1.46765 9.73137C1.76771 10.0314 2.17468 10.2 2.59902 10.2C2.65227 10.1995 2.70546 10.1964 2.7584 10.1906L3.39902 16.6H5.79902H16.199H18.599H20.999L21.6396 10.1922C21.6926 10.1974 21.7458 10.2 21.799 10.2C22.2234 10.2 22.6303 10.0314 22.9304 9.73137C23.2305 9.43131 23.399 9.02435 23.399 8.6C23.399 8.17565 23.2305 7.76869 22.9304 7.46863C22.6303 7.16857 22.2234 7 21.799 7C21.3747 7 20.9677 7.16857 20.6677 7.46863C20.3676 7.76869 20.199 8.17565 20.199 8.6C20.1994 8.88526 20.276 9.16524 20.4209 9.41094L16.1162 11.9438L12.9521 6.01094C13.2079 5.87451 13.4217 5.67119 13.5709 5.42269C13.72 5.17418 13.7989 4.88983 13.799 4.6C13.799 4.17565 13.6305 3.76869 13.3304 3.46863C13.0303 3.16857 12.6234 3 12.199 3ZM3.39902 18.2V19.8C3.39902 20.684 4.11502 21.4 4.99902 21.4H19.399C20.283 21.4 20.999 20.684 20.999 19.8V18.2H3.39902Z', fill: color }) }));
};
var AdminIcon$1 = react.memo(AdminIcon);


//# sourceMappingURL=Admin.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/HeadHunter.js
'use client';





var HeadHunterIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return ((0,jsx_runtime.jsx)("svg", { width: width, height: height, viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: (0,jsx_runtime.jsx)("path", { d: 'M7 0a5.612 5.612 0 0 0-1.083.108c-.042.004-.083.013-.13.022C4.219.457 1.969 1.535 1.87 4.895c-.004.08-.004.159-.004.238V6.38l.205-.135a1.034 1.034 0 0 1 1.279.093c.004-.028.014-.055.023-.083a.41.41 0 0 1 .023-.07.685.685 0 0 1 .066-.146.14.14 0 0 1 .028-.05c.019-.047.047-.089.075-.131a.085.085 0 0 1 .027-.033.623.623 0 0 1 .09-.116.266.266 0 0 1 .05-.052.856.856 0 0 1 .117-.107c.005-.005.004-.01.01-.005a.782.782 0 0 1 .125-.098c.014-.01.029-.019.047-.033.052-.033.107-.06.168-.088.06-.033.126-.06.196-.089.065-.028.135-.056.205-.074.681-.22 1.54-.285 2.357-.5.07-.014.14-.038.21-.056.13-.038.261-.08.387-.13a1.83 1.83 0 0 0 .2-.085.838.838 0 0 0 .546-.308c.42-.284.78-.695 1.032-1.283 0 0 .206.187.458.583.037.056.075.122.112.187.047.075.088.154.13.238.271.532.542 1.274.65 2.259.018.149.032.303.037.466.009.15.013.308.013.467h.467v.467c0 .457-.159.653-.308.788-.15.13-.27.159-.27.159l-.252.06-.08.243s-.644 1.998-2.572 2.408l.836.523a.97.97 0 0 1 .163.13c1.587-.709 2.254-2.263 2.385-2.599.13-.051.21-.056.406-.224.317-.275.625-.779.625-1.488V5.133c0-1.866-.933-4.2-2.8-4.2C9.333.933 8.867 0 7 0ZM4.9 6.533a.7.7 0 1 0 0 1.4.7.7 0 0 0 0-1.4Zm4.2 0a.7.7 0 1 0 0 1.4.7.7 0 0 0 0-1.4ZM2.562 7c-.037 0-.08 0-.117.01a1.2 1.2 0 0 0-.565.34l-.013.014c-.649.658-.976 1.769 1.479 4.223 2.473 2.474 3.58 2.124 4.237 1.466.21-.21.304-.411.341-.565a.373.373 0 0 0-.173-.406c-.005-.004-.009-.005-.018-.014-.355-.206-1.092-.64-1.442-.84a.36.36 0 0 0-.37.005l-.583.345a.366.366 0 0 1-.41-.023 10.085 10.085 0 0 1-.826-.723c-.29-.29-.56-.622-.723-.827a.358.358 0 0 1-.024-.41l.346-.583a.342.342 0 0 0 .05-.178.335.335 0 0 0-.05-.196l-.038-.066-.033-.097-.027-.01-.752-1.283a.665.665 0 0 0-.051-.07A.392.392 0 0 0 2.562 7Z', fill: color }) }));
};
var HeadHunterIcon$1 = react.memo(HeadHunterIcon);


//# sourceMappingURL=HeadHunter.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/Address.js
'use client';





var Address = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return ((0,jsx_runtime.jsx)("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none', children: (0,jsx_runtime.jsx)("path", { d: 'M12.0001 1.6001C8.46572 1.6001 5.60012 4.4657 5.60012 8.0001C5.60012 12.8001 11.2001 14.4001 11.2001 17.6001C11.2001 18.0417 11.5585 18.4001 12.0001 18.4001C12.4417 18.4001 12.8001 18.0417 12.8001 17.6001C12.8001 14.4001 18.4001 12.8001 18.4001 8.0001C18.4001 4.4657 15.5345 1.6001 12.0001 1.6001ZM12.0001 6.4001C12.8841 6.4001 13.6001 7.1161 13.6001 8.0001C13.6001 8.8841 12.8841 9.6001 12.0001 9.6001C11.1161 9.6001 10.4001 8.8841 10.4001 8.0001C10.4001 7.1161 11.1161 6.4001 12.0001 6.4001ZM4.80012 13.6001C4.46652 13.6001 4.16772 13.8076 4.05012 14.1188L1.65012 20.5188C1.55812 20.7652 1.59351 21.0388 1.74231 21.2548C1.89271 21.4708 2.13772 21.6001 2.40012 21.6001H21.6001C21.8625 21.6001 22.1083 21.4708 22.2579 21.2548C22.4075 21.0396 22.4421 20.7652 22.3501 20.5188L19.9501 14.1188C19.8325 13.8076 19.5337 13.6001 19.2001 13.6001H17.6189C17.1805 14.0897 16.7281 14.5371 16.3017 14.9579C16.2177 15.0395 16.1372 15.1201 16.0564 15.2001H18.6454L20.4454 20.0001H3.55481L5.35481 15.2001H7.94387C7.86307 15.1201 7.78332 15.0395 7.70012 14.9579C7.27292 14.5371 6.81977 14.0897 6.38137 13.6001H4.80012Z', fill: color }) }));
};
var AddressIcon = react.memo(Address);


//# sourceMappingURL=Address.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/Salary.js
'use client';





var Salary = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return ((0,jsx_runtime.jsx)("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none', children: (0,jsx_runtime.jsx)("path", { d: 'M3.19961 4C3.09571 4.00035 2.9921 4.01081 2.89023 4.03125C2.88176 4.03295 2.87366 4.03566 2.86523 4.0375C2.50741 4.11397 2.18661 4.31077 1.95631 4.5951C1.726 4.87942 1.60011 5.2341 1.59961 5.6V15.2C1.59996 15.3039 1.61042 15.4075 1.63086 15.5094C1.63256 15.5178 1.63527 15.5259 1.63711 15.5344C1.71358 15.8922 1.91038 16.213 2.19471 16.4433C2.47903 16.6736 2.83371 16.7995 3.19961 16.8H20.7996C20.9035 16.7997 21.0071 16.7892 21.109 16.7688C21.1175 16.767 21.1256 16.7643 21.134 16.7625C21.4918 16.686 21.8126 16.4892 22.0429 16.2049C22.2732 15.9206 22.3991 15.5659 22.3996 15.2V5.6C22.3993 5.4961 22.3888 5.39249 22.3684 5.29062C22.3667 5.28215 22.3639 5.27405 22.3621 5.26562C22.2856 4.9078 22.0888 4.587 21.8045 4.3567C21.5202 4.12639 21.1655 4.0005 20.7996 4H3.19961ZM4.79961 5.6H19.1996C19.1996 6.02435 19.3682 6.43131 19.6682 6.73137C19.9683 7.03143 20.3753 7.2 20.7996 7.2V13.6C20.3753 13.6 19.9683 13.7686 19.6682 14.0686C19.3682 14.3687 19.1996 14.7757 19.1996 15.2H4.79961C4.79961 14.7757 4.63104 14.3687 4.33098 14.0686C4.03092 13.7686 3.62396 13.6 3.19961 13.6V7.2C3.62396 7.2 4.03092 7.03143 4.33098 6.73137C4.63104 6.43131 4.79961 6.02435 4.79961 5.6ZM11.9996 7.2C10.2324 7.2 8.79961 8.812 8.79961 10.8C8.79961 11.9376 9.27775 12.94 10.0105 13.6H13.9887C14.7215 12.94 15.1996 11.9376 15.1996 10.8C15.1996 8.812 13.7668 7.2 11.9996 7.2ZM5.59961 9.6C5.38744 9.6 5.18395 9.68429 5.03392 9.83431C4.88389 9.98434 4.79961 10.1878 4.79961 10.4C4.79961 10.6122 4.88389 10.8157 5.03392 10.9657C5.18395 11.1157 5.38744 11.2 5.59961 11.2C5.81178 11.2 6.01527 11.1157 6.16529 10.9657C6.31532 10.8157 6.39961 10.6122 6.39961 10.4C6.39961 10.1878 6.31532 9.98434 6.16529 9.83431C6.01527 9.68429 5.81178 9.6 5.59961 9.6ZM18.3996 9.6C18.1874 9.6 17.984 9.68429 17.8339 9.83431C17.6839 9.98434 17.5996 10.1878 17.5996 10.4C17.5996 10.6122 17.6839 10.8157 17.8339 10.9657C17.984 11.1157 18.1874 11.2 18.3996 11.2C18.6118 11.2 18.8153 11.1157 18.9653 10.9657C19.1153 10.8157 19.1996 10.6122 19.1996 10.4C19.1996 10.1878 19.1153 9.98434 18.9653 9.83431C18.8153 9.68429 18.6118 9.6 18.3996 9.6ZM3.19961 18.4C3.0936 18.3985 2.98835 18.4181 2.88997 18.4576C2.7916 18.4971 2.70206 18.5558 2.62657 18.6303C2.55107 18.7047 2.49112 18.7934 2.4502 18.8912C2.40929 18.989 2.38822 19.094 2.38822 19.2C2.38822 19.306 2.40929 19.411 2.4502 19.5088C2.49112 19.6066 2.55107 19.6953 2.62657 19.7697C2.70206 19.8442 2.7916 19.9029 2.88997 19.9424C2.98835 19.9819 3.0936 20.0015 3.19961 20H20.7996C20.9056 20.0015 21.0109 19.9819 21.1092 19.9424C21.2076 19.9029 21.2972 19.8442 21.3727 19.7697C21.4481 19.6953 21.5081 19.6066 21.549 19.5088C21.5899 19.411 21.611 19.306 21.611 19.2C21.611 19.094 21.5899 18.989 21.549 18.8912C21.5081 18.7934 21.4481 18.7047 21.3727 18.6303C21.2972 18.5558 21.2076 18.4971 21.1092 18.4576C21.0109 18.4181 20.9056 18.3985 20.7996 18.4H3.19961Z', fill: color }) }));
};
var SalaryIcon = react.memo(Salary);


//# sourceMappingURL=Salary.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/Gender.js
'use client';





var GenderIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return ((0,jsx_runtime.jsx)("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none', children: (0,jsx_runtime.jsx)("path", { d: 'M16.8003 2.39998C16.6943 2.39848 16.589 2.41807 16.4906 2.4576C16.3923 2.49713 16.3027 2.55582 16.2272 2.63025C16.1517 2.70469 16.0918 2.79339 16.0509 2.89119C16.0099 2.989 15.9889 3.09396 15.9889 3.19998C15.9889 3.306 16.0099 3.41097 16.0509 3.50877C16.0918 3.60658 16.1517 3.69527 16.2272 3.76971C16.3027 3.84415 16.3923 3.90283 16.4906 3.94237C16.589 3.9819 16.6943 4.00148 16.8003 3.99998H18.869L16.38 6.48905C15.5957 5.93099 14.6389 5.59842 13.6049 5.59842C10.9578 5.59842 8.80495 7.75122 8.80495 10.3984C8.80495 12.2976 9.91734 13.9396 11.5221 14.7172C11.5677 14.6716 11.622 14.6379 11.6628 14.5875C11.818 14.3899 12.005 14.0568 12.005 13.5984C12.005 13.4288 11.9718 13.267 11.9206 13.1094C11.0142 12.5438 10.405 11.544 10.405 10.3984C10.405 8.63362 11.8401 7.19842 13.6049 7.19842C15.3698 7.19842 16.8049 8.63362 16.8049 10.3984C16.8049 10.8656 16.6982 11.307 16.5175 11.7078C16.7046 12.3134 16.8049 12.9488 16.8049 13.5984C16.8049 13.7264 16.7965 13.854 16.7893 13.9812C17.7781 13.1012 18.405 11.8232 18.405 10.3984C18.405 9.36221 18.0715 8.40554 17.5112 7.6203L20.0003 5.13123V7.19998C19.9988 7.30599 20.0183 7.41124 20.0579 7.50962C20.0974 7.60799 20.1561 7.69753 20.2305 7.77302C20.305 7.84852 20.3937 7.90847 20.4915 7.94939C20.5893 7.9903 20.6942 8.01138 20.8003 8.01138C20.9063 8.01138 21.0112 7.9903 21.1091 7.94939C21.2069 7.90847 21.2956 7.84852 21.37 7.77302C21.4444 7.69753 21.5031 7.60799 21.5426 7.50962C21.5822 7.41124 21.6018 7.30599 21.6003 7.19998V2.39998H16.8003ZM12.4831 9.28123C12.4375 9.32683 12.3817 9.36052 12.3409 9.41092C12.1857 9.60932 12.0003 9.94158 12.0003 10.4C12.0003 10.5696 12.0334 10.733 12.0846 10.8906C12.991 11.4562 13.6003 12.4544 13.6003 13.6C13.6003 15.3648 12.1651 16.8 10.4003 16.8C8.63546 16.8 7.20026 15.3648 7.20026 13.6C7.20026 13.1328 7.30696 12.6914 7.48776 12.2906C7.30056 11.685 7.20026 11.0496 7.20026 10.4C7.20026 10.272 7.20869 10.1444 7.21589 10.0172C6.22709 10.8972 5.60026 12.1752 5.60026 13.6C5.60026 14.6352 5.93162 15.5933 6.49089 16.3781L4.80026 18.0687L3.76589 17.0344C3.69134 16.9577 3.60218 16.8968 3.50369 16.8552C3.4052 16.8136 3.29937 16.7922 3.19245 16.7922C3.0333 16.7922 2.87779 16.8397 2.74578 16.9286C2.61377 17.0175 2.51127 17.1437 2.45139 17.2912C2.3915 17.4386 2.37695 17.6006 2.40959 17.7564C2.44223 17.9121 2.52059 18.0546 2.63464 18.1656L3.66901 19.2L2.63464 20.2344C2.55786 20.3081 2.49656 20.3964 2.45433 20.4941C2.4121 20.5918 2.3898 20.6969 2.38871 20.8034C2.38763 20.9098 2.4078 21.0154 2.44803 21.1139C2.48826 21.2124 2.54775 21.302 2.62301 21.3772C2.69827 21.4525 2.7878 21.512 2.88634 21.5522C2.98488 21.5925 3.09046 21.6126 3.19689 21.6115C3.30332 21.6104 3.40847 21.5881 3.50617 21.5459C3.60388 21.5037 3.69217 21.4424 3.76589 21.3656L4.80026 20.3312L5.83464 21.3656C5.90835 21.4424 5.99665 21.5037 6.09435 21.5459C6.19205 21.5881 6.2972 21.6104 6.40363 21.6115C6.51007 21.6126 6.61564 21.5925 6.71419 21.5522C6.81273 21.512 6.90225 21.4525 6.97752 21.3772C7.05278 21.302 7.11227 21.2124 7.1525 21.1139C7.19273 21.0154 7.21289 20.9098 7.21181 20.8034C7.21073 20.6969 7.18842 20.5918 7.14619 20.4941C7.10396 20.3964 7.04267 20.3081 6.96589 20.2344L5.93151 19.2L7.62214 17.5094C8.40696 18.0686 9.36505 18.4 10.4003 18.4C13.0475 18.4 15.2003 16.2472 15.2003 13.6C15.2003 11.7 14.0887 10.0588 12.4831 9.28123Z', fill: color }) }));
};
var GenderIcon$1 = react.memo(GenderIcon);


//# sourceMappingURL=Gender.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/Translator.js
'use client';





var TranslatorIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return ((0,jsx_runtime.jsx)("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none', children: (0,jsx_runtime.jsx)("path", { d: 'M15.8272 1.43994C15.6078 1.44369 15.396 1.45869 15.1878 1.47744C15.111 1.48494 15.0341 1.49244 14.9572 1.49994C14.8466 1.51494 14.7378 1.53182 14.631 1.54869C13.2603 1.76619 12.1841 2.32307 11.4153 3.20994C11.3985 3.23057 11.3797 3.25119 11.3628 3.27182C11.3178 3.32619 11.2672 3.37307 11.226 3.43119C11.0647 3.64119 10.9278 3.86432 10.806 4.09494C10.8003 4.10619 10.7928 4.11557 10.7872 4.12869C10.7403 4.21682 10.6991 4.30682 10.6578 4.39682C10.6503 4.41369 10.641 4.43057 10.6353 4.44744C10.6316 4.45307 10.6297 4.45869 10.6278 4.46432C9.83283 6.29994 10.0653 8.56119 10.4928 10.3481C10.431 10.3968 10.3691 10.4606 10.3128 10.5337V10.5356C10.2641 10.5974 10.2228 10.6706 10.1872 10.7493C10.1235 10.8881 10.0803 11.0568 10.0728 11.2649V11.2668C10.0691 11.3624 10.0691 11.4637 10.0822 11.5781C10.1028 11.7374 10.1291 11.8893 10.1572 12.0356C10.1647 12.0768 10.1741 12.1143 10.1835 12.1537C10.2041 12.2493 10.2266 12.3431 10.2528 12.4331C10.2641 12.4781 10.2791 12.5231 10.2922 12.5662C10.3203 12.6543 10.3503 12.7387 10.3803 12.8193C10.3916 12.8456 10.4028 12.8737 10.4122 12.8999C10.5903 13.3181 10.8191 13.6256 11.0853 13.7868C11.2935 14.8856 11.9703 15.9412 12.4803 16.5093V19.8506L7.48158 22.1231C7.26408 22.2187 7.14971 22.4587 7.20971 22.6874C7.27158 22.9162 7.49096 23.0662 7.72721 23.0399H23.5203C23.5747 23.0399 23.6272 23.0306 23.6778 23.0118C23.6797 23.0137 23.6797 23.0137 23.6797 23.0118C23.7303 22.9949 23.7772 22.9687 23.8185 22.9349H23.8203C23.8616 22.9012 23.8953 22.8637 23.9253 22.8206C23.9253 22.8187 23.9253 22.8168 23.9253 22.8168C23.9535 22.7718 23.9741 22.7231 23.9872 22.6724C23.9872 22.6706 23.9872 22.6706 23.9872 22.6706C23.9891 22.6687 23.9872 22.6668 23.9872 22.6649C24.0003 22.6143 24.0022 22.5637 23.9985 22.5112C23.9966 22.5093 23.9966 22.5074 23.9966 22.5056C23.991 22.4531 23.9778 22.4024 23.9553 22.3574C23.9553 22.3556 23.9553 22.3556 23.9553 22.3556C23.9328 22.3068 23.901 22.2637 23.8653 22.2262C23.8278 22.1868 23.7828 22.1549 23.736 22.1306L19.2003 19.8637V16.5093C19.7085 15.9431 20.3853 14.8856 20.5935 13.7868C20.7941 13.6668 20.9741 13.4606 21.126 13.1906C21.1297 13.1849 21.1316 13.1774 21.1353 13.1718C21.1803 13.0893 21.2235 13.0031 21.2628 12.9074C21.2778 12.8756 21.2891 12.8399 21.3022 12.8081C21.3322 12.7312 21.3603 12.6543 21.3866 12.5718C21.4016 12.5268 21.4147 12.4818 21.4278 12.4331C21.4522 12.3468 21.4747 12.2568 21.4953 12.1649C21.5047 12.1181 21.516 12.0749 21.5253 12.0262C21.5535 11.8818 21.5778 11.7337 21.5966 11.5781C21.6097 11.4637 21.6116 11.3624 21.6078 11.2649C21.6078 11.2649 21.6097 11.2649 21.6078 11.2649C21.6003 11.0587 21.5572 10.8937 21.4953 10.7568C21.4691 10.6968 21.4372 10.6443 21.4035 10.5937C21.3922 10.5768 21.3847 10.5562 21.3735 10.5412C21.3716 10.5393 21.3697 10.5374 21.3678 10.5356C21.3603 10.5243 21.3547 10.5224 21.3472 10.5149C21.3022 10.4587 21.2553 10.4043 21.2085 10.3631C21.3397 9.93182 21.4822 9.36932 21.5985 8.75432C21.6153 8.65869 21.6341 8.56119 21.651 8.46182C21.6622 8.38682 21.6753 8.31369 21.6866 8.23682C21.7203 8.00432 21.7466 7.76619 21.7653 7.52432C21.7672 7.48307 21.7691 7.44182 21.771 7.40057C21.7841 7.18869 21.7878 6.97682 21.7841 6.76307C21.7822 6.69744 21.7841 6.63369 21.7803 6.56994C21.7803 6.55119 21.7803 6.53432 21.7803 6.51744C21.7785 6.49119 21.7747 6.46682 21.7728 6.44057C21.7635 6.29057 21.7485 6.14244 21.7278 5.99432C21.7241 5.95307 21.7203 5.91182 21.7128 5.87244C21.6866 5.69994 21.651 5.53307 21.6078 5.36994C21.5797 5.26119 21.5497 5.15619 21.5122 5.05119V5.04932C21.471 4.92932 21.4222 4.81119 21.3678 4.69682C21.3622 4.68369 21.3566 4.67244 21.351 4.65932C21.3041 4.56557 21.2535 4.47369 21.201 4.38369C21.1916 4.37057 21.186 4.35744 21.1785 4.34432C21.1672 4.32557 21.1522 4.30869 21.141 4.28994C21.1203 4.25994 21.1035 4.22807 21.0828 4.19994C21.0697 4.17932 21.051 4.15869 21.036 4.13807C21.0003 4.09119 20.9666 4.04619 20.931 4.00307C20.916 3.98619 20.901 3.96932 20.886 3.95244C20.4228 3.41807 19.7947 3.06932 19.0053 2.92119C18.8291 2.68307 18.5797 2.45244 18.2853 2.24244C18.2403 2.20869 18.1935 2.17494 18.1447 2.14119C18.111 2.12057 18.0735 2.09994 18.0378 2.07744C17.976 2.03994 17.916 1.99682 17.8485 1.96119C17.8166 1.94432 17.7828 1.93119 17.7528 1.91619C17.7097 1.89369 17.6647 1.87494 17.6197 1.85432C17.5203 1.80744 17.4191 1.76244 17.3122 1.72119C17.2653 1.70244 17.2166 1.68932 17.1678 1.67244C17.061 1.63682 16.956 1.60119 16.8435 1.57119C16.7835 1.55619 16.7197 1.54682 16.6578 1.53369C16.5566 1.51307 16.4553 1.48869 16.3503 1.47557C16.221 1.45869 16.0897 1.45307 15.9603 1.44744C15.9191 1.44744 15.8816 1.43994 15.8403 1.43994H15.8347C15.8347 1.43994 15.8328 1.43994 15.831 1.43994C15.8291 1.43994 15.8291 1.43994 15.8272 1.43994ZM6.51221 1.53744C6.03408 1.54307 5.54846 1.59369 5.06658 1.68932C3.14096 2.07369 1.28096 3.28119 0.504709 5.60807C-0.430916 8.41494 0.602209 10.7343 1.83408 12.4837C1.60346 12.9037 1.27533 13.4249 0.952834 13.8974C0.765334 14.1693 0.592834 14.4168 0.465334 14.6043C0.399709 14.6981 0.347209 14.7768 0.304084 14.8424C0.283459 14.8762 0.266584 14.9043 0.247834 14.9399C0.238459 14.9568 0.229084 14.9756 0.215959 15.0056C0.202834 15.0337 0.174709 15.0543 0.174709 15.2024L0.262834 15.4799C0.262834 15.4818 0.313459 15.5418 0.337834 15.5624C0.360334 15.5849 0.382834 15.5999 0.401584 15.6131C0.480334 15.6618 0.523459 15.6674 0.555334 15.6749C0.620959 15.6899 0.647209 15.6881 0.675334 15.6899C0.727834 15.6899 0.769084 15.6881 0.817834 15.6824C0.915334 15.6749 1.03533 15.6562 1.17971 15.6299C1.47033 15.5756 1.85846 15.4837 2.28033 15.3412C3.02846 15.0881 3.86096 14.6418 4.45908 13.9481C4.72908 14.0343 5.20158 14.1993 6.04533 14.2443C7.05033 14.3006 8.32346 14.1581 9.40721 13.3443C9.62096 13.1849 9.66408 12.8849 9.50471 12.6731C9.34533 12.4593 9.04533 12.4162 8.83346 12.5756C7.99721 13.2018 6.96596 13.3331 6.09783 13.2862C5.23158 13.2393 4.53408 13.0068 4.48158 12.9881L4.12908 12.8624L3.92096 13.1737C3.54596 13.7381 2.71908 14.1806 1.97283 14.4318C1.86783 14.4674 1.80033 14.4749 1.69908 14.5049C1.71783 14.4787 1.72721 14.4637 1.74408 14.4393C2.12283 13.8843 2.56346 13.2262 2.82971 12.6956L2.96096 12.4312L2.78658 12.1949C1.55096 10.5262 0.553459 8.50119 1.41596 5.91182C2.07971 3.91869 3.57971 2.96619 5.25408 2.63057C6.92846 2.29494 8.76783 2.65119 9.83283 3.29244C9.98096 3.38619 10.1685 3.39369 10.3222 3.31119C10.4778 3.22682 10.5735 3.06557 10.5753 2.89119C10.5753 2.71494 10.4797 2.55369 10.3278 2.46744C9.32658 1.86932 7.95033 1.51494 6.51221 1.53744ZM6.20283 4.31244C5.93846 4.31619 5.72658 4.53557 5.73033 4.79994V5.96807H3.82533C3.65096 5.96432 3.48971 6.05619 3.40346 6.20432C3.31533 6.35432 3.31533 6.53994 3.40346 6.68994C3.48971 6.83807 3.65096 6.92994 3.82533 6.92807H7.60346C7.54346 7.17744 7.44033 7.50182 7.23971 7.87494C7.06346 8.20494 6.81408 8.56119 6.46533 8.90807C5.90096 8.33244 5.59533 7.88994 5.59533 7.88994C5.50346 7.75494 5.35158 7.67432 5.18846 7.67807C5.01033 7.67994 4.84721 7.78119 4.76658 7.93869C4.68596 8.09807 4.69908 8.28744 4.80221 8.43369C4.80221 8.43369 5.12658 8.90244 5.72283 9.51744C5.29908 9.80244 4.78533 10.0668 4.14783 10.2843C3.97908 10.3368 3.85158 10.4737 3.81596 10.6462C3.78033 10.8187 3.84033 10.9968 3.97533 11.1112C4.11033 11.2256 4.29408 11.2556 4.45908 11.1918C5.25596 10.9199 5.89908 10.5693 6.42783 10.1868C6.72033 10.4418 7.04283 10.7024 7.40846 10.9556C7.54908 11.0587 7.73471 11.0774 7.89408 11.0043C8.05346 10.9312 8.16033 10.7774 8.17158 10.6031C8.18471 10.4287 8.10033 10.2599 7.95221 10.1643C7.66346 9.96557 7.40658 9.75932 7.16846 9.55682C7.57346 9.14807 7.87346 8.72619 8.08533 8.33057C8.38346 7.77369 8.51471 7.27682 8.58033 6.92807H9.03033C9.20283 6.92994 9.36408 6.83807 9.45033 6.68994C9.53846 6.53994 9.53846 6.35432 9.45033 6.20432C9.36408 6.05619 9.20283 5.96432 9.03033 5.96807H8.24283C8.21658 5.96244 8.18846 5.96057 8.16221 5.96057C8.13408 5.96057 8.10783 5.96244 8.07971 5.96807H6.69033V4.79994C6.69033 4.67057 6.63971 4.54494 6.54971 4.45307C6.45783 4.36307 6.33221 4.31244 6.20283 4.31244ZM15.8403 5.27994C16.0447 5.27994 16.2266 5.40932 16.2941 5.60244L18.6941 12.5362C18.7803 12.7874 18.6472 13.0612 18.3978 13.1474C18.3453 13.1643 18.2928 13.1737 18.2403 13.1737C18.0416 13.1737 17.856 13.0481 17.7866 12.8493L17.1603 11.0399H14.5203L13.8941 12.8493C13.806 13.1006 13.5341 13.2318 13.2828 13.1474C13.0335 13.0593 12.9003 12.7856 12.9866 12.5362L15.3866 5.60244C15.4541 5.40932 15.636 5.27994 15.8403 5.27994ZM15.8403 7.22807L14.8522 10.0799H16.8285L15.8403 7.22807Z', fill: color }) }));
};
var TranslatorIcon$1 = react.memo(TranslatorIcon);


//# sourceMappingURL=Translator.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/Birthday.js
'use client';





var BirthdayIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return ((0,jsx_runtime.jsx)("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none', children: (0,jsx_runtime.jsx)("path", { d: 'M6.40039 0.799805C6.40039 0.799805 4.80039 3.1158 4.80039 3.9998C4.80039 4.8838 5.51639 5.5998 6.40039 5.5998C7.28439 5.5998 8.00039 4.8838 8.00039 3.9998C8.00039 3.1158 6.40039 0.799805 6.40039 0.799805ZM12.0004 0.799805C12.0004 0.799805 10.4004 3.1158 10.4004 3.9998C10.4004 4.8838 11.1164 5.5998 12.0004 5.5998C12.8844 5.5998 13.6004 4.8838 13.6004 3.9998C13.6004 3.1158 12.0004 0.799805 12.0004 0.799805ZM17.6004 0.799805C17.6004 0.799805 16.0004 3.1158 16.0004 3.9998C16.0004 4.8838 16.7164 5.5998 17.6004 5.5998C18.4844 5.5998 19.2004 4.8838 19.2004 3.9998C19.2004 3.1158 17.6004 0.799805 17.6004 0.799805ZM4.80039 7.1998V10.5154C3.42775 10.8753 2.40039 12.1195 2.40039 13.5998C2.40039 14.4 2.70903 15.1258 3.20039 15.6889V19.1998C3.20039 20.0838 3.91639 20.7998 4.80039 20.7998H19.2004C20.0844 20.7998 20.8004 20.0838 20.8004 19.1998V15.6889C21.2917 15.1258 21.6004 14.4 21.6004 13.5998C21.6004 12.1195 20.573 10.8753 19.2004 10.5154V7.1998H16.0004V10.3998H13.6004V7.1998H10.4004V10.3998H8.00039V7.1998H4.80039ZM5.60039 11.9998H18.4004C19.2937 11.9998 20.0004 12.7065 20.0004 13.5998C20.0004 14.4931 19.2937 15.1998 18.4004 15.1998C17.99 15.1998 17.6275 15.0448 17.3363 14.7826L16.8004 14.2998L16.2645 14.7826C15.9733 15.0448 15.6107 15.1998 15.2004 15.1998C14.79 15.1998 14.4275 15.0448 14.1363 14.7826L13.6004 14.2998L13.0645 14.7826C12.7733 15.0448 12.4107 15.1998 12.0004 15.1998C11.59 15.1998 11.2275 15.0448 10.9363 14.7826L10.4004 14.2998L9.86445 14.7826C9.57326 15.0448 9.21074 15.1998 8.80039 15.1998C8.39004 15.1998 8.02752 15.0448 7.73633 14.7826L7.20039 14.2998L6.66445 14.7826C6.37326 15.0448 6.01074 15.1998 5.60039 15.1998C4.70706 15.1998 4.00039 14.4931 4.00039 13.5998C4.00039 12.7065 4.70706 11.9998 5.60039 11.9998Z', fill: color }) }));
};
var BirthdayIcon$1 = react.memo(BirthdayIcon);


//# sourceMappingURL=Birthday.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/LocationIOS16Glyph.js
'use client';





var LocationIOS16GlyphIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return ((0,jsx_runtime.jsx)("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none', children: (0,jsx_runtime.jsx)("path", { d: 'M12.0002 1.6001C7.1402 1.6001 3.2002 5.5401 3.2002 10.4001C3.2002 16.1873 8.9218 18.9577 9.6386 19.6025C10.3706 20.2609 10.9754 21.7369 11.2194 22.5737C11.3378 22.9801 11.6706 23.1857 12.0002 23.1945C12.3306 23.1849 12.6626 22.9793 12.781 22.5737C13.025 21.7369 13.6298 20.2617 14.3618 19.6025C15.0786 18.9577 20.8002 16.1873 20.8002 10.4001C20.8002 5.5401 16.8602 1.6001 12.0002 1.6001ZM12.0002 12.8001C10.6746 12.8001 9.6002 11.7257 9.6002 10.4001C9.6002 9.0745 10.6746 8.0001 12.0002 8.0001C13.3258 8.0001 14.4002 9.0745 14.4002 10.4001C14.4002 11.7257 13.3258 12.8001 12.0002 12.8001Z', fill: color }) }));
};
var LocationIOS16GlyphIcon$1 = react.memo(LocationIOS16GlyphIcon);


//# sourceMappingURL=LocationIOS16Glyph.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/CreditIcon.js
'use client';





var CreditIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? Colors/* colors.grey.50 */.O9.grey[50] : _d;
    return ((0,jsx_runtime.jsx)("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none', children: (0,jsx_runtime.jsx)("path", { d: 'M17.5922 3.97668C17.5327 3.97789 17.4735 3.98575 17.4157 4.00011H12.0407H11.961H6.52191C6.48214 3.99344 6.44192 3.98978 6.4016 3.98918C6.26567 3.98843 6.1318 4.02232 6.01261 4.08766C5.89341 4.153 5.79283 4.24762 5.72035 4.36261L1.05941 9.80168C0.970892 9.88014 0.900872 9.97725 0.854393 10.086C0.807913 10.1948 0.786131 10.3125 0.790614 10.4307C0.795097 10.5489 0.825734 10.6647 0.880319 10.7696C0.934904 10.8745 1.01208 10.9661 1.10629 11.0376L11.4157 21.347C11.4182 21.3501 11.4208 21.3533 11.4235 21.3564L11.4344 21.3657C11.4721 21.4036 11.5134 21.4377 11.5578 21.4673C11.5599 21.4684 11.562 21.4694 11.5641 21.4704C11.5834 21.4833 11.6032 21.4952 11.6235 21.5064C11.6276 21.508 11.6318 21.5095 11.636 21.5111C11.7279 21.5585 11.8282 21.5877 11.9313 21.597C11.9583 21.5994 11.9854 21.6004 12.0125 21.6001C12.023 21.5998 12.0334 21.5993 12.0438 21.5986C12.0574 21.5979 12.0709 21.5968 12.0844 21.5954C12.087 21.5954 12.0896 21.5954 12.0922 21.5954C12.0969 21.5944 12.1016 21.5934 12.1063 21.5923C12.1278 21.5895 12.1492 21.5859 12.1703 21.5814C12.1914 21.577 12.2122 21.5718 12.2328 21.5657C12.2381 21.5642 12.2433 21.5627 12.2485 21.5611C12.2542 21.559 12.26 21.5569 12.2657 21.5548C12.31 21.5393 12.3529 21.52 12.3938 21.497L12.3953 21.4954C12.4135 21.4852 12.4312 21.4742 12.4485 21.4626C12.4527 21.4595 12.4568 21.4564 12.461 21.4532C12.4983 21.4271 12.5333 21.3978 12.5657 21.3657L12.5719 21.3611C12.5756 21.3569 12.5792 21.3528 12.5828 21.3486L22.8953 11.0361C22.9892 10.9644 23.066 10.8728 23.1203 10.768C23.1745 10.6631 23.2049 10.5475 23.2093 10.4296C23.2136 10.3116 23.1918 10.1941 23.1453 10.0855C23.0989 9.97696 23.029 9.88003 22.9407 9.80168L18.3141 4.4048C18.2452 4.27359 18.1413 4.16408 18.0138 4.08849C17.8863 4.01289 17.7404 3.97418 17.5922 3.97668ZM7.45941 5.60011H10.4438L8.31254 8.58449L7.45941 5.60011ZM13.5563 5.60011H16.5407L15.6875 8.58449L13.5563 5.60011ZM12 6.17824L14.4438 9.60011H9.55629L12 6.17824ZM6.0391 6.44855L6.9391 9.60011H3.3391L6.0391 6.44855ZM17.961 6.44855L20.661 9.60011H17.061L17.961 6.44855ZM3.53129 11.2001H7.45004L9.90004 17.5689L3.53129 11.2001ZM9.16566 11.2001H14.8344L12 18.5704L9.16566 11.2001ZM16.55 11.2001H20.4688L14.1 17.5689L16.55 11.2001Z', fill: color }) }));
};
var CreditIcon$1 = react.memo(CreditIcon);


//# sourceMappingURL=CreditIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/IconCongratulations.js
'use client';





var IconCongratulations = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, _c = _a.fill, fill = _c === void 0 ? Colors/* colors.grey.20 */.O9.grey[20] : _c;
    return ((0,jsx_runtime.jsx)("svg", { width: size, height: size, viewBox: '0 0 16 16', fill: fill, xmlns: 'http://www.w3.org/2000/svg', children: (0,jsx_runtime.jsx)("path", { d: 'M4.90234 6.79395C5.25398 6.79181 5.62123 6.88367 5.97266 7.02441C6.67796 7.30693 7.44634 7.83703 8.1377 8.52832C8.82913 9.21976 9.35905 9.98892 9.6416 10.6943C9.78234 11.0458 9.87423 11.413 9.87207 11.7646C9.86979 12.1202 9.76917 12.507 9.47168 12.8047C9.37943 12.8969 9.27669 12.968 9.1709 13.0254C9.12552 13.0558 9.07633 13.0825 9.02246 13.1016L1.88965 15.6279C1.64746 15.7137 1.37703 15.6533 1.19531 15.4717C1.01359 15.2898 0.952043 15.0186 1.03809 14.7764L3.53027 7.75977C3.59085 7.55784 3.69526 7.36235 3.8623 7.19531L3.97754 7.09277C4.25587 6.87406 4.59117 6.79589 4.90234 6.79395ZM15.0068 13C15.3748 13.0002 15.6729 13.2989 15.6729 13.667C15.6727 14.0349 15.3747 14.3328 15.0068 14.333H15C14.6319 14.333 14.3332 14.035 14.333 13.667C14.333 13.2988 14.6318 13 15 13H15.0068ZM2.7627 13.9043L6.55371 12.5615C6.09384 12.276 5.62918 11.9055 5.19531 11.4717C4.76255 11.0389 4.39265 10.5759 4.10742 10.1172L2.7627 13.9043ZM4.81055 8.13867L4.7998 8.16895C4.79675 8.1866 4.79415 8.21139 4.79395 8.24414C4.79319 8.36823 4.82789 8.5588 4.92871 8.81055C5.12948 9.31169 5.54268 9.93324 6.1377 10.5283C6.73286 11.1235 7.35522 11.5365 7.85645 11.7373C8.10811 11.8381 8.29878 11.8738 8.42285 11.873C8.47954 11.8727 8.51125 11.8646 8.52637 11.8594C8.53159 11.8442 8.53969 11.8126 8.54004 11.7559C8.54078 11.6317 8.50514 11.4412 8.4043 11.1895C8.20352 10.6883 7.79038 10.0668 7.19531 9.47168C6.60032 8.87669 5.97869 8.46356 5.47754 8.2627C5.22602 8.16195 5.03525 8.12726 4.91113 8.12793C4.85836 8.12825 4.82686 8.13361 4.81055 8.13867ZM12.4766 9.4043C12.6505 8.41576 13.6647 7.81578 14.6074 8.12695L14.6982 8.16016L14.7021 8.16113L15.249 8.38184C15.5902 8.51944 15.7555 8.90764 15.6182 9.24902C15.4806 9.5903 15.0924 9.75544 14.751 9.61816L14.2061 9.39941C14.0275 9.33059 13.8238 9.44386 13.79 9.63574L13.7891 9.63477C13.6597 10.4213 12.9759 11 12.1797 11H11.667C11.2988 11 11 10.7012 11 10.333C11.0002 9.96498 11.2989 9.66699 11.667 9.66699H12.1797C12.3261 9.66695 12.4523 9.55768 12.4746 9.41699C12.4752 9.413 12.4759 9.40828 12.4766 9.4043L13.1338 9.52051L13.1504 9.52246L12.4766 9.4043ZM14.7881 1.03418C15.1372 0.917337 15.5149 1.10603 15.6318 1.45508C15.7486 1.80407 15.5608 2.18179 15.2119 2.29883L13.7178 2.79883V2.7998L13.6143 2.83887C13.3804 2.94014 13.1814 3.10993 13.0449 3.32715C12.9083 3.54463 12.8421 3.79784 12.8525 4.05273L12.8623 4.16992L12.873 4.34863C12.8794 5.23809 12.162 5.99977 11.2334 6H10.9795C10.7186 6.00019 10.5073 6.18039 10.4619 6.41797L9.77246 6.28613L9.81445 6.29492L10.4619 6.41797L10.4609 6.42285L10.3203 7.12988C10.2486 7.49087 9.89817 7.72484 9.53711 7.65332C9.17597 7.58174 8.94115 7.23127 9.0127 6.87012L9.15137 6.16895L9.19043 6.00684C9.41714 5.21188 10.1495 4.66717 10.9795 4.66699H11.2334C11.4158 4.66675 11.5593 4.50571 11.5381 4.32324L11.5195 4.09961C11.4997 3.57893 11.637 3.06242 11.916 2.61816C12.2365 2.10804 12.7244 1.72463 13.2959 1.53418L14.7881 1.03418ZM15.0068 5C15.3748 5.00023 15.6729 5.29894 15.6729 5.66699C15.6727 6.03491 15.3747 6.33278 15.0068 6.33301H15C14.6319 6.33301 14.3332 6.03505 14.333 5.66699C14.333 5.2988 14.6318 5 15 5H15.0068ZM7.41797 1.04785C7.75944 0.91067 8.14775 1.07653 8.28516 1.41797L8.50488 1.96387L8.50684 1.96777L8.54004 2.05957C8.85087 3.0021 8.25088 4.01633 7.2627 4.19043C7.2558 4.19164 7.24816 4.19237 7.24121 4.19336C7.11535 4.21138 7 4.33314 7 4.4873V5C7 5.36819 6.7012 5.66699 6.33301 5.66699C5.96492 5.66687 5.66699 5.36811 5.66699 5V4.4873C5.66699 3.70178 6.2349 3.00152 7.03125 2.87695L7.09961 2.85645C7.24822 2.79248 7.32774 2.61766 7.26855 2.46191L7.04785 1.91504C6.91081 1.57361 7.07659 1.18524 7.41797 1.04785ZM3.00684 1.66699C3.37471 1.66722 3.67266 1.96512 3.67285 2.33301C3.67285 2.70106 3.37483 2.99977 3.00684 3H3C2.63181 3 2.33301 2.7012 2.33301 2.33301C2.3332 1.96498 2.63193 1.66699 3 1.66699H3.00684ZM10.3398 1C10.708 1.00005 11.0068 1.29883 11.0068 1.66699C11.0067 2.03502 10.7079 2.33296 10.3398 2.33301H10.333C9.96502 2.33288 9.66715 2.03497 9.66699 1.66699C9.66699 1.29888 9.96492 1.00013 10.333 1H10.3398Z', fill: fill }) }));
};
var IconCongratulations$1 = react.memo(IconCongratulations);


//# sourceMappingURL=IconCongratulations.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/icons/InfoOverviewGroupIcons/index.js
'use client';

















var InfoOverview = {
    CompanySizeIcon: CompanySizeIcon$1,
    LocationIcon: LocationIcon$1,
    EducationIcon: EducationIcon$1,
    PhoneNumberIcon: PhoneNumberIcon$1,
    CalendarIOS16GlyphICon: CalendarIOS16GlyphICon,
    AdminIcon: AdminIcon$1,
    HeadHunterIcon: HeadHunterIcon$1,
    SalaryIcon: SalaryIcon,
    AddressIcon: AddressIcon,
    GenderIcon: GenderIcon$1,
    TranslatorIcon: TranslatorIcon$1,
    BirthdayIcon: BirthdayIcon$1,
    LocationIOS16GlyphIcon: LocationIOS16GlyphIcon$1,
    CreditIcon: CreditIcon$1,
    IconCongratulations: IconCongratulations$1
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Utils/utilities.js
'use client';

function parseJSON(value) {
    try {
        if (!value)
            return;
        var parsedObject = JSON.parse(value);
        return parsedObject;
    }
    catch (error) {
        if (error instanceof SyntaxError) {
            // Handle SyntaxError specifically, like logging or returning a default value
            console.error('Invalid JSON format:', error.message);
            throw error; // Or any other appropriate default value
        }
        else {
            // Handle other potential errors
            console.error('Error parsing JSON:', error);
            throw error; // Re-throw the error for further handling
        }
    }
}


//# sourceMappingURL=utilities.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/SearchBarUnstable/components/Locations/index.js
'use client';












function Locations() {
    var _a = (0,react.useContext)(reducer/* SearchBarContext */.O), state = _a.state, props = _a.props, t = _a.t, dispatch = _a.dispatch;
    var isShow = state.isShow;
    var _b = (0,react.useState)([]), locations = _b[0], setLocations = _b[1];
    var isMobile = props.isMobile, langCode = props.langCode, dataProvider = props.dataProvider, optionList = props.optionList, searchBarOptions = props.searchBarOptions;
    var locationDistricts = dataProvider === null || dataProvider === void 0 ? void 0 : dataProvider.getDistricts();
    var forceLimitDisplay = (0,react.useMemo)(function () {
        if (isShow || ((searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isHomepage) && !isMobile)) {
            return 3;
        }
        return 1;
    }, [isMobile, isShow, searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isHomepage]);
    var memoDelayTimeToShowDroupdown = (0,react.useMemo)(function () {
        if ((searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isHomepage) || isShow) {
            return 0;
        }
        return 380;
    }, [isShow, searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isHomepage]);
    var updateLocations = function (locations) {
        setLocations(locations);
        dispatch({
            type: actions/* ACTIONS.SET_LOCATIONS */.a.SET_LOCATIONS,
            payload: locations
        });
    };
    (0,react.useEffect)(function () {
        var _a;
        // case default update locations
        if (searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isNeedNavigate) {
            var localStorageParams = parseJSON(localStorage.getItem('params') || '');
            updateLocations((_a = localStorageParams === null || localStorageParams === void 0 ? void 0 : localStorageParams.locations) !== null && _a !== void 0 ? _a : []);
        }
        var handleOnEventSearch = function (e) {
            var _a;
            var searchEvent = e;
            var locations = ((_a = searchEvent === null || searchEvent === void 0 ? void 0 : searchEvent.detail) === null || _a === void 0 ? void 0 : _a.params).locations;
            if (typeof locations !== 'object')
                return;
            updateLocations(locations !== null && locations !== void 0 ? locations : []);
        };
        window.addEventListener('SEARCH', handleOnEventSearch);
        return function () {
            window.removeEventListener('SEARCH', handleOnEventSearch);
        };
    }, [searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isNeedNavigate]);
    return ((0,jsx_runtime.jsx)(TreeSelect$1, { langCode: langCode, textOptions: {
            headerLabel: t('Location'),
            inputPlaceholder: t('All locations'),
            maxLimitText: t('You have selected up to three locations')
        }, options: optionList, childrenList: locationDistricts, value: locations, onValueChange: function (value) {
            updateLocations(value !== null && value !== void 0 ? value : []);
        }, onShowDropdown: function (isShowDropdown) {
            if (isShowDropdown || !isShow) {
                dispatch({
                    type: actions/* ACTIONS.FORCE_CONTROL */.a.FORCE_CONTROL,
                    payload: types/* EForceControDropdown.JUST_SHOW_DROPDOWN_TREE_SELECT */.q.JUST_SHOW_DROPDOWN_TREE_SELECT
                });
            }
        }, onCloseDropdown: function (_, isShowDropdown) {
            if (!isShow) {
                return;
            }
            if (!isShowDropdown) {
                dispatch({
                    type: actions/* ACTIONS.FORCE_CONTROL */.a.FORCE_CONTROL,
                    payload: types/* EForceControDropdown.JUST_SHOW_DROPDOWN_CONTENT */.q.JUST_SHOW_DROPDOWN_CONTENT
                });
            }
        }, selectOptions: { isFilter: true }, styleOptions: {
            variant: TreeSelect_types/* EVariant.SECONDARY */.e.SECONDARY,
            leftIcon: function (props) { return (0,jsx_runtime.jsx)(InfoOverview.LocationIOS16GlyphIcon, (0,_tslib/* __assign */.pi)({}, props)); },
            forceLimitDisplay: forceLimitDisplay,
            arrowDownSize: {
                width: 20,
                height: 20
            }
        }, dropdownStyleOptions: {
            width: '350px',
            borderRadius: 16,
            marginTop: 12,
            delayTime: memoDelayTimeToShowDroupdown,
            isForceClose: true
        }, floatingConfig: {
            position: 'fixed',
            enablePortal: true,
            useWindowAsFlippingContainer: true,
            isFlip: false,
            placement: 'bottom-end'
        }, isMobile: isMobile, isDisabledClearValue: !(searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isHomepage) && !isShow }));
}
var Locations$1 = (0,react.memo)(Locations);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(76576);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/SearchBarUnstable/components/SearchSection/index.js
'use client';




















var SearchSection = function (params) {
    var _a = (0,react.useContext)(reducer/* SearchBarContext */.O), props = _a.props, state = _a.state, dispatch = _a.dispatch, t = _a.t, search = _a.search;
    var isMountedDropdown = params.isMountedDropdown;
    var searchBarOptions = props.searchBarOptions, isMobile = props.isMobile, pageName = props.pageName;
    var isShow = state.isShow, keyword = state.keyword;
    var mergedSearchBarOptions = (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, constants/* DEFAULT_SEARCH_BAR_OPTIONS */.Uj), searchBarOptions);
    var _b = mergedSearchBarOptions.isHomepage, isHomepage = _b === void 0 ? false : _b;
    var _c = (0,react.useState)(true), isSupportAnim = _c[0], setSupportAnim = _c[1];
    var inputContentRef = (0,react.useRef)(null);
    var searchSectionWrapperRef = (0,react.useRef)(null);
    var matcher = (0,useMediaQuery/* default */.Z)(!isHomepage ? '(max-width: 1023px)' : '(max-width: 767px)');
    var matcherMobile = (0,useMediaQuery/* default */.Z)('(max-width: 767px)');
    var handleClickSearchIcon = function () {
        var _a;
        if (!inputContentRef.current) {
            return;
        }
        var inputElement = (_a = inputContentRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(constants/* SEARCH_INPUT_QUERY_STRING */._o);
        inputElement && inputElement.focus();
    };
    var onClickCancel = function () {
        dispatch({
            type: actions/* ACTIONS.CLOSE_DROP_DOWN */.a.CLOSE_DROP_DOWN
        });
    };
    var onClickSearch = function () {
        search();
    };
    (0,react.useEffect)(function () {
        var iOSVersion = (0,helpers/* getiOSVersion */.u1)();
        setSupportAnim(iOSVersion === -2 || iOSVersion >= 16);
    }, []);
    return ((0,jsx_runtime.jsxs)(SearchSectionWrapper, { "data-cname": 'seachSection', isMobile: isMobile, isHomepage: isHomepage, isShow: isShow, pageName: pageName, isMountedDropdown: isMountedDropdown, ref: searchSectionWrapperRef, isSupportAnim: isSupportAnim, children: [(0,jsx_runtime.jsxs)(InputGroup, { "data-cname": 'InputGroup', isMobile: isMobile, isHomepage: isHomepage, isShow: isShow, children: [(0,jsx_runtime.jsx)(Icon, { className: 'sb-searchIcon', isHaveKeyword: keyword !== '', isShow: isShow, isMobile: isMobile, pageName: pageName, isHomePage: isHomepage, onClick: handleClickSearchIcon, children: (0,jsx_runtime.jsx)(IconSearch, { fill: Colors/* colors.grey.20 */.O9.grey[20] }) }), (0,jsx_runtime.jsx)(InputContent, { ref: inputContentRef, children: (0,jsx_runtime.jsx)(SearchInput, {}) })] }), (0,jsx_runtime.jsx)(CustomTreeSelect, { isShow: isShow, isHomePage: isHomepage, children: (0,jsx_runtime.jsx)(Locations$1, {}) }), (0,jsx_runtime.jsx)(ActionGroup, { isShow: !matcher || isShow, isHomepage: isHomepage, isMobile: matcherMobile, children: (0,jsx_runtime.jsxs)(Button/* default */.Z, { className: 'search__button', type: 'primary', onClick: onClickSearch, "aria-label": t('Search'), children: [(0,jsx_runtime.jsx)(TextButton, { isShow: isShow, isHomepage: isHomepage, children: t('Search') }), (0,jsx_runtime.jsx)(SearchIconWrap, { isShow: isShow, isHomepage: isHomepage, children: (0,jsx_runtime.jsx)(IconSearch, { width: 20, height: 20, fill: Colors/* colors.primary.100 */.O9.primary[100] }) })] }) }), (0,jsx_runtime.jsx)(ActionGroup, { isShow: isMobile && isMountedDropdown && isShow, children: (0,jsx_runtime.jsx)(Button/* default */.Z, { className: 'cancel__button', type: 'info', onClick: onClickCancel, children: t('Cancel') }) })] }));
};
var SearchSection$1 = (0,react.memo)(SearchSection);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Utils/hooks/UseElementOnScreen/index.js
'use client';



var useElementOnScreen = function (props) {
    var target = props.target, options = props.options;
    var _a = (0,react.useState)(true), enable = _a[0], setEnable = _a[1];
    var isUseReactRef = props.options && props.options.isUseReactRef !== undefined ? props.options.isUseReactRef : true;
    var _b = (0,react.useState)(false), isElementOnScreen = _b[0], setElementOnScreen = _b[1];
    var callbackObserve = (0,react.useCallback)(function (entities) {
        var entry = entities[0];
        setElementOnScreen(entry.isIntersecting);
        if (entry.isIntersecting && (options === null || options === void 0 ? void 0 : options.runOnce)) {
            setEnable(false);
        }
    }, [options === null || options === void 0 ? void 0 : options.runOnce]);
    (0,react.useEffect)(function () {
        // on mount
        if (target === undefined || target === null) {
            return;
        }
        if (typeof window === 'undefined') {
            return;
        }
        if (options === null) {
            return;
        }
        if (!enable) {
            return;
        }
        var intersectionObserver = null;
        if (typeof window.IntersectionObserver !== 'undefined') {
            if (isUseReactRef && (target.current === undefined || target.current === null)) {
                return;
            }
            intersectionObserver = new IntersectionObserver(callbackObserve, options);
            intersectionObserver.observe(isUseReactRef ? target.current : target);
        }
        return function () {
            // on disMount
            if (target === undefined || target === null) {
                return;
            }
            if (isUseReactRef && (target.current === undefined || target.current === null)) {
                return;
            }
            if (intersectionObserver !== null) {
                intersectionObserver.unobserve(isUseReactRef ? target.current : target);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [target, enable]);
    return [isElementOnScreen];
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Utils/cookie.js
var cookie = __webpack_require__(75929);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/PostHog/hooks/useHog/index.js
var useHog = __webpack_require__(20560);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/SearchBarUnstable/index.js
'use client';





















var DropdownContent = react.lazy(function () { return __webpack_require__.e(/* import() */ 437).then(__webpack_require__.bind(__webpack_require__, 88437)); });
var SearchBar = function (props) {
    var isMobile = props.isMobile, searchBarOptions = props.searchBarOptions, pageName = props.pageName, langCode = props.langCode, _a = props.domain, domain = _a === void 0 ? '' : _a;
    var mergedSearchBarOptions = (0,react.useMemo)(function () { return ((0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, constants/* DEFAULT_SEARCH_BAR_OPTIONS */.Uj), searchBarOptions)); }, [searchBarOptions]);
    var _b = (0,react.useReducer)(reducer/* searchBarReducer */.V, context/* initialSearchBar */.n), state = _b[0], dispatch = _b[1];
    var isShow = state.isShow, keyword = state.keyword, locations = state.locations, forceControllDropdown = state.forceControllDropdown;
    var tracking = (0,useHog/* default */.Z)().tracking;
    // State
    var _c = (0,react.useState)(false), isMountedDropdown = _c[0], setMountedDropdown = _c[1];
    var _d = (0,react.useState)(-1), initialWidth = _d[0], setInitialWidth = _d[1];
    var _e = (0,react.useState)(false), isMountedSearchBar = _e[0], setMountedSearchBar = _e[1];
    var searchBarContentRef = (0,react.useRef)(null);
    var searchBarWrapperRef = (0,react.useRef)(null);
    var dropdownContentOverflowRef = (0,react.useRef)(null);
    var timeoutRefs = (0,react.useRef)({});
    var isSearchOnScreen = useElementOnScreen({
        target: searchBarWrapperRef,
        options: {
            rootMargin: '0px 0px 0px 0px'
        }
    })[0];
    var t = (0,react.useCallback)(function (text) {
        var _a;
        if (langCode === 'en') {
            return text;
        }
        else {
            return (_a = translations[text]) !== null && _a !== void 0 ? _a : text;
        }
    }, [langCode]);
    var search = (0,react.useCallback)(function (params) {
        var _a;
        if (params === void 0) { params = {}; }
        var _b = params.withKeyword, withKeyword = _b === void 0 ? '' : _b, _c = params.withJobFunction, withJobFunction = _c === void 0 ? [] : _c, _d = params.onlyFillInput, onlyFillInput = _d === void 0 ? false : _d;
        var localStorageParams = (0,searchbarHelpers/* getLocalStorage */.$o)('params', '');
        // VNW-30947 remove special word
        var searchKeyword = (_a = keyword === null || keyword === void 0 ? void 0 : keyword.toLowerCase().replace(/[`~,/':;\\"\s]+/g, ' ')) !== null && _a !== void 0 ? _a : '';
        if (withKeyword !== '') {
            searchKeyword = withKeyword === null || withKeyword === void 0 ? void 0 : withKeyword.toLowerCase();
        }
        var searchUrl = t('/job-search/all-jobs');
        var latinKeyword = (0,helpers/* transformToLatin */.nr)(searchKeyword).replace(/ +/g, ' ');
        if (searchKeyword !== latinKeyword && mergedSearchBarOptions.isNeedNavigate) {
            searchKeyword = latinKeyword;
        }
        var searchLocations = locations;
        searchUrl = "".concat(domain).concat((0,searchbarHelpers/* buildSearchUrl */.aH)(searchKeyword, searchLocations, langCode));
        if (typeof window !== 'undefined' && searchKeyword === '') {
            if (localStorageParams !== undefined && localStorageParams !== null) {
                localStorageParams.query = '';
            }
            localStorage.setItem('params', JSON.stringify(localStorageParams));
        }
        // update cookies
        var locationsIds = searchLocations === null || searchLocations === void 0 ? void 0 : searchLocations.map(function (e) { return e.parentId; });
        if (locationsIds.length > 0) {
            (0,cookie/* setCookie */.d)(constants/* VNW_SEARCH_JOB_CITY_COOKIE_NAME */.Kr, locationsIds === null || locationsIds === void 0 ? void 0 : locationsIds.join(','), 30);
        }
        else {
            (0,cookie/* setCookie */.d)(constants/* VNW_SEARCH_JOB_CITY_COOKIE_NAME */.Kr, 'all', 30);
        }
        var districtId = (0,searchbarHelpers/* getDistrictIdFromLocations */.Ak)(searchLocations);
        tracking({
            eventName: 'js_search_result_page:search_button_click',
            properties: {
                keyword: keyword,
                filterLocationCityId: locationsIds,
                filterLocationDistrictId: districtId
            }
        });
        if (mergedSearchBarOptions.isNeedNavigate) {
            // Delay 300ms for finished transition
            // (UX: make user feeling smooth when navigating to search page)
            // Clear previous timeout if exists
            if (timeoutRefs.current.navigate) {
                clearTimeout(timeoutRefs.current.navigate);
            }
            timeoutRefs.current.navigate = setTimeout(function () {
                var _a;
                // update localStorage search params
                if (localStorageParams !== undefined && localStorageParams !== null) {
                    localStorageParams.query = searchKeyword;
                    localStorageParams.locationId = (_a = searchLocations.map(function (item) { return item.parentId; })) !== null && _a !== void 0 ? _a : [];
                    localStorageParams.locations = searchLocations;
                    localStorageParams.districtId = districtId;
                }
                localStorage.setItem('params', JSON.stringify(localStorageParams));
                (0,searchbarHelpers/* changeLocation */.zF)(searchUrl, false, onlyFillInput);
                timeoutRefs.current.navigate = null;
            }, 300);
        }
        else {
            // for page-container, the page should stay
            if (!onlyFillInput) {
                if (typeof window === 'undefined') {
                    return;
                }
                var params_1 = {
                    query: searchKeyword,
                    page: 0
                };
                params_1.locationId = searchLocations.map(function (item) { return item.parentId; }) || [];
                params_1.districtId = districtId || [];
                params_1.locations = searchLocations || [];
                if (withJobFunction && withJobFunction.length > 0) {
                    params_1.jobFunctionId = withJobFunction;
                }
                var searchEvent = new CustomEvent('SEARCH', {
                    detail: {
                        params: params_1,
                        from: 'AppShell > SearchBar > Search',
                        hideFilter: true,
                        clearCurrentParams: false
                    }
                });
                window.dispatchEvent(searchEvent);
                // await 500ms then get recent keyword
                // Clear previous timeout if exists
                if (timeoutRefs.current.recentSearch) {
                    clearTimeout(timeoutRefs.current.recentSearch);
                }
                timeoutRefs.current.recentSearch = setTimeout(function () {
                    var recentSearchList = (0,searchbarHelpers/* getLocalStorage */.$o)(constants/* RECENT_SEARCH */.Mt, '');
                    dispatch({
                        type: actions/* ACTIONS.SET_RECENT_KEYWORDS */.a.SET_RECENT_KEYWORDS,
                        payload: Array.isArray(recentSearchList) ? recentSearchList.reverse() : []
                    });
                    timeoutRefs.current.recentSearch = null;
                }, 500);
            }
        }
        dispatch({
            type: actions/* ACTIONS.FORCE_CONTROL */.a.FORCE_CONTROL,
            payload: types/* EForceControDropdown.CLOSE_ALL */.q.CLOSE_ALL
        });
    }, [domain, keyword, langCode, locations, mergedSearchBarOptions.isNeedNavigate, t, tracking]);
    var handleAnimationEnd = (0,react.useCallback)(function () {
        if (isShow) {
            return;
        }
        setMountedDropdown(false);
    }, [isShow]);
    (0,react.useEffect)(function () {
        if (!isShow) {
            setMountedDropdown(false);
            return;
        }
        setMountedDropdown(forceControllDropdown === types/* EForceControDropdown.JUST_SHOW_DROPDOWN_CONTENT */.q.JUST_SHOW_DROPDOWN_CONTENT || isShow);
    }, [forceControllDropdown, isShow]);
    (0,react.useEffect)(function () {
        if (initialWidth !== -1) {
            return;
        }
        var calculateInitialWidth = function () {
            var _a;
            if (!searchBarContentRef.current) {
                return;
            }
            var initWidth = (_a = searchBarContentRef === null || searchBarContentRef === void 0 ? void 0 : searchBarContentRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth;
            if (!mergedSearchBarOptions.isHomepage && !isMobile) {
                initWidth -= 2;
            }
            if (isMobile && pageName !== 'searchResult') {
                initWidth = 40;
            }
            if (isMobile && pageName === 'searchResult') {
                initWidth = -1;
            }
            setInitialWidth(initWidth);
        };
        // Clear previous timeout if exists
        if (timeoutRefs.current.calculateWidth) {
            clearTimeout(timeoutRefs.current.calculateWidth);
        }
        timeoutRefs.current.calculateWidth = setTimeout(function () {
            calculateInitialWidth();
            timeoutRefs.current.calculateWidth = null;
        }, 300);
        return function () {
            if (timeoutRefs.current.calculateWidth) {
                clearTimeout(timeoutRefs.current.calculateWidth);
                timeoutRefs.current.calculateWidth = null;
            }
        };
    }, [initialWidth, mergedSearchBarOptions.isHomepage, isMobile, pageName]);
    (0,react.useEffect)(function () {
        if (!isShow) {
            return;
        }
        if (isSearchOnScreen) {
            return;
        }
        if (isMobile) {
            return;
        }
        dispatch({
            type: actions/* ACTIONS.CLOSE_DROP_DOWN */.a.CLOSE_DROP_DOWN
        });
    }, [isSearchOnScreen, isMobile, isShow]);
    var handleOnEventSearch = (0,react.useCallback)(function (e) {
        var _a, _b, _c;
        var searchEvent = e;
        var query = (_c = (_b = (_a = searchEvent === null || searchEvent === void 0 ? void 0 : searchEvent.detail) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.query) !== null && _c !== void 0 ? _c : '';
        if (query === '' || isShow) {
            return;
        }
        dispatch({
            type: actions/* ACTIONS.SET_KEYWORD */.a.SET_KEYWORD,
            payload: query
        });
    }, [isShow]);
    (0,react.useEffect)(function () {
        var onWindowResize = function () {
            setInitialWidth(-1);
        };
        var setKeywordFromLocalStorage = function () {
            var queryKeyword = (0,searchbarHelpers/* getLocalStorage */.$o)('params', 'query');
            if (queryKeyword === '') {
                return;
            }
            dispatch({
                type: actions/* ACTIONS.SET_KEYWORD */.a.SET_KEYWORD,
                payload: queryKeyword
            });
        };
        // This setTimeout is used for preventing layout shifting
        // when component first render
        // Clear previous timeout if exists
        if (timeoutRefs.current.initMount) {
            clearTimeout(timeoutRefs.current.initMount);
        }
        timeoutRefs.current.initMount = setTimeout(function () {
            setMountedSearchBar(true);
            setKeywordFromLocalStorage();
            timeoutRefs.current.initMount = null;
        }, 50);
        // Listen on Resize to make initialWidth responsive
        window.addEventListener('resize', onWindowResize);
        window.addEventListener('SEARCH', handleOnEventSearch);
        return function () {
            window.removeEventListener('resize', onWindowResize);
            window.removeEventListener('SEARCH', handleOnEventSearch);
            // Cleanup timeouts
            if (timeoutRefs.current.initMount) {
                clearTimeout(timeoutRefs.current.initMount);
                timeoutRefs.current.initMount = null;
            }
        };
    }, [handleOnEventSearch]);
    // Memoize context value to prevent unnecessary re-renders
    var contextValue = (0,react.useMemo)(function () { return ({
        state: state,
        props: (0,_tslib/* __assign */.pi)((0,_tslib/* __assign */.pi)({}, props), { searchBarOptions: mergedSearchBarOptions }),
        t: t,
        search: search,
        dispatch: dispatch
    }); }, [state, props, mergedSearchBarOptions, t, search, dispatch]);
    // Cleanup all timeouts on unmount
    (0,react.useEffect)(function () {
        return function () {
            Object.values(timeoutRefs.current).forEach(function (timeout) {
                if (timeout) {
                    clearTimeout(timeout);
                }
            });
            timeoutRefs.current = {};
        };
    }, []);
    return ((0,jsx_runtime.jsx)(reducer/* SearchBarContext.Provider */.O.Provider, { value: contextValue, children: (0,jsx_runtime.jsxs)(SearchBarContentWrapper, { "data-cname": 'SearchBarContentWrapper', isHomepage: mergedSearchBarOptions.isHomepage, ref: searchBarContentRef, children: [(0,jsx_runtime.jsx)(SearchBackground$1, {}), (0,jsx_runtime.jsx)(SearchBlockHolder, { isMountedDropdown: isMountedDropdown, isShow: isShow, isHomepage: mergedSearchBarOptions.isHomepage, isMobile: isMobile }), (0,jsx_runtime.jsxs)(SearchBarWrapper, { isShow: isShow, isMobile: isMobile, isHomepage: mergedSearchBarOptions.isHomepage, isMountedDropdown: isMountedDropdown, "data-id": 'search-bar', ref: searchBarWrapperRef, children: [(0,jsx_runtime.jsx)(SearchBarContent, { "data-cname": 'SearchBarContent', isMounted: isMountedSearchBar, isMountedDropdown: isMountedDropdown, isShow: isShow, isMobile: isMobile, initialWidth: initialWidth, isHomepage: mergedSearchBarOptions.isHomepage, children: (0,jsx_runtime.jsx)(SearchSection$1, { isMountedDropdown: isMountedDropdown }) }), isMountedDropdown ? ((0,jsx_runtime.jsx)(DropDownContentOverflow, { isHidden: forceControllDropdown !== types/* EForceControDropdown.JUST_SHOW_DROPDOWN_CONTENT */.q.JUST_SHOW_DROPDOWN_CONTENT, isMobile: isMobile, isHomepage: mergedSearchBarOptions.isHomepage, ref: dropdownContentOverflowRef, children: (0,jsx_runtime.jsx)(react.Suspense, { fallback: (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}), children: (0,jsx_runtime.jsx)(DropdownContent, { dropdownContentOverflowRef: dropdownContentOverflowRef, onAnimationEnd: handleAnimationEnd }) }) })) : null] })] }) }));
};
var index = react.memo(SearchBar);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 62761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ix": function() { return /* binding */ buildJobsByCompanyUrl; },
  "aH": function() { return /* binding */ buildSearchUrl; },
  "zF": function() { return /* binding */ changeLocation; },
  "Ak": function() { return /* binding */ getDistrictIdFromLocations; },
  "$o": function() { return /* binding */ getLocalStorage; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96782);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(31545);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/SearchBarUnstable/constants.js
var SearchBarUnstable_constants = __webpack_require__(83528);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/SearchBarUnstable/types.js
'use client';

var SEARCH_PARAMS = {
    QUERY: 'q',
    LOCATION: 'l',
    DISTRICT: 'd',
    CATEGORY: 'f',
    INDUSTRY: 'i',
    WORKING_TYPE: 'w',
    JOB_LEVEL: 'level',
    URGENT: 'urgent',
    PAGE: 'page'
};


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/SearchBarUnstable/searchbarHelpers.js
'use client';







var getDistrictIdFromLocations = function (locations) {
    var updatedList = [];
    // Loop through cities
    locations === null || locations === void 0 ? void 0 : locations.map(function (location) {
        var _a;
        // Loop through district
        (_a = location === null || location === void 0 ? void 0 : location.childrenIds) === null || _a === void 0 ? void 0 : _a.map(function (item) {
            // Do not push -1 to list
            if (item === -1) {
                return;
            }
            if (updatedList.indexOf(item) >= 0) {
                return;
            }
            updatedList.push(item);
        });
    });
    return updatedList;
};
var buildSearchUrl = function (keyword, locationObj, language) {
    var params = {};
    if (keyword) {
        params[SEARCH_PARAMS.QUERY] = keyword.replace(/ /g, '-');
    }
    if (Array.isArray(locationObj) && locationObj.length > 0) {
        params[SEARCH_PARAMS.LOCATION] = locationObj.map(function (i) { return i.parentId; }).join('.');
        var districtId = getDistrictIdFromLocations(locationObj);
        if (districtId && districtId.length > 0) {
            params[SEARCH_PARAMS.DISTRICT] = districtId.join('.');
        }
    }
    if (Object.keys(params).length > 0) {
        var paramsString = '?' + new URLSearchParams(params).toString();
        var baseUrl = language === constants/* ELanguage.VI */.Df.VI ? '/viec-lam' : '/jobs';
        return baseUrl + paramsString;
    }
    else {
        return language === constants/* ELanguage.VI */.Df.VI ? '/tim-viec-lam/tim-tat-ca-viec-lam' : '/job-search/all-jobs';
    }
};
var buildJobsByCompanyUrl = function (companyId, companyName, lang) {
    var prefix = lang === 'en' ? 'companies' : 'nha-tuyen-dung';
    return "/".concat(prefix, "/").concat((0,helpers/* slugify */.lV)(companyName), "-c").concat(companyId);
};
var changeLocation = function (url, isReturn, onlyFillInput) {
    if (isReturn === void 0) { isReturn = false; }
    var locationHref = window.location.origin;
    if (onlyFillInput) {
        return '';
    }
    // Remove wowcv from location (Because wowcv is using different domain)
    if (locationHref.indexOf('wowcv.') >= 0) {
        locationHref = locationHref.replace('wowcv.', '');
        // only for staging
        if (locationHref.indexOf('staging-vietnamworks') >= 0) {
            locationHref = locationHref.replace('staging-vietnamworks', 'staging.vietnamworks');
        }
        // only for release
        if (locationHref.indexOf('release-vietnamworks') >= 0) {
            locationHref = locationHref.replace('release-vietnamworks', 'release.vietnamworks');
        }
        if (!isReturn) {
            window.location.assign(locationHref + url);
        }
        return locationHref + url;
    }
    else {
        if (!isReturn) {
            window.location.assign(url);
        }
        return url;
    }
};
var getLocalStorage = function (mainKey, key) {
    if (mainKey === void 0) { mainKey = 'params'; }
    var params = typeof window !== 'undefined' ? localStorage.getItem(mainKey) : '';
    var defaultValue = {};
    if (mainKey === SearchBarUnstable_constants/* RECENT_SEARCH */.Mt) {
        defaultValue = [];
    }
    else if (mainKey === 'params') {
        if (key === 'query') {
            defaultValue = '';
        }
        else if (key === 'categoryId') {
            defaultValue = [];
        }
        else if (key === 'companyIndustries') {
            defaultValue = [];
        }
        else if (key === 'locationId') {
            defaultValue = [];
        }
        else if (key === 'locations') {
            defaultValue = [];
        }
        else if (key === '') {
            defaultValue = SearchBarUnstable_constants/* defaultSearchFilterParams */.FB;
        }
    }
    var localParams = params !== '' && params !== null ? JSON.parse(params) : defaultValue;
    if (localParams[key] !== undefined && localParams[key] !== null && key !== '') {
        return localParams[key];
    }
    else if (key !== undefined && key !== '' && localParams[key] === undefined) {
        return defaultValue;
    }
    return localParams;
};


//# sourceMappingURL=searchbarHelpers.js.map


/***/ }),

/***/ 45867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Skeleton; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74982);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
'use client';





var shimmer = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(templateObject_1 || (templateObject_1 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__makeTemplateObject */ .cy)(["\n    100% {\n        transform: translateX(100%);\n    }\n"], ["\n    100% {\n        transform: translateX(100%);\n    }\n"])));
var StyledSkeleton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(templateObject_2 || (templateObject_2 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__makeTemplateObject */ .cy)(["\n    display: block;\n    height: ", "px;\n    width: ", ";\n    position: relative;\n    overflow: hidden;\n    background-color: #efefef;\n    border-radius: 4px;\n\n    &::after {\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        transform: translateX(-100%);\n        background: linear-gradient(\n            90deg,\n            rgba(255, 255, 255, 0) 0,\n            rgba(255, 255, 255, 0.2) 20%,\n            rgba(255, 255, 255, 0.5) 60%,\n            rgba(255, 255, 255, 0)\n        );\n        animation: ", " 2s infinite forwards;\n        content: '';\n    }\n"], ["\n    display: block;\n    height: ", "px;\n    width: ", ";\n    position: relative;\n    overflow: hidden;\n    background-color: #efefef;\n    border-radius: 4px;\n\n    &::after {\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        transform: translateX(-100%);\n        background: linear-gradient(\n            90deg,\n            rgba(255, 255, 255, 0) 0,\n            rgba(255, 255, 255, 0.2) 20%,\n            rgba(255, 255, 255, 0.5) 60%,\n            rgba(255, 255, 255, 0)\n        );\n        animation: ", " 2s infinite forwards;\n        content: '';\n    }\n"])), function (props) { return props.height; }, function (props) { return (props.width ? "".concat(props.width, "px") : '100%'); }, shimmer);
function Skeleton(props) {
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSkeleton, (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, props));
}
var templateObject_1, templateObject_2;


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 98965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AH": function() { return /* binding */ DEFAULT_MOBILE_FIXED_HEIGHT_WITHOUT_ERROR; },
/* harmony export */   "Bk": function() { return /* binding */ DEFAULT_MOBILE_FIXED_HEIGHT; },
/* harmony export */   "P7": function() { return /* binding */ DEFAULT_MARGIN_WIDTH; },
/* harmony export */   "Rh": function() { return /* binding */ SELECT_CATE_LEVEL_SUB; },
/* harmony export */   "Rm": function() { return /* binding */ DEFAULT_PADDING_WIDTH; },
/* harmony export */   "Y4": function() { return /* binding */ DEFAULT_TEXT_OPTIONS; },
/* harmony export */   "Z0": function() { return /* binding */ DEFAULT_BORDER_WIDTH; },
/* harmony export */   "av": function() { return /* binding */ SELECT_CATE_LEVEL_PARENT; },
/* harmony export */   "bx": function() { return /* binding */ DEFAULT_DROPDOWN_FOOTER_OPTIONS; },
/* harmony export */   "mG": function() { return /* binding */ DEFAULT_REMOVE_ICON_WIDTH; },
/* harmony export */   "mg": function() { return /* binding */ FIXED_WIDTH_OF_INPUT; },
/* harmony export */   "mt": function() { return /* binding */ DEFAULT_SELECT_OPTIONS; },
/* harmony export */   "r$": function() { return /* binding */ DEFAULT_CHARACTER_WIDTH; },
/* harmony export */   "tX": function() { return /* binding */ DEFAULT_DROPDOWN_STYLE_OPTIONS; },
/* harmony export */   "uQ": function() { return /* binding */ DEFAULT_OPTION_ITEM_HEIGHT; },
/* harmony export */   "v1": function() { return /* binding */ DEFAULT_INPUT_STYLE; },
/* harmony export */   "y8": function() { return /* binding */ DEFAULT_MIN_HEIGHT_OF_DROPDOWN; }
/* harmony export */ });
/* unused harmony export DEFAULT_LIMIT_SELECT_COUNT */
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69710);
'use client';



// Limit number option user can select
var DEFAULT_LIMIT_SELECT_COUNT = 3;
// 1 character is ~ 6.8px => 7px
var DEFAULT_CHARACTER_WIDTH = 7;
// 1 item padding is 16px
var DEFAULT_PADDING_WIDTH = 16;
// other item (except first one) have margin-left 4px
var DEFAULT_MARGIN_WIDTH = 4;
// 1 item have border width 2px (left + right)
var DEFAULT_BORDER_WIDTH = 2;
// Remove icon button width is 24px with extra plus item (34px)
var DEFAULT_REMOVE_ICON_WIDTH = 88;
var DEFAULT_MOBILE_FIXED_HEIGHT = 206;
var DEFAULT_MOBILE_FIXED_HEIGHT_WITHOUT_ERROR = 168;
var FIXED_WIDTH_OF_INPUT = 36;
// Job Function Level
var SELECT_CATE_LEVEL_PARENT = 0;
var SELECT_CATE_LEVEL_SUB = 1;
var DEFAULT_INPUT_STYLE = {
    arrowDownSize: {
        width: 24,
        height: 24
    },
    isTransparentBackground: false,
    limitDisplay: 3,
    variant: _types_js__WEBPACK_IMPORTED_MODULE_0__/* .EVariant.PRIMARY */ .e.PRIMARY,
    placeholderColor: '',
    cssString: '',
    leftIcon: function (_props) {
        return null;
    },
    forceLimitDisplay: 0
};
// Default option item height in pixel is 40px
var DEFAULT_OPTION_ITEM_HEIGHT = 40;
// Min height of dropdown item in pixel: 240px
var DEFAULT_MIN_HEIGHT_OF_DROPDOWN = 240;
var DEFAULT_DROPDOWN_FOOTER_OPTIONS = {
    isEnableFooter: false,
    setElementVisible: function () { },
    onClickApply: function () { },
    onClickCancel: function () { },
    resetSelectedValue: function () { }
};
var DEFAULT_TEXT_OPTIONS = {
    headerLabel: 'Header',
    searchPlaceholder: 'Search',
    allText: 'All',
    maxLimitText: 'Limit reached!',
    removeAllText: 'Remove all',
    backText: 'Back',
    noResultText: 'No result',
    selectedCountText: '',
    selectAllText: '',
    primaryButtonText: '',
    subOptionText: ''
};
var DEFAULT_DROPDOWN_STYLE_OPTIONS = {
    width: '100%',
    marginTop: 0,
    isShowTooltip: false,
    primaryBtnType: 'primary',
    borderRadius: 6,
    delayTime: 0,
    isForceClose: false
};
var DEFAULT_SELECT_OPTIONS = {
    limitParentCount: DEFAULT_LIMIT_SELECT_COUNT,
    isSortAlphabet: false,
    isSingleSelect: false,
    isFilter: false,
    isStripFirstItem: false,
    limitFirstItemLength: 24
};


//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 68371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ initialTreeSelect; }
/* harmony export */ });
'use client';

var initialTreeSelect = {
    selectedParentId: -1,
    selectLevel: 0,
    history: {
        selectedParentId: -1,
        selectLevel: 0,
        bodyScrollPosition: []
    }
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 49287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ TreeSelectContext; },
/* harmony export */   "s": function() { return /* binding */ treeSelectReducer; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74982);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68371);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69013);
'use client';






var treeSelectReducer = function (state, action) {
    var type = action.type, payload = action.payload;
    switch (type) {
        case _types_js__WEBPACK_IMPORTED_MODULE_1__/* .TreeSelectAction.UPDATE_SELECTED_PARENT_ID */ .N.UPDATE_SELECTED_PARENT_ID: {
            var parentId = payload;
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, state), { selectedParentId: parentId });
        }
        case _types_js__WEBPACK_IMPORTED_MODULE_1__/* .TreeSelectAction.UPDATE_SELECT_LEVEL */ .N.UPDATE_SELECT_LEVEL: {
            var levelIndex = payload;
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, state), { selectLevel: levelIndex });
        }
        case _types_js__WEBPACK_IMPORTED_MODULE_1__/* .TreeSelectAction.UPDATE_HISTORY */ .N.UPDATE_HISTORY: {
            var _a = payload, _b = _a.selectedParentId, selectedParentId = _b === void 0 ? -1 : _b, _c = _a.selectLevel, selectLevel = _c === void 0 ? 0 : _c;
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, state), { history: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, state.history), { selectedParentId: selectedParentId, selectLevel: selectLevel }) });
        }
        case _types_js__WEBPACK_IMPORTED_MODULE_1__/* .TreeSelectAction.UPDATE_SCROLLING_POSITION */ .N.UPDATE_SCROLLING_POSITION: {
            var history_1 = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, state.history);
            var updateItemPosition = payload;
            // This only work for 2 levels categories.
            // If we using 3 levels (currently not supported in TreeSelect) then this need to rework.
            var bodyScrollPosition = [updateItemPosition];
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, state), { history: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, history_1), { bodyScrollPosition: (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__spreadArray */ .ev)([], bodyScrollPosition, true) }) });
        }
        default:
            console.error('Unknown type of Reducer');
            return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, state);
    }
};
var TreeSelectContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    state: _index_js__WEBPACK_IMPORTED_MODULE_3__/* .initialTreeSelect */ .b,
    dispatch: function () { }
});


//# sourceMappingURL=reducer.js.map


/***/ }),

/***/ 69013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ TreeSelectAction; }
/* harmony export */ });
'use client';

var TreeSelectAction;
(function (TreeSelectAction) {
    TreeSelectAction[TreeSelectAction["UPDATE_SELECTED_PARENT_ID"] = 0] = "UPDATE_SELECTED_PARENT_ID";
    TreeSelectAction[TreeSelectAction["UPDATE_SELECT_LEVEL"] = 1] = "UPDATE_SELECT_LEVEL";
    TreeSelectAction[TreeSelectAction["UPDATE_HISTORY"] = 2] = "UPDATE_HISTORY";
    TreeSelectAction[TreeSelectAction["UPDATE_SCROLLING_POSITION"] = 3] = "UPDATE_SCROLLING_POSITION";
})(TreeSelectAction || (TreeSelectAction = {}));


//# sourceMappingURL=types.js.map


/***/ }),

/***/ 71078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NU": function() { return /* binding */ deepCloneArray; },
/* harmony export */   "fq": function() { return /* binding */ getChildrenListByParentId; },
/* harmony export */   "j5": function() { return /* binding */ sortChildOptionAlphabet; },
/* harmony export */   "kh": function() { return /* binding */ deepCloneObject; },
/* harmony export */   "t_": function() { return /* binding */ sortOptionsAlphabet; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74982);
/* harmony import */ var _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96782);
'use client';




/**
 * Get sub-level list from parent Id
 * @param parentId Parent Id in string
 * @param list Parent List. It should be look like districtData from app-shell-v2 (initialDataProvider)
 * @returns List of sub-level list from parent
 */
var getChildrenListByParentId = function (parentId, list) {
    var keyList = Object.keys(list);
    var valueList = Object.values(list);
    var index = keyList.indexOf(parentId.toString());
    if (!valueList[index]) {
        return [];
    }
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__spreadArray */ .ev)([], valueList[index], true);
};
var sortOptionsAlphabet = function (options, isSortAlphabet) {
    if (!isSortAlphabet) {
        return options;
    }
    var removedItem = null;
    var filteredHaveAllItem = options.filter(function (item) { return item.id === -1; });
    if (filteredHaveAllItem.length > 0) {
        removedItem = options.splice(0, 1);
    }
    options.sort(function (itemA, itemB) {
        if (itemA.name < itemB.name) {
            return -1;
        }
        if (itemA.name > itemB.name) {
            return 1;
        }
        return 0;
    });
    if (removedItem !== null) {
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__spreadArray */ .ev)((0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__spreadArray */ .ev)([], removedItem, true), options, true);
    }
    return options;
};
var sortChildOptionAlphabet = function (options, langCode, isSortAlphabet) {
    if (!isSortAlphabet) {
        return options;
    }
    var returnValue = {};
    var values = Object.values(options);
    /**
     * TODO: Find a more effective solution to resolve this problem without using unshift.
     * The 'childrenList' starts with an ID of 1, whereas the array starts at 0.
     * This misalignment is causing a shift of one item.
     */
    values.unshift([]);
    var newValues = values.map(function (item) {
        return item.sort(function (itemA, itemB) {
            if (langCode === _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ELanguage.VI */ .Df.VI) {
                if (itemA.name < itemB.name) {
                    return -1;
                }
                if (itemA.name > itemB.name) {
                    return 1;
                }
            }
            else {
                if (itemA.nameEn < itemB.nameEn) {
                    return -1;
                }
                if (itemA.nameEn > itemB.nameEn) {
                    return 1;
                }
            }
            return 0;
        });
    });
    Object.assign(returnValue, newValues);
    return returnValue;
};
/**
 * Completely deep clone array
 * @param arr any array value (Only Primitive accepted)
 * @returns new deep cloned value
 */
function deepCloneArray(arr) {
    var clone = [];
    for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
        var element = arr_1[_i];
        if (Array.isArray(element)) {
            clone.push(deepCloneArray(element));
        }
        else if (typeof element === 'object' && element !== null) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            clone.push(deepCloneObject(element));
        }
        else {
            clone.push(element);
        }
    }
    return clone;
}
/**
 * Completely deep clone object (Alternative with  )
 * @param arr any array value (Only Primitive accepted)
 * @returns new deep cloned value
 */
function deepCloneObject(obj) {
    var clone = {};
    for (var key in obj) {
        if (Array.isArray(obj[key])) {
            clone[key] = deepCloneArray(obj[key]);
        }
        else if (typeof obj[key] === 'object' && obj[key] !== null) {
            clone[key] = deepCloneObject(obj[key]);
        }
        else {
            clone[key] = obj[key];
        }
    }
    return clone;
}


//# sourceMappingURL=helpers.js.map


/***/ }),

/***/ 69710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ EVariant; }
/* harmony export */ });
'use client';

var EVariant;
(function (EVariant) {
    EVariant["PRIMARY"] = "PRIMARY";
    EVariant["SECONDARY"] = "SECONDARY";
})(EVariant || (EVariant = {}));


//# sourceMappingURL=types.js.map


/***/ }),

/***/ 22618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Typography; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(74982);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(48421);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Typography/const.js
'use client';

var display = {
    extraLarge: {},
    large: {
        'font-size': '57px',
        'font-weight': '400',
        'line-height': '64px'
    },
    medium: {
        'font-size': '45px',
        'font-weight': '400',
        'line-height': '52px'
    },
    small: {
        'font-size': '36px',
        'font-weight': '400',
        'line-height': '44px'
    }
};
var headline = {
    extraLarge: {},
    large: {
        'font-size': '32px',
        'font-weight': '600',
        'line-height': '40px'
    },
    medium: {
        'font-size': '28px',
        'font-weight': '600',
        'line-height': '36px'
    },
    small: { 'font-size': '24px', 'font-weight': '600', 'line-height': '32px' }
};
var title = {
    extraLarge: {
        'font-size': '20px',
        'font-weight': '600',
        'line-height': '24px'
    },
    large: {
        'font-size': '18px',
        'font-weight': '600',
        'line-height': '22px'
    },
    medium: {
        'font-size': '16px',
        'font-weight': '600',
        'line-height': '20px'
    },
    small: {
        'font-size': '14px',
        'font-weight': '600',
        'line-height': '18px'
    }
};
var label = {
    extraLarge: {},
    large: {
        'font-size': '16px',
        'font-weight': '500',
        'line-height': '20px'
    },
    medium: {
        'font-size': '14px',
        'font-weight': '500',
        'line-height': '18px'
    },
    small: { 'font-size': '12px', 'font-weight': '500', 'line-height': '14px' }
};
var body = {
    extraLarge: {},
    large: {
        'font-size': '16px',
        'font-weight': '400',
        'line-height': '20px'
    },
    medium: {
        'font-size': '14px',
        'font-weight': '400',
        'line-height': '18px'
    },
    small: { 'font-size': '12px', 'font-weight': '400', 'line-height': '14px' }
};
var paragraph = {
    extraLarge: {},
    large: {
        'font-size': '16px',
        'font-weight': '400',
        'line-height': '24px'
    },
    medium: {
        'font-size': '14px',
        'font-weight': '400',
        'line-height': '20px'
    },
    small: { 'font-size': '12px', 'font-weight': '400', 'line-height': '18px' }
};


//# sourceMappingURL=const.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Typography/styled.css.js
'use client';





var typoStyles = (0,styled_components_browser_esm/* css */.iv)(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var name = _a.name, size = _a.size;
    switch (name) {
        case 'display':
            return function () {
                switch (size) {
                    case 'large':
                        return display.large;
                    case 'medium':
                        return display.medium;
                    case 'small':
                        return display.small;
                }
            };
        case 'headline':
            return function () {
                switch (size) {
                    case 'large':
                        return headline.large;
                    case 'medium':
                        return headline.medium;
                    case 'small':
                        return headline.small;
                }
            };
        case 'title':
            return function () {
                switch (size) {
                    case 'extraLarge':
                        return title.extraLarge;
                    case 'large':
                        return title.large;
                    case 'medium':
                        return title.medium;
                    case 'small':
                        return title.small;
                }
            };
        case 'label':
            return function () {
                switch (size) {
                    case 'large':
                        return label.large;
                    case 'medium':
                        return label.medium;
                    case 'small':
                        return label.small;
                }
            };
        case 'body':
            return function () {
                switch (size) {
                    case 'large':
                        return body.large;
                    case 'medium':
                        return body.medium;
                    case 'small':
                        return body.small;
                }
            };
        case 'paragraph':
            return function () {
                switch (size) {
                    case 'large':
                        return paragraph.large;
                    case 'medium':
                        return paragraph.medium;
                    case 'small':
                        return paragraph.small;
                }
            };
    }
});
var Typo = styled_components_browser_esm/* default.div */.ZP.div(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    color: ", ";\n    font-family: ", ", Arial, sans-serif;\n    font-style: normal;\n    margin: 0;\n    padding: 0;\n    ", "\n"], ["\n    color: ", ";\n    font-family: ", ", Arial, sans-serif;\n    font-style: normal;\n    margin: 0;\n    padding: 0;\n    ", "\n"])), function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var fontFamily = _a.fontFamily;
    return fontFamily;
}, typoStyles);
var templateObject_1, templateObject_2;


//# sourceMappingURL=styled.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Typography/index.js
'use client';







var Typography = react.forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'p' : _b, _c = _a.name, name = _c === void 0 ? 'paragraph' : _c, _d = _a.size, size = _d === void 0 ? 'large' : _d, className = _a.className, style = _a.style, _e = _a.fontFamily, fontFamily = _e === void 0 ? 'Inter' : _e, _f = _a.color, color = _f === void 0 ? Colors/* colors.primary.0 */.O9.primary[0] : _f, rest = (0,_tslib/* __rest */._T)(_a, ["children", "variant", "name", "size", "className", "style", "fontFamily", "color"]);
    return ((0,jsx_runtime.jsx)(Typo, (0,_tslib/* __assign */.pi)({ ref: ref, style: (0,_tslib/* __assign */.pi)({}, style), className: className, as: variant, name: name, size: size, color: color, fontFamily: fontFamily }, rest, { children: children })));
});


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 96782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Df": function() { return /* binding */ ELanguage; },
/* harmony export */   "O9": function() { return /* binding */ colors; },
/* harmony export */   "P": function() { return /* binding */ EAlertType; },
/* harmony export */   "Xs": function() { return /* binding */ pathPage; }
/* harmony export */ });
/* unused harmony exports EAppMode, FORTIWEB_IP, INTERNATIONAL_CITY_ID, NAVIGOS_COMPANY_ID, ROUTE_SEARCH, SEARCH_PARAMS, SELECT_EMPTY_OPTION_ID, VIETNAM_COUNTRY_ID */
'use client';

var SELECT_EMPTY_OPTION_ID = (/* unused pure expression or super */ null && (-1));
var EAlertType;
(function (EAlertType) {
    EAlertType["info"] = "info";
    EAlertType["success"] = "success";
    EAlertType["danger"] = "danger";
    EAlertType["warning"] = "warning";
})(EAlertType || (EAlertType = {}));
var ELanguage;
(function (ELanguage) {
    ELanguage["EN"] = "en";
    ELanguage["VI"] = "vi";
})(ELanguage || (ELanguage = {}));
var EAppMode;
(function (EAppMode) {
    EAppMode["staging"] = "staging";
    EAppMode["release"] = "release";
    EAppMode["production"] = "production";
})(EAppMode || (EAppMode = {}));
var pathPage = [
    {
        page: 'search-result',
        path: ['/job-search/all-jobs', '/tim-viec-lam/tim-tat-ca-viec-lam', '-kv', '-kw', '-en', '-vn']
    },
    {
        page: 'job-detail',
        path: ['-jv', '-jd']
    },
    {
        page: 'wowcv',
        path: ['wowcv.']
    },
    {
        page: 'company-info',
        path: ['/cong-ty', '/companies']
    },
    {
        page: 'interview',
        path: ['/cau-hoi-phong-van/', '/interview/']
    },
    {
        page: 'salary',
        path: ['/muc-luong/', '/salary/']
    },
    {
        page: 'dashboard',
        path: ['/quan-ly-nghe-nghiep/quan-ly-ho-so', '/my-career-center/dashboard']
    },
    {
        page: 'my-profile',
        path: ['/ho-so', '/my-profile']
    },
    {
        page: 'profile-settings',
        path: ['/quan-ly-nghe-nghiep/thiet-lap-ho-so', '/my-career-center/profile-settings']
    },
    {
        page: 'profile-view',
        path: ['/quan-ly-nghe-nghiep/nha-tuyen-dung-nao-xem-ho-so-cua-ban', '/my-career-center/who-view-my-resume']
    },
    {
        page: 'my-jobs',
        path: ['/quan-ly-nghe-nghiep/viec-lam-cua-toi', '/my-career-center/my-jobs']
    },
    {
        page: 'job-alert',
        path: ['/quan-ly-nghe-nghiep/thong-bao-viec-lam', '/my-career-center/my-job-alert']
    },
    {
        page: 'account-settings',
        path: ['/quan-ly-tai-khoan', '/account-settings']
    }
];
var colors = {
    textColor: '#333333',
    textPlaceholder: '#999999',
    textGrayColor: '#848484',
    primaryColor: '#005AFF',
    secondaryColor: '#979797',
    buttonColor: '#FF7D55',
    infoColor: '#48BBFF',
    successColor: '#50B704',
    dangerColor: '#FF4A53',
    highlightColor: '#f7be06',
    darkBlueColor: '#001744',
    bgNormal: '#fbfbfc',
    bgHover: '#f7faff',
    bgError: '#FFF9F9',
    bgDisable: '#F6F8FB',
    bgHeader: '#e5eeff',
    borderNormal: '#D9D9D9',
    borderHover: '#80ADFF',
    borderFocus: '#0066FF',
    borderError: '#FF4A53',
    borderErrorFocus: '#fd2020',
    borderDisable: '#E8EDF6',
    borderCard: '#e0e0e9',
    cardShadow: '#efefef',
    tagSelect: '#E6EFFF',
    tagSelectBorder: '#B3CEFF',
    tagHover: '#CCDEFF',
    jobCardBorder: '#f1f1f1',
    jobCardHover: '#f8f9fa',
    saveIconHover: '#eff5ff'
};
/**
    staging: 252025
    release: 330189 (Manual), 330355 (Auto)
    production: 18364, 319884
 */
var NAVIGOS_COMPANY_ID = {
    staging: [252025],
    release: [330189, 330355],
    production: [18364, 319884]
};
var SEARCH_PARAMS;
(function (SEARCH_PARAMS) {
    SEARCH_PARAMS["QUERY"] = "q";
    SEARCH_PARAMS["LOCATION"] = "l";
    SEARCH_PARAMS["CATEGORY"] = "f";
    SEARCH_PARAMS["GROUP_JOB_FUNCTION"] = "g";
    SEARCH_PARAMS["JOB_FUNCTION"] = "j";
    SEARCH_PARAMS["INDUSTRY"] = "i";
    SEARCH_PARAMS["WORKING_TYPE"] = "w";
    SEARCH_PARAMS["JOB_LEVEL"] = "level";
    SEARCH_PARAMS["SALARY"] = "s";
    SEARCH_PARAMS["URGENT"] = "urgent";
    SEARCH_PARAMS["LANGUAGE"] = "lang";
    SEARCH_PARAMS["PAGE"] = "page";
    SEARCH_PARAMS["SORTING"] = "sorting";
    SEARCH_PARAMS["DISTRICT"] = "d";
})(SEARCH_PARAMS || (SEARCH_PARAMS = {}));
var ROUTE_SEARCH;
(function (ROUTE_SEARCH) {
    ROUTE_SEARCH["RESULT"] = "/job-search/all-jobs";
    ROUTE_SEARCH["RESULT_VI"] = "/tim-viec-lam/tim-tat-ca-viec-lam";
    ROUTE_SEARCH["JOBS"] = "/jobs";
    ROUTE_SEARCH["JOBS_VI"] = "/viec-lam";
})(ROUTE_SEARCH || (ROUTE_SEARCH = {}));
// Private IP of Fortiweb
var FORTIWEB_IP = (/* unused pure expression or super */ null && (['10.122.10.10', '10.122.10.11', '10.122.4.11', '10.122.4.12', '10.122.4.13']));
// Locations
var VIETNAM_COUNTRY_ID = 1;
var INTERNATIONAL_CITY_ID = 70;


//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 75929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ setCookie; }
/* harmony export */ });
/* unused harmony export getCookie */
'use client';

var setCookie = function (name, value, days, domain) {
    if (domain === void 0) { domain = ''; }
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
    }
    var domainStr = '';
    if (domain !== '') {
        domainStr = 'domain=' + domain + '; ';
    }
    document.cookie = name + '=' + value + expires + '; ' + domainStr + 'path=/';
};
var getCookie = function (name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return c.substring(nameEQ.length, c.length);
    }
    return null;
};


//# sourceMappingURL=cookie.js.map


/***/ }),

/***/ 31545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ isLocationChanged; },
/* harmony export */   "HI": function() { return /* binding */ encrypt; },
/* harmony export */   "If": function() { return /* binding */ detectEncryptAccessToken; },
/* harmony export */   "_2": function() { return /* binding */ attachQueryParamToUrl; },
/* harmony export */   "iz": function() { return /* binding */ detectPage; },
/* harmony export */   "kb": function() { return /* binding */ randomId; },
/* harmony export */   "lV": function() { return /* binding */ slugify; },
/* harmony export */   "n3": function() { return /* binding */ checkIfEmailInString; },
/* harmony export */   "nr": function() { return /* binding */ transformToLatin; },
/* harmony export */   "oo": function() { return /* binding */ hexToRgb; },
/* harmony export */   "pe": function() { return /* binding */ decrypt; },
/* harmony export */   "u1": function() { return /* binding */ getiOSVersion; }
/* harmony export */ });
/* unused harmony exports ConvertHexToRgbA, addCommaToNumber, compareVariable, createTranslator, debounceHandler, deepMerge, downloadAttachFile, encodeKeyword, filterHTMLTag, filterInt, filterObjectArrayBasedOnObjectArray, filterPrivateIP, fixedNumber, formatSalary, generateJobUrl, getNumberFromString, isCompanyWhitelisted, isDifferentArrayData, isIPv4FromGoogle, isPrivateIP, isRobot, isVietnamese, locationsMappingHelperForMultiLevelSelect, quickFilterByKeywords, sortArray, t, textToLatin */
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96782);
/* provided dependency */ var Buffer = __webpack_require__(21876)["Buffer"];
'use client';





function filterInt(value) {
    if (/^[-+]?(\d+|Infinity)$/.test(value)) {
        return Number(value);
    }
    else {
        return NaN;
    }
}
// Hex to RGBA with 20% opacity
function ConvertHexToRgbA(hex, opacity) {
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        var c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ",".concat(opacity, ")");
    }
    throw new Error('Bad Hex');
}
function addCommaToNumber(number) {
    var nums = number.toString().replace(/,/g, '');
    if (!nums || nums.endsWith('.'))
        return number.toString();
    return parseFloat(nums).toLocaleString('en-US');
}
function getNumberFromString(string) {
    if (string) {
        return Number(string.replace(/,/g, ''));
    }
    else
        return '';
}
function encodeKeyword(rawKeyword) {
    var blackList = [
        { regex: /C#/gi, replace: 'C_sharp' },
        {
            regex: /C\+\+/gi,
            replace: 'C_plus_plus'
        },
        { regex: /[[\]\\/:~^?!()><"'@%|{}`*#]/gi, replace: ' ' },
        { regex: /&/gi, replace: encodeURIComponent('&') }
    ];
    var tempkeyword;
    for (var i in blackList) {
        rawKeyword = rawKeyword.replace(blackList[i].regex, blackList[i].replace);
    }
    do {
        tempkeyword = rawKeyword;
        rawKeyword = tempkeyword.replace('  ', ' ');
    } while (tempkeyword !== rawKeyword);
    rawKeyword = rawKeyword.replace(/[-]{1,}/g, '--');
    rawKeyword = rawKeyword.trim();
    return rawKeyword.replace(/ /g, '-');
}
/**
 * Transform all characters with accent into latin, e.g. `Ô kìa Con vịt` to `o kia con vit`
 * @param text - the text you want to transform
 */
function transformToLatin(text, isUrl) {
    if (isUrl === void 0) { isUrl = false; }
    text = text.toString().toLowerCase().trim();
    var sets = [
        { to: 'a', from: '[ÀÁÂÃÄÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶἀ]' },
        { to: 'c', from: '[ÇĆĈČ]' },
        { to: 'd', from: '[ÐĎĐÞ]' },
        { to: 'e', from: '[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]' },
        { to: 'g', from: '[ĜĞĢǴ]' },
        { to: 'h', from: '[ĤḦ]' },
        { to: 'i', from: '[ÌÍÎÏĨĪĮİỈỊ]' },
        { to: 'j', from: '[Ĵ]' },
        { to: 'ij', from: '[Ĳ]' },
        { to: 'k', from: '[Ķ]' },
        { to: 'l', from: '[ĹĻĽŁ]' },
        { to: 'm', from: '[Ḿ]' },
        { to: 'n', from: '[ÑŃŅŇ]' },
        { to: 'o', from: '[ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]' },
        { to: 'oe', from: '[Œ]' },
        { to: 'p', from: '[ṕ]' },
        { to: 'r', from: '[ŔŖŘ]' },
        { to: 's', from: '[ßŚŜŞŠȘ]' },
        { to: 't', from: '[ŢŤ]' },
        { to: 'u', from: '[ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]' },
        { to: 'w', from: '[ẂŴẀẄ]' },
        { to: 'x', from: '[ẍ]' },
        { to: 'y', from: '[ÝŶŸỲỴỶỸ]' },
        { to: 'z', from: '[ŹŻŽ]' }
    ];
    if (!isUrl) {
        sets.push({ to: '-', from: "[·/_,:;']" });
    }
    sets.forEach(function (set) {
        text = text.replace(new RegExp(set.from, 'gi'), set.to);
    });
    text = text.replace(/[^ -~]/gi, '');
    return text;
}
/**
 * Clean slugs by removing spaces, invalid characters and dashes
 * @param slug - the slug you wanna clean
 */
function slugify(slug) {
    slug = slug.replace(/^\s+|\s+$/g, ''); // trim
    slug = slug.toLowerCase();
    // remove accents
    slug = transformToLatin(slug);
    slug = slug
        .replace(/[^a-z0-9 -]/g, '-') // invalid chars to -
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes
    return slug;
}
function t(key, language) {
    var _a;
    if (language === 'en') {
        return key;
    }
    else {
        return (_a = translations[key]) !== null && _a !== void 0 ? _a : key;
    }
}
/**
 * Decrypt accessToken (Copied from app-shell-v2/src/helpers/helper.ts:245 )
 * @param token accessToken (Example: user.accessToken from homepage)
 * @returns decrypted accessToken
 */
function decrypt(token) {
    if (typeof atob === 'function') {
        return atob(atob(token));
    }
    var nodeAtob = function (str) {
        return Buffer.from(str, 'base64').toString('binary');
    };
    return nodeAtob(nodeAtob(token));
}
function encrypt(token) {
    if (typeof btoa === 'function') {
        return btoa(btoa(token)).replace(/=/g, '');
    }
    var nodeBtoa = function (str) {
        return Buffer.from(str).toString('base64');
    };
    return nodeBtoa(nodeBtoa(token));
}
var detectPage = function () {
    if (typeof window === undefined) {
        return 'search-result';
    }
    var url = window.location.href;
    for (var i = 0; i < _constants_js__WEBPACK_IMPORTED_MODULE_0__/* .pathPage.length */ .Xs.length; i++) {
        var pathItem = _constants_js__WEBPACK_IMPORTED_MODULE_0__/* .pathPage */ .Xs[i];
        var checkPath = pathItem.path.filter(function (path) { return url.indexOf(path) >= 0; });
        if (checkPath.length > 0) {
            return pathItem.page;
        }
    }
    return 'homepage';
};
var filterHTMLTag = function (text) {
    if (text === void 0) { text = ''; }
    return text !== undefined && text !== null ? text.replace(/<\/?[^>]+(>|$)/g, '') : '';
};
function generateJobUrl(jobId, alias, lang, domain, utmString) {
    if (lang === void 0) { lang = 'en'; }
    if (domain === void 0) { domain = ''; }
    if (utmString === void 0) { utmString = ''; }
    var linkJob = domain + '/' + alias + '-' + jobId;
    if (lang === 'en') {
        linkJob += '-jd';
    }
    else {
        linkJob += '-jv';
    }
    if (utmString.length > 0) {
        linkJob += '?' + utmString;
    }
    return linkJob;
}
var compareVariable = function (val1, val2) {
    return JSON.stringify(val1) === JSON.stringify(val2);
};
function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) {
        return null;
    }
    var _a = {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    }, r = _a.r, g = _a.g, b = _a.b;
    return {
        r: r,
        g: g,
        b: b,
        toString: function () {
            return [r, g, b].join(',');
        }
    };
}
function isDifferentArrayData(arr1, arr2) {
    if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
        console.trace("[isDifferentArrayData] Invalid input data ".concat(arr1, " ").concat(arr2));
        return true;
    }
    return arr1.some(function (item) { return !arr2.includes(item); }) || arr2.some(function (item) { return !arr1.includes(item); });
}
var sortArray = function (options, type, objectKey) {
    if (type === void 0) { type = 'asc'; }
    if (objectKey === void 0) { objectKey = ''; }
    if (options.length > 0) {
        switch (typeof options[0]) {
            case 'number':
                return options.sort(function (a, b) { return (type === 'asc' ? a - b : b - a); });
            case 'string':
                return options.sort(function (a, b) {
                    if (transformToLatin(a) < transformToLatin(b)) {
                        return type === 'asc' ? 1 : -1;
                    }
                    if (transformToLatin(a) > transformToLatin(b)) {
                        return type === 'asc' ? -1 : 1;
                    }
                    return 0;
                });
            case 'object': {
                var firstObject = options[0];
                switch (typeof firstObject[objectKey]) {
                    case 'number':
                        return options.sort(function (a, b) {
                            return type === 'asc' ? a[objectKey] - b[objectKey] : b[objectKey] - a[objectKey];
                        });
                    case 'string':
                        return options.sort(function (a, b) {
                            if (transformToLatin(a[objectKey]) < transformToLatin(b[objectKey])) {
                                return type === 'asc' ? -1 : 1;
                            }
                            if (transformToLatin(a[objectKey]) > transformToLatin(b[objectKey])) {
                                return type === 'asc' ? 1 : -1;
                            }
                            return 0;
                        });
                    default:
                        return [];
                }
            }
            default:
                return [];
        }
    }
    else {
        return [];
    }
};
var fixedNumber = function (number, rounding) {
    if (rounding === void 0) { rounding = 0.5; }
    var numb = Number(number);
    if (numb > 0) {
        var plusNumb = Math.abs(numb - Math.floor(numb)) < rounding ? 0 : 1;
        return Math.floor(numb) + plusNumb;
    }
    else {
        var plusNumb = Math.abs(numb - Math.ceil(numb)) < rounding ? 0 : 1;
        return Math.ceil(numb) - plusNumb;
    }
};
var textToLatin = function (text) {
    text = text.toString().toLowerCase().trim();
    var sets = [
        { to: 'a', from: '[ÀÁÂÃÄÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶἀ]' },
        { to: 'c', from: '[ÇĆĈČ]' },
        { to: 'd', from: '[ÐĎĐÞ]' },
        { to: 'e', from: '[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]' },
        { to: 'g', from: '[ĜĞĢǴ]' },
        { to: 'h', from: '[ĤḦ]' },
        { to: 'i', from: '[ÌÍÎÏĨĪĮİỈỊ]' },
        { to: 'j', from: '[Ĵ]' },
        { to: 'ij', from: '[Ĳ]' },
        { to: 'k', from: '[Ķ]' },
        { to: 'l', from: '[ĹĻĽŁ]' },
        { to: 'm', from: '[Ḿ]' },
        { to: 'n', from: '[ÑŃŅŇ]' },
        { to: 'o', from: '[ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]' },
        { to: 'oe', from: '[Œ]' },
        { to: 'p', from: '[ṕ]' },
        { to: 'r', from: '[ŔŖŘ]' },
        { to: 's', from: '[ßŚŜŞŠȘ]' },
        { to: 't', from: '[ŢŤ]' },
        { to: 'u', from: '[ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]' },
        { to: 'w', from: '[ẂŴẀẄ]' },
        { to: 'x', from: '[ẍ]' },
        { to: 'y', from: '[ÝŶŸỲỴỶỸ]' },
        { to: 'z', from: '[ŹŻŽ]' }
    ];
    sets.forEach(function (set) {
        text = text.replace(new RegExp(set.from, 'gi'), set.to);
    });
    return text;
};
function checkIfEmailInString(text) {
    var regex = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
    return regex.test(text);
}
var addrToNumber = function (addr) {
    return addr.split('.').reduce(function (acc, cur, i) { return (acc += Number(cur) << ((3 - i) * 8)); }, 0);
};
var subnetMaskToNumber = function (mask) {
    return (0xffffffff << (32 - Number(mask))) & 0xffffffff;
};
var isIPv4FromGoogle = function (userIP) {
    var googleBotIPRange = [
        '66.249.64.0/27',
        '66.249.64.128/27',
        '66.249.64.160/27',
        '66.249.64.192/27',
        '66.249.64.224/27',
        '66.249.64.32/27',
        '66.249.64.64/27',
        '66.249.64.96/27',
        '66.249.65.0/27',
        '66.249.65.128/27',
        '66.249.65.160/27',
        '66.249.65.192/27',
        '66.249.65.224/27',
        '66.249.65.32/27',
        '66.249.65.64/27',
        '66.249.65.96/27',
        '66.249.66.0/27',
        '66.249.66.128/27',
        '66.249.66.192/27',
        '66.249.66.32/27',
        '66.249.66.64/27',
        '66.249.68.0/27',
        '66.249.68.32/27',
        '66.249.68.64/27',
        '66.249.69.0/27',
        '66.249.69.128/27',
        '66.249.69.160/27',
        '66.249.69.192/27',
        '66.249.69.224/27',
        '66.249.69.32/27',
        '66.249.69.64/27',
        '66.249.69.96/27',
        '66.249.70.0/27',
        '66.249.70.128/27',
        '66.249.70.160/27',
        '66.249.70.192/27',
        '66.249.70.224/27',
        '66.249.70.32/27',
        '66.249.70.64/27',
        '66.249.70.96/27',
        '66.249.71.0/27',
        '66.249.71.128/27',
        '66.249.71.160/27',
        '66.249.71.192/27',
        '66.249.71.32/27',
        '66.249.71.64/27',
        '66.249.71.96/27',
        '66.249.72.0/27',
        '66.249.72.128/27',
        '66.249.72.160/27',
        '66.249.72.192/27',
        '66.249.72.224/27',
        '66.249.72.32/27',
        '66.249.72.64/27',
        '66.249.72.96/27',
        '66.249.73.0/27',
        '66.249.73.128/27',
        '66.249.73.160/27',
        '66.249.73.192/27',
        '66.249.73.224/27',
        '66.249.73.32/27',
        '66.249.73.64/27',
        '66.249.73.96/27',
        '66.249.74.0/27',
        '66.249.74.32/27',
        '66.249.74.64/27',
        '66.249.74.96/27',
        '66.249.75.0/27',
        '66.249.75.128/27',
        '66.249.75.160/27',
        '66.249.75.192/27',
        '66.249.75.224/27',
        '66.249.75.32/27',
        '66.249.75.64/27',
        '66.249.75.96/27',
        '66.249.76.0/27',
        '66.249.76.128/27',
        '66.249.76.160/27',
        '66.249.76.192/27',
        '66.249.76.224/27',
        '66.249.76.32/27',
        '66.249.76.64/27',
        '66.249.76.96/27',
        '66.249.77.0/27',
        '66.249.77.128/27',
        '66.249.77.32/27',
        '66.249.77.64/27',
        '66.249.77.96/27',
        '66.249.79.0/27',
        '66.249.79.128/27',
        '66.249.79.160/27',
        '66.249.79.192/27',
        '66.249.79.224/27',
        '66.249.79.32/27',
        '66.249.79.64/27',
        '66.249.79.96/27',
        '66.249.91.0/27'
    ];
    var isFromGoogle = false;
    // Loop through all CIDR from google IPv4 to find match IP
    googleBotIPRange.map(function (cidr) {
        var _a = cidr.split('/'), networkAddr = _a[0], subnetMask = _a[1];
        var match = (addrToNumber(userIP) & subnetMaskToNumber(subnetMask)) === addrToNumber(networkAddr);
        if (match) {
            isFromGoogle = true;
        }
    });
    return isFromGoogle;
};
// For IPv6
var isIPv6FromGoogle = function (userIP) {
    var isFromGoogle = false;
    // TODO: Loop through all CIDR from google IPv6 to find match IP
    // IPv6 is not support yet
    return isFromGoogle;
};
/**
 * Check user IP address if it is a bot or not
 * @param userIP string
 */
var isIPFromGoogleBot = function (userIP) {
    if (userIP.length === 0) {
        return false;
    }
    var isFromGoogle = false;
    for (var i = 0; i < userIP.length; i++) {
        if (!userIP[i]) {
            continue;
        }
        var isIPv4 = userIP[i].indexOf('.') > 0;
        var userIPSplitted = isIPv4 ? userIP[i].split('.') : userIP[i].split(':');
        if (isIPv4 && userIPSplitted[0] === '66' && userIPSplitted[1] === '249') {
            isFromGoogle = isIPv4FromGoogle(userIP[i]);
        }
        else if (!isIPv4 &&
            userIPSplitted.length > 1 &&
            userIPSplitted[0] === '2001' &&
            userIPSplitted[1] === '4860' &&
            userIPSplitted[2] === '4801') {
            isFromGoogle = isIPv6FromGoogle(userIP[i]);
        }
    }
    return isFromGoogle;
};
/**
 * Check a user-agent if it's a robot
 * @param userAgent
 */
var isRobot = function (userAgent, userIP) {
    var botUserAgents = [
        'googlebot',
        'google-structured-data-testing-tool',
        'bingbot',
        'linkedinbot',
        'mediapartners-google',
        'apis-google',
        'feedfetcher-google',
        'googlebot-image',
        'storebot-google',
        'adsBot-google-mobile',
        'adsBot-google-mobile-apps',
        'adsBot-google',
        'googlebot-news',
        'googlebot-video',
        'storebot-google'
    ];
    var currentUserAgent = userAgent.toLowerCase();
    var isBot = botUserAgents.some(function (item) {
        return currentUserAgent.includes(item);
    });
    // Detect IP from Google bot
    // Only call detect IP when isBot = false (For better performance)
    if (!isBot && userIP !== undefined) {
        isBot = isIPFromGoogleBot(userIP);
    }
    return isBot;
};
var isCompanyWhitelisted = function (props) {
    var companyId = props.companyId, appMode = props.appMode;
    // staging
    if (appMode === 'staging') {
        return NAVIGOS_COMPANY_ID.staging.includes(companyId);
    }
    // release
    if (appMode === 'release') {
        return NAVIGOS_COMPANY_ID.release.includes(companyId);
    }
    // production
    return NAVIGOS_COMPANY_ID.production.includes(companyId);
};
/**
 * Return Random UID - @SangNguyen
 * @returns unique id (Ex: rand-bdc08475-7af48ce5-9da0d3be)
 */
var randomId = function () {
    var s4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    return "rand-".concat(s4()).concat(s4(), "-").concat(s4()).concat(s4(), "-").concat(s4()).concat(s4());
};
/**
 * Check values change
 * @param firstLocations first item locations need to compare
 * @param secondLocations second item locations need to compare
 * @returns boolean true when 2 variables is different
 */
function isLocationChanged(firstLocations, secondLocations) {
    var _a, _b, _c, _d, _e, _f;
    // parents is have more or less item
    if (firstLocations.length !== secondLocations.length) {
        return true;
    }
    var _loop_1 = function (i) {
        var currentItem = firstLocations[i];
        var filtered = secondLocations.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.parentId) === (currentItem === null || currentItem === void 0 ? void 0 : currentItem.parentId); });
        // length match then detect child item
        // second item doesn't have item that first item have
        if (filtered.length === 0) {
            return { value: true };
        }
        // Child is have more or less selected
        if (((_b = (_a = filtered[0]) === null || _a === void 0 ? void 0 : _a.childrenIds) === null || _b === void 0 ? void 0 : _b.length) !== ((_c = currentItem === null || currentItem === void 0 ? void 0 : currentItem.childrenIds) === null || _c === void 0 ? void 0 : _c.length)) {
            return { value: true };
        }
        var _loop_2 = function (j) {
            var childId = currentItem === null || currentItem === void 0 ? void 0 : currentItem.childrenIds[j];
            var filteredChild = (_f = (_e = filtered[0]) === null || _e === void 0 ? void 0 : _e.childrenIds) === null || _f === void 0 ? void 0 : _f.filter(function (childItemId) { return childItemId === childId; });
            if (filteredChild.length === 0) {
                return { value: true };
            }
        };
        // length does match need to compare child
        for (var j = 0; j < ((_d = currentItem === null || currentItem === void 0 ? void 0 : currentItem.childrenIds) === null || _d === void 0 ? void 0 : _d.length); j++) {
            var state_2 = _loop_2(j);
            if (typeof state_2 === "object")
                return state_2;
        }
    };
    // Check districts
    for (var i = 0; i < firstLocations.length; i++) {
        var state_1 = _loop_1(i);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return false;
}
function formatSalary(_a, isShowSalary, language) {
    var min = _a.min, max = _a.max;
    if (!isShowSalary) {
        return language === 'en' ? 'Negotiate' : 'Thương Lượng';
    }
    if (min > 0 && max > 0) {
        return "$".concat(min, " - $").concat(max);
    }
    if (min > 0) {
        return "".concat(language === 'en' ? 'From' : 'Từ', " $").concat(min);
    }
    if (max > 0) {
        return "".concat(language === 'en' ? 'Up To' : 'Tới', " $").concat(max);
    }
    return '';
}
function isVietnamese(text) {
    return /[\u0300-\u036f]|[đĐ]/gi.test(text.normalize('NFD'));
}
function createTranslator(_a) {
    var translations = _a.translations, defaultLanguage = _a.defaultLanguage, currentLanguage = _a.currentLanguage;
    var firstEntry = null;
    var detectedDefaultLanguage = defaultLanguage;
    if (!detectedDefaultLanguage) {
        for (var _i = 0, _b = Object.entries(translations); _i < _b.length; _i++) {
            var _c = _b[_i], keyText = _c[0], valueText = _c[1];
            if (!firstEntry) {
                firstEntry = [keyText, valueText];
            }
            if (isVietnamese(keyText)) {
                detectedDefaultLanguage = ELanguage.VI;
                break;
            }
            if (isVietnamese(valueText)) {
                detectedDefaultLanguage = ELanguage.EN;
                break;
            }
        }
    }
    if (!detectedDefaultLanguage) {
        console.warn("Cannot detect default language from provided dictionary. First entry is \"".concat(firstEntry, "\""));
        console.warn("Fallback to English as default language");
        detectedDefaultLanguage = ELanguage.EN;
    }
    return function (text, replacement) {
        if (!text) {
            return '';
        }
        var matchedText = currentLanguage === detectedDefaultLanguage ? text : translations[text];
        if (!matchedText) {
            matchedText = text;
        }
        return replacement
            ? Object.keys(replacement).reduce(function (acc, key) { return acc.replace(new RegExp(key, 'g'), replacement[key].toString()); }, matchedText)
            : matchedText;
    };
}
// this fnc using when not using state in input => using custom debounce
// for example in Form management
function debounceHandler(func, delay) {
    var timer;
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timer);
        timer = setTimeout(function () {
            func.apply(_this, args);
        }, delay);
    };
}
function attachQueryParamToUrl(url, params) {
    if (!Object.keys(params).length) {
        return url;
    }
    var urlEntity = new URL(url);
    for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (value === undefined) {
            urlEntity.searchParams.delete(key);
            continue;
        }
        if ((typeof value === 'object' && !Array.isArray(value)) || Number.isNaN(value)) {
            continue;
        }
        urlEntity.searchParams.set(key, value);
    }
    return urlEntity.toString();
}
function extractFileNameAndExtension(fileName) {
    var lastDotIndex = fileName === null || fileName === void 0 ? void 0 : fileName.lastIndexOf('.');
    var name = fileName === null || fileName === void 0 ? void 0 : fileName.slice(0, lastDotIndex);
    var extension = fileName === null || fileName === void 0 ? void 0 : fileName.slice(lastDotIndex + 1);
    return [name, extension];
}
function downloadAttachFile(params) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var resumeId, accessToken, msBaseUrl, fileName, _b, downloadRequest, _c, body, _d, onOpenOrDownload_1, docExtensions, pdfMineType, API_DOWNLOAD_CV, requestOptions, response, blob, file_1, _e, extractedFilename_1, fileExtension_1, responseMineType, requestState, download, openNewTab, ex_1;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 3, , 4]);
                    resumeId = params.resumeId, accessToken = params.accessToken, msBaseUrl = params.msBaseUrl, fileName = params.fileName, _b = params.downloadRequest, downloadRequest = _b === void 0 ? 'all' : _b, _c = params.body, body = _c === void 0 ? null : _c, _d = params.onOpenOrDownload, onOpenOrDownload_1 = _d === void 0 ? null : _d;
                    if (!accessToken) {
                        return [2 /*return*/];
                    }
                    docExtensions = ['docx', 'doc'];
                    pdfMineType = 'application/pdf';
                    API_DOWNLOAD_CV = "".concat(msBaseUrl, "/api-gateway/v1.0/profile/resume-file/").concat(resumeId);
                    requestOptions = {
                        method: 'POST',
                        headers: {
                            Authorization: "Bearer ".concat(accessToken)
                        }
                    };
                    if (body !== null) {
                        requestOptions.headers['Content-Type'] = 'application/json';
                        requestOptions.body = JSON.stringify(body);
                    }
                    return [4 /*yield*/, fetch(API_DOWNLOAD_CV, requestOptions)];
                case 1:
                    response = _f.sent();
                    return [4 /*yield*/, response.blob()];
                case 2:
                    blob = _f.sent();
                    file_1 = window.URL.createObjectURL(blob);
                    _e = extractFileNameAndExtension(fileName), extractedFilename_1 = _e[0], fileExtension_1 = _e[1];
                    responseMineType = (_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a.get('Content-Type');
                    requestState = downloadRequest;
                    if (docExtensions.includes(fileExtension_1) && responseMineType !== pdfMineType) {
                        requestState = 'download';
                    }
                    download = function () {
                        var a = document.createElement('a');
                        a.href = file_1;
                        a.download = transformToLatin("".concat(extractedFilename_1, ".").concat(fileExtension_1));
                        a.click();
                        onOpenOrDownload_1 && onOpenOrDownload_1();
                    };
                    openNewTab = function () {
                        onOpenOrDownload_1 && onOpenOrDownload_1();
                        if (typeof window === 'undefined') {
                            return;
                        }
                        window.open(file_1, '_blank');
                    };
                    switch (requestState) {
                        case 'download':
                            download();
                            break;
                        case 'new-window':
                            openNewTab();
                            break;
                        case 'all':
                        default:
                            download();
                            openNewTab();
                            break;
                    }
                    return [3 /*break*/, 4];
                case 3:
                    ex_1 = _f.sent();
                    console.error('Error when download file', ex_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var ACCESS_TOKEN_LENGTH = 86;
var detectEncryptAccessToken = function (accessToken) {
    // If access token length is larger than 86 characters
    // then it should be decrypted
    return accessToken.length === ACCESS_TOKEN_LENGTH ? accessToken : decrypt(accessToken !== null && accessToken !== void 0 ? accessToken : '');
};
function getiOSVersion() {
    if (typeof window === 'undefined') {
        return -2;
    }
    var userAgent = window.navigator.userAgent;
    var match = userAgent.match(/(iPad|iPhone|iPod)\s+OS\s+(\d+)/);
    if (!match) {
        // Not iOS
        return -2;
    }
    if (match && match[2]) {
        var versionInNumber = Number(match[2]);
        if (isNaN(versionInNumber)) {
            return -1;
        }
        return versionInNumber;
    }
    // -1 is standing for Unknown
    return -1;
}
function isPrivateIP(ip) {
    // Localhost range
    var privateRanges = [
        { start: '10.0.0.0', end: '10.255.255.255' },
        { start: '172.16.0.0', end: '172.31.255.255' },
        { start: '192.168.0.0', end: '192.168.255.255' },
        { start: '127.0.0.0', end: '127.255.255.255' }
    ];
    var ipToNumber = function (ip) {
        return ip.split('.').reduce(function (acc, octet) { return acc * 256 + parseInt(octet, 10); }, 0);
    };
    var ipNumber = ipToNumber(ip.trim());
    return privateRanges.some(function (range) {
        return ipNumber >= ipToNumber(range.start) && ipNumber <= ipToNumber(range.end);
    });
}
var filterPrivateIP = function (ipList) {
    // Filter out all Fortiweb IP
    var filteredNotFortiweb = ipList.filter(function (ip) { return !FORTIWEB_IP.includes(ip); });
    // Filter out all private IP
    var filteredPublic = filteredNotFortiweb.filter(function (ip) { return !isPrivateIP(ip); });
    if (filteredPublic.length > 0) {
        return filteredPublic;
    }
    // If no public IP remain then return filtered not fortiweb
    return filteredNotFortiweb;
};
function filterObjectArrayBasedOnObjectArray(targetArray, filterArray, key, omit) {
    var filterArrayKeys = filterArray.map(function (item) { return item[key]; });
    if (omit && omit.length > 0) {
        filterArrayKeys = filterArrayKeys.concat(omit);
    }
    return targetArray.filter(function (item) { return !filterArrayKeys.includes(item[key]); });
}
function quickFilterByKeywords(options, keywords, fieldSearch) {
    var cpOptions = __spreadArray([], options, true);
    return cpOptions.filter(function (option) {
        if (keywords === '') {
            return true;
        }
        return transformToLatin(option[fieldSearch]).indexOf(transformToLatin(keywords)) > -1;
    });
}
function locationsMappingHelperForMultiLevelSelect(countries, cities, districts, langcode) {
    var mappedVietNamCities = [];
    cities.forEach(function (city) {
        if (districts[city.id]) {
            var result = __assign(__assign({}, city), { name: langcode === ELanguage.VI ? city.name : city.nameEn, children: districts[city.id].map(function (district) { return (__assign(__assign({}, district), { name: langcode === ELanguage.VI ? district.name : district.nameEn })); }) });
            mappedVietNamCities.push(result);
        }
        else {
            mappedVietNamCities.push(__assign(__assign({}, city), { name: langcode === ELanguage.VI ? city.name : city.nameEn }));
        }
    });
    mappedVietNamCities = mappedVietNamCities.filter(function (city) { return city.id !== INTERNATIONAL_CITY_ID; });
    var mappedCountries = [];
    countries.forEach(function (country) {
        if (country.id === VIETNAM_COUNTRY_ID) {
            var result = __assign(__assign({}, country), { name: langcode === ELanguage.VI ? country.name : country.nameEn, children: mappedVietNamCities });
            mappedCountries.push(result);
        }
        else {
            var result = __assign(__assign({}, country), { name: langcode === ELanguage.VI ? country.name : country.nameEn });
            mappedCountries.push(result);
        }
    });
    return mappedCountries;
}
/**
 * Deeply merge two or more objects
 * @param  {...object} objects - Objects to merge
 */
function deepMerge() {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    var target = {};
    var merge = function (obj) {
        for (var prop in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                if (obj[prop] === null || obj[prop] === undefined) {
                    continue;
                }
                if (typeof obj[prop] === 'object' && !Array.isArray(obj[prop])) {
                    target[prop] = deepMerge(target[prop], obj[prop]);
                }
                else if (typeof obj[prop] === 'object' && Array.isArray(obj[prop])) {
                    target[prop] = __spreadArray(__spreadArray([], (target[prop] || []), true), (obj[prop] || []), true);
                }
                else {
                    target[prop] = obj[prop];
                }
            }
        }
    };
    objects.forEach(function (object) { return merge(object); });
    return target;
}


//# sourceMappingURL=helpers.js.map


/***/ }),

/***/ 53417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tq": function() { return /* binding */ isMobile; }
/* harmony export */ });
/* unused harmony exports isDesktop, isPhone, isTablet, isTouch, screens */
'use client';

/**
 * Consolidated Responsive Helpers
 * All responsive detection functions in one place
 */
function isPhone() {
    if (typeof window !== 'undefined') {
        return window.innerWidth < 768;
    }
    return false;
}
function isMobile() {
    // Alias for isPhone - using < 768 for consistency
    return isPhone();
}
function isTablet() {
    if (typeof window !== 'undefined') {
        return window.innerWidth >= 768 && window.innerWidth < 992;
    }
    return false;
}
function isTouch() {
    if (typeof window !== 'undefined') {
        return window.innerWidth < 992;
    }
    return false;
}
function isDesktop() {
    if (typeof window !== 'undefined') {
        return window.innerWidth >= 992;
    }
    return false;
}
var screens = {
    mobile: 768,
    tablet: 991
};


//# sourceMappingURL=responsiveHelper.js.map


/***/ }),

/***/ 22365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "eW": function() { return /* binding */ callTrackingUTM; }
/* harmony export */ });
/* unused harmony exports formatCanonicalUrl, getUrlParameter */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74982);
'use client';



var getUrlParameter = function (url, name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(url);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
var callTrackingUTM = function (event, apiLink) {
    var getFiltersFromNaviCMS = function (form) { return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(void 0, void 0, void 0, function () {
        var response;
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__generator */ .Jh)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(apiLink, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(form)
                    })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var form = {
        utm_source: '',
        utm_campaign: '',
        utm_medium: '',
        utm_content: '',
        utm_term: ''
    };
    var element = event.currentTarget;
    form.utm_source = getUrlParameter(element.href, 'utm_source');
    form.utm_campaign = getUrlParameter(element.href, 'utm_campaign');
    form.utm_medium = getUrlParameter(element.href, 'utm_medium');
    form.utm_content = getUrlParameter(element.href, 'utm_content');
    form.utm_term = getUrlParameter(element.href, 'utm_term');
    if (!form.utm_source)
        form.utm_source = getUrlParameter(element.href, 'utm_source_navi');
    if (!form.utm_campaign)
        form.utm_campaign = getUrlParameter(element.href, 'utm_campaign_navi');
    if (!form.utm_medium)
        form.utm_medium = getUrlParameter(element.href, 'utm_medium_navi');
    if (!form.utm_content)
        form.utm_content = getUrlParameter(element.href, 'utm_content_navi');
    if (!form.utm_term)
        form.utm_term = getUrlParameter(element.href, 'utm_term_navi');
    getFiltersFromNaviCMS(form);
};
var formatCanonicalUrl = function (url) {
    var urlFormat = url.split('?')[0];
    // remove '/' if it's final word, www.vietnamworks.com/hcm-kw/ -> www.vietnamworks.com/hcm-kw
    return urlFormat.replace(/\/$/, '');
};


//# sourceMappingURL=utmTracking.js.map


/***/ }),

/***/ 83773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ZaloWidget; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(74982);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/ZaloWidget/styles.js
'use client';




var ZaloWidgetContainer = styled_components_browser_esm/* default.a */.ZP.a(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: fixed;\n    z-index: 99;\n    bottom: 165px;\n    right: 20px;\n    width: 60px;\n    height: 60px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: white;\n    border-radius: 50%;\n    box-shadow: rgb(0 0 0 / 20%) 0px 0px 6px 0px;\n\n    @media (max-width: 769px) {\n        right: 10px;\n        bottom: 100px;\n    }\n"], ["\n    position: fixed;\n    z-index: 99;\n    bottom: 165px;\n    right: 20px;\n    width: 60px;\n    height: 60px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: white;\n    border-radius: 50%;\n    box-shadow: rgb(0 0 0 / 20%) 0px 0px 6px 0px;\n\n    @media (max-width: 769px) {\n        right: 10px;\n        bottom: 100px;\n    }\n"])));
var templateObject_1;


//# sourceMappingURL=styles.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/ZaloWidget/ZaloIcon.js
'use client';



var ZaloIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 50 : _b;
    return ((0,jsx_runtime.jsxs)("svg", { width: size, height: size, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: [(0,jsx_runtime.jsx)("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M22.782.166h4.417c6.066 0 9.611.891 12.758 2.578 3.147 1.687 5.63 4.152 7.299 7.299 1.687 3.147 2.578 6.692 2.578 12.758v4.398c0 6.066-.891 9.611-2.578 12.758-1.688 3.147-4.152 5.63-7.299 7.299-3.147 1.687-6.692 2.578-12.758 2.578h-4.398c-6.066 0-9.611-.89-12.758-2.578-3.147-1.687-5.63-4.152-7.299-7.299C1.057 36.81.166 33.265.166 27.2v-4.398c0-6.066.891-9.611 2.578-12.758 1.687-3.147 4.152-5.63 7.299-7.299C13.17 1.057 16.735.166 22.782.166Z', fill: '#0068FF' }), (0,jsx_runtime.jsx)("path", { opacity: 0.12, fillRule: 'evenodd', clipRule: 'evenodd', d: 'M49.834 26.474v.725c0 6.067-.891 9.612-2.579 12.759-1.687 3.147-4.151 5.63-7.298 7.298-3.147 1.687-6.692 2.578-12.758 2.578H22.8c-4.964 0-8.24-.596-10.99-1.737l-4.536-4.67 42.559-16.953Z', fill: '#001A33' }), (0,jsx_runtime.jsx)("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M7.779 43.59c2.323.256 5.227-.406 7.29-1.408 8.954 4.95 22.95 4.713 31.423-.709a18.69 18.69 0 0 0 .92-1.537C49.107 36.778 50 33.22 50 27.132v-4.415c0-6.088-.894-9.646-2.587-12.804-1.674-3.159-4.167-5.632-7.325-7.325C36.929.894 33.37 0 27.283 0H22.85c-5.186 0-8.552.653-11.38 1.899-.155.138-.306.28-.455.422-8.298 8-8.928 25.338-1.892 34.757a.631.631 0 0 0 .026.042c1.084 1.599.038 4.395-1.598 6.032-.267.247-.172.4.228.437Z', fill: '#fff' }), (0,jsx_runtime.jsx)("path", { d: 'M20.563 17h-9.725v2.085h6.749l-6.654 8.247c-.209.303-.36.587-.36 1.232v.53h9.175a.84.84 0 0 0 .834-.833v-1.119h-7.09l6.256-7.848c.095-.114.265-.322.341-.417l.038-.057c.36-.53.436-.986.436-1.536V17Zm12.379 12.095h1.383V17H32.24v11.393a.7.7 0 0 0 .702.702Zm-7.128-9.403a4.741 4.741 0 0 0-4.74 4.74 4.741 4.741 0 0 0 4.74 4.739 4.741 4.741 0 0 0 4.74-4.74c.018-2.615-2.105-4.739-4.74-4.739Zm0 7.526a2.791 2.791 0 0 1-2.787-2.786 2.791 2.791 0 0 1 2.787-2.787 2.791 2.791 0 0 1 2.787 2.787 2.78 2.78 0 0 1-2.787 2.786Zm14.673-7.602a4.781 4.781 0 0 0-4.778 4.777 4.781 4.781 0 0 0 4.778 4.778 4.782 4.782 0 0 0 4.777-4.778 4.782 4.782 0 0 0-4.777-4.777Zm0 7.602a2.8 2.8 0 0 1-2.806-2.806 2.8 2.8 0 0 1 2.806-2.805 2.8 2.8 0 0 1 2.805 2.805 2.8 2.8 0 0 1-2.805 2.806Z', fill: '#0068FF' }), (0,jsx_runtime.jsx)("path", { d: 'M29.456 29.094h1.119v-9.137h-1.953v8.322c0 .436.38.815.834.815Z', fill: '#0068FF' })] }));
};


//# sourceMappingURL=ZaloIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/ZaloWidget/index.js
'use client';






function ZaloWidget(_a) {
    var oaid = _a.oaid, className = _a.className;
    var _b = (0,react.useState)(false), isClient = _b[0], setIsClient = _b[1];
    var ZALO_LINK = "https://zalo.me/".concat(oaid);
    (0,react.useEffect)(function () {
        setIsClient(true);
    }, []);
    return isClient ? ((0,jsx_runtime.jsx)(ZaloWidgetContainer, { "aria-label": 'chat with vietnamworks', href: ZALO_LINK, target: '_blank', className: "zalo-widget ".concat(className), children: (0,jsx_runtime.jsx)(ZaloIcon, { size: 44 }) })) : null;
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 74982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jh": function() { return /* binding */ __generator; },
/* harmony export */   "ZT": function() { return /* binding */ __extends; },
/* harmony export */   "_T": function() { return /* binding */ __rest; },
/* harmony export */   "cy": function() { return /* binding */ __makeTemplateObject; },
/* harmony export */   "ev": function() { return /* binding */ __spreadArray; },
/* harmony export */   "mG": function() { return /* binding */ __awaiter; },
/* harmony export */   "pi": function() { return /* binding */ __assign; }
/* harmony export */ });
'use client';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};


//# sourceMappingURL=_tslib.js.map


/***/ }),

/***/ 11908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useClickAway; }
/* harmony export */ });
/* unused harmony export useOnClickOutside */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



/**
 * Consolidated click outside hook
 * Supports both useClickAway and useOnClickOutside patterns
 *
 * @example
 * // Pattern 1: Returns ref (useClickAway style)
 * const ref = useClickAway(() => handleClose())
 *
 * // Pattern 2: Uses existing ref (useOnClickOutside style)
 * const ref = useRef<HTMLDivElement>(null)
 * useClickAway(() => handleClose(), { ref })
 */
function useClickAway(handler, options) {
    var _a = options || {}, nodeRefs = _a.nodeRefs, _b = _a.event, event = _b === void 0 ? 'mouseup' : _b, _c = _a.useWindow, useWindow = _c === void 0 ? false : _c;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var listener = function (e) {
            var target = (e !== null && e !== void 0 ? e : {}).target;
            // Support multiple refs pattern
            if (Array.isArray(nodeRefs)) {
                var shouldIgnore = !document.body.contains(target) && target.tagName !== 'HTML';
                var shouldTrigger = nodeRefs.every(function (ref) {
                    if (ref.current) {
                        return !e.composedPath().includes(ref.current);
                    }
                    return false;
                });
                if (shouldTrigger && !shouldIgnore) {
                    handler(e);
                }
            }
            // Support single ref pattern (useOnClickOutside style)
            else if (ref.current && !ref.current.contains(target)) {
                handler(e);
            }
        };
        var target = useWindow ? window : document;
        target.addEventListener(event, listener, { passive: true });
        return function () {
            target.removeEventListener(event, listener);
        };
    }, [event, handler, nodeRefs, useWindow]);
    return ref;
}
/**
 * Compatibility wrapper for useOnClickOutside pattern
 * @deprecated Use useClickAway with useWindow option instead
 */
function useOnClickOutside(ref, handler, mouseEvent) {
    if (mouseEvent === void 0) { mouseEvent = 'mousedown'; }
    useEffect(function () {
        var handleClick = function (event) {
            var el = ref === null || ref === void 0 ? void 0 : ref.current;
            if (!el || el.contains(event.target)) {
                return;
            }
            handler(event);
        };
        window.addEventListener(mouseEvent, handleClick);
        return function () {
            window.removeEventListener(mouseEvent, handleClick);
        };
    }, [ref, handler, mouseEvent]);
}


//# sourceMappingURL=useClickAway.js.map


/***/ }),

/***/ 59523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useDropdownAnimation; }
/* harmony export */ });
/* harmony import */ var _useTransition_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81781);
'use client';



function useDropdownAnimation(open, placement) {
    var side = placement.split('-')[0];
    var _a = (0,_useTransition_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        open: open,
        args: {
            side: side
        }
    }, {
        initial: function (_a) {
            var side = _a.side;
            return {
                opacity: 0,
                transform: 'scaleY(0)',
                transformOrigin: side === 'top' ? 'bottom' : 'top'
            };
        },
        enter: function (_a) {
            var side = _a.side;
            return {
                opacity: 1,
                transform: 'scaleY(1)',
                transformOrigin: side === 'top' ? 'bottom' : 'top'
            };
        },
        leave: function (_a) {
            var side = _a.side;
            return {
                opacity: 0,
                transform: 'scaleY(0)',
                transformOrigin: side === 'top' ? 'bottom' : 'top'
            };
        }
    }), isMounted = _a.isMounted, styles = _a.styles;
    return { isMounted: isMounted, styles: styles };
}


//# sourceMappingURL=useDropdownAnimation.js.map


/***/ }),

/***/ 88904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useFloating; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useFloating/helpers/use-isomorphic-layout-effect.js
'use client';



var useIsomorphicLayoutEffect = typeof window === 'undefined' ? react.useEffect : react.useLayoutEffect;


//# sourceMappingURL=use-isomorphic-layout-effect.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useFloating/helpers/isAbsolutePositioning.js
'use client';

function isAbsolutePositioning(element) {
    var position = window.getComputedStyle(element).position;
    return position === 'absolute';
}


//# sourceMappingURL=isAbsolutePositioning.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useFloating/helpers/isBodyElement.js
'use client';

function isBodyElement(element) {
    return element === document.body;
}


//# sourceMappingURL=isBodyElement.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useFloating/helpers/isDocumentElement.js
'use client';

function isDocumentElement(element) {
    return element === document.documentElement || element instanceof Document;
}


//# sourceMappingURL=isDocumentElement.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useFloating/helpers/isOverflowSet.js
'use client';

function isOverflowSet(overflowValue) {
    return (overflowValue === 'auto' ||
        overflowValue === 'hidden' ||
        overflowValue === 'scroll' ||
        overflowValue === 'overlay');
}


//# sourceMappingURL=isOverflowSet.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useFloating/helpers/getScrollableParents.js
'use client';






var getScrollableParents = function (element, containers) {
    if (containers === void 0) { containers = new Set(); }
    if (isDocumentElement(element) || isBodyElement(element)) {
        containers.add(window);
    }
    else {
        var computedStyle = window.getComputedStyle(element);
        if (isOverflowSet(computedStyle.overflow) ||
            isOverflowSet(computedStyle.overflowX) ||
            isOverflowSet(computedStyle.overflowY)) {
            if (!isAbsolutePositioning(element)) {
                containers.add(element);
            }
        }
    }
    if (element.parentNode) {
        getScrollableParents(element.parentNode, containers);
    }
    return containers;
};


//# sourceMappingURL=getScrollableParents.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/Utils/deepEqual.js
'use client';

/*
 * Forked of https://github.com/epoberezkin/fast-deep-equal
 * Consolidated from multiple duplicate implementations
 */
function deepEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (typeof a !== typeof b) {
        return false;
    }
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        if (a.constructor !== b.constructor) {
            return false;
        }
        var length_1, i = void 0;
        if (Array.isArray(a)) {
            length_1 = a.length;
            if (length_1 !== b.length) {
                return false;
            }
            for (i = length_1; i-- !== 0;) {
                if (!deepEqual(a[i], b[i])) {
                    return false;
                }
            }
            return true;
        }
        var keys = Object.keys(a);
        length_1 = keys.length;
        if (length_1 !== Object.keys(b).length) {
            return false;
        }
        for (i = length_1; i-- !== 0;) {
            if (!{}.hasOwnProperty.call(b, keys[i])) {
                return false;
            }
        }
        for (i = length_1; i-- !== 0;) {
            var key = keys[i];
            if (key === '_owner' && a.$$typeof) {
                continue;
            }
            if (!deepEqual(a[key], b[key])) {
                return false;
            }
        }
        return true;
    }
    return a !== a && b !== b;
}


//# sourceMappingURL=deepEqual.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useFloating/helpers/getElementClientRect.js
'use client';

function getElementClientRect(element) {
    if (element instanceof Window) {
        var width_1 = window.innerWidth;
        var height_1 = window.innerHeight;
        return {
            width: width_1,
            height: height_1,
            top: 0,
            left: 0,
            bottom: height_1,
            right: width_1,
            x: 0,
            y: height_1
        };
    }
    var _a = element.getBoundingClientRect(), x = _a.x, y = _a.y, width = _a.width, height = _a.height, top = _a.top, bottom = _a.bottom, left = _a.left, right = _a.right;
    return {
        x: x,
        y: y,
        width: width,
        height: height,
        top: top,
        bottom: bottom,
        left: left,
        right: right
    };
}


//# sourceMappingURL=getElementClientRect.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useFloating/core/flip.js
'use client';




function getOpositePlacement(placement) {
    switch (placement) {
        case 'top-start':
            return 'bottom-start';
        case 'top':
            return 'bottom';
        case 'top-end':
            return 'bottom-end';
        case 'right-start':
            return 'left-start';
        case 'right':
            return 'left';
        case 'right-end':
            return 'left-end';
        case 'left-start':
            return 'right-start';
        case 'left':
            return 'right';
        case 'left-end':
            return 'right-end';
        case 'bottom-start':
            return 'top-start';
        case 'bottom':
            return 'top';
        case 'bottom-end':
            return 'top-end';
    }
}
function shouldFlip(_a) {
    var placement = _a.placement, offset = _a.offset, referenceRect = _a.referenceRect, popupRect = _a.popupRect, scrollableParent = _a.scrollableParent;
    var scrollableParentRect = getElementClientRect(scrollableParent);
    var popupHeight = popupRect.height;
    var referenceHeight = referenceRect.height;
    var popupWidth = popupRect.width;
    var referenceWidth = referenceRect.width;
    /*
     * Calculate the top, right bottom, left of popup if it touch the limit
     * of scrollable parent
     * */
    var top = referenceRect.y - (popupHeight + offset);
    var bottom = referenceRect.y + referenceHeight + popupHeight + offset;
    var left = referenceRect.x - popupWidth - offset;
    var right = referenceRect.x + referenceWidth + popupWidth + offset;
    switch (placement) {
        case 'top-start':
        case 'top':
        case 'top-end':
            return top < scrollableParentRect.top;
        case 'bottom-start':
        case 'bottom':
        case 'bottom-end':
            return bottom > scrollableParentRect.bottom;
        case 'left-start':
        case 'left':
        case 'left-end':
            return left < scrollableParentRect.left;
        case 'right-start':
        case 'right':
        case 'right-end':
            return right > scrollableParentRect.right;
    }
}
function flip(_a) {
    var reference = _a.reference, popup = _a.popup, scrollableParents = _a.scrollableParents, placement = _a.placement, popupConfigs = _a.popupConfigs;
    var _b = popupConfigs || {}, _c = _b.offset, offset = _c === void 0 ? 0 : _c, _d = _b.isFlip, isFlip = _d === void 0 ? true : _d, _e = _b.useWindowAsFlippingContainer, useWindowAsFlippingContainer = _e === void 0 ? false : _e;
    /*
     * Return immediately if flip doesn't enable
     * */
    if (!isFlip || scrollableParents.size === 0) {
        return placement;
    }
    var returnPlacement = placement;
    var getScrollableParents = scrollableParents;
    if (useWindowAsFlippingContainer) {
        getScrollableParents = new Set([window]);
    }
    var referenceRect = reference.getBoundingClientRect();
    var popupRect = popup.getBoundingClientRect();
    getScrollableParents.forEach(function (scrollableParent) {
        if (shouldFlip({
            placement: placement,
            referenceRect: referenceRect,
            popupRect: popupRect,
            offset: offset,
            scrollableParent: scrollableParent
        })) {
            returnPlacement = getOpositePlacement(placement);
        }
    });
    return returnPlacement;
}


//# sourceMappingURL=flip.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useFloating/helpers/getElementClientRectByPosition.js
'use client';

function getElementClientRectByPosition(element, position) {
    if (element instanceof Window) {
        var width_1 = window.innerWidth;
        var height_1 = window.innerHeight;
        return {
            width: width_1,
            height: height_1,
            top: 0,
            left: 0,
            bottom: height_1,
            right: width_1,
            x: 0,
            y: height_1
        };
    }
    var _a = element.getBoundingClientRect(), _x = _a.x, _y = _a.y, width = _a.width, height = _a.height;
    var isFixed = position === 'fixed';
    var offsetTop = element.offsetTop;
    var offsetLeft = element.offsetLeft;
    var x = isFixed ? _x : offsetLeft;
    var y = isFixed ? _y : offsetTop;
    var top = y;
    var left = x;
    var right = x + width;
    var bottom = y + height;
    return {
        x: x,
        y: y,
        width: width,
        height: height,
        top: top,
        bottom: bottom,
        left: left,
        right: right
    };
}


//# sourceMappingURL=getElementClientRectByPosition.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useFloating/core/getPosition.js
'use client';




function getPosition(options) {
    var placement = options.placement, position = options.position, reference = options.reference, popup = options.popup, popupConfigs = options.popupConfigs, shiftValues = options.shiftValues;
    var _a = (popupConfigs || {}).offset, offset = _a === void 0 ? 0 : _a;
    var referenceRect = getElementClientRectByPosition(reference, position);
    var popupRect = getElementClientRectByPosition(popup, position);
    var xPos = referenceRect.x;
    var yPos = referenceRect.y;
    var referenceHeight = referenceRect.height;
    var referenceWidth = referenceRect.width;
    var popupHeight = popupRect.height;
    var popupWidth = popupRect.width;
    var returnPosition = {
        x: 0,
        y: 0
    };
    /*
     * Calculate y position
     * */
    switch (placement) {
        case 'top-start':
        case 'top':
        case 'top-end':
            returnPosition.y = yPos - (popupHeight + offset);
            break;
        case 'bottom-start':
        case 'bottom':
        case 'bottom-end':
            returnPosition.y = yPos + referenceHeight + offset;
            break;
        case 'left-start':
        case 'right-start':
            returnPosition.y = yPos;
            break;
        case 'left':
        case 'right':
            returnPosition.y = yPos + referenceHeight / 2 - popupHeight / 2;
            break;
        case 'left-end':
        case 'right-end':
            returnPosition.y = yPos + referenceHeight - popupHeight;
            break;
    }
    /*
     * Calculate x position
     * */
    switch (placement) {
        case 'left-start':
        case 'left':
        case 'left-end':
            returnPosition.x = xPos - (popupWidth + offset);
            break;
        case 'right-start':
        case 'right':
        case 'right-end':
            returnPosition.x = xPos + referenceWidth + offset;
            break;
        case 'top-start':
        case 'bottom-start':
            returnPosition.x = xPos;
            break;
        case 'top':
        case 'bottom':
            returnPosition.x = xPos + referenceWidth / 2 - popupWidth / 2;
            break;
        case 'top-end':
        case 'bottom-end':
            returnPosition.x = xPos + referenceWidth - popupRect.width;
            break;
    }
    /*
     * Add shift values
     * */
    returnPosition.x -= shiftValues.x;
    returnPosition.y -= shiftValues.y;
    return returnPosition;
}


//# sourceMappingURL=getPosition.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useFloating/core/hide.js
'use client';




function hide(_a) {
    var scrollableParents = _a.scrollableParents, reference = _a.reference, popupConfigs = _a.popupConfigs;
    var _b = (popupConfigs || {}).detectHidden, detectHidden = _b === void 0 ? false : _b;
    /*
     * Return immediately if not enable detect hidden
     * */
    if (!detectHidden) {
        return false;
    }
    var isHidden = false;
    /*
     * Reference values
     * */
    var referenceRect = reference.getBoundingClientRect();
    var referenceLeft = referenceRect.left;
    var referenceRight = referenceRect.right;
    var referenceTop = referenceRect.top;
    var referenceBottom = referenceRect.bottom;
    var scrollableParentsLength = scrollableParents.size;
    var arrayScrollableParents = Array.from(scrollableParents);
    for (var i = 0; i < scrollableParentsLength; ++i) {
        var parentRect = getElementClientRect(arrayScrollableParents[i]);
        var parentLeft = parentRect.left;
        var parentRight = parentRect.right;
        var parentTop = parentRect.top;
        var parentBottom = parentRect.bottom;
        isHidden =
            referenceRight < parentLeft ||
                referenceLeft > parentRight ||
                referenceBottom < parentTop ||
                referenceTop > parentBottom;
        if (isHidden) {
            break;
        }
    }
    return isHidden;
}


//# sourceMappingURL=hide.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useFloating/helpers/within.js
'use client';

function within(_a) {
    var min = _a.min, value = _a.value, max = _a.max;
    return Math.max(min, Math.min(value, max));
}


//# sourceMappingURL=within.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useFloating/core/shift.js
'use client';





function shift(_a) {
    var placement = _a.placement, position = _a.position, reference = _a.reference, popup = _a.popup, popupConfigs = _a.popupConfigs, scrollableParents = _a.scrollableParents;
    var returnShiftValues = {
        x: 0,
        y: 0
    };
    var _b = (popupConfigs || {}).isShift, isShift = _b === void 0 ? false : _b;
    /*
     * Return immediately if isShift not enable
     * or postion is fixed
     * */
    if (!isShift || position === 'fixed' || scrollableParents.size === 0) {
        return returnShiftValues;
    }
    /*
     * Calculate shifting value
     * */
    var scrollableParent = getElementClientRect(Array.from(scrollableParents)[0]);
    var referenceRect = getElementClientRect(reference);
    var popupRect = getElementClientRect(popup);
    /*
     * scrollable container value
     * */
    var scrollableParentLeft = scrollableParent.left;
    var scrollableParentRight = scrollableParent.right;
    var scrollableParentTop = scrollableParent.top;
    var scrollableParentBottom = scrollableParent.bottom;
    /*
     * Popup value
     * */
    var popupWidth = popupRect.width;
    var popupHeight = popupRect.height;
    /*
     * Reference value
     * */
    var referenceLeft = referenceRect.left;
    var referenceTop = referenceRect.top;
    var referenceWidth = referenceRect.width;
    var referenceHeight = referenceRect.height;
    switch (placement) {
        case 'top-start':
        case 'bottom-start':
            {
                var popupLeft = referenceLeft;
                var popupRight = referenceLeft + popupWidth;
                var limitLeft = -referenceWidth;
                var limitRight = popupWidth;
                var shiftLeft = within({
                    min: limitLeft,
                    value: 0,
                    max: popupLeft - scrollableParentLeft
                });
                var shiftRight = within({
                    min: 0,
                    value: popupRight - scrollableParentRight,
                    max: limitRight
                });
                returnShiftValues.x = shiftLeft + shiftRight;
            }
            break;
        case 'top':
        case 'bottom':
            {
                var popupLeft = referenceLeft + referenceWidth / 2 - popupWidth / 2;
                var popupRight = referenceLeft + referenceWidth / 2 + popupWidth / 2;
                var limitLeft = -(referenceWidth / 2 + popupWidth / 2);
                var limitRight = referenceWidth / 2 + popupWidth / 2;
                var shiftLeft = within({
                    min: limitLeft,
                    value: 0,
                    max: popupLeft - scrollableParentLeft
                });
                var shiftRight = within({
                    min: 0,
                    value: popupRight - scrollableParentRight,
                    max: limitRight
                });
                returnShiftValues.x = shiftLeft + shiftRight;
            }
            break;
        case 'top-end':
        case 'bottom-end':
            {
                var popupLeft = referenceLeft + referenceWidth - popupWidth;
                var popupRight = referenceLeft + referenceWidth;
                var limitLeft = -popupWidth;
                var limitRight = referenceWidth;
                var shiftLeft = within({
                    min: limitLeft,
                    value: 0,
                    max: popupLeft - scrollableParentLeft
                });
                var shiftRight = within({
                    min: 0,
                    value: popupRight - scrollableParentRight,
                    max: limitRight
                });
                returnShiftValues.x = shiftLeft + shiftRight;
            }
            break;
        case 'left-start':
        case 'right-start':
            {
                var popupTop = referenceTop;
                var popupBottom = referenceTop + popupHeight;
                var limitTop = -referenceHeight;
                var limitBottom = popupHeight;
                var shiftTop = within({
                    min: limitTop,
                    value: 0,
                    max: popupTop - scrollableParentTop
                });
                var shiftBottom = within({
                    min: 0,
                    value: popupBottom - scrollableParentBottom,
                    max: limitBottom
                });
                returnShiftValues.y = shiftTop + shiftBottom;
            }
            break;
        case 'left':
        case 'right':
            {
                var popupTop = referenceTop + referenceHeight / 2 - popupHeight / 2;
                var popupBottom = referenceTop + referenceHeight / 2 + popupHeight / 2;
                var limitTop = -(referenceHeight / 2 + popupHeight / 2);
                var limitBottom = referenceHeight / 2 + popupHeight / 2;
                var shiftTop = within({
                    min: limitTop,
                    value: 0,
                    max: popupTop - scrollableParentTop
                });
                var shiftBottom = within({
                    min: 0,
                    value: popupBottom - scrollableParentBottom,
                    max: limitBottom
                });
                returnShiftValues.y = shiftTop + shiftBottom;
            }
            break;
        case 'left-end':
        case 'right-end':
            {
                var popupTop = referenceTop + referenceHeight - popupHeight;
                var popupBottom = referenceTop + referenceHeight;
                var limitTop = -popupHeight;
                var limitBottom = referenceHeight;
                var shiftTop = within({
                    min: limitTop,
                    value: 0,
                    max: popupTop - scrollableParentTop
                });
                var shiftBottom = within({
                    min: 0,
                    value: popupBottom - scrollableParentBottom,
                    max: limitBottom
                });
                returnShiftValues.y = shiftTop + shiftBottom;
            }
            break;
    }
    return returnShiftValues;
}


//# sourceMappingURL=shift.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useFloating/core/computePosition.js
'use client';






function computePosition(reference, popup, configs) {
    var position = configs.position, placement = configs.placement, scrollableParents = configs.scrollableParents, popupConfigs = configs.popupConfigs;
    /*
     * Make popup flip
     * */
    var flippedPlacement = flip({
        position: position,
        reference: reference,
        popup: popup,
        scrollableParents: scrollableParents,
        placement: placement,
        popupConfigs: popupConfigs
    });
    var shiftValues = shift({
        position: position,
        reference: reference,
        popup: popup,
        scrollableParents: scrollableParents,
        placement: placement,
        popupConfigs: popupConfigs
    });
    var isReferenceHidden = hide({
        reference: reference,
        scrollableParents: scrollableParents,
        popupConfigs: popupConfigs
    });
    var args = {
        placement: flippedPlacement,
        position: position,
        reference: reference,
        popup: popup,
        popupConfigs: popupConfigs,
        shiftValues: shiftValues
    };
    var _a = getPosition(args), x = _a.x, y = _a.y;
    return {
        x: x,
        y: y,
        position: position,
        placement: flippedPlacement,
        isReferenceHidden: isReferenceHidden
    };
}


//# sourceMappingURL=computePosition.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useFloating/core/autoUpdate.js
'use client';

function autoUpdate(scrollParents, fn) {
    scrollParents.forEach(function (container) {
        container.addEventListener('scroll', fn, { passive: true });
        container.addEventListener('resize', fn, { passive: true });
    });
    fn();
    return function () {
        scrollParents.forEach(function (container) {
            container.removeEventListener('scroll', fn);
            container.removeEventListener('resize', fn);
        });
    };
}


//# sourceMappingURL=autoUpdate.js.map

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useFloating/FloatingPortal.js
'use client';



function FloatingPortal(_a) {
    var children = _a.children, nodeRef = _a.nodeRef, enable = _a.enable;
    if (!enable) {
        return children;
    }
    if (typeof window === 'undefined' && !nodeRef) {
        return null;
    }
    var node = (nodeRef === null || nodeRef === void 0 ? void 0 : nodeRef.current) || document.body;
    return (0,react_dom.createPortal)(children, node);
}


//# sourceMappingURL=FloatingPortal.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useFloating/index.js
'use client';









var useFloating = function (options) {
    var _a = options.position, position = _a === void 0 ? 'absolute' : _a, placement = options.placement, config = options.config;
    var _b = (config || {}).autoUpdate, autoUpdate$1 = _b === void 0 ? true : _b;
    var _c = (0,react.useState)(null), _reference = _c[0], _setReference = _c[1];
    var _d = (0,react.useState)(null), _popup = _d[0], _setPopup = _d[1];
    var referenceRef = (0,react.useRef)(null);
    var popupRef = (0,react.useRef)(null);
    var scrollableParents = (0,react.useRef)(new Set());
    var _e = (0,react.useState)({
        x: 0,
        y: 0,
        position: position,
        placement: placement,
        isReferenceHidden: false
    }), context = _e[0], setContext = _e[1];
    var contextRef = (0,react.useRef)();
    /*
     * Custom function to avoid node being set multiple time
     * */
    var setReference = (0,react.useCallback)(function (node) {
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, [_setReference]);
    var setPopup = (0,react.useCallback)(function (node) {
        if (node !== popupRef.current) {
            popupRef.current = node;
            _setPopup(node);
        }
    }, [_setPopup]);
    /*
     * Update function will be called to calculated popup position
     * */
    var update = (0,react.useCallback)(function () {
        if (!referenceRef.current || !popupRef.current) {
            return;
        }
        var computePositionConfigs = {
            placement: placement,
            position: position,
            scrollableParents: scrollableParents.current,
            popupConfigs: config
        };
        var context = computePosition(referenceRef.current, popupRef.current, computePositionConfigs);
        if (!deepEqual(context, contextRef.current)) {
            contextRef.current = context;
            setContext(context);
        }
    }, [placement, position, config]);
    useIsomorphicLayoutEffect(function () {
        if (_reference) {
            referenceRef.current = _reference;
        }
        if (_popup) {
            popupRef.current = _popup;
        }
        if (_reference && _popup) {
            var target = position === 'fixed' ? _reference : _popup;
            var scrollableParentsByTarget = getScrollableParents(target);
            if (scrollableParents.current.size === 0 && scrollableParentsByTarget.size > 0) {
                /*
                 * Get and store scrollableParents
                 * */
                scrollableParents.current = scrollableParentsByTarget;
            }
            /*
             * Update function will calculate the position of popup element
             * */
            if (autoUpdate$1) {
                var clear_1 = autoUpdate(scrollableParents.current, update);
                /*
                 * Observer the changes of popup element when auto update is enable
                 * */
                var observer_1 = new MutationObserver(update);
                observer_1.observe(_popup, {
                    attributes: true,
                    childList: true,
                    subtree: true
                });
                return function () {
                    clear_1();
                    observer_1.disconnect();
                };
            }
            update();
        }
        return function () { };
    }, [_reference, _popup, update, position, autoUpdate$1]);
    var refs = {
        setReference: setReference,
        setPopup: setPopup,
        reference: referenceRef,
        popup: popupRef
    };
    return {
        refs: refs,
        context: context,
        FloatingPortal: FloatingPortal
    };
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 57767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIsomorphicLayoutEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;


//# sourceMappingURL=useIsomorphicLayoutEffect.js.map


/***/ }),

/***/ 76576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useIsomorphicLayoutEffect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57767);
'use client';




/**
 * Older versions of Safari (shipped withCatalina and before) do not support addEventListener on matchMedia
 * https://stackoverflow.com/questions/56466261/matchmedia-addlistener-marked-as-deprecated-addeventlistener-equivalent
 * */
function attachMediaListener(query, callback) {
    try {
        query.addEventListener('change', callback);
        return function () { return query.removeEventListener('change', callback); };
    }
    catch (e) {
        query.addListener(callback);
        return function () { return query.removeListener(callback); };
    }
}
function getInitialValue(query, initialValue) {
    if (typeof initialValue === 'boolean') {
        return initialValue;
    }
    if (typeof window !== 'undefined' && 'matchMedia' in window) {
        return window.matchMedia(query).matches;
    }
    return false;
}
function useMediaQuery(query, initialValue, _a) {
    var _b = _a === void 0 ? {
        getInitialValueInEffect: true
    } : _a, getInitialValueInEffect = _b.getInitialValueInEffect;
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getInitialValueInEffect ? initialValue : getInitialValue(query, initialValue)), matches = _c[0], setMatches = _c[1];
    var queryRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,_useIsomorphicLayoutEffect_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
        if ('matchMedia' in window) {
            queryRef.current = window.matchMedia(query);
            setMatches(queryRef.current.matches);
            return attachMediaListener(queryRef.current, function (event) { return setMatches(event.matches); });
        }
        return undefined;
    }, [query]);
    return matches;
}


//# sourceMappingURL=useMediaQuery.js.map


/***/ }),

/***/ 81781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useTransition; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(74982);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useIsomorphicLayoutEffect.js
var useIsomorphicLayoutEffect = __webpack_require__(57767);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useLatestRef.js
'use client';




function useLatestRef(value) {
    var ref = (0,react.useRef)(value);
    (0,useIsomorphicLayoutEffect/* default */.Z)(function () {
        ref.current = value;
    });
    return ref;
}


//# sourceMappingURL=useLatestRef.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/app-shell-v2/node_modules/@microfrontends/react-components/components/hooks/useTransition.js
'use client';






var DEFAULT_DURATION = 250;
function camelCaseToKebabCase(str) {
    return str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, function ($, ofs) { return (ofs ? '-' : '') + $.toLowerCase(); });
}
function execWithArgsOrReturn(valueOrFunc, args) {
    return typeof valueOrFunc === 'function' ? valueOrFunc(args) : valueOrFunc;
}
function isEmptyObject(obj) {
    return Object.keys(obj).length === 0;
}
function useDelayUnmount(open, duration) {
    var _a = (0,react.useState)(open), isMounted = _a[0], setMounted = _a[1];
    if (open && !isMounted) {
        setMounted(true);
    }
    (0,react.useEffect)(function () {
        if (!open) {
            var timeout_1 = setTimeout(function () { return setMounted(false); }, duration);
            return function () {
                clearTimeout(timeout_1);
            };
        }
        return function () { };
    }, [open, duration]);
    return isMounted;
}
function useTransitionStatus(open, duration) {
    var _a = (0,react.useState)('initial'), status = _a[0], setStatus = _a[1];
    var _b = (0,react.useState)(false), initiated = _b[0], setInitiated = _b[1];
    var isNumberDuration = typeof duration === 'number';
    var enterDuration = isNumberDuration ? duration : duration.enter || 0;
    var leaveDuration = isNumberDuration ? duration : duration.leave || 0;
    var isMounted = useDelayUnmount(open, leaveDuration);
    (0,useIsomorphicLayoutEffect/* default */.Z)(function () {
        if (initiated && !isMounted) {
            setStatus('unmount');
        }
    }, [isMounted, initiated]);
    (0,useIsomorphicLayoutEffect/* default */.Z)(function () {
        if (!isMounted)
            return;
        if (open) {
            setStatus('initial');
            var timeout_2;
            var frame_1 = requestAnimationFrame(function () {
                setStatus('enter');
                timeout_2 = setTimeout(function () { return setStatus('entered'); }, enterDuration);
            });
            return function () {
                cancelAnimationFrame(frame_1);
                clearTimeout(timeout_2);
            };
        }
        setInitiated(true);
        setStatus('before-leave');
        var leaveFrame = requestAnimationFrame(function () { return setStatus('leave'); });
        return function () {
            cancelAnimationFrame(leaveFrame);
        };
    }, [open, isMounted, enterDuration]);
    return {
        isMounted: isMounted,
        status: status
    };
}
function useTransition(context, transitions) {
    var open = context.open, args = context.args;
    var _a = transitions.duration, duration = _a === void 0 ? DEFAULT_DURATION : _a, _b = transitions.initial, initial = _b === void 0 ? { opacity: 0 } : _b, _c = transitions.enter, enter = _c === void 0 ? {} : _c, _d = transitions.entered, entered = _d === void 0 ? {} : _d, _e = transitions.beforeLeave, beforeLeave = _e === void 0 ? {} : _e, _f = transitions.leave, leave = _f === void 0 ? {} : _f;
    var funcArgs = (0,react.useMemo)(function () { return args; }, [JSON.stringify(args)]);
    var _g = useTransitionStatus(open, duration), isMounted = _g.isMounted, status = _g.status;
    var _h = (0,react.useState)((0,_tslib/* __assign */.pi)({}, execWithArgsOrReturn(initial, funcArgs))), styles = _h[0], setStyles = _h[1];
    var initialRef = useLatestRef(initial);
    var enterRef = useLatestRef(enter);
    var enteredRef = useLatestRef(entered);
    var beforeLeaveRef = useLatestRef(beforeLeave);
    var leaveRef = useLatestRef(leave);
    var isNumberDuration = typeof duration === 'number';
    var enterDuration = isNumberDuration ? duration : duration.enter || 0;
    var leaveDuration = isNumberDuration ? duration : duration.leave || 0;
    (0,useIsomorphicLayoutEffect/* default */.Z)(function () {
        var initialStyles = execWithArgsOrReturn(initialRef.current, funcArgs);
        var enterStyles = execWithArgsOrReturn(enterRef.current, funcArgs);
        var enteredStyles = execWithArgsOrReturn(enteredRef.current, funcArgs);
        var beforeLeaveStyles = execWithArgsOrReturn(beforeLeaveRef.current, funcArgs);
        var leaveStyles = execWithArgsOrReturn(leaveRef.current, funcArgs);
        if (status === 'initial') {
            setStyles(function (styles) { return ((0,_tslib/* __assign */.pi)({ transitionProperty: styles.transitionProperty }, initialStyles)); });
        }
        if (status === 'enter') {
            setStyles((0,_tslib/* __assign */.pi)({ transitionDuration: "".concat(enterDuration, "ms"), transitionProperty: Object.keys(enterStyles).map(camelCaseToKebabCase).join(',') }, enterStyles));
        }
        if (status === 'entered') {
            var styles_1 = isEmptyObject(enteredStyles) ? enterStyles : enteredStyles;
            setStyles((0,_tslib/* __assign */.pi)({ transitionDuration: "".concat(enterDuration, "ms"), transitionProperty: Object.keys(enterStyles).map(camelCaseToKebabCase).join(',') }, styles_1));
        }
        if (status === 'before-leave') {
            var styles_2 = isEmptyObject(beforeLeaveRef) ? initialStyles : beforeLeaveStyles;
            setStyles((0,_tslib/* __assign */.pi)({ transitionDuration: "".concat(leaveDuration, "ms"), transitionProperty: Object.keys(enterStyles).map(camelCaseToKebabCase).join(',') }, styles_2));
        }
        if (status === 'leave') {
            var styles_3 = isEmptyObject(leaveStyles) ? initialStyles : leaveStyles;
            setStyles((0,_tslib/* __assign */.pi)({ transitionDuration: "".concat(leaveDuration, "ms"), transitionProperty: Object.keys(enterStyles).map(camelCaseToKebabCase).join(',') }, styles_3));
        }
    }, [initialRef, enterRef, enteredRef, beforeLeaveRef, leaveRef, status, enterDuration, leaveDuration, funcArgs]);
    return { isMounted: isMounted, styles: styles };
}


//# sourceMappingURL=useTransition.js.map


/***/ }),

/***/ 78190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AccountSettingsIcon$1; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
'use client';




var AccountSettingsIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#888888' : _c;
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", { width: width, height: width, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", { clipPath: 'url(#clip0_3011_6580)', children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: 'M22.6368 10.186L19.8 9.72236C19.6339 9.15308 19.4069 8.60588 19.1227 8.08796L20.7787 5.7278C20.9126 5.53724 20.8896 5.27756 20.7249 5.11244L18.8582 3.24668C18.6917 3.0806 18.4296 3.059 18.2385 3.19676L15.9139 4.86764C15.3912 4.57868 14.8392 4.34924 14.2665 4.18268L13.7717 1.3574C13.7313 1.12796 13.5321 0.959961 13.2989 0.959961H10.6589C10.4237 0.959961 10.223 1.13036 10.1851 1.36268L9.72622 4.1726C9.15022 4.3382 8.59726 4.56524 8.07646 4.85036L5.75806 3.19436C5.56654 3.05756 5.3059 3.07964 5.13934 3.24524L3.27358 5.111C3.10894 5.27564 3.0859 5.53484 3.21982 5.7254L4.85134 8.05964C4.56094 8.58524 4.32958 9.14156 4.1611 9.72044L1.36222 10.1865C1.13086 10.2249 0.960938 10.4256 0.960938 10.6598V13.2998C0.960938 13.5326 1.12798 13.7318 1.35694 13.7726L4.15582 14.2689C4.32334 14.8464 4.5547 15.4027 4.84606 15.9297L3.19438 18.24C3.05806 18.4305 3.07966 18.6921 3.24526 18.8587L5.1115 20.7264C5.27614 20.891 5.53582 20.914 5.72638 20.7801L8.06398 19.1428C8.58862 19.4313 9.14302 19.6603 9.71758 19.8264L10.1861 22.6396C10.224 22.8705 10.4241 23.04 10.6589 23.04H13.2989C13.5317 23.04 13.7309 22.8729 13.7712 22.644L14.2728 19.8168C14.8483 19.6473 15.3998 19.4169 15.9192 19.128L18.2736 20.7796C18.4646 20.9145 18.7238 20.891 18.8889 20.7264L20.7552 18.8587C20.9213 18.6921 20.9429 18.4296 20.8051 18.2385L19.1261 15.9072C19.4107 15.3888 19.6368 14.8406 19.8014 14.2713L22.6421 13.7726C22.872 13.7323 23.039 13.5326 23.039 13.2998V10.6598C23.0395 10.4246 22.8691 10.224 22.6368 10.186ZM12 15.36C10.1443 15.36 8.63998 13.8556 8.63998 12C8.63998 10.1443 10.1443 8.63996 12 8.63996C13.8557 8.63996 15.36 10.1443 15.36 12C15.36 13.8556 13.8557 15.36 12 15.36Z', fill: color }) }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", { id: 'clip0_3011_6580', children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", { width: '24', height: '24', fill: 'white' }) }) })] }));
};
var AccountSettingsIcon$1 = react__WEBPACK_IMPORTED_MODULE_1__.memo(AccountSettingsIcon);


//# sourceMappingURL=AccountSettingsIcon.js.map


/***/ }),

/***/ 13952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DashboardIcon$1; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
'use client';




var DashboardIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#888888' : _c;
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", { width: width, height: width, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: 'M12 3.35986C5.91184 3.35986 0.959961 8.31174 0.959961 14.3999C0.959961 16.048 1.28809 17.5424 1.94621 18.9449C1.97621 19.0105 2.00809 19.0742 2.03809 19.1399C2.08309 19.228 2.12621 19.318 2.17309 19.4061C2.35121 19.753 2.54059 20.0942 2.75621 20.4224C2.84434 20.5574 2.99434 20.6399 3.15746 20.6399H20.8425C21.0056 20.6399 21.1556 20.5574 21.2437 20.4224C21.4593 20.0942 21.6487 19.753 21.8268 19.4061C21.8718 19.318 21.9168 19.228 21.9618 19.1399C21.9918 19.0742 22.0237 19.0105 22.0537 18.9449C22.7118 17.5424 23.04 16.048 23.04 14.3999C23.04 8.31174 18.0881 3.35986 12 3.35986ZM14.88 18.7199H9.11996C8.85371 18.7199 8.63996 18.5042 8.63996 18.2399C8.63996 17.9755 8.85371 17.7599 9.11996 17.7599H14.88C15.1462 17.7599 15.36 17.9755 15.36 18.2399C15.36 18.5042 15.1462 18.7199 14.88 18.7199ZM17.4412 11.7636L12.9581 14.3905C12.9581 14.3942 12.96 14.3961 12.96 14.3999C12.96 14.9305 12.5306 15.3599 12 15.3599C11.4693 15.3599 11.04 14.9305 11.04 14.3999C11.04 13.8692 11.4693 13.4399 12 13.4399C12.1706 13.4399 12.3281 13.4886 12.4668 13.5655L16.9518 10.9367C17.1787 10.8017 17.475 10.8767 17.61 11.1055C17.745 11.3342 17.67 11.6286 17.4412 11.7636ZM20.7206 19.4399C20.6306 19.5936 20.4693 19.6799 20.3043 19.6799C20.2818 19.6799 20.2575 19.6742 20.235 19.6705C20.2106 19.6742 20.1843 19.6799 20.16 19.6799C20.0681 19.6799 19.9762 19.6536 19.8937 19.5992L18.4537 18.6392C18.2325 18.493 18.1725 18.1949 18.3206 17.9736C18.4668 17.7524 18.765 17.6924 18.9862 17.8405L20.0943 18.5792C20.1 18.568 20.1056 18.5567 20.1112 18.5474C20.1131 18.5192 20.1131 18.4911 20.1337 18.4967C20.1356 18.4967 20.1375 18.4967 20.1375 18.4967C20.7075 17.368 21.0375 16.1342 21.105 14.8799H19.68C19.4137 14.8799 19.2 14.6661 19.2 14.3999C19.2 14.1355 19.4137 13.9199 19.68 13.9199H21.0956C21.0281 12.6299 20.6943 11.413 20.1431 10.318C20.1318 10.2974 20.115 10.2805 20.1037 10.258L18.9712 10.9536C18.8925 11.0024 18.8062 11.0249 18.72 11.0249C18.5587 11.0249 18.4012 10.9424 18.3112 10.7942C18.1725 10.5692 18.2437 10.273 18.4687 10.1342L19.6237 9.42736C19.5881 9.37299 19.56 9.31861 19.53 9.26424C18.8137 8.21799 17.8818 7.33299 16.8018 6.66174C16.7831 6.65049 16.7606 6.63924 16.7418 6.62799L16.05 7.88236C15.9618 8.03986 15.7987 8.12986 15.6281 8.12986C15.5512 8.12986 15.4706 8.11111 15.3975 8.06986C15.165 7.94236 15.0806 7.64986 15.21 7.41736L15.8981 6.17049C15.8868 6.16486 15.8756 6.15736 15.8643 6.15174C14.8256 5.66236 13.6837 5.36799 12.4781 5.30424V6.71986C12.4781 6.98424 12.2643 7.19986 11.9981 7.19986C11.7337 7.19986 11.5181 6.98424 11.5181 6.71986V5.30424C10.2112 5.37361 8.97559 5.71486 7.86934 6.27924C7.82996 6.30361 7.78871 6.32799 7.74934 6.34861L8.48809 7.54299C8.62684 7.76799 8.55746 8.06424 8.33059 8.20299C8.25184 8.25174 8.16559 8.27424 8.07934 8.27424C7.91809 8.27424 7.76246 8.19361 7.67059 8.04736L6.92621 6.83986C6.89246 6.86236 6.85871 6.87924 6.82496 6.89799C5.77871 7.62361 4.89746 8.56111 4.23184 9.64674L5.42809 10.2974C5.66246 10.4249 5.74871 10.7155 5.62121 10.948C5.53496 11.1092 5.36996 11.1992 5.19934 11.1992C5.12246 11.1992 5.04371 11.1805 4.97059 11.1411L3.77246 10.4905C3.27184 11.5405 2.96809 12.6974 2.90434 13.9199H4.31996C4.58621 13.9199 4.79996 14.1355 4.79996 14.3999C4.79996 14.6642 4.58621 14.8799 4.31996 14.8799H2.89496C2.96246 16.1249 3.28496 17.3474 3.84746 18.4686C3.85121 18.478 3.86059 18.4874 3.86621 18.4949C3.88121 18.5249 3.91121 18.5755 3.91121 18.5755L5.01371 17.8405C5.23496 17.6924 5.53309 17.7524 5.67934 17.9736C5.82746 18.193 5.76746 18.4911 5.54621 18.6392L4.10621 19.5992C4.02371 19.6536 3.93184 19.6799 3.83996 19.6799C3.83434 19.6799 3.82684 19.6649 3.81746 19.6555C3.61496 19.7099 3.38996 19.633 3.27934 19.4399C2.39059 17.9042 1.91996 16.1624 1.91996 14.3999C1.91996 8.84236 6.44246 4.31986 12 4.31986C17.5575 4.31986 22.08 8.84236 22.08 14.3999C22.08 16.1624 21.6093 17.9042 20.7206 19.4399Z', fill: color }) }));
};
var DashboardIcon$1 = react__WEBPACK_IMPORTED_MODULE_1__.memo(DashboardIcon);


//# sourceMappingURL=DashboardIcon.js.map


/***/ }),

/***/ 93570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ JobAlertsIcon$1; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
'use client';




var JobAlertsIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#888888' : _c;
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", { width: width, height: width, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: 'M12 2.3999C11.116 2.3999 10.4 3.1159 10.4 3.9999V4.20928C7.64139 4.92094 5.59999 7.41914 5.59999 10.3999V12.3155C5.59999 13.5875 5.33876 14.8375 4.85156 15.9999H19.1484C18.6612 14.8383 18.4 13.5875 18.4 12.3155V10.3999C18.4 7.41914 16.3586 4.92094 13.6 4.20928V3.9999C13.6 3.1159 12.884 2.3999 12 2.3999ZM3.99999 17.5999C3.89398 17.5984 3.78873 17.618 3.69036 17.6575C3.59198 17.6971 3.50245 17.7557 3.42695 17.8302C3.35146 17.9046 3.29151 17.9933 3.25059 18.0911C3.20967 18.1889 3.1886 18.2939 3.1886 18.3999C3.1886 18.5059 3.20967 18.6109 3.25059 18.7087C3.29151 18.8065 3.35146 18.8952 3.42695 18.9696C3.50245 19.0441 3.59198 19.1028 3.69036 19.1423C3.78873 19.1818 3.89398 19.2014 3.99999 19.1999H9.74062C9.64863 19.4566 9.60107 19.7272 9.59999 19.9999C9.59999 20.6364 9.85285 21.2469 10.3029 21.697C10.753 22.147 11.3635 22.3999 12 22.3999C12.6365 22.3999 13.247 22.147 13.697 21.697C14.1471 21.2469 14.4 20.6364 14.4 19.9999C14.3994 19.7273 14.3524 19.4567 14.2609 19.1999H20C20.106 19.2014 20.2113 19.1818 20.3096 19.1423C20.408 19.1028 20.4975 19.0441 20.573 18.9696C20.6485 18.8952 20.7085 18.8065 20.7494 18.7087C20.7903 18.6109 20.8114 18.5059 20.8114 18.3999C20.8114 18.2939 20.7903 18.1889 20.7494 18.0911C20.7085 17.9933 20.6485 17.9046 20.573 17.8302C20.4975 17.7557 20.408 17.6971 20.3096 17.6575C20.2113 17.618 20.106 17.5984 20 17.5999H12H3.99999Z', fill: color }) }));
};
var JobAlertsIcon$1 = react__WEBPACK_IMPORTED_MODULE_1__.memo(JobAlertsIcon);


//# sourceMappingURL=JobAlertsIcon.js.map


/***/ }),

/***/ 182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LogoutIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
'use client';



var LogoutIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#888888' : _c;
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", { width: width, height: width, viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: 'M3.33333 2C2.598 2 2 2.598 2 3.33333V16.6667C2 17.402 2.598 18 3.33333 18H12.6667C13.402 18 14 17.402 14 16.6667V10.6667H8.66667C8.29867 10.6667 8 10.368 8 10C8 9.632 8.29867 9.33333 8.66667 9.33333H14V3.33333C14 2.598 13.402 2 12.6667 2H3.33333ZM14 9.33333V10.6667H17.724L16.1953 12.1953C16.1313 12.2567 16.0802 12.3303 16.0451 12.4117C16.0099 12.4932 15.9913 12.5808 15.9904 12.6695C15.9895 12.7582 16.0063 12.8462 16.0398 12.9283C16.0733 13.0104 16.1229 13.085 16.1856 13.1477C16.2483 13.2104 16.3229 13.26 16.4051 13.2935C16.4872 13.3271 16.5752 13.3439 16.6639 13.343C16.7526 13.3421 16.8402 13.3235 16.9216 13.2883C17.003 13.2531 17.0766 13.202 17.138 13.138L19.8047 10.4714C19.9297 10.3463 19.9999 10.1768 19.9999 10C19.9999 9.82322 19.9297 9.65368 19.8047 9.52865L17.138 6.86198C17.0759 6.79812 17.0016 6.74735 16.9195 6.71269C16.8374 6.67802 16.7493 6.66016 16.6602 6.66016C16.5275 6.66019 16.3979 6.69978 16.2879 6.77385C16.1779 6.84793 16.0925 6.95313 16.0426 7.076C15.9927 7.19888 15.9806 7.33384 16.0078 7.46365C16.035 7.59345 16.1003 7.71219 16.1953 7.80469L17.724 9.33333H14Z', fill: color }) }));
};


//# sourceMappingURL=LogoutIcon.js.map


/***/ }),

/***/ 18089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MyCompaniesIcon$1; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
'use client';




var MyCompaniesIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#888888' : _c;
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", { width: width, height: width, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: 'M4.80002 2.39998C4.69401 2.39848 4.58876 2.41807 4.49038 2.4576C4.39201 2.49713 4.30247 2.55582 4.22698 2.63025C4.15148 2.70469 4.09153 2.79339 4.05061 2.89119C4.00969 2.989 3.98862 3.09396 3.98862 3.19998C3.98862 3.306 4.00969 3.41097 4.05061 3.50877C4.09153 3.60658 4.15148 3.69527 4.22698 3.76971C4.30247 3.84415 4.39201 3.90283 4.49038 3.94237C4.58876 3.9819 4.69401 4.00148 4.80002 3.99998H12.8C12.906 4.00148 13.0113 3.9819 13.1097 3.94237C13.208 3.90283 13.2976 3.84415 13.3731 3.76971C13.4486 3.69527 13.5085 3.60658 13.5494 3.50877C13.5903 3.41097 13.6114 3.306 13.6114 3.19998C13.6114 3.09396 13.5903 2.989 13.5494 2.89119C13.5085 2.79339 13.4486 2.70469 13.3731 2.63025C13.2976 2.55582 13.208 2.49713 13.1097 2.4576C13.0113 2.41807 12.906 2.39848 12.8 2.39998H4.80002ZM2.40002 5.59998C2.29401 5.59848 2.18876 5.61807 2.09038 5.6576C1.99201 5.69713 1.90247 5.75582 1.82698 5.83025C1.75148 5.90469 1.69153 5.99339 1.65061 6.09119C1.60969 6.189 1.58862 6.29396 1.58862 6.39998C1.58862 6.506 1.60969 6.61097 1.65061 6.70877C1.69153 6.80658 1.75148 6.89528 1.82698 6.96971C1.90247 7.04415 1.99201 7.10284 2.09038 7.14237C2.18876 7.1819 2.29401 7.20148 2.40002 7.19998V20.8H7.20002V17.6H10.4V20.8H15.2V7.19998C15.306 7.20148 15.4113 7.1819 15.5097 7.14237C15.608 7.10284 15.6976 7.04415 15.7731 6.96971C15.8486 6.89528 15.9085 6.80658 15.9494 6.70877C15.9903 6.61097 16.0114 6.506 16.0114 6.39998C16.0114 6.29396 15.9903 6.189 15.9494 6.09119C15.9085 5.99339 15.8486 5.90469 15.7731 5.83025C15.6976 5.75582 15.608 5.69713 15.5097 5.6576C15.4113 5.61807 15.306 5.59848 15.2 5.59998H2.40002ZM4.00002 7.99998H5.60002V9.59998H4.00002V7.99998ZM7.20002 7.99998H10.4V9.59998H7.20002V7.99998ZM12 7.99998H13.6V9.59998H12V7.99998ZM16.8 7.99998V10.4V12V13.6V15.2V16.8V18.4V20.8H21.6V7.99998H16.8ZM18.4 10.4H20V12H18.4V10.4ZM4.00002 11.2H5.60002V12.8H4.00002V11.2ZM7.20002 11.2H10.4V12.8H7.20002V11.2ZM12 11.2H13.6V12.8H12V11.2ZM18.4 13.6H20V15.2H18.4V13.6ZM4.00002 14.4H5.60002V16H4.00002V14.4ZM7.20002 14.4H10.4V16H7.20002V14.4ZM12 14.4H13.6V16H12V14.4ZM18.4 16.8H20V18.4H18.4V16.8ZM4.00002 17.6H5.60002V19.2H4.00002V17.6ZM12 17.6H13.6V19.2H12V17.6Z', fill: color }) }));
};
var MyCompaniesIcon$1 = react__WEBPACK_IMPORTED_MODULE_1__.memo(MyCompaniesIcon);


//# sourceMappingURL=MyCompaniesIcon.js.map


/***/ }),

/***/ 93809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MyJobsIcon$1; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
'use client';




var MyJobsIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#888888' : _c;
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", { width: width, height: width, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: 'M11.2 2.3999C10.316 2.3999 9.59998 3.1159 9.59998 3.9999H3.19998C2.31598 3.9999 1.59998 4.7159 1.59998 5.5999V12.7999C1.59998 13.6839 2.31598 14.3999 3.19998 14.3999H20.8C21.684 14.3999 22.4 13.6839 22.4 12.7999V5.5999C22.4 4.7159 21.684 3.9999 20.8 3.9999H14.4C14.4 3.1159 13.684 2.3999 12.8 2.3999H11.2ZM12 11.1999C12.4416 11.1999 12.8 11.5583 12.8 11.9999C12.8 12.4415 12.4416 12.7999 12 12.7999C11.5584 12.7999 11.2 12.4415 11.2 11.9999C11.2 11.5583 11.5584 11.1999 12 11.1999ZM1.59998 15.5546V18.3999C1.59998 19.2839 2.31598 19.9999 3.19998 19.9999H20.8C21.684 19.9999 22.4 19.2839 22.4 18.3999V15.5546C21.9272 15.8298 21.3856 15.9999 20.8 15.9999H3.19998C2.61438 15.9999 2.07278 15.8298 1.59998 15.5546Z', fill: color }) }));
};
var MyJobsIcon$1 = react__WEBPACK_IMPORTED_MODULE_1__.memo(MyJobsIcon);


//# sourceMappingURL=MyJobsIcon.js.map


/***/ }),

/***/ 77203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MyProfileIcon$1; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
'use client';




var MyProfileIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#888888' : _c;
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", { width: width, height: width, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: 'M5.6 1.6001C4.716 1.6001 4 2.3161 4 3.2001V20.8001C4 21.6841 4.716 22.4001 5.6 22.4001H13.05C13.6612 20.6225 15.2518 20.0363 16.1078 19.7235C16.1574 19.7051 16.2135 19.6842 16.2703 19.6626C16.0815 19.4146 15.9031 19.1368 15.7688 18.8392C15.3703 18.4136 15.0797 17.7903 15.0797 17.0079C15.0797 16.8727 15.0894 16.7443 15.1078 16.6235C14.9766 16.2699 14.8687 15.8289 14.8688 15.3329C14.8703 12.9385 16.6912 11.2001 19.2 11.2001C19.4856 11.2001 19.7496 11.2523 20 11.3251V7.6001C20 7.3881 19.916 7.18407 19.7656 7.03447L14.5656 1.83447C14.4152 1.68407 14.212 1.6001 14 1.6001H5.6ZM13.6 3.12354L18.4766 8.0001H14.4C13.9584 8.0001 13.6 7.6417 13.6 7.2001V3.12354ZM19.2 12.7985C17.6928 12.7985 16.4703 13.7073 16.4703 15.3329C16.4703 16.0201 16.8547 16.5548 16.8547 16.5548C16.8547 16.5548 16.6797 16.6407 16.6797 17.0079C16.6797 17.7207 17.1391 17.8923 17.1391 17.8923C17.2031 18.4571 18.0797 19.2845 18.0797 19.2845V20.2267C17.6085 21.6419 14.4 20.8313 14.4 24.0001H24C24 20.8313 20.7915 21.6419 20.3203 20.2267V19.2845C20.3203 19.2845 21.1977 18.4571 21.2609 17.8923C21.2609 17.8923 21.7203 17.5751 21.7203 17.0079C21.7203 16.6143 21.5453 16.5548 21.5453 16.5548C21.5453 16.5548 21.8594 15.9572 21.8594 15.386C21.8594 14.2412 21.2859 13.3595 20.3203 13.3595C20.3203 13.3595 19.9096 12.7985 19.2 12.7985Z', fill: color }) }));
};
var MyProfileIcon$1 = react__WEBPACK_IMPORTED_MODULE_1__.memo(MyProfileIcon);


//# sourceMappingURL=MyProfileIcon.js.map


/***/ }),

/***/ 23877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OrderManagementIcon$1; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
'use client';




var OrderManagementIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#797979' : _c;
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", { width: width, height: width, viewBox: '0 0 24 24', fill: 'none', children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: 'M1.59997 1.60164C1.49396 1.60014 1.38871 1.61973 1.29033 1.65926C1.19196 1.69879 1.10242 1.75748 1.02693 1.83191C0.951431 1.90635 0.891482 1.99505 0.850564 2.09285C0.809646 2.19066 0.788574 2.29562 0.788574 2.40164C0.788574 2.50766 0.809646 2.61263 0.850564 2.71043C0.891482 2.80824 0.951431 2.89693 1.02693 2.97137C1.10242 3.04581 1.19196 3.10449 1.29033 3.14403C1.38871 3.18356 1.49396 3.20314 1.59997 3.20164H3.10309C3.28381 3.20164 3.43462 3.31481 3.48591 3.48914L6.89528 15.0798C7.19451 16.0971 8.13549 16.8016 9.19684 16.8016H17.9781C19.0568 16.8016 20.0093 16.0726 20.2937 15.0329L22.3718 7.41258C22.4043 7.29387 22.4089 7.16928 22.3853 7.0485C22.3618 6.92772 22.3106 6.814 22.236 6.71619C22.1613 6.61838 22.065 6.53911 21.9547 6.48456C21.8444 6.43001 21.723 6.40163 21.6 6.40164H6.01091L5.02184 3.03758C5.02132 3.03758 5.0208 3.03758 5.02028 3.03758C4.77077 2.18951 3.98637 1.60164 3.10309 1.60164H1.59997ZM9.59997 18.4016C9.17562 18.4016 8.76866 18.5702 8.4686 18.8703C8.16854 19.1703 7.99997 19.5773 7.99997 20.0016C7.99997 20.426 8.16854 20.833 8.4686 21.133C8.76866 21.4331 9.17562 21.6016 9.59997 21.6016C10.0243 21.6016 10.4313 21.4331 10.7313 21.133C11.0314 20.833 11.2 20.426 11.2 20.0016C11.2 19.5773 11.0314 19.1703 10.7313 18.8703C10.4313 18.5702 10.0243 18.4016 9.59997 18.4016ZM17.6 18.4016C17.1756 18.4016 16.7687 18.5702 16.4686 18.8703C16.1685 19.1703 16 19.5773 16 20.0016C16 20.426 16.1685 20.833 16.4686 21.133C16.7687 21.4331 17.1756 21.6016 17.6 21.6016C18.0243 21.6016 18.4313 21.4331 18.7313 21.133C19.0314 20.833 19.2 20.426 19.2 20.0016C19.2 19.5773 19.0314 19.1703 18.7313 18.8703C18.4313 18.5702 18.0243 18.4016 17.6 18.4016Z', fill: color }) }));
};
var OrderManagementIcon$1 = react__WEBPACK_IMPORTED_MODULE_1__.memo(OrderManagementIcon);


//# sourceMappingURL=OrderManagementIcon.js.map


/***/ }),

/***/ 232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ ENestedDatasetName; }
/* harmony export */ });
/* unused harmony export MobileSelectMode */
'use client';

var ENestedDatasetName;
(function (ENestedDatasetName) {
    ENestedDatasetName["JOB_FUNCTION"] = "jobFunction";
})(ENestedDatasetName || (ENestedDatasetName = {}));
var MobileSelectMode;
(function (MobileSelectMode) {
    MobileSelectMode[MobileSelectMode["Single"] = 0] = "Single";
    MobileSelectMode[MobileSelectMode["Multiple"] = 1] = "Multiple";
})(MobileSelectMode || (MobileSelectMode = {}));
// export type TTranslation = Record<string, string>
// export type TTranslatorFunction<T extends TTranslation> = ReturnType<typeof createTranslator<T>>
// export type TTranslatorFactoryProps<T extends TTranslation> = Parameters<typeof createTranslator<T>>
// export type TTranslatorFactory<T extends TTranslation> = typeof createTranslator<T>


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(21296);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 96103:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 21296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(96103);
} else {}


/***/ }),

/***/ 21876:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={675:function(e,r){"use strict";r.byteLength=byteLength;r.toByteArray=toByteArray;r.fromByteArray=fromByteArray;var t=[];var f=[];var n=typeof Uint8Array!=="undefined"?Uint8Array:Array;var i="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";for(var o=0,u=i.length;o<u;++o){t[o]=i[o];f[i.charCodeAt(o)]=o}f["-".charCodeAt(0)]=62;f["_".charCodeAt(0)]=63;function getLens(e){var r=e.length;if(r%4>0){throw new Error("Invalid string. Length must be a multiple of 4")}var t=e.indexOf("=");if(t===-1)t=r;var f=t===r?0:4-t%4;return[t,f]}function byteLength(e){var r=getLens(e);var t=r[0];var f=r[1];return(t+f)*3/4-f}function _byteLength(e,r,t){return(r+t)*3/4-t}function toByteArray(e){var r;var t=getLens(e);var i=t[0];var o=t[1];var u=new n(_byteLength(e,i,o));var a=0;var s=o>0?i-4:i;var h;for(h=0;h<s;h+=4){r=f[e.charCodeAt(h)]<<18|f[e.charCodeAt(h+1)]<<12|f[e.charCodeAt(h+2)]<<6|f[e.charCodeAt(h+3)];u[a++]=r>>16&255;u[a++]=r>>8&255;u[a++]=r&255}if(o===2){r=f[e.charCodeAt(h)]<<2|f[e.charCodeAt(h+1)]>>4;u[a++]=r&255}if(o===1){r=f[e.charCodeAt(h)]<<10|f[e.charCodeAt(h+1)]<<4|f[e.charCodeAt(h+2)]>>2;u[a++]=r>>8&255;u[a++]=r&255}return u}function tripletToBase64(e){return t[e>>18&63]+t[e>>12&63]+t[e>>6&63]+t[e&63]}function encodeChunk(e,r,t){var f;var n=[];for(var i=r;i<t;i+=3){f=(e[i]<<16&16711680)+(e[i+1]<<8&65280)+(e[i+2]&255);n.push(tripletToBase64(f))}return n.join("")}function fromByteArray(e){var r;var f=e.length;var n=f%3;var i=[];var o=16383;for(var u=0,a=f-n;u<a;u+=o){i.push(encodeChunk(e,u,u+o>a?a:u+o))}if(n===1){r=e[f-1];i.push(t[r>>2]+t[r<<4&63]+"==")}else if(n===2){r=(e[f-2]<<8)+e[f-1];i.push(t[r>>10]+t[r>>4&63]+t[r<<2&63]+"=")}return i.join("")}},72:function(e,r,t){"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */var f=t(675);var n=t(783);var i=typeof Symbol==="function"&&typeof Symbol.for==="function"?Symbol.for("nodejs.util.inspect.custom"):null;r.Buffer=Buffer;r.SlowBuffer=SlowBuffer;r.INSPECT_MAX_BYTES=50;var o=2147483647;r.kMaxLength=o;Buffer.TYPED_ARRAY_SUPPORT=typedArraySupport();if(!Buffer.TYPED_ARRAY_SUPPORT&&typeof console!=="undefined"&&typeof console.error==="function"){console.error("This browser lacks typed array (Uint8Array) support which is required by "+"`buffer` v5.x. Use `buffer` v4.x if you require old browser support.")}function typedArraySupport(){try{var e=new Uint8Array(1);var r={foo:function(){return 42}};Object.setPrototypeOf(r,Uint8Array.prototype);Object.setPrototypeOf(e,r);return e.foo()===42}catch(e){return false}}Object.defineProperty(Buffer.prototype,"parent",{enumerable:true,get:function(){if(!Buffer.isBuffer(this))return undefined;return this.buffer}});Object.defineProperty(Buffer.prototype,"offset",{enumerable:true,get:function(){if(!Buffer.isBuffer(this))return undefined;return this.byteOffset}});function createBuffer(e){if(e>o){throw new RangeError('The value "'+e+'" is invalid for option "size"')}var r=new Uint8Array(e);Object.setPrototypeOf(r,Buffer.prototype);return r}function Buffer(e,r,t){if(typeof e==="number"){if(typeof r==="string"){throw new TypeError('The "string" argument must be of type string. Received type number')}return allocUnsafe(e)}return from(e,r,t)}Buffer.poolSize=8192;function from(e,r,t){if(typeof e==="string"){return fromString(e,r)}if(ArrayBuffer.isView(e)){return fromArrayLike(e)}if(e==null){throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, "+"or Array-like Object. Received type "+typeof e)}if(isInstance(e,ArrayBuffer)||e&&isInstance(e.buffer,ArrayBuffer)){return fromArrayBuffer(e,r,t)}if(typeof SharedArrayBuffer!=="undefined"&&(isInstance(e,SharedArrayBuffer)||e&&isInstance(e.buffer,SharedArrayBuffer))){return fromArrayBuffer(e,r,t)}if(typeof e==="number"){throw new TypeError('The "value" argument must not be of type number. Received type number')}var f=e.valueOf&&e.valueOf();if(f!=null&&f!==e){return Buffer.from(f,r,t)}var n=fromObject(e);if(n)return n;if(typeof Symbol!=="undefined"&&Symbol.toPrimitive!=null&&typeof e[Symbol.toPrimitive]==="function"){return Buffer.from(e[Symbol.toPrimitive]("string"),r,t)}throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, "+"or Array-like Object. Received type "+typeof e)}Buffer.from=function(e,r,t){return from(e,r,t)};Object.setPrototypeOf(Buffer.prototype,Uint8Array.prototype);Object.setPrototypeOf(Buffer,Uint8Array);function assertSize(e){if(typeof e!=="number"){throw new TypeError('"size" argument must be of type number')}else if(e<0){throw new RangeError('The value "'+e+'" is invalid for option "size"')}}function alloc(e,r,t){assertSize(e);if(e<=0){return createBuffer(e)}if(r!==undefined){return typeof t==="string"?createBuffer(e).fill(r,t):createBuffer(e).fill(r)}return createBuffer(e)}Buffer.alloc=function(e,r,t){return alloc(e,r,t)};function allocUnsafe(e){assertSize(e);return createBuffer(e<0?0:checked(e)|0)}Buffer.allocUnsafe=function(e){return allocUnsafe(e)};Buffer.allocUnsafeSlow=function(e){return allocUnsafe(e)};function fromString(e,r){if(typeof r!=="string"||r===""){r="utf8"}if(!Buffer.isEncoding(r)){throw new TypeError("Unknown encoding: "+r)}var t=byteLength(e,r)|0;var f=createBuffer(t);var n=f.write(e,r);if(n!==t){f=f.slice(0,n)}return f}function fromArrayLike(e){var r=e.length<0?0:checked(e.length)|0;var t=createBuffer(r);for(var f=0;f<r;f+=1){t[f]=e[f]&255}return t}function fromArrayBuffer(e,r,t){if(r<0||e.byteLength<r){throw new RangeError('"offset" is outside of buffer bounds')}if(e.byteLength<r+(t||0)){throw new RangeError('"length" is outside of buffer bounds')}var f;if(r===undefined&&t===undefined){f=new Uint8Array(e)}else if(t===undefined){f=new Uint8Array(e,r)}else{f=new Uint8Array(e,r,t)}Object.setPrototypeOf(f,Buffer.prototype);return f}function fromObject(e){if(Buffer.isBuffer(e)){var r=checked(e.length)|0;var t=createBuffer(r);if(t.length===0){return t}e.copy(t,0,0,r);return t}if(e.length!==undefined){if(typeof e.length!=="number"||numberIsNaN(e.length)){return createBuffer(0)}return fromArrayLike(e)}if(e.type==="Buffer"&&Array.isArray(e.data)){return fromArrayLike(e.data)}}function checked(e){if(e>=o){throw new RangeError("Attempt to allocate Buffer larger than maximum "+"size: 0x"+o.toString(16)+" bytes")}return e|0}function SlowBuffer(e){if(+e!=e){e=0}return Buffer.alloc(+e)}Buffer.isBuffer=function isBuffer(e){return e!=null&&e._isBuffer===true&&e!==Buffer.prototype};Buffer.compare=function compare(e,r){if(isInstance(e,Uint8Array))e=Buffer.from(e,e.offset,e.byteLength);if(isInstance(r,Uint8Array))r=Buffer.from(r,r.offset,r.byteLength);if(!Buffer.isBuffer(e)||!Buffer.isBuffer(r)){throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array')}if(e===r)return 0;var t=e.length;var f=r.length;for(var n=0,i=Math.min(t,f);n<i;++n){if(e[n]!==r[n]){t=e[n];f=r[n];break}}if(t<f)return-1;if(f<t)return 1;return 0};Buffer.isEncoding=function isEncoding(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return true;default:return false}};Buffer.concat=function concat(e,r){if(!Array.isArray(e)){throw new TypeError('"list" argument must be an Array of Buffers')}if(e.length===0){return Buffer.alloc(0)}var t;if(r===undefined){r=0;for(t=0;t<e.length;++t){r+=e[t].length}}var f=Buffer.allocUnsafe(r);var n=0;for(t=0;t<e.length;++t){var i=e[t];if(isInstance(i,Uint8Array)){i=Buffer.from(i)}if(!Buffer.isBuffer(i)){throw new TypeError('"list" argument must be an Array of Buffers')}i.copy(f,n);n+=i.length}return f};function byteLength(e,r){if(Buffer.isBuffer(e)){return e.length}if(ArrayBuffer.isView(e)||isInstance(e,ArrayBuffer)){return e.byteLength}if(typeof e!=="string"){throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. '+"Received type "+typeof e)}var t=e.length;var f=arguments.length>2&&arguments[2]===true;if(!f&&t===0)return 0;var n=false;for(;;){switch(r){case"ascii":case"latin1":case"binary":return t;case"utf8":case"utf-8":return utf8ToBytes(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return t*2;case"hex":return t>>>1;case"base64":return base64ToBytes(e).length;default:if(n){return f?-1:utf8ToBytes(e).length}r=(""+r).toLowerCase();n=true}}}Buffer.byteLength=byteLength;function slowToString(e,r,t){var f=false;if(r===undefined||r<0){r=0}if(r>this.length){return""}if(t===undefined||t>this.length){t=this.length}if(t<=0){return""}t>>>=0;r>>>=0;if(t<=r){return""}if(!e)e="utf8";while(true){switch(e){case"hex":return hexSlice(this,r,t);case"utf8":case"utf-8":return utf8Slice(this,r,t);case"ascii":return asciiSlice(this,r,t);case"latin1":case"binary":return latin1Slice(this,r,t);case"base64":return base64Slice(this,r,t);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return utf16leSlice(this,r,t);default:if(f)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase();f=true}}}Buffer.prototype._isBuffer=true;function swap(e,r,t){var f=e[r];e[r]=e[t];e[t]=f}Buffer.prototype.swap16=function swap16(){var e=this.length;if(e%2!==0){throw new RangeError("Buffer size must be a multiple of 16-bits")}for(var r=0;r<e;r+=2){swap(this,r,r+1)}return this};Buffer.prototype.swap32=function swap32(){var e=this.length;if(e%4!==0){throw new RangeError("Buffer size must be a multiple of 32-bits")}for(var r=0;r<e;r+=4){swap(this,r,r+3);swap(this,r+1,r+2)}return this};Buffer.prototype.swap64=function swap64(){var e=this.length;if(e%8!==0){throw new RangeError("Buffer size must be a multiple of 64-bits")}for(var r=0;r<e;r+=8){swap(this,r,r+7);swap(this,r+1,r+6);swap(this,r+2,r+5);swap(this,r+3,r+4)}return this};Buffer.prototype.toString=function toString(){var e=this.length;if(e===0)return"";if(arguments.length===0)return utf8Slice(this,0,e);return slowToString.apply(this,arguments)};Buffer.prototype.toLocaleString=Buffer.prototype.toString;Buffer.prototype.equals=function equals(e){if(!Buffer.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(this===e)return true;return Buffer.compare(this,e)===0};Buffer.prototype.inspect=function inspect(){var e="";var t=r.INSPECT_MAX_BYTES;e=this.toString("hex",0,t).replace(/(.{2})/g,"$1 ").trim();if(this.length>t)e+=" ... ";return"<Buffer "+e+">"};if(i){Buffer.prototype[i]=Buffer.prototype.inspect}Buffer.prototype.compare=function compare(e,r,t,f,n){if(isInstance(e,Uint8Array)){e=Buffer.from(e,e.offset,e.byteLength)}if(!Buffer.isBuffer(e)){throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. '+"Received type "+typeof e)}if(r===undefined){r=0}if(t===undefined){t=e?e.length:0}if(f===undefined){f=0}if(n===undefined){n=this.length}if(r<0||t>e.length||f<0||n>this.length){throw new RangeError("out of range index")}if(f>=n&&r>=t){return 0}if(f>=n){return-1}if(r>=t){return 1}r>>>=0;t>>>=0;f>>>=0;n>>>=0;if(this===e)return 0;var i=n-f;var o=t-r;var u=Math.min(i,o);var a=this.slice(f,n);var s=e.slice(r,t);for(var h=0;h<u;++h){if(a[h]!==s[h]){i=a[h];o=s[h];break}}if(i<o)return-1;if(o<i)return 1;return 0};function bidirectionalIndexOf(e,r,t,f,n){if(e.length===0)return-1;if(typeof t==="string"){f=t;t=0}else if(t>2147483647){t=2147483647}else if(t<-2147483648){t=-2147483648}t=+t;if(numberIsNaN(t)){t=n?0:e.length-1}if(t<0)t=e.length+t;if(t>=e.length){if(n)return-1;else t=e.length-1}else if(t<0){if(n)t=0;else return-1}if(typeof r==="string"){r=Buffer.from(r,f)}if(Buffer.isBuffer(r)){if(r.length===0){return-1}return arrayIndexOf(e,r,t,f,n)}else if(typeof r==="number"){r=r&255;if(typeof Uint8Array.prototype.indexOf==="function"){if(n){return Uint8Array.prototype.indexOf.call(e,r,t)}else{return Uint8Array.prototype.lastIndexOf.call(e,r,t)}}return arrayIndexOf(e,[r],t,f,n)}throw new TypeError("val must be string, number or Buffer")}function arrayIndexOf(e,r,t,f,n){var i=1;var o=e.length;var u=r.length;if(f!==undefined){f=String(f).toLowerCase();if(f==="ucs2"||f==="ucs-2"||f==="utf16le"||f==="utf-16le"){if(e.length<2||r.length<2){return-1}i=2;o/=2;u/=2;t/=2}}function read(e,r){if(i===1){return e[r]}else{return e.readUInt16BE(r*i)}}var a;if(n){var s=-1;for(a=t;a<o;a++){if(read(e,a)===read(r,s===-1?0:a-s)){if(s===-1)s=a;if(a-s+1===u)return s*i}else{if(s!==-1)a-=a-s;s=-1}}}else{if(t+u>o)t=o-u;for(a=t;a>=0;a--){var h=true;for(var c=0;c<u;c++){if(read(e,a+c)!==read(r,c)){h=false;break}}if(h)return a}}return-1}Buffer.prototype.includes=function includes(e,r,t){return this.indexOf(e,r,t)!==-1};Buffer.prototype.indexOf=function indexOf(e,r,t){return bidirectionalIndexOf(this,e,r,t,true)};Buffer.prototype.lastIndexOf=function lastIndexOf(e,r,t){return bidirectionalIndexOf(this,e,r,t,false)};function hexWrite(e,r,t,f){t=Number(t)||0;var n=e.length-t;if(!f){f=n}else{f=Number(f);if(f>n){f=n}}var i=r.length;if(f>i/2){f=i/2}for(var o=0;o<f;++o){var u=parseInt(r.substr(o*2,2),16);if(numberIsNaN(u))return o;e[t+o]=u}return o}function utf8Write(e,r,t,f){return blitBuffer(utf8ToBytes(r,e.length-t),e,t,f)}function asciiWrite(e,r,t,f){return blitBuffer(asciiToBytes(r),e,t,f)}function latin1Write(e,r,t,f){return asciiWrite(e,r,t,f)}function base64Write(e,r,t,f){return blitBuffer(base64ToBytes(r),e,t,f)}function ucs2Write(e,r,t,f){return blitBuffer(utf16leToBytes(r,e.length-t),e,t,f)}Buffer.prototype.write=function write(e,r,t,f){if(r===undefined){f="utf8";t=this.length;r=0}else if(t===undefined&&typeof r==="string"){f=r;t=this.length;r=0}else if(isFinite(r)){r=r>>>0;if(isFinite(t)){t=t>>>0;if(f===undefined)f="utf8"}else{f=t;t=undefined}}else{throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported")}var n=this.length-r;if(t===undefined||t>n)t=n;if(e.length>0&&(t<0||r<0)||r>this.length){throw new RangeError("Attempt to write outside buffer bounds")}if(!f)f="utf8";var i=false;for(;;){switch(f){case"hex":return hexWrite(this,e,r,t);case"utf8":case"utf-8":return utf8Write(this,e,r,t);case"ascii":return asciiWrite(this,e,r,t);case"latin1":case"binary":return latin1Write(this,e,r,t);case"base64":return base64Write(this,e,r,t);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return ucs2Write(this,e,r,t);default:if(i)throw new TypeError("Unknown encoding: "+f);f=(""+f).toLowerCase();i=true}}};Buffer.prototype.toJSON=function toJSON(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};function base64Slice(e,r,t){if(r===0&&t===e.length){return f.fromByteArray(e)}else{return f.fromByteArray(e.slice(r,t))}}function utf8Slice(e,r,t){t=Math.min(e.length,t);var f=[];var n=r;while(n<t){var i=e[n];var o=null;var u=i>239?4:i>223?3:i>191?2:1;if(n+u<=t){var a,s,h,c;switch(u){case 1:if(i<128){o=i}break;case 2:a=e[n+1];if((a&192)===128){c=(i&31)<<6|a&63;if(c>127){o=c}}break;case 3:a=e[n+1];s=e[n+2];if((a&192)===128&&(s&192)===128){c=(i&15)<<12|(a&63)<<6|s&63;if(c>2047&&(c<55296||c>57343)){o=c}}break;case 4:a=e[n+1];s=e[n+2];h=e[n+3];if((a&192)===128&&(s&192)===128&&(h&192)===128){c=(i&15)<<18|(a&63)<<12|(s&63)<<6|h&63;if(c>65535&&c<1114112){o=c}}}}if(o===null){o=65533;u=1}else if(o>65535){o-=65536;f.push(o>>>10&1023|55296);o=56320|o&1023}f.push(o);n+=u}return decodeCodePointsArray(f)}var u=4096;function decodeCodePointsArray(e){var r=e.length;if(r<=u){return String.fromCharCode.apply(String,e)}var t="";var f=0;while(f<r){t+=String.fromCharCode.apply(String,e.slice(f,f+=u))}return t}function asciiSlice(e,r,t){var f="";t=Math.min(e.length,t);for(var n=r;n<t;++n){f+=String.fromCharCode(e[n]&127)}return f}function latin1Slice(e,r,t){var f="";t=Math.min(e.length,t);for(var n=r;n<t;++n){f+=String.fromCharCode(e[n])}return f}function hexSlice(e,r,t){var f=e.length;if(!r||r<0)r=0;if(!t||t<0||t>f)t=f;var n="";for(var i=r;i<t;++i){n+=s[e[i]]}return n}function utf16leSlice(e,r,t){var f=e.slice(r,t);var n="";for(var i=0;i<f.length;i+=2){n+=String.fromCharCode(f[i]+f[i+1]*256)}return n}Buffer.prototype.slice=function slice(e,r){var t=this.length;e=~~e;r=r===undefined?t:~~r;if(e<0){e+=t;if(e<0)e=0}else if(e>t){e=t}if(r<0){r+=t;if(r<0)r=0}else if(r>t){r=t}if(r<e)r=e;var f=this.subarray(e,r);Object.setPrototypeOf(f,Buffer.prototype);return f};function checkOffset(e,r,t){if(e%1!==0||e<0)throw new RangeError("offset is not uint");if(e+r>t)throw new RangeError("Trying to access beyond buffer length")}Buffer.prototype.readUIntLE=function readUIntLE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=this[e];var n=1;var i=0;while(++i<r&&(n*=256)){f+=this[e+i]*n}return f};Buffer.prototype.readUIntBE=function readUIntBE(e,r,t){e=e>>>0;r=r>>>0;if(!t){checkOffset(e,r,this.length)}var f=this[e+--r];var n=1;while(r>0&&(n*=256)){f+=this[e+--r]*n}return f};Buffer.prototype.readUInt8=function readUInt8(e,r){e=e>>>0;if(!r)checkOffset(e,1,this.length);return this[e]};Buffer.prototype.readUInt16LE=function readUInt16LE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);return this[e]|this[e+1]<<8};Buffer.prototype.readUInt16BE=function readUInt16BE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);return this[e]<<8|this[e+1]};Buffer.prototype.readUInt32LE=function readUInt32LE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return(this[e]|this[e+1]<<8|this[e+2]<<16)+this[e+3]*16777216};Buffer.prototype.readUInt32BE=function readUInt32BE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]*16777216+(this[e+1]<<16|this[e+2]<<8|this[e+3])};Buffer.prototype.readIntLE=function readIntLE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=this[e];var n=1;var i=0;while(++i<r&&(n*=256)){f+=this[e+i]*n}n*=128;if(f>=n)f-=Math.pow(2,8*r);return f};Buffer.prototype.readIntBE=function readIntBE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=r;var n=1;var i=this[e+--f];while(f>0&&(n*=256)){i+=this[e+--f]*n}n*=128;if(i>=n)i-=Math.pow(2,8*r);return i};Buffer.prototype.readInt8=function readInt8(e,r){e=e>>>0;if(!r)checkOffset(e,1,this.length);if(!(this[e]&128))return this[e];return(255-this[e]+1)*-1};Buffer.prototype.readInt16LE=function readInt16LE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);var t=this[e]|this[e+1]<<8;return t&32768?t|4294901760:t};Buffer.prototype.readInt16BE=function readInt16BE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);var t=this[e+1]|this[e]<<8;return t&32768?t|4294901760:t};Buffer.prototype.readInt32LE=function readInt32LE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24};Buffer.prototype.readInt32BE=function readInt32BE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]};Buffer.prototype.readFloatLE=function readFloatLE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return n.read(this,e,true,23,4)};Buffer.prototype.readFloatBE=function readFloatBE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return n.read(this,e,false,23,4)};Buffer.prototype.readDoubleLE=function readDoubleLE(e,r){e=e>>>0;if(!r)checkOffset(e,8,this.length);return n.read(this,e,true,52,8)};Buffer.prototype.readDoubleBE=function readDoubleBE(e,r){e=e>>>0;if(!r)checkOffset(e,8,this.length);return n.read(this,e,false,52,8)};function checkInt(e,r,t,f,n,i){if(!Buffer.isBuffer(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(r>n||r<i)throw new RangeError('"value" argument is out of bounds');if(t+f>e.length)throw new RangeError("Index out of range")}Buffer.prototype.writeUIntLE=function writeUIntLE(e,r,t,f){e=+e;r=r>>>0;t=t>>>0;if(!f){var n=Math.pow(2,8*t)-1;checkInt(this,e,r,t,n,0)}var i=1;var o=0;this[r]=e&255;while(++o<t&&(i*=256)){this[r+o]=e/i&255}return r+t};Buffer.prototype.writeUIntBE=function writeUIntBE(e,r,t,f){e=+e;r=r>>>0;t=t>>>0;if(!f){var n=Math.pow(2,8*t)-1;checkInt(this,e,r,t,n,0)}var i=t-1;var o=1;this[r+i]=e&255;while(--i>=0&&(o*=256)){this[r+i]=e/o&255}return r+t};Buffer.prototype.writeUInt8=function writeUInt8(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,1,255,0);this[r]=e&255;return r+1};Buffer.prototype.writeUInt16LE=function writeUInt16LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,65535,0);this[r]=e&255;this[r+1]=e>>>8;return r+2};Buffer.prototype.writeUInt16BE=function writeUInt16BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,65535,0);this[r]=e>>>8;this[r+1]=e&255;return r+2};Buffer.prototype.writeUInt32LE=function writeUInt32LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,4294967295,0);this[r+3]=e>>>24;this[r+2]=e>>>16;this[r+1]=e>>>8;this[r]=e&255;return r+4};Buffer.prototype.writeUInt32BE=function writeUInt32BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,4294967295,0);this[r]=e>>>24;this[r+1]=e>>>16;this[r+2]=e>>>8;this[r+3]=e&255;return r+4};Buffer.prototype.writeIntLE=function writeIntLE(e,r,t,f){e=+e;r=r>>>0;if(!f){var n=Math.pow(2,8*t-1);checkInt(this,e,r,t,n-1,-n)}var i=0;var o=1;var u=0;this[r]=e&255;while(++i<t&&(o*=256)){if(e<0&&u===0&&this[r+i-1]!==0){u=1}this[r+i]=(e/o>>0)-u&255}return r+t};Buffer.prototype.writeIntBE=function writeIntBE(e,r,t,f){e=+e;r=r>>>0;if(!f){var n=Math.pow(2,8*t-1);checkInt(this,e,r,t,n-1,-n)}var i=t-1;var o=1;var u=0;this[r+i]=e&255;while(--i>=0&&(o*=256)){if(e<0&&u===0&&this[r+i+1]!==0){u=1}this[r+i]=(e/o>>0)-u&255}return r+t};Buffer.prototype.writeInt8=function writeInt8(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,1,127,-128);if(e<0)e=255+e+1;this[r]=e&255;return r+1};Buffer.prototype.writeInt16LE=function writeInt16LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,32767,-32768);this[r]=e&255;this[r+1]=e>>>8;return r+2};Buffer.prototype.writeInt16BE=function writeInt16BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,32767,-32768);this[r]=e>>>8;this[r+1]=e&255;return r+2};Buffer.prototype.writeInt32LE=function writeInt32LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,2147483647,-2147483648);this[r]=e&255;this[r+1]=e>>>8;this[r+2]=e>>>16;this[r+3]=e>>>24;return r+4};Buffer.prototype.writeInt32BE=function writeInt32BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,2147483647,-2147483648);if(e<0)e=4294967295+e+1;this[r]=e>>>24;this[r+1]=e>>>16;this[r+2]=e>>>8;this[r+3]=e&255;return r+4};function checkIEEE754(e,r,t,f,n,i){if(t+f>e.length)throw new RangeError("Index out of range");if(t<0)throw new RangeError("Index out of range")}function writeFloat(e,r,t,f,i){r=+r;t=t>>>0;if(!i){checkIEEE754(e,r,t,4,34028234663852886e22,-34028234663852886e22)}n.write(e,r,t,f,23,4);return t+4}Buffer.prototype.writeFloatLE=function writeFloatLE(e,r,t){return writeFloat(this,e,r,true,t)};Buffer.prototype.writeFloatBE=function writeFloatBE(e,r,t){return writeFloat(this,e,r,false,t)};function writeDouble(e,r,t,f,i){r=+r;t=t>>>0;if(!i){checkIEEE754(e,r,t,8,17976931348623157e292,-17976931348623157e292)}n.write(e,r,t,f,52,8);return t+8}Buffer.prototype.writeDoubleLE=function writeDoubleLE(e,r,t){return writeDouble(this,e,r,true,t)};Buffer.prototype.writeDoubleBE=function writeDoubleBE(e,r,t){return writeDouble(this,e,r,false,t)};Buffer.prototype.copy=function copy(e,r,t,f){if(!Buffer.isBuffer(e))throw new TypeError("argument should be a Buffer");if(!t)t=0;if(!f&&f!==0)f=this.length;if(r>=e.length)r=e.length;if(!r)r=0;if(f>0&&f<t)f=t;if(f===t)return 0;if(e.length===0||this.length===0)return 0;if(r<0){throw new RangeError("targetStart out of bounds")}if(t<0||t>=this.length)throw new RangeError("Index out of range");if(f<0)throw new RangeError("sourceEnd out of bounds");if(f>this.length)f=this.length;if(e.length-r<f-t){f=e.length-r+t}var n=f-t;if(this===e&&typeof Uint8Array.prototype.copyWithin==="function"){this.copyWithin(r,t,f)}else if(this===e&&t<r&&r<f){for(var i=n-1;i>=0;--i){e[i+r]=this[i+t]}}else{Uint8Array.prototype.set.call(e,this.subarray(t,f),r)}return n};Buffer.prototype.fill=function fill(e,r,t,f){if(typeof e==="string"){if(typeof r==="string"){f=r;r=0;t=this.length}else if(typeof t==="string"){f=t;t=this.length}if(f!==undefined&&typeof f!=="string"){throw new TypeError("encoding must be a string")}if(typeof f==="string"&&!Buffer.isEncoding(f)){throw new TypeError("Unknown encoding: "+f)}if(e.length===1){var n=e.charCodeAt(0);if(f==="utf8"&&n<128||f==="latin1"){e=n}}}else if(typeof e==="number"){e=e&255}else if(typeof e==="boolean"){e=Number(e)}if(r<0||this.length<r||this.length<t){throw new RangeError("Out of range index")}if(t<=r){return this}r=r>>>0;t=t===undefined?this.length:t>>>0;if(!e)e=0;var i;if(typeof e==="number"){for(i=r;i<t;++i){this[i]=e}}else{var o=Buffer.isBuffer(e)?e:Buffer.from(e,f);var u=o.length;if(u===0){throw new TypeError('The value "'+e+'" is invalid for argument "value"')}for(i=0;i<t-r;++i){this[i+r]=o[i%u]}}return this};var a=/[^+/0-9A-Za-z-_]/g;function base64clean(e){e=e.split("=")[0];e=e.trim().replace(a,"");if(e.length<2)return"";while(e.length%4!==0){e=e+"="}return e}function utf8ToBytes(e,r){r=r||Infinity;var t;var f=e.length;var n=null;var i=[];for(var o=0;o<f;++o){t=e.charCodeAt(o);if(t>55295&&t<57344){if(!n){if(t>56319){if((r-=3)>-1)i.push(239,191,189);continue}else if(o+1===f){if((r-=3)>-1)i.push(239,191,189);continue}n=t;continue}if(t<56320){if((r-=3)>-1)i.push(239,191,189);n=t;continue}t=(n-55296<<10|t-56320)+65536}else if(n){if((r-=3)>-1)i.push(239,191,189)}n=null;if(t<128){if((r-=1)<0)break;i.push(t)}else if(t<2048){if((r-=2)<0)break;i.push(t>>6|192,t&63|128)}else if(t<65536){if((r-=3)<0)break;i.push(t>>12|224,t>>6&63|128,t&63|128)}else if(t<1114112){if((r-=4)<0)break;i.push(t>>18|240,t>>12&63|128,t>>6&63|128,t&63|128)}else{throw new Error("Invalid code point")}}return i}function asciiToBytes(e){var r=[];for(var t=0;t<e.length;++t){r.push(e.charCodeAt(t)&255)}return r}function utf16leToBytes(e,r){var t,f,n;var i=[];for(var o=0;o<e.length;++o){if((r-=2)<0)break;t=e.charCodeAt(o);f=t>>8;n=t%256;i.push(n);i.push(f)}return i}function base64ToBytes(e){return f.toByteArray(base64clean(e))}function blitBuffer(e,r,t,f){for(var n=0;n<f;++n){if(n+t>=r.length||n>=e.length)break;r[n+t]=e[n]}return n}function isInstance(e,r){return e instanceof r||e!=null&&e.constructor!=null&&e.constructor.name!=null&&e.constructor.name===r.name}function numberIsNaN(e){return e!==e}var s=function(){var e="0123456789abcdef";var r=new Array(256);for(var t=0;t<16;++t){var f=t*16;for(var n=0;n<16;++n){r[f+n]=e[t]+e[n]}}return r}()},783:function(e,r){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
r.read=function(e,r,t,f,n){var i,o;var u=n*8-f-1;var a=(1<<u)-1;var s=a>>1;var h=-7;var c=t?n-1:0;var l=t?-1:1;var p=e[r+c];c+=l;i=p&(1<<-h)-1;p>>=-h;h+=u;for(;h>0;i=i*256+e[r+c],c+=l,h-=8){}o=i&(1<<-h)-1;i>>=-h;h+=f;for(;h>0;o=o*256+e[r+c],c+=l,h-=8){}if(i===0){i=1-s}else if(i===a){return o?NaN:(p?-1:1)*Infinity}else{o=o+Math.pow(2,f);i=i-s}return(p?-1:1)*o*Math.pow(2,i-f)};r.write=function(e,r,t,f,n,i){var o,u,a;var s=i*8-n-1;var h=(1<<s)-1;var c=h>>1;var l=n===23?Math.pow(2,-24)-Math.pow(2,-77):0;var p=f?0:i-1;var y=f?1:-1;var g=r<0||r===0&&1/r<0?1:0;r=Math.abs(r);if(isNaN(r)||r===Infinity){u=isNaN(r)?1:0;o=h}else{o=Math.floor(Math.log(r)/Math.LN2);if(r*(a=Math.pow(2,-o))<1){o--;a*=2}if(o+c>=1){r+=l/a}else{r+=l*Math.pow(2,1-c)}if(r*a>=2){o++;a/=2}if(o+c>=h){u=0;o=h}else if(o+c>=1){u=(r*a-1)*Math.pow(2,n);o=o+c}else{u=r*Math.pow(2,c-1)*Math.pow(2,n);o=0}}for(;n>=8;e[t+p]=u&255,p+=y,u/=256,n-=8){}o=o<<n|u;s+=n;for(;s>0;e[t+p]=o&255,p+=y,o/=256,s-=8){}e[t+p-y]|=g*128}}};var r={};function __nccwpck_require__(t){var f=r[t];if(f!==undefined){return f.exports}var n=r[t]={exports:{}};var i=true;try{e[t](n,n.exports,__nccwpck_require__);i=false}finally{if(i)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(72);module.exports=t})();

/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;__webpack_unused_export__=B;__webpack_unused_export__=C;__webpack_unused_export__=D;__webpack_unused_export__=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
exports.typeOf=y;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 96774:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 19521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vJ": function() { return /* binding */ $e; },
  "iv": function() { return /* binding */ Ae; },
  "ZP": function() { return /* binding */ styled_components_browser_esm; },
  "F4": function() { return /* binding */ We; }
});

// UNUSED EXPORTS: ServerStyleSheet, StyleSheetConsumer, StyleSheetContext, StyleSheetManager, ThemeConsumer, ThemeContext, ThemeProvider, __PRIVATE__, isStyledComponent, useTheme, version, withTheme

// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(96774);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
;// CONCATENATED MODULE: ./node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

;// CONCATENATED MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var emotion_memoize_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */emotion_memoize_esm(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var emotion_is_prop_valid_esm = (isPropValid);

// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(83454);
function y(){return(y=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var v=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},g=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!(0,react_is.typeOf)(t)},S=Object.freeze([]),w=Object.freeze({});function E(e){return"function"==typeof e}function b(e){return false||e.displayName||e.name||"Component"}function _(e){return e&&"string"==typeof e.styledComponentId}var N="undefined"!=typeof process&&void 0!==process.env&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",A="5.3.11",C="undefined"!=typeof window&&"HTMLElement"in window,I=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&(void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production")),P={},O= false?0:{};function R(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function D(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var j=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&D(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),T=new Map,x=new Map,k=1,V=function(e){if(T.has(e))return T.get(e);for(;x.has(k);)k++;var t=k++;return false&&0,T.set(e,t),x.set(t,e),t},B=function(e){return x.get(e)},z=function(e,t){t>=k&&(k=t+1),T.set(e,t),x.set(t,e)},M="style["+N+'][data-styled-version="5.3.11"]',G=new RegExp("^"+N+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),L=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},F=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(G);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(z(u,c),L(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},Y=function(){return true?__webpack_require__.nc:0},q=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(N))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(N,"active"),r.setAttribute("data-styled-version","5.3.11");var i=Y();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},H=function(){function e(e){var t=this.element=q(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}D(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),$=function(){function e(e){var t=this.element=q(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),W=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),U=C,J={isServer:!C,useCSSOMInjection:!I},X=function(){function e(e,t,n){void 0===e&&(e=w),void 0===t&&(t={}),this.options=y({},J,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&C&&U&&(U=!1,function(e){for(var t=document.querySelectorAll(M),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(N)&&(F(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return V(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(y({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new W(o):r?new H(o):new $(o),new j(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(V(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(V(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(V(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=B(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=N+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),Z=/(a)(d)/gi,K=function(e){return String.fromCharCode(e+(e>25?39:97))};function Q(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=K(t%52)+n;return(K(t%52)+n).replace(Z,"$1-$2")}var ee=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},te=function(e){return ee(5381,e)};function ne(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(E(n)&&!_(n))return!1}return!0}var re=te("5.3.11"),oe=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&ne(e),this.componentId=t,this.baseHash=ee(re,t),this.baseStyle=n,X.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=_e(this.rules,e,t,n).join(""),i=Q(ee(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=ee(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=_e(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=ee(u,f+d),l+=f}}if(l){var m=Q(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),se=/^\s*\/\/.*$/gm,ie=[":","[",".","#"];function ae(e){var t,n,r,o,s=void 0===e?w:e,i=s.options,a=void 0===i?w:i,c=s.plugins,u=void 0===c?S:c,l=new stylis_browser_esm(a),d=[],p=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ie.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(se,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},p,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||D(15),ee(e,t.name)}),5381).toString():"",m}var ce=react.createContext(),ue=ce.Consumer,le=react.createContext(),de=(le.Consumer,new X),he=ae();function pe(){return (0,react.useContext)(ce)||de}function fe(){return (0,react.useContext)(le)||he}function me(e){var t=(0,react.useState)(e.stylisPlugins),n=t[0],s=t[1],c=pe(),u=(0,react.useMemo)((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=(0,react.useMemo)((function(){return ae({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return (0,react.useEffect)((function(){shallowequal_default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),react.createElement(ce.Provider,{value:u},react.createElement(le.Provider,{value:l}, false?0:e.children))}var ye=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=he);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return D(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=he),this.name+e.hash},e}(),ve=/([A-Z])/,ge=/([A-Z])/g,Se=/^ms-/,we=function(e){return"-"+e.toLowerCase()};function Ee(e){return ve.test(e)?e.replace(ge,we).replace(Se,"-ms-"):e}var be=function(e){return null==e||!1===e||""===e};function _e(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=_e(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(be(e))return"";if(_(e))return"."+e.styledComponentId;if(E(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return false&&0,_e(u,n,r,o)}var l;return e instanceof ye?r?(e.inject(r,o),e.getName(o)):e:g(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!be(t[i])&&(Array.isArray(t[i])&&t[i].isCss||E(t[i])?s.push(Ee(i)+":",t[i],";"):g(t[i])?s.push.apply(s,e(t[i],i)):s.push(Ee(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitless_browser_esm||r.startsWith("--")?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ne=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ae(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return E(e)||g(e)?Ne(_e(v(S,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ne(_e(v(e,n)))}var Ce=/invalid hook call/i,Ie=new Set,Pe=function(e,t){if(false){ var o, n, r; }},Oe=function(e,t,n){return void 0===n&&(n=w),e.theme!==n.theme&&e.theme||t||n.theme},Re=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,De=/(^-|-$)/g;function je(e){return e.replace(Re,"-").replace(De,"")}var Te=function(e){return Q(te(e)>>>0)};function xe(e){return"string"==typeof e&&( true||0)}var ke=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Ve=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function Be(e,t,n){var r=e[n];ke(t)&&ke(r)?ze(r,t):e[n]=t}function ze(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(ke(i))for(var a in i)Ve(a)&&Be(e,i[a],a)}return e}var Me=react.createContext(),Ge=Me.Consumer;function Le(e){var t=s(Me),n=i((function(){return function(e,t){if(!e)return D(14);if(E(e)){var n=e(t);return true?n:0}return Array.isArray(e)||"object"!=typeof e?D(8):t?y({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?r.createElement(Me.Provider,{value:n},e.children):null}var Fe={};function Ye(e,t,n){var o=_(e),i=!xe(e),a=t.attrs,c=void 0===a?S:a,l=t.componentId,d=void 0===l?function(e,t){var n="string"!=typeof e?"sc":je(e);Fe[n]=(Fe[n]||0)+1;var r=n+"-"+Te("5.3.11"+n+Fe[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):l,h=t.displayName,p=void 0===h?function(e){return xe(e)?"styled."+e:"Styled("+b(e)+")"}(e):h,v=t.displayName&&t.componentId?je(t.displayName)+"-"+t.componentId:t.componentId||d,g=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,N=t.shouldForwardProp;o&&e.shouldForwardProp&&(N=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var A,C=new oe(n,v,o?e.componentStyle:void 0),I=C.isStatic&&0===c.length,P=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,l=e.shouldForwardProp,d=e.styledComponentId,h=e.target,p=function(e,t,n){void 0===e&&(e=w);var r=y({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in E(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Oe(t,(0,react.useContext)(Me),a)||w,t,o),m=p[0],v=p[1],g=function(e,t,n,r){var o=pe(),s=fe(),i=t?e.generateAndInjectStyles(w,o,s):e.generateAndInjectStyles(n,o,s);return false&&0,i}(i,r,m, false?0:void 0),S=n,b=v.$as||t.$as||v.as||t.as||h,_=xe(b),N=v!==t?y({},t,{},v):t,A={};for(var C in N)"$"!==C[0]&&"as"!==C&&("forwardedAs"===C?A.as=N[C]:(l?l(C,emotion_is_prop_valid_esm,b):!_||emotion_is_prop_valid_esm(C))&&(A[C]=N[C]));return t.style&&v.style!==t.style&&(A.style=y({},t.style,{},v.style)),A.className=Array.prototype.concat(c,d,g!==d?g:null,t.className,v.className).filter(Boolean).join(" "),A.ref=S,(0,react.createElement)(b,A)}(A,e,t,I)};return P.displayName=p,(A=react.forwardRef(P)).attrs=g,A.componentStyle=C,A.displayName=p,A.shouldForwardProp=N,A.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):S,A.styledComponentId=v,A.target=o?e.target:e,A.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(xe(e)?e:je(b(e)));return Ye(e,y({},o,{attrs:g,componentId:s}),n)},Object.defineProperty(A,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?ze({},e.defaultProps,t):t}}), false&&(0),Object.defineProperty(A,"toString",{value:function(){return"."+A.styledComponentId}}),i&&hoist_non_react_statics_cjs_default()(A,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),A}var qe=function(e){return function e(t,r,o){if(void 0===o&&(o=w),!(0,react_is.isValidElementType)(r))return D(1,String(r));var s=function(){return t(r,o,Ae.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,y({},o,{},n))},s.attrs=function(n){return e(t,r,y({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(Ye,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){qe[e]=qe(e)}));var He=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=ne(e),X.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(_e(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&X.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function $e(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ae.apply(void 0,[e].concat(n)),a="sc-global-"+Te(JSON.stringify(i)),u=new He(i,a);function d(e){var t=pe(),n=fe(),o=(0,react.useContext)(Me),d=(0,react.useRef)(t.allocateGSInstance(a)).current;return false&&0, false&&0,t.server&&h(d,e,t,o,n),(0,react.useLayoutEffect)((function(){if(!t.server)return h(d,e,t,o,n),function(){return u.removeStyles(d,t)}}),[d,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,P,n,o);else{var s=y({},t,{theme:Oe(t,r,d.defaultProps)});u.renderStyles(e,s,n,o)}}return false&&0,react.memo(d)}function We(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ae.apply(void 0,[e].concat(n)).join(""),s=Te(o);return new ye(s,o)}var Ue=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=Y();return"<style "+[n&&'nonce="'+n+'"',N+'="true"','data-styled-version="5.3.11"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?D(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return D(2);var n=((t={})[N]="",t["data-styled-version"]="5.3.11",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=Y();return o&&(n.nonce=o),[react.createElement("style",y({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new X({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?D(2):react.createElement(me,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return D(3)},e}(),Je=function(e){var t=r.forwardRef((function(t,n){var o=s(Me),i=e.defaultProps,a=Oe(t,o,i);return false&&0,r.createElement(e,y({},t,{theme:a,ref:n}))}));return m(t,e),t.displayName="WithTheme("+b(e)+")",t},Xe=function(){return s(Me)},Ze={StyleSheet:X,masterSheet:de}; false&&0, false&&(0);/* harmony default export */ var styled_components_browser_esm = (qe);
//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 1280:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports default, masks, i18n, formatTimezone */
var token=/d{1,4}|D{3,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|W{1,2}|[LlopSZN]|"[^"]*"|'[^']*'/g;var timezone=/\b(?:[A-Z]{1,3}[A-Z][TC])(?:[-+]\d{4})?|((?:Australian )?(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time)\b/g;var timezoneClip=/[^-+\dA-Z]/g;function dateFormat(date,mask,utc,gmt){if(arguments.length===1&&typeof date==="string"&&!/\d/.test(date)){mask=date;date=undefined}date=date||date===0?date:new Date;if(!(date instanceof Date)){date=new Date(date)}if(isNaN(date)){throw TypeError("Invalid date")}mask=String(masks[mask]||mask||masks["default"]);var maskSlice=mask.slice(0,4);if(maskSlice==="UTC:"||maskSlice==="GMT:"){mask=mask.slice(4);utc=true;if(maskSlice==="GMT:"){gmt=true}}var _=function _(){return utc?"getUTC":"get"};var _d=function d(){return date[_()+"Date"]()};var D=function D(){return date[_()+"Day"]()};var _m=function m(){return date[_()+"Month"]()};var y=function y(){return date[_()+"FullYear"]()};var _H=function H(){return date[_()+"Hours"]()};var _M=function M(){return date[_()+"Minutes"]()};var _s=function s(){return date[_()+"Seconds"]()};var _L=function L(){return date[_()+"Milliseconds"]()};var _o=function o(){return utc?0:date.getTimezoneOffset()};var _W=function W(){return getWeek(date)};var _N=function N(){return getDayOfWeek(date)};var flags={d:function d(){return _d()},dd:function dd(){return pad(_d())},ddd:function ddd(){return i18n.dayNames[D()]},DDD:function DDD(){return getDayName({y:y(),m:_m(),d:_d(),_:_(),dayName:i18n.dayNames[D()],short:true})},dddd:function dddd(){return i18n.dayNames[D()+7]},DDDD:function DDDD(){return getDayName({y:y(),m:_m(),d:_d(),_:_(),dayName:i18n.dayNames[D()+7]})},m:function m(){return _m()+1},mm:function mm(){return pad(_m()+1)},mmm:function mmm(){return i18n.monthNames[_m()]},mmmm:function mmmm(){return i18n.monthNames[_m()+12]},yy:function yy(){return String(y()).slice(2)},yyyy:function yyyy(){return pad(y(),4)},h:function h(){return _H()%12||12},hh:function hh(){return pad(_H()%12||12)},H:function H(){return _H()},HH:function HH(){return pad(_H())},M:function M(){return _M()},MM:function MM(){return pad(_M())},s:function s(){return _s()},ss:function ss(){return pad(_s())},l:function l(){return pad(_L(),3)},L:function L(){return pad(Math.floor(_L()/10))},t:function t(){return _H()<12?i18n.timeNames[0]:i18n.timeNames[1]},tt:function tt(){return _H()<12?i18n.timeNames[2]:i18n.timeNames[3]},T:function T(){return _H()<12?i18n.timeNames[4]:i18n.timeNames[5]},TT:function TT(){return _H()<12?i18n.timeNames[6]:i18n.timeNames[7]},Z:function Z(){return gmt?"GMT":utc?"UTC":formatTimezone(date)},o:function o(){return(_o()>0?"-":"+")+pad(Math.floor(Math.abs(_o())/60)*100+Math.abs(_o())%60,4)},p:function p(){return(_o()>0?"-":"+")+pad(Math.floor(Math.abs(_o())/60),2)+":"+pad(Math.floor(Math.abs(_o())%60),2)},S:function S(){return["th","st","nd","rd"][_d()%10>3?0:(_d()%100-_d()%10!=10)*_d()%10]},W:function W(){return _W()},WW:function WW(){return pad(_W())},N:function N(){return _N()}};return mask.replace(token,function(match){if(match in flags){return flags[match]()}return match.slice(1,match.length-1)})}var masks={default:"ddd mmm dd yyyy HH:MM:ss",shortDate:"m/d/yy",paddedShortDate:"mm/dd/yyyy",mediumDate:"mmm d, yyyy",longDate:"mmmm d, yyyy",fullDate:"dddd, mmmm d, yyyy",shortTime:"h:MM TT",mediumTime:"h:MM:ss TT",longTime:"h:MM:ss TT Z",isoDate:"yyyy-mm-dd",isoTime:"HH:MM:ss",isoDateTime:"yyyy-mm-dd'T'HH:MM:sso",isoUtcDateTime:"UTC:yyyy-mm-dd'T'HH:MM:ss'Z'",expiresHeaderFormat:"ddd, dd mmm yyyy HH:MM:ss Z"};var i18n={dayNames:["Sun","Mon","Tue","Wed","Thu","Fri","Sat","Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],monthNames:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec","January","February","March","April","May","June","July","August","September","October","November","December"],timeNames:["a","p","am","pm","A","P","AM","PM"]};var pad=function pad(val){var len=arguments.length>1&&arguments[1]!==undefined?arguments[1]:2;return String(val).padStart(len,"0")};var getDayName=function getDayName(_ref){var y=_ref.y,m=_ref.m,d=_ref.d,_=_ref._,dayName=_ref.dayName,_ref$short=_ref["short"],_short=_ref$short===void 0?false:_ref$short;var today=new Date;var yesterday=new Date;yesterday.setDate(yesterday[_+"Date"]()-1);var tomorrow=new Date;tomorrow.setDate(tomorrow[_+"Date"]()+1);var today_d=function today_d(){return today[_+"Date"]()};var today_m=function today_m(){return today[_+"Month"]()};var today_y=function today_y(){return today[_+"FullYear"]()};var yesterday_d=function yesterday_d(){return yesterday[_+"Date"]()};var yesterday_m=function yesterday_m(){return yesterday[_+"Month"]()};var yesterday_y=function yesterday_y(){return yesterday[_+"FullYear"]()};var tomorrow_d=function tomorrow_d(){return tomorrow[_+"Date"]()};var tomorrow_m=function tomorrow_m(){return tomorrow[_+"Month"]()};var tomorrow_y=function tomorrow_y(){return tomorrow[_+"FullYear"]()};if(today_y()===y&&today_m()===m&&today_d()===d){return _short?"Tdy":"Today"}else if(yesterday_y()===y&&yesterday_m()===m&&yesterday_d()===d){return _short?"Ysd":"Yesterday"}else if(tomorrow_y()===y&&tomorrow_m()===m&&tomorrow_d()===d){return _short?"Tmw":"Tomorrow"}return dayName};var getWeek=function getWeek(date){var targetThursday=new Date(date.getFullYear(),date.getMonth(),date.getDate());targetThursday.setDate(targetThursday.getDate()-(targetThursday.getDay()+6)%7+3);var firstThursday=new Date(targetThursday.getFullYear(),0,4);firstThursday.setDate(firstThursday.getDate()-(firstThursday.getDay()+6)%7+3);var ds=targetThursday.getTimezoneOffset()-firstThursday.getTimezoneOffset();targetThursday.setHours(targetThursday.getHours()-ds);var weekDiff=(targetThursday-firstThursday)/(864e5*7);return 1+Math.floor(weekDiff)};var getDayOfWeek=function getDayOfWeek(date){var dow=date.getDay();if(dow===0){dow=7}return dow};var formatTimezone=function formatTimezone(date){return(String(date).match(timezone)||[""]).pop().replace(timezoneClip,"").replace(/GMT\+0000/g,"UTC")};

/***/ })

}]);